import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  float8: { input: number; output: number; }
  interval: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  smallint: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
  _FieldSet: { input: any; output: any; }
};

export type AddRiskToEnterpriseRiskInput = {
  EnterpriseRiskId?: InputMaybe<Scalars['uuid']['input']>;
  EntityId: Scalars['uuid']['input'];
  RiskId: Scalars['uuid']['input'];
};

export type AttestationInput = {
  AttestationGroupIds: Array<Scalars['uuid']['input']>;
  AttestationPromptText?: InputMaybe<Scalars['String']['input']>;
  AttestationTimeLimit?: InputMaybe<Scalars['interval']['input']>;
  RequireGlobalAttestation: Scalars['Boolean']['input'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CustomDatasourceField = {
  dataSourceIndex: Scalars['Int']['input'];
  fieldId: Scalars['String']['input'];
};

export type CustomRoleInsertInputData = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  RoleKeys: Array<Scalars['String']['input']>;
  UserIds: Array<Scalars['String']['input']>;
};

export type CustomRoleUpdateInputData = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  RoleKeys: Array<Scalars['String']['input']>;
  UserIds: Array<Scalars['String']['input']>;
};

export type CustomRoleUserUpdateInputData = {
  CustomRoleIds: Array<Scalars['String']['input']>;
  UserId: Scalars['String']['input'];
};

export type DataExportCreateScheduleInput = {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  bucketName?: InputMaybe<Scalars['String']['input']>;
  containerName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  entraClientId?: InputMaybe<Scalars['String']['input']>;
  entraSecretValue?: InputMaybe<Scalars['String']['input']>;
  entraTenantId?: InputMaybe<Scalars['String']['input']>;
  frequency: Data_Export_Schedule_Frequency_Enum;
  hostname?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  s3Folder?: InputMaybe<Scalars['String']['input']>;
  sasToken?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
  sftpFolder?: InputMaybe<Scalars['String']['input']>;
  sharePointDriveId?: InputMaybe<Scalars['String']['input']>;
  sharePointSiteId?: InputMaybe<Scalars['String']['input']>;
  spFolder?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storageType: Data_Export_Schedule_Storage_Type_Enum;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DataExportCreateScheduleOutput = {
  __typename?: 'DataExportCreateScheduleOutput';
  message: Scalars['String']['output'];
};

export type DataExportOneOffExportOutput = {
  __typename?: 'DataExportOneOffExportOutput';
  downloadUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type DataExportTestScheduleInput = {
  scheduleId: Scalars['uuid']['input'];
};

export type DataExportTestScheduleOutput = {
  __typename?: 'DataExportTestScheduleOutput';
  message: Scalars['String']['output'];
};

export type DataImportStartImportOutput = {
  __typename?: 'DataImportStartImportOutput';
  message: Scalars['String']['output'];
};

export type DataImportValidateOutput = {
  __typename?: 'DataImportValidateOutput';
  message: Scalars['String']['output'];
};

export type DataSource = {
  joinType?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  parentIndex?: InputMaybe<Scalars['Int']['input']>;
  relationshipToParentIndex?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DeleteFormFieldInput = {
  FieldId: Scalars['String']['input'];
  ParentType: Scalars['String']['input'];
};

export type DeleteScimDomainOutput = {
  __typename?: 'DeleteScimDomainOutput';
  updatedDomains: Array<ScimDomainOutput>;
};

export type DeleteScimTokenOutput = {
  __typename?: 'DeleteScimTokenOutput';
  keyId: Scalars['String']['output'];
};

export type DisconnectSlackOutput = {
  __typename?: 'DisconnectSlackOutput';
  message: Scalars['String']['output'];
};

export type FormFieldOption = {
  AltValue?: InputMaybe<Scalars['String']['input']>;
  Value: Scalars['String']['input'];
  _tag: Scalars['String']['input'];
};

export type GenericMutationOutput = {
  __typename?: 'GenericMutationOutput';
  affected_rows: Scalars['Int']['output'];
};

export type GetScimConfigOutput = {
  __typename?: 'GetScimConfigOutput';
  domains: Array<ScimDomainOutput>;
  legacyTokens: Scalars['Boolean']['output'];
  tokens: Array<ScimTokenOutput>;
};

export type GroupBy = {
  datePrecision?: InputMaybe<Scalars['String']['input']>;
  field: CustomDatasourceField;
};

export type IdOutput = {
  __typename?: 'IdOutput';
  Id: Scalars['uuid']['output'];
};

export type InsertAssessmentInput = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status: Assessment_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type InsertAttestationConfigInput = {
  AttestationGroupIds: Array<Scalars['uuid']['input']>;
  AttestationPromptText?: InputMaybe<Scalars['String']['input']>;
  AttestationTimeLimit?: InputMaybe<Scalars['interval']['input']>;
  ParentId: Scalars['uuid']['input'];
  RequireGlobalAttestation: Scalars['Boolean']['input'];
};

export type InsertChildAttestationCycleInput = {
  AllowCarryForward: Scalars['Boolean']['input'];
  DocumentId: Scalars['uuid']['input'];
};

export type InsertChildControlInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId: Scalars['uuid']['input'];
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type?: InputMaybe<Scalars['String']['input']>;
  schedule: ScheduleInput;
};

export type InsertChildDocumentAssessmentResultOutput = {
  __typename?: 'InsertChildDocumentAssessmentResultOutput';
  Ids: Array<Scalars['uuid']['output']>;
};

export type InsertChildDocumentInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  DocumentType: Scalars['String']['input'];
  LinkedDocumentIds: Array<Scalars['uuid']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentDocument?: InputMaybe<Scalars['uuid']['input']>;
  Purpose?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  attestation?: InputMaybe<AttestationInput>;
  schedule: ScheduleInput;
};

export type InsertChildIndicatorInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  LowerAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  LowerToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Indicator_Type_Enum>;
  Unit?: InputMaybe<Scalars['String']['input']>;
  UpperAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  UpperToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  schedule: ScheduleInput;
};

export type InsertChildIssueOutput = {
  __typename?: 'InsertChildIssueOutput';
  Id: Scalars['uuid']['output'];
  SequentialId: Scalars['Int']['output'];
};

export type InsertChildObligationAssessmentResultOutput = {
  __typename?: 'InsertChildObligationAssessmentResultOutput';
  Ids: Array<Scalars['uuid']['output']>;
};

export type InsertChildObligationChangeAttestationInput = {
  ObligationChangeId: Scalars['uuid']['input'];
};

export type InsertChildObligationInput = {
  Adherence: Scalars['String']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Interpretation?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type: Obligation_Type_Enum;
  schedule: ScheduleInput;
};

export type InsertChildRiskAssessmentResultOutput = {
  __typename?: 'InsertChildRiskAssessmentResultOutput';
  Ids: Array<Scalars['uuid']['output']>;
};

export type InsertChildRiskInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentRiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Risk_Status_Type_Enum>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Tier: Scalars['Int']['input'];
  Title: Scalars['String']['input'];
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  schedule: ScheduleInput;
};

export type InsertEnterpriseRiskInput = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Meta?: InputMaybe<Scalars['jsonb']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Tier: Scalars['Int']['input'];
  Title: Scalars['String']['input'];
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
};

export type InsertEntityInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight: Scalars['numeric']['input'];
  ownerGroups: Array<Scalars['String']['input']>;
  owners: Array<Scalars['String']['input']>;
};

export type InsertFormFieldInput = {
  AltLabel?: InputMaybe<Scalars['String']['input']>;
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Hidden: Scalars['Boolean']['input'];
  IsCustomField: Scalars['Boolean']['input'];
  Label: Scalars['String']['input'];
  Options: Array<FormFieldOption>;
  ParentType: Scalars['String']['input'];
  ReadOnly: Scalars['Boolean']['input'];
  Required: Scalars['Boolean']['input'];
  Type: Scalars['String']['input'];
};

export type InsertImpactInput = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['smallint']['input']>;
  Name: Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  RatingGuidance?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
};

export type InsertImpactRatingPairInput = {
  ImpactId: Scalars['uuid']['input'];
  Rating: Scalars['Int']['input'];
};

export type InsertInternalAuditInput = {
  BusinessArea: Scalars['String']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};

export type InsertIssueInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateIdentified: Scalars['timestamptz']['input'];
  DateOccurred: Scalars['timestamptz']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  ImpactsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  IsExternalIssue?: InputMaybe<Scalars['Boolean']['input']>;
  Meta?: InputMaybe<Scalars['jsonb']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type: Scalars['String']['input'];
};

export type InsertQuestionnaireTemplateInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};

export type InsertRiskAssessmentResultConfigApiOutput = {
  __typename?: 'InsertRiskAssessmentResultConfigApiOutput';
  Id: Scalars['uuid']['output'];
  IsLatest: Scalars['Boolean']['output'];
  Version: Scalars['Int']['output'];
};

export type InsertThirdPartyInput = {
  Address?: InputMaybe<Scalars['String']['input']>;
  CityTown?: InputMaybe<Scalars['String']['input']>;
  CompaniesHouseNumber?: InputMaybe<Scalars['String']['input']>;
  CompanyDomain?: InputMaybe<Scalars['String']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  ContactEmail?: InputMaybe<Scalars['String']['input']>;
  ContactName?: InputMaybe<Scalars['String']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  PrimaryContactName?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type?: InputMaybe<Scalars['String']['input']>;
};

export type InsertWizardInput = {
  ActivityId?: InputMaybe<Scalars['uuid']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CurrentStep?: InputMaybe<Scalars['Int']['input']>;
  RiskId: Scalars['uuid']['input'];
  Status?: InputMaybe<Wizard_Status_Enum>;
};

export type InsertWizardOutput = {
  __typename?: 'InsertWizardOutput';
  RiskId: Scalars['uuid']['output'];
};

export type InstantiateEnterpriseRiskInput = {
  EnterpriseRiskIds: Array<Scalars['uuid']['input']>;
  Entities: Array<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LinkItemRecordOutput = {
  __typename?: 'LinkItemRecordOutput';
  RelationshipType: Scalars['String']['output'];
  Source: Scalars['uuid']['output'];
  Target: Scalars['uuid']['output'];
};

export type LinkItemsOutput = {
  __typename?: 'LinkItemsOutput';
  Links: Array<LinkItemRecordOutput>;
};

export type NotificationPreferencesOutput = {
  __typename?: 'NotificationPreferencesOutput';
  categories?: Maybe<Scalars['jsonb']['output']>;
  channel_types?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['String']['output'];
  workflows?: Maybe<Scalars['jsonb']['output']>;
};

export type RecalculateAppetitesOutput = {
  __typename?: 'RecalculateAppetitesOutput';
  message?: Maybe<Scalars['String']['output']>;
};

export type RecalculateRiskScoresOutput = {
  __typename?: 'RecalculateRiskScoresOutput';
  message?: Maybe<Scalars['String']['output']>;
};

export type RefreshScheduleStateOutput = {
  __typename?: 'RefreshScheduleStateOutput';
  missingNodeIds: Array<Scalars['uuid']['output']>;
  unsupportedNodeIds: Array<Scalars['String']['output']>;
};

export type ReportField = {
  __typename?: 'ReportField';
  meta?: Maybe<Scalars['jsonb']['output']>;
  value?: Maybe<Scalars['jsonb']['output']>;
};

export type ReportingDataInput = {
  aggregateField?: InputMaybe<CustomDatasourceField>;
  aggregateType?: InputMaybe<Scalars['String']['input']>;
  dataSources: Array<DataSource>;
  fields: Array<SelectedDatasourceField>;
  filters: Scalars['jsonb']['input'];
  groupBy?: InputMaybe<Array<GroupBy>>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ReportingFilterOption = {
  __typename?: 'ReportingFilterOption';
  value: Scalars['String']['output'];
};

export type ReportingFilterOptionsInput = {
  dataSourceType: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
  filteringText: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type RevokeThirdPartyContactAccessOutput = {
  __typename?: 'RevokeThirdPartyContactAccessOutput';
  results: Array<RevokeThirdPartyContactAccessResultOutput>;
};

export type RevokeThirdPartyContactAccessResultOutput = {
  __typename?: 'RevokeThirdPartyContactAccessResultOutput';
  Id: Scalars['uuid']['output'];
  IsRevoked: Scalars['Boolean']['output'];
  Message: Scalars['String']['output'];
};

export type RiskAssessmentResultImpactsInput = {
  Label: Scalars['String']['input'];
  Value: Scalars['Int']['input'];
};

export type RoleOutput = {
  __typename?: 'RoleOutput';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ScheduleInput = {
  Frequency?: InputMaybe<Test_Frequency_Enum>;
  ManualDueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TimeToCompleteUnit?: InputMaybe<Unit_Of_Time_Enum>;
  TimeToCompleteValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ScimDomainOutput = {
  __typename?: 'ScimDomainOutput';
  createdOn: Scalars['String']['output'];
  domain: Scalars['String']['output'];
};

export type ScimTokenOutput = {
  __typename?: 'ScimTokenOutput';
  createdOn: Scalars['String']['output'];
  expiresOn: Scalars['String']['output'];
  keyId: Scalars['String']['output'];
  orgKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type SelectedDatasourceField = {
  dataSourceIndex: Scalars['Int']['input'];
  fieldId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SlackNotificationConnectionOutput = {
  __typename?: 'SlackNotificationConnectionOutput';
  connected: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkItemsOutput = {
  __typename?: 'UnlinkItemsOutput';
  Ids?: Maybe<Array<Maybe<Scalars['uuid']['output']>>>;
};

export type UpdateApproverResponsesInput = {
  ChangeRequestId: Scalars['uuid']['input'];
  Comment: Scalars['String']['input'];
  LevelId: Scalars['uuid']['input'];
  OverrideLevel: Scalars['Boolean']['input'];
  Response: Scalars['Boolean']['input'];
};

export type UpdateAssessmentInput = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Id: Scalars['uuid']['input'];
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status: Assessment_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChildActionOutput = {
  __typename?: 'UpdateChildActionOutput';
  affected_rows: Scalars['Int']['output'];
  change_request_id?: Maybe<Scalars['uuid']['output']>;
};

export type UpdateChildControlInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type?: InputMaybe<Scalars['String']['input']>;
  schedule: ScheduleInput;
};

export type UpdateChildDocumentInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  DocumentType: Scalars['String']['input'];
  Id: Scalars['uuid']['input'];
  LinkedDocumentIds: Array<Scalars['uuid']['input']>;
  OriginalTimestamp: Scalars['timestamptz']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentDocument?: InputMaybe<Scalars['uuid']['input']>;
  Purpose?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  attestation?: InputMaybe<AttestationInput>;
  schedule: ScheduleInput;
};

export type UpdateChildIndicatorInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  LowerAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  LowerToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Indicator_Type_Enum>;
  Unit?: InputMaybe<Scalars['String']['input']>;
  UpperAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  UpperToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  schedule: ScheduleInput;
};

export type UpdateChildObligationInput = {
  Adherence: Scalars['String']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  Interpretation?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type: Obligation_Type_Enum;
  schedule: ScheduleInput;
};

export type UpdateChildRiskInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentRiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Risk_Status_Type_Enum>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Tier: Scalars['Int']['input'];
  Title: Scalars['String']['input'];
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  schedule: ScheduleInput;
};

export type UpdateEnterpriseRiskInput = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  Meta?: InputMaybe<Scalars['jsonb']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Tier: Scalars['Int']['input'];
  Title: Scalars['String']['input'];
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
};

export type UpdateEntityInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight: Scalars['numeric']['input'];
  ownerGroups: Array<Scalars['String']['input']>;
  owners: Array<Scalars['String']['input']>;
};

export type UpdateFormFieldInput = {
  AltLabel?: InputMaybe<Scalars['String']['input']>;
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  FieldId: Scalars['String']['input'];
  Hidden: Scalars['Boolean']['input'];
  IsCustomField: Scalars['Boolean']['input'];
  Label?: InputMaybe<Scalars['String']['input']>;
  Options: Array<FormFieldOption>;
  ParentType: Scalars['String']['input'];
  ReadOnly: Scalars['Boolean']['input'];
  Required: Scalars['Boolean']['input'];
};

export type UpdateImpactInput = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id: Scalars['uuid']['input'];
  LikelihoodAppetite?: InputMaybe<Scalars['smallint']['input']>;
  Name: Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  RatingGuidance?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInternalAuditInput = {
  BusinessArea: Scalars['String']['input'];
  BusinessAreaId: Scalars['uuid']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};

export type UpdateIssueInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateIdentified: Scalars['timestamptz']['input'];
  DateOccurred: Scalars['timestamptz']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  ImpactsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  IsExternalIssue?: InputMaybe<Scalars['Boolean']['input']>;
  OriginalTimestamp: Scalars['timestamptz']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};

export type UpdateNotificationPreferencesInput = {
  categories?: InputMaybe<Scalars['jsonb']['input']>;
  channel_types?: InputMaybe<Scalars['jsonb']['input']>;
  id: Scalars['String']['input'];
  workflows?: InputMaybe<Scalars['jsonb']['input']>;
};

export type UpdateNotificationPreferencesOutput = {
  __typename?: 'UpdateNotificationPreferencesOutput';
  message: Scalars['String']['output'];
};

export type UpdateQuestionnaireTemplateInput = {
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};

export type UpdateRiskAssessmentResultConfigApiOutput = {
  __typename?: 'UpdateRiskAssessmentResultConfigApiOutput';
  Id: Scalars['uuid']['output'];
  IsLatest: Scalars['Boolean']['output'];
  Version: Scalars['Int']['output'];
};

export type UpdateTestResultInput = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId: Scalars['uuid']['input'];
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateThirdPartyInput = {
  Address?: InputMaybe<Scalars['String']['input']>;
  CityTown?: InputMaybe<Scalars['String']['input']>;
  CompaniesHouseNumber?: InputMaybe<Scalars['String']['input']>;
  CompanyDomain?: InputMaybe<Scalars['String']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  ContactEmail?: InputMaybe<Scalars['String']['input']>;
  ContactName?: InputMaybe<Scalars['String']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  PrimaryContactName?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
  Type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserRolesMutationOutput = {
  __typename?: 'UpdateUserRolesMutationOutput';
  roles: Array<Maybe<RoleOutput>>;
};

export type UpdateWizardInput = {
  CurrentStep?: InputMaybe<Scalars['Int']['input']>;
  RiskId: Scalars['uuid']['input'];
  Status?: InputMaybe<Wizard_Status_Enum>;
};

/** columns and relationships of "risksmart.acceptance" */
export type Acceptance = {
  __typename?: 'acceptance';
  ApprovedByUser?: Maybe<Scalars['String']['output']>;
  ApprovedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateAcceptedFrom: Scalars['timestamptz']['output'];
  DateAcceptedTo: Scalars['timestamptz']['output'];
  Details?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RequestedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status: Acceptance_Status_Enum;
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  approvedByUser?: Maybe<User>;
  /** An object relationship */
  approvedByUserGroup?: Maybe<User_Group>;
  /** An array relationship */
  changeRequests: Array<Change_Request>;
  /** An aggregate relationship */
  changeRequests_aggregate: Change_Request_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Acceptance_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Acceptance_Parent_Aggregate;
  /** An object relationship */
  requestedByUser?: Maybe<User>;
  /** An object relationship */
  requestedByUserGroup?: Maybe<User_Group>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceChangeRequestsArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceChangeRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceParentsArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.acceptance" */
export type AcceptanceParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.acceptance" */
export type Acceptance_Aggregate = {
  __typename?: 'acceptance_aggregate';
  aggregate?: Maybe<Acceptance_Aggregate_Fields>;
  nodes: Array<Acceptance>;
};

/** aggregate fields of "risksmart.acceptance" */
export type Acceptance_Aggregate_Fields = {
  __typename?: 'acceptance_aggregate_fields';
  avg?: Maybe<Acceptance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Acceptance_Max_Fields>;
  min?: Maybe<Acceptance_Min_Fields>;
  stddev?: Maybe<Acceptance_Stddev_Fields>;
  stddev_pop?: Maybe<Acceptance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Acceptance_Stddev_Samp_Fields>;
  sum?: Maybe<Acceptance_Sum_Fields>;
  var_pop?: Maybe<Acceptance_Var_Pop_Fields>;
  var_samp?: Maybe<Acceptance_Var_Samp_Fields>;
  variance?: Maybe<Acceptance_Variance_Fields>;
};


/** aggregate fields of "risksmart.acceptance" */
export type Acceptance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Acceptance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.acceptance_audit" */
export type Acceptance_Audit = {
  __typename?: 'acceptance_audit';
  ApprovedByUser?: Maybe<Scalars['String']['output']>;
  ApprovedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateAcceptedFrom: Scalars['timestamptz']['output'];
  DateAcceptedTo: Scalars['timestamptz']['output'];
  Details?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.acceptance_audit" */
export type Acceptance_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.acceptance_audit". All fields are combined with a logical 'AND'. */
export type Acceptance_Audit_Bool_Exp = {
  ApprovedByUser?: InputMaybe<String_Comparison_Exp>;
  ApprovedByUserGroup?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateAcceptedFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateAcceptedTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  Details?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RequestedByUser?: InputMaybe<String_Comparison_Exp>;
  RequestedByUserGroup?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Acceptance_Audit_Bool_Exp>>;
  _not?: InputMaybe<Acceptance_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Acceptance_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.acceptance_audit". */
export type Acceptance_Audit_Order_By = {
  ApprovedByUser?: InputMaybe<Order_By>;
  ApprovedByUserGroup?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateAcceptedFrom?: InputMaybe<Order_By>;
  DateAcceptedTo?: InputMaybe<Order_By>;
  Details?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RequestedByUser?: InputMaybe<Order_By>;
  RequestedByUserGroup?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.acceptance_audit" */
export const Acceptance_Audit_Select_Column = {
  /** column name */
  ApprovedByUser: 'ApprovedByUser',
  /** column name */
  ApprovedByUserGroup: 'ApprovedByUserGroup',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateAcceptedFrom: 'DateAcceptedFrom',
  /** column name */
  DateAcceptedTo: 'DateAcceptedTo',
  /** column name */
  Details: 'Details',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RequestedByUser: 'RequestedByUser',
  /** column name */
  RequestedByUserGroup: 'RequestedByUserGroup',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Acceptance_Audit_Select_Column = typeof Acceptance_Audit_Select_Column[keyof typeof Acceptance_Audit_Select_Column];
/** Streaming cursor of the table "acceptance_audit" */
export type Acceptance_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acceptance_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acceptance_Audit_Stream_Cursor_Value_Input = {
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateAcceptedFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  DateAcceptedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Acceptance_Avg_Fields = {
  __typename?: 'acceptance_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.acceptance". All fields are combined with a logical 'AND'. */
export type Acceptance_Bool_Exp = {
  ApprovedByUser?: InputMaybe<String_Comparison_Exp>;
  ApprovedByUserGroup?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateAcceptedFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateAcceptedTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  Details?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RequestedByUser?: InputMaybe<String_Comparison_Exp>;
  RequestedByUserGroup?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<Acceptance_Status_Enum_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Acceptance_Bool_Exp>>;
  _not?: InputMaybe<Acceptance_Bool_Exp>;
  _or?: InputMaybe<Array<Acceptance_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  approvedByUser?: InputMaybe<User_Bool_Exp>;
  approvedByUserGroup?: InputMaybe<User_Group_Bool_Exp>;
  changeRequests?: InputMaybe<Change_Request_Bool_Exp>;
  changeRequests_aggregate?: InputMaybe<Change_Request_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Acceptance_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Acceptance_Parent_Aggregate_Bool_Exp>;
  requestedByUser?: InputMaybe<User_Bool_Exp>;
  requestedByUserGroup?: InputMaybe<User_Group_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.acceptance" */
export const Acceptance_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AcceptancePkey: 'acceptance_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxAcceptanceOrgkeySequentialid: 'idx_acceptance_orgkey_sequentialid'
} as const;

export type Acceptance_Constraint = typeof Acceptance_Constraint[keyof typeof Acceptance_Constraint];
/** input type for inserting data into table "risksmart.acceptance" */
export type Acceptance_Insert_Input = {
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateAcceptedFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  DateAcceptedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
  approvedByUserGroup?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
  changeRequests?: InputMaybe<Change_Request_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Acceptance_Parent_Arr_Rel_Insert_Input>;
  requestedByUserGroup?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Acceptance_Max_Fields = {
  __typename?: 'acceptance_max_fields';
  ApprovedByUser?: Maybe<Scalars['String']['output']>;
  ApprovedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateAcceptedFrom?: Maybe<Scalars['timestamptz']['output']>;
  DateAcceptedTo?: Maybe<Scalars['timestamptz']['output']>;
  Details?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Acceptance_Min_Fields = {
  __typename?: 'acceptance_min_fields';
  ApprovedByUser?: Maybe<Scalars['String']['output']>;
  ApprovedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateAcceptedFrom?: Maybe<Scalars['timestamptz']['output']>;
  DateAcceptedTo?: Maybe<Scalars['timestamptz']['output']>;
  Details?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUser?: Maybe<Scalars['String']['output']>;
  RequestedByUserGroup?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "risksmart.acceptance" */
export type Acceptance_Obj_Rel_Insert_Input = {
  data: Acceptance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Acceptance_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.acceptance" */
export type Acceptance_On_Conflict = {
  constraint: Acceptance_Constraint;
  update_columns?: Array<Acceptance_Update_Column>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.acceptance". */
export type Acceptance_Order_By = {
  ApprovedByUser?: InputMaybe<Order_By>;
  ApprovedByUserGroup?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateAcceptedFrom?: InputMaybe<Order_By>;
  DateAcceptedTo?: InputMaybe<Order_By>;
  Details?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RequestedByUser?: InputMaybe<Order_By>;
  RequestedByUserGroup?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  approvedByUser?: InputMaybe<User_Order_By>;
  approvedByUserGroup?: InputMaybe<User_Group_Order_By>;
  changeRequests_aggregate?: InputMaybe<Change_Request_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Acceptance_Parent_Aggregate_Order_By>;
  requestedByUser?: InputMaybe<User_Order_By>;
  requestedByUserGroup?: InputMaybe<User_Group_Order_By>;
};

/** columns and relationships of "risksmart.acceptance_parent" */
export type Acceptance_Parent = {
  __typename?: 'acceptance_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
};

/** aggregated selection of "risksmart.acceptance_parent" */
export type Acceptance_Parent_Aggregate = {
  __typename?: 'acceptance_parent_aggregate';
  aggregate?: Maybe<Acceptance_Parent_Aggregate_Fields>;
  nodes: Array<Acceptance_Parent>;
};

export type Acceptance_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Acceptance_Parent_Aggregate_Bool_Exp_Count>;
};

export type Acceptance_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Acceptance_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.acceptance_parent" */
export type Acceptance_Parent_Aggregate_Fields = {
  __typename?: 'acceptance_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Acceptance_Parent_Max_Fields>;
  min?: Maybe<Acceptance_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.acceptance_parent" */
export type Acceptance_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Acceptance_Parent_Max_Order_By>;
  min?: InputMaybe<Acceptance_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Arr_Rel_Insert_Input = {
  data: Array<Acceptance_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Acceptance_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.acceptance_parent_audit" */
export type Acceptance_Parent_Audit = {
  __typename?: 'acceptance_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risksmart.acceptance_parent_audit" */
export type Acceptance_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Acceptance_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Acceptance_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.acceptance_parent_audit". All fields are combined with a logical 'AND'. */
export type Acceptance_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Acceptance_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Acceptance_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.acceptance_parent_audit" */
export type Acceptance_Parent_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.acceptance_parent_audit" */
export type Acceptance_Parent_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.acceptance_parent_audit". */
export type Acceptance_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.acceptance_parent_audit" */
export const Acceptance_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Acceptance_Parent_Audit_Select_Column = typeof Acceptance_Parent_Audit_Select_Column[keyof typeof Acceptance_Parent_Audit_Select_Column];
/** Streaming cursor of the table "acceptance_parent_audit" */
export type Acceptance_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acceptance_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acceptance_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.acceptance_parent". All fields are combined with a logical 'AND'. */
export type Acceptance_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Acceptance_Parent_Bool_Exp>>;
  _not?: InputMaybe<Acceptance_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Acceptance_Parent_Bool_Exp>>;
  acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.acceptance_parent" */
export const Acceptance_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "Id" */
  AcceptanceParentPkey: 'acceptance_parent_pkey'
} as const;

export type Acceptance_Parent_Constraint = typeof Acceptance_Parent_Constraint[keyof typeof Acceptance_Parent_Constraint];
/** input type for inserting data into table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  acceptance?: InputMaybe<Acceptance_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Acceptance_Parent_Max_Fields = {
  __typename?: 'acceptance_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Acceptance_Parent_Min_Fields = {
  __typename?: 'acceptance_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.acceptance_parent" */
export type Acceptance_Parent_Mutation_Response = {
  __typename?: 'acceptance_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Acceptance_Parent>;
};

/** on_conflict condition type for table "risksmart.acceptance_parent" */
export type Acceptance_Parent_On_Conflict = {
  constraint: Acceptance_Parent_Constraint;
  update_columns?: Array<Acceptance_Parent_Update_Column>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.acceptance_parent". */
export type Acceptance_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  acceptance?: InputMaybe<Acceptance_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.acceptance_parent" */
export const Acceptance_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Acceptance_Parent_Select_Column = typeof Acceptance_Parent_Select_Column[keyof typeof Acceptance_Parent_Select_Column];
/** Streaming cursor of the table "acceptance_parent" */
export type Acceptance_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acceptance_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acceptance_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.acceptance_parent" (current role has no relevant permissions) */
export const Acceptance_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Acceptance_Parent_Update_Column = typeof Acceptance_Parent_Update_Column[keyof typeof Acceptance_Parent_Update_Column];
/** select columns of table "risksmart.acceptance" */
export const Acceptance_Select_Column = {
  /** column name */
  ApprovedByUser: 'ApprovedByUser',
  /** column name */
  ApprovedByUserGroup: 'ApprovedByUserGroup',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateAcceptedFrom: 'DateAcceptedFrom',
  /** column name */
  DateAcceptedTo: 'DateAcceptedTo',
  /** column name */
  Details: 'Details',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RequestedByUser: 'RequestedByUser',
  /** column name */
  RequestedByUserGroup: 'RequestedByUserGroup',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Acceptance_Select_Column = typeof Acceptance_Select_Column[keyof typeof Acceptance_Select_Column];
export const Acceptance_Status_Enum = {
  /** awaiting closure */
  Awaitingclosure: 'awaitingclosure',
  /** closed */
  Closed: 'closed',
  /** declined */
  Declined: 'declined',
  /** 1st line approval */
  Firstlineapproval: 'firstlineapproval',
  /** open */
  Open: 'open',
  /** pending */
  Pending: 'pending'
} as const;

export type Acceptance_Status_Enum = typeof Acceptance_Status_Enum[keyof typeof Acceptance_Status_Enum];
/** Boolean expression to compare columns of type "acceptance_status_enum". All fields are combined with logical 'AND'. */
export type Acceptance_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Acceptance_Status_Enum>;
  _in?: InputMaybe<Array<Acceptance_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Acceptance_Status_Enum>;
  _nin?: InputMaybe<Array<Acceptance_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Acceptance_Stddev_Fields = {
  __typename?: 'acceptance_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Acceptance_Stddev_Pop_Fields = {
  __typename?: 'acceptance_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Acceptance_Stddev_Samp_Fields = {
  __typename?: 'acceptance_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "acceptance" */
export type Acceptance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acceptance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acceptance_Stream_Cursor_Value_Input = {
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateAcceptedFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  DateAcceptedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Acceptance_Sum_Fields = {
  __typename?: 'acceptance_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.acceptance" */
export const Acceptance_Update_Column = {
  /** column name */
  ApprovedByUser: 'ApprovedByUser',
  /** column name */
  ApprovedByUserGroup: 'ApprovedByUserGroup',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateAcceptedFrom: 'DateAcceptedFrom',
  /** column name */
  DateAcceptedTo: 'DateAcceptedTo',
  /** column name */
  Details: 'Details',
  /** column name */
  RequestedByUser: 'RequestedByUser',
  /** column name */
  RequestedByUserGroup: 'RequestedByUserGroup',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Acceptance_Update_Column = typeof Acceptance_Update_Column[keyof typeof Acceptance_Update_Column];
/** aggregate var_pop on columns */
export type Acceptance_Var_Pop_Fields = {
  __typename?: 'acceptance_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Acceptance_Var_Samp_Fields = {
  __typename?: 'acceptance_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Acceptance_Variance_Fields = {
  __typename?: 'acceptance_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

export const Access_Type_Enum = {
  /** Delete */
  Delete: 'delete',
  /** Insert */
  Insert: 'insert',
  /** Read */
  Read: 'read',
  /** Update */
  Update: 'update'
} as const;

export type Access_Type_Enum = typeof Access_Type_Enum[keyof typeof Access_Type_Enum];
/** Boolean expression to compare columns of type "access_type_enum". All fields are combined with logical 'AND'. */
export type Access_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Access_Type_Enum>;
  _in?: InputMaybe<Array<Access_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Access_Type_Enum>;
  _nin?: InputMaybe<Array<Access_Type_Enum>>;
};

/** columns and relationships of "risksmart.action" */
export type Action = {
  __typename?: 'action';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateDue: Scalars['timestamptz']['output'];
  DateRaised: Scalars['timestamptz']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status: Action_Status_Enum;
  Title: Scalars['String']['output'];
  /** An object relationship */
  actionStatus?: Maybe<Action_Status_View>;
  /** An object relationship */
  actionUpdateSummary?: Maybe<Action_Update_Summary>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  parents: Array<Action_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
  /** An array relationship */
  updates: Array<Action_Update>;
  /** An aggregate relationship */
  updates_aggregate: Action_Update_Aggregate;
};


/** columns and relationships of "risksmart.action" */
export type ActionCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.action" */
export type ActionAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionParentsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionUpdatesArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


/** columns and relationships of "risksmart.action" */
export type ActionUpdates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};

/** aggregated selection of "risksmart.action" */
export type Action_Aggregate = {
  __typename?: 'action_aggregate';
  aggregate?: Maybe<Action_Aggregate_Fields>;
  nodes: Array<Action>;
};

/** aggregate fields of "risksmart.action" */
export type Action_Aggregate_Fields = {
  __typename?: 'action_aggregate_fields';
  avg?: Maybe<Action_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Max_Fields>;
  min?: Maybe<Action_Min_Fields>;
  stddev?: Maybe<Action_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Sum_Fields>;
  var_pop?: Maybe<Action_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Var_Samp_Fields>;
  variance?: Maybe<Action_Variance_Fields>;
};


/** aggregate fields of "risksmart.action" */
export type Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.action_audit" */
export type Action_Audit = {
  __typename?: 'action_audit';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateDue: Scalars['timestamptz']['output'];
  DateRaised: Scalars['timestamptz']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.action_audit" */
export type Action_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.action_audit" */
export type Action_Audit_Aggregate = {
  __typename?: 'action_audit_aggregate';
  aggregate?: Maybe<Action_Audit_Aggregate_Fields>;
  nodes: Array<Action_Audit>;
};

/** aggregate fields of "risksmart.action_audit" */
export type Action_Audit_Aggregate_Fields = {
  __typename?: 'action_audit_aggregate_fields';
  avg?: Maybe<Action_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Audit_Max_Fields>;
  min?: Maybe<Action_Audit_Min_Fields>;
  stddev?: Maybe<Action_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Audit_Sum_Fields>;
  var_pop?: Maybe<Action_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Audit_Var_Samp_Fields>;
  variance?: Maybe<Action_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.action_audit" */
export type Action_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Action_Audit_Avg_Fields = {
  __typename?: 'action_audit_avg_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_audit". All fields are combined with a logical 'AND'. */
export type Action_Audit_Bool_Exp = {
  ClosedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateDue?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateRaised?: InputMaybe<Timestamptz_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Priority?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Audit_Bool_Exp>>;
  _not?: InputMaybe<Action_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Action_Audit_Max_Fields = {
  __typename?: 'action_audit_max_fields';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateDue?: Maybe<Scalars['timestamptz']['output']>;
  DateRaised?: Maybe<Scalars['timestamptz']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Action_Audit_Min_Fields = {
  __typename?: 'action_audit_min_fields';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateDue?: Maybe<Scalars['timestamptz']['output']>;
  DateRaised?: Maybe<Scalars['timestamptz']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.action_audit". */
export type Action_Audit_Order_By = {
  ClosedDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateDue?: InputMaybe<Order_By>;
  DateRaised?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Priority?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.action_audit" */
export const Action_Audit_Select_Column = {
  /** column name */
  ClosedDate: 'ClosedDate',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateDue: 'DateDue',
  /** column name */
  DateRaised: 'DateRaised',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Priority: 'Priority',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Audit_Select_Column = typeof Action_Audit_Select_Column[keyof typeof Action_Audit_Select_Column];
/** aggregate stddev on columns */
export type Action_Audit_Stddev_Fields = {
  __typename?: 'action_audit_stddev_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Action_Audit_Stddev_Pop_Fields = {
  __typename?: 'action_audit_stddev_pop_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Action_Audit_Stddev_Samp_Fields = {
  __typename?: 'action_audit_stddev_samp_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "action_audit" */
export type Action_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Audit_Stream_Cursor_Value_Input = {
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateDue?: InputMaybe<Scalars['timestamptz']['input']>;
  DateRaised?: InputMaybe<Scalars['timestamptz']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Action_Audit_Sum_Fields = {
  __typename?: 'action_audit_sum_fields';
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Action_Audit_Var_Pop_Fields = {
  __typename?: 'action_audit_var_pop_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Action_Audit_Var_Samp_Fields = {
  __typename?: 'action_audit_var_samp_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Action_Audit_Variance_Fields = {
  __typename?: 'action_audit_variance_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Action_Avg_Fields = {
  __typename?: 'action_avg_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.action". All fields are combined with a logical 'AND'. */
export type Action_Bool_Exp = {
  ClosedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateDue?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateRaised?: InputMaybe<Timestamptz_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Priority?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<Action_Status_Enum_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Bool_Exp>>;
  _not?: InputMaybe<Action_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Bool_Exp>>;
  actionStatus?: InputMaybe<Action_Status_View_Bool_Exp>;
  actionUpdateSummary?: InputMaybe<Action_Update_Summary_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Action_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
  updates?: InputMaybe<Action_Update_Bool_Exp>;
  updates_aggregate?: InputMaybe<Action_Update_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.action" */
export const Action_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ActionPkey: 'action_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxActionOrgkeySequentialid: 'idx_action_orgkey_sequentialid'
} as const;

export type Action_Constraint = typeof Action_Constraint[keyof typeof Action_Constraint];
/** input type for inserting data into table "risksmart.action" */
export type Action_Insert_Input = {
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateDue?: InputMaybe<Scalars['timestamptz']['input']>;
  DateRaised?: InputMaybe<Scalars['timestamptz']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Action_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
  updates?: InputMaybe<Action_Update_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Action_Max_Fields = {
  __typename?: 'action_max_fields';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateDue?: Maybe<Scalars['timestamptz']['output']>;
  DateRaised?: Maybe<Scalars['timestamptz']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Action_Min_Fields = {
  __typename?: 'action_min_fields';
  ClosedDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateDue?: Maybe<Scalars['timestamptz']['output']>;
  DateRaised?: Maybe<Scalars['timestamptz']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "risksmart.action" */
export type Action_Obj_Rel_Insert_Input = {
  data: Action_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Action_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.action" */
export type Action_On_Conflict = {
  constraint: Action_Constraint;
  update_columns?: Array<Action_Update_Column>;
  where?: InputMaybe<Action_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.action". */
export type Action_Order_By = {
  ClosedDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateDue?: InputMaybe<Order_By>;
  DateRaised?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Priority?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  actionStatus?: InputMaybe<Action_Status_View_Order_By>;
  actionUpdateSummary?: InputMaybe<Action_Update_Summary_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
  updates_aggregate?: InputMaybe<Action_Update_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.action_parent" */
export type Action_Parent = {
  __typename?: 'action_parent';
  ActionId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  ParentType: Parent_Type_Enum;
  /** An object relationship */
  action?: Maybe<Action>;
  /** An object relationship */
  assessment?: Maybe<Assessment>;
  /** An object relationship */
  complianceMonitoringAssessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  internalAuditEntity?: Maybe<Internal_Audit_Entity>;
  /** An object relationship */
  internalAuditReport?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
};

/** aggregated selection of "risksmart.action_parent" */
export type Action_Parent_Aggregate = {
  __typename?: 'action_parent_aggregate';
  aggregate?: Maybe<Action_Parent_Aggregate_Fields>;
  nodes: Array<Action_Parent>;
};

export type Action_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Action_Parent_Aggregate_Bool_Exp_Count>;
};

export type Action_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Action_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Action_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.action_parent" */
export type Action_Parent_Aggregate_Fields = {
  __typename?: 'action_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Parent_Max_Fields>;
  min?: Maybe<Action_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.action_parent" */
export type Action_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.action_parent" */
export type Action_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Action_Parent_Max_Order_By>;
  min?: InputMaybe<Action_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.action_parent" */
export type Action_Parent_Arr_Rel_Insert_Input = {
  data: Array<Action_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Action_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.action_parent_audit" */
export type Action_Parent_Audit = {
  __typename?: 'action_parent_audit';
  ActionId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  ParentType?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "risksmart.action_parent_audit" */
export type Action_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Action_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Action_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.action_parent_audit". All fields are combined with a logical 'AND'. */
export type Action_Parent_Audit_Bool_Exp = {
  ActionId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.action_parent_audit" */
export type Action_Parent_Audit_Max_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.action_parent_audit" */
export type Action_Parent_Audit_Min_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.action_parent_audit". */
export type Action_Parent_Audit_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.action_parent_audit" */
export const Action_Parent_Audit_Select_Column = {
  /** column name */
  ActionId: 'ActionId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Action_Parent_Audit_Select_Column = typeof Action_Parent_Audit_Select_Column[keyof typeof Action_Parent_Audit_Select_Column];
/** Streaming cursor of the table "action_parent_audit" */
export type Action_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Parent_Audit_Stream_Cursor_Value_Input = {
  ActionId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_parent". All fields are combined with a logical 'AND'. */
export type Action_Parent_Bool_Exp = {
  ActionId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Parent_Bool_Exp>>;
  _not?: InputMaybe<Action_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Parent_Bool_Exp>>;
  action?: InputMaybe<Action_Bool_Exp>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  control?: InputMaybe<Control_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.action_parent" */
export const Action_Parent_Constraint = {
  /** unique or primary key constraint on columns "ActionId", "ParentId" */
  ActionParentPkey: 'action_parent_pkey'
} as const;

export type Action_Parent_Constraint = typeof Action_Parent_Constraint[keyof typeof Action_Parent_Constraint];
/** input type for inserting data into table "risksmart.action_parent" */
export type Action_Parent_Insert_Input = {
  ActionId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  action?: InputMaybe<Action_Obj_Rel_Insert_Input>;
  assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input>;
  control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Obj_Rel_Insert_Input>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Action_Parent_Max_Fields = {
  __typename?: 'action_parent_max_fields';
  ActionId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.action_parent" */
export type Action_Parent_Max_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Action_Parent_Min_Fields = {
  __typename?: 'action_parent_min_fields';
  ActionId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.action_parent" */
export type Action_Parent_Min_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.action_parent" */
export type Action_Parent_Mutation_Response = {
  __typename?: 'action_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Action_Parent>;
};

/** on_conflict condition type for table "risksmart.action_parent" */
export type Action_Parent_On_Conflict = {
  constraint: Action_Parent_Constraint;
  update_columns?: Array<Action_Parent_Update_Column>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.action_parent". */
export type Action_Parent_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  action?: InputMaybe<Action_Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  control?: InputMaybe<Control_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Order_By>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
};

/** select columns of table "risksmart.action_parent" */
export const Action_Parent_Select_Column = {
  /** column name */
  ActionId: 'ActionId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Action_Parent_Select_Column = typeof Action_Parent_Select_Column[keyof typeof Action_Parent_Select_Column];
/** Streaming cursor of the table "action_parent" */
export type Action_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Parent_Stream_Cursor_Value_Input = {
  ActionId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** placeholder for update columns of table "risksmart.action_parent" (current role has no relevant permissions) */
export const Action_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Action_Parent_Update_Column = typeof Action_Parent_Update_Column[keyof typeof Action_Parent_Update_Column];
/** select columns of table "risksmart.action" */
export const Action_Select_Column = {
  /** column name */
  ClosedDate: 'ClosedDate',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateDue: 'DateDue',
  /** column name */
  DateRaised: 'DateRaised',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Priority: 'Priority',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Select_Column = typeof Action_Select_Column[keyof typeof Action_Select_Column];
export const Action_Status_Enum = {
  /** Closed */
  Closed: 'closed',
  /** Open */
  Open: 'open',
  /** Pending */
  Pending: 'pending'
} as const;

export type Action_Status_Enum = typeof Action_Status_Enum[keyof typeof Action_Status_Enum];
/** Boolean expression to compare columns of type "action_status_enum". All fields are combined with logical 'AND'. */
export type Action_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Action_Status_Enum>;
  _in?: InputMaybe<Array<Action_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Action_Status_Enum>;
  _nin?: InputMaybe<Array<Action_Status_Enum>>;
};

/** columns and relationships of "risksmart.action_status_view" */
export type Action_Status_View = {
  __typename?: 'action_status_view';
  Id?: Maybe<Scalars['uuid']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_status_view". All fields are combined with a logical 'AND'. */
export type Action_Status_View_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Status_View_Bool_Exp>>;
  _not?: InputMaybe<Action_Status_View_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Status_View_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.action_status_view". */
export type Action_Status_View_Order_By = {
  Id?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Action_Stddev_Fields = {
  __typename?: 'action_stddev_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Action_Stddev_Pop_Fields = {
  __typename?: 'action_stddev_pop_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Action_Stddev_Samp_Fields = {
  __typename?: 'action_stddev_samp_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "action" */
export type Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Stream_Cursor_Value_Input = {
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateDue?: InputMaybe<Scalars['timestamptz']['input']>;
  DateRaised?: InputMaybe<Scalars['timestamptz']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Action_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Action_Sum_Fields = {
  __typename?: 'action_sum_fields';
  Priority?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "risksmart.action_update" */
export type Action_Update = {
  __typename?: 'action_update';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentActionId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
  /** An object relationship */
  action?: Maybe<Action>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.action_update" */
export type Action_UpdateCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.action_update" */
export type Action_UpdateFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.action_update" */
export type Action_UpdateFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** aggregated selection of "risksmart.action_update" */
export type Action_Update_Aggregate = {
  __typename?: 'action_update_aggregate';
  aggregate?: Maybe<Action_Update_Aggregate_Fields>;
  nodes: Array<Action_Update>;
};

export type Action_Update_Aggregate_Bool_Exp = {
  count?: InputMaybe<Action_Update_Aggregate_Bool_Exp_Count>;
};

export type Action_Update_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Action_Update_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Action_Update_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.action_update" */
export type Action_Update_Aggregate_Fields = {
  __typename?: 'action_update_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Update_Max_Fields>;
  min?: Maybe<Action_Update_Min_Fields>;
};


/** aggregate fields of "risksmart.action_update" */
export type Action_Update_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Update_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.action_update" */
export type Action_Update_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Action_Update_Max_Order_By>;
  min?: InputMaybe<Action_Update_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Action_Update_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.action_update" */
export type Action_Update_Arr_Rel_Insert_Input = {
  data: Array<Action_Update_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Action_Update_On_Conflict>;
};

/** columns and relationships of "risksmart.action_update_audit" */
export type Action_Update_Audit = {
  __typename?: 'action_update_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentActionId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.action_update_audit" */
export type Action_Update_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_update_audit". All fields are combined with a logical 'AND'. */
export type Action_Update_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentActionId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Update_Audit_Bool_Exp>>;
  _not?: InputMaybe<Action_Update_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Update_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.action_update_audit". */
export type Action_Update_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentActionId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.action_update_audit" */
export const Action_Update_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentActionId: 'ParentActionId',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Update_Audit_Select_Column = typeof Action_Update_Audit_Select_Column[keyof typeof Action_Update_Audit_Select_Column];
/** Streaming cursor of the table "action_update_audit" */
export type Action_Update_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Update_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Update_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentActionId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_update". All fields are combined with a logical 'AND'. */
export type Action_Update_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentActionId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Update_Bool_Exp>>;
  _not?: InputMaybe<Action_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Update_Bool_Exp>>;
  action?: InputMaybe<Action_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** update columns of table "risksmart.action" */
export const Action_Update_Column = {
  /** column name */
  ClosedDate: 'ClosedDate',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateDue: 'DateDue',
  /** column name */
  DateRaised: 'DateRaised',
  /** column name */
  Description: 'Description',
  /** column name */
  Priority: 'Priority',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Update_Column = typeof Action_Update_Column[keyof typeof Action_Update_Column];
/** unique or primary key constraints on table "risksmart.action_update" */
export const Action_Update_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ActionUpdatePkey: 'action_update_pkey'
} as const;

export type Action_Update_Constraint = typeof Action_Update_Constraint[keyof typeof Action_Update_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Action_Update_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Action_Update_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Action_Update_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.action_update" */
export type Action_Update_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentActionId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<Action_Obj_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Action_Update_Max_Fields = {
  __typename?: 'action_update_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentActionId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.action_update" */
export type Action_Update_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentActionId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Action_Update_Min_Fields = {
  __typename?: 'action_update_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentActionId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.action_update" */
export type Action_Update_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentActionId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.action_update" */
export type Action_Update_Mutation_Response = {
  __typename?: 'action_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Action_Update>;
};

/** input type for inserting object relation for remote table "risksmart.action_update" */
export type Action_Update_Obj_Rel_Insert_Input = {
  data: Action_Update_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Action_Update_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.action_update" */
export type Action_Update_On_Conflict = {
  constraint: Action_Update_Constraint;
  update_columns?: Array<Action_Update_Update_Column>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.action_update". */
export type Action_Update_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentActionId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  action?: InputMaybe<Action_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.action_update */
export type Action_Update_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Action_Update_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.action_update" */
export const Action_Update_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentActionId: 'ParentActionId',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Update_Select_Column = typeof Action_Update_Select_Column[keyof typeof Action_Update_Select_Column];
/** input type for updating data in table "risksmart.action_update" */
export type Action_Update_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentActionId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "action_update" */
export type Action_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Update_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentActionId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.action_update_summary_view" */
export type Action_Update_Summary = {
  __typename?: 'action_update_summary';
  ActionId?: Maybe<Scalars['uuid']['output']>;
  Count?: Maybe<Scalars['bigint']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "risksmart.action_update_summary_view" */
export type Action_Update_Summary_Aggregate = {
  __typename?: 'action_update_summary_aggregate';
  aggregate?: Maybe<Action_Update_Summary_Aggregate_Fields>;
  nodes: Array<Action_Update_Summary>;
};

/** aggregate fields of "risksmart.action_update_summary_view" */
export type Action_Update_Summary_Aggregate_Fields = {
  __typename?: 'action_update_summary_aggregate_fields';
  avg?: Maybe<Action_Update_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Action_Update_Summary_Max_Fields>;
  min?: Maybe<Action_Update_Summary_Min_Fields>;
  stddev?: Maybe<Action_Update_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Update_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Update_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Update_Summary_Sum_Fields>;
  var_pop?: Maybe<Action_Update_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Update_Summary_Var_Samp_Fields>;
  variance?: Maybe<Action_Update_Summary_Variance_Fields>;
};


/** aggregate fields of "risksmart.action_update_summary_view" */
export type Action_Update_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Update_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Action_Update_Summary_Avg_Fields = {
  __typename?: 'action_update_summary_avg_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.action_update_summary_view". All fields are combined with a logical 'AND'. */
export type Action_Update_Summary_Bool_Exp = {
  ActionId?: InputMaybe<Uuid_Comparison_Exp>;
  Count?: InputMaybe<Bigint_Comparison_Exp>;
  LatestCreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  LatestDescription?: InputMaybe<String_Comparison_Exp>;
  LatestTitle?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Action_Update_Summary_Bool_Exp>>;
  _not?: InputMaybe<Action_Update_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Update_Summary_Bool_Exp>>;
};

/** aggregate max on columns */
export type Action_Update_Summary_Max_Fields = {
  __typename?: 'action_update_summary_max_fields';
  ActionId?: Maybe<Scalars['uuid']['output']>;
  Count?: Maybe<Scalars['bigint']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Action_Update_Summary_Min_Fields = {
  __typename?: 'action_update_summary_min_fields';
  ActionId?: Maybe<Scalars['uuid']['output']>;
  Count?: Maybe<Scalars['bigint']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.action_update_summary_view". */
export type Action_Update_Summary_Order_By = {
  ActionId?: InputMaybe<Order_By>;
  Count?: InputMaybe<Order_By>;
  LatestCreatedAtTimestamp?: InputMaybe<Order_By>;
  LatestDescription?: InputMaybe<Order_By>;
  LatestTitle?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.action_update_summary_view" */
export const Action_Update_Summary_Select_Column = {
  /** column name */
  ActionId: 'ActionId',
  /** column name */
  Count: 'Count',
  /** column name */
  LatestCreatedAtTimestamp: 'LatestCreatedAtTimestamp',
  /** column name */
  LatestDescription: 'LatestDescription',
  /** column name */
  LatestTitle: 'LatestTitle'
} as const;

export type Action_Update_Summary_Select_Column = typeof Action_Update_Summary_Select_Column[keyof typeof Action_Update_Summary_Select_Column];
/** aggregate stddev on columns */
export type Action_Update_Summary_Stddev_Fields = {
  __typename?: 'action_update_summary_stddev_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Action_Update_Summary_Stddev_Pop_Fields = {
  __typename?: 'action_update_summary_stddev_pop_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Action_Update_Summary_Stddev_Samp_Fields = {
  __typename?: 'action_update_summary_stddev_samp_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "action_update_summary" */
export type Action_Update_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Update_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Update_Summary_Stream_Cursor_Value_Input = {
  ActionId?: InputMaybe<Scalars['uuid']['input']>;
  Count?: InputMaybe<Scalars['bigint']['input']>;
  LatestCreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  LatestDescription?: InputMaybe<Scalars['String']['input']>;
  LatestTitle?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Action_Update_Summary_Sum_Fields = {
  __typename?: 'action_update_summary_sum_fields';
  Count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Action_Update_Summary_Var_Pop_Fields = {
  __typename?: 'action_update_summary_var_pop_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Action_Update_Summary_Var_Samp_Fields = {
  __typename?: 'action_update_summary_var_samp_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Action_Update_Summary_Variance_Fields = {
  __typename?: 'action_update_summary_variance_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "risksmart.action_update" */
export const Action_Update_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ParentActionId: 'ParentActionId',
  /** column name */
  Title: 'Title'
} as const;

export type Action_Update_Update_Column = typeof Action_Update_Update_Column[keyof typeof Action_Update_Update_Column];
export type Action_Update_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Action_Update_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Action_Update_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Action_Update_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Action_Update_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Action_Update_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Action_Update_Set_Input>;
  /** filter the rows which have to be updated */
  where: Action_Update_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Action_Var_Pop_Fields = {
  __typename?: 'action_var_pop_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Action_Var_Samp_Fields = {
  __typename?: 'action_var_samp_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Action_Variance_Fields = {
  __typename?: 'action_variance_fields';
  Priority?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.aggregation_org" */
export type Aggregation_Org = {
  __typename?: 'aggregation_org';
  Appetite?: Maybe<Appetite_Model_Enum>;
  Config?: Maybe<Scalars['jsonb']['output']>;
  OrgKey: Scalars['String']['output'];
  RiskScoringModel?: Maybe<Risk_Scoring_Model_Enum>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.aggregation_org" */
export type Aggregation_OrgConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Aggregation_Org_Append_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.aggregation_org". All fields are combined with a logical 'AND'. */
export type Aggregation_Org_Bool_Exp = {
  Appetite?: InputMaybe<Appetite_Model_Enum_Comparison_Exp>;
  Config?: InputMaybe<Jsonb_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  RiskScoringModel?: InputMaybe<Risk_Scoring_Model_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Aggregation_Org_Bool_Exp>>;
  _not?: InputMaybe<Aggregation_Org_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregation_Org_Bool_Exp>>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.aggregation_org" */
export const Aggregation_Org_Constraint = {
  /** unique or primary key constraint on columns "OrgKey" */
  AggregationOrgPkey: 'aggregation_org_pkey'
} as const;

export type Aggregation_Org_Constraint = typeof Aggregation_Org_Constraint[keyof typeof Aggregation_Org_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Aggregation_Org_Delete_At_Path_Input = {
  Config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Aggregation_Org_Delete_Elem_Input = {
  Config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Aggregation_Org_Delete_Key_Input = {
  Config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.aggregation_org" */
export type Aggregation_Org_Insert_Input = {
  Appetite?: InputMaybe<Appetite_Model_Enum>;
  Config?: InputMaybe<Scalars['jsonb']['input']>;
  RiskScoringModel?: InputMaybe<Risk_Scoring_Model_Enum>;
};

/** response of any mutation on the table "risksmart.aggregation_org" */
export type Aggregation_Org_Mutation_Response = {
  __typename?: 'aggregation_org_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Aggregation_Org>;
};

/** on_conflict condition type for table "risksmart.aggregation_org" */
export type Aggregation_Org_On_Conflict = {
  constraint: Aggregation_Org_Constraint;
  update_columns?: Array<Aggregation_Org_Update_Column>;
  where?: InputMaybe<Aggregation_Org_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.aggregation_org". */
export type Aggregation_Org_Order_By = {
  Appetite?: InputMaybe<Order_By>;
  Config?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RiskScoringModel?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.aggregation_org */
export type Aggregation_Org_Pk_Columns_Input = {
  OrgKey: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Aggregation_Org_Prepend_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.aggregation_org" */
export const Aggregation_Org_Select_Column = {
  /** column name */
  Appetite: 'Appetite',
  /** column name */
  Config: 'Config',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  RiskScoringModel: 'RiskScoringModel'
} as const;

export type Aggregation_Org_Select_Column = typeof Aggregation_Org_Select_Column[keyof typeof Aggregation_Org_Select_Column];
/** input type for updating data in table "risksmart.aggregation_org" */
export type Aggregation_Org_Set_Input = {
  Appetite?: InputMaybe<Appetite_Model_Enum>;
  Config?: InputMaybe<Scalars['jsonb']['input']>;
  RiskScoringModel?: InputMaybe<Risk_Scoring_Model_Enum>;
};

/** Streaming cursor of the table "aggregation_org" */
export type Aggregation_Org_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Aggregation_Org_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Aggregation_Org_Stream_Cursor_Value_Input = {
  Appetite?: InputMaybe<Appetite_Model_Enum>;
  Config?: InputMaybe<Scalars['jsonb']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  RiskScoringModel?: InputMaybe<Risk_Scoring_Model_Enum>;
};

/** update columns of table "risksmart.aggregation_org" */
export const Aggregation_Org_Update_Column = {
  /** column name */
  Appetite: 'Appetite',
  /** column name */
  Config: 'Config',
  /** column name */
  RiskScoringModel: 'RiskScoringModel'
} as const;

export type Aggregation_Org_Update_Column = typeof Aggregation_Org_Update_Column[keyof typeof Aggregation_Org_Update_Column];
export type Aggregation_Org_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Aggregation_Org_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Aggregation_Org_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Aggregation_Org_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Aggregation_Org_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Aggregation_Org_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Aggregation_Org_Set_Input>;
  /** filter the rows which have to be updated */
  where: Aggregation_Org_Bool_Exp;
};

/** columns and relationships of "risksmart.ancestor_contributor_view" */
export type Ancestor_Contributor = {
  __typename?: 'ancestor_contributor';
  AncestorId?: Maybe<Scalars['uuid']['output']>;
  ContributorType?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ObjectType?: Maybe<Scalars['String']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  action?: Maybe<Action>;
  /** An object relationship */
  appetite?: Maybe<Appetite>;
  /** An object relationship */
  assessment?: Maybe<Assessment>;
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  dashboard?: Maybe<Dashboard>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  document_assessment_result?: Maybe<Document_Assessment_Result>;
  /** An object relationship */
  impact?: Maybe<Impact>;
  /** An object relationship */
  indicator?: Maybe<Indicator>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  node?: Maybe<Node>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  obligationAssessmentResult?: Maybe<Obligation_Assessment_Result>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  risk_assessment_result?: Maybe<Risk_Assessment_Result>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  user_group?: Maybe<User_Group>;
};

/** order by aggregate values of table "risksmart.ancestor_contributor_view" */
export type Ancestor_Contributor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ancestor_Contributor_Max_Order_By>;
  min?: InputMaybe<Ancestor_Contributor_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.ancestor_contributor_view". All fields are combined with a logical 'AND'. */
export type Ancestor_Contributor_Bool_Exp = {
  AncestorId?: InputMaybe<Uuid_Comparison_Exp>;
  ContributorType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ObjectType?: InputMaybe<String_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Ancestor_Contributor_Bool_Exp>>;
  _not?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  _or?: InputMaybe<Array<Ancestor_Contributor_Bool_Exp>>;
  acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  action?: InputMaybe<Action_Bool_Exp>;
  appetite?: InputMaybe<Appetite_Bool_Exp>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  control?: InputMaybe<Control_Bool_Exp>;
  dashboard?: InputMaybe<Dashboard_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_assessment_result?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  indicator?: InputMaybe<Indicator_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  node?: InputMaybe<Node_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  obligationAssessmentResult?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  risk_assessment_result?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_group?: InputMaybe<User_Group_Bool_Exp>;
};

/** order by max() on columns of table "risksmart.ancestor_contributor_view" */
export type Ancestor_Contributor_Max_Order_By = {
  AncestorId?: InputMaybe<Order_By>;
  ContributorType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.ancestor_contributor_view" */
export type Ancestor_Contributor_Min_Order_By = {
  AncestorId?: InputMaybe<Order_By>;
  ContributorType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.ancestor_contributor_view". */
export type Ancestor_Contributor_Order_By = {
  AncestorId?: InputMaybe<Order_By>;
  ContributorType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  acceptance?: InputMaybe<Acceptance_Order_By>;
  action?: InputMaybe<Action_Order_By>;
  appetite?: InputMaybe<Appetite_Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  control?: InputMaybe<Control_Order_By>;
  dashboard?: InputMaybe<Dashboard_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_assessment_result?: InputMaybe<Document_Assessment_Result_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  indicator?: InputMaybe<Indicator_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  node?: InputMaybe<Node_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  obligationAssessmentResult?: InputMaybe<Obligation_Assessment_Result_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  risk_assessment_result?: InputMaybe<Risk_Assessment_Result_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_group?: InputMaybe<User_Group_Order_By>;
};

/** select columns of table "risksmart.ancestor_contributor_view" */
export const Ancestor_Contributor_Select_Column = {
  /** column name */
  AncestorId: 'AncestorId',
  /** column name */
  ContributorType: 'ContributorType',
  /** column name */
  Id: 'Id',
  /** column name */
  ObjectType: 'ObjectType',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Ancestor_Contributor_Select_Column = typeof Ancestor_Contributor_Select_Column[keyof typeof Ancestor_Contributor_Select_Column];
/** Streaming cursor of the table "ancestor_contributor" */
export type Ancestor_Contributor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ancestor_Contributor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ancestor_Contributor_Stream_Cursor_Value_Input = {
  AncestorId?: InputMaybe<Scalars['uuid']['input']>;
  ContributorType?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ObjectType?: InputMaybe<Scalars['String']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.appetite" */
export type Appetite = {
  __typename?: 'appetite';
  AppetiteType: Appetite_Type_Enum;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  EffectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactAppetite?: Maybe<Scalars['Int']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Int']['output']>;
  LowerAppetite?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequentialId: Scalars['Int']['output'];
  Statement?: Maybe<Scalars['String']['output']>;
  UpperAppetite?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  impact?: Maybe<Impact>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Appetite_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Appetite_Parent_Aggregate;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteParentsArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.appetite" */
export type AppetiteParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.appetite" */
export type Appetite_Aggregate = {
  __typename?: 'appetite_aggregate';
  aggregate?: Maybe<Appetite_Aggregate_Fields>;
  nodes: Array<Appetite>;
};

export type Appetite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appetite_Aggregate_Bool_Exp_Count>;
};

export type Appetite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appetite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Appetite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.appetite" */
export type Appetite_Aggregate_Fields = {
  __typename?: 'appetite_aggregate_fields';
  avg?: Maybe<Appetite_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Appetite_Max_Fields>;
  min?: Maybe<Appetite_Min_Fields>;
  stddev?: Maybe<Appetite_Stddev_Fields>;
  stddev_pop?: Maybe<Appetite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appetite_Stddev_Samp_Fields>;
  sum?: Maybe<Appetite_Sum_Fields>;
  var_pop?: Maybe<Appetite_Var_Pop_Fields>;
  var_samp?: Maybe<Appetite_Var_Samp_Fields>;
  variance?: Maybe<Appetite_Variance_Fields>;
};


/** aggregate fields of "risksmart.appetite" */
export type Appetite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appetite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.appetite" */
export type Appetite_Aggregate_Order_By = {
  avg?: InputMaybe<Appetite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appetite_Max_Order_By>;
  min?: InputMaybe<Appetite_Min_Order_By>;
  stddev?: InputMaybe<Appetite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appetite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appetite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appetite_Sum_Order_By>;
  var_pop?: InputMaybe<Appetite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appetite_Var_Samp_Order_By>;
  variance?: InputMaybe<Appetite_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Appetite_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.appetite" */
export type Appetite_Arr_Rel_Insert_Input = {
  data: Array<Appetite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appetite_On_Conflict>;
};

/** columns and relationships of "risksmart.appetite_audit" */
export type Appetite_Audit = {
  __typename?: 'appetite_audit';
  AppetiteType?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  EffectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactAppetite?: Maybe<Scalars['Int']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Int']['output']>;
  LowerAppetite?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Statement?: Maybe<Scalars['String']['output']>;
  UpperAppetite?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "risksmart.appetite_audit" */
export type Appetite_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.appetite_audit". All fields are combined with a logical 'AND'. */
export type Appetite_Audit_Bool_Exp = {
  AppetiteType?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactAppetite?: InputMaybe<Int_Comparison_Exp>;
  LikelihoodAppetite?: InputMaybe<Int_Comparison_Exp>;
  LowerAppetite?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Statement?: InputMaybe<String_Comparison_Exp>;
  UpperAppetite?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Appetite_Audit_Bool_Exp>>;
  _not?: InputMaybe<Appetite_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Appetite_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.appetite_audit". */
export type Appetite_Audit_Order_By = {
  AppetiteType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Statement?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.appetite_audit" */
export const Appetite_Audit_Select_Column = {
  /** column name */
  AppetiteType: 'AppetiteType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  EffectiveDate: 'EffectiveDate',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactAppetite: 'ImpactAppetite',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  LowerAppetite: 'LowerAppetite',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Statement: 'Statement',
  /** column name */
  UpperAppetite: 'UpperAppetite'
} as const;

export type Appetite_Audit_Select_Column = typeof Appetite_Audit_Select_Column[keyof typeof Appetite_Audit_Select_Column];
/** Streaming cursor of the table "appetite_audit" */
export type Appetite_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appetite_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appetite_Audit_Stream_Cursor_Value_Input = {
  AppetiteType?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate avg on columns */
export type Appetite_Avg_Fields = {
  __typename?: 'appetite_avg_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.appetite" */
export type Appetite_Avg_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.appetite". All fields are combined with a logical 'AND'. */
export type Appetite_Bool_Exp = {
  AppetiteType?: InputMaybe<Appetite_Type_Enum_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactAppetite?: InputMaybe<Int_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  LikelihoodAppetite?: InputMaybe<Int_Comparison_Exp>;
  LowerAppetite?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Statement?: InputMaybe<String_Comparison_Exp>;
  UpperAppetite?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Appetite_Bool_Exp>>;
  _not?: InputMaybe<Appetite_Bool_Exp>;
  _or?: InputMaybe<Array<Appetite_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Appetite_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Appetite_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.appetite" */
export const Appetite_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AppetitePkey: 'appetite_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxAppetiteOrgkeySequentialid: 'idx_appetite_orgkey_sequentialid'
} as const;

export type Appetite_Constraint = typeof Appetite_Constraint[keyof typeof Appetite_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Appetite_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Appetite_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Appetite_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.appetite" */
export type Appetite_Inc_Input = {
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.appetite" */
export type Appetite_Insert_Input = {
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
  parents?: InputMaybe<Appetite_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Appetite_Max_Fields = {
  __typename?: 'appetite_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  EffectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactAppetite?: Maybe<Scalars['Int']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Int']['output']>;
  LowerAppetite?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Statement?: Maybe<Scalars['String']['output']>;
  UpperAppetite?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "risksmart.appetite" */
export type Appetite_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactAppetite?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Statement?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appetite_Min_Fields = {
  __typename?: 'appetite_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  EffectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactAppetite?: Maybe<Scalars['Int']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Int']['output']>;
  LowerAppetite?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Statement?: Maybe<Scalars['String']['output']>;
  UpperAppetite?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "risksmart.appetite" */
export type Appetite_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactAppetite?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Statement?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

export const Appetite_Model_Enum = {
  /** Default model */
  Default: 'default',
  /** Top down cascade */
  TopDownCascade: 'top_down_cascade'
} as const;

export type Appetite_Model_Enum = typeof Appetite_Model_Enum[keyof typeof Appetite_Model_Enum];
/** Boolean expression to compare columns of type "appetite_model_enum". All fields are combined with logical 'AND'. */
export type Appetite_Model_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Appetite_Model_Enum>;
  _in?: InputMaybe<Array<Appetite_Model_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Appetite_Model_Enum>;
  _nin?: InputMaybe<Array<Appetite_Model_Enum>>;
};

/** response of any mutation on the table "risksmart.appetite" */
export type Appetite_Mutation_Response = {
  __typename?: 'appetite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Appetite>;
};

/** input type for inserting object relation for remote table "risksmart.appetite" */
export type Appetite_Obj_Rel_Insert_Input = {
  data: Appetite_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Appetite_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.appetite" */
export type Appetite_On_Conflict = {
  constraint: Appetite_Constraint;
  update_columns?: Array<Appetite_Update_Column>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.appetite". */
export type Appetite_Order_By = {
  AppetiteType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactAppetite?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Statement?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Appetite_Parent_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.appetite_parent" */
export type Appetite_Parent = {
  __typename?: 'appetite_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  Status?: Maybe<Appetite_Status_Enum>;
  /** An object relationship */
  appetite?: Maybe<Appetite>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
};

/** aggregated selection of "risksmart.appetite_parent" */
export type Appetite_Parent_Aggregate = {
  __typename?: 'appetite_parent_aggregate';
  aggregate?: Maybe<Appetite_Parent_Aggregate_Fields>;
  nodes: Array<Appetite_Parent>;
};

export type Appetite_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appetite_Parent_Aggregate_Bool_Exp_Count>;
};

export type Appetite_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Appetite_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.appetite_parent" */
export type Appetite_Parent_Aggregate_Fields = {
  __typename?: 'appetite_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Appetite_Parent_Max_Fields>;
  min?: Maybe<Appetite_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.appetite_parent" */
export type Appetite_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.appetite_parent" */
export type Appetite_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appetite_Parent_Max_Order_By>;
  min?: InputMaybe<Appetite_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.appetite_parent" */
export type Appetite_Parent_Arr_Rel_Insert_Input = {
  data: Array<Appetite_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appetite_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit = {
  __typename?: 'appetite_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
};

/** aggregated selection of "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Aggregate = {
  __typename?: 'appetite_parent_audit_aggregate';
  aggregate?: Maybe<Appetite_Parent_Audit_Aggregate_Fields>;
  nodes: Array<Appetite_Parent_Audit>;
};

export type Appetite_Parent_Audit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appetite_Parent_Audit_Aggregate_Bool_Exp_Count>;
};

export type Appetite_Parent_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Aggregate_Fields = {
  __typename?: 'appetite_parent_audit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Appetite_Parent_Audit_Max_Fields>;
  min?: Maybe<Appetite_Parent_Audit_Min_Fields>;
};


/** aggregate fields of "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appetite_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Appetite_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.appetite_parent_audit". All fields are combined with a logical 'AND'. */
export type Appetite_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Appetite_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Appetite_Parent_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Appetite_Parent_Audit_Max_Fields = {
  __typename?: 'appetite_parent_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appetite_Parent_Audit_Min_Fields = {
  __typename?: 'appetite_parent_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.appetite_parent_audit" */
export type Appetite_Parent_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.appetite_parent_audit". */
export type Appetite_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.appetite_parent_audit" */
export const Appetite_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Appetite_Parent_Audit_Select_Column = typeof Appetite_Parent_Audit_Select_Column[keyof typeof Appetite_Parent_Audit_Select_Column];
/** Streaming cursor of the table "appetite_parent_audit" */
export type Appetite_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appetite_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appetite_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.appetite_parent". All fields are combined with a logical 'AND'. */
export type Appetite_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<Appetite_Status_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Appetite_Parent_Bool_Exp>>;
  _not?: InputMaybe<Appetite_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Appetite_Parent_Bool_Exp>>;
  appetite?: InputMaybe<Appetite_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.appetite_parent" */
export const Appetite_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "Id" */
  AppetiteParentPkey: 'appetite_parent_pkey'
} as const;

export type Appetite_Parent_Constraint = typeof Appetite_Parent_Constraint[keyof typeof Appetite_Parent_Constraint];
/** input type for inserting data into table "risksmart.appetite_parent" */
export type Appetite_Parent_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  appetite?: InputMaybe<Appetite_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Appetite_Parent_Max_Fields = {
  __typename?: 'appetite_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.appetite_parent" */
export type Appetite_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appetite_Parent_Min_Fields = {
  __typename?: 'appetite_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.appetite_parent" */
export type Appetite_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.appetite_parent" */
export type Appetite_Parent_Mutation_Response = {
  __typename?: 'appetite_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Appetite_Parent>;
};

/** on_conflict condition type for table "risksmart.appetite_parent" */
export type Appetite_Parent_On_Conflict = {
  constraint: Appetite_Parent_Constraint;
  update_columns?: Array<Appetite_Parent_Update_Column>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.appetite_parent". */
export type Appetite_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  appetite?: InputMaybe<Appetite_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.appetite_parent" */
export const Appetite_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Status: 'Status'
} as const;

export type Appetite_Parent_Select_Column = typeof Appetite_Parent_Select_Column[keyof typeof Appetite_Parent_Select_Column];
/** Streaming cursor of the table "appetite_parent" */
export type Appetite_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appetite_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appetite_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Appetite_Status_Enum>;
};

/** placeholder for update columns of table "risksmart.appetite_parent" (current role has no relevant permissions) */
export const Appetite_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Appetite_Parent_Update_Column = typeof Appetite_Parent_Update_Column[keyof typeof Appetite_Parent_Update_Column];
/** primary key columns input for table: risksmart.appetite */
export type Appetite_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Appetite_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.appetite" */
export const Appetite_Select_Column = {
  /** column name */
  AppetiteType: 'AppetiteType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  EffectiveDate: 'EffectiveDate',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactAppetite: 'ImpactAppetite',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  LowerAppetite: 'LowerAppetite',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Statement: 'Statement',
  /** column name */
  UpperAppetite: 'UpperAppetite'
} as const;

export type Appetite_Select_Column = typeof Appetite_Select_Column[keyof typeof Appetite_Select_Column];
/** input type for updating data in table "risksmart.appetite" */
export type Appetite_Set_Input = {
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
};

export const Appetite_Status_Enum = {
  /** Active */
  Active: 'active',
  /** Archived */
  Archived: 'archived'
} as const;

export type Appetite_Status_Enum = typeof Appetite_Status_Enum[keyof typeof Appetite_Status_Enum];
/** Boolean expression to compare columns of type "appetite_status_enum". All fields are combined with logical 'AND'. */
export type Appetite_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Appetite_Status_Enum>;
  _in?: InputMaybe<Array<Appetite_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Appetite_Status_Enum>;
  _nin?: InputMaybe<Array<Appetite_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Appetite_Stddev_Fields = {
  __typename?: 'appetite_stddev_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.appetite" */
export type Appetite_Stddev_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Appetite_Stddev_Pop_Fields = {
  __typename?: 'appetite_stddev_pop_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.appetite" */
export type Appetite_Stddev_Pop_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Appetite_Stddev_Samp_Fields = {
  __typename?: 'appetite_stddev_samp_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.appetite" */
export type Appetite_Stddev_Samp_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appetite" */
export type Appetite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appetite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appetite_Stream_Cursor_Value_Input = {
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Appetite_Sum_Fields = {
  __typename?: 'appetite_sum_fields';
  ImpactAppetite?: Maybe<Scalars['Int']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Int']['output']>;
  LowerAppetite?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  UpperAppetite?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.appetite" */
export type Appetite_Sum_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

export const Appetite_Type_Enum = {
  /** Impact */
  Impact: 'impact',
  /** Likelihood */
  Likelihood: 'likelihood',
  /** Risk */
  Risk: 'risk'
} as const;

export type Appetite_Type_Enum = typeof Appetite_Type_Enum[keyof typeof Appetite_Type_Enum];
/** Boolean expression to compare columns of type "appetite_type_enum". All fields are combined with logical 'AND'. */
export type Appetite_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Appetite_Type_Enum>;
  _in?: InputMaybe<Array<Appetite_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Appetite_Type_Enum>;
  _nin?: InputMaybe<Array<Appetite_Type_Enum>>;
};

/** update columns of table "risksmart.appetite" */
export const Appetite_Update_Column = {
  /** column name */
  AppetiteType: 'AppetiteType',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  EffectiveDate: 'EffectiveDate',
  /** column name */
  ImpactAppetite: 'ImpactAppetite',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  LowerAppetite: 'LowerAppetite',
  /** column name */
  Statement: 'Statement',
  /** column name */
  UpperAppetite: 'UpperAppetite'
} as const;

export type Appetite_Update_Column = typeof Appetite_Update_Column[keyof typeof Appetite_Update_Column];
export type Appetite_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Appetite_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Appetite_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Appetite_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Appetite_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appetite_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Appetite_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appetite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appetite_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appetite_Var_Pop_Fields = {
  __typename?: 'appetite_var_pop_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.appetite" */
export type Appetite_Var_Pop_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Appetite_Var_Samp_Fields = {
  __typename?: 'appetite_var_samp_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.appetite" */
export type Appetite_Var_Samp_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Appetite_Variance_Fields = {
  __typename?: 'appetite_variance_fields';
  ImpactAppetite?: Maybe<Scalars['Float']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  LowerAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
  UpperAppetite?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.appetite" */
export type Appetite_Variance_Order_By = {
  ImpactAppetite?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  LowerAppetite?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetite?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.approval" */
export type Approval = {
  __typename?: 'approval';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  Workflow: Scalars['String']['output'];
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An array relationship */
  levels: Array<Approval_Level>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
  /** An object relationship */
  parent?: Maybe<Node>;
};


/** columns and relationships of "risksmart.approval" */
export type ApprovalLevelsArgs = {
  distinct_on?: InputMaybe<Array<Approval_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Level_Order_By>>;
  where?: InputMaybe<Approval_Level_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.approval" */
export type Approval_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approval_Max_Order_By>;
  min?: InputMaybe<Approval_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.approval" */
export type Approval_Arr_Rel_Insert_Input = {
  data: Array<Approval_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};

/** columns and relationships of "risksmart.approval_audit" */
export type Approval_Audit = {
  __typename?: 'approval_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  InFlightEditRule: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  Workflow: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.approval_audit". All fields are combined with a logical 'AND'. */
export type Approval_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InFlightEditRule?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Workflow?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Approval_Audit_Bool_Exp>>;
  _not?: InputMaybe<Approval_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Approval_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.approval_audit". */
export type Approval_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InFlightEditRule?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Workflow?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.approval_audit" */
export const Approval_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  InFlightEditRule: 'InFlightEditRule',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Workflow: 'Workflow'
} as const;

export type Approval_Audit_Select_Column = typeof Approval_Audit_Select_Column[keyof typeof Approval_Audit_Select_Column];
/** Streaming cursor of the table "approval_audit" */
export type Approval_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approval_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approval_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  InFlightEditRule?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Workflow?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.approval". All fields are combined with a logical 'AND'. */
export type Approval_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InFlightEditRule?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Workflow?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Approval_Bool_Exp>>;
  _not?: InputMaybe<Approval_Bool_Exp>;
  _or?: InputMaybe<Array<Approval_Bool_Exp>>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  levels?: InputMaybe<Approval_Level_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.approval" */
export const Approval_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ApprovalPkey: 'approval_pkey',
  /** unique or primary key constraint on columns "Workflow", "ParentId" */
  IdxApprovalParentParentType: 'idx_approval_parent_parent_type'
} as const;

export type Approval_Constraint = typeof Approval_Constraint[keyof typeof Approval_Constraint];
export const Approval_In_Flight_Edit_Rule_Enum = {
  /** Only approvers can edit */
  Approvers: 'approvers',
  /** Everyone who has access can edit */
  Everyone: 'everyone',
  /** No one can edit */
  Noone: 'noone'
} as const;

export type Approval_In_Flight_Edit_Rule_Enum = typeof Approval_In_Flight_Edit_Rule_Enum[keyof typeof Approval_In_Flight_Edit_Rule_Enum];
/** Boolean expression to compare columns of type "approval_in_flight_edit_rule_enum". All fields are combined with logical 'AND'. */
export type Approval_In_Flight_Edit_Rule_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum>;
  _in?: InputMaybe<Array<Approval_In_Flight_Edit_Rule_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum>;
  _nin?: InputMaybe<Array<Approval_In_Flight_Edit_Rule_Enum>>;
};

/** input type for inserting data into table "risksmart.approval" */
export type Approval_Insert_Input = {
  InFlightEditRule?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Workflow?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Approval_Level_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "risksmart.approval_level" */
export type Approval_Level = {
  __typename?: 'approval_level';
  ApprovalId: Scalars['uuid']['output'];
  ApprovalRuleType: Approval_Rule_Type_Enum;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequenceOrder: Scalars['Int']['output'];
  /** An object relationship */
  approval?: Maybe<Approval>;
  /** An array relationship */
  approvers: Array<Approver>;
  /** An aggregate relationship */
  approvers_aggregate: Approver_Aggregate;
};


/** columns and relationships of "risksmart.approval_level" */
export type Approval_LevelApproversArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


/** columns and relationships of "risksmart.approval_level" */
export type Approval_LevelApprovers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.approval_level" */
export type Approval_Level_Aggregate_Order_By = {
  avg?: InputMaybe<Approval_Level_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approval_Level_Max_Order_By>;
  min?: InputMaybe<Approval_Level_Min_Order_By>;
  stddev?: InputMaybe<Approval_Level_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Approval_Level_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Approval_Level_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Approval_Level_Sum_Order_By>;
  var_pop?: InputMaybe<Approval_Level_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Approval_Level_Var_Samp_Order_By>;
  variance?: InputMaybe<Approval_Level_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.approval_level" */
export type Approval_Level_Arr_Rel_Insert_Input = {
  data: Array<Approval_Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_Level_On_Conflict>;
};

/** columns and relationships of "risksmart.approval_level_audit" */
export type Approval_Level_Audit = {
  __typename?: 'approval_level_audit';
  ApprovalId: Scalars['uuid']['output'];
  ApprovalRuleType: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequenceOrder: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.approval_level_audit". All fields are combined with a logical 'AND'. */
export type Approval_Level_Audit_Bool_Exp = {
  ApprovalId?: InputMaybe<Uuid_Comparison_Exp>;
  ApprovalRuleType?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequenceOrder?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Approval_Level_Audit_Bool_Exp>>;
  _not?: InputMaybe<Approval_Level_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Approval_Level_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.approval_level_audit". */
export type Approval_Level_Audit_Order_By = {
  ApprovalId?: InputMaybe<Order_By>;
  ApprovalRuleType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequenceOrder?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.approval_level_audit" */
export const Approval_Level_Audit_Select_Column = {
  /** column name */
  ApprovalId: 'ApprovalId',
  /** column name */
  ApprovalRuleType: 'ApprovalRuleType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequenceOrder: 'SequenceOrder'
} as const;

export type Approval_Level_Audit_Select_Column = typeof Approval_Level_Audit_Select_Column[keyof typeof Approval_Level_Audit_Select_Column];
/** Streaming cursor of the table "approval_level_audit" */
export type Approval_Level_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approval_Level_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approval_Level_Audit_Stream_Cursor_Value_Input = {
  ApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  ApprovalRuleType?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequenceOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** order by avg() on columns of table "risksmart.approval_level" */
export type Approval_Level_Avg_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.approval_level". All fields are combined with a logical 'AND'. */
export type Approval_Level_Bool_Exp = {
  ApprovalId?: InputMaybe<Uuid_Comparison_Exp>;
  ApprovalRuleType?: InputMaybe<Approval_Rule_Type_Enum_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequenceOrder?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Approval_Level_Bool_Exp>>;
  _not?: InputMaybe<Approval_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Approval_Level_Bool_Exp>>;
  approval?: InputMaybe<Approval_Bool_Exp>;
  approvers?: InputMaybe<Approver_Bool_Exp>;
  approvers_aggregate?: InputMaybe<Approver_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.approval_level" */
export const Approval_Level_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ApprovalLevelPkey: 'approval_level_pkey',
  /** unique or primary key constraint on columns "SequenceOrder", "ApprovalId" */
  IdxApprovalLevelSeqApprovalId: 'idx_approval_level_seq_approval_id'
} as const;

export type Approval_Level_Constraint = typeof Approval_Level_Constraint[keyof typeof Approval_Level_Constraint];
/** input type for incrementing numeric columns in table "risksmart.approval_level" */
export type Approval_Level_Inc_Input = {
  SequenceOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.approval_level" */
export type Approval_Level_Insert_Input = {
  ApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  ApprovalRuleType?: InputMaybe<Approval_Rule_Type_Enum>;
  Description?: InputMaybe<Scalars['String']['input']>;
  SequenceOrder?: InputMaybe<Scalars['Int']['input']>;
  approval?: InputMaybe<Approval_Obj_Rel_Insert_Input>;
  approvers?: InputMaybe<Approver_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.approval_level" */
export type Approval_Level_Max_Order_By = {
  ApprovalId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.approval_level" */
export type Approval_Level_Min_Order_By = {
  ApprovalId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequenceOrder?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.approval_level" */
export type Approval_Level_Mutation_Response = {
  __typename?: 'approval_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Approval_Level>;
};

/** input type for inserting object relation for remote table "risksmart.approval_level" */
export type Approval_Level_Obj_Rel_Insert_Input = {
  data: Approval_Level_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_Level_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.approval_level" */
export type Approval_Level_On_Conflict = {
  constraint: Approval_Level_Constraint;
  update_columns?: Array<Approval_Level_Update_Column>;
  where?: InputMaybe<Approval_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.approval_level". */
export type Approval_Level_Order_By = {
  ApprovalId?: InputMaybe<Order_By>;
  ApprovalRuleType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequenceOrder?: InputMaybe<Order_By>;
  approval?: InputMaybe<Approval_Order_By>;
  approvers_aggregate?: InputMaybe<Approver_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.approval_level */
export type Approval_Level_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.approval_level" */
export const Approval_Level_Select_Column = {
  /** column name */
  ApprovalId: 'ApprovalId',
  /** column name */
  ApprovalRuleType: 'ApprovalRuleType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequenceOrder: 'SequenceOrder'
} as const;

export type Approval_Level_Select_Column = typeof Approval_Level_Select_Column[keyof typeof Approval_Level_Select_Column];
/** input type for updating data in table "risksmart.approval_level" */
export type Approval_Level_Set_Input = {
  ApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  ApprovalRuleType?: InputMaybe<Approval_Rule_Type_Enum>;
  Description?: InputMaybe<Scalars['String']['input']>;
  SequenceOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "risksmart.approval_level" */
export type Approval_Level_Stddev_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.approval_level" */
export type Approval_Level_Stddev_Pop_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.approval_level" */
export type Approval_Level_Stddev_Samp_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "approval_level" */
export type Approval_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approval_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approval_Level_Stream_Cursor_Value_Input = {
  ApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  ApprovalRuleType?: InputMaybe<Approval_Rule_Type_Enum>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequenceOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "risksmart.approval_level" */
export type Approval_Level_Sum_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.approval_level" */
export const Approval_Level_Update_Column = {
  /** column name */
  ApprovalId: 'ApprovalId',
  /** column name */
  ApprovalRuleType: 'ApprovalRuleType',
  /** column name */
  Description: 'Description',
  /** column name */
  SequenceOrder: 'SequenceOrder'
} as const;

export type Approval_Level_Update_Column = typeof Approval_Level_Update_Column[keyof typeof Approval_Level_Update_Column];
export type Approval_Level_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Approval_Level_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Approval_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Approval_Level_Bool_Exp;
};

/** order by var_pop() on columns of table "risksmart.approval_level" */
export type Approval_Level_Var_Pop_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.approval_level" */
export type Approval_Level_Var_Samp_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.approval_level" */
export type Approval_Level_Variance_Order_By = {
  SequenceOrder?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "risksmart.approval" */
export type Approval_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Workflow?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.approval" */
export type Approval_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Workflow?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.approval" */
export type Approval_Mutation_Response = {
  __typename?: 'approval_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Approval>;
};

/** input type for inserting object relation for remote table "risksmart.approval" */
export type Approval_Obj_Rel_Insert_Input = {
  data: Approval_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.approval" */
export type Approval_On_Conflict = {
  constraint: Approval_Constraint;
  update_columns?: Array<Approval_Update_Column>;
  where?: InputMaybe<Approval_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.approval". */
export type Approval_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InFlightEditRule?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Workflow?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  levels_aggregate?: InputMaybe<Approval_Level_Aggregate_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
};

/** primary key columns input for table: risksmart.approval */
export type Approval_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

export const Approval_Rule_Type_Enum = {
  /** All approve */
  AllApprove: 'all_approve',
  /** Any one approval */
  AnyOneApprove: 'any_one_approve',
  /** Majority approves */
  MajorityApprove: 'majority_approve'
} as const;

export type Approval_Rule_Type_Enum = typeof Approval_Rule_Type_Enum[keyof typeof Approval_Rule_Type_Enum];
/** Boolean expression to compare columns of type "approval_rule_type_enum". All fields are combined with logical 'AND'. */
export type Approval_Rule_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Approval_Rule_Type_Enum>;
  _in?: InputMaybe<Array<Approval_Rule_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Approval_Rule_Type_Enum>;
  _nin?: InputMaybe<Array<Approval_Rule_Type_Enum>>;
};

/** select columns of table "risksmart.approval" */
export const Approval_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  InFlightEditRule: 'InFlightEditRule',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Workflow: 'Workflow'
} as const;

export type Approval_Select_Column = typeof Approval_Select_Column[keyof typeof Approval_Select_Column];
/** input type for updating data in table "risksmart.approval" */
export type Approval_Set_Input = {
  InFlightEditRule?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Workflow?: InputMaybe<Scalars['String']['input']>;
};

export const Approval_Status_Enum = {
  /** Approved */
  Approved: 'approved',
  /** The parent node has been deleted */
  Deleted: 'deleted',
  /** failed */
  Failed: 'failed',
  /** Pending */
  Pending: 'pending',
  /** Rejected */
  Rejected: 'rejected'
} as const;

export type Approval_Status_Enum = typeof Approval_Status_Enum[keyof typeof Approval_Status_Enum];
/** Boolean expression to compare columns of type "approval_status_enum". All fields are combined with logical 'AND'. */
export type Approval_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Approval_Status_Enum>;
  _in?: InputMaybe<Array<Approval_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Approval_Status_Enum>;
  _nin?: InputMaybe<Array<Approval_Status_Enum>>;
};

/** Streaming cursor of the table "approval" */
export type Approval_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approval_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approval_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  InFlightEditRule?: InputMaybe<Approval_In_Flight_Edit_Rule_Enum>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Workflow?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.approval" */
export const Approval_Update_Column = {
  /** column name */
  InFlightEditRule: 'InFlightEditRule',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Workflow: 'Workflow'
} as const;

export type Approval_Update_Column = typeof Approval_Update_Column[keyof typeof Approval_Update_Column];
export type Approval_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Approval_Set_Input>;
  /** filter the rows which have to be updated */
  where: Approval_Bool_Exp;
};

/** columns and relationships of "risksmart.approver" */
export type Approver = {
  __typename?: 'approver';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  LevelId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OwnerApprover?: Maybe<Scalars['Boolean']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  group?: Maybe<User_Group>;
  /** An object relationship */
  level?: Maybe<Approval_Level>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
  /** An array relationship */
  responses: Array<Approver_Response>;
  /** An object relationship */
  user?: Maybe<User>;
};


/** columns and relationships of "risksmart.approver" */
export type ApproverResponsesArgs = {
  distinct_on?: InputMaybe<Array<Approver_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Response_Order_By>>;
  where?: InputMaybe<Approver_Response_Bool_Exp>;
};

/** aggregated selection of "risksmart.approver" */
export type Approver_Aggregate = {
  __typename?: 'approver_aggregate';
  aggregate?: Maybe<Approver_Aggregate_Fields>;
  nodes: Array<Approver>;
};

export type Approver_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Approver_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Approver_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Approver_Aggregate_Bool_Exp_Count>;
};

export type Approver_Aggregate_Bool_Exp_Bool_And = {
  arguments: Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Approver_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Approver_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Approver_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Approver_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Approver_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Approver_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.approver" */
export type Approver_Aggregate_Fields = {
  __typename?: 'approver_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Approver_Max_Fields>;
  min?: Maybe<Approver_Min_Fields>;
};


/** aggregate fields of "risksmart.approver" */
export type Approver_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Approver_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.approver" */
export type Approver_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approver_Max_Order_By>;
  min?: InputMaybe<Approver_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.approver" */
export type Approver_Arr_Rel_Insert_Input = {
  data: Array<Approver_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approver_On_Conflict>;
};

/** columns and relationships of "risksmart.approver_audit" */
export type Approver_Audit = {
  __typename?: 'approver_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  LevelId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OwnerApprover?: Maybe<Scalars['Boolean']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.approver_audit". All fields are combined with a logical 'AND'. */
export type Approver_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LevelId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OwnerApprover?: InputMaybe<Boolean_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Approver_Audit_Bool_Exp>>;
  _not?: InputMaybe<Approver_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Approver_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.approver_audit". */
export type Approver_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LevelId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OwnerApprover?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.approver_audit" */
export const Approver_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  LevelId: 'LevelId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OwnerApprover: 'OwnerApprover',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Approver_Audit_Select_Column = typeof Approver_Audit_Select_Column[keyof typeof Approver_Audit_Select_Column];
/** Streaming cursor of the table "approver_audit" */
export type Approver_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approver_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approver_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LevelId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OwnerApprover?: InputMaybe<Scalars['Boolean']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.approver". All fields are combined with a logical 'AND'. */
export type Approver_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LevelId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OwnerApprover?: InputMaybe<Boolean_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Approver_Bool_Exp>>;
  _not?: InputMaybe<Approver_Bool_Exp>;
  _or?: InputMaybe<Array<Approver_Bool_Exp>>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  group?: InputMaybe<User_Group_Bool_Exp>;
  level?: InputMaybe<Approval_Level_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
  responses?: InputMaybe<Approver_Response_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.approver" */
export const Approver_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ApproverPkey: 'approver_pkey',
  /** unique or primary key constraint on columns "LevelId", "UserId" */
  IdxApproverUserLevel: 'idx_approver_user_level'
} as const;

export type Approver_Constraint = typeof Approver_Constraint[keyof typeof Approver_Constraint];
/** input type for inserting data into table "risksmart.approver" */
export type Approver_Insert_Input = {
  LevelId?: InputMaybe<Scalars['uuid']['input']>;
  OwnerApprover?: InputMaybe<Scalars['Boolean']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
  level?: InputMaybe<Approval_Level_Obj_Rel_Insert_Input>;
  responses?: InputMaybe<Approver_Response_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Approver_Max_Fields = {
  __typename?: 'approver_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  LevelId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.approver" */
export type Approver_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LevelId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Approver_Min_Fields = {
  __typename?: 'approver_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  LevelId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.approver" */
export type Approver_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LevelId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.approver" */
export type Approver_Mutation_Response = {
  __typename?: 'approver_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Approver>;
};

/** input type for inserting object relation for remote table "risksmart.approver" */
export type Approver_Obj_Rel_Insert_Input = {
  data: Approver_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Approver_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.approver" */
export type Approver_On_Conflict = {
  constraint: Approver_Constraint;
  update_columns?: Array<Approver_Update_Column>;
  where?: InputMaybe<Approver_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.approver". */
export type Approver_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LevelId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OwnerApprover?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  group?: InputMaybe<User_Group_Order_By>;
  level?: InputMaybe<Approval_Level_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
  responses_aggregate?: InputMaybe<Approver_Response_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: risksmart.approver */
export type Approver_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** columns and relationships of "risksmart.approver_response" */
export type Approver_Response = {
  __typename?: 'approver_response';
  Approved?: Maybe<Scalars['Boolean']['output']>;
  ApprovedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ApprovedByUser?: Maybe<Scalars['String']['output']>;
  Comment?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  /** An object relationship */
  approvedBy?: Maybe<User>;
  /** An object relationship */
  approver: Approver;
  /** An object relationship */
  changeRequest?: Maybe<Change_Request>;
};

/** order by aggregate values of table "risksmart.approver_response" */
export type Approver_Response_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approver_Response_Max_Order_By>;
  min?: InputMaybe<Approver_Response_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.approver_response" */
export type Approver_Response_Arr_Rel_Insert_Input = {
  data: Array<Approver_Response_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approver_Response_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.approver_response". All fields are combined with a logical 'AND'. */
export type Approver_Response_Bool_Exp = {
  Approved?: InputMaybe<Boolean_Comparison_Exp>;
  ApprovedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ApprovedByUser?: InputMaybe<String_Comparison_Exp>;
  Comment?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Approver_Response_Bool_Exp>>;
  _not?: InputMaybe<Approver_Response_Bool_Exp>;
  _or?: InputMaybe<Array<Approver_Response_Bool_Exp>>;
  approvedBy?: InputMaybe<User_Bool_Exp>;
  approver?: InputMaybe<Approver_Bool_Exp>;
  changeRequest?: InputMaybe<Change_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.approver_response" */
export const Approver_Response_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ApproverResponsePkey: 'approver_response_pkey'
} as const;

export type Approver_Response_Constraint = typeof Approver_Response_Constraint[keyof typeof Approver_Response_Constraint];
/** input type for inserting data into table "risksmart.approver_response" */
export type Approver_Response_Insert_Input = {
  Approved?: InputMaybe<Scalars['Boolean']['input']>;
  ApproverId?: InputMaybe<Scalars['uuid']['input']>;
  ChangeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  Comment?: InputMaybe<Scalars['String']['input']>;
  approver?: InputMaybe<Approver_Obj_Rel_Insert_Input>;
  changeRequest?: InputMaybe<Change_Request_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.approver_response" */
export type Approver_Response_Max_Order_By = {
  ApprovedAtTimestamp?: InputMaybe<Order_By>;
  ApprovedByUser?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.approver_response" */
export type Approver_Response_Min_Order_By = {
  ApprovedAtTimestamp?: InputMaybe<Order_By>;
  ApprovedByUser?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.approver_response" */
export type Approver_Response_On_Conflict = {
  constraint: Approver_Response_Constraint;
  update_columns?: Array<Approver_Response_Update_Column>;
  where?: InputMaybe<Approver_Response_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.approver_response". */
export type Approver_Response_Order_By = {
  Approved?: InputMaybe<Order_By>;
  ApprovedAtTimestamp?: InputMaybe<Order_By>;
  ApprovedByUser?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  approvedBy?: InputMaybe<User_Order_By>;
  approver?: InputMaybe<Approver_Order_By>;
  changeRequest?: InputMaybe<Change_Request_Order_By>;
};

/** select columns of table "risksmart.approver_response" */
export const Approver_Response_Select_Column = {
  /** column name */
  Approved: 'Approved',
  /** column name */
  ApprovedAtTimestamp: 'ApprovedAtTimestamp',
  /** column name */
  ApprovedByUser: 'ApprovedByUser',
  /** column name */
  Comment: 'Comment',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp'
} as const;

export type Approver_Response_Select_Column = typeof Approver_Response_Select_Column[keyof typeof Approver_Response_Select_Column];
/** update columns of table "risksmart.approver_response" */
export const Approver_Response_Update_Column = {
  /** column name */
  Approved: 'Approved',
  /** column name */
  ApprovedAtTimestamp: 'ApprovedAtTimestamp',
  /** column name */
  ApprovedByUser: 'ApprovedByUser',
  /** column name */
  Comment: 'Comment'
} as const;

export type Approver_Response_Update_Column = typeof Approver_Response_Update_Column[keyof typeof Approver_Response_Update_Column];
/** select columns of table "risksmart.approver" */
export const Approver_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  LevelId: 'LevelId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OwnerApprover: 'OwnerApprover',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Approver_Select_Column = typeof Approver_Select_Column[keyof typeof Approver_Select_Column];
/** select "approver_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risksmart.approver" */
export const Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  OwnerApprover: 'OwnerApprover'
} as const;

export type Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "approver_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risksmart.approver" */
export const Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  OwnerApprover: 'OwnerApprover'
} as const;

export type Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Approver_Select_Column_Approver_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "risksmart.approver" */
export type Approver_Set_Input = {
  LevelId?: InputMaybe<Scalars['uuid']['input']>;
  OwnerApprover?: InputMaybe<Scalars['Boolean']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "approver" */
export type Approver_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approver_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approver_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LevelId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OwnerApprover?: InputMaybe<Scalars['Boolean']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.approver" */
export const Approver_Update_Column = {
  /** column name */
  LevelId: 'LevelId',
  /** column name */
  OwnerApprover: 'OwnerApprover',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Approver_Update_Column = typeof Approver_Update_Column[keyof typeof Approver_Update_Column];
export type Approver_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Approver_Set_Input>;
  /** filter the rows which have to be updated */
  where: Approver_Bool_Exp;
};

/** columns and relationships of "risksmart.assessment" */
export type Assessment = {
  __typename?: 'assessment';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status: Assessment_Status_Enum;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  assessmentActions: Array<Action_Parent>;
  /** An aggregate relationship */
  assessmentActions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  assessmentActivities: Array<Assessment_Activity>;
  /** An aggregate relationship */
  assessmentActivities_aggregate: Assessment_Activity_Aggregate;
  /** An array relationship */
  assessmentIssues: Array<Issue_Parent>;
  /** An aggregate relationship */
  assessmentIssues_aggregate: Issue_Parent_Aggregate;
  /** An array relationship */
  assessmentResults: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Assessment_Result_Parent_Aggregate;
  /** An object relationship */
  completedByUser?: Maybe<User>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  originatingItem?: Maybe<Node>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment" */
export type AssessmentTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_Activity = {
  __typename?: 'assessment_activity';
  ActivityType: Assessment_Activity_Type_Enum;
  AssignedUser?: Maybe<Scalars['String']['output']>;
  CompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  IsRCSA: Scalars['Boolean']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  RiskId?: Maybe<Scalars['uuid']['output']>;
  Status?: Maybe<Assessment_Activity_Status_Enum>;
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  assignedUser?: Maybe<User>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  parentAssessment?: Maybe<Assessment>;
  /** An object relationship */
  parentComplianceMonitoringAssessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  parentInternalAuditReport?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  parentRisk?: Maybe<Risk>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.assessment_activity" */
export type Assessment_ActivityOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** aggregated selection of "risksmart.assessment_activity" */
export type Assessment_Activity_Aggregate = {
  __typename?: 'assessment_activity_aggregate';
  aggregate?: Maybe<Assessment_Activity_Aggregate_Fields>;
  nodes: Array<Assessment_Activity>;
};

export type Assessment_Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assessment_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assessment_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.assessment_activity" */
export type Assessment_Activity_Aggregate_Fields = {
  __typename?: 'assessment_activity_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Activity_Max_Fields>;
  min?: Maybe<Assessment_Activity_Min_Fields>;
};


/** aggregate fields of "risksmart.assessment_activity" */
export type Assessment_Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.assessment_activity" */
export type Assessment_Activity_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Activity_Max_Order_By>;
  min?: InputMaybe<Assessment_Activity_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Assessment_Activity_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.assessment_activity" */
export type Assessment_Activity_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Activity_On_Conflict>;
};

/** columns and relationships of "risksmart.assessment_activity_audit" */
export type Assessment_Activity_Audit = {
  __typename?: 'assessment_activity_audit';
  ActivityType: Scalars['String']['output'];
  AssignedUser?: Maybe<Scalars['String']['output']>;
  CompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  Status?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.assessment_activity_audit" */
export type Assessment_Activity_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment_activity_audit". All fields are combined with a logical 'AND'. */
export type Assessment_Activity_Audit_Bool_Exp = {
  ActivityType?: InputMaybe<String_Comparison_Exp>;
  AssignedUser?: InputMaybe<String_Comparison_Exp>;
  CompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Activity_Audit_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Activity_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Activity_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.assessment_activity_audit". */
export type Assessment_Activity_Audit_Order_By = {
  ActivityType?: InputMaybe<Order_By>;
  AssignedUser?: InputMaybe<Order_By>;
  CompletionDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.assessment_activity_audit" */
export const Assessment_Activity_Audit_Select_Column = {
  /** column name */
  ActivityType: 'ActivityType',
  /** column name */
  AssignedUser: 'AssignedUser',
  /** column name */
  CompletionDate: 'CompletionDate',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Activity_Audit_Select_Column = typeof Assessment_Activity_Audit_Select_Column[keyof typeof Assessment_Activity_Audit_Select_Column];
/** Streaming cursor of the table "assessment_activity_audit" */
export type Assessment_Activity_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Activity_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Activity_Audit_Stream_Cursor_Value_Input = {
  ActivityType?: InputMaybe<Scalars['String']['input']>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment_activity". All fields are combined with a logical 'AND'. */
export type Assessment_Activity_Bool_Exp = {
  ActivityType?: InputMaybe<Assessment_Activity_Type_Enum_Comparison_Exp>;
  AssignedUser?: InputMaybe<String_Comparison_Exp>;
  CompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsRCSA?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  RiskId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<Assessment_Activity_Status_Enum_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Activity_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Activity_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assignedUser?: InputMaybe<User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parentAssessment?: InputMaybe<Assessment_Bool_Exp>;
  parentComplianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  parentInternalAuditReport?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  parentRisk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.assessment_activity" */
export const Assessment_Activity_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AssessmentActivityPkey: 'assessment_activity_pkey'
} as const;

export type Assessment_Activity_Constraint = typeof Assessment_Activity_Constraint[keyof typeof Assessment_Activity_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Assessment_Activity_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Assessment_Activity_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Assessment_Activity_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.assessment_activity" */
export type Assessment_Activity_Insert_Input = {
  ActivityType?: InputMaybe<Assessment_Activity_Type_Enum>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsRCSA?: InputMaybe<Scalars['Boolean']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Assessment_Activity_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parentAssessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  parentComplianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input>;
  parentInternalAuditReport?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  parentRisk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assessment_Activity_Max_Fields = {
  __typename?: 'assessment_activity_max_fields';
  AssignedUser?: Maybe<Scalars['String']['output']>;
  CompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.assessment_activity" */
export type Assessment_Activity_Max_Order_By = {
  AssignedUser?: InputMaybe<Order_By>;
  CompletionDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Activity_Min_Fields = {
  __typename?: 'assessment_activity_min_fields';
  AssignedUser?: Maybe<Scalars['String']['output']>;
  CompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.assessment_activity" */
export type Assessment_Activity_Min_Order_By = {
  AssignedUser?: InputMaybe<Order_By>;
  CompletionDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.assessment_activity" */
export type Assessment_Activity_Mutation_Response = {
  __typename?: 'assessment_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Activity>;
};

/** input type for inserting object relation for remote table "risksmart.assessment_activity" */
export type Assessment_Activity_Obj_Rel_Insert_Input = {
  data: Assessment_Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Activity_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.assessment_activity" */
export type Assessment_Activity_On_Conflict = {
  constraint: Assessment_Activity_Constraint;
  update_columns?: Array<Assessment_Activity_Update_Column>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.assessment_activity". */
export type Assessment_Activity_Order_By = {
  ActivityType?: InputMaybe<Order_By>;
  AssignedUser?: InputMaybe<Order_By>;
  CompletionDate?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsRCSA?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assignedUser?: InputMaybe<User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parentAssessment?: InputMaybe<Assessment_Order_By>;
  parentComplianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  parentInternalAuditReport?: InputMaybe<Internal_Audit_Report_Order_By>;
  parentRisk?: InputMaybe<Risk_Order_By>;
};

/** primary key columns input for table: risksmart.assessment_activity */
export type Assessment_Activity_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Assessment_Activity_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.assessment_activity" */
export const Assessment_Activity_Select_Column = {
  /** column name */
  ActivityType: 'ActivityType',
  /** column name */
  AssignedUser: 'AssignedUser',
  /** column name */
  CompletionDate: 'CompletionDate',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  IsRcsa: 'IsRCSA',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  RiskId: 'RiskId',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Activity_Select_Column = typeof Assessment_Activity_Select_Column[keyof typeof Assessment_Activity_Select_Column];
/** select "assessment_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risksmart.assessment_activity" */
export const Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsRcsa: 'IsRCSA'
} as const;

export type Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "assessment_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risksmart.assessment_activity" */
export const Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsRcsa: 'IsRCSA'
} as const;

export type Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Assessment_Activity_Select_Column_Assessment_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "risksmart.assessment_activity" */
export type Assessment_Activity_Set_Input = {
  ActivityType?: InputMaybe<Assessment_Activity_Type_Enum>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Assessment_Activity_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export const Assessment_Activity_Status_Enum = {
  /** Complete */
  Complete: 'complete',
  /** In Progress */
  Inprogress: 'inprogress',
  /** Not Started */
  Notstarted: 'notstarted'
} as const;

export type Assessment_Activity_Status_Enum = typeof Assessment_Activity_Status_Enum[keyof typeof Assessment_Activity_Status_Enum];
/** Boolean expression to compare columns of type "assessment_activity_status_enum". All fields are combined with logical 'AND'. */
export type Assessment_Activity_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Assessment_Activity_Status_Enum>;
  _in?: InputMaybe<Array<Assessment_Activity_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Assessment_Activity_Status_Enum>;
  _nin?: InputMaybe<Array<Assessment_Activity_Status_Enum>>;
};

/** Streaming cursor of the table "assessment_activity" */
export type Assessment_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Activity_Stream_Cursor_Value_Input = {
  ActivityType?: InputMaybe<Assessment_Activity_Type_Enum>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsRCSA?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Assessment_Activity_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export const Assessment_Activity_Type_Enum = {
  /** Interview */
  Interview: 'interview',
  /** Meeting */
  Meeting: 'meeting',
  /** Reminder */
  Reminder: 'reminder',
  /** Review */
  Review: 'review',
  /** Task */
  Task: 'task'
} as const;

export type Assessment_Activity_Type_Enum = typeof Assessment_Activity_Type_Enum[keyof typeof Assessment_Activity_Type_Enum];
/** Boolean expression to compare columns of type "assessment_activity_type_enum". All fields are combined with logical 'AND'. */
export type Assessment_Activity_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Assessment_Activity_Type_Enum>;
  _in?: InputMaybe<Array<Assessment_Activity_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Assessment_Activity_Type_Enum>;
  _nin?: InputMaybe<Array<Assessment_Activity_Type_Enum>>;
};

/** update columns of table "risksmart.assessment_activity" */
export const Assessment_Activity_Update_Column = {
  /** column name */
  ActivityType: 'ActivityType',
  /** column name */
  AssignedUser: 'AssignedUser',
  /** column name */
  CompletionDate: 'CompletionDate',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Activity_Update_Column = typeof Assessment_Activity_Update_Column[keyof typeof Assessment_Activity_Update_Column];
export type Assessment_Activity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Assessment_Activity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Assessment_Activity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Assessment_Activity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Assessment_Activity_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Assessment_Activity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Activity_Bool_Exp;
};

/** aggregated selection of "risksmart.assessment" */
export type Assessment_Aggregate = {
  __typename?: 'assessment_aggregate';
  aggregate?: Maybe<Assessment_Aggregate_Fields>;
  nodes: Array<Assessment>;
};

/** aggregate fields of "risksmart.assessment" */
export type Assessment_Aggregate_Fields = {
  __typename?: 'assessment_aggregate_fields';
  avg?: Maybe<Assessment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Max_Fields>;
  min?: Maybe<Assessment_Min_Fields>;
  stddev?: Maybe<Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Sum_Fields>;
  var_pop?: Maybe<Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Variance_Fields>;
};


/** aggregate fields of "risksmart.assessment" */
export type Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.assessment_audit" */
export type Assessment_Audit = {
  __typename?: 'assessment_audit';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.assessment_audit" */
export type Assessment_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.assessment_audit" */
export type Assessment_Audit_Aggregate = {
  __typename?: 'assessment_audit_aggregate';
  aggregate?: Maybe<Assessment_Audit_Aggregate_Fields>;
  nodes: Array<Assessment_Audit>;
};

/** aggregate fields of "risksmart.assessment_audit" */
export type Assessment_Audit_Aggregate_Fields = {
  __typename?: 'assessment_audit_aggregate_fields';
  avg?: Maybe<Assessment_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Audit_Max_Fields>;
  min?: Maybe<Assessment_Audit_Min_Fields>;
  stddev?: Maybe<Assessment_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Audit_Sum_Fields>;
  var_pop?: Maybe<Assessment_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Audit_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.assessment_audit" */
export type Assessment_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Assessment_Audit_Avg_Fields = {
  __typename?: 'assessment_audit_avg_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment_audit". All fields are combined with a logical 'AND'. */
export type Assessment_Audit_Bool_Exp = {
  ActualCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CompletedByUser?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextTestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  OriginatingItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Outcome?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  TargetCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Audit_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Assessment_Audit_Max_Fields = {
  __typename?: 'assessment_audit_max_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Assessment_Audit_Min_Fields = {
  __typename?: 'assessment_audit_min_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.assessment_audit". */
export type Assessment_Audit_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.assessment_audit" */
export const Assessment_Audit_Select_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Audit_Select_Column = typeof Assessment_Audit_Select_Column[keyof typeof Assessment_Audit_Select_Column];
/** aggregate stddev on columns */
export type Assessment_Audit_Stddev_Fields = {
  __typename?: 'assessment_audit_stddev_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Audit_Stddev_Pop_Fields = {
  __typename?: 'assessment_audit_stddev_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Audit_Stddev_Samp_Fields = {
  __typename?: 'assessment_audit_stddev_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "assessment_audit" */
export type Assessment_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Audit_Stream_Cursor_Value_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Assessment_Audit_Sum_Fields = {
  __typename?: 'assessment_audit_sum_fields';
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Assessment_Audit_Var_Pop_Fields = {
  __typename?: 'assessment_audit_var_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Assessment_Audit_Var_Samp_Fields = {
  __typename?: 'assessment_audit_var_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Assessment_Audit_Variance_Fields = {
  __typename?: 'assessment_audit_variance_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Assessment_Avg_Fields = {
  __typename?: 'assessment_avg_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment". All fields are combined with a logical 'AND'. */
export type Assessment_Bool_Exp = {
  ActualCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CompletedByUser?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextTestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  OriginatingItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Outcome?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<Assessment_Status_Enum_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  TargetCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assessmentActions?: InputMaybe<Action_Parent_Bool_Exp>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Bool_Exp>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp>;
  assessmentIssues?: InputMaybe<Issue_Parent_Bool_Exp>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  completedByUser?: InputMaybe<User_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  originatingItem?: InputMaybe<Node_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.assessment" */
export const Assessment_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AssessmentPkey: 'assessment_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxAssessmentOrgkeySequentialid: 'idx_assessment_orgkey_sequentialid'
} as const;

export type Assessment_Constraint = typeof Assessment_Constraint[keyof typeof Assessment_Constraint];
/** input type for inserting data into table "risksmart.assessment" */
export type Assessment_Insert_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  assessmentActions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Arr_Rel_Insert_Input>;
  assessmentIssues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assessment_Max_Fields = {
  __typename?: 'assessment_max_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Assessment_Min_Fields = {
  __typename?: 'assessment_min_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.assessment" */
export type Assessment_Mutation_Response = {
  __typename?: 'assessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment>;
};

/** input type for inserting object relation for remote table "risksmart.assessment" */
export type Assessment_Obj_Rel_Insert_Input = {
  data: Assessment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.assessment" */
export type Assessment_On_Conflict = {
  constraint: Assessment_Constraint;
  update_columns?: Array<Assessment_Update_Column>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.assessment". */
export type Assessment_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Order_By>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  completedByUser?: InputMaybe<User_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  originatingItem?: InputMaybe<Node_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent = {
  __typename?: 'assessment_result_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  ParentType: Parent_Type_Enum;
  ResultType: Parent_Type_Enum;
  /** An object relationship */
  assessment?: Maybe<Assessment>;
  /** An object relationship */
  assessment_result?: Maybe<Node>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  documentAssessmentResult?: Maybe<Document_Assessment_Result>;
  /** An object relationship */
  impactRating?: Maybe<Impact_Rating>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  node?: Maybe<Node>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  obligationAssessmentResult?: Maybe<Obligation_Assessment_Result>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  riskAssessmentResult?: Maybe<Risk_Assessment_Result>;
  /** An object relationship */
  testResult?: Maybe<Test_Result>;
};

/** aggregated selection of "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Aggregate = {
  __typename?: 'assessment_result_parent_aggregate';
  aggregate?: Maybe<Assessment_Result_Parent_Aggregate_Fields>;
  nodes: Array<Assessment_Result_Parent>;
};

export type Assessment_Result_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Result_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Aggregate_Fields = {
  __typename?: 'assessment_result_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Result_Parent_Max_Fields>;
  min?: Maybe<Assessment_Result_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Result_Parent_Max_Order_By>;
  min?: InputMaybe<Assessment_Result_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Result_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Result_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.assessment_result_parent_audit" */
export type Assessment_Result_Parent_Audit = {
  __typename?: 'assessment_result_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  ParentType: Scalars['String']['output'];
  ResultType: Scalars['String']['output'];
};

/** order by aggregate values of table "risksmart.assessment_result_parent_audit" */
export type Assessment_Result_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Result_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Assessment_Result_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment_result_parent_audit". All fields are combined with a logical 'AND'. */
export type Assessment_Result_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<String_Comparison_Exp>;
  ResultType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Result_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Result_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.assessment_result_parent_audit" */
export type Assessment_Result_Parent_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.assessment_result_parent_audit" */
export type Assessment_Result_Parent_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.assessment_result_parent_audit". */
export type Assessment_Result_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.assessment_result_parent_audit" */
export const Assessment_Result_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType',
  /** column name */
  ResultType: 'ResultType'
} as const;

export type Assessment_Result_Parent_Audit_Select_Column = typeof Assessment_Result_Parent_Audit_Select_Column[keyof typeof Assessment_Result_Parent_Audit_Select_Column];
/** Streaming cursor of the table "assessment_result_parent_audit" */
export type Assessment_Result_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Result_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Result_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Scalars['String']['input']>;
  ResultType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.assessment_result_parent". All fields are combined with a logical 'AND'. */
export type Assessment_Result_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  ResultType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Assessment_Result_Parent_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Result_Parent_Bool_Exp>>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  assessment_result?: InputMaybe<Node_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  documentAssessmentResult?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
  impactRating?: InputMaybe<Impact_Rating_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  node?: InputMaybe<Node_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  obligationAssessmentResult?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
  testResult?: InputMaybe<Test_Result_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.assessment_result_parent" */
export const Assessment_Result_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "Id" */
  AssessmentResultParentPkey: 'assessment_result_parent_pkey'
} as const;

export type Assessment_Result_Parent_Constraint = typeof Assessment_Result_Parent_Constraint[keyof typeof Assessment_Result_Parent_Constraint];
/** input type for inserting data into table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  ResultType?: InputMaybe<Parent_Type_Enum>;
  assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  documentAssessmentResult?: InputMaybe<Document_Assessment_Result_Obj_Rel_Insert_Input>;
  impactRating?: InputMaybe<Impact_Rating_Obj_Rel_Insert_Input>;
  obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  obligationAssessmentResult?: InputMaybe<Obligation_Assessment_Result_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Obj_Rel_Insert_Input>;
  testResult?: InputMaybe<Test_Result_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Assessment_Result_Parent_Max_Fields = {
  __typename?: 'assessment_result_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Result_Parent_Min_Fields = {
  __typename?: 'assessment_result_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_Mutation_Response = {
  __typename?: 'assessment_result_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Result_Parent>;
};

/** on_conflict condition type for table "risksmart.assessment_result_parent" */
export type Assessment_Result_Parent_On_Conflict = {
  constraint: Assessment_Result_Parent_Constraint;
  update_columns?: Array<Assessment_Result_Parent_Update_Column>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.assessment_result_parent". */
export type Assessment_Result_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  assessment_result?: InputMaybe<Node_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  documentAssessmentResult?: InputMaybe<Document_Assessment_Result_Order_By>;
  impactRating?: InputMaybe<Impact_Rating_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  node?: InputMaybe<Node_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  obligationAssessmentResult?: InputMaybe<Obligation_Assessment_Result_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Order_By>;
  testResult?: InputMaybe<Test_Result_Order_By>;
};

/** select columns of table "risksmart.assessment_result_parent" */
export const Assessment_Result_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType',
  /** column name */
  ResultType: 'ResultType'
} as const;

export type Assessment_Result_Parent_Select_Column = typeof Assessment_Result_Parent_Select_Column[keyof typeof Assessment_Result_Parent_Select_Column];
/** Streaming cursor of the table "assessment_result_parent" */
export type Assessment_Result_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Result_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Result_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  ResultType?: InputMaybe<Parent_Type_Enum>;
};

/** placeholder for update columns of table "risksmart.assessment_result_parent" (current role has no relevant permissions) */
export const Assessment_Result_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Assessment_Result_Parent_Update_Column = typeof Assessment_Result_Parent_Update_Column[keyof typeof Assessment_Result_Parent_Update_Column];
/** select columns of table "risksmart.assessment" */
export const Assessment_Select_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Select_Column = typeof Assessment_Select_Column[keyof typeof Assessment_Select_Column];
export const Assessment_Status_Enum = {
  /** Complete */
  Complete: 'complete',
  /** In Progress */
  Inprogress: 'inprogress',
  /** Not Started */
  Notstarted: 'notstarted'
} as const;

export type Assessment_Status_Enum = typeof Assessment_Status_Enum[keyof typeof Assessment_Status_Enum];
/** Boolean expression to compare columns of type "assessment_status_enum". All fields are combined with logical 'AND'. */
export type Assessment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Assessment_Status_Enum>;
  _in?: InputMaybe<Array<Assessment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Assessment_Status_Enum>;
  _nin?: InputMaybe<Array<Assessment_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Assessment_Stddev_Fields = {
  __typename?: 'assessment_stddev_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Stddev_Pop_Fields = {
  __typename?: 'assessment_stddev_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Stddev_Samp_Fields = {
  __typename?: 'assessment_stddev_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "assessment" */
export type Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Stream_Cursor_Value_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Assessment_Sum_Fields = {
  __typename?: 'assessment_sum_fields';
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.assessment" */
export const Assessment_Update_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Assessment_Update_Column = typeof Assessment_Update_Column[keyof typeof Assessment_Update_Column];
/** aggregate var_pop on columns */
export type Assessment_Var_Pop_Fields = {
  __typename?: 'assessment_var_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Assessment_Var_Samp_Fields = {
  __typename?: 'assessment_var_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Assessment_Variance_Fields = {
  __typename?: 'assessment_variance_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.attestation_config" */
export type Attestation_Config = {
  __typename?: 'attestation_config';
  AttestationTimeLimit?: Maybe<Scalars['interval']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  PromptText?: Maybe<Scalars['String']['output']>;
  RequireGlobalAttestation: Scalars['Boolean']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  groups: Array<Attestation_Group>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent: Node;
  /** An array relationship */
  records: Array<Attestation_Record>;
  /** An aggregate relationship */
  records_aggregate: Attestation_Record_Aggregate;
  timeLimitMs?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "risksmart.attestation_config" */
export type Attestation_ConfigGroupsArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Group_Order_By>>;
  where?: InputMaybe<Attestation_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.attestation_config" */
export type Attestation_ConfigRecordsArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


/** columns and relationships of "risksmart.attestation_config" */
export type Attestation_ConfigRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.attestation_config". All fields are combined with a logical 'AND'. */
export type Attestation_Config_Bool_Exp = {
  AttestationTimeLimit?: InputMaybe<Interval_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  PromptText?: InputMaybe<String_Comparison_Exp>;
  RequireGlobalAttestation?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<Attestation_Config_Bool_Exp>>;
  _not?: InputMaybe<Attestation_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Attestation_Config_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  groups?: InputMaybe<Attestation_Group_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  records?: InputMaybe<Attestation_Record_Bool_Exp>;
  records_aggregate?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp>;
  timeLimitMs?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "risksmart.attestation_config" */
export const Attestation_Config_Constraint = {
  /** unique or primary key constraint on columns "ParentId" */
  AttestationConfigPkey: 'attestation_config_pkey'
} as const;

export type Attestation_Config_Constraint = typeof Attestation_Config_Constraint[keyof typeof Attestation_Config_Constraint];
/** input type for inserting data into table "risksmart.attestation_config" */
export type Attestation_Config_Insert_Input = {
  AttestationTimeLimit?: InputMaybe<Scalars['interval']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  PromptText?: InputMaybe<Scalars['String']['input']>;
  RequireGlobalAttestation?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Attestation_Group_Arr_Rel_Insert_Input>;
  records?: InputMaybe<Attestation_Record_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.attestation_config" */
export type Attestation_Config_Mutation_Response = {
  __typename?: 'attestation_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Attestation_Config>;
};

/** input type for inserting object relation for remote table "risksmart.attestation_config" */
export type Attestation_Config_Obj_Rel_Insert_Input = {
  data: Attestation_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attestation_Config_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.attestation_config" */
export type Attestation_Config_On_Conflict = {
  constraint: Attestation_Config_Constraint;
  update_columns?: Array<Attestation_Config_Update_Column>;
  where?: InputMaybe<Attestation_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.attestation_config". */
export type Attestation_Config_Order_By = {
  AttestationTimeLimit?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  PromptText?: InputMaybe<Order_By>;
  RequireGlobalAttestation?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  groups_aggregate?: InputMaybe<Attestation_Group_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  records_aggregate?: InputMaybe<Attestation_Record_Aggregate_Order_By>;
  timeLimitMs?: InputMaybe<Order_By>;
};

/** primary key columns input for table: risksmart.attestation_config */
export type Attestation_Config_Pk_Columns_Input = {
  ParentId: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.attestation_config" */
export const Attestation_Config_Select_Column = {
  /** column name */
  AttestationTimeLimit: 'AttestationTimeLimit',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  PromptText: 'PromptText',
  /** column name */
  RequireGlobalAttestation: 'RequireGlobalAttestation'
} as const;

export type Attestation_Config_Select_Column = typeof Attestation_Config_Select_Column[keyof typeof Attestation_Config_Select_Column];
/** input type for updating data in table "risksmart.attestation_config" */
export type Attestation_Config_Set_Input = {
  AttestationTimeLimit?: InputMaybe<Scalars['interval']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  PromptText?: InputMaybe<Scalars['String']['input']>;
  RequireGlobalAttestation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "attestation_config" */
export type Attestation_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attestation_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attestation_Config_Stream_Cursor_Value_Input = {
  AttestationTimeLimit?: InputMaybe<Scalars['interval']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  PromptText?: InputMaybe<Scalars['String']['input']>;
  RequireGlobalAttestation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "risksmart.attestation_config" */
export const Attestation_Config_Update_Column = {
  /** column name */
  AttestationTimeLimit: 'AttestationTimeLimit',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  PromptText: 'PromptText',
  /** column name */
  RequireGlobalAttestation: 'RequireGlobalAttestation'
} as const;

export type Attestation_Config_Update_Column = typeof Attestation_Config_Update_Column[keyof typeof Attestation_Config_Update_Column];
export type Attestation_Config_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attestation_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Attestation_Config_Bool_Exp;
};

/** columns and relationships of "risksmart.attestation_cycle" */
export type Attestation_Cycle = {
  __typename?: 'attestation_cycle';
  AllowCarryForward: Scalars['Boolean']['output'];
  ConcludedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  Status: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent: Document_File;
  /** An array relationship */
  records: Array<Attestation_Record>;
  /** An aggregate relationship */
  records_aggregate: Attestation_Record_Aggregate;
};


/** columns and relationships of "risksmart.attestation_cycle" */
export type Attestation_CycleRecordsArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


/** columns and relationships of "risksmart.attestation_cycle" */
export type Attestation_CycleRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};

/** columns and relationships of "risksmart.attestation_cycle_audit" */
export type Attestation_Cycle_Audit = {
  __typename?: 'attestation_cycle_audit';
  AllowCarryForward: Scalars['Boolean']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Status: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.attestation_cycle_audit". All fields are combined with a logical 'AND'. */
export type Attestation_Cycle_Audit_Bool_Exp = {
  AllowCarryForward?: InputMaybe<Boolean_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Attestation_Cycle_Audit_Bool_Exp>>;
  _not?: InputMaybe<Attestation_Cycle_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Attestation_Cycle_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.attestation_cycle_audit". */
export type Attestation_Cycle_Audit_Order_By = {
  AllowCarryForward?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.attestation_cycle_audit" */
export const Attestation_Cycle_Audit_Select_Column = {
  /** column name */
  AllowCarryForward: 'AllowCarryForward',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Status: 'Status'
} as const;

export type Attestation_Cycle_Audit_Select_Column = typeof Attestation_Cycle_Audit_Select_Column[keyof typeof Attestation_Cycle_Audit_Select_Column];
/** Streaming cursor of the table "attestation_cycle_audit" */
export type Attestation_Cycle_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attestation_Cycle_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attestation_Cycle_Audit_Stream_Cursor_Value_Input = {
  AllowCarryForward?: InputMaybe<Scalars['Boolean']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.attestation_cycle". All fields are combined with a logical 'AND'. */
export type Attestation_Cycle_Bool_Exp = {
  AllowCarryForward?: InputMaybe<Boolean_Comparison_Exp>;
  ConcludedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Attestation_Cycle_Bool_Exp>>;
  _not?: InputMaybe<Attestation_Cycle_Bool_Exp>;
  _or?: InputMaybe<Array<Attestation_Cycle_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Document_File_Bool_Exp>;
  records?: InputMaybe<Attestation_Record_Bool_Exp>;
  records_aggregate?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.attestation_cycle" */
export const Attestation_Cycle_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AttestationCyclePkey: 'attestation_cycle_pkey'
} as const;

export type Attestation_Cycle_Constraint = typeof Attestation_Cycle_Constraint[keyof typeof Attestation_Cycle_Constraint];
/** input type for inserting data into table "risksmart.attestation_cycle" */
export type Attestation_Cycle_Insert_Input = {
  AllowCarryForward?: InputMaybe<Scalars['Boolean']['input']>;
  ConcludedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Document_File_Obj_Rel_Insert_Input>;
  records?: InputMaybe<Attestation_Record_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.attestation_cycle" */
export type Attestation_Cycle_Mutation_Response = {
  __typename?: 'attestation_cycle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Attestation_Cycle>;
};

/** input type for inserting object relation for remote table "risksmart.attestation_cycle" */
export type Attestation_Cycle_Obj_Rel_Insert_Input = {
  data: Attestation_Cycle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attestation_Cycle_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.attestation_cycle" */
export type Attestation_Cycle_On_Conflict = {
  constraint: Attestation_Cycle_Constraint;
  update_columns?: Array<Attestation_Cycle_Update_Column>;
  where?: InputMaybe<Attestation_Cycle_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.attestation_cycle". */
export type Attestation_Cycle_Order_By = {
  AllowCarryForward?: InputMaybe<Order_By>;
  ConcludedAtTimestamp?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Document_File_Order_By>;
  records_aggregate?: InputMaybe<Attestation_Record_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.attestation_cycle */
export type Attestation_Cycle_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.attestation_cycle" */
export const Attestation_Cycle_Select_Column = {
  /** column name */
  AllowCarryForward: 'AllowCarryForward',
  /** column name */
  ConcludedAtTimestamp: 'ConcludedAtTimestamp',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Status: 'Status'
} as const;

export type Attestation_Cycle_Select_Column = typeof Attestation_Cycle_Select_Column[keyof typeof Attestation_Cycle_Select_Column];
/** input type for updating data in table "risksmart.attestation_cycle" */
export type Attestation_Cycle_Set_Input = {
  ConcludedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "attestation_cycle" */
export type Attestation_Cycle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attestation_Cycle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attestation_Cycle_Stream_Cursor_Value_Input = {
  AllowCarryForward?: InputMaybe<Scalars['Boolean']['input']>;
  ConcludedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.attestation_cycle" */
export const Attestation_Cycle_Update_Column = {
  /** column name */
  ConcludedAtTimestamp: 'ConcludedAtTimestamp',
  /** column name */
  Status: 'Status'
} as const;

export type Attestation_Cycle_Update_Column = typeof Attestation_Cycle_Update_Column[keyof typeof Attestation_Cycle_Update_Column];
export type Attestation_Cycle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attestation_Cycle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Attestation_Cycle_Bool_Exp;
};

/** columns and relationships of "risksmart.attestation_group" */
export type Attestation_Group = {
  __typename?: 'attestation_group';
  ConfigId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  GroupId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  /** An object relationship */
  config: Attestation_Config;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  group: User_Group;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** order by aggregate values of table "risksmart.attestation_group" */
export type Attestation_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Attestation_Group_Max_Order_By>;
  min?: InputMaybe<Attestation_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.attestation_group" */
export type Attestation_Group_Arr_Rel_Insert_Input = {
  data: Array<Attestation_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attestation_Group_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.attestation_group". All fields are combined with a logical 'AND'. */
export type Attestation_Group_Bool_Exp = {
  ConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  GroupId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Attestation_Group_Bool_Exp>>;
  _not?: InputMaybe<Attestation_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Attestation_Group_Bool_Exp>>;
  config?: InputMaybe<Attestation_Config_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  group?: InputMaybe<User_Group_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.attestation_group" */
export const Attestation_Group_Constraint = {
  /** unique or primary key constraint on columns "ConfigId", "GroupId" */
  AttestationGroupPkey: 'attestation_group_pkey'
} as const;

export type Attestation_Group_Constraint = typeof Attestation_Group_Constraint[keyof typeof Attestation_Group_Constraint];
/** input type for inserting data into table "risksmart.attestation_group" */
export type Attestation_Group_Insert_Input = {
  ConfigId?: InputMaybe<Scalars['uuid']['input']>;
  GroupId?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Attestation_Config_Obj_Rel_Insert_Input>;
  group?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.attestation_group" */
export type Attestation_Group_Max_Order_By = {
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  GroupId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.attestation_group" */
export type Attestation_Group_Min_Order_By = {
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  GroupId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.attestation_group" */
export type Attestation_Group_Mutation_Response = {
  __typename?: 'attestation_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Attestation_Group>;
};

/** on_conflict condition type for table "risksmart.attestation_group" */
export type Attestation_Group_On_Conflict = {
  constraint: Attestation_Group_Constraint;
  update_columns?: Array<Attestation_Group_Update_Column>;
  where?: InputMaybe<Attestation_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.attestation_group". */
export type Attestation_Group_Order_By = {
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  GroupId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  config?: InputMaybe<Attestation_Config_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  group?: InputMaybe<User_Group_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.attestation_group */
export type Attestation_Group_Pk_Columns_Input = {
  ConfigId: Scalars['uuid']['input'];
  GroupId: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.attestation_group" */
export const Attestation_Group_Select_Column = {
  /** column name */
  ConfigId: 'ConfigId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  GroupId: 'GroupId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type Attestation_Group_Select_Column = typeof Attestation_Group_Select_Column[keyof typeof Attestation_Group_Select_Column];
/** input type for updating data in table "risksmart.attestation_group" */
export type Attestation_Group_Set_Input = {
  ConfigId?: InputMaybe<Scalars['uuid']['input']>;
  GroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "attestation_group" */
export type Attestation_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attestation_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attestation_Group_Stream_Cursor_Value_Input = {
  ConfigId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  GroupId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.attestation_group" */
export const Attestation_Group_Update_Column = {
  /** column name */
  ConfigId: 'ConfigId',
  /** column name */
  GroupId: 'GroupId'
} as const;

export type Attestation_Group_Update_Column = typeof Attestation_Group_Update_Column[keyof typeof Attestation_Group_Update_Column];
export type Attestation_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attestation_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Attestation_Group_Bool_Exp;
};

/** columns and relationships of "risksmart.attestation_record" */
export type Attestation_Record = {
  __typename?: 'attestation_record';
  Active: Scalars['Boolean']['output'];
  AttestationStatus: Attestation_Record_Status_Enum;
  AttestedAt?: Maybe<Scalars['timestamptz']['output']>;
  CarriedForwardFromRecordId?: Maybe<Scalars['uuid']['output']>;
  ConfigId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CycleId?: Maybe<Scalars['uuid']['output']>;
  ExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  NodeId: Scalars['uuid']['output'];
  OrgKey?: Maybe<Scalars['String']['output']>;
  UserId: Scalars['String']['output'];
  /** An object relationship */
  carriedForwardFromRecord?: Maybe<Attestation_Record>;
  /** An object relationship */
  config?: Maybe<Attestation_Config>;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  cycle?: Maybe<Attestation_Cycle>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  node: Node;
  /** An object relationship */
  user: Auth_User;
};

/** aggregated selection of "risksmart.attestation_record" */
export type Attestation_Record_Aggregate = {
  __typename?: 'attestation_record_aggregate';
  aggregate?: Maybe<Attestation_Record_Aggregate_Fields>;
  nodes: Array<Attestation_Record>;
};

export type Attestation_Record_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp_Count>;
};

export type Attestation_Record_Aggregate_Bool_Exp_Bool_And = {
  arguments: Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Attestation_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Attestation_Record_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Attestation_Record_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Attestation_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Attestation_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.attestation_record" */
export type Attestation_Record_Aggregate_Fields = {
  __typename?: 'attestation_record_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Attestation_Record_Max_Fields>;
  min?: Maybe<Attestation_Record_Min_Fields>;
};


/** aggregate fields of "risksmart.attestation_record" */
export type Attestation_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.attestation_record" */
export type Attestation_Record_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Attestation_Record_Max_Order_By>;
  min?: InputMaybe<Attestation_Record_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.attestation_record" */
export type Attestation_Record_Arr_Rel_Insert_Input = {
  data: Array<Attestation_Record_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attestation_Record_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.attestation_record". All fields are combined with a logical 'AND'. */
export type Attestation_Record_Bool_Exp = {
  Active?: InputMaybe<Boolean_Comparison_Exp>;
  AttestationStatus?: InputMaybe<Attestation_Record_Status_Enum_Comparison_Exp>;
  AttestedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  CarriedForwardFromRecordId?: InputMaybe<Uuid_Comparison_Exp>;
  ConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CycleId?: InputMaybe<Uuid_Comparison_Exp>;
  ExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NodeId?: InputMaybe<Uuid_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Attestation_Record_Bool_Exp>>;
  _not?: InputMaybe<Attestation_Record_Bool_Exp>;
  _or?: InputMaybe<Array<Attestation_Record_Bool_Exp>>;
  carriedForwardFromRecord?: InputMaybe<Attestation_Record_Bool_Exp>;
  config?: InputMaybe<Attestation_Config_Bool_Exp>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  cycle?: InputMaybe<Attestation_Cycle_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  node?: InputMaybe<Node_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.attestation_record" */
export const Attestation_Record_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  AttestationRecordPkey: 'attestation_record_pkey',
  /** unique or primary key constraint on columns "CycleId", "Active", "UserId", "NodeId" */
  IdxAttestationRecordNodeidUseridCycleidActive: 'idx_attestation_record_nodeid_userid_cycleid_active'
} as const;

export type Attestation_Record_Constraint = typeof Attestation_Record_Constraint[keyof typeof Attestation_Record_Constraint];
/** input type for inserting data into table "risksmart.attestation_record" */
export type Attestation_Record_Insert_Input = {
  Active?: InputMaybe<Scalars['Boolean']['input']>;
  AttestationStatus?: InputMaybe<Attestation_Record_Status_Enum>;
  AttestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  CarriedForwardFromRecordId?: InputMaybe<Scalars['uuid']['input']>;
  ConfigId?: InputMaybe<Scalars['uuid']['input']>;
  CycleId?: InputMaybe<Scalars['uuid']['input']>;
  ExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  NodeId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  carriedForwardFromRecord?: InputMaybe<Attestation_Record_Obj_Rel_Insert_Input>;
  config?: InputMaybe<Attestation_Config_Obj_Rel_Insert_Input>;
  cycle?: InputMaybe<Attestation_Cycle_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Attestation_Record_Max_Fields = {
  __typename?: 'attestation_record_max_fields';
  AttestedAt?: Maybe<Scalars['timestamptz']['output']>;
  CarriedForwardFromRecordId?: Maybe<Scalars['uuid']['output']>;
  ConfigId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CycleId?: Maybe<Scalars['uuid']['output']>;
  ExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NodeId?: Maybe<Scalars['uuid']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.attestation_record" */
export type Attestation_Record_Max_Order_By = {
  AttestedAt?: InputMaybe<Order_By>;
  CarriedForwardFromRecordId?: InputMaybe<Order_By>;
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CycleId?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NodeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Attestation_Record_Min_Fields = {
  __typename?: 'attestation_record_min_fields';
  AttestedAt?: Maybe<Scalars['timestamptz']['output']>;
  CarriedForwardFromRecordId?: Maybe<Scalars['uuid']['output']>;
  ConfigId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CycleId?: Maybe<Scalars['uuid']['output']>;
  ExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NodeId?: Maybe<Scalars['uuid']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.attestation_record" */
export type Attestation_Record_Min_Order_By = {
  AttestedAt?: InputMaybe<Order_By>;
  CarriedForwardFromRecordId?: InputMaybe<Order_By>;
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CycleId?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NodeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.attestation_record" */
export type Attestation_Record_Obj_Rel_Insert_Input = {
  data: Attestation_Record_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attestation_Record_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.attestation_record" */
export type Attestation_Record_On_Conflict = {
  constraint: Attestation_Record_Constraint;
  update_columns?: Array<Attestation_Record_Update_Column>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.attestation_record". */
export type Attestation_Record_Order_By = {
  Active?: InputMaybe<Order_By>;
  AttestationStatus?: InputMaybe<Order_By>;
  AttestedAt?: InputMaybe<Order_By>;
  CarriedForwardFromRecordId?: InputMaybe<Order_By>;
  ConfigId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CycleId?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NodeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  carriedForwardFromRecord?: InputMaybe<Attestation_Record_Order_By>;
  config?: InputMaybe<Attestation_Config_Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  cycle?: InputMaybe<Attestation_Cycle_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  node?: InputMaybe<Node_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
};

/** select columns of table "risksmart.attestation_record" */
export const Attestation_Record_Select_Column = {
  /** column name */
  Active: 'Active',
  /** column name */
  AttestationStatus: 'AttestationStatus',
  /** column name */
  AttestedAt: 'AttestedAt',
  /** column name */
  CarriedForwardFromRecordId: 'CarriedForwardFromRecordId',
  /** column name */
  ConfigId: 'ConfigId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CycleId: 'CycleId',
  /** column name */
  ExpiresAt: 'ExpiresAt',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NodeId: 'NodeId',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  UserId: 'UserId'
} as const;

export type Attestation_Record_Select_Column = typeof Attestation_Record_Select_Column[keyof typeof Attestation_Record_Select_Column];
/** select "attestation_record_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risksmart.attestation_record" */
export const Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  Active: 'Active'
} as const;

export type Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "attestation_record_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risksmart.attestation_record" */
export const Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  Active: 'Active'
} as const;

export type Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Attestation_Record_Select_Column_Attestation_Record_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
export const Attestation_Record_Status_Enum = {
  /** User has attested */
  Attested: 'attested',
  /** The due date has expired */
  Expired: 'expired',
  /** Attestation was not provided */
  NotAttested: 'not_attested',
  /** Attestation is cancelled */
  NotRequired: 'not_required',
  /** Waiting for attestation */
  Pending: 'pending'
} as const;

export type Attestation_Record_Status_Enum = typeof Attestation_Record_Status_Enum[keyof typeof Attestation_Record_Status_Enum];
/** Boolean expression to compare columns of type "attestation_record_status_enum". All fields are combined with logical 'AND'. */
export type Attestation_Record_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Attestation_Record_Status_Enum>;
  _in?: InputMaybe<Array<Attestation_Record_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Attestation_Record_Status_Enum>;
  _nin?: InputMaybe<Array<Attestation_Record_Status_Enum>>;
};

/** Streaming cursor of the table "attestation_record" */
export type Attestation_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attestation_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attestation_Record_Stream_Cursor_Value_Input = {
  Active?: InputMaybe<Scalars['Boolean']['input']>;
  AttestationStatus?: InputMaybe<Attestation_Record_Status_Enum>;
  AttestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  CarriedForwardFromRecordId?: InputMaybe<Scalars['uuid']['input']>;
  ConfigId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CycleId?: InputMaybe<Scalars['uuid']['input']>;
  ExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NodeId?: InputMaybe<Scalars['uuid']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.attestation_record" */
export const Attestation_Record_Update_Column = {
  /** column name */
  Active: 'Active',
  /** column name */
  AttestationStatus: 'AttestationStatus',
  /** column name */
  AttestedAt: 'AttestedAt',
  /** column name */
  CarriedForwardFromRecordId: 'CarriedForwardFromRecordId',
  /** column name */
  ConfigId: 'ConfigId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CycleId: 'CycleId',
  /** column name */
  ExpiresAt: 'ExpiresAt',
  /** column name */
  Id: 'Id',
  /** column name */
  NodeId: 'NodeId',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  UserId: 'UserId'
} as const;

export type Attestation_Record_Update_Column = typeof Attestation_Record_Update_Column[keyof typeof Attestation_Record_Update_Column];
/** columns and relationships of "risksmart.audit_log_view" */
export type Audit_Log_View = {
  __typename?: 'audit_log_view';
  Action?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Item?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ObjectType?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  PerformedByUser?: Maybe<User>;
};

/** aggregated selection of "risksmart.audit_log_view" */
export type Audit_Log_View_Aggregate = {
  __typename?: 'audit_log_view_aggregate';
  aggregate?: Maybe<Audit_Log_View_Aggregate_Fields>;
  nodes: Array<Audit_Log_View>;
};

/** aggregate fields of "risksmart.audit_log_view" */
export type Audit_Log_View_Aggregate_Fields = {
  __typename?: 'audit_log_view_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Audit_Log_View_Max_Fields>;
  min?: Maybe<Audit_Log_View_Min_Fields>;
};


/** aggregate fields of "risksmart.audit_log_view" */
export type Audit_Log_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Log_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.audit_log_view". All fields are combined with a logical 'AND'. */
export type Audit_Log_View_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<String_Comparison_Exp>;
  Item?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ObjectType?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  PerformedByUser?: InputMaybe<User_Bool_Exp>;
  _and?: InputMaybe<Array<Audit_Log_View_Bool_Exp>>;
  _not?: InputMaybe<Audit_Log_View_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Log_View_Bool_Exp>>;
};

/** aggregate max on columns */
export type Audit_Log_View_Max_Fields = {
  __typename?: 'audit_log_view_max_fields';
  Action?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Item?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ObjectType?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Audit_Log_View_Min_Fields = {
  __typename?: 'audit_log_view_min_fields';
  Action?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Item?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ObjectType?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.audit_log_view". */
export type Audit_Log_View_Order_By = {
  Action?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Item?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  PerformedByUser?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.audit_log_view" */
export const Audit_Log_View_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  Id: 'Id',
  /** column name */
  Item: 'Item',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ObjectType: 'ObjectType',
  /** column name */
  OrgKey: 'OrgKey'
} as const;

export type Audit_Log_View_Select_Column = typeof Audit_Log_View_Select_Column[keyof typeof Audit_Log_View_Select_Column];
/** Streaming cursor of the table "audit_log_view" */
export type Audit_Log_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Log_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Log_View_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  Item?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ObjectType?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "auth.organisation" */
export type Auth_Organisation = {
  __typename?: 'auth_organisation';
  Meta?: Maybe<Scalars['json']['output']>;
  Name: Scalars['String']['output'];
  OrgKey: Scalars['String']['output'];
  ScimEnabled: Scalars['Boolean']['output'];
  /** An array relationship */
  organisationusers: Array<Auth_Organisationuser>;
};


/** columns and relationships of "auth.organisation" */
export type Auth_OrganisationMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "auth.organisation" */
export type Auth_OrganisationOrganisationusersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisationuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisationuser_Order_By>>;
  where?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "auth.organisation". All fields are combined with a logical 'AND'. */
export type Auth_Organisation_Bool_Exp = {
  Meta?: InputMaybe<Json_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ScimEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_Organisation_Bool_Exp>>;
  _not?: InputMaybe<Auth_Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Organisation_Bool_Exp>>;
  organisationusers?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};

/** response of any mutation on the table "auth.organisation" */
export type Auth_Organisation_Mutation_Response = {
  __typename?: 'auth_organisation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Organisation>;
};

/** Ordering options when selecting data from "auth.organisation". */
export type Auth_Organisation_Order_By = {
  Meta?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ScimEnabled?: InputMaybe<Order_By>;
  organisationusers_aggregate?: InputMaybe<Auth_Organisationuser_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.organisation */
export type Auth_Organisation_Pk_Columns_Input = {
  OrgKey: Scalars['String']['input'];
};

/** select columns of table "auth.organisation" */
export const Auth_Organisation_Select_Column = {
  /** column name */
  Meta: 'Meta',
  /** column name */
  Name: 'Name',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ScimEnabled: 'ScimEnabled'
} as const;

export type Auth_Organisation_Select_Column = typeof Auth_Organisation_Select_Column[keyof typeof Auth_Organisation_Select_Column];
/** input type for updating data in table "auth.organisation" */
export type Auth_Organisation_Set_Input = {
  ScimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "auth_organisation" */
export type Auth_Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Organisation_Stream_Cursor_Value_Input = {
  Meta?: InputMaybe<Scalars['json']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ScimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Auth_Organisation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Organisation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Organisation_Bool_Exp;
};

/** columns and relationships of "auth.organisationuser" */
export type Auth_Organisationuser = {
  __typename?: 'auth_organisationuser';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  External_Id?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  OrgKey: Scalars['String']['output'];
  RoleKey?: Maybe<Scalars['String']['output']>;
  User_Id: Scalars['String']['output'];
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  user: Auth_User;
};

/** order by aggregate values of table "auth.organisationuser" */
export type Auth_Organisationuser_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Organisationuser_Max_Order_By>;
  min?: InputMaybe<Auth_Organisationuser_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "auth.organisationuser". All fields are combined with a logical 'AND'. */
export type Auth_Organisationuser_Bool_Exp = {
  AuthConnection?: InputMaybe<String_Comparison_Exp>;
  External_Id?: InputMaybe<String_Comparison_Exp>;
  LastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  User_Id?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_Organisationuser_Bool_Exp>>;
  _not?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Organisationuser_Bool_Exp>>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
};

/** order by max() on columns of table "auth.organisationuser" */
export type Auth_Organisationuser_Max_Order_By = {
  AuthConnection?: InputMaybe<Order_By>;
  External_Id?: InputMaybe<Order_By>;
  LastSeen?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  User_Id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "auth.organisationuser" */
export type Auth_Organisationuser_Min_Order_By = {
  AuthConnection?: InputMaybe<Order_By>;
  External_Id?: InputMaybe<Order_By>;
  LastSeen?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  User_Id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.organisationuser" */
export type Auth_Organisationuser_Mutation_Response = {
  __typename?: 'auth_organisationuser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Organisationuser>;
};

/** Ordering options when selecting data from "auth.organisationuser". */
export type Auth_Organisationuser_Order_By = {
  AuthConnection?: InputMaybe<Order_By>;
  External_Id?: InputMaybe<Order_By>;
  LastSeen?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  User_Id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
};

/** primary key columns input for table: auth.organisationuser */
export type Auth_Organisationuser_Pk_Columns_Input = {
  OrgKey: Scalars['String']['input'];
  User_Id: Scalars['String']['input'];
};

/** select columns of table "auth.organisationuser" */
export const Auth_Organisationuser_Select_Column = {
  /** column name */
  AuthConnection: 'AuthConnection',
  /** column name */
  ExternalId: 'External_Id',
  /** column name */
  LastSeen: 'LastSeen',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  UserId: 'User_Id'
} as const;

export type Auth_Organisationuser_Select_Column = typeof Auth_Organisationuser_Select_Column[keyof typeof Auth_Organisationuser_Select_Column];
/** input type for updating data in table "auth.organisationuser" */
export type Auth_Organisationuser_Set_Input = {
  RoleKey?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_organisationuser" */
export type Auth_Organisationuser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Organisationuser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Organisationuser_Stream_Cursor_Value_Input = {
  AuthConnection?: InputMaybe<Scalars['String']['input']>;
  External_Id?: InputMaybe<Scalars['String']['input']>;
  LastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  User_Id?: InputMaybe<Scalars['String']['input']>;
};

export type Auth_Organisationuser_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Organisationuser_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Organisationuser_Bool_Exp;
};

/** columns and relationships of "auth.role_resource_type" */
export type Auth_Role_Resource_Type = {
  __typename?: 'auth_role_resource_type';
  IsTopLevel: Scalars['Boolean']['output'];
  ResourceType: Parent_Type_Enum;
};

/** Boolean expression to filter rows from the table "auth.role_resource_type". All fields are combined with a logical 'AND'. */
export type Auth_Role_Resource_Type_Bool_Exp = {
  IsTopLevel?: InputMaybe<Boolean_Comparison_Exp>;
  ResourceType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_Role_Resource_Type_Bool_Exp>>;
  _not?: InputMaybe<Auth_Role_Resource_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Role_Resource_Type_Bool_Exp>>;
};

/** Ordering options when selecting data from "auth.role_resource_type". */
export type Auth_Role_Resource_Type_Order_By = {
  IsTopLevel?: InputMaybe<Order_By>;
  ResourceType?: InputMaybe<Order_By>;
};

/** select columns of table "auth.role_resource_type" */
export const Auth_Role_Resource_Type_Select_Column = {
  /** column name */
  IsTopLevel: 'IsTopLevel',
  /** column name */
  ResourceType: 'ResourceType'
} as const;

export type Auth_Role_Resource_Type_Select_Column = typeof Auth_Role_Resource_Type_Select_Column[keyof typeof Auth_Role_Resource_Type_Select_Column];
/** Streaming cursor of the table "auth_role_resource_type" */
export type Auth_Role_Resource_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Role_Resource_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Role_Resource_Type_Stream_Cursor_Value_Input = {
  IsTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  ResourceType?: InputMaybe<Parent_Type_Enum>;
};

/** columns and relationships of "auth.role_type" */
export type Auth_Role_Type = {
  __typename?: 'auth_role_type';
  Category: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  InstanceRoleKey?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  RiskSmartInternal?: Maybe<Scalars['Boolean']['output']>;
  RoleKey: Scalars['String']['output'];
  TopLevelRoleKey?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  resourceTypes: Array<Auth_Role_Type_Resource_Type>;
  /** An array relationship */
  userRoles: Array<Auth_User_Role>;
};


/** columns and relationships of "auth.role_type" */
export type Auth_Role_TypeResourceTypesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
};


/** columns and relationships of "auth.role_type" */
export type Auth_Role_TypeUserRolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Role_Order_By>>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "auth.role_type". All fields are combined with a logical 'AND'. */
export type Auth_Role_Type_Bool_Exp = {
  Category?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  InstanceRoleKey?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  RiskSmartInternal?: InputMaybe<Boolean_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  TopLevelRoleKey?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_Role_Type_Bool_Exp>>;
  _not?: InputMaybe<Auth_Role_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Role_Type_Bool_Exp>>;
  resourceTypes?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
  userRoles?: InputMaybe<Auth_User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.role_type". */
export type Auth_Role_Type_Order_By = {
  Category?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  InstanceRoleKey?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  RiskSmartInternal?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  TopLevelRoleKey?: InputMaybe<Order_By>;
  resourceTypes_aggregate?: InputMaybe<Auth_Role_Type_Resource_Type_Aggregate_Order_By>;
  userRoles_aggregate?: InputMaybe<Auth_User_Role_Aggregate_Order_By>;
};

/** columns and relationships of "auth.role_type_resource_type" */
export type Auth_Role_Type_Resource_Type = {
  __typename?: 'auth_role_type_resource_type';
  ResourceType: Scalars['String']['output'];
  RoleKey: Scalars['String']['output'];
  /** An object relationship */
  resourceType: Auth_Role_Resource_Type;
  /** An object relationship */
  roleType: Auth_Role_Type;
};

/** order by aggregate values of table "auth.role_type_resource_type" */
export type Auth_Role_Type_Resource_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Role_Type_Resource_Type_Max_Order_By>;
  min?: InputMaybe<Auth_Role_Type_Resource_Type_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "auth.role_type_resource_type". All fields are combined with a logical 'AND'. */
export type Auth_Role_Type_Resource_Type_Bool_Exp = {
  ResourceType?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Bool_Exp>>;
  _not?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Bool_Exp>>;
  resourceType?: InputMaybe<Auth_Role_Resource_Type_Bool_Exp>;
  roleType?: InputMaybe<Auth_Role_Type_Bool_Exp>;
};

/** order by max() on columns of table "auth.role_type_resource_type" */
export type Auth_Role_Type_Resource_Type_Max_Order_By = {
  ResourceType?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "auth.role_type_resource_type" */
export type Auth_Role_Type_Resource_Type_Min_Order_By = {
  ResourceType?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "auth.role_type_resource_type". */
export type Auth_Role_Type_Resource_Type_Order_By = {
  ResourceType?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  resourceType?: InputMaybe<Auth_Role_Resource_Type_Order_By>;
  roleType?: InputMaybe<Auth_Role_Type_Order_By>;
};

/** select columns of table "auth.role_type_resource_type" */
export const Auth_Role_Type_Resource_Type_Select_Column = {
  /** column name */
  ResourceType: 'ResourceType',
  /** column name */
  RoleKey: 'RoleKey'
} as const;

export type Auth_Role_Type_Resource_Type_Select_Column = typeof Auth_Role_Type_Resource_Type_Select_Column[keyof typeof Auth_Role_Type_Resource_Type_Select_Column];
/** Streaming cursor of the table "auth_role_type_resource_type" */
export type Auth_Role_Type_Resource_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Role_Type_Resource_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Role_Type_Resource_Type_Stream_Cursor_Value_Input = {
  ResourceType?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "auth.role_type" */
export const Auth_Role_Type_Select_Column = {
  /** column name */
  Category: 'Category',
  /** column name */
  Description: 'Description',
  /** column name */
  InstanceRoleKey: 'InstanceRoleKey',
  /** column name */
  Name: 'Name',
  /** column name */
  RiskSmartInternal: 'RiskSmartInternal',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  TopLevelRoleKey: 'TopLevelRoleKey'
} as const;

export type Auth_Role_Type_Select_Column = typeof Auth_Role_Type_Select_Column[keyof typeof Auth_Role_Type_Select_Column];
/** Streaming cursor of the table "auth_role_type" */
export type Auth_Role_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Role_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Role_Type_Stream_Cursor_Value_Input = {
  Category?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  InstanceRoleKey?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  RiskSmartInternal?: InputMaybe<Scalars['Boolean']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  TopLevelRoleKey?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "auth.user" */
export type Auth_User = {
  __typename?: 'auth_user';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  AuthUser_Id?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CreatedOn?: Maybe<Scalars['timestamptz']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  IsCustomerSupport?: Maybe<Scalars['Boolean']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<User_Status_Enum>;
  UserName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  customRoles: Array<Custom_Role_User>;
  /** An aggregate relationship */
  customRoles_aggregate: Custom_Role_User_Aggregate;
  /** An array relationship */
  organisationusers: Array<Auth_Organisationuser>;
  /** An array relationship */
  userGroupUsers: Array<User_Group_User>;
  /** An aggregate relationship */
  userGroupUsers_aggregate: User_Group_User_Aggregate;
  /** An array relationship */
  userRoles: Array<Auth_User_Role>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserCustomRolesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserCustomRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserOrganisationusersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisationuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisationuser_Order_By>>;
  where?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserUserGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserUserGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


/** columns and relationships of "auth.user" */
export type Auth_UserUserRolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Role_Order_By>>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};

/** aggregated selection of "auth.user" */
export type Auth_User_Aggregate = {
  __typename?: 'auth_user_aggregate';
  aggregate?: Maybe<Auth_User_Aggregate_Fields>;
  nodes: Array<Auth_User>;
};

/** aggregate fields of "auth.user" */
export type Auth_User_Aggregate_Fields = {
  __typename?: 'auth_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_User_Max_Fields>;
  min?: Maybe<Auth_User_Min_Fields>;
};


/** aggregate fields of "auth.user" */
export type Auth_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.user". All fields are combined with a logical 'AND'. */
export type Auth_User_Bool_Exp = {
  AuthConnection?: InputMaybe<String_Comparison_Exp>;
  AuthUser_Id?: InputMaybe<String_Comparison_Exp>;
  BusinessUnit_Id?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  Department?: InputMaybe<String_Comparison_Exp>;
  DisplayName?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  FirstName?: InputMaybe<String_Comparison_Exp>;
  FriendlyName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<String_Comparison_Exp>;
  IsCustomerSupport?: InputMaybe<Boolean_Comparison_Exp>;
  JobTitle?: InputMaybe<String_Comparison_Exp>;
  LastName?: InputMaybe<String_Comparison_Exp>;
  LastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OfficeLocation?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<User_Status_Enum_Comparison_Exp>;
  UserName?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  customRoles?: InputMaybe<Custom_Role_User_Bool_Exp>;
  customRoles_aggregate?: InputMaybe<Custom_Role_User_Aggregate_Bool_Exp>;
  organisationusers?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
  userGroupUsers?: InputMaybe<User_Group_User_Bool_Exp>;
  userGroupUsers_aggregate?: InputMaybe<User_Group_User_Aggregate_Bool_Exp>;
  userRoles?: InputMaybe<Auth_User_Role_Bool_Exp>;
};

/** aggregate max on columns */
export type Auth_User_Max_Fields = {
  __typename?: 'auth_user_max_fields';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  AuthUser_Id?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CreatedOn?: Maybe<Scalars['timestamptz']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_User_Min_Fields = {
  __typename?: 'auth_user_min_fields';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  AuthUser_Id?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CreatedOn?: Maybe<Scalars['timestamptz']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.user" */
export type Auth_User_Mutation_Response = {
  __typename?: 'auth_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_User>;
};

/** Ordering options when selecting data from "auth.user". */
export type Auth_User_Order_By = {
  AuthConnection?: InputMaybe<Order_By>;
  AuthUser_Id?: InputMaybe<Order_By>;
  BusinessUnit_Id?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Department?: InputMaybe<Order_By>;
  DisplayName?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FriendlyName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsCustomerSupport?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  LastSeen?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OfficeLocation?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  UserName?: InputMaybe<Order_By>;
  customRoles_aggregate?: InputMaybe<Custom_Role_User_Aggregate_Order_By>;
  organisationusers_aggregate?: InputMaybe<Auth_Organisationuser_Aggregate_Order_By>;
  userGroupUsers_aggregate?: InputMaybe<User_Group_User_Aggregate_Order_By>;
  userRoles_aggregate?: InputMaybe<Auth_User_Role_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.user */
export type Auth_User_Pk_Columns_Input = {
  Id: Scalars['String']['input'];
};

/** columns and relationships of "auth.user_role" */
export type Auth_User_Role = {
  __typename?: 'auth_user_role';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey: Scalars['String']['output'];
  RoleKey: Scalars['String']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  role_type: Auth_Role_Type;
  /** An object relationship */
  user: Auth_User;
};

/** order by aggregate values of table "auth.user_role" */
export type Auth_User_Role_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_User_Role_Max_Order_By>;
  min?: InputMaybe<Auth_User_Role_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_role". All fields are combined with a logical 'AND'. */
export type Auth_User_Role_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Auth_User_Role_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Role_Bool_Exp>>;
  role_type?: InputMaybe<Auth_Role_Type_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.user_role" */
export const Auth_User_Role_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  UserRolePkey: 'user_role_pkey',
  /** unique or primary key constraint on columns "RoleKey", "OrgKey", "UserId" */
  UserRoleUniqueConstraint: 'user_role_unique_constraint'
} as const;

export type Auth_User_Role_Constraint = typeof Auth_User_Role_Constraint[keyof typeof Auth_User_Role_Constraint];
/** input type for inserting data into table "auth.user_role" */
export type Auth_User_Role_Insert_Input = {
  Id?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "auth.user_role" */
export type Auth_User_Role_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "auth.user_role" */
export type Auth_User_Role_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.user_role" */
export type Auth_User_Role_Mutation_Response = {
  __typename?: 'auth_user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_User_Role>;
};

/** on_conflict condition type for table "auth.user_role" */
export type Auth_User_Role_On_Conflict = {
  constraint: Auth_User_Role_Constraint;
  update_columns?: Array<Auth_User_Role_Update_Column>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_role". */
export type Auth_User_Role_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  role_type?: InputMaybe<Auth_Role_Type_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
};

/** primary key columns input for table: auth.user_role */
export type Auth_User_Role_Pk_Columns_Input = {
  Id: Scalars['String']['input'];
};

/** select columns of table "auth.user_role" */
export const Auth_User_Role_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  UserId: 'UserId'
} as const;

export type Auth_User_Role_Select_Column = typeof Auth_User_Role_Select_Column[keyof typeof Auth_User_Role_Select_Column];
/** input type for updating data in table "auth.user_role" */
export type Auth_User_Role_Set_Input = {
  RoleKey?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_user_role" */
export type Auth_User_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Role_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.user_role" */
export const Auth_User_Role_Update_Column = {
  /** column name */
  RoleKey: 'RoleKey'
} as const;

export type Auth_User_Role_Update_Column = typeof Auth_User_Role_Update_Column[keyof typeof Auth_User_Role_Update_Column];
export type Auth_User_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_User_Role_Bool_Exp;
};

/** select columns of table "auth.user" */
export const Auth_User_Select_Column = {
  /** column name */
  AuthConnection: 'AuthConnection',
  /** column name */
  AuthUserId: 'AuthUser_Id',
  /** column name */
  BusinessUnitId: 'BusinessUnit_Id',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CreatedOn: 'CreatedOn',
  /** column name */
  Department: 'Department',
  /** column name */
  DisplayName: 'DisplayName',
  /** column name */
  Email: 'Email',
  /** column name */
  FirstName: 'FirstName',
  /** column name */
  FriendlyName: 'FriendlyName',
  /** column name */
  Id: 'Id',
  /** column name */
  IsCustomerSupport: 'IsCustomerSupport',
  /** column name */
  JobTitle: 'JobTitle',
  /** column name */
  LastName: 'LastName',
  /** column name */
  LastSeen: 'LastSeen',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OfficeLocation: 'OfficeLocation',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  Status: 'Status',
  /** column name */
  UserName: 'UserName'
} as const;

export type Auth_User_Select_Column = typeof Auth_User_Select_Column[keyof typeof Auth_User_Select_Column];
/** input type for updating data in table "auth.user" */
export type Auth_User_Set_Input = {
  RoleKey?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_user" */
export type Auth_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_User_Stream_Cursor_Value_Input = {
  AuthConnection?: InputMaybe<Scalars['String']['input']>;
  AuthUser_Id?: InputMaybe<Scalars['String']['input']>;
  BusinessUnit_Id?: InputMaybe<Scalars['uuid']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CreatedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  Department?: InputMaybe<Scalars['String']['input']>;
  DisplayName?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  FriendlyName?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  IsCustomerSupport?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OfficeLocation?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<User_Status_Enum>;
  UserName?: InputMaybe<Scalars['String']['input']>;
};

export type Auth_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_User_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "risksmart.business_area" */
export type Business_Area = {
  __typename?: 'business_area';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequentialId: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  internalAuditEntities: Array<Internal_Audit_Entity>;
  /** An aggregate relationship */
  internalAuditEntities_aggregate: Internal_Audit_Entity_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.business_area" */
export type Business_AreaInternalAuditEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


/** columns and relationships of "risksmart.business_area" */
export type Business_AreaInternalAuditEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};

/** aggregated selection of "risksmart.business_area" */
export type Business_Area_Aggregate = {
  __typename?: 'business_area_aggregate';
  aggregate?: Maybe<Business_Area_Aggregate_Fields>;
  nodes: Array<Business_Area>;
};

/** aggregate fields of "risksmart.business_area" */
export type Business_Area_Aggregate_Fields = {
  __typename?: 'business_area_aggregate_fields';
  avg?: Maybe<Business_Area_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Business_Area_Max_Fields>;
  min?: Maybe<Business_Area_Min_Fields>;
  stddev?: Maybe<Business_Area_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Area_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Area_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Area_Sum_Fields>;
  var_pop?: Maybe<Business_Area_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Area_Var_Samp_Fields>;
  variance?: Maybe<Business_Area_Variance_Fields>;
};


/** aggregate fields of "risksmart.business_area" */
export type Business_Area_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Area_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Business_Area_Avg_Fields = {
  __typename?: 'business_area_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.business_area". All fields are combined with a logical 'AND'. */
export type Business_Area_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Business_Area_Bool_Exp>>;
  _not?: InputMaybe<Business_Area_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Area_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  internalAuditEntities?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  internalAuditEntities_aggregate?: InputMaybe<Internal_Audit_Entity_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.business_area" */
export const Business_Area_Constraint = {
  /** unique or primary key constraint on columns "OrgKey", "Title" */
  BusinessAreaOrgkeyTitle: 'business_area_orgkey_title',
  /** unique or primary key constraint on columns "Id" */
  BusinessAreaPkey: 'business_area_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxBusinessAreaOrgkeySequentialid: 'idx_business_area_orgkey_sequentialid'
} as const;

export type Business_Area_Constraint = typeof Business_Area_Constraint[keyof typeof Business_Area_Constraint];
/** input type for inserting data into table "risksmart.business_area" */
export type Business_Area_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  internalAuditEntities?: InputMaybe<Internal_Audit_Entity_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Business_Area_Max_Fields = {
  __typename?: 'business_area_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Business_Area_Min_Fields = {
  __typename?: 'business_area_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.business_area" */
export type Business_Area_Mutation_Response = {
  __typename?: 'business_area_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Area>;
};

/** input type for inserting object relation for remote table "risksmart.business_area" */
export type Business_Area_Obj_Rel_Insert_Input = {
  data: Business_Area_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Area_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.business_area" */
export type Business_Area_On_Conflict = {
  constraint: Business_Area_Constraint;
  update_columns?: Array<Business_Area_Update_Column>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.business_area". */
export type Business_Area_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  internalAuditEntities_aggregate?: InputMaybe<Internal_Audit_Entity_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.business_area */
export type Business_Area_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.business_area" */
export const Business_Area_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Business_Area_Select_Column = typeof Business_Area_Select_Column[keyof typeof Business_Area_Select_Column];
/** input type for updating data in table "risksmart.business_area" */
export type Business_Area_Set_Input = {
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Business_Area_Stddev_Fields = {
  __typename?: 'business_area_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Business_Area_Stddev_Pop_Fields = {
  __typename?: 'business_area_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Business_Area_Stddev_Samp_Fields = {
  __typename?: 'business_area_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "business_area" */
export type Business_Area_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Area_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Area_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Business_Area_Sum_Fields = {
  __typename?: 'business_area_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.business_area" */
export const Business_Area_Update_Column = {
  /** column name */
  Title: 'Title'
} as const;

export type Business_Area_Update_Column = typeof Business_Area_Update_Column[keyof typeof Business_Area_Update_Column];
export type Business_Area_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Area_Set_Input>;
  /** filter the rows which have to be updated */
  where: Business_Area_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Area_Var_Pop_Fields = {
  __typename?: 'business_area_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Business_Area_Var_Samp_Fields = {
  __typename?: 'business_area_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Business_Area_Variance_Fields = {
  __typename?: 'business_area_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.cause" */
export type Cause = {
  __typename?: 'cause';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentIssueId: Scalars['uuid']['output'];
  Significance?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.cause" */
export type CauseCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.cause" */
export type Cause_Aggregate = {
  __typename?: 'cause_aggregate';
  aggregate?: Maybe<Cause_Aggregate_Fields>;
  nodes: Array<Cause>;
};

export type Cause_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cause_Aggregate_Bool_Exp_Count>;
};

export type Cause_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cause_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cause_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.cause" */
export type Cause_Aggregate_Fields = {
  __typename?: 'cause_aggregate_fields';
  avg?: Maybe<Cause_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cause_Max_Fields>;
  min?: Maybe<Cause_Min_Fields>;
  stddev?: Maybe<Cause_Stddev_Fields>;
  stddev_pop?: Maybe<Cause_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cause_Stddev_Samp_Fields>;
  sum?: Maybe<Cause_Sum_Fields>;
  var_pop?: Maybe<Cause_Var_Pop_Fields>;
  var_samp?: Maybe<Cause_Var_Samp_Fields>;
  variance?: Maybe<Cause_Variance_Fields>;
};


/** aggregate fields of "risksmart.cause" */
export type Cause_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cause_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.cause" */
export type Cause_Aggregate_Order_By = {
  avg?: InputMaybe<Cause_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cause_Max_Order_By>;
  min?: InputMaybe<Cause_Min_Order_By>;
  stddev?: InputMaybe<Cause_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cause_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cause_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cause_Sum_Order_By>;
  var_pop?: InputMaybe<Cause_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cause_Var_Samp_Order_By>;
  variance?: InputMaybe<Cause_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cause_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.cause" */
export type Cause_Arr_Rel_Insert_Input = {
  data: Array<Cause_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cause_On_Conflict>;
};

/** columns and relationships of "risksmart.cause_audit" */
export type Cause_Audit = {
  __typename?: 'cause_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId: Scalars['uuid']['output'];
  Significance?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.cause_audit" */
export type Cause_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.cause_audit". All fields are combined with a logical 'AND'. */
export type Cause_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Significance?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Cause_Audit_Bool_Exp>>;
  _not?: InputMaybe<Cause_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Cause_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.cause_audit". */
export type Cause_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Significance?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.cause_audit" */
export const Cause_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Significance: 'Significance',
  /** column name */
  Title: 'Title'
} as const;

export type Cause_Audit_Select_Column = typeof Cause_Audit_Select_Column[keyof typeof Cause_Audit_Select_Column];
/** Streaming cursor of the table "cause_audit" */
export type Cause_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cause_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cause_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Cause_Avg_Fields = {
  __typename?: 'cause_avg_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.cause" */
export type Cause_Avg_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.cause". All fields are combined with a logical 'AND'. */
export type Cause_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Significance?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Cause_Bool_Exp>>;
  _not?: InputMaybe<Cause_Bool_Exp>;
  _or?: InputMaybe<Array<Cause_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.cause" */
export const Cause_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  CausePkey: 'cause_pkey'
} as const;

export type Cause_Constraint = typeof Cause_Constraint[keyof typeof Cause_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cause_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cause_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cause_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.cause" */
export type Cause_Inc_Input = {
  Significance?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.cause" */
export type Cause_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Cause_Max_Fields = {
  __typename?: 'cause_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Significance?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.cause" */
export type Cause_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Significance?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cause_Min_Fields = {
  __typename?: 'cause_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Significance?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.cause" */
export type Cause_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Significance?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.cause" */
export type Cause_Mutation_Response = {
  __typename?: 'cause_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cause>;
};

/** input type for inserting object relation for remote table "risksmart.cause" */
export type Cause_Obj_Rel_Insert_Input = {
  data: Cause_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cause_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.cause" */
export type Cause_On_Conflict = {
  constraint: Cause_Constraint;
  update_columns?: Array<Cause_Update_Column>;
  where?: InputMaybe<Cause_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.cause". */
export type Cause_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Significance?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.cause */
export type Cause_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cause_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.cause" */
export const Cause_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Significance: 'Significance',
  /** column name */
  Title: 'Title'
} as const;

export type Cause_Select_Column = typeof Cause_Select_Column[keyof typeof Cause_Select_Column];
/** input type for updating data in table "risksmart.cause" */
export type Cause_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Cause_Stddev_Fields = {
  __typename?: 'cause_stddev_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.cause" */
export type Cause_Stddev_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cause_Stddev_Pop_Fields = {
  __typename?: 'cause_stddev_pop_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.cause" */
export type Cause_Stddev_Pop_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cause_Stddev_Samp_Fields = {
  __typename?: 'cause_stddev_samp_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.cause" */
export type Cause_Stddev_Samp_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cause" */
export type Cause_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cause_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cause_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Cause_Sum_Fields = {
  __typename?: 'cause_sum_fields';
  Significance?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.cause" */
export type Cause_Sum_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.cause" */
export const Cause_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Significance: 'Significance',
  /** column name */
  Title: 'Title'
} as const;

export type Cause_Update_Column = typeof Cause_Update_Column[keyof typeof Cause_Update_Column];
export type Cause_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cause_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cause_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cause_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cause_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cause_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cause_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cause_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cause_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cause_Var_Pop_Fields = {
  __typename?: 'cause_var_pop_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.cause" */
export type Cause_Var_Pop_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cause_Var_Samp_Fields = {
  __typename?: 'cause_var_samp_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.cause" */
export type Cause_Var_Samp_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cause_Variance_Fields = {
  __typename?: 'cause_variance_fields';
  Significance?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.cause" */
export type Cause_Variance_Order_By = {
  Significance?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.change_request" */
export type Change_Request = {
  __typename?: 'change_request';
  ActionUserId: Scalars['String']['output'];
  ChangeRequestStatus: Approval_Status_Enum;
  Comment: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  OverriddenAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OverriddenByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  RequestedChanges?: Maybe<Scalars['jsonb']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Type: Scalars['String']['output'];
  /** An array relationship */
  contributors: Array<Change_Request_Contributor>;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  overriddenBy?: Maybe<User>;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An array relationship */
  parentOwnerAndContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  requestedFileChanges: Array<Relation_File>;
  /** An aggregate relationship */
  requestedFileChanges_aggregate: Relation_File_Aggregate;
  /** An array relationship */
  responses: Array<Approver_Response>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestRequestedChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestContributorsArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Contributor_Order_By>>;
  where?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestParentOwnerAndContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestRequestedFileChangesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestRequestedFileChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.change_request" */
export type Change_RequestResponsesArgs = {
  distinct_on?: InputMaybe<Array<Approver_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Response_Order_By>>;
  where?: InputMaybe<Approver_Response_Bool_Exp>;
};

/** aggregated selection of "risksmart.change_request" */
export type Change_Request_Aggregate = {
  __typename?: 'change_request_aggregate';
  aggregate?: Maybe<Change_Request_Aggregate_Fields>;
  nodes: Array<Change_Request>;
};

export type Change_Request_Aggregate_Bool_Exp = {
  count?: InputMaybe<Change_Request_Aggregate_Bool_Exp_Count>;
};

export type Change_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Change_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Change_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.change_request" */
export type Change_Request_Aggregate_Fields = {
  __typename?: 'change_request_aggregate_fields';
  avg?: Maybe<Change_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Change_Request_Max_Fields>;
  min?: Maybe<Change_Request_Min_Fields>;
  stddev?: Maybe<Change_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Change_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Change_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Change_Request_Sum_Fields>;
  var_pop?: Maybe<Change_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Change_Request_Var_Samp_Fields>;
  variance?: Maybe<Change_Request_Variance_Fields>;
};


/** aggregate fields of "risksmart.change_request" */
export type Change_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Change_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.change_request" */
export type Change_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Change_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Change_Request_Max_Order_By>;
  min?: InputMaybe<Change_Request_Min_Order_By>;
  stddev?: InputMaybe<Change_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Change_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Change_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Change_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Change_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Change_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Change_Request_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.change_request" */
export type Change_Request_Arr_Rel_Insert_Input = {
  data: Array<Change_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Change_Request_On_Conflict>;
};

/** columns and relationships of "risksmart.change_request_audit" */
export type Change_Request_Audit = {
  __typename?: 'change_request_audit';
  ChangeRequestStatus: Scalars['String']['output'];
  Comment: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OverriddenAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OverriddenByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  RequestedChanges?: Maybe<Scalars['jsonb']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Type: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.change_request_audit" */
export type Change_Request_AuditRequestedChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.change_request_audit". All fields are combined with a logical 'AND'. */
export type Change_Request_Audit_Bool_Exp = {
  ChangeRequestStatus?: InputMaybe<String_Comparison_Exp>;
  Comment?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OverriddenAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  OverriddenByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  RequestedChanges?: InputMaybe<Jsonb_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Change_Request_Audit_Bool_Exp>>;
  _not?: InputMaybe<Change_Request_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Change_Request_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.change_request_audit". */
export type Change_Request_Audit_Order_By = {
  ChangeRequestStatus?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverriddenAtTimestamp?: InputMaybe<Order_By>;
  OverriddenByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  RequestedChanges?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.change_request_audit" */
export const Change_Request_Audit_Select_Column = {
  /** column name */
  ChangeRequestStatus: 'ChangeRequestStatus',
  /** column name */
  Comment: 'Comment',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OverriddenAtTimestamp: 'OverriddenAtTimestamp',
  /** column name */
  OverriddenByUser: 'OverriddenByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  RequestedChanges: 'RequestedChanges',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Type: 'Type'
} as const;

export type Change_Request_Audit_Select_Column = typeof Change_Request_Audit_Select_Column[keyof typeof Change_Request_Audit_Select_Column];
/** Streaming cursor of the table "change_request_audit" */
export type Change_Request_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Change_Request_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Change_Request_Audit_Stream_Cursor_Value_Input = {
  ChangeRequestStatus?: InputMaybe<Scalars['String']['input']>;
  Comment?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OverriddenAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OverriddenByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  RequestedChanges?: InputMaybe<Scalars['jsonb']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Change_Request_Avg_Fields = {
  __typename?: 'change_request_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.change_request" */
export type Change_Request_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.change_request". All fields are combined with a logical 'AND'. */
export type Change_Request_Bool_Exp = {
  ActionUserId?: InputMaybe<String_Comparison_Exp>;
  ChangeRequestStatus?: InputMaybe<Approval_Status_Enum_Comparison_Exp>;
  Comment?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  OverriddenAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  OverriddenByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  RequestedChanges?: InputMaybe<Jsonb_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Change_Request_Bool_Exp>>;
  _not?: InputMaybe<Change_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Change_Request_Bool_Exp>>;
  contributors?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  overriddenBy?: InputMaybe<User_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  parentOwnerAndContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  requestedFileChanges?: InputMaybe<Relation_File_Bool_Exp>;
  requestedFileChanges_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  responses?: InputMaybe<Approver_Response_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.change_request" */
export const Change_Request_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ChangeRequestPkey: 'change_request_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxChangerequestOrgkeySequentialid: 'idx_changerequest_orgkey_sequentialid'
} as const;

export type Change_Request_Constraint = typeof Change_Request_Constraint[keyof typeof Change_Request_Constraint];
/** columns and relationships of "risksmart.change_request_contributor" */
export type Change_Request_Contributor = {
  __typename?: 'change_request_contributor';
  Id: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  changeRequest: Change_Request;
  /** An object relationship */
  user?: Maybe<User>;
};

/** order by aggregate values of table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Change_Request_Contributor_Max_Order_By>;
  min?: InputMaybe<Change_Request_Contributor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_Arr_Rel_Insert_Input = {
  data: Array<Change_Request_Contributor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Change_Request_Contributor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.change_request_contributor". All fields are combined with a logical 'AND'. */
export type Change_Request_Contributor_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Change_Request_Contributor_Bool_Exp>>;
  _not?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
  _or?: InputMaybe<Array<Change_Request_Contributor_Bool_Exp>>;
  changeRequest?: InputMaybe<Change_Request_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.change_request_contributor" */
export const Change_Request_Contributor_Constraint = {
  /** unique or primary key constraint on columns "ChangeRequestId", "UserId" */
  ChangeRequestContributorChangeRequestIdUserIdKey: 'change_request_contributor_ChangeRequestId_UserId_key',
  /** unique or primary key constraint on columns "Id" */
  ChangeRequestContributorPkey: 'change_request_contributor_pkey'
} as const;

export type Change_Request_Contributor_Constraint = typeof Change_Request_Contributor_Constraint[keyof typeof Change_Request_Contributor_Constraint];
/** input type for inserting data into table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_Insert_Input = {
  ChangeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  changeRequest?: InputMaybe<Change_Request_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_Max_Order_By = {
  Id?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_Min_Order_By = {
  Id?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.change_request_contributor" */
export type Change_Request_Contributor_On_Conflict = {
  constraint: Change_Request_Contributor_Constraint;
  update_columns?: Array<Change_Request_Contributor_Update_Column>;
  where?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.change_request_contributor". */
export type Change_Request_Contributor_Order_By = {
  Id?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  changeRequest?: InputMaybe<Change_Request_Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.change_request_contributor" */
export const Change_Request_Contributor_Select_Column = {
  /** column name */
  Id: 'Id',
  /** column name */
  UserId: 'UserId'
} as const;

export type Change_Request_Contributor_Select_Column = typeof Change_Request_Contributor_Select_Column[keyof typeof Change_Request_Contributor_Select_Column];
/** Streaming cursor of the table "change_request_contributor" */
export type Change_Request_Contributor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Change_Request_Contributor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Change_Request_Contributor_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "risksmart.change_request_contributor" (current role has no relevant permissions) */
export const Change_Request_Contributor_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Change_Request_Contributor_Update_Column = typeof Change_Request_Contributor_Update_Column[keyof typeof Change_Request_Contributor_Update_Column];
export const Change_Request_File_Operation_Enum = {
  /** Added */
  Added: 'added',
  /** Removed */
  Removed: 'removed'
} as const;

export type Change_Request_File_Operation_Enum = typeof Change_Request_File_Operation_Enum[keyof typeof Change_Request_File_Operation_Enum];
/** Boolean expression to compare columns of type "change_request_file_operation_enum". All fields are combined with logical 'AND'. */
export type Change_Request_File_Operation_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Change_Request_File_Operation_Enum>;
  _in?: InputMaybe<Array<Change_Request_File_Operation_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Change_Request_File_Operation_Enum>;
  _nin?: InputMaybe<Array<Change_Request_File_Operation_Enum>>;
};

/** input type for inserting data into table "risksmart.change_request" */
export type Change_Request_Insert_Input = {
  ActionUserId?: InputMaybe<Scalars['String']['input']>;
  ChangeRequestStatus?: InputMaybe<Approval_Status_Enum>;
  Comment?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  OverriddenAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OverriddenByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  RequestedChanges?: InputMaybe<Scalars['jsonb']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  contributors?: InputMaybe<Change_Request_Contributor_Arr_Rel_Insert_Input>;
  requestedFileChanges?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  responses?: InputMaybe<Approver_Response_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Change_Request_Max_Fields = {
  __typename?: 'change_request_max_fields';
  ActionUserId?: Maybe<Scalars['String']['output']>;
  Comment?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  OverriddenAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OverriddenByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.change_request" */
export type Change_Request_Max_Order_By = {
  ActionUserId?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OverriddenAtTimestamp?: InputMaybe<Order_By>;
  OverriddenByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Change_Request_Min_Fields = {
  __typename?: 'change_request_min_fields';
  ActionUserId?: Maybe<Scalars['String']['output']>;
  Comment?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  OverriddenAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OverriddenByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.change_request" */
export type Change_Request_Min_Order_By = {
  ActionUserId?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OverriddenAtTimestamp?: InputMaybe<Order_By>;
  OverriddenByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.change_request" */
export type Change_Request_Obj_Rel_Insert_Input = {
  data: Change_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Change_Request_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.change_request" */
export type Change_Request_On_Conflict = {
  constraint: Change_Request_Constraint;
  update_columns?: Array<Change_Request_Update_Column>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.change_request". */
export type Change_Request_Order_By = {
  ActionUserId?: InputMaybe<Order_By>;
  ChangeRequestStatus?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OverriddenAtTimestamp?: InputMaybe<Order_By>;
  OverriddenByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  RequestedChanges?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  contributors_aggregate?: InputMaybe<Change_Request_Contributor_Aggregate_Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  overriddenBy?: InputMaybe<User_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  parentOwnerAndContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  requestedFileChanges_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  responses_aggregate?: InputMaybe<Approver_Response_Aggregate_Order_By>;
};

/** select columns of table "risksmart.change_request" */
export const Change_Request_Select_Column = {
  /** column name */
  ActionUserId: 'ActionUserId',
  /** column name */
  ChangeRequestStatus: 'ChangeRequestStatus',
  /** column name */
  Comment: 'Comment',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  OverriddenAtTimestamp: 'OverriddenAtTimestamp',
  /** column name */
  OverriddenByUser: 'OverriddenByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  RequestedChanges: 'RequestedChanges',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Type: 'Type'
} as const;

export type Change_Request_Select_Column = typeof Change_Request_Select_Column[keyof typeof Change_Request_Select_Column];
/** aggregate stddev on columns */
export type Change_Request_Stddev_Fields = {
  __typename?: 'change_request_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.change_request" */
export type Change_Request_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Change_Request_Stddev_Pop_Fields = {
  __typename?: 'change_request_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.change_request" */
export type Change_Request_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Change_Request_Stddev_Samp_Fields = {
  __typename?: 'change_request_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.change_request" */
export type Change_Request_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "change_request" */
export type Change_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Change_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Change_Request_Stream_Cursor_Value_Input = {
  ActionUserId?: InputMaybe<Scalars['String']['input']>;
  ChangeRequestStatus?: InputMaybe<Approval_Status_Enum>;
  Comment?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  OverriddenAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OverriddenByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  RequestedChanges?: InputMaybe<Scalars['jsonb']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Change_Request_Sum_Fields = {
  __typename?: 'change_request_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.change_request" */
export type Change_Request_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.change_request" */
export const Change_Request_Update_Column = {
  /** column name */
  ActionUserId: 'ActionUserId',
  /** column name */
  ChangeRequestStatus: 'ChangeRequestStatus',
  /** column name */
  Comment: 'Comment',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  OverriddenAtTimestamp: 'OverriddenAtTimestamp',
  /** column name */
  OverriddenByUser: 'OverriddenByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  RequestedChanges: 'RequestedChanges',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Type: 'Type'
} as const;

export type Change_Request_Update_Column = typeof Change_Request_Update_Column[keyof typeof Change_Request_Update_Column];
/** aggregate var_pop on columns */
export type Change_Request_Var_Pop_Fields = {
  __typename?: 'change_request_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.change_request" */
export type Change_Request_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Change_Request_Var_Samp_Fields = {
  __typename?: 'change_request_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.change_request" */
export type Change_Request_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Change_Request_Variance_Fields = {
  __typename?: 'change_request_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.change_request" */
export type Change_Request_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.colour_palette" */
export type Colour_Palette = {
  __typename?: 'colour_palette';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Settings: Scalars['jsonb']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.colour_palette" */
export type Colour_PaletteSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.colour_palette" */
export type Colour_Palette_Aggregate = {
  __typename?: 'colour_palette_aggregate';
  aggregate?: Maybe<Colour_Palette_Aggregate_Fields>;
  nodes: Array<Colour_Palette>;
};

/** aggregate fields of "risksmart.colour_palette" */
export type Colour_Palette_Aggregate_Fields = {
  __typename?: 'colour_palette_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Colour_Palette_Max_Fields>;
  min?: Maybe<Colour_Palette_Min_Fields>;
};


/** aggregate fields of "risksmart.colour_palette" */
export type Colour_Palette_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Colour_Palette_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Colour_Palette_Append_Input = {
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.colour_palette_audit" */
export type Colour_Palette_Audit = {
  __typename?: 'colour_palette_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Settings: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.colour_palette_audit" */
export type Colour_Palette_AuditSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.colour_palette_audit". All fields are combined with a logical 'AND'. */
export type Colour_Palette_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Settings?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Colour_Palette_Audit_Bool_Exp>>;
  _not?: InputMaybe<Colour_Palette_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Colour_Palette_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.colour_palette_audit". */
export type Colour_Palette_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Settings?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.colour_palette_audit" */
export const Colour_Palette_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  Settings: 'Settings'
} as const;

export type Colour_Palette_Audit_Select_Column = typeof Colour_Palette_Audit_Select_Column[keyof typeof Colour_Palette_Audit_Select_Column];
/** Streaming cursor of the table "colour_palette_audit" */
export type Colour_Palette_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Colour_Palette_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Colour_Palette_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.colour_palette". All fields are combined with a logical 'AND'. */
export type Colour_Palette_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Settings?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Colour_Palette_Bool_Exp>>;
  _not?: InputMaybe<Colour_Palette_Bool_Exp>;
  _or?: InputMaybe<Array<Colour_Palette_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.colour_palette" */
export const Colour_Palette_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ColourPalettePkey: 'colour_palette_pkey'
} as const;

export type Colour_Palette_Constraint = typeof Colour_Palette_Constraint[keyof typeof Colour_Palette_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Colour_Palette_Delete_At_Path_Input = {
  Settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Colour_Palette_Delete_Elem_Input = {
  Settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Colour_Palette_Delete_Key_Input = {
  Settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.colour_palette" */
export type Colour_Palette_Insert_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Colour_Palette_Max_Fields = {
  __typename?: 'colour_palette_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Colour_Palette_Min_Fields = {
  __typename?: 'colour_palette_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.colour_palette" */
export type Colour_Palette_Mutation_Response = {
  __typename?: 'colour_palette_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Colour_Palette>;
};

/** on_conflict condition type for table "risksmart.colour_palette" */
export type Colour_Palette_On_Conflict = {
  constraint: Colour_Palette_Constraint;
  update_columns?: Array<Colour_Palette_Update_Column>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.colour_palette". */
export type Colour_Palette_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Settings?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.colour_palette */
export type Colour_Palette_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Colour_Palette_Prepend_Input = {
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.colour_palette" */
export const Colour_Palette_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  Settings: 'Settings'
} as const;

export type Colour_Palette_Select_Column = typeof Colour_Palette_Select_Column[keyof typeof Colour_Palette_Select_Column];
/** input type for updating data in table "risksmart.colour_palette" */
export type Colour_Palette_Set_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "colour_palette" */
export type Colour_Palette_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Colour_Palette_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Colour_Palette_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.colour_palette" */
export const Colour_Palette_Update_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  Name: 'Name',
  /** column name */
  Settings: 'Settings'
} as const;

export type Colour_Palette_Update_Column = typeof Colour_Palette_Update_Column[keyof typeof Colour_Palette_Update_Column];
export type Colour_Palette_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Colour_Palette_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Colour_Palette_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Colour_Palette_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Colour_Palette_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Colour_Palette_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Colour_Palette_Set_Input>;
  /** filter the rows which have to be updated */
  where: Colour_Palette_Bool_Exp;
};

/** columns and relationships of "risksmart.comment" */
export type Comment = {
  __typename?: 'comment';
  Content: Scalars['String']['output'];
  ConversationId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  /** An object relationship */
  conversation?: Maybe<Conversation>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** order by aggregate values of table "risksmart.comment" */
export type Comment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comment_Max_Order_By>;
  min?: InputMaybe<Comment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.comment" */
export type Comment_Arr_Rel_Insert_Input = {
  data: Array<Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};

/** columns and relationships of "risksmart.comment_audit" */
export type Comment_Audit = {
  __typename?: 'comment_audit';
  Content: Scalars['String']['output'];
  ConversationId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.comment_audit". All fields are combined with a logical 'AND'. */
export type Comment_Audit_Bool_Exp = {
  Content?: InputMaybe<String_Comparison_Exp>;
  ConversationId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Comment_Audit_Bool_Exp>>;
  _not?: InputMaybe<Comment_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Comment_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.comment_audit". */
export type Comment_Audit_Order_By = {
  Content?: InputMaybe<Order_By>;
  ConversationId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.comment_audit" */
export const Comment_Audit_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  ConversationId: 'ConversationId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type Comment_Audit_Select_Column = typeof Comment_Audit_Select_Column[keyof typeof Comment_Audit_Select_Column];
/** Streaming cursor of the table "comment_audit" */
export type Comment_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comment_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comment_Audit_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  ConversationId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.comment". All fields are combined with a logical 'AND'. */
export type Comment_Bool_Exp = {
  Content?: InputMaybe<String_Comparison_Exp>;
  ConversationId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Comment_Bool_Exp>>;
  _not?: InputMaybe<Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Comment_Bool_Exp>>;
  conversation?: InputMaybe<Conversation_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.comment" */
export const Comment_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  CommentPkey: 'comment_pkey'
} as const;

export type Comment_Constraint = typeof Comment_Constraint[keyof typeof Comment_Constraint];
/** input type for inserting data into table "risksmart.comment" */
export type Comment_Insert_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  ConversationId?: InputMaybe<Scalars['uuid']['input']>;
  conversation?: InputMaybe<Conversation_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.comment" */
export type Comment_Max_Order_By = {
  Content?: InputMaybe<Order_By>;
  ConversationId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.comment" */
export type Comment_Min_Order_By = {
  Content?: InputMaybe<Order_By>;
  ConversationId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.comment" */
export type Comment_Mutation_Response = {
  __typename?: 'comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comment>;
};

/** on_conflict condition type for table "risksmart.comment" */
export type Comment_On_Conflict = {
  constraint: Comment_Constraint;
  update_columns?: Array<Comment_Update_Column>;
  where?: InputMaybe<Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.comment". */
export type Comment_Order_By = {
  Content?: InputMaybe<Order_By>;
  ConversationId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  conversation?: InputMaybe<Conversation_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.comment */
export type Comment_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.comment" */
export const Comment_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  ConversationId: 'ConversationId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type Comment_Select_Column = typeof Comment_Select_Column[keyof typeof Comment_Select_Column];
/** input type for updating data in table "risksmart.comment" */
export type Comment_Set_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "comment" */
export type Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comment_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  ConversationId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.comment" */
export const Comment_Update_Column = {
  /** column name */
  Content: 'Content'
} as const;

export type Comment_Update_Column = typeof Comment_Update_Column[keyof typeof Comment_Update_Column];
export type Comment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comment_Bool_Exp;
};

/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment = {
  __typename?: 'compliance_monitoring_assessment';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status?: Maybe<Assessment_Status_Enum>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  assessmentActions: Array<Action_Parent>;
  /** An aggregate relationship */
  assessmentActions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  assessmentActivities: Array<Assessment_Activity>;
  /** An aggregate relationship */
  assessmentActivities_aggregate: Assessment_Activity_Aggregate;
  /** An array relationship */
  assessmentIssues: Array<Issue_Parent>;
  /** An aggregate relationship */
  assessmentIssues_aggregate: Issue_Parent_Aggregate;
  /** An array relationship */
  assessmentResults: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Assessment_Result_Parent_Aggregate;
  /** An object relationship */
  completedByUser?: Maybe<User>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  originatingItem?: Maybe<Node>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_AssessmentTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** aggregated selection of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Aggregate = {
  __typename?: 'compliance_monitoring_assessment_aggregate';
  aggregate?: Maybe<Compliance_Monitoring_Assessment_Aggregate_Fields>;
  nodes: Array<Compliance_Monitoring_Assessment>;
};

/** aggregate fields of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Aggregate_Fields = {
  __typename?: 'compliance_monitoring_assessment_aggregate_fields';
  avg?: Maybe<Compliance_Monitoring_Assessment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Compliance_Monitoring_Assessment_Max_Fields>;
  min?: Maybe<Compliance_Monitoring_Assessment_Min_Fields>;
  stddev?: Maybe<Compliance_Monitoring_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Compliance_Monitoring_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Compliance_Monitoring_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Compliance_Monitoring_Assessment_Sum_Fields>;
  var_pop?: Maybe<Compliance_Monitoring_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Compliance_Monitoring_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Compliance_Monitoring_Assessment_Variance_Fields>;
};


/** aggregate fields of "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Compliance_Monitoring_Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Compliance_Monitoring_Assessment_Avg_Fields = {
  __typename?: 'compliance_monitoring_assessment_avg_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.compliance_monitoring_assessment". All fields are combined with a logical 'AND'. */
export type Compliance_Monitoring_Assessment_Bool_Exp = {
  ActualCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CompletedByUser?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextTestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  OriginatingItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Outcome?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<Assessment_Status_Enum_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  TargetCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Compliance_Monitoring_Assessment_Bool_Exp>>;
  _not?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Compliance_Monitoring_Assessment_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assessmentActions?: InputMaybe<Action_Parent_Bool_Exp>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Bool_Exp>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp>;
  assessmentIssues?: InputMaybe<Issue_Parent_Bool_Exp>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  completedByUser?: InputMaybe<User_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  originatingItem?: InputMaybe<Node_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.compliance_monitoring_assessment" */
export const Compliance_Monitoring_Assessment_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ComplianceMonitoringAssessmentPkey: 'compliance_monitoring_assessment_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxComplianceMonitoringAssessmentOrgkeySequentialid: 'idx_compliance_monitoring_assessment_orgkey_sequentialid'
} as const;

export type Compliance_Monitoring_Assessment_Constraint = typeof Compliance_Monitoring_Assessment_Constraint[keyof typeof Compliance_Monitoring_Assessment_Constraint];
/** input type for inserting data into table "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Insert_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  assessmentActions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Arr_Rel_Insert_Input>;
  assessmentIssues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Compliance_Monitoring_Assessment_Max_Fields = {
  __typename?: 'compliance_monitoring_assessment_max_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Compliance_Monitoring_Assessment_Min_Fields = {
  __typename?: 'compliance_monitoring_assessment_min_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Mutation_Response = {
  __typename?: 'compliance_monitoring_assessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Compliance_Monitoring_Assessment>;
};

/** input type for inserting object relation for remote table "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input = {
  data: Compliance_Monitoring_Assessment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Compliance_Monitoring_Assessment_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_On_Conflict = {
  constraint: Compliance_Monitoring_Assessment_Constraint;
  update_columns?: Array<Compliance_Monitoring_Assessment_Update_Column>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.compliance_monitoring_assessment". */
export type Compliance_Monitoring_Assessment_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Order_By>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  completedByUser?: InputMaybe<User_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  originatingItem?: InputMaybe<Node_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** select columns of table "risksmart.compliance_monitoring_assessment" */
export const Compliance_Monitoring_Assessment_Select_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Compliance_Monitoring_Assessment_Select_Column = typeof Compliance_Monitoring_Assessment_Select_Column[keyof typeof Compliance_Monitoring_Assessment_Select_Column];
/** aggregate stddev on columns */
export type Compliance_Monitoring_Assessment_Stddev_Fields = {
  __typename?: 'compliance_monitoring_assessment_stddev_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Compliance_Monitoring_Assessment_Stddev_Pop_Fields = {
  __typename?: 'compliance_monitoring_assessment_stddev_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Compliance_Monitoring_Assessment_Stddev_Samp_Fields = {
  __typename?: 'compliance_monitoring_assessment_stddev_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "compliance_monitoring_assessment" */
export type Compliance_Monitoring_Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Compliance_Monitoring_Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Compliance_Monitoring_Assessment_Stream_Cursor_Value_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Compliance_Monitoring_Assessment_Sum_Fields = {
  __typename?: 'compliance_monitoring_assessment_sum_fields';
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.compliance_monitoring_assessment" */
export const Compliance_Monitoring_Assessment_Update_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Compliance_Monitoring_Assessment_Update_Column = typeof Compliance_Monitoring_Assessment_Update_Column[keyof typeof Compliance_Monitoring_Assessment_Update_Column];
/** aggregate var_pop on columns */
export type Compliance_Monitoring_Assessment_Var_Pop_Fields = {
  __typename?: 'compliance_monitoring_assessment_var_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Compliance_Monitoring_Assessment_Var_Samp_Fields = {
  __typename?: 'compliance_monitoring_assessment_var_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Compliance_Monitoring_Assessment_Variance_Fields = {
  __typename?: 'compliance_monitoring_assessment_variance_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.consequence" */
export type Consequence = {
  __typename?: 'consequence';
  CostType: Cost_Type_Enum;
  CostValue: Scalars['numeric']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentIssueId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
  Type?: Maybe<Consequence_Type_Enum>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.consequence" */
export type ConsequenceCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.consequence" */
export type Consequence_Aggregate = {
  __typename?: 'consequence_aggregate';
  aggregate?: Maybe<Consequence_Aggregate_Fields>;
  nodes: Array<Consequence>;
};

export type Consequence_Aggregate_Bool_Exp = {
  count?: InputMaybe<Consequence_Aggregate_Bool_Exp_Count>;
};

export type Consequence_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consequence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Consequence_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.consequence" */
export type Consequence_Aggregate_Fields = {
  __typename?: 'consequence_aggregate_fields';
  avg?: Maybe<Consequence_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consequence_Max_Fields>;
  min?: Maybe<Consequence_Min_Fields>;
  stddev?: Maybe<Consequence_Stddev_Fields>;
  stddev_pop?: Maybe<Consequence_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consequence_Stddev_Samp_Fields>;
  sum?: Maybe<Consequence_Sum_Fields>;
  var_pop?: Maybe<Consequence_Var_Pop_Fields>;
  var_samp?: Maybe<Consequence_Var_Samp_Fields>;
  variance?: Maybe<Consequence_Variance_Fields>;
};


/** aggregate fields of "risksmart.consequence" */
export type Consequence_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consequence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.consequence" */
export type Consequence_Aggregate_Order_By = {
  avg?: InputMaybe<Consequence_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consequence_Max_Order_By>;
  min?: InputMaybe<Consequence_Min_Order_By>;
  stddev?: InputMaybe<Consequence_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consequence_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consequence_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consequence_Sum_Order_By>;
  var_pop?: InputMaybe<Consequence_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consequence_Var_Samp_Order_By>;
  variance?: InputMaybe<Consequence_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Consequence_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.consequence" */
export type Consequence_Arr_Rel_Insert_Input = {
  data: Array<Consequence_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consequence_On_Conflict>;
};

/** columns and relationships of "risksmart.consequence_audit" */
export type Consequence_Audit = {
  __typename?: 'consequence_audit';
  CostType: Scalars['String']['output'];
  CostValue: Scalars['numeric']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
  Type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.consequence_audit" */
export type Consequence_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.consequence_audit" */
export type Consequence_Audit_Aggregate = {
  __typename?: 'consequence_audit_aggregate';
  aggregate?: Maybe<Consequence_Audit_Aggregate_Fields>;
  nodes: Array<Consequence_Audit>;
};

/** aggregate fields of "risksmart.consequence_audit" */
export type Consequence_Audit_Aggregate_Fields = {
  __typename?: 'consequence_audit_aggregate_fields';
  avg?: Maybe<Consequence_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consequence_Audit_Max_Fields>;
  min?: Maybe<Consequence_Audit_Min_Fields>;
  stddev?: Maybe<Consequence_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Consequence_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consequence_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Consequence_Audit_Sum_Fields>;
  var_pop?: Maybe<Consequence_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Consequence_Audit_Var_Samp_Fields>;
  variance?: Maybe<Consequence_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.consequence_audit" */
export type Consequence_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consequence_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Consequence_Audit_Avg_Fields = {
  __typename?: 'consequence_audit_avg_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.consequence_audit". All fields are combined with a logical 'AND'. */
export type Consequence_Audit_Bool_Exp = {
  CostType?: InputMaybe<String_Comparison_Exp>;
  CostValue?: InputMaybe<Numeric_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Criticality?: InputMaybe<Int_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Consequence_Audit_Bool_Exp>>;
  _not?: InputMaybe<Consequence_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Consequence_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Consequence_Audit_Max_Fields = {
  __typename?: 'consequence_audit_max_fields';
  CostType?: Maybe<Scalars['String']['output']>;
  CostValue?: Maybe<Scalars['numeric']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Consequence_Audit_Min_Fields = {
  __typename?: 'consequence_audit_min_fields';
  CostType?: Maybe<Scalars['String']['output']>;
  CostValue?: Maybe<Scalars['numeric']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.consequence_audit". */
export type Consequence_Audit_Order_By = {
  CostType?: InputMaybe<Order_By>;
  CostValue?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.consequence_audit" */
export const Consequence_Audit_Select_Column = {
  /** column name */
  CostType: 'CostType',
  /** column name */
  CostValue: 'CostValue',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Criticality: 'Criticality',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Consequence_Audit_Select_Column = typeof Consequence_Audit_Select_Column[keyof typeof Consequence_Audit_Select_Column];
/** aggregate stddev on columns */
export type Consequence_Audit_Stddev_Fields = {
  __typename?: 'consequence_audit_stddev_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Consequence_Audit_Stddev_Pop_Fields = {
  __typename?: 'consequence_audit_stddev_pop_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Consequence_Audit_Stddev_Samp_Fields = {
  __typename?: 'consequence_audit_stddev_samp_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "consequence_audit" */
export type Consequence_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consequence_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consequence_Audit_Stream_Cursor_Value_Input = {
  CostType?: InputMaybe<Scalars['String']['input']>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Consequence_Audit_Sum_Fields = {
  __typename?: 'consequence_audit_sum_fields';
  CostValue?: Maybe<Scalars['numeric']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Consequence_Audit_Var_Pop_Fields = {
  __typename?: 'consequence_audit_var_pop_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Consequence_Audit_Var_Samp_Fields = {
  __typename?: 'consequence_audit_var_samp_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Consequence_Audit_Variance_Fields = {
  __typename?: 'consequence_audit_variance_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Consequence_Avg_Fields = {
  __typename?: 'consequence_avg_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.consequence" */
export type Consequence_Avg_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.consequence". All fields are combined with a logical 'AND'. */
export type Consequence_Bool_Exp = {
  CostType?: InputMaybe<Cost_Type_Enum_Comparison_Exp>;
  CostValue?: InputMaybe<Numeric_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Criticality?: InputMaybe<Int_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Consequence_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Consequence_Bool_Exp>>;
  _not?: InputMaybe<Consequence_Bool_Exp>;
  _or?: InputMaybe<Array<Consequence_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.consequence" */
export const Consequence_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ConsequencePkey: 'consequence_pkey'
} as const;

export type Consequence_Constraint = typeof Consequence_Constraint[keyof typeof Consequence_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Consequence_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Consequence_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Consequence_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.consequence" */
export type Consequence_Inc_Input = {
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.consequence" */
export type Consequence_Insert_Input = {
  CostType?: InputMaybe<Cost_Type_Enum>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Consequence_Type_Enum>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Consequence_Max_Fields = {
  __typename?: 'consequence_max_fields';
  CostValue?: Maybe<Scalars['numeric']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.consequence" */
export type Consequence_Max_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consequence_Min_Fields = {
  __typename?: 'consequence_min_fields';
  CostValue?: Maybe<Scalars['numeric']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.consequence" */
export type Consequence_Min_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.consequence" */
export type Consequence_Mutation_Response = {
  __typename?: 'consequence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consequence>;
};

/** input type for inserting object relation for remote table "risksmart.consequence" */
export type Consequence_Obj_Rel_Insert_Input = {
  data: Consequence_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Consequence_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.consequence" */
export type Consequence_On_Conflict = {
  constraint: Consequence_Constraint;
  update_columns?: Array<Consequence_Update_Column>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.consequence". */
export type Consequence_Order_By = {
  CostType?: InputMaybe<Order_By>;
  CostValue?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.consequence */
export type Consequence_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Consequence_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.consequence" */
export const Consequence_Select_Column = {
  /** column name */
  CostType: 'CostType',
  /** column name */
  CostValue: 'CostValue',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Criticality: 'Criticality',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Consequence_Select_Column = typeof Consequence_Select_Column[keyof typeof Consequence_Select_Column];
/** input type for updating data in table "risksmart.consequence" */
export type Consequence_Set_Input = {
  CostType?: InputMaybe<Cost_Type_Enum>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Consequence_Type_Enum>;
};

/** aggregate stddev on columns */
export type Consequence_Stddev_Fields = {
  __typename?: 'consequence_stddev_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.consequence" */
export type Consequence_Stddev_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consequence_Stddev_Pop_Fields = {
  __typename?: 'consequence_stddev_pop_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.consequence" */
export type Consequence_Stddev_Pop_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consequence_Stddev_Samp_Fields = {
  __typename?: 'consequence_stddev_samp_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.consequence" */
export type Consequence_Stddev_Samp_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consequence" */
export type Consequence_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consequence_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consequence_Stream_Cursor_Value_Input = {
  CostType?: InputMaybe<Cost_Type_Enum>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Consequence_Type_Enum>;
};

/** aggregate sum on columns */
export type Consequence_Sum_Fields = {
  __typename?: 'consequence_sum_fields';
  CostValue?: Maybe<Scalars['numeric']['output']>;
  Criticality?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.consequence" */
export type Consequence_Sum_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

export const Consequence_Type_Enum = {
  /** Customer */
  Customer: 'customer',
  /** Financial */
  Financial: 'financial',
  /** Legal & Regulatory */
  LegalAndRegulatory: 'legal_and_regulatory',
  /** Operational */
  Operational: 'operational',
  /** Reputational */
  Reputational: 'reputational'
} as const;

export type Consequence_Type_Enum = typeof Consequence_Type_Enum[keyof typeof Consequence_Type_Enum];
/** Boolean expression to compare columns of type "consequence_type_enum". All fields are combined with logical 'AND'. */
export type Consequence_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Consequence_Type_Enum>;
  _in?: InputMaybe<Array<Consequence_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Consequence_Type_Enum>;
  _nin?: InputMaybe<Array<Consequence_Type_Enum>>;
};

/** update columns of table "risksmart.consequence" */
export const Consequence_Update_Column = {
  /** column name */
  CostType: 'CostType',
  /** column name */
  CostValue: 'CostValue',
  /** column name */
  Criticality: 'Criticality',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Consequence_Update_Column = typeof Consequence_Update_Column[keyof typeof Consequence_Update_Column];
export type Consequence_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Consequence_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Consequence_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Consequence_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Consequence_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consequence_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Consequence_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consequence_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consequence_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consequence_Var_Pop_Fields = {
  __typename?: 'consequence_var_pop_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.consequence" */
export type Consequence_Var_Pop_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consequence_Var_Samp_Fields = {
  __typename?: 'consequence_var_samp_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.consequence" */
export type Consequence_Var_Samp_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consequence_Variance_Fields = {
  __typename?: 'consequence_variance_fields';
  CostValue?: Maybe<Scalars['Float']['output']>;
  Criticality?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.consequence" */
export type Consequence_Variance_Order_By = {
  CostValue?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.contributor" */
export type Contributor = {
  __typename?: 'contributor';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "risksmart.contributor" */
export type Contributor_Aggregate = {
  __typename?: 'contributor_aggregate';
  aggregate?: Maybe<Contributor_Aggregate_Fields>;
  nodes: Array<Contributor>;
};

export type Contributor_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contributor_Aggregate_Bool_Exp_Count>;
};

export type Contributor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contributor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contributor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.contributor" */
export type Contributor_Aggregate_Fields = {
  __typename?: 'contributor_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contributor_Max_Fields>;
  min?: Maybe<Contributor_Min_Fields>;
};


/** aggregate fields of "risksmart.contributor" */
export type Contributor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contributor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.contributor" */
export type Contributor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contributor_Max_Order_By>;
  min?: InputMaybe<Contributor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.contributor" */
export type Contributor_Arr_Rel_Insert_Input = {
  data: Array<Contributor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contributor_On_Conflict>;
};

/** columns and relationships of "risksmart.contributor_audit" */
export type Contributor_Audit = {
  __typename?: 'contributor_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
};

/** aggregated selection of "risksmart.contributor_audit" */
export type Contributor_Audit_Aggregate = {
  __typename?: 'contributor_audit_aggregate';
  aggregate?: Maybe<Contributor_Audit_Aggregate_Fields>;
  nodes: Array<Contributor_Audit>;
};

export type Contributor_Audit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contributor_Audit_Aggregate_Bool_Exp_Count>;
};

export type Contributor_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contributor_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.contributor_audit" */
export type Contributor_Audit_Aggregate_Fields = {
  __typename?: 'contributor_audit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contributor_Audit_Max_Fields>;
  min?: Maybe<Contributor_Audit_Min_Fields>;
};


/** aggregate fields of "risksmart.contributor_audit" */
export type Contributor_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.contributor_audit" */
export type Contributor_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contributor_Audit_Max_Order_By>;
  min?: InputMaybe<Contributor_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.contributor_audit". All fields are combined with a logical 'AND'. */
export type Contributor_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Contributor_Audit_Bool_Exp>>;
  _not?: InputMaybe<Contributor_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Contributor_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Contributor_Audit_Max_Fields = {
  __typename?: 'contributor_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.contributor_audit" */
export type Contributor_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contributor_Audit_Min_Fields = {
  __typename?: 'contributor_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.contributor_audit" */
export type Contributor_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.contributor_audit". */
export type Contributor_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.contributor_audit" */
export const Contributor_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Contributor_Audit_Select_Column = typeof Contributor_Audit_Select_Column[keyof typeof Contributor_Audit_Select_Column];
/** Boolean expression to filter rows from the table "risksmart.contributor". All fields are combined with a logical 'AND'. */
export type Contributor_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Contributor_Bool_Exp>>;
  _not?: InputMaybe<Contributor_Bool_Exp>;
  _or?: InputMaybe<Array<Contributor_Bool_Exp>>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.contributor" */
export const Contributor_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "UserId" */
  ContributorPkey: 'contributor_pkey'
} as const;

export type Contributor_Constraint = typeof Contributor_Constraint[keyof typeof Contributor_Constraint];
/** columns and relationships of "risksmart.contributor_group" */
export type Contributor_Group = {
  __typename?: 'contributor_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  UserGroupId: Scalars['uuid']['output'];
  /** An object relationship */
  group?: Maybe<User_Group>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** aggregated selection of "risksmart.contributor_group" */
export type Contributor_Group_Aggregate = {
  __typename?: 'contributor_group_aggregate';
  aggregate?: Maybe<Contributor_Group_Aggregate_Fields>;
  nodes: Array<Contributor_Group>;
};

export type Contributor_Group_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp_Count>;
};

export type Contributor_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contributor_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.contributor_group" */
export type Contributor_Group_Aggregate_Fields = {
  __typename?: 'contributor_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contributor_Group_Max_Fields>;
  min?: Maybe<Contributor_Group_Min_Fields>;
};


/** aggregate fields of "risksmart.contributor_group" */
export type Contributor_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.contributor_group" */
export type Contributor_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contributor_Group_Max_Order_By>;
  min?: InputMaybe<Contributor_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.contributor_group" */
export type Contributor_Group_Arr_Rel_Insert_Input = {
  data: Array<Contributor_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contributor_Group_On_Conflict>;
};

/** columns and relationships of "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit = {
  __typename?: 'contributor_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  UserGroupId: Scalars['uuid']['output'];
};

/** aggregated selection of "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Aggregate = {
  __typename?: 'contributor_group_audit_aggregate';
  aggregate?: Maybe<Contributor_Group_Audit_Aggregate_Fields>;
  nodes: Array<Contributor_Group_Audit>;
};

export type Contributor_Group_Audit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contributor_Group_Audit_Aggregate_Bool_Exp_Count>;
};

export type Contributor_Group_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Aggregate_Fields = {
  __typename?: 'contributor_group_audit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contributor_Group_Audit_Max_Fields>;
  min?: Maybe<Contributor_Group_Audit_Min_Fields>;
};


/** aggregate fields of "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contributor_Group_Audit_Max_Order_By>;
  min?: InputMaybe<Contributor_Group_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.contributor_group_audit". All fields are combined with a logical 'AND'. */
export type Contributor_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Contributor_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Contributor_Group_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Contributor_Group_Audit_Max_Fields = {
  __typename?: 'contributor_group_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contributor_Group_Audit_Min_Fields = {
  __typename?: 'contributor_group_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.contributor_group_audit" */
export type Contributor_Group_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.contributor_group_audit". */
export type Contributor_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.contributor_group_audit" */
export const Contributor_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserGroupId: 'UserGroupId'
} as const;

export type Contributor_Group_Audit_Select_Column = typeof Contributor_Group_Audit_Select_Column[keyof typeof Contributor_Group_Audit_Select_Column];
/** Boolean expression to filter rows from the table "risksmart.contributor_group". All fields are combined with a logical 'AND'. */
export type Contributor_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Contributor_Group_Bool_Exp>>;
  _not?: InputMaybe<Contributor_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Contributor_Group_Bool_Exp>>;
  group?: InputMaybe<User_Group_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.contributor_group" */
export const Contributor_Group_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "UserGroupId" */
  ContributorGroupPkey: 'contributor_group_pkey'
} as const;

export type Contributor_Group_Constraint = typeof Contributor_Group_Constraint[keyof typeof Contributor_Group_Constraint];
/** input type for inserting data into table "risksmart.contributor_group" */
export type Contributor_Group_Insert_Input = {
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  group?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Contributor_Group_Max_Fields = {
  __typename?: 'contributor_group_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.contributor_group" */
export type Contributor_Group_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contributor_Group_Min_Fields = {
  __typename?: 'contributor_group_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.contributor_group" */
export type Contributor_Group_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.contributor_group" */
export type Contributor_Group_On_Conflict = {
  constraint: Contributor_Group_Constraint;
  update_columns?: Array<Contributor_Group_Update_Column>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.contributor_group". */
export type Contributor_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  group?: InputMaybe<User_Group_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** select columns of table "risksmart.contributor_group" */
export const Contributor_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserGroupId: 'UserGroupId'
} as const;

export type Contributor_Group_Select_Column = typeof Contributor_Group_Select_Column[keyof typeof Contributor_Group_Select_Column];
/** placeholder for update columns of table "risksmart.contributor_group" (current role has no relevant permissions) */
export const Contributor_Group_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Contributor_Group_Update_Column = typeof Contributor_Group_Update_Column[keyof typeof Contributor_Group_Update_Column];
/** input type for inserting data into table "risksmart.contributor" */
export type Contributor_Insert_Input = {
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Contributor_Max_Fields = {
  __typename?: 'contributor_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.contributor" */
export type Contributor_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contributor_Min_Fields = {
  __typename?: 'contributor_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.contributor" */
export type Contributor_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.contributor" */
export type Contributor_On_Conflict = {
  constraint: Contributor_Constraint;
  update_columns?: Array<Contributor_Update_Column>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.contributor". */
export type Contributor_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.contributor" */
export const Contributor_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Contributor_Select_Column = typeof Contributor_Select_Column[keyof typeof Contributor_Select_Column];
export const Contributor_Type_Enum = {
  /** Any */
  Any: 'any',
  /** Contributor */
  Contributor: 'contributor',
  /** Owner */
  Owner: 'owner'
} as const;

export type Contributor_Type_Enum = typeof Contributor_Type_Enum[keyof typeof Contributor_Type_Enum];
/** Boolean expression to compare columns of type "contributor_type_enum". All fields are combined with logical 'AND'. */
export type Contributor_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Contributor_Type_Enum>;
  _in?: InputMaybe<Array<Contributor_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Contributor_Type_Enum>;
  _nin?: InputMaybe<Array<Contributor_Type_Enum>>;
};

/** placeholder for update columns of table "risksmart.contributor" (current role has no relevant permissions) */
export const Contributor_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Contributor_Update_Column = typeof Contributor_Update_Column[keyof typeof Contributor_Update_Column];
/** columns and relationships of "risksmart.control" */
export type Control = {
  __typename?: 'control';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  Type?: Maybe<Control_Type_Enum>;
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  indicators: Array<Indicator_Parent>;
  /** An aggregate relationship */
  indicators_aggregate: Indicator_Parent_Aggregate;
  /** An array relationship */
  issues: Array<Issue_Parent>;
  /** An aggregate relationship */
  issues_aggregate: Issue_Parent_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  parents: Array<Control_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Control_Parent_Aggregate;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
  /** An object relationship */
  scheduleState?: Maybe<Schedule_State>;
  /** An array relationship */
  tags: Array<Tag>;
  /** An array relationship */
  testResults: Array<Test_Result>;
  /** An aggregate relationship */
  testResults_aggregate: Test_Result_Aggregate;
};


/** columns and relationships of "risksmart.control" */
export type ControlCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.control" */
export type ControlActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlIndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlIndicators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlParentsArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlTestResultsArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


/** columns and relationships of "risksmart.control" */
export type ControlTestResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};

/** aggregated selection of "risksmart.control" */
export type Control_Aggregate = {
  __typename?: 'control_aggregate';
  aggregate?: Maybe<Control_Aggregate_Fields>;
  nodes: Array<Control>;
};

/** aggregate fields of "risksmart.control" */
export type Control_Aggregate_Fields = {
  __typename?: 'control_aggregate_fields';
  avg?: Maybe<Control_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Max_Fields>;
  min?: Maybe<Control_Min_Fields>;
  stddev?: Maybe<Control_Stddev_Fields>;
  stddev_pop?: Maybe<Control_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Control_Stddev_Samp_Fields>;
  sum?: Maybe<Control_Sum_Fields>;
  var_pop?: Maybe<Control_Var_Pop_Fields>;
  var_samp?: Maybe<Control_Var_Samp_Fields>;
  variance?: Maybe<Control_Variance_Fields>;
};


/** aggregate fields of "risksmart.control" */
export type Control_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.control_audit" */
export type Control_Audit = {
  __typename?: 'control_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  Type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  actionAudits: Array<Action_Parent_Audit>;
  /** An array relationship */
  contributorAudits: Array<Contributor_Audit>;
  /** An aggregate relationship */
  contributorAudits_aggregate: Contributor_Audit_Aggregate;
  /** An array relationship */
  contributorGroupAudits: Array<Contributor_Group_Audit>;
  /** An aggregate relationship */
  contributorGroupAudits_aggregate: Contributor_Group_Audit_Aggregate;
  /** An array relationship */
  departmentAudits: Array<Department_Audit>;
  /** An array relationship */
  indicatorAudits: Array<Risksmart_Indicator_Parent_Audit>;
  /** An array relationship */
  issueAudits: Array<Issue_Parent_Audit>;
  /** An array relationship */
  ownerAudits: Array<Owner_Audit>;
  /** An array relationship */
  ownerGroupAudits: Array<Owner_Group_Audit>;
  /** An array relationship */
  testResultAudits: Array<Test_Result_Audit>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditActionAuditsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Audit_Order_By>>;
  where?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditContributorAuditsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditContributorAudits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditContributorGroupAuditsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditContributorGroupAudits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditDepartmentAuditsArgs = {
  distinct_on?: InputMaybe<Array<Department_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Audit_Order_By>>;
  where?: InputMaybe<Department_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditIndicatorAuditsArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditIssueAuditsArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Audit_Order_By>>;
  where?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditOwnerAuditsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Audit_Order_By>>;
  where?: InputMaybe<Owner_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditOwnerGroupAuditsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Audit_Order_By>>;
  where?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_audit" */
export type Control_AuditTestResultAuditsArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Audit_Order_By>>;
  where?: InputMaybe<Test_Result_Audit_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.control_audit". All fields are combined with a logical 'AND'. */
export type Control_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Audit_Bool_Exp>>;
  _not?: InputMaybe<Control_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Audit_Bool_Exp>>;
  actionAudits?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
  contributorAudits?: InputMaybe<Contributor_Audit_Bool_Exp>;
  contributorAudits_aggregate?: InputMaybe<Contributor_Audit_Aggregate_Bool_Exp>;
  contributorGroupAudits?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
  contributorGroupAudits_aggregate?: InputMaybe<Contributor_Group_Audit_Aggregate_Bool_Exp>;
  departmentAudits?: InputMaybe<Department_Audit_Bool_Exp>;
  indicatorAudits?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
  issueAudits?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
  ownerAudits?: InputMaybe<Owner_Audit_Bool_Exp>;
  ownerGroupAudits?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
  testResultAudits?: InputMaybe<Test_Result_Audit_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.control_audit". */
export type Control_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  actionAudits_aggregate?: InputMaybe<Action_Parent_Audit_Aggregate_Order_By>;
  contributorAudits_aggregate?: InputMaybe<Contributor_Audit_Aggregate_Order_By>;
  contributorGroupAudits_aggregate?: InputMaybe<Contributor_Group_Audit_Aggregate_Order_By>;
  departmentAudits_aggregate?: InputMaybe<Department_Audit_Aggregate_Order_By>;
  indicatorAudits_aggregate?: InputMaybe<Risksmart_Indicator_Parent_Audit_Aggregate_Order_By>;
  issueAudits_aggregate?: InputMaybe<Issue_Parent_Audit_Aggregate_Order_By>;
  ownerAudits_aggregate?: InputMaybe<Owner_Audit_Aggregate_Order_By>;
  ownerGroupAudits_aggregate?: InputMaybe<Owner_Group_Audit_Aggregate_Order_By>;
  testResultAudits_aggregate?: InputMaybe<Test_Result_Audit_Aggregate_Order_By>;
};

/** select columns of table "risksmart.control_audit" */
export const Control_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Control_Audit_Select_Column = typeof Control_Audit_Select_Column[keyof typeof Control_Audit_Select_Column];
/** Streaming cursor of the table "control_audit" */
export type Control_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Control_Avg_Fields = {
  __typename?: 'control_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.control". All fields are combined with a logical 'AND'. */
export type Control_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Control_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Bool_Exp>>;
  _not?: InputMaybe<Control_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  indicators?: InputMaybe<Indicator_Parent_Bool_Exp>;
  indicators_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Bool_Exp>;
  issues?: InputMaybe<Issue_Parent_Bool_Exp>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Control_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Control_Parent_Aggregate_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
  scheduleState?: InputMaybe<Schedule_State_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
  testResults?: InputMaybe<Test_Result_Bool_Exp>;
  testResults_aggregate?: InputMaybe<Test_Result_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.control" */
export const Control_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ControlPkey: 'control_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxControlOrgkeySequentialid: 'idx_control_orgkey_sequentialid'
} as const;

export type Control_Constraint = typeof Control_Constraint[keyof typeof Control_Constraint];
/** columns and relationships of "risksmart.control_group" */
export type Control_Group = {
  __typename?: 'control_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Owner: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  controls: Array<Control_Parent>;
  /** An aggregate relationship */
  controls_aggregate: Control_Parent_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  owner?: Maybe<User>;
};


/** columns and relationships of "risksmart.control_group" */
export type Control_GroupCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.control_group" */
export type Control_GroupAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_group" */
export type Control_GroupControlsArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_group" */
export type Control_GroupControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.control_group" */
export type Control_Group_Aggregate = {
  __typename?: 'control_group_aggregate';
  aggregate?: Maybe<Control_Group_Aggregate_Fields>;
  nodes: Array<Control_Group>;
};

/** aggregate fields of "risksmart.control_group" */
export type Control_Group_Aggregate_Fields = {
  __typename?: 'control_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Group_Max_Fields>;
  min?: Maybe<Control_Group_Min_Fields>;
};


/** aggregate fields of "risksmart.control_group" */
export type Control_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Control_Group_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.control_group_audit" */
export type Control_Group_Audit = {
  __typename?: 'control_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Owner: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.control_group_audit" */
export type Control_Group_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.control_group_audit". All fields are combined with a logical 'AND'. */
export type Control_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Owner?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<Control_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Group_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.control_group_audit". */
export type Control_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Owner?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.control_group_audit" */
export const Control_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Owner: 'Owner',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Group_Audit_Select_Column = typeof Control_Group_Audit_Select_Column[keyof typeof Control_Group_Audit_Select_Column];
/** Streaming cursor of the table "control_group_audit" */
export type Control_Group_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Group_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Group_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Owner?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.control_group". All fields are combined with a logical 'AND'. */
export type Control_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Owner?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Group_Bool_Exp>>;
  _not?: InputMaybe<Control_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Group_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  controls?: InputMaybe<Control_Parent_Bool_Exp>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  owner?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.control_group" */
export const Control_Group_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ControlGroupPkey: 'control_group_pkey',
  /** unique or primary key constraint on columns "OrgKey", "Title" */
  IxControlGroupOrgkeyTitle: 'ix_control_group_orgkey_title'
} as const;

export type Control_Group_Constraint = typeof Control_Group_Constraint[keyof typeof Control_Group_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Control_Group_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Control_Group_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Control_Group_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.control_group" */
export type Control_Group_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Owner?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  controls?: InputMaybe<Control_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Control_Group_Max_Fields = {
  __typename?: 'control_group_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Control_Group_Min_Fields = {
  __typename?: 'control_group_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.control_group" */
export type Control_Group_Mutation_Response = {
  __typename?: 'control_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Group>;
};

/** input type for inserting object relation for remote table "risksmart.control_group" */
export type Control_Group_Obj_Rel_Insert_Input = {
  data: Control_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Group_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.control_group" */
export type Control_Group_On_Conflict = {
  constraint: Control_Group_Constraint;
  update_columns?: Array<Control_Group_Update_Column>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.control_group". */
export type Control_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Owner?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  owner?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: risksmart.control_group */
export type Control_Group_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Control_Group_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.control_group" */
export const Control_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Owner: 'Owner',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Group_Select_Column = typeof Control_Group_Select_Column[keyof typeof Control_Group_Select_Column];
/** input type for updating data in table "risksmart.control_group" */
export type Control_Group_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Owner?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "control_group" */
export type Control_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Group_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Owner?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.control_group" */
export const Control_Group_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Owner: 'Owner',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Group_Update_Column = typeof Control_Group_Update_Column[keyof typeof Control_Group_Update_Column];
export type Control_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Control_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Control_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Control_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Control_Group_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Control_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Control_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Control_Group_Bool_Exp;
};

/** input type for inserting data into table "risksmart.control" */
export type Control_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Control_Type_Enum>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  indicators?: InputMaybe<Indicator_Parent_Arr_Rel_Insert_Input>;
  issues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Control_Parent_Arr_Rel_Insert_Input>;
  schedule?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
  testResults?: InputMaybe<Test_Result_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Control_Max_Fields = {
  __typename?: 'control_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Control_Min_Fields = {
  __typename?: 'control_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.control" */
export type Control_Mutation_Response = {
  __typename?: 'control_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control>;
};

/** input type for inserting object relation for remote table "risksmart.control" */
export type Control_Obj_Rel_Insert_Input = {
  data: Control_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.control" */
export type Control_On_Conflict = {
  constraint: Control_Constraint;
  update_columns?: Array<Control_Update_Column>;
  where?: InputMaybe<Control_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.control". */
export type Control_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  indicators_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Order_By>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Control_Parent_Aggregate_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
  scheduleState?: InputMaybe<Schedule_State_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
  testResults_aggregate?: InputMaybe<Test_Result_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.control_parent" */
export type Control_Parent = {
  __typename?: 'control_parent';
  ControlId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  group?: Maybe<Control_Group>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
};

/** aggregated selection of "risksmart.control_parent" */
export type Control_Parent_Aggregate = {
  __typename?: 'control_parent_aggregate';
  aggregate?: Maybe<Control_Parent_Aggregate_Fields>;
  nodes: Array<Control_Parent>;
};

export type Control_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Control_Parent_Aggregate_Bool_Exp_Count>;
};

export type Control_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Control_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Control_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.control_parent" */
export type Control_Parent_Aggregate_Fields = {
  __typename?: 'control_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Parent_Max_Fields>;
  min?: Maybe<Control_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.control_parent" */
export type Control_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.control_parent" */
export type Control_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Parent_Max_Order_By>;
  min?: InputMaybe<Control_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.control_parent" */
export type Control_Parent_Arr_Rel_Insert_Input = {
  data: Array<Control_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.control_parent_audit" */
export type Control_Parent_Audit = {
  __typename?: 'control_parent_audit';
  ControlId: Scalars['uuid']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risksmart.control_parent_audit" */
export type Control_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Control_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Control_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.control_parent_audit". All fields are combined with a logical 'AND'. */
export type Control_Parent_Audit_Bool_Exp = {
  ControlId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.control_parent_audit" */
export type Control_Parent_Audit_Max_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.control_parent_audit" */
export type Control_Parent_Audit_Min_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.control_parent_audit". */
export type Control_Parent_Audit_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.control_parent_audit" */
export const Control_Parent_Audit_Select_Column = {
  /** column name */
  ControlId: 'ControlId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Control_Parent_Audit_Select_Column = typeof Control_Parent_Audit_Select_Column[keyof typeof Control_Parent_Audit_Select_Column];
/** Streaming cursor of the table "control_parent_audit" */
export type Control_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Parent_Audit_Stream_Cursor_Value_Input = {
  ControlId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.control_parent". All fields are combined with a logical 'AND'. */
export type Control_Parent_Bool_Exp = {
  ControlId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Parent_Bool_Exp>>;
  _not?: InputMaybe<Control_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Parent_Bool_Exp>>;
  control?: InputMaybe<Control_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  group?: InputMaybe<Control_Group_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.control_parent" */
export const Control_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "ControlId" */
  ControlParentPkey: 'control_parent_pkey'
} as const;

export type Control_Parent_Constraint = typeof Control_Parent_Constraint[keyof typeof Control_Parent_Constraint];
/** input type for inserting data into table "risksmart.control_parent" */
export type Control_Parent_Insert_Input = {
  ControlId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  group?: InputMaybe<Control_Group_Obj_Rel_Insert_Input>;
  obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Control_Parent_Max_Fields = {
  __typename?: 'control_parent_max_fields';
  ControlId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.control_parent" */
export type Control_Parent_Max_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Control_Parent_Min_Fields = {
  __typename?: 'control_parent_min_fields';
  ControlId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.control_parent" */
export type Control_Parent_Min_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.control_parent" */
export type Control_Parent_Mutation_Response = {
  __typename?: 'control_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Parent>;
};

/** on_conflict condition type for table "risksmart.control_parent" */
export type Control_Parent_On_Conflict = {
  constraint: Control_Parent_Constraint;
  update_columns?: Array<Control_Parent_Update_Column>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.control_parent". */
export type Control_Parent_Order_By = {
  ControlId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  control?: InputMaybe<Control_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  group?: InputMaybe<Control_Group_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
};

/** select columns of table "risksmart.control_parent" */
export const Control_Parent_Select_Column = {
  /** column name */
  ControlId: 'ControlId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Control_Parent_Select_Column = typeof Control_Parent_Select_Column[keyof typeof Control_Parent_Select_Column];
/** Streaming cursor of the table "control_parent" */
export type Control_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Parent_Stream_Cursor_Value_Input = {
  ControlId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.control_parent" (current role has no relevant permissions) */
export const Control_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Control_Parent_Update_Column = typeof Control_Parent_Update_Column[keyof typeof Control_Parent_Update_Column];
/** select columns of table "risksmart.control" */
export const Control_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Control_Select_Column = typeof Control_Select_Column[keyof typeof Control_Select_Column];
/** aggregate stddev on columns */
export type Control_Stddev_Fields = {
  __typename?: 'control_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Control_Stddev_Pop_Fields = {
  __typename?: 'control_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Control_Stddev_Samp_Fields = {
  __typename?: 'control_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "control" */
export type Control_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Control_Type_Enum>;
};

/** aggregate sum on columns */
export type Control_Sum_Fields = {
  __typename?: 'control_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result = {
  __typename?: 'control_test_internal_audit_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId: Scalars['uuid']['output'];
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId: Scalars['Int']['output'];
  Submitter: Scalars['String']['output'];
  TestDate: Scalars['timestamptz']['output'];
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Control>;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
  /** An object relationship */
  submitter?: Maybe<User>;
};


/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Aggregate = {
  __typename?: 'control_test_internal_audit_result_aggregate';
  aggregate?: Maybe<Control_Test_Internal_Audit_Result_Aggregate_Fields>;
  nodes: Array<Control_Test_Internal_Audit_Result>;
};

/** aggregate fields of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Aggregate_Fields = {
  __typename?: 'control_test_internal_audit_result_aggregate_fields';
  avg?: Maybe<Control_Test_Internal_Audit_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Test_Internal_Audit_Result_Max_Fields>;
  min?: Maybe<Control_Test_Internal_Audit_Result_Min_Fields>;
  stddev?: Maybe<Control_Test_Internal_Audit_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Control_Test_Internal_Audit_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Control_Test_Internal_Audit_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Control_Test_Internal_Audit_Result_Sum_Fields>;
  var_pop?: Maybe<Control_Test_Internal_Audit_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Control_Test_Internal_Audit_Result_Var_Samp_Fields>;
  variance?: Maybe<Control_Test_Internal_Audit_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Control_Test_Internal_Audit_Result_Avg_Fields = {
  __typename?: 'control_test_internal_audit_result_avg_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.control_test_internal_audit_result". All fields are combined with a logical 'AND'. */
export type Control_Test_Internal_Audit_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DesignEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OverallEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  ParentControlId?: InputMaybe<Uuid_Comparison_Exp>;
  PerformanceEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Submitter?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TestType?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Bool_Exp>>;
  _not?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Control_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
  submitter?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.control_test_internal_audit_result" */
export const Control_Test_Internal_Audit_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ControlTestInternalAuditResultPkey: 'control_test_internal_audit_result_pkey'
} as const;

export type Control_Test_Internal_Audit_Result_Constraint = typeof Control_Test_Internal_Audit_Result_Constraint[keyof typeof Control_Test_Internal_Audit_Result_Constraint];
/** input type for inserting data into table "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Control_Test_Internal_Audit_Result_Max_Fields = {
  __typename?: 'control_test_internal_audit_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Control_Test_Internal_Audit_Result_Min_Fields = {
  __typename?: 'control_test_internal_audit_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Mutation_Response = {
  __typename?: 'control_test_internal_audit_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Test_Internal_Audit_Result>;
};

/** input type for inserting object relation for remote table "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Obj_Rel_Insert_Input = {
  data: Control_Test_Internal_Audit_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Control_Test_Internal_Audit_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_On_Conflict = {
  constraint: Control_Test_Internal_Audit_Result_Constraint;
  update_columns?: Array<Control_Test_Internal_Audit_Result_Update_Column>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.control_test_internal_audit_result". */
export type Control_Test_Internal_Audit_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Control_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
  submitter?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.control_test_internal_audit_result" */
export const Control_Test_Internal_Audit_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Test_Internal_Audit_Result_Select_Column = typeof Control_Test_Internal_Audit_Result_Select_Column[keyof typeof Control_Test_Internal_Audit_Result_Select_Column];
/** aggregate stddev on columns */
export type Control_Test_Internal_Audit_Result_Stddev_Fields = {
  __typename?: 'control_test_internal_audit_result_stddev_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Control_Test_Internal_Audit_Result_Stddev_Pop_Fields = {
  __typename?: 'control_test_internal_audit_result_stddev_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Control_Test_Internal_Audit_Result_Stddev_Samp_Fields = {
  __typename?: 'control_test_internal_audit_result_stddev_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "control_test_internal_audit_result" */
export type Control_Test_Internal_Audit_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Test_Internal_Audit_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Test_Internal_Audit_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Control_Test_Internal_Audit_Result_Sum_Fields = {
  __typename?: 'control_test_internal_audit_result_sum_fields';
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.control_test_internal_audit_result" */
export const Control_Test_Internal_Audit_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Test_Internal_Audit_Result_Update_Column = typeof Control_Test_Internal_Audit_Result_Update_Column[keyof typeof Control_Test_Internal_Audit_Result_Update_Column];
/** aggregate var_pop on columns */
export type Control_Test_Internal_Audit_Result_Var_Pop_Fields = {
  __typename?: 'control_test_internal_audit_result_var_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Control_Test_Internal_Audit_Result_Var_Samp_Fields = {
  __typename?: 'control_test_internal_audit_result_var_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Control_Test_Internal_Audit_Result_Variance_Fields = {
  __typename?: 'control_test_internal_audit_result_variance_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_Result = {
  __typename?: 'control_test_second_line_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId: Scalars['uuid']['output'];
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId: Scalars['Int']['output'];
  Submitter: Scalars['String']['output'];
  TestDate: Scalars['timestamptz']['output'];
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Control>;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
  /** An object relationship */
  submitter?: Maybe<User>;
};


/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_Result_Aggregate = {
  __typename?: 'control_test_second_line_result_aggregate';
  aggregate?: Maybe<Control_Test_Second_Line_Result_Aggregate_Fields>;
  nodes: Array<Control_Test_Second_Line_Result>;
};

/** aggregate fields of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_Result_Aggregate_Fields = {
  __typename?: 'control_test_second_line_result_aggregate_fields';
  avg?: Maybe<Control_Test_Second_Line_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Control_Test_Second_Line_Result_Max_Fields>;
  min?: Maybe<Control_Test_Second_Line_Result_Min_Fields>;
  stddev?: Maybe<Control_Test_Second_Line_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Control_Test_Second_Line_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Control_Test_Second_Line_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Control_Test_Second_Line_Result_Sum_Fields>;
  var_pop?: Maybe<Control_Test_Second_Line_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Control_Test_Second_Line_Result_Var_Samp_Fields>;
  variance?: Maybe<Control_Test_Second_Line_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Control_Test_Second_Line_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Control_Test_Second_Line_Result_Avg_Fields = {
  __typename?: 'control_test_second_line_result_avg_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.control_test_second_line_result". All fields are combined with a logical 'AND'. */
export type Control_Test_Second_Line_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DesignEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OverallEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  ParentControlId?: InputMaybe<Uuid_Comparison_Exp>;
  PerformanceEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Submitter?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TestType?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Control_Test_Second_Line_Result_Bool_Exp>>;
  _not?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Control_Test_Second_Line_Result_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Control_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
  submitter?: InputMaybe<User_Bool_Exp>;
};

/** aggregate max on columns */
export type Control_Test_Second_Line_Result_Max_Fields = {
  __typename?: 'control_test_second_line_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Control_Test_Second_Line_Result_Min_Fields = {
  __typename?: 'control_test_second_line_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.control_test_second_line_result" */
export type Control_Test_Second_Line_Result_Mutation_Response = {
  __typename?: 'control_test_second_line_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Control_Test_Second_Line_Result>;
};

/** Ordering options when selecting data from "risksmart.control_test_second_line_result". */
export type Control_Test_Second_Line_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Control_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
  submitter?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.control_test_second_line_result" */
export const Control_Test_Second_Line_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Control_Test_Second_Line_Result_Select_Column = typeof Control_Test_Second_Line_Result_Select_Column[keyof typeof Control_Test_Second_Line_Result_Select_Column];
/** aggregate stddev on columns */
export type Control_Test_Second_Line_Result_Stddev_Fields = {
  __typename?: 'control_test_second_line_result_stddev_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Control_Test_Second_Line_Result_Stddev_Pop_Fields = {
  __typename?: 'control_test_second_line_result_stddev_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Control_Test_Second_Line_Result_Stddev_Samp_Fields = {
  __typename?: 'control_test_second_line_result_stddev_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "control_test_second_line_result" */
export type Control_Test_Second_Line_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Control_Test_Second_Line_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Control_Test_Second_Line_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Control_Test_Second_Line_Result_Sum_Fields = {
  __typename?: 'control_test_second_line_result_sum_fields';
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Control_Test_Second_Line_Result_Var_Pop_Fields = {
  __typename?: 'control_test_second_line_result_var_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Control_Test_Second_Line_Result_Var_Samp_Fields = {
  __typename?: 'control_test_second_line_result_var_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Control_Test_Second_Line_Result_Variance_Fields = {
  __typename?: 'control_test_second_line_result_variance_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

export const Control_Type_Enum = {
  /** Corrective */
  Corrective: 'Corrective',
  /** Detective */
  Detective: 'Detective',
  /** Directive */
  Directive: 'Directive',
  /** Preventive */
  Preventive: 'Preventive'
} as const;

export type Control_Type_Enum = typeof Control_Type_Enum[keyof typeof Control_Type_Enum];
/** Boolean expression to compare columns of type "control_type_enum". All fields are combined with logical 'AND'. */
export type Control_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Control_Type_Enum>;
  _in?: InputMaybe<Array<Control_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Control_Type_Enum>;
  _nin?: InputMaybe<Array<Control_Type_Enum>>;
};

/** update columns of table "risksmart.control" */
export const Control_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Control_Update_Column = typeof Control_Update_Column[keyof typeof Control_Update_Column];
/** aggregate var_pop on columns */
export type Control_Var_Pop_Fields = {
  __typename?: 'control_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Control_Var_Samp_Fields = {
  __typename?: 'control_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Control_Variance_Fields = {
  __typename?: 'control_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.conversation" */
export type Conversation = {
  __typename?: 'conversation';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  IsResolved?: Maybe<Scalars['Boolean']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<Comment>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
};


/** columns and relationships of "risksmart.conversation" */
export type ConversationCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};

/** columns and relationships of "risksmart.conversation_audit" */
export type Conversation_Audit = {
  __typename?: 'conversation_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  IsResolved?: Maybe<Scalars['Boolean']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.conversation_audit". All fields are combined with a logical 'AND'. */
export type Conversation_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsResolved?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Conversation_Audit_Bool_Exp>>;
  _not?: InputMaybe<Conversation_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Conversation_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.conversation_audit". */
export type Conversation_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsResolved?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.conversation_audit" */
export const Conversation_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  IsResolved: 'IsResolved',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Conversation_Audit_Select_Column = typeof Conversation_Audit_Select_Column[keyof typeof Conversation_Audit_Select_Column];
/** Streaming cursor of the table "conversation_audit" */
export type Conversation_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Conversation_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conversation_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.conversation". All fields are combined with a logical 'AND'. */
export type Conversation_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsResolved?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Conversation_Bool_Exp>>;
  _not?: InputMaybe<Conversation_Bool_Exp>;
  _or?: InputMaybe<Array<Conversation_Bool_Exp>>;
  comments?: InputMaybe<Comment_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.conversation" */
export const Conversation_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ConversationPkey: 'conversation_pkey'
} as const;

export type Conversation_Constraint = typeof Conversation_Constraint[keyof typeof Conversation_Constraint];
/** input type for inserting data into table "risksmart.conversation" */
export type Conversation_Insert_Input = {
  IsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Comment_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.conversation" */
export type Conversation_Mutation_Response = {
  __typename?: 'conversation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Conversation>;
};

/** input type for inserting object relation for remote table "risksmart.conversation" */
export type Conversation_Obj_Rel_Insert_Input = {
  data: Conversation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Conversation_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.conversation" */
export type Conversation_On_Conflict = {
  constraint: Conversation_Constraint;
  update_columns?: Array<Conversation_Update_Column>;
  where?: InputMaybe<Conversation_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.conversation". */
export type Conversation_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsResolved?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
};

/** primary key columns input for table: risksmart.conversation */
export type Conversation_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.conversation" */
export const Conversation_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  IsResolved: 'IsResolved',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Conversation_Select_Column = typeof Conversation_Select_Column[keyof typeof Conversation_Select_Column];
/** input type for updating data in table "risksmart.conversation" */
export type Conversation_Set_Input = {
  IsResolved?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "conversation" */
export type Conversation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Conversation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conversation_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risksmart.conversation" */
export const Conversation_Update_Column = {
  /** column name */
  IsResolved: 'IsResolved'
} as const;

export type Conversation_Update_Column = typeof Conversation_Update_Column[keyof typeof Conversation_Update_Column];
export type Conversation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Conversation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Conversation_Bool_Exp;
};

export const Cost_Type_Enum = {
  /** Customers impacted */
  CustomersImpacted: 'customers_impacted',
  /** Financial */
  Financial: 'financial',
  /** Hours */
  Hours: 'hours',
  /** Number */
  Number: 'number'
} as const;

export type Cost_Type_Enum = typeof Cost_Type_Enum[keyof typeof Cost_Type_Enum];
/** Boolean expression to compare columns of type "cost_type_enum". All fields are combined with logical 'AND'. */
export type Cost_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cost_Type_Enum>;
  _in?: InputMaybe<Array<Cost_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cost_Type_Enum>;
  _nin?: InputMaybe<Array<Cost_Type_Enum>>;
};

/** ordering argument of a cursor */
export const Cursor_Ordering = {
  /** ascending ordering of the cursor */
  Asc: 'ASC',
  /** descending ordering of the cursor */
  Desc: 'DESC'
} as const;

export type Cursor_Ordering = typeof Cursor_Ordering[keyof typeof Cursor_Ordering];
/** columns and relationships of "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema = {
  __typename?: 'custom_attribute_schema';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Schema: Scalars['jsonb']['output'];
  UiSchema: Scalars['jsonb']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  form?: Maybe<Form_Configuration>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};


/** columns and relationships of "risksmart.custom_attribute_schema" */
export type Custom_Attribute_SchemaSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.custom_attribute_schema" */
export type Custom_Attribute_SchemaUiSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Custom_Attribute_Schema_Append_Input = {
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.custom_attribute_schema_audit" */
export type Custom_Attribute_Schema_Audit = {
  __typename?: 'custom_attribute_schema_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Schema: Scalars['jsonb']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  UiSchema: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.custom_attribute_schema_audit" */
export type Custom_Attribute_Schema_AuditSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.custom_attribute_schema_audit" */
export type Custom_Attribute_Schema_AuditUiSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_attribute_schema_audit". All fields are combined with a logical 'AND'. */
export type Custom_Attribute_Schema_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Schema?: InputMaybe<Jsonb_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  UiSchema?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Bool_Exp>>;
  _not?: InputMaybe<Custom_Attribute_Schema_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.custom_attribute_schema_audit". */
export type Custom_Attribute_Schema_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Schema?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  UiSchema?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.custom_attribute_schema_audit" */
export const Custom_Attribute_Schema_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Schema: 'Schema',
  /** column name */
  Title: 'Title',
  /** column name */
  UiSchema: 'UiSchema'
} as const;

export type Custom_Attribute_Schema_Audit_Select_Column = typeof Custom_Attribute_Schema_Audit_Select_Column[keyof typeof Custom_Attribute_Schema_Audit_Select_Column];
/** Streaming cursor of the table "custom_attribute_schema_audit" */
export type Custom_Attribute_Schema_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Attribute_Schema_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Attribute_Schema_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_attribute_schema". All fields are combined with a logical 'AND'. */
export type Custom_Attribute_Schema_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Schema?: InputMaybe<Jsonb_Comparison_Exp>;
  UiSchema?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Attribute_Schema_Bool_Exp>>;
  _not?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Attribute_Schema_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  form?: InputMaybe<Form_Configuration_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.custom_attribute_schema" */
export const Custom_Attribute_Schema_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  CustomAttributeSchemaPkey: 'custom_attribute_schema_pkey'
} as const;

export type Custom_Attribute_Schema_Constraint = typeof Custom_Attribute_Schema_Constraint[keyof typeof Custom_Attribute_Schema_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Custom_Attribute_Schema_Delete_At_Path_Input = {
  Schema?: InputMaybe<Array<Scalars['String']['input']>>;
  UiSchema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Custom_Attribute_Schema_Delete_Elem_Input = {
  Schema?: InputMaybe<Scalars['Int']['input']>;
  UiSchema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Custom_Attribute_Schema_Delete_Key_Input = {
  Schema?: InputMaybe<Scalars['String']['input']>;
  UiSchema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
  form?: InputMaybe<Form_Configuration_Obj_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema_Mutation_Response = {
  __typename?: 'custom_attribute_schema_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Attribute_Schema>;
};

/** input type for inserting object relation for remote table "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema_Obj_Rel_Insert_Input = {
  data: Custom_Attribute_Schema_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Attribute_Schema_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema_On_Conflict = {
  constraint: Custom_Attribute_Schema_Constraint;
  update_columns?: Array<Custom_Attribute_Schema_Update_Column>;
  where?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.custom_attribute_schema". */
export type Custom_Attribute_Schema_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Schema?: InputMaybe<Order_By>;
  UiSchema?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  form?: InputMaybe<Form_Configuration_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: risksmart.custom_attribute_schema */
export type Custom_Attribute_Schema_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Custom_Attribute_Schema_Prepend_Input = {
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.custom_attribute_schema" */
export const Custom_Attribute_Schema_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Schema: 'Schema',
  /** column name */
  UiSchema: 'UiSchema'
} as const;

export type Custom_Attribute_Schema_Select_Column = typeof Custom_Attribute_Schema_Select_Column[keyof typeof Custom_Attribute_Schema_Select_Column];
/** input type for updating data in table "risksmart.custom_attribute_schema" */
export type Custom_Attribute_Schema_Set_Input = {
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "custom_attribute_schema" */
export type Custom_Attribute_Schema_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Attribute_Schema_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Attribute_Schema_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UiSchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.custom_attribute_schema" */
export const Custom_Attribute_Schema_Update_Column = {
  /** column name */
  Schema: 'Schema',
  /** column name */
  UiSchema: 'UiSchema'
} as const;

export type Custom_Attribute_Schema_Update_Column = typeof Custom_Attribute_Schema_Update_Column[keyof typeof Custom_Attribute_Schema_Update_Column];
export type Custom_Attribute_Schema_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Custom_Attribute_Schema_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Custom_Attribute_Schema_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Custom_Attribute_Schema_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Custom_Attribute_Schema_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Custom_Attribute_Schema_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Attribute_Schema_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Attribute_Schema_Bool_Exp;
};

/** columns and relationships of "risksmart.custom_datasource" */
export type Custom_Datasource = {
  __typename?: 'custom_datasource';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Datasources: Scalars['jsonb']['output'];
  Fields?: Maybe<Scalars['jsonb']['output']>;
  Filters?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.custom_datasource" */
export type Custom_DatasourceDatasourcesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.custom_datasource" */
export type Custom_DatasourceFieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.custom_datasource" */
export type Custom_DatasourceFiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Custom_Datasource_Append_Input = {
  Datasources?: InputMaybe<Scalars['jsonb']['input']>;
  Fields?: InputMaybe<Scalars['jsonb']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_datasource". All fields are combined with a logical 'AND'. */
export type Custom_Datasource_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Datasources?: InputMaybe<Jsonb_Comparison_Exp>;
  Fields?: InputMaybe<Jsonb_Comparison_Exp>;
  Filters?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Datasource_Bool_Exp>>;
  _not?: InputMaybe<Custom_Datasource_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Datasource_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.custom_datasource" */
export const Custom_Datasource_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  CustomDatasourcePkey: 'custom_datasource_pkey'
} as const;

export type Custom_Datasource_Constraint = typeof Custom_Datasource_Constraint[keyof typeof Custom_Datasource_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Custom_Datasource_Delete_At_Path_Input = {
  Datasources?: InputMaybe<Array<Scalars['String']['input']>>;
  Fields?: InputMaybe<Array<Scalars['String']['input']>>;
  Filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Custom_Datasource_Delete_Elem_Input = {
  Datasources?: InputMaybe<Scalars['Int']['input']>;
  Fields?: InputMaybe<Scalars['Int']['input']>;
  Filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Custom_Datasource_Delete_Key_Input = {
  Datasources?: InputMaybe<Scalars['String']['input']>;
  Fields?: InputMaybe<Scalars['String']['input']>;
  Filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.custom_datasource" */
export type Custom_Datasource_Insert_Input = {
  Datasources?: InputMaybe<Scalars['jsonb']['input']>;
  Fields?: InputMaybe<Scalars['jsonb']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "risksmart.custom_datasource" */
export type Custom_Datasource_Mutation_Response = {
  __typename?: 'custom_datasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Datasource>;
};

/** on_conflict condition type for table "risksmart.custom_datasource" */
export type Custom_Datasource_On_Conflict = {
  constraint: Custom_Datasource_Constraint;
  update_columns?: Array<Custom_Datasource_Update_Column>;
  where?: InputMaybe<Custom_Datasource_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.custom_datasource". */
export type Custom_Datasource_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Datasources?: InputMaybe<Order_By>;
  Fields?: InputMaybe<Order_By>;
  Filters?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.custom_datasource */
export type Custom_Datasource_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Custom_Datasource_Prepend_Input = {
  Datasources?: InputMaybe<Scalars['jsonb']['input']>;
  Fields?: InputMaybe<Scalars['jsonb']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.custom_datasource" */
export const Custom_Datasource_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Datasources: 'Datasources',
  /** column name */
  Fields: 'Fields',
  /** column name */
  Filters: 'Filters',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Title: 'Title'
} as const;

export type Custom_Datasource_Select_Column = typeof Custom_Datasource_Select_Column[keyof typeof Custom_Datasource_Select_Column];
/** input type for updating data in table "risksmart.custom_datasource" */
export type Custom_Datasource_Set_Input = {
  Datasources?: InputMaybe<Scalars['jsonb']['input']>;
  Fields?: InputMaybe<Scalars['jsonb']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_datasource" */
export type Custom_Datasource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Datasource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Datasource_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Datasources?: InputMaybe<Scalars['jsonb']['input']>;
  Fields?: InputMaybe<Scalars['jsonb']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.custom_datasource" */
export const Custom_Datasource_Update_Column = {
  /** column name */
  Datasources: 'Datasources',
  /** column name */
  Fields: 'Fields',
  /** column name */
  Filters: 'Filters',
  /** column name */
  Title: 'Title'
} as const;

export type Custom_Datasource_Update_Column = typeof Custom_Datasource_Update_Column[keyof typeof Custom_Datasource_Update_Column];
export type Custom_Datasource_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Custom_Datasource_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Custom_Datasource_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Custom_Datasource_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Custom_Datasource_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Custom_Datasource_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Datasource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Datasource_Bool_Exp;
};

/** columns and relationships of "risksmart.custom_ribbon" */
export type Custom_Ribbon = {
  __typename?: 'custom_ribbon';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Filters: Scalars['jsonb']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentType: Parent_Type_Enum;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};


/** columns and relationships of "risksmart.custom_ribbon" */
export type Custom_RibbonFiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Custom_Ribbon_Append_Input = {
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.custom_ribbon_audit" */
export type Custom_Ribbon_Audit = {
  __typename?: 'custom_ribbon_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Filters: Scalars['jsonb']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentType: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.custom_ribbon_audit" */
export type Custom_Ribbon_AuditFiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_ribbon_audit". All fields are combined with a logical 'AND'. */
export type Custom_Ribbon_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Filters?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Ribbon_Audit_Bool_Exp>>;
  _not?: InputMaybe<Custom_Ribbon_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Ribbon_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.custom_ribbon_audit". */
export type Custom_Ribbon_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Filters?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.custom_ribbon_audit" */
export const Custom_Ribbon_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Filters: 'Filters',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Custom_Ribbon_Audit_Select_Column = typeof Custom_Ribbon_Audit_Select_Column[keyof typeof Custom_Ribbon_Audit_Select_Column];
/** Streaming cursor of the table "custom_ribbon_audit" */
export type Custom_Ribbon_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Ribbon_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Ribbon_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_ribbon". All fields are combined with a logical 'AND'. */
export type Custom_Ribbon_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Filters?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Ribbon_Bool_Exp>>;
  _not?: InputMaybe<Custom_Ribbon_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Ribbon_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.custom_ribbon" */
export const Custom_Ribbon_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  CustomRibbonPkey: 'custom_ribbon_pkey',
  /** unique or primary key constraint on columns "OrgKey", "ParentType" */
  IdxCustomribbonOrgkeyParenttype: 'idx_customribbon_orgkey_parenttype'
} as const;

export type Custom_Ribbon_Constraint = typeof Custom_Ribbon_Constraint[keyof typeof Custom_Ribbon_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Custom_Ribbon_Delete_At_Path_Input = {
  Filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Custom_Ribbon_Delete_Elem_Input = {
  Filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Custom_Ribbon_Delete_Key_Input = {
  Filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.custom_ribbon" */
export type Custom_Ribbon_Insert_Input = {
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** response of any mutation on the table "risksmart.custom_ribbon" */
export type Custom_Ribbon_Mutation_Response = {
  __typename?: 'custom_ribbon_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Ribbon>;
};

/** on_conflict condition type for table "risksmart.custom_ribbon" */
export type Custom_Ribbon_On_Conflict = {
  constraint: Custom_Ribbon_Constraint;
  update_columns?: Array<Custom_Ribbon_Update_Column>;
  where?: InputMaybe<Custom_Ribbon_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.custom_ribbon". */
export type Custom_Ribbon_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Filters?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: risksmart.custom_ribbon */
export type Custom_Ribbon_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Custom_Ribbon_Prepend_Input = {
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.custom_ribbon" */
export const Custom_Ribbon_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Filters: 'Filters',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Custom_Ribbon_Select_Column = typeof Custom_Ribbon_Select_Column[keyof typeof Custom_Ribbon_Select_Column];
/** input type for updating data in table "risksmart.custom_ribbon" */
export type Custom_Ribbon_Set_Input = {
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "custom_ribbon" */
export type Custom_Ribbon_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Ribbon_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Ribbon_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Filters?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** update columns of table "risksmart.custom_ribbon" */
export const Custom_Ribbon_Update_Column = {
  /** column name */
  Filters: 'Filters'
} as const;

export type Custom_Ribbon_Update_Column = typeof Custom_Ribbon_Update_Column[keyof typeof Custom_Ribbon_Update_Column];
export type Custom_Ribbon_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Custom_Ribbon_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Custom_Ribbon_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Custom_Ribbon_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Custom_Ribbon_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Custom_Ribbon_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Ribbon_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Ribbon_Bool_Exp;
};

/** columns and relationships of "risksmart.custom_role" */
export type Custom_Role = {
  __typename?: 'custom_role';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleName: Scalars['String']['output'];
  /** An array relationship */
  customRoleAssignments: Array<Custom_Role_Assignment>;
  /** An aggregate relationship */
  customRoleAssignments_aggregate: Custom_Role_Assignment_Aggregate;
  /** An array relationship */
  customRoleUsers: Array<Custom_Role_User>;
  /** An aggregate relationship */
  customRoleUsers_aggregate: Custom_Role_User_Aggregate;
};


/** columns and relationships of "risksmart.custom_role" */
export type Custom_RoleCustomRoleAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


/** columns and relationships of "risksmart.custom_role" */
export type Custom_RoleCustomRoleAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


/** columns and relationships of "risksmart.custom_role" */
export type Custom_RoleCustomRoleUsersArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


/** columns and relationships of "risksmart.custom_role" */
export type Custom_RoleCustomRoleUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};

/** aggregated selection of "risksmart.custom_role" */
export type Custom_Role_Aggregate = {
  __typename?: 'custom_role_aggregate';
  aggregate?: Maybe<Custom_Role_Aggregate_Fields>;
  nodes: Array<Custom_Role>;
};

/** aggregate fields of "risksmart.custom_role" */
export type Custom_Role_Aggregate_Fields = {
  __typename?: 'custom_role_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Role_Max_Fields>;
  min?: Maybe<Custom_Role_Min_Fields>;
};


/** aggregate fields of "risksmart.custom_role" */
export type Custom_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment = {
  __typename?: 'custom_role_assignment';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId: Scalars['uuid']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleTypeKey: Scalars['String']['output'];
  /** An object relationship */
  roleType: Auth_Role_Type;
};

/** aggregated selection of "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Aggregate = {
  __typename?: 'custom_role_assignment_aggregate';
  aggregate?: Maybe<Custom_Role_Assignment_Aggregate_Fields>;
  nodes: Array<Custom_Role_Assignment>;
};

export type Custom_Role_Assignment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Custom_Role_Assignment_Aggregate_Bool_Exp_Count>;
};

export type Custom_Role_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Aggregate_Fields = {
  __typename?: 'custom_role_assignment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Role_Assignment_Max_Fields>;
  min?: Maybe<Custom_Role_Assignment_Min_Fields>;
};


/** aggregate fields of "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Custom_Role_Assignment_Max_Order_By>;
  min?: InputMaybe<Custom_Role_Assignment_Min_Order_By>;
};

/** columns and relationships of "risksmart.custom_role_assignment_audit" */
export type Custom_Role_Assignment_Audit = {
  __typename?: 'custom_role_assignment_audit';
  Action: Scalars['String']['output'];
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId: Scalars['uuid']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleTypeKey: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.custom_role_assignment_audit". All fields are combined with a logical 'AND'. */
export type Custom_Role_Assignment_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RoleTypeKey?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_Assignment_Audit_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_Assignment_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_Assignment_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.custom_role_assignment_audit". */
export type Custom_Role_Assignment_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleTypeKey?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.custom_role_assignment_audit" */
export const Custom_Role_Assignment_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomRoleId: 'CustomRoleId',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RoleTypeKey: 'RoleTypeKey'
} as const;

export type Custom_Role_Assignment_Audit_Select_Column = typeof Custom_Role_Assignment_Audit_Select_Column[keyof typeof Custom_Role_Assignment_Audit_Select_Column];
/** Streaming cursor of the table "custom_role_assignment_audit" */
export type Custom_Role_Assignment_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_Assignment_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_Assignment_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomRoleId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RoleTypeKey?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_role_assignment". All fields are combined with a logical 'AND'. */
export type Custom_Role_Assignment_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RoleTypeKey?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_Assignment_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_Assignment_Bool_Exp>>;
  roleType?: InputMaybe<Auth_Role_Type_Bool_Exp>;
};

/** aggregate max on columns */
export type Custom_Role_Assignment_Max_Fields = {
  __typename?: 'custom_role_assignment_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleTypeKey?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleTypeKey?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Role_Assignment_Min_Fields = {
  __typename?: 'custom_role_assignment_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleTypeKey?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleTypeKey?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.custom_role_assignment" */
export type Custom_Role_Assignment_Mutation_Response = {
  __typename?: 'custom_role_assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Role_Assignment>;
};

/** Ordering options when selecting data from "risksmart.custom_role_assignment". */
export type Custom_Role_Assignment_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleTypeKey?: InputMaybe<Order_By>;
  roleType?: InputMaybe<Auth_Role_Type_Order_By>;
};

/** select columns of table "risksmart.custom_role_assignment" */
export const Custom_Role_Assignment_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomRoleId: 'CustomRoleId',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RoleTypeKey: 'RoleTypeKey'
} as const;

export type Custom_Role_Assignment_Select_Column = typeof Custom_Role_Assignment_Select_Column[keyof typeof Custom_Role_Assignment_Select_Column];
/** Streaming cursor of the table "custom_role_assignment" */
export type Custom_Role_Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_Assignment_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomRoleId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RoleTypeKey?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.custom_role_audit" */
export type Custom_Role_Audit = {
  __typename?: 'custom_role_audit';
  Action: Scalars['String']['output'];
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleName: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.custom_role_audit". All fields are combined with a logical 'AND'. */
export type Custom_Role_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RoleName?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_Audit_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.custom_role_audit". */
export type Custom_Role_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleName?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.custom_role_audit" */
export const Custom_Role_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RoleName: 'RoleName'
} as const;

export type Custom_Role_Audit_Select_Column = typeof Custom_Role_Audit_Select_Column[keyof typeof Custom_Role_Audit_Select_Column];
/** Streaming cursor of the table "custom_role_audit" */
export type Custom_Role_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RoleName?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_role". All fields are combined with a logical 'AND'. */
export type Custom_Role_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RoleName?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_Bool_Exp>>;
  customRoleAssignments?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
  customRoleAssignments_aggregate?: InputMaybe<Custom_Role_Assignment_Aggregate_Bool_Exp>;
  customRoleUsers?: InputMaybe<Custom_Role_User_Bool_Exp>;
  customRoleUsers_aggregate?: InputMaybe<Custom_Role_User_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Custom_Role_Max_Fields = {
  __typename?: 'custom_role_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Custom_Role_Min_Fields = {
  __typename?: 'custom_role_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RoleName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.custom_role" */
export type Custom_Role_Mutation_Response = {
  __typename?: 'custom_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Role>;
};

/** Ordering options when selecting data from "risksmart.custom_role". */
export type Custom_Role_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RoleName?: InputMaybe<Order_By>;
  customRoleAssignments_aggregate?: InputMaybe<Custom_Role_Assignment_Aggregate_Order_By>;
  customRoleUsers_aggregate?: InputMaybe<Custom_Role_User_Aggregate_Order_By>;
};

/** select columns of table "risksmart.custom_role" */
export const Custom_Role_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RoleName: 'RoleName'
} as const;

export type Custom_Role_Select_Column = typeof Custom_Role_Select_Column[keyof typeof Custom_Role_Select_Column];
/** Streaming cursor of the table "custom_role" */
export type Custom_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RoleName?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.custom_role_user" */
export type Custom_Role_User = {
  __typename?: 'custom_role_user';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId: Scalars['uuid']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserId: Scalars['String']['output'];
  /** An object relationship */
  role: Custom_Role;
  /** An object relationship */
  user: Auth_User;
};

/** aggregated selection of "risksmart.custom_role_user" */
export type Custom_Role_User_Aggregate = {
  __typename?: 'custom_role_user_aggregate';
  aggregate?: Maybe<Custom_Role_User_Aggregate_Fields>;
  nodes: Array<Custom_Role_User>;
};

export type Custom_Role_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Custom_Role_User_Aggregate_Bool_Exp_Count>;
};

export type Custom_Role_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Custom_Role_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.custom_role_user" */
export type Custom_Role_User_Aggregate_Fields = {
  __typename?: 'custom_role_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Role_User_Max_Fields>;
  min?: Maybe<Custom_Role_User_Min_Fields>;
};


/** aggregate fields of "risksmart.custom_role_user" */
export type Custom_Role_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.custom_role_user" */
export type Custom_Role_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Custom_Role_User_Max_Order_By>;
  min?: InputMaybe<Custom_Role_User_Min_Order_By>;
};

/** columns and relationships of "risksmart.custom_role_user_audit" */
export type Custom_Role_User_Audit = {
  __typename?: 'custom_role_user_audit';
  Action: Scalars['String']['output'];
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId: Scalars['uuid']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserId: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.custom_role_user_audit". All fields are combined with a logical 'AND'. */
export type Custom_Role_User_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_User_Audit_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_User_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_User_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.custom_role_user_audit". */
export type Custom_Role_User_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.custom_role_user_audit" */
export const Custom_Role_User_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomRoleId: 'CustomRoleId',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  UserId: 'UserId'
} as const;

export type Custom_Role_User_Audit_Select_Column = typeof Custom_Role_User_Audit_Select_Column[keyof typeof Custom_Role_User_Audit_Select_Column];
/** Streaming cursor of the table "custom_role_user_audit" */
export type Custom_Role_User_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_User_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_User_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomRoleId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.custom_role_user". All fields are combined with a logical 'AND'. */
export type Custom_Role_User_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Role_User_Bool_Exp>>;
  _not?: InputMaybe<Custom_Role_User_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Role_User_Bool_Exp>>;
  role?: InputMaybe<Custom_Role_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
};

/** aggregate max on columns */
export type Custom_Role_User_Max_Fields = {
  __typename?: 'custom_role_user_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.custom_role_user" */
export type Custom_Role_User_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Role_User_Min_Fields = {
  __typename?: 'custom_role_user_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomRoleId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.custom_role_user" */
export type Custom_Role_User_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.custom_role_user" */
export type Custom_Role_User_Mutation_Response = {
  __typename?: 'custom_role_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Role_User>;
};

/** Ordering options when selecting data from "risksmart.custom_role_user". */
export type Custom_Role_User_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomRoleId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  role?: InputMaybe<Custom_Role_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
};

/** select columns of table "risksmart.custom_role_user" */
export const Custom_Role_User_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomRoleId: 'CustomRoleId',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  UserId: 'UserId'
} as const;

export type Custom_Role_User_Select_Column = typeof Custom_Role_User_Select_Column[keyof typeof Custom_Role_User_Select_Column];
/** Streaming cursor of the table "custom_role_user" */
export type Custom_Role_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Role_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Role_User_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomRoleId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Saved dashboards */
export type Dashboard = {
  __typename?: 'dashboard';
  Content?: Maybe<Scalars['jsonb']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  Name: Scalars['String']['output'];
  Sharing: Dashboard_Sharing_Type_Enum;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
};


/** Saved dashboards */
export type DashboardContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Saved dashboards */
export type DashboardAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** Saved dashboards */
export type DashboardOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** columns and relationships of "risksmart.dashboard_audit" */
export type Dashboard_Audit = {
  __typename?: 'dashboard_audit';
  Content?: Maybe<Scalars['jsonb']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Sharing?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.dashboard_audit" */
export type Dashboard_AuditContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.dashboard_audit". All fields are combined with a logical 'AND'. */
export type Dashboard_Audit_Bool_Exp = {
  Content?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Sharing?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Dashboard_Audit_Bool_Exp>>;
  _not?: InputMaybe<Dashboard_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Dashboard_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.dashboard_audit". */
export type Dashboard_Audit_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Sharing?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.dashboard_audit" */
export const Dashboard_Audit_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  Sharing: 'Sharing'
} as const;

export type Dashboard_Audit_Select_Column = typeof Dashboard_Audit_Select_Column[keyof typeof Dashboard_Audit_Select_Column];
/** Streaming cursor of the table "dashboard_audit" */
export type Dashboard_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dashboard_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dashboard_Audit_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Sharing?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.dashboard". All fields are combined with a logical 'AND'. */
export type Dashboard_Bool_Exp = {
  Content?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Sharing?: InputMaybe<Dashboard_Sharing_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Dashboard_Bool_Exp>>;
  _not?: InputMaybe<Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<Dashboard_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
};

/** response of any mutation on the table "risksmart.dashboard" */
export type Dashboard_Mutation_Response = {
  __typename?: 'dashboard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dashboard>;
};

/** Ordering options when selecting data from "risksmart.dashboard". */
export type Dashboard_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Sharing?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
};

/** select columns of table "risksmart.dashboard" */
export const Dashboard_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  Name: 'Name',
  /** column name */
  Sharing: 'Sharing'
} as const;

export type Dashboard_Select_Column = typeof Dashboard_Select_Column[keyof typeof Dashboard_Select_Column];
export const Dashboard_Sharing_Type_Enum = {
  /** Custom */
  Custom: 'custom',
  /** Organisation */
  Organisation: 'organisation',
  /** Private */
  UserOnly: 'user_only'
} as const;

export type Dashboard_Sharing_Type_Enum = typeof Dashboard_Sharing_Type_Enum[keyof typeof Dashboard_Sharing_Type_Enum];
export const Dashboard_Sharing_Type_Enum_Action = {
  /** Custom */
  Custom: 'custom',
  /** Organisation */
  Organisation: 'organisation',
  /** Private */
  UserOnly: 'user_only'
} as const;

export type Dashboard_Sharing_Type_Enum_Action = typeof Dashboard_Sharing_Type_Enum_Action[keyof typeof Dashboard_Sharing_Type_Enum_Action];
/** Boolean expression to compare columns of type "dashboard_sharing_type_enum". All fields are combined with logical 'AND'. */
export type Dashboard_Sharing_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dashboard_Sharing_Type_Enum>;
  _in?: InputMaybe<Array<Dashboard_Sharing_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dashboard_Sharing_Type_Enum>;
  _nin?: InputMaybe<Array<Dashboard_Sharing_Type_Enum>>;
};

/** Streaming cursor of the table "dashboard" */
export type Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dashboard_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Sharing?: InputMaybe<Dashboard_Sharing_Type_Enum>;
};

/** columns and relationships of "risksmart.data_export_schedule" */
export type Data_Export_Schedule = {
  __typename?: 'data_export_schedule';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CronArn?: Maybe<Scalars['String']['output']>;
  EndTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  Frequency: Data_Export_Schedule_Frequency_Enum;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SecretArn: Scalars['String']['output'];
  StartTimestamp: Scalars['timestamptz']['output'];
  Status: Data_Export_Schedule_Status_Enum;
  StorageType: Data_Export_Schedule_Storage_Type_Enum;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  dataExportScheduleExecutions: Array<Data_Export_Schedule_Execution>;
  /** An aggregate relationship */
  dataExportScheduleExecutions_aggregate: Data_Export_Schedule_Execution_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.data_export_schedule" */
export type Data_Export_ScheduleDataExportScheduleExecutionsArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


/** columns and relationships of "risksmart.data_export_schedule" */
export type Data_Export_ScheduleDataExportScheduleExecutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};

/** aggregated selection of "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Aggregate = {
  __typename?: 'data_export_schedule_aggregate';
  aggregate?: Maybe<Data_Export_Schedule_Aggregate_Fields>;
  nodes: Array<Data_Export_Schedule>;
};

/** aggregate fields of "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Aggregate_Fields = {
  __typename?: 'data_export_schedule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Data_Export_Schedule_Max_Fields>;
  min?: Maybe<Data_Export_Schedule_Min_Fields>;
};


/** aggregate fields of "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data_Export_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.data_export_schedule_audit" */
export type Data_Export_Schedule_Audit = {
  __typename?: 'data_export_schedule_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CronArn?: Maybe<Scalars['String']['output']>;
  EndTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  Frequency: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SecretArn: Scalars['String']['output'];
  StartTimestamp: Scalars['timestamptz']['output'];
  Status: Scalars['String']['output'];
  StorageType: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.data_export_schedule_audit". All fields are combined with a logical 'AND'. */
export type Data_Export_Schedule_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CronArn?: InputMaybe<String_Comparison_Exp>;
  EndTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Frequency?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SecretArn?: InputMaybe<String_Comparison_Exp>;
  StartTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  StorageType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Data_Export_Schedule_Audit_Bool_Exp>>;
  _not?: InputMaybe<Data_Export_Schedule_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Export_Schedule_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.data_export_schedule_audit". */
export type Data_Export_Schedule_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CronArn?: InputMaybe<Order_By>;
  EndTimestamp?: InputMaybe<Order_By>;
  Frequency?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SecretArn?: InputMaybe<Order_By>;
  StartTimestamp?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  StorageType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.data_export_schedule_audit" */
export const Data_Export_Schedule_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CronArn: 'CronArn',
  /** column name */
  EndTimestamp: 'EndTimestamp',
  /** column name */
  Frequency: 'Frequency',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SecretArn: 'SecretArn',
  /** column name */
  StartTimestamp: 'StartTimestamp',
  /** column name */
  Status: 'Status',
  /** column name */
  StorageType: 'StorageType'
} as const;

export type Data_Export_Schedule_Audit_Select_Column = typeof Data_Export_Schedule_Audit_Select_Column[keyof typeof Data_Export_Schedule_Audit_Select_Column];
/** Streaming cursor of the table "data_export_schedule_audit" */
export type Data_Export_Schedule_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Export_Schedule_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Export_Schedule_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CronArn?: InputMaybe<Scalars['String']['input']>;
  EndTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Frequency?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SecretArn?: InputMaybe<Scalars['String']['input']>;
  StartTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  StorageType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.data_export_schedule". All fields are combined with a logical 'AND'. */
export type Data_Export_Schedule_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CronArn?: InputMaybe<String_Comparison_Exp>;
  EndTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Frequency?: InputMaybe<Data_Export_Schedule_Frequency_Enum_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SecretArn?: InputMaybe<String_Comparison_Exp>;
  StartTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<Data_Export_Schedule_Status_Enum_Comparison_Exp>;
  StorageType?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Data_Export_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Export_Schedule_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  dataExportScheduleExecutions?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
  dataExportScheduleExecutions_aggregate?: InputMaybe<Data_Export_Schedule_Execution_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.data_export_schedule" */
export const Data_Export_Schedule_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DataExportSchedulePkey: 'data_export_schedule_pkey'
} as const;

export type Data_Export_Schedule_Constraint = typeof Data_Export_Schedule_Constraint[keyof typeof Data_Export_Schedule_Constraint];
/** columns and relationships of "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution = {
  __typename?: 'data_export_schedule_execution';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Errors?: Maybe<Scalars['String']['output']>;
  ExecutionTimestamp: Scalars['timestamptz']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  Status: Data_Export_Schedule_Execution_Status_Enum;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  dataExportSchedule?: Maybe<Data_Export_Schedule>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** aggregated selection of "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Aggregate = {
  __typename?: 'data_export_schedule_execution_aggregate';
  aggregate?: Maybe<Data_Export_Schedule_Execution_Aggregate_Fields>;
  nodes: Array<Data_Export_Schedule_Execution>;
};

export type Data_Export_Schedule_Execution_Aggregate_Bool_Exp = {
  count?: InputMaybe<Data_Export_Schedule_Execution_Aggregate_Bool_Exp_Count>;
};

export type Data_Export_Schedule_Execution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Aggregate_Fields = {
  __typename?: 'data_export_schedule_execution_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Data_Export_Schedule_Execution_Max_Fields>;
  min?: Maybe<Data_Export_Schedule_Execution_Min_Fields>;
};


/** aggregate fields of "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Data_Export_Schedule_Execution_Max_Order_By>;
  min?: InputMaybe<Data_Export_Schedule_Execution_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Arr_Rel_Insert_Input = {
  data: Array<Data_Export_Schedule_Execution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Data_Export_Schedule_Execution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.data_export_schedule_execution". All fields are combined with a logical 'AND'. */
export type Data_Export_Schedule_Execution_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Errors?: InputMaybe<String_Comparison_Exp>;
  ExecutionTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Data_Export_Schedule_Execution_Bool_Exp>>;
  _not?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Export_Schedule_Execution_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  dataExportSchedule?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.data_export_schedule_execution" */
export const Data_Export_Schedule_Execution_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "ExecutionTimestamp" */
  DataExportScheduleExecutionPkey: 'data_export_schedule_execution_pkey'
} as const;

export type Data_Export_Schedule_Execution_Constraint = typeof Data_Export_Schedule_Execution_Constraint[keyof typeof Data_Export_Schedule_Execution_Constraint];
/** input type for inserting data into table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Insert_Input = {
  Errors?: InputMaybe<Scalars['String']['input']>;
  ExecutionTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum>;
  dataExportSchedule?: InputMaybe<Data_Export_Schedule_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Data_Export_Schedule_Execution_Max_Fields = {
  __typename?: 'data_export_schedule_execution_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Errors?: Maybe<Scalars['String']['output']>;
  ExecutionTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Errors?: InputMaybe<Order_By>;
  ExecutionTimestamp?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Data_Export_Schedule_Execution_Min_Fields = {
  __typename?: 'data_export_schedule_execution_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Errors?: Maybe<Scalars['String']['output']>;
  ExecutionTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Errors?: InputMaybe<Order_By>;
  ExecutionTimestamp?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Mutation_Response = {
  __typename?: 'data_export_schedule_execution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Data_Export_Schedule_Execution>;
};

/** on_conflict condition type for table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_On_Conflict = {
  constraint: Data_Export_Schedule_Execution_Constraint;
  update_columns?: Array<Data_Export_Schedule_Execution_Update_Column>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.data_export_schedule_execution". */
export type Data_Export_Schedule_Execution_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Errors?: InputMaybe<Order_By>;
  ExecutionTimestamp?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  dataExportSchedule?: InputMaybe<Data_Export_Schedule_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.data_export_schedule_execution */
export type Data_Export_Schedule_Execution_Pk_Columns_Input = {
  ExecutionTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.data_export_schedule_execution" */
export const Data_Export_Schedule_Execution_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Errors: 'Errors',
  /** column name */
  ExecutionTimestamp: 'ExecutionTimestamp',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Status: 'Status'
} as const;

export type Data_Export_Schedule_Execution_Select_Column = typeof Data_Export_Schedule_Execution_Select_Column[keyof typeof Data_Export_Schedule_Execution_Select_Column];
/** input type for updating data in table "risksmart.data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Set_Input = {
  Errors?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum>;
};

export const Data_Export_Schedule_Execution_Status_Enum = {
  /** Cancelled */
  Cancelled: 'cancelled',
  /** Complete */
  Complete: 'complete',
  /** Failed */
  Failed: 'failed',
  /** Scheduled */
  Scheduled: 'scheduled'
} as const;

export type Data_Export_Schedule_Execution_Status_Enum = typeof Data_Export_Schedule_Execution_Status_Enum[keyof typeof Data_Export_Schedule_Execution_Status_Enum];
/** Boolean expression to compare columns of type "data_export_schedule_execution_status_enum". All fields are combined with logical 'AND'. */
export type Data_Export_Schedule_Execution_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum>;
  _in?: InputMaybe<Array<Data_Export_Schedule_Execution_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum>;
  _nin?: InputMaybe<Array<Data_Export_Schedule_Execution_Status_Enum>>;
};

/** Streaming cursor of the table "data_export_schedule_execution" */
export type Data_Export_Schedule_Execution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Export_Schedule_Execution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Export_Schedule_Execution_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Errors?: InputMaybe<Scalars['String']['input']>;
  ExecutionTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Execution_Status_Enum>;
};

/** update columns of table "risksmart.data_export_schedule_execution" */
export const Data_Export_Schedule_Execution_Update_Column = {
  /** column name */
  Errors: 'Errors',
  /** column name */
  Status: 'Status'
} as const;

export type Data_Export_Schedule_Execution_Update_Column = typeof Data_Export_Schedule_Execution_Update_Column[keyof typeof Data_Export_Schedule_Execution_Update_Column];
export type Data_Export_Schedule_Execution_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Data_Export_Schedule_Execution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Data_Export_Schedule_Execution_Bool_Exp;
};

export const Data_Export_Schedule_Frequency_Enum = {
  /** Daily */
  Daily: 'daily',
  /** Monthly */
  Monthly: 'monthly',
  /** Weekly */
  Weekly: 'weekly'
} as const;

export type Data_Export_Schedule_Frequency_Enum = typeof Data_Export_Schedule_Frequency_Enum[keyof typeof Data_Export_Schedule_Frequency_Enum];
/** Boolean expression to compare columns of type "data_export_schedule_frequency_enum". All fields are combined with logical 'AND'. */
export type Data_Export_Schedule_Frequency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Data_Export_Schedule_Frequency_Enum>;
  _in?: InputMaybe<Array<Data_Export_Schedule_Frequency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Data_Export_Schedule_Frequency_Enum>;
  _nin?: InputMaybe<Array<Data_Export_Schedule_Frequency_Enum>>;
};

/** input type for inserting data into table "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Insert_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CronArn?: InputMaybe<Scalars['String']['input']>;
  EndTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Frequency?: InputMaybe<Data_Export_Schedule_Frequency_Enum>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  SecretArn?: InputMaybe<Scalars['String']['input']>;
  StartTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Status_Enum>;
  StorageType?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum>;
  dataExportScheduleExecutions?: InputMaybe<Data_Export_Schedule_Execution_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Data_Export_Schedule_Max_Fields = {
  __typename?: 'data_export_schedule_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CronArn?: Maybe<Scalars['String']['output']>;
  EndTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SecretArn?: Maybe<Scalars['String']['output']>;
  StartTimestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Data_Export_Schedule_Min_Fields = {
  __typename?: 'data_export_schedule_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CronArn?: Maybe<Scalars['String']['output']>;
  EndTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SecretArn?: Maybe<Scalars['String']['output']>;
  StartTimestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Mutation_Response = {
  __typename?: 'data_export_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Data_Export_Schedule>;
};

/** input type for inserting object relation for remote table "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Obj_Rel_Insert_Input = {
  data: Data_Export_Schedule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Data_Export_Schedule_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.data_export_schedule" */
export type Data_Export_Schedule_On_Conflict = {
  constraint: Data_Export_Schedule_Constraint;
  update_columns?: Array<Data_Export_Schedule_Update_Column>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.data_export_schedule". */
export type Data_Export_Schedule_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CronArn?: InputMaybe<Order_By>;
  EndTimestamp?: InputMaybe<Order_By>;
  Frequency?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SecretArn?: InputMaybe<Order_By>;
  StartTimestamp?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  StorageType?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  dataExportScheduleExecutions_aggregate?: InputMaybe<Data_Export_Schedule_Execution_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.data_export_schedule */
export type Data_Export_Schedule_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.data_export_schedule" */
export const Data_Export_Schedule_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CronArn: 'CronArn',
  /** column name */
  EndTimestamp: 'EndTimestamp',
  /** column name */
  Frequency: 'Frequency',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SecretArn: 'SecretArn',
  /** column name */
  StartTimestamp: 'StartTimestamp',
  /** column name */
  Status: 'Status',
  /** column name */
  StorageType: 'StorageType'
} as const;

export type Data_Export_Schedule_Select_Column = typeof Data_Export_Schedule_Select_Column[keyof typeof Data_Export_Schedule_Select_Column];
/** input type for updating data in table "risksmart.data_export_schedule" */
export type Data_Export_Schedule_Set_Input = {
  CronArn?: InputMaybe<Scalars['String']['input']>;
  EndTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Frequency?: InputMaybe<Data_Export_Schedule_Frequency_Enum>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  SecretArn?: InputMaybe<Scalars['String']['input']>;
  StartTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Status_Enum>;
  StorageType?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum>;
};

export const Data_Export_Schedule_Status_Enum = {
  /** Active */
  Active: 'active',
  /** Inactive */
  Inactive: 'inactive'
} as const;

export type Data_Export_Schedule_Status_Enum = typeof Data_Export_Schedule_Status_Enum[keyof typeof Data_Export_Schedule_Status_Enum];
/** Boolean expression to compare columns of type "data_export_schedule_status_enum". All fields are combined with logical 'AND'. */
export type Data_Export_Schedule_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Data_Export_Schedule_Status_Enum>;
  _in?: InputMaybe<Array<Data_Export_Schedule_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Data_Export_Schedule_Status_Enum>;
  _nin?: InputMaybe<Array<Data_Export_Schedule_Status_Enum>>;
};

export const Data_Export_Schedule_Storage_Type_Enum = {
  /** AmazonS3 */
  AmazonS3: 'amazonS3',
  /** AzureBlobStorage */
  AzureBlobStorage: 'azureBlobStorage',
  /** MsSharePoint */
  MsSharePoint: 'msSharePoint',
  /** SFTP */
  Sftp: 'sftp'
} as const;

export type Data_Export_Schedule_Storage_Type_Enum = typeof Data_Export_Schedule_Storage_Type_Enum[keyof typeof Data_Export_Schedule_Storage_Type_Enum];
/** Boolean expression to compare columns of type "data_export_schedule_storage_type_enum". All fields are combined with logical 'AND'. */
export type Data_Export_Schedule_Storage_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum>;
  _in?: InputMaybe<Array<Data_Export_Schedule_Storage_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum>;
  _nin?: InputMaybe<Array<Data_Export_Schedule_Storage_Type_Enum>>;
};

/** Streaming cursor of the table "data_export_schedule" */
export type Data_Export_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Export_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Export_Schedule_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CronArn?: InputMaybe<Scalars['String']['input']>;
  EndTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Frequency?: InputMaybe<Data_Export_Schedule_Frequency_Enum>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SecretArn?: InputMaybe<Scalars['String']['input']>;
  StartTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Data_Export_Schedule_Status_Enum>;
  StorageType?: InputMaybe<Data_Export_Schedule_Storage_Type_Enum>;
};

/** update columns of table "risksmart.data_export_schedule" */
export const Data_Export_Schedule_Update_Column = {
  /** column name */
  CronArn: 'CronArn',
  /** column name */
  EndTimestamp: 'EndTimestamp',
  /** column name */
  Frequency: 'Frequency',
  /** column name */
  Id: 'Id',
  /** column name */
  SecretArn: 'SecretArn',
  /** column name */
  StartTimestamp: 'StartTimestamp',
  /** column name */
  Status: 'Status',
  /** column name */
  StorageType: 'StorageType'
} as const;

export type Data_Export_Schedule_Update_Column = typeof Data_Export_Schedule_Update_Column[keyof typeof Data_Export_Schedule_Update_Column];
export type Data_Export_Schedule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Data_Export_Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Data_Export_Schedule_Bool_Exp;
};

/** columns and relationships of "risksmart.data_import" */
export type Data_Import = {
  __typename?: 'data_import';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Status: Data_Import_Status_Enum;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};


/** columns and relationships of "risksmart.data_import" */
export type Data_ImportFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.data_import" */
export type Data_ImportFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** aggregated selection of "risksmart.data_import" */
export type Data_Import_Aggregate = {
  __typename?: 'data_import_aggregate';
  aggregate?: Maybe<Data_Import_Aggregate_Fields>;
  nodes: Array<Data_Import>;
};

/** aggregate fields of "risksmart.data_import" */
export type Data_Import_Aggregate_Fields = {
  __typename?: 'data_import_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Data_Import_Max_Fields>;
  min?: Maybe<Data_Import_Min_Fields>;
};


/** aggregate fields of "risksmart.data_import" */
export type Data_Import_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data_Import_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.data_import". All fields are combined with a logical 'AND'. */
export type Data_Import_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<Data_Import_Status_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Data_Import_Bool_Exp>>;
  _not?: InputMaybe<Data_Import_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Import_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.data_import" */
export const Data_Import_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DataImportPkey: 'data_import_pkey'
} as const;

export type Data_Import_Constraint = typeof Data_Import_Constraint[keyof typeof Data_Import_Constraint];
/** columns and relationships of "risksmart.data_import_error" */
export type Data_Import_Error = {
  __typename?: 'data_import_error';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  DataImportId?: Maybe<Scalars['uuid']['output']>;
  Id: Scalars['uuid']['output'];
  ImportObject: Scalars['String']['output'];
  Message: Scalars['String']['output'];
  RowNumber: Scalars['Int']['output'];
};

/** aggregated selection of "risksmart.data_import_error" */
export type Data_Import_Error_Aggregate = {
  __typename?: 'data_import_error_aggregate';
  aggregate?: Maybe<Data_Import_Error_Aggregate_Fields>;
  nodes: Array<Data_Import_Error>;
};

/** aggregate fields of "risksmart.data_import_error" */
export type Data_Import_Error_Aggregate_Fields = {
  __typename?: 'data_import_error_aggregate_fields';
  avg?: Maybe<Data_Import_Error_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Data_Import_Error_Max_Fields>;
  min?: Maybe<Data_Import_Error_Min_Fields>;
  stddev?: Maybe<Data_Import_Error_Stddev_Fields>;
  stddev_pop?: Maybe<Data_Import_Error_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Data_Import_Error_Stddev_Samp_Fields>;
  sum?: Maybe<Data_Import_Error_Sum_Fields>;
  var_pop?: Maybe<Data_Import_Error_Var_Pop_Fields>;
  var_samp?: Maybe<Data_Import_Error_Var_Samp_Fields>;
  variance?: Maybe<Data_Import_Error_Variance_Fields>;
};


/** aggregate fields of "risksmart.data_import_error" */
export type Data_Import_Error_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data_Import_Error_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Data_Import_Error_Avg_Fields = {
  __typename?: 'data_import_error_avg_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.data_import_error". All fields are combined with a logical 'AND'. */
export type Data_Import_Error_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DataImportId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImportObject?: InputMaybe<String_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  RowNumber?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Data_Import_Error_Bool_Exp>>;
  _not?: InputMaybe<Data_Import_Error_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Import_Error_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.data_import_error" */
export const Data_Import_Error_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DataImportErrorPkey: 'data_import_error_pkey'
} as const;

export type Data_Import_Error_Constraint = typeof Data_Import_Error_Constraint[keyof typeof Data_Import_Error_Constraint];
/** input type for inserting data into table "risksmart.data_import_error" */
export type Data_Import_Error_Insert_Input = {
  DataImportId?: InputMaybe<Scalars['uuid']['input']>;
  ImportObject?: InputMaybe<Scalars['String']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  RowNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Data_Import_Error_Max_Fields = {
  __typename?: 'data_import_error_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DataImportId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImportObject?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  RowNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Data_Import_Error_Min_Fields = {
  __typename?: 'data_import_error_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DataImportId?: Maybe<Scalars['uuid']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImportObject?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  RowNumber?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "risksmart.data_import_error" */
export type Data_Import_Error_Mutation_Response = {
  __typename?: 'data_import_error_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Data_Import_Error>;
};

/** on_conflict condition type for table "risksmart.data_import_error" */
export type Data_Import_Error_On_Conflict = {
  constraint: Data_Import_Error_Constraint;
  update_columns?: Array<Data_Import_Error_Update_Column>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.data_import_error". */
export type Data_Import_Error_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DataImportId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImportObject?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  RowNumber?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.data_import_error" */
export const Data_Import_Error_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DataImportId: 'DataImportId',
  /** column name */
  Id: 'Id',
  /** column name */
  ImportObject: 'ImportObject',
  /** column name */
  Message: 'Message',
  /** column name */
  RowNumber: 'RowNumber'
} as const;

export type Data_Import_Error_Select_Column = typeof Data_Import_Error_Select_Column[keyof typeof Data_Import_Error_Select_Column];
/** aggregate stddev on columns */
export type Data_Import_Error_Stddev_Fields = {
  __typename?: 'data_import_error_stddev_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Data_Import_Error_Stddev_Pop_Fields = {
  __typename?: 'data_import_error_stddev_pop_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Data_Import_Error_Stddev_Samp_Fields = {
  __typename?: 'data_import_error_stddev_samp_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "data_import_error" */
export type Data_Import_Error_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Import_Error_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Import_Error_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DataImportId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImportObject?: InputMaybe<Scalars['String']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  RowNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Data_Import_Error_Sum_Fields = {
  __typename?: 'data_import_error_sum_fields';
  RowNumber?: Maybe<Scalars['Int']['output']>;
};

/** placeholder for update columns of table "risksmart.data_import_error" (current role has no relevant permissions) */
export const Data_Import_Error_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Data_Import_Error_Update_Column = typeof Data_Import_Error_Update_Column[keyof typeof Data_Import_Error_Update_Column];
/** aggregate var_pop on columns */
export type Data_Import_Error_Var_Pop_Fields = {
  __typename?: 'data_import_error_var_pop_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Data_Import_Error_Var_Samp_Fields = {
  __typename?: 'data_import_error_var_samp_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Data_Import_Error_Variance_Fields = {
  __typename?: 'data_import_error_variance_fields';
  RowNumber?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "risksmart.data_import" */
export type Data_Import_Insert_Input = {
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Data_Import_Max_Fields = {
  __typename?: 'data_import_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Data_Import_Min_Fields = {
  __typename?: 'data_import_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.data_import" */
export type Data_Import_Mutation_Response = {
  __typename?: 'data_import_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Data_Import>;
};

/** on_conflict condition type for table "risksmart.data_import" */
export type Data_Import_On_Conflict = {
  constraint: Data_Import_Constraint;
  update_columns?: Array<Data_Import_Update_Column>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.data_import". */
export type Data_Import_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.data_import" */
export const Data_Import_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Status: 'Status'
} as const;

export type Data_Import_Select_Column = typeof Data_Import_Select_Column[keyof typeof Data_Import_Select_Column];
export const Data_Import_Status_Enum = {
  /** Complete */
  Complete: 'complete',
  /** Failed */
  Failed: 'failed',
  /** Importing */
  Importing: 'importing',
  /** Initiating import */
  InitiatingImport: 'initiatingImport',
  /** Not Started */
  Notstarted: 'notstarted',
  /** Valid */
  Valid: 'valid',
  /** Validating */
  Validating: 'validating'
} as const;

export type Data_Import_Status_Enum = typeof Data_Import_Status_Enum[keyof typeof Data_Import_Status_Enum];
/** Boolean expression to compare columns of type "data_import_status_enum". All fields are combined with logical 'AND'. */
export type Data_Import_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Data_Import_Status_Enum>;
  _in?: InputMaybe<Array<Data_Import_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Data_Import_Status_Enum>;
  _nin?: InputMaybe<Array<Data_Import_Status_Enum>>;
};

/** Streaming cursor of the table "data_import" */
export type Data_Import_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Import_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Import_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Data_Import_Status_Enum>;
};

/** update columns of table "risksmart.data_import" */
export const Data_Import_Update_Column = {
  /** column name */
  Status: 'Status'
} as const;

export type Data_Import_Update_Column = typeof Data_Import_Update_Column[keyof typeof Data_Import_Update_Column];
/** columns and relationships of "risksmart.department" */
export type Department = {
  __typename?: 'department';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DepartmentTypeId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  type?: Maybe<Department_Type>;
};

/** order by aggregate values of table "risksmart.department" */
export type Department_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Max_Order_By>;
  min?: InputMaybe<Department_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.department" */
export type Department_Arr_Rel_Insert_Input = {
  data: Array<Department_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_On_Conflict>;
};

/** columns and relationships of "risksmart.department_audit" */
export type Department_Audit = {
  __typename?: 'department_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DepartmentTypeId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risksmart.department_audit" */
export type Department_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Audit_Max_Order_By>;
  min?: InputMaybe<Department_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.department_audit". All fields are combined with a logical 'AND'. */
export type Department_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DepartmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Audit_Bool_Exp>>;
  _not?: InputMaybe<Department_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.department_audit" */
export type Department_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.department_audit" */
export type Department_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.department_audit". */
export type Department_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.department_audit" */
export const Department_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DepartmentTypeId: 'DepartmentTypeId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Department_Audit_Select_Column = typeof Department_Audit_Select_Column[keyof typeof Department_Audit_Select_Column];
/** Streaming cursor of the table "department_audit" */
export type Department_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DepartmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DepartmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  type?: InputMaybe<Department_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.department" */
export const Department_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "DepartmentTypeId" */
  DepartmentPkey: 'department_pkey'
} as const;

export type Department_Constraint = typeof Department_Constraint[keyof typeof Department_Constraint];
/** input type for inserting data into table "risksmart.department" */
export type Department_Insert_Input = {
  DepartmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Department_Type_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.department" */
export type Department_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.department" */
export type Department_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.department" */
export type Department_On_Conflict = {
  constraint: Department_Constraint;
  update_columns?: Array<Department_Update_Column>;
  where?: InputMaybe<Department_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.department". */
export type Department_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  type?: InputMaybe<Department_Type_Order_By>;
};

/** select columns of table "risksmart.department" */
export const Department_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DepartmentTypeId: 'DepartmentTypeId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Department_Select_Column = typeof Department_Select_Column[keyof typeof Department_Select_Column];
/** columns and relationships of "risksmart.department_type" */
export type Department_Type = {
  __typename?: 'department_type';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DepartmentTypeGroupId?: Maybe<Scalars['uuid']['output']>;
  DepartmentTypeId: Scalars['uuid']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  department_type_group?: Maybe<Department_Type_Group>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** order by aggregate values of table "risksmart.department_type" */
export type Department_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Type_Max_Order_By>;
  min?: InputMaybe<Department_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.department_type" */
export type Department_Type_Arr_Rel_Insert_Input = {
  data: Array<Department_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Type_On_Conflict>;
};

/** columns and relationships of "risksmart.department_type_audit" */
export type Department_Type_Audit = {
  __typename?: 'department_type_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DepartmentTypeGroupId?: Maybe<Scalars['uuid']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.department_type_audit". All fields are combined with a logical 'AND'. */
export type Department_Type_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DepartmentTypeGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Type_Audit_Bool_Exp>>;
  _not?: InputMaybe<Department_Type_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Type_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.department_type_audit". */
export type Department_Type_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeGroupId?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.department_type_audit" */
export const Department_Type_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DepartmentTypeGroupId: 'DepartmentTypeGroupId',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Audit_Select_Column = typeof Department_Type_Audit_Select_Column[keyof typeof Department_Type_Audit_Select_Column];
/** Streaming cursor of the table "department_type_audit" */
export type Department_Type_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Type_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Type_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.department_type". All fields are combined with a logical 'AND'. */
export type Department_Type_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DepartmentTypeGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  DepartmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Type_Bool_Exp>>;
  _not?: InputMaybe<Department_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Type_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  department_type_group?: InputMaybe<Department_Type_Group_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.department_type" */
export const Department_Type_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DepartmentTypePkey: 'department_type_pkey',
  /** unique or primary key constraint on columns "Name", "OrgKey" */
  IxDepartmentTypeOrgkeyTitle: 'ix_department_type_orgkey_title'
} as const;

export type Department_Type_Constraint = typeof Department_Type_Constraint[keyof typeof Department_Type_Constraint];
/** columns and relationships of "risksmart.department_type_group" */
export type Department_Type_Group = {
  __typename?: 'department_type_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  /** An array relationship */
  department_types: Array<Department_Type>;
};


/** columns and relationships of "risksmart.department_type_group" */
export type Department_Type_GroupDepartment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Order_By>>;
  where?: InputMaybe<Department_Type_Bool_Exp>;
};

/** columns and relationships of "risksmart.department_type_group_audit" */
export type Department_Type_Group_Audit = {
  __typename?: 'department_type_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.department_type_group_audit". All fields are combined with a logical 'AND'. */
export type Department_Type_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Type_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<Department_Type_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Type_Group_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.department_type_group_audit". */
export type Department_Type_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.department_type_group_audit" */
export const Department_Type_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Group_Audit_Select_Column = typeof Department_Type_Group_Audit_Select_Column[keyof typeof Department_Type_Group_Audit_Select_Column];
/** Streaming cursor of the table "department_type_group_audit" */
export type Department_Type_Group_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Type_Group_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Type_Group_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.department_type_group". All fields are combined with a logical 'AND'. */
export type Department_Type_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Department_Type_Group_Bool_Exp>>;
  _not?: InputMaybe<Department_Type_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Type_Group_Bool_Exp>>;
  department_types?: InputMaybe<Department_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.department_type_group" */
export const Department_Type_Group_Constraint = {
  /** unique or primary key constraint on columns "Name", "OrgKey" */
  DepartmentTypeGroupPkey: 'DepartmentTypeGroup_pkey',
  /** unique or primary key constraint on columns "Id" */
  DepartmentTypeGroupIdKey: 'department_type_group_Id_key'
} as const;

export type Department_Type_Group_Constraint = typeof Department_Type_Group_Constraint[keyof typeof Department_Type_Group_Constraint];
/** input type for inserting data into table "risksmart.department_type_group" */
export type Department_Type_Group_Insert_Input = {
  Name?: InputMaybe<Scalars['String']['input']>;
  department_types?: InputMaybe<Department_Type_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.department_type_group" */
export type Department_Type_Group_Mutation_Response = {
  __typename?: 'department_type_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Department_Type_Group>;
};

/** input type for inserting object relation for remote table "risksmart.department_type_group" */
export type Department_Type_Group_Obj_Rel_Insert_Input = {
  data: Department_Type_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Type_Group_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.department_type_group" */
export type Department_Type_Group_On_Conflict = {
  constraint: Department_Type_Group_Constraint;
  update_columns?: Array<Department_Type_Group_Update_Column>;
  where?: InputMaybe<Department_Type_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.department_type_group". */
export type Department_Type_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  department_types_aggregate?: InputMaybe<Department_Type_Aggregate_Order_By>;
};

/** select columns of table "risksmart.department_type_group" */
export const Department_Type_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Group_Select_Column = typeof Department_Type_Group_Select_Column[keyof typeof Department_Type_Group_Select_Column];
/** input type for updating data in table "risksmart.department_type_group" */
export type Department_Type_Group_Set_Input = {
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "department_type_group" */
export type Department_Type_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Type_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Type_Group_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.department_type_group" */
export const Department_Type_Group_Update_Column = {
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Group_Update_Column = typeof Department_Type_Group_Update_Column[keyof typeof Department_Type_Group_Update_Column];
export type Department_Type_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Type_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Department_Type_Group_Bool_Exp;
};

/** input type for inserting data into table "risksmart.department_type" */
export type Department_Type_Insert_Input = {
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  department_type_group?: InputMaybe<Department_Type_Group_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.department_type" */
export type Department_Type_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeGroupId?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.department_type" */
export type Department_Type_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeGroupId?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.department_type" */
export type Department_Type_Mutation_Response = {
  __typename?: 'department_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Department_Type>;
};

/** input type for inserting object relation for remote table "risksmart.department_type" */
export type Department_Type_Obj_Rel_Insert_Input = {
  data: Department_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Type_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.department_type" */
export type Department_Type_On_Conflict = {
  constraint: Department_Type_Constraint;
  update_columns?: Array<Department_Type_Update_Column>;
  where?: InputMaybe<Department_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.department_type". */
export type Department_Type_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DepartmentTypeGroupId?: InputMaybe<Order_By>;
  DepartmentTypeId?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  department_type_group?: InputMaybe<Department_Type_Group_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.department_type */
export type Department_Type_Pk_Columns_Input = {
  DepartmentTypeId: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.department_type" */
export const Department_Type_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DepartmentTypeGroupId: 'DepartmentTypeGroupId',
  /** column name */
  DepartmentTypeId: 'DepartmentTypeId',
  /** column name */
  Description: 'Description',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Select_Column = typeof Department_Type_Select_Column[keyof typeof Department_Type_Select_Column];
/** input type for updating data in table "risksmart.department_type" */
export type Department_Type_Set_Input = {
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "department_type" */
export type Department_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Type_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  DepartmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.department_type" */
export const Department_Type_Update_Column = {
  /** column name */
  DepartmentTypeGroupId: 'DepartmentTypeGroupId',
  /** column name */
  Description: 'Description',
  /** column name */
  Name: 'Name'
} as const;

export type Department_Type_Update_Column = typeof Department_Type_Update_Column[keyof typeof Department_Type_Update_Column];
export type Department_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Department_Type_Bool_Exp;
};

/** placeholder for update columns of table "risksmart.department" (current role has no relevant permissions) */
export const Department_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Department_Update_Column = typeof Department_Update_Column[keyof typeof Department_Update_Column];
/** columns and relationships of "risksmart.document" */
export type Document = {
  __typename?: 'document';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DocumentType: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentDocument?: Maybe<Scalars['uuid']['output']>;
  Purpose?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  approvals: Array<Approval>;
  /** An array relationship */
  assessmentResults: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Assessment_Result_Parent_Aggregate;
  /** An object relationship */
  attestationConfig?: Maybe<Attestation_Config>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  documentFiles: Array<Document_File>;
  /** An array relationship */
  issues: Array<Issue_Parent>;
  /** An aggregate relationship */
  issues_aggregate: Issue_Parent_Aggregate;
  /** An array relationship */
  linkedDocuments: Array<Document_Linked_Document>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  parent?: Maybe<Document>;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
  /** An object relationship */
  scheduleState?: Maybe<Schedule_State>;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentDocumentFilesArgs = {
  distinct_on?: InputMaybe<Array<Document_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_File_Order_By>>;
  where?: InputMaybe<Document_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentLinkedDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Linked_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Linked_Document_Order_By>>;
  where?: InputMaybe<Document_Linked_Document_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.document" */
export type DocumentTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_Result = {
  __typename?: 'document_assessment_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType: Scalars['String']['output'];
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Assessment_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_assessment_result" */
export type Document_Assessment_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Aggregate = {
  __typename?: 'document_assessment_result_aggregate';
  aggregate?: Maybe<Document_Assessment_Result_Aggregate_Fields>;
  nodes: Array<Document_Assessment_Result>;
};

/** aggregate fields of "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Aggregate_Fields = {
  __typename?: 'document_assessment_result_aggregate_fields';
  avg?: Maybe<Document_Assessment_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Assessment_Result_Max_Fields>;
  min?: Maybe<Document_Assessment_Result_Min_Fields>;
  stddev?: Maybe<Document_Assessment_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Assessment_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Assessment_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Assessment_Result_Sum_Fields>;
  var_pop?: Maybe<Document_Assessment_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Assessment_Result_Var_Samp_Fields>;
  variance?: Maybe<Document_Assessment_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Assessment_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Assessment_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.document_assessment_result_audit" */
export type Document_Assessment_Result_Audit = {
  __typename?: 'document_assessment_result_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "risksmart.document_assessment_result_audit" */
export type Document_Assessment_Result_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.document_assessment_result_audit" */
export type Document_Assessment_Result_Audit_Aggregate = {
  __typename?: 'document_assessment_result_audit_aggregate';
  aggregate?: Maybe<Document_Assessment_Result_Audit_Aggregate_Fields>;
  nodes: Array<Document_Assessment_Result_Audit>;
};

/** aggregate fields of "risksmart.document_assessment_result_audit" */
export type Document_Assessment_Result_Audit_Aggregate_Fields = {
  __typename?: 'document_assessment_result_audit_aggregate_fields';
  avg?: Maybe<Document_Assessment_Result_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Assessment_Result_Audit_Max_Fields>;
  min?: Maybe<Document_Assessment_Result_Audit_Min_Fields>;
  stddev?: Maybe<Document_Assessment_Result_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Assessment_Result_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Assessment_Result_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Assessment_Result_Audit_Sum_Fields>;
  var_pop?: Maybe<Document_Assessment_Result_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Assessment_Result_Audit_Var_Samp_Fields>;
  variance?: Maybe<Document_Assessment_Result_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.document_assessment_result_audit" */
export type Document_Assessment_Result_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Assessment_Result_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Document_Assessment_Result_Audit_Avg_Fields = {
  __typename?: 'document_assessment_result_audit_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_assessment_result_audit". All fields are combined with a logical 'AND'. */
export type Document_Assessment_Result_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Assessment_Result_Audit_Bool_Exp>>;
  _not?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Assessment_Result_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Document_Assessment_Result_Audit_Max_Fields = {
  __typename?: 'document_assessment_result_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Document_Assessment_Result_Audit_Min_Fields = {
  __typename?: 'document_assessment_result_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "risksmart.document_assessment_result_audit". */
export type Document_Assessment_Result_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.document_assessment_result_audit" */
export const Document_Assessment_Result_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Assessment_Result_Audit_Select_Column = typeof Document_Assessment_Result_Audit_Select_Column[keyof typeof Document_Assessment_Result_Audit_Select_Column];
/** aggregate stddev on columns */
export type Document_Assessment_Result_Audit_Stddev_Fields = {
  __typename?: 'document_assessment_result_audit_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Document_Assessment_Result_Audit_Stddev_Pop_Fields = {
  __typename?: 'document_assessment_result_audit_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Document_Assessment_Result_Audit_Stddev_Samp_Fields = {
  __typename?: 'document_assessment_result_audit_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "document_assessment_result_audit" */
export type Document_Assessment_Result_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Assessment_Result_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Assessment_Result_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Document_Assessment_Result_Audit_Sum_Fields = {
  __typename?: 'document_assessment_result_audit_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Document_Assessment_Result_Audit_Var_Pop_Fields = {
  __typename?: 'document_assessment_result_audit_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Document_Assessment_Result_Audit_Var_Samp_Fields = {
  __typename?: 'document_assessment_result_audit_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Document_Assessment_Result_Audit_Variance_Fields = {
  __typename?: 'document_assessment_result_audit_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Document_Assessment_Result_Avg_Fields = {
  __typename?: 'document_assessment_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_assessment_result". All fields are combined with a logical 'AND'. */
export type Document_Assessment_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Assessment_Result_Bool_Exp>>;
  _not?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Assessment_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.document_assessment_result" */
export const Document_Assessment_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DocumentAssessmentResultPkey: 'document_assessment_result_pkey'
} as const;

export type Document_Assessment_Result_Constraint = typeof Document_Assessment_Result_Constraint[keyof typeof Document_Assessment_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Assessment_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Assessment_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Assessment_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Document_Assessment_Result_Max_Fields = {
  __typename?: 'document_assessment_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Document_Assessment_Result_Min_Fields = {
  __typename?: 'document_assessment_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Mutation_Response = {
  __typename?: 'document_assessment_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Assessment_Result>;
};

/** input type for inserting object relation for remote table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Obj_Rel_Insert_Input = {
  data: Document_Assessment_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Assessment_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_On_Conflict = {
  constraint: Document_Assessment_Result_Constraint;
  update_columns?: Array<Document_Assessment_Result_Update_Column>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.document_assessment_result". */
export type Document_Assessment_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.document_assessment_result */
export type Document_Assessment_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Assessment_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.document_assessment_result" */
export const Document_Assessment_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Assessment_Result_Select_Column = typeof Document_Assessment_Result_Select_Column[keyof typeof Document_Assessment_Result_Select_Column];
/** input type for updating data in table "risksmart.document_assessment_result" */
export type Document_Assessment_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Document_Assessment_Result_Stddev_Fields = {
  __typename?: 'document_assessment_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Document_Assessment_Result_Stddev_Pop_Fields = {
  __typename?: 'document_assessment_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Document_Assessment_Result_Stddev_Samp_Fields = {
  __typename?: 'document_assessment_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "document_assessment_result" */
export type Document_Assessment_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Assessment_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Assessment_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Document_Assessment_Result_Sum_Fields = {
  __typename?: 'document_assessment_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.document_assessment_result" */
export const Document_Assessment_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Assessment_Result_Update_Column = typeof Document_Assessment_Result_Update_Column[keyof typeof Document_Assessment_Result_Update_Column];
export type Document_Assessment_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Assessment_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Assessment_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Assessment_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Assessment_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Assessment_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Assessment_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Assessment_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Assessment_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Assessment_Result_Var_Pop_Fields = {
  __typename?: 'document_assessment_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Document_Assessment_Result_Var_Samp_Fields = {
  __typename?: 'document_assessment_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Document_Assessment_Result_Variance_Fields = {
  __typename?: 'document_assessment_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.document_audit" */
export type Document_Audit = {
  __typename?: 'document_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DocumentType: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentDocument?: Maybe<Scalars['uuid']['output']>;
  Purpose?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.document_audit" */
export type Document_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_audit". All fields are combined with a logical 'AND'. */
export type Document_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DocumentType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentDocument?: InputMaybe<Uuid_Comparison_Exp>;
  Purpose?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Audit_Bool_Exp>>;
  _not?: InputMaybe<Document_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.document_audit". */
export type Document_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DocumentType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentDocument?: InputMaybe<Order_By>;
  Purpose?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.document_audit" */
export const Document_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DocumentType: 'DocumentType',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentDocument: 'ParentDocument',
  /** column name */
  Purpose: 'Purpose',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Document_Audit_Select_Column = typeof Document_Audit_Select_Column[keyof typeof Document_Audit_Select_Column];
/** Streaming cursor of the table "document_audit" */
export type Document_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentType?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentDocument?: InputMaybe<Scalars['uuid']['input']>;
  Purpose?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DocumentType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentDocument?: InputMaybe<Uuid_Comparison_Exp>;
  Purpose?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  approvals?: InputMaybe<Approval_Bool_Exp>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  attestationConfig?: InputMaybe<Attestation_Config_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  documentFiles?: InputMaybe<Document_File_Bool_Exp>;
  issues?: InputMaybe<Issue_Parent_Bool_Exp>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  linkedDocuments?: InputMaybe<Document_Linked_Document_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Document_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
  scheduleState?: InputMaybe<Schedule_State_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.document" */
export const Document_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DocumentPkey: 'document_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxDocumentOrgkeySequentialid: 'idx_document_orgkey_sequentialid'
} as const;

export type Document_Constraint = typeof Document_Constraint[keyof typeof Document_Constraint];
/** columns and relationships of "risksmart.document_file" */
export type Document_File = {
  __typename?: 'document_file';
  Content?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  FileId?: Maybe<Scalars['uuid']['output']>;
  Id: Scalars['uuid']['output'];
  Link?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  NextReviewDate?: Maybe<Scalars['timestamptz']['output']>;
  ParentDocumentId: Scalars['uuid']['output'];
  PublishedDate?: Maybe<Scalars['timestamptz']['output']>;
  ReasonForReview?: Maybe<Scalars['String']['output']>;
  ReviewDate?: Maybe<Scalars['timestamptz']['output']>;
  ReviewedBy?: Maybe<Scalars['String']['output']>;
  Status: Version_Status_Enum;
  Summary?: Maybe<Scalars['String']['output']>;
  Type: Document_File_Type_Enum;
  Version: Scalars['String']['output'];
  /** An array relationship */
  attestations: Array<Attestation_Record>;
  /** An aggregate relationship */
  attestations_aggregate: Attestation_Record_Aggregate;
  /** An array relationship */
  changeRequests: Array<Change_Request>;
  /** An aggregate relationship */
  changeRequests_aggregate: Change_Request_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  file?: Maybe<File>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  parent?: Maybe<Document>;
  /** An object relationship */
  reviewedBy?: Maybe<User>;
};


/** columns and relationships of "risksmart.document_file" */
export type Document_FileCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.document_file" */
export type Document_FileAttestationsArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_file" */
export type Document_FileAttestations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_file" */
export type Document_FileChangeRequestsArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_file" */
export type Document_FileChangeRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.document_file" */
export type Document_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_File_Max_Order_By>;
  min?: InputMaybe<Document_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.document_file" */
export type Document_File_Arr_Rel_Insert_Input = {
  data: Array<Document_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_File_On_Conflict>;
};

/** columns and relationships of "risksmart.document_file_audit" */
export type Document_File_Audit = {
  __typename?: 'document_file_audit';
  Content?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  FileId?: Maybe<Scalars['uuid']['output']>;
  Id: Scalars['uuid']['output'];
  Link?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  NextReviewDate?: Maybe<Scalars['timestamptz']['output']>;
  ParentDocumentId: Scalars['uuid']['output'];
  PublishedDate?: Maybe<Scalars['timestamptz']['output']>;
  ReasonForReview?: Maybe<Scalars['String']['output']>;
  ReviewDate?: Maybe<Scalars['timestamptz']['output']>;
  ReviewedBy?: Maybe<Scalars['String']['output']>;
  Status: Scalars['String']['output'];
  Summary?: Maybe<Scalars['String']['output']>;
  Type: Scalars['String']['output'];
  Version: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.document_file_audit" */
export type Document_File_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_file_audit". All fields are combined with a logical 'AND'. */
export type Document_File_Audit_Bool_Exp = {
  Content?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  FileId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Link?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextReviewDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ParentDocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  PublishedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ReasonForReview?: InputMaybe<String_Comparison_Exp>;
  ReviewDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ReviewedBy?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Version?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_File_Audit_Bool_Exp>>;
  _not?: InputMaybe<Document_File_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Document_File_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.document_file_audit". */
export type Document_File_Audit_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  FileId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Link?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextReviewDate?: InputMaybe<Order_By>;
  ParentDocumentId?: InputMaybe<Order_By>;
  PublishedDate?: InputMaybe<Order_By>;
  ReasonForReview?: InputMaybe<Order_By>;
  ReviewDate?: InputMaybe<Order_By>;
  ReviewedBy?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.document_file_audit" */
export const Document_File_Audit_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  FileId: 'FileId',
  /** column name */
  Id: 'Id',
  /** column name */
  Link: 'Link',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextReviewDate: 'NextReviewDate',
  /** column name */
  ParentDocumentId: 'ParentDocumentId',
  /** column name */
  PublishedDate: 'PublishedDate',
  /** column name */
  ReasonForReview: 'ReasonForReview',
  /** column name */
  ReviewDate: 'ReviewDate',
  /** column name */
  ReviewedBy: 'ReviewedBy',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Type: 'Type',
  /** column name */
  Version: 'Version'
} as const;

export type Document_File_Audit_Select_Column = typeof Document_File_Audit_Select_Column[keyof typeof Document_File_Audit_Select_Column];
/** Streaming cursor of the table "document_file_audit" */
export type Document_File_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_File_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_File_Audit_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  PublishedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_file". All fields are combined with a logical 'AND'. */
export type Document_File_Bool_Exp = {
  Content?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  FileId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Link?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextReviewDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ParentDocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  PublishedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ReasonForReview?: InputMaybe<String_Comparison_Exp>;
  ReviewDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ReviewedBy?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<Version_Status_Enum_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Document_File_Type_Enum_Comparison_Exp>;
  Version?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_File_Bool_Exp>>;
  _not?: InputMaybe<Document_File_Bool_Exp>;
  _or?: InputMaybe<Array<Document_File_Bool_Exp>>;
  attestations?: InputMaybe<Attestation_Record_Bool_Exp>;
  attestations_aggregate?: InputMaybe<Attestation_Record_Aggregate_Bool_Exp>;
  changeRequests?: InputMaybe<Change_Request_Bool_Exp>;
  changeRequests_aggregate?: InputMaybe<Change_Request_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  parent?: InputMaybe<Document_Bool_Exp>;
  reviewedBy?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.document_file" */
export const Document_File_Constraint = {
  /** unique or primary key constraint on columns "FileId" */
  DocumentFileFileId: 'document_file_fileId',
  /** unique or primary key constraint on columns "Id" */
  DocumentFilePkey: 'document_file_pkey'
} as const;

export type Document_File_Constraint = typeof Document_File_Constraint[keyof typeof Document_File_Constraint];
/** input type for inserting data into table "risksmart.document_file" */
export type Document_File_Insert_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Version_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Document_File_Type_Enum>;
  Version?: InputMaybe<Scalars['String']['input']>;
  attestations?: InputMaybe<Attestation_Record_Arr_Rel_Insert_Input>;
  changeRequests?: InputMaybe<Change_Request_Arr_Rel_Insert_Input>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  parent?: InputMaybe<Document_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.document_file" */
export type Document_File_Max_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FileId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Link?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextReviewDate?: InputMaybe<Order_By>;
  ParentDocumentId?: InputMaybe<Order_By>;
  PublishedDate?: InputMaybe<Order_By>;
  ReasonForReview?: InputMaybe<Order_By>;
  ReviewDate?: InputMaybe<Order_By>;
  ReviewedBy?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.document_file" */
export type Document_File_Min_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FileId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Link?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextReviewDate?: InputMaybe<Order_By>;
  ParentDocumentId?: InputMaybe<Order_By>;
  PublishedDate?: InputMaybe<Order_By>;
  ReasonForReview?: InputMaybe<Order_By>;
  ReviewDate?: InputMaybe<Order_By>;
  ReviewedBy?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.document_file" */
export type Document_File_Mutation_Response = {
  __typename?: 'document_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_File>;
};

/** input type for inserting object relation for remote table "risksmart.document_file" */
export type Document_File_Obj_Rel_Insert_Input = {
  data: Document_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_File_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.document_file" */
export type Document_File_On_Conflict = {
  constraint: Document_File_Constraint;
  update_columns?: Array<Document_File_Update_Column>;
  where?: InputMaybe<Document_File_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.document_file". */
export type Document_File_Order_By = {
  Content?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  FileId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Link?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextReviewDate?: InputMaybe<Order_By>;
  ParentDocumentId?: InputMaybe<Order_By>;
  PublishedDate?: InputMaybe<Order_By>;
  ReasonForReview?: InputMaybe<Order_By>;
  ReviewDate?: InputMaybe<Order_By>;
  ReviewedBy?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
  attestations_aggregate?: InputMaybe<Attestation_Record_Aggregate_Order_By>;
  changeRequests_aggregate?: InputMaybe<Change_Request_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  file?: InputMaybe<File_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  parent?: InputMaybe<Document_Order_By>;
  reviewedBy?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.document_file" */
export const Document_File_Select_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  FileId: 'FileId',
  /** column name */
  Id: 'Id',
  /** column name */
  Link: 'Link',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextReviewDate: 'NextReviewDate',
  /** column name */
  ParentDocumentId: 'ParentDocumentId',
  /** column name */
  PublishedDate: 'PublishedDate',
  /** column name */
  ReasonForReview: 'ReasonForReview',
  /** column name */
  ReviewDate: 'ReviewDate',
  /** column name */
  ReviewedBy: 'ReviewedBy',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Type: 'Type',
  /** column name */
  Version: 'Version'
} as const;

export type Document_File_Select_Column = typeof Document_File_Select_Column[keyof typeof Document_File_Select_Column];
/** Streaming cursor of the table "document_file" */
export type Document_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_File_Stream_Cursor_Value_Input = {
  Content?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  PublishedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Version_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Document_File_Type_Enum>;
  Version?: InputMaybe<Scalars['String']['input']>;
};

export const Document_File_Type_Enum = {
  /** File */
  File: 'file',
  /** Html */
  Html: 'html',
  /** Link */
  Link: 'link'
} as const;

export type Document_File_Type_Enum = typeof Document_File_Type_Enum[keyof typeof Document_File_Type_Enum];
/** Boolean expression to compare columns of type "document_file_type_enum". All fields are combined with logical 'AND'. */
export type Document_File_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Document_File_Type_Enum>;
  _in?: InputMaybe<Array<Document_File_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Document_File_Type_Enum>;
  _nin?: InputMaybe<Array<Document_File_Type_Enum>>;
};

/** update columns of table "risksmart.document_file" */
export const Document_File_Update_Column = {
  /** column name */
  Content: 'Content',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  FileId: 'FileId',
  /** column name */
  Link: 'Link',
  /** column name */
  NextReviewDate: 'NextReviewDate',
  /** column name */
  PublishedDate: 'PublishedDate',
  /** column name */
  ReasonForReview: 'ReasonForReview',
  /** column name */
  ReviewDate: 'ReviewDate',
  /** column name */
  ReviewedBy: 'ReviewedBy',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  Type: 'Type',
  /** column name */
  Version: 'Version'
} as const;

export type Document_File_Update_Column = typeof Document_File_Update_Column[keyof typeof Document_File_Update_Column];
/** input type for inserting data into table "risksmart.document" */
export type Document_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentType?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentDocument?: InputMaybe<Scalars['uuid']['input']>;
  Purpose?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  approvals?: InputMaybe<Approval_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  attestationConfig?: InputMaybe<Attestation_Config_Obj_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  documentFiles?: InputMaybe<Document_File_Arr_Rel_Insert_Input>;
  issues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  linkedDocuments?: InputMaybe<Document_Linked_Document_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  schedule?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result = {
  __typename?: 'document_internal_audit_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Aggregate = {
  __typename?: 'document_internal_audit_result_aggregate';
  aggregate?: Maybe<Document_Internal_Audit_Result_Aggregate_Fields>;
  nodes: Array<Document_Internal_Audit_Result>;
};

/** aggregate fields of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Aggregate_Fields = {
  __typename?: 'document_internal_audit_result_aggregate_fields';
  avg?: Maybe<Document_Internal_Audit_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Internal_Audit_Result_Max_Fields>;
  min?: Maybe<Document_Internal_Audit_Result_Min_Fields>;
  stddev?: Maybe<Document_Internal_Audit_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Internal_Audit_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Internal_Audit_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Internal_Audit_Result_Sum_Fields>;
  var_pop?: Maybe<Document_Internal_Audit_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Internal_Audit_Result_Var_Samp_Fields>;
  variance?: Maybe<Document_Internal_Audit_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Internal_Audit_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Internal_Audit_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Document_Internal_Audit_Result_Avg_Fields = {
  __typename?: 'document_internal_audit_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_internal_audit_result". All fields are combined with a logical 'AND'. */
export type Document_Internal_Audit_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Internal_Audit_Result_Bool_Exp>>;
  _not?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Internal_Audit_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.document_internal_audit_result" */
export const Document_Internal_Audit_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  DocumentInternalAuditResultPkey: 'document_internal_audit_result_pkey'
} as const;

export type Document_Internal_Audit_Result_Constraint = typeof Document_Internal_Audit_Result_Constraint[keyof typeof Document_Internal_Audit_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Internal_Audit_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Internal_Audit_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Internal_Audit_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Document_Internal_Audit_Result_Max_Fields = {
  __typename?: 'document_internal_audit_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Document_Internal_Audit_Result_Min_Fields = {
  __typename?: 'document_internal_audit_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Mutation_Response = {
  __typename?: 'document_internal_audit_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Internal_Audit_Result>;
};

/** input type for inserting object relation for remote table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Obj_Rel_Insert_Input = {
  data: Document_Internal_Audit_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Internal_Audit_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_On_Conflict = {
  constraint: Document_Internal_Audit_Result_Constraint;
  update_columns?: Array<Document_Internal_Audit_Result_Update_Column>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.document_internal_audit_result". */
export type Document_Internal_Audit_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.document_internal_audit_result */
export type Document_Internal_Audit_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Internal_Audit_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.document_internal_audit_result" */
export const Document_Internal_Audit_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Internal_Audit_Result_Select_Column = typeof Document_Internal_Audit_Result_Select_Column[keyof typeof Document_Internal_Audit_Result_Select_Column];
/** input type for updating data in table "risksmart.document_internal_audit_result" */
export type Document_Internal_Audit_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Document_Internal_Audit_Result_Stddev_Fields = {
  __typename?: 'document_internal_audit_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Document_Internal_Audit_Result_Stddev_Pop_Fields = {
  __typename?: 'document_internal_audit_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Document_Internal_Audit_Result_Stddev_Samp_Fields = {
  __typename?: 'document_internal_audit_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "document_internal_audit_result" */
export type Document_Internal_Audit_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Internal_Audit_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Internal_Audit_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Document_Internal_Audit_Result_Sum_Fields = {
  __typename?: 'document_internal_audit_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.document_internal_audit_result" */
export const Document_Internal_Audit_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Internal_Audit_Result_Update_Column = typeof Document_Internal_Audit_Result_Update_Column[keyof typeof Document_Internal_Audit_Result_Update_Column];
export type Document_Internal_Audit_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Internal_Audit_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Internal_Audit_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Internal_Audit_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Internal_Audit_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Internal_Audit_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Internal_Audit_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Internal_Audit_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Internal_Audit_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Internal_Audit_Result_Var_Pop_Fields = {
  __typename?: 'document_internal_audit_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Document_Internal_Audit_Result_Var_Samp_Fields = {
  __typename?: 'document_internal_audit_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Document_Internal_Audit_Result_Variance_Fields = {
  __typename?: 'document_internal_audit_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.document_linked_document" */
export type Document_Linked_Document = {
  __typename?: 'document_linked_document';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  DocumentId: Scalars['uuid']['output'];
  LinkedDocumentId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  /** An object relationship */
  child?: Maybe<Document>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Document>;
};

/** order by aggregate values of table "risksmart.document_linked_document" */
export type Document_Linked_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Linked_Document_Max_Order_By>;
  min?: InputMaybe<Document_Linked_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.document_linked_document" */
export type Document_Linked_Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Linked_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Linked_Document_On_Conflict>;
};

/** columns and relationships of "risksmart.document_linked_document_audit" */
export type Document_Linked_Document_Audit = {
  __typename?: 'document_linked_document_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  DocumentId: Scalars['uuid']['output'];
  LinkedDocumentId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.document_linked_document_audit". All fields are combined with a logical 'AND'. */
export type Document_Linked_Document_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  LinkedDocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Linked_Document_Audit_Bool_Exp>>;
  _not?: InputMaybe<Document_Linked_Document_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Linked_Document_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.document_linked_document_audit". */
export type Document_Linked_Document_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DocumentId?: InputMaybe<Order_By>;
  LinkedDocumentId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.document_linked_document_audit" */
export const Document_Linked_Document_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DocumentId: 'DocumentId',
  /** column name */
  LinkedDocumentId: 'LinkedDocumentId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type Document_Linked_Document_Audit_Select_Column = typeof Document_Linked_Document_Audit_Select_Column[keyof typeof Document_Linked_Document_Audit_Select_Column];
/** Streaming cursor of the table "document_linked_document_audit" */
export type Document_Linked_Document_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Linked_Document_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Linked_Document_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DocumentId?: InputMaybe<Scalars['uuid']['input']>;
  LinkedDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_linked_document". All fields are combined with a logical 'AND'. */
export type Document_Linked_Document_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  LinkedDocumentId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Linked_Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Linked_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Linked_Document_Bool_Exp>>;
  child?: InputMaybe<Document_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Document_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.document_linked_document" */
export const Document_Linked_Document_Constraint = {
  /** unique or primary key constraint on columns "DocumentId", "LinkedDocumentId" */
  DocumentLinkedDocumentPkey: 'document_linked_document_pkey'
} as const;

export type Document_Linked_Document_Constraint = typeof Document_Linked_Document_Constraint[keyof typeof Document_Linked_Document_Constraint];
/** input type for inserting data into table "risksmart.document_linked_document" */
export type Document_Linked_Document_Insert_Input = {
  DocumentId?: InputMaybe<Scalars['uuid']['input']>;
  LinkedDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  child?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  parent?: InputMaybe<Document_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.document_linked_document" */
export type Document_Linked_Document_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DocumentId?: InputMaybe<Order_By>;
  LinkedDocumentId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.document_linked_document" */
export type Document_Linked_Document_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DocumentId?: InputMaybe<Order_By>;
  LinkedDocumentId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.document_linked_document" */
export type Document_Linked_Document_Mutation_Response = {
  __typename?: 'document_linked_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Linked_Document>;
};

/** on_conflict condition type for table "risksmart.document_linked_document" */
export type Document_Linked_Document_On_Conflict = {
  constraint: Document_Linked_Document_Constraint;
  update_columns?: Array<Document_Linked_Document_Update_Column>;
  where?: InputMaybe<Document_Linked_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.document_linked_document". */
export type Document_Linked_Document_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DocumentId?: InputMaybe<Order_By>;
  LinkedDocumentId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  child?: InputMaybe<Document_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Document_Order_By>;
};

/** select columns of table "risksmart.document_linked_document" */
export const Document_Linked_Document_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DocumentId: 'DocumentId',
  /** column name */
  LinkedDocumentId: 'LinkedDocumentId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type Document_Linked_Document_Select_Column = typeof Document_Linked_Document_Select_Column[keyof typeof Document_Linked_Document_Select_Column];
/** Streaming cursor of the table "document_linked_document" */
export type Document_Linked_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Linked_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Linked_Document_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DocumentId?: InputMaybe<Scalars['uuid']['input']>;
  LinkedDocumentId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "risksmart.document_linked_document" (current role has no relevant permissions) */
export const Document_Linked_Document_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Document_Linked_Document_Update_Column = typeof Document_Linked_Document_Update_Column[keyof typeof Document_Linked_Document_Update_Column];
/** input type for inserting object relation for remote table "risksmart.document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.document". */
export type Document_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DocumentType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentDocument?: InputMaybe<Order_By>;
  Purpose?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  approvals_aggregate?: InputMaybe<Approval_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  attestationConfig?: InputMaybe<Attestation_Config_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  documentFiles_aggregate?: InputMaybe<Document_File_Aggregate_Order_By>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  linkedDocuments_aggregate?: InputMaybe<Document_Linked_Document_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parent?: InputMaybe<Document_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
  scheduleState?: InputMaybe<Schedule_State_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_Result = {
  __typename?: 'document_second_line_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.document_second_line_result" */
export type Document_Second_Line_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Aggregate = {
  __typename?: 'document_second_line_result_aggregate';
  aggregate?: Maybe<Document_Second_Line_Result_Aggregate_Fields>;
  nodes: Array<Document_Second_Line_Result>;
};

/** aggregate fields of "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Aggregate_Fields = {
  __typename?: 'document_second_line_result_aggregate_fields';
  avg?: Maybe<Document_Second_Line_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Second_Line_Result_Max_Fields>;
  min?: Maybe<Document_Second_Line_Result_Min_Fields>;
  stddev?: Maybe<Document_Second_Line_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Second_Line_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Second_Line_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Second_Line_Result_Sum_Fields>;
  var_pop?: Maybe<Document_Second_Line_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Second_Line_Result_Var_Samp_Fields>;
  variance?: Maybe<Document_Second_Line_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Second_Line_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Second_Line_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Document_Second_Line_Result_Avg_Fields = {
  __typename?: 'document_second_line_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.document_second_line_result". All fields are combined with a logical 'AND'. */
export type Document_Second_Line_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Document_Second_Line_Result_Bool_Exp>>;
  _not?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Second_Line_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Second_Line_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Second_Line_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Second_Line_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Document_Second_Line_Result_Max_Fields = {
  __typename?: 'document_second_line_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Document_Second_Line_Result_Min_Fields = {
  __typename?: 'document_second_line_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Mutation_Response = {
  __typename?: 'document_second_line_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Second_Line_Result>;
};

/** Ordering options when selecting data from "risksmart.document_second_line_result". */
export type Document_Second_Line_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.document_second_line_result */
export type Document_Second_Line_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Second_Line_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.document_second_line_result" */
export const Document_Second_Line_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Document_Second_Line_Result_Select_Column = typeof Document_Second_Line_Result_Select_Column[keyof typeof Document_Second_Line_Result_Select_Column];
/** input type for updating data in table "risksmart.document_second_line_result" */
export type Document_Second_Line_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Document_Second_Line_Result_Stddev_Fields = {
  __typename?: 'document_second_line_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Document_Second_Line_Result_Stddev_Pop_Fields = {
  __typename?: 'document_second_line_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Document_Second_Line_Result_Stddev_Samp_Fields = {
  __typename?: 'document_second_line_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "document_second_line_result" */
export type Document_Second_Line_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Second_Line_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Second_Line_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Document_Second_Line_Result_Sum_Fields = {
  __typename?: 'document_second_line_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

export type Document_Second_Line_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Second_Line_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Second_Line_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Second_Line_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Second_Line_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Second_Line_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Second_Line_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Second_Line_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Second_Line_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Second_Line_Result_Var_Pop_Fields = {
  __typename?: 'document_second_line_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Document_Second_Line_Result_Var_Samp_Fields = {
  __typename?: 'document_second_line_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Document_Second_Line_Result_Variance_Fields = {
  __typename?: 'document_second_line_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "risksmart.document" */
export const Document_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DocumentType: 'DocumentType',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentDocument: 'ParentDocument',
  /** column name */
  Purpose: 'Purpose',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Document_Select_Column = typeof Document_Select_Column[keyof typeof Document_Select_Column];
/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentType?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentDocument?: InputMaybe<Scalars['uuid']['input']>;
  Purpose?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.document" */
export const Document_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DocumentType: 'DocumentType',
  /** column name */
  ParentDocument: 'ParentDocument',
  /** column name */
  Purpose: 'Purpose',
  /** column name */
  Title: 'Title'
} as const;

export type Document_Update_Column = typeof Document_Update_Column[keyof typeof Document_Update_Column];
/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_Risk = {
  __typename?: 'enterprise_risk';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId: Scalars['Int']['output'];
  Tier: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  Treatment?: Maybe<Risk_Treatment_Type_Enum>;
  /** An array relationship */
  children: Array<Enterprise_Risk>;
  /** An aggregate relationship */
  children_aggregate: Enterprise_Risk_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  instances: Array<Enterprise_Risk_Instance>;
  /** An aggregate relationship */
  instances_aggregate: Enterprise_Risk_Instance_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Enterprise_Risk>;
  /** An object relationship */
  parentNode?: Maybe<Node>;
  /** An object relationship */
  score?: Maybe<Enterprise_Risk_Score>;
};


/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_RiskCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_RiskChildrenArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_RiskChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_RiskInstancesArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


/** columns and relationships of "risksmart.enterprise_risk" */
export type Enterprise_RiskInstances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};

/** aggregated selection of "risksmart.enterprise_risk" */
export type Enterprise_Risk_Aggregate = {
  __typename?: 'enterprise_risk_aggregate';
  aggregate?: Maybe<Enterprise_Risk_Aggregate_Fields>;
  nodes: Array<Enterprise_Risk>;
};

export type Enterprise_Risk_Aggregate_Bool_Exp = {
  count?: InputMaybe<Enterprise_Risk_Aggregate_Bool_Exp_Count>;
};

export type Enterprise_Risk_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.enterprise_risk" */
export type Enterprise_Risk_Aggregate_Fields = {
  __typename?: 'enterprise_risk_aggregate_fields';
  avg?: Maybe<Enterprise_Risk_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Enterprise_Risk_Max_Fields>;
  min?: Maybe<Enterprise_Risk_Min_Fields>;
  stddev?: Maybe<Enterprise_Risk_Stddev_Fields>;
  stddev_pop?: Maybe<Enterprise_Risk_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enterprise_Risk_Stddev_Samp_Fields>;
  sum?: Maybe<Enterprise_Risk_Sum_Fields>;
  var_pop?: Maybe<Enterprise_Risk_Var_Pop_Fields>;
  var_samp?: Maybe<Enterprise_Risk_Var_Samp_Fields>;
  variance?: Maybe<Enterprise_Risk_Variance_Fields>;
};


/** aggregate fields of "risksmart.enterprise_risk" */
export type Enterprise_Risk_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Aggregate_Order_By = {
  avg?: InputMaybe<Enterprise_Risk_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enterprise_Risk_Max_Order_By>;
  min?: InputMaybe<Enterprise_Risk_Min_Order_By>;
  stddev?: InputMaybe<Enterprise_Risk_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Enterprise_Risk_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Enterprise_Risk_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Enterprise_Risk_Sum_Order_By>;
  var_pop?: InputMaybe<Enterprise_Risk_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Enterprise_Risk_Var_Samp_Order_By>;
  variance?: InputMaybe<Enterprise_Risk_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Arr_Rel_Insert_Input = {
  data: Array<Enterprise_Risk_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Enterprise_Risk_On_Conflict>;
};

/** aggregate avg on columns */
export type Enterprise_Risk_Avg_Fields = {
  __typename?: 'enterprise_risk_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.enterprise_risk". All fields are combined with a logical 'AND'. */
export type Enterprise_Risk_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Tier?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Enterprise_Risk_Bool_Exp>>;
  _not?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  _or?: InputMaybe<Array<Enterprise_Risk_Bool_Exp>>;
  children?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  children_aggregate?: InputMaybe<Enterprise_Risk_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  instances?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
  instances_aggregate?: InputMaybe<Enterprise_Risk_Instance_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  parentNode?: InputMaybe<Node_Bool_Exp>;
  score?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.enterprise_risk" */
export const Enterprise_Risk_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  EnterpriseRiskPkey: 'enterprise_risk_pkey',
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxEnterpriseRiskOrgkeySequentialid: 'idx_enterprise_risk_orgkey_sequentialid'
} as const;

export type Enterprise_Risk_Constraint = typeof Enterprise_Risk_Constraint[keyof typeof Enterprise_Risk_Constraint];
/** input type for inserting data into table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Tier?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  children?: InputMaybe<Enterprise_Risk_Arr_Rel_Insert_Input>;
  instances?: InputMaybe<Enterprise_Risk_Instance_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Enterprise_Risk_Obj_Rel_Insert_Input>;
  score?: InputMaybe<Enterprise_Risk_Score_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance = {
  __typename?: 'enterprise_risk_instance';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  EnterpriseRiskId?: Maybe<Scalars['uuid']['output']>;
  EntityId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RiskId: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  enterpriseRisk?: Maybe<Enterprise_Risk>;
  /** An object relationship */
  entity?: Maybe<Entity>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  risk?: Maybe<Risk>;
};

/** aggregated selection of "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Aggregate = {
  __typename?: 'enterprise_risk_instance_aggregate';
  aggregate?: Maybe<Enterprise_Risk_Instance_Aggregate_Fields>;
  nodes: Array<Enterprise_Risk_Instance>;
};

export type Enterprise_Risk_Instance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Enterprise_Risk_Instance_Aggregate_Bool_Exp_Count>;
};

export type Enterprise_Risk_Instance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Aggregate_Fields = {
  __typename?: 'enterprise_risk_instance_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enterprise_Risk_Instance_Max_Fields>;
  min?: Maybe<Enterprise_Risk_Instance_Min_Fields>;
};


/** aggregate fields of "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enterprise_Risk_Instance_Max_Order_By>;
  min?: InputMaybe<Enterprise_Risk_Instance_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Arr_Rel_Insert_Input = {
  data: Array<Enterprise_Risk_Instance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Enterprise_Risk_Instance_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.enterprise_risk_instance". All fields are combined with a logical 'AND'. */
export type Enterprise_Risk_Instance_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  EnterpriseRiskId?: InputMaybe<Uuid_Comparison_Exp>;
  EntityId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RiskId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Enterprise_Risk_Instance_Bool_Exp>>;
  _not?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
  _or?: InputMaybe<Array<Enterprise_Risk_Instance_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  entity?: InputMaybe<Entity_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.enterprise_risk_instance" */
export const Enterprise_Risk_Instance_Constraint = {
  /** unique or primary key constraint on columns "RiskId" */
  EnterpriseRiskInstancePkey: 'enterprise_risk_instance_pkey'
} as const;

export type Enterprise_Risk_Instance_Constraint = typeof Enterprise_Risk_Instance_Constraint[keyof typeof Enterprise_Risk_Instance_Constraint];
/** input type for inserting data into table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Insert_Input = {
  EnterpriseRiskId?: InputMaybe<Scalars['uuid']['input']>;
  EntityId?: InputMaybe<Scalars['uuid']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Obj_Rel_Insert_Input>;
  entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enterprise_Risk_Instance_Max_Fields = {
  __typename?: 'enterprise_risk_instance_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  EnterpriseRiskId?: Maybe<Scalars['uuid']['output']>;
  EntityId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  EnterpriseRiskId?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enterprise_Risk_Instance_Min_Fields = {
  __typename?: 'enterprise_risk_instance_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  EnterpriseRiskId?: Maybe<Scalars['uuid']['output']>;
  EntityId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  EnterpriseRiskId?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Obj_Rel_Insert_Input = {
  data: Enterprise_Risk_Instance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enterprise_Risk_Instance_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.enterprise_risk_instance" */
export type Enterprise_Risk_Instance_On_Conflict = {
  constraint: Enterprise_Risk_Instance_Constraint;
  update_columns?: Array<Enterprise_Risk_Instance_Update_Column>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.enterprise_risk_instance". */
export type Enterprise_Risk_Instance_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  EnterpriseRiskId?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Order_By>;
  entity?: InputMaybe<Entity_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.enterprise_risk_instance" */
export const Enterprise_Risk_Instance_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  EnterpriseRiskId: 'EnterpriseRiskId',
  /** column name */
  EntityId: 'EntityId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RiskId: 'RiskId'
} as const;

export type Enterprise_Risk_Instance_Select_Column = typeof Enterprise_Risk_Instance_Select_Column[keyof typeof Enterprise_Risk_Instance_Select_Column];
/** Streaming cursor of the table "enterprise_risk_instance" */
export type Enterprise_Risk_Instance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enterprise_Risk_Instance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enterprise_Risk_Instance_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  EnterpriseRiskId?: InputMaybe<Scalars['uuid']['input']>;
  EntityId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risksmart.enterprise_risk_instance" */
export const Enterprise_Risk_Instance_Update_Column = {
  /** column name */
  EnterpriseRiskId: 'EnterpriseRiskId',
  /** column name */
  EntityId: 'EntityId',
  /** column name */
  RiskId: 'RiskId'
} as const;

export type Enterprise_Risk_Instance_Update_Column = typeof Enterprise_Risk_Instance_Update_Column[keyof typeof Enterprise_Risk_Instance_Update_Column];
/** aggregate max on columns */
export type Enterprise_Risk_Max_Fields = {
  __typename?: 'enterprise_risk_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enterprise_Risk_Min_Fields = {
  __typename?: 'enterprise_risk_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Obj_Rel_Insert_Input = {
  data: Enterprise_Risk_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enterprise_Risk_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.enterprise_risk" */
export type Enterprise_Risk_On_Conflict = {
  constraint: Enterprise_Risk_Constraint;
  update_columns?: Array<Enterprise_Risk_Update_Column>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.enterprise_risk". */
export type Enterprise_Risk_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Treatment?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Enterprise_Risk_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  instances_aggregate?: InputMaybe<Enterprise_Risk_Instance_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Enterprise_Risk_Order_By>;
  parentNode?: InputMaybe<Node_Order_By>;
  score?: InputMaybe<Enterprise_Risk_Score_Order_By>;
};

/** columns and relationships of "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score = {
  __typename?: 'enterprise_risk_score';
  EnterpriseRiskId: Scalars['uuid']['output'];
  InherentRatingMean?: Maybe<Scalars['float8']['output']>;
  InherentRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  InherentScoreMean?: Maybe<Scalars['float8']['output']>;
  InherentScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentScoreWorstCase?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  OrgKey: Scalars['String']['output'];
  ResidualRatingMean?: Maybe<Scalars['float8']['output']>;
  ResidualRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMean?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualScoreWorstCase?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  enterpriseRisk?: Maybe<Enterprise_Risk>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** aggregated selection of "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Aggregate = {
  __typename?: 'enterprise_risk_score_aggregate';
  aggregate?: Maybe<Enterprise_Risk_Score_Aggregate_Fields>;
  nodes: Array<Enterprise_Risk_Score>;
};

/** aggregate fields of "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Aggregate_Fields = {
  __typename?: 'enterprise_risk_score_aggregate_fields';
  avg?: Maybe<Enterprise_Risk_Score_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Enterprise_Risk_Score_Max_Fields>;
  min?: Maybe<Enterprise_Risk_Score_Min_Fields>;
  stddev?: Maybe<Enterprise_Risk_Score_Stddev_Fields>;
  stddev_pop?: Maybe<Enterprise_Risk_Score_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enterprise_Risk_Score_Stddev_Samp_Fields>;
  sum?: Maybe<Enterprise_Risk_Score_Sum_Fields>;
  var_pop?: Maybe<Enterprise_Risk_Score_Var_Pop_Fields>;
  var_samp?: Maybe<Enterprise_Risk_Score_Var_Samp_Fields>;
  variance?: Maybe<Enterprise_Risk_Score_Variance_Fields>;
};


/** aggregate fields of "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enterprise_Risk_Score_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Enterprise_Risk_Score_Avg_Fields = {
  __typename?: 'enterprise_risk_score_avg_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.enterprise_risk_score". All fields are combined with a logical 'AND'. */
export type Enterprise_Risk_Score_Bool_Exp = {
  EnterpriseRiskId?: InputMaybe<Uuid_Comparison_Exp>;
  InherentRatingMean?: InputMaybe<Float8_Comparison_Exp>;
  InherentRatingMedian?: InputMaybe<Float8_Array_Comparison_Exp>;
  InherentRatingWorstCase?: InputMaybe<Float8_Comparison_Exp>;
  InherentScoreMean?: InputMaybe<Float8_Comparison_Exp>;
  InherentScoreMedian?: InputMaybe<Float8_Array_Comparison_Exp>;
  InherentScoreWorstCase?: InputMaybe<Float8_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ResidualRatingMean?: InputMaybe<Float8_Comparison_Exp>;
  ResidualRatingMedian?: InputMaybe<Float8_Array_Comparison_Exp>;
  ResidualRatingWorstCase?: InputMaybe<Float8_Comparison_Exp>;
  ResidualScoreMean?: InputMaybe<Float8_Comparison_Exp>;
  ResidualScoreMedian?: InputMaybe<Float8_Array_Comparison_Exp>;
  ResidualScoreWorstCase?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<Enterprise_Risk_Score_Bool_Exp>>;
  _not?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
  _or?: InputMaybe<Array<Enterprise_Risk_Score_Bool_Exp>>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.enterprise_risk_score" */
export const Enterprise_Risk_Score_Constraint = {
  /** unique or primary key constraint on columns "EnterpriseRiskId" */
  EnterpriseRiskScorePkey: 'enterprise_risk_score_pkey'
} as const;

export type Enterprise_Risk_Score_Constraint = typeof Enterprise_Risk_Score_Constraint[keyof typeof Enterprise_Risk_Score_Constraint];
/** input type for inserting data into table "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Insert_Input = {
  EnterpriseRiskId?: InputMaybe<Scalars['uuid']['input']>;
  InherentRatingMean?: InputMaybe<Scalars['float8']['input']>;
  InherentRatingMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  InherentRatingWorstCase?: InputMaybe<Scalars['float8']['input']>;
  InherentScoreMean?: InputMaybe<Scalars['float8']['input']>;
  InherentScoreMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  InherentScoreWorstCase?: InputMaybe<Scalars['float8']['input']>;
  ResidualRatingMean?: InputMaybe<Scalars['float8']['input']>;
  ResidualRatingMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  ResidualRatingWorstCase?: InputMaybe<Scalars['float8']['input']>;
  ResidualScoreMean?: InputMaybe<Scalars['float8']['input']>;
  ResidualScoreMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  ResidualScoreWorstCase?: InputMaybe<Scalars['float8']['input']>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enterprise_Risk_Score_Max_Fields = {
  __typename?: 'enterprise_risk_score_max_fields';
  EnterpriseRiskId?: Maybe<Scalars['uuid']['output']>;
  InherentRatingMean?: Maybe<Scalars['float8']['output']>;
  InherentRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  InherentScoreMean?: Maybe<Scalars['float8']['output']>;
  InherentScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentScoreWorstCase?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ResidualRatingMean?: Maybe<Scalars['float8']['output']>;
  ResidualRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMean?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualScoreWorstCase?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Enterprise_Risk_Score_Min_Fields = {
  __typename?: 'enterprise_risk_score_min_fields';
  EnterpriseRiskId?: Maybe<Scalars['uuid']['output']>;
  InherentRatingMean?: Maybe<Scalars['float8']['output']>;
  InherentRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  InherentScoreMean?: Maybe<Scalars['float8']['output']>;
  InherentScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  InherentScoreWorstCase?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ResidualRatingMean?: Maybe<Scalars['float8']['output']>;
  ResidualRatingMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMean?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMedian?: Maybe<Array<Scalars['float8']['output']>>;
  ResidualScoreWorstCase?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Mutation_Response = {
  __typename?: 'enterprise_risk_score_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enterprise_Risk_Score>;
};

/** input type for inserting object relation for remote table "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_Obj_Rel_Insert_Input = {
  data: Enterprise_Risk_Score_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enterprise_Risk_Score_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.enterprise_risk_score" */
export type Enterprise_Risk_Score_On_Conflict = {
  constraint: Enterprise_Risk_Score_Constraint;
  update_columns?: Array<Enterprise_Risk_Score_Update_Column>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.enterprise_risk_score". */
export type Enterprise_Risk_Score_Order_By = {
  EnterpriseRiskId?: InputMaybe<Order_By>;
  InherentRatingMean?: InputMaybe<Order_By>;
  InherentRatingMedian?: InputMaybe<Order_By>;
  InherentRatingWorstCase?: InputMaybe<Order_By>;
  InherentScoreMean?: InputMaybe<Order_By>;
  InherentScoreMedian?: InputMaybe<Order_By>;
  InherentScoreWorstCase?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResidualRatingMean?: InputMaybe<Order_By>;
  ResidualRatingMedian?: InputMaybe<Order_By>;
  ResidualRatingWorstCase?: InputMaybe<Order_By>;
  ResidualScoreMean?: InputMaybe<Order_By>;
  ResidualScoreMedian?: InputMaybe<Order_By>;
  ResidualScoreWorstCase?: InputMaybe<Order_By>;
  enterpriseRisk?: InputMaybe<Enterprise_Risk_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** select columns of table "risksmart.enterprise_risk_score" */
export const Enterprise_Risk_Score_Select_Column = {
  /** column name */
  EnterpriseRiskId: 'EnterpriseRiskId',
  /** column name */
  InherentRatingMean: 'InherentRatingMean',
  /** column name */
  InherentRatingMedian: 'InherentRatingMedian',
  /** column name */
  InherentRatingWorstCase: 'InherentRatingWorstCase',
  /** column name */
  InherentScoreMean: 'InherentScoreMean',
  /** column name */
  InherentScoreMedian: 'InherentScoreMedian',
  /** column name */
  InherentScoreWorstCase: 'InherentScoreWorstCase',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ResidualRatingMean: 'ResidualRatingMean',
  /** column name */
  ResidualRatingMedian: 'ResidualRatingMedian',
  /** column name */
  ResidualRatingWorstCase: 'ResidualRatingWorstCase',
  /** column name */
  ResidualScoreMean: 'ResidualScoreMean',
  /** column name */
  ResidualScoreMedian: 'ResidualScoreMedian',
  /** column name */
  ResidualScoreWorstCase: 'ResidualScoreWorstCase'
} as const;

export type Enterprise_Risk_Score_Select_Column = typeof Enterprise_Risk_Score_Select_Column[keyof typeof Enterprise_Risk_Score_Select_Column];
/** aggregate stddev on columns */
export type Enterprise_Risk_Score_Stddev_Fields = {
  __typename?: 'enterprise_risk_score_stddev_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Enterprise_Risk_Score_Stddev_Pop_Fields = {
  __typename?: 'enterprise_risk_score_stddev_pop_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Enterprise_Risk_Score_Stddev_Samp_Fields = {
  __typename?: 'enterprise_risk_score_stddev_samp_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "enterprise_risk_score" */
export type Enterprise_Risk_Score_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enterprise_Risk_Score_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enterprise_Risk_Score_Stream_Cursor_Value_Input = {
  EnterpriseRiskId?: InputMaybe<Scalars['uuid']['input']>;
  InherentRatingMean?: InputMaybe<Scalars['float8']['input']>;
  InherentRatingMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  InherentRatingWorstCase?: InputMaybe<Scalars['float8']['input']>;
  InherentScoreMean?: InputMaybe<Scalars['float8']['input']>;
  InherentScoreMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  InherentScoreWorstCase?: InputMaybe<Scalars['float8']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ResidualRatingMean?: InputMaybe<Scalars['float8']['input']>;
  ResidualRatingMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  ResidualRatingWorstCase?: InputMaybe<Scalars['float8']['input']>;
  ResidualScoreMean?: InputMaybe<Scalars['float8']['input']>;
  ResidualScoreMedian?: InputMaybe<Array<Scalars['float8']['input']>>;
  ResidualScoreWorstCase?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Enterprise_Risk_Score_Sum_Fields = {
  __typename?: 'enterprise_risk_score_sum_fields';
  InherentRatingMean?: Maybe<Scalars['float8']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  InherentScoreMean?: Maybe<Scalars['float8']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['float8']['output']>;
  ResidualRatingMean?: Maybe<Scalars['float8']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['float8']['output']>;
  ResidualScoreMean?: Maybe<Scalars['float8']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "risksmart.enterprise_risk_score" */
export const Enterprise_Risk_Score_Update_Column = {
  /** column name */
  EnterpriseRiskId: 'EnterpriseRiskId',
  /** column name */
  InherentRatingMean: 'InherentRatingMean',
  /** column name */
  InherentRatingMedian: 'InherentRatingMedian',
  /** column name */
  InherentRatingWorstCase: 'InherentRatingWorstCase',
  /** column name */
  InherentScoreMean: 'InherentScoreMean',
  /** column name */
  InherentScoreMedian: 'InherentScoreMedian',
  /** column name */
  InherentScoreWorstCase: 'InherentScoreWorstCase',
  /** column name */
  ResidualRatingMean: 'ResidualRatingMean',
  /** column name */
  ResidualRatingMedian: 'ResidualRatingMedian',
  /** column name */
  ResidualRatingWorstCase: 'ResidualRatingWorstCase',
  /** column name */
  ResidualScoreMean: 'ResidualScoreMean',
  /** column name */
  ResidualScoreMedian: 'ResidualScoreMedian',
  /** column name */
  ResidualScoreWorstCase: 'ResidualScoreWorstCase'
} as const;

export type Enterprise_Risk_Score_Update_Column = typeof Enterprise_Risk_Score_Update_Column[keyof typeof Enterprise_Risk_Score_Update_Column];
/** aggregate var_pop on columns */
export type Enterprise_Risk_Score_Var_Pop_Fields = {
  __typename?: 'enterprise_risk_score_var_pop_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Enterprise_Risk_Score_Var_Samp_Fields = {
  __typename?: 'enterprise_risk_score_var_samp_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Enterprise_Risk_Score_Variance_Fields = {
  __typename?: 'enterprise_risk_score_variance_fields';
  InherentRatingMean?: Maybe<Scalars['Float']['output']>;
  InherentRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  InherentScoreMean?: Maybe<Scalars['Float']['output']>;
  InherentScoreWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualRatingMean?: Maybe<Scalars['Float']['output']>;
  ResidualRatingWorstCase?: Maybe<Scalars['Float']['output']>;
  ResidualScoreMean?: Maybe<Scalars['Float']['output']>;
  ResidualScoreWorstCase?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "risksmart.enterprise_risk" */
export const Enterprise_Risk_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Tier: 'Tier',
  /** column name */
  Title: 'Title',
  /** column name */
  Treatment: 'Treatment'
} as const;

export type Enterprise_Risk_Select_Column = typeof Enterprise_Risk_Select_Column[keyof typeof Enterprise_Risk_Select_Column];
/** aggregate stddev on columns */
export type Enterprise_Risk_Stddev_Fields = {
  __typename?: 'enterprise_risk_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Enterprise_Risk_Stddev_Pop_Fields = {
  __typename?: 'enterprise_risk_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Enterprise_Risk_Stddev_Samp_Fields = {
  __typename?: 'enterprise_risk_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "enterprise_risk" */
export type Enterprise_Risk_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enterprise_Risk_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enterprise_Risk_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Tier?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
};

/** aggregate sum on columns */
export type Enterprise_Risk_Sum_Fields = {
  __typename?: 'enterprise_risk_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.enterprise_risk" */
export const Enterprise_Risk_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Tier: 'Tier',
  /** column name */
  Title: 'Title',
  /** column name */
  Treatment: 'Treatment'
} as const;

export type Enterprise_Risk_Update_Column = typeof Enterprise_Risk_Update_Column[keyof typeof Enterprise_Risk_Update_Column];
/** aggregate var_pop on columns */
export type Enterprise_Risk_Var_Pop_Fields = {
  __typename?: 'enterprise_risk_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Enterprise_Risk_Var_Samp_Fields = {
  __typename?: 'enterprise_risk_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Enterprise_Risk_Variance_Fields = {
  __typename?: 'enterprise_risk_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.enterprise_risk" */
export type Enterprise_Risk_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.entity" */
export type Entity = {
  __typename?: 'entity';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  Weight: Scalars['numeric']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  children: Array<Entity>;
  /** An aggregate relationship */
  children_aggregate: Entity_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** Returns the descendants of the entity */
  descendants?: Maybe<Array<Entity>>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  parent?: Maybe<Entity>;
  /** An object relationship */
  parentNode?: Maybe<Node>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityChildrenArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityDescendantsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.entity" */
export type EntityOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** aggregated selection of "risksmart.entity" */
export type Entity_Aggregate = {
  __typename?: 'entity_aggregate';
  aggregate?: Maybe<Entity_Aggregate_Fields>;
  nodes: Array<Entity>;
};

export type Entity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Entity_Aggregate_Bool_Exp_Count>;
};

export type Entity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.entity" */
export type Entity_Aggregate_Fields = {
  __typename?: 'entity_aggregate_fields';
  avg?: Maybe<Entity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Entity_Max_Fields>;
  min?: Maybe<Entity_Min_Fields>;
  stddev?: Maybe<Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Entity_Sum_Fields>;
  var_pop?: Maybe<Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Entity_Var_Samp_Fields>;
  variance?: Maybe<Entity_Variance_Fields>;
};


/** aggregate fields of "risksmart.entity" */
export type Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.entity" */
export type Entity_Aggregate_Order_By = {
  avg?: InputMaybe<Entity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_Max_Order_By>;
  min?: InputMaybe<Entity_Min_Order_By>;
  stddev?: InputMaybe<Entity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entity_Sum_Order_By>;
  var_pop?: InputMaybe<Entity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entity_Var_Samp_Order_By>;
  variance?: InputMaybe<Entity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.entity" */
export type Entity_Arr_Rel_Insert_Input = {
  data: Array<Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};

/** aggregate avg on columns */
export type Entity_Avg_Fields = {
  __typename?: 'entity_avg_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.entity" */
export type Entity_Avg_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.entity". All fields are combined with a logical 'AND'. */
export type Entity_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Weight?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<Entity_Bool_Exp>>;
  _not?: InputMaybe<Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  children?: InputMaybe<Entity_Bool_Exp>;
  children_aggregate?: InputMaybe<Entity_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  descendants?: InputMaybe<Entity_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Entity_Bool_Exp>;
  parentNode?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.entity" */
export const Entity_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  EntityPkey: 'entity_pkey'
} as const;

export type Entity_Constraint = typeof Entity_Constraint[keyof typeof Entity_Constraint];
/** input type for inserting data into table "risksmart.entity" */
export type Entity_Insert_Input = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight?: InputMaybe<Scalars['numeric']['input']>;
  children?: InputMaybe<Entity_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Entity_Max_Fields = {
  __typename?: 'entity_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  Weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "risksmart.entity" */
export type Entity_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_Min_Fields = {
  __typename?: 'entity_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  Weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "risksmart.entity" */
export type Entity_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Weight?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.entity" */
export type Entity_Obj_Rel_Insert_Input = {
  data: Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.entity" */
export type Entity_On_Conflict = {
  constraint: Entity_Constraint;
  update_columns?: Array<Entity_Update_Column>;
  where?: InputMaybe<Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.entity". */
export type Entity_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Weight?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Entity_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  descendants_aggregate?: InputMaybe<Entity_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parent?: InputMaybe<Entity_Order_By>;
  parentNode?: InputMaybe<Node_Order_By>;
};

/** select columns of table "risksmart.entity" */
export const Entity_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Weight: 'Weight'
} as const;

export type Entity_Select_Column = typeof Entity_Select_Column[keyof typeof Entity_Select_Column];
/** aggregate stddev on columns */
export type Entity_Stddev_Fields = {
  __typename?: 'entity_stddev_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.entity" */
export type Entity_Stddev_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Entity_Stddev_Pop_Fields = {
  __typename?: 'entity_stddev_pop_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.entity" */
export type Entity_Stddev_Pop_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Entity_Stddev_Samp_Fields = {
  __typename?: 'entity_stddev_samp_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.entity" */
export type Entity_Stddev_Samp_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entity" */
export type Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Entity_Sum_Fields = {
  __typename?: 'entity_sum_fields';
  Weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "risksmart.entity" */
export type Entity_Sum_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.entity" */
export const Entity_Update_Column = {
  /** column name */
  Description: 'Description',
  /** column name */
  Name: 'Name',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Weight: 'Weight'
} as const;

export type Entity_Update_Column = typeof Entity_Update_Column[keyof typeof Entity_Update_Column];
/** aggregate var_pop on columns */
export type Entity_Var_Pop_Fields = {
  __typename?: 'entity_var_pop_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.entity" */
export type Entity_Var_Pop_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Entity_Var_Samp_Fields = {
  __typename?: 'entity_var_samp_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.entity" */
export type Entity_Var_Samp_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Entity_Variance_Fields = {
  __typename?: 'entity_variance_fields';
  Weight?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.entity" */
export type Entity_Variance_Order_By = {
  Weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.file" */
export type File = {
  __typename?: 'file';
  ContentType: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  FileName: Scalars['String']['output'];
  FileSize: Scalars['Int']['output'];
  Id: Scalars['uuid']['output'];
  Meta?: Maybe<Scalars['json']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  documentFile?: Maybe<Document_File>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  relationFile: Array<Relation_File>;
  /** An aggregate relationship */
  relationFile_aggregate: Relation_File_Aggregate;
};


/** columns and relationships of "risksmart.file" */
export type FileMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.file" */
export type FileRelationFileArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.file" */
export type FileRelationFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** aggregated selection of "risksmart.file" */
export type File_Aggregate = {
  __typename?: 'file_aggregate';
  aggregate?: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

/** aggregate fields of "risksmart.file" */
export type File_Aggregate_Fields = {
  __typename?: 'file_aggregate_fields';
  avg?: Maybe<File_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<File_Max_Fields>;
  min?: Maybe<File_Min_Fields>;
  stddev?: Maybe<File_Stddev_Fields>;
  stddev_pop?: Maybe<File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Stddev_Samp_Fields>;
  sum?: Maybe<File_Sum_Fields>;
  var_pop?: Maybe<File_Var_Pop_Fields>;
  var_samp?: Maybe<File_Var_Samp_Fields>;
  variance?: Maybe<File_Variance_Fields>;
};


/** aggregate fields of "risksmart.file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.file_audit" */
export type File_Audit = {
  __typename?: 'file_audit';
  ContentType: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  FileName: Scalars['String']['output'];
  FileSize: Scalars['Int']['output'];
  Id: Scalars['uuid']['output'];
  Meta?: Maybe<Scalars['json']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.file_audit" */
export type File_AuditMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.file_audit". All fields are combined with a logical 'AND'. */
export type File_Audit_Bool_Exp = {
  ContentType?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  FileSize?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Meta?: InputMaybe<Json_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<File_Audit_Bool_Exp>>;
  _not?: InputMaybe<File_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<File_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.file_audit". */
export type File_Audit_Order_By = {
  ContentType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  FileSize?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Meta?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.file_audit" */
export const File_Audit_Select_Column = {
  /** column name */
  ContentType: 'ContentType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FileName: 'FileName',
  /** column name */
  FileSize: 'FileSize',
  /** column name */
  Id: 'Id',
  /** column name */
  Meta: 'Meta',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type File_Audit_Select_Column = typeof File_Audit_Select_Column[keyof typeof File_Audit_Select_Column];
/** Streaming cursor of the table "file_audit" */
export type File_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Audit_Stream_Cursor_Value_Input = {
  ContentType?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FileName?: InputMaybe<Scalars['String']['input']>;
  FileSize?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type File_Avg_Fields = {
  __typename?: 'file_avg_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  ContentType?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  FileSize?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Meta?: InputMaybe<Json_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  documentFile?: InputMaybe<Document_File_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  relationFile?: InputMaybe<Relation_File_Bool_Exp>;
  relationFile_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.file" */
export const File_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  FilePkey: 'file_pkey'
} as const;

export type File_Constraint = typeof File_Constraint[keyof typeof File_Constraint];
/** input type for inserting data into table "risksmart.file" */
export type File_Insert_Input = {
  ContentType?: InputMaybe<Scalars['String']['input']>;
  FileName?: InputMaybe<Scalars['String']['input']>;
  FileSize?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  documentFile?: InputMaybe<Document_File_Obj_Rel_Insert_Input>;
  relationFile?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  __typename?: 'file_max_fields';
  ContentType?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  __typename?: 'file_min_fields';
  ContentType?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.file" */
export type File_Mutation_Response = {
  __typename?: 'file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "risksmart.file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.file". */
export type File_Order_By = {
  ContentType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  FileSize?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Meta?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  documentFile?: InputMaybe<Document_File_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  relationFile_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
};

/** select columns of table "risksmart.file" */
export const File_Select_Column = {
  /** column name */
  ContentType: 'ContentType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FileName: 'FileName',
  /** column name */
  FileSize: 'FileSize',
  /** column name */
  Id: 'Id',
  /** column name */
  Meta: 'Meta',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser'
} as const;

export type File_Select_Column = typeof File_Select_Column[keyof typeof File_Select_Column];
/** aggregate stddev on columns */
export type File_Stddev_Fields = {
  __typename?: 'file_stddev_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type File_Stddev_Pop_Fields = {
  __typename?: 'file_stddev_pop_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type File_Stddev_Samp_Fields = {
  __typename?: 'file_stddev_samp_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  ContentType?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FileName?: InputMaybe<Scalars['String']['input']>;
  FileSize?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type File_Sum_Fields = {
  __typename?: 'file_sum_fields';
  FileSize?: Maybe<Scalars['Int']['output']>;
};

/** placeholder for update columns of table "risksmart.file" (current role has no relevant permissions) */
export const File_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type File_Update_Column = typeof File_Update_Column[keyof typeof File_Update_Column];
/** aggregate var_pop on columns */
export type File_Var_Pop_Fields = {
  __typename?: 'file_var_pop_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type File_Var_Samp_Fields = {
  __typename?: 'file_var_samp_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type File_Variance_Fields = {
  __typename?: 'file_variance_fields';
  FileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "risksmart.form_configuration" */
export type Form_Configuration = {
  __typename?: 'form_configuration';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeSchemaId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentType: Parent_Type_Enum;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  customAttributeSchema?: Maybe<Custom_Attribute_Schema>;
  /** An array relationship */
  fields_config: Array<Form_Field_Configuration>;
  /** An array relationship */
  fields_ordering: Array<Form_Field_Ordering>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};


/** columns and relationships of "risksmart.form_configuration" */
export type Form_ConfigurationFields_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Configuration_Order_By>>;
  where?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
};


/** columns and relationships of "risksmart.form_configuration" */
export type Form_ConfigurationFields_OrderingArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Ordering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Ordering_Order_By>>;
  where?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
};

/** columns and relationships of "risksmart.form_configuration_audit" */
export type Form_Configuration_Audit = {
  __typename?: 'form_configuration_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeSchemaId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentType: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.form_configuration_audit". All fields are combined with a logical 'AND'. */
export type Form_Configuration_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeSchemaId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Configuration_Audit_Bool_Exp>>;
  _not?: InputMaybe<Form_Configuration_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Configuration_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.form_configuration_audit". */
export type Form_Configuration_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeSchemaId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.form_configuration_audit" */
export const Form_Configuration_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeSchemaId: 'CustomAttributeSchemaId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Form_Configuration_Audit_Select_Column = typeof Form_Configuration_Audit_Select_Column[keyof typeof Form_Configuration_Audit_Select_Column];
/** Streaming cursor of the table "form_configuration_audit" */
export type Form_Configuration_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Configuration_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Configuration_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeSchemaId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.form_configuration". All fields are combined with a logical 'AND'. */
export type Form_Configuration_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeSchemaId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Form_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Configuration_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  customAttributeSchema?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
  fields_config?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
  fields_ordering?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.form_configuration" */
export const Form_Configuration_Constraint = {
  /** unique or primary key constraint on columns "OrgKey", "ParentType" */
  FormConfigurationPkey: 'form_configuration_pkey'
} as const;

export type Form_Configuration_Constraint = typeof Form_Configuration_Constraint[keyof typeof Form_Configuration_Constraint];
/** input type for inserting data into table "risksmart.form_configuration" */
export type Form_Configuration_Insert_Input = {
  CustomAttributeSchemaId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  customAttributeSchema?: InputMaybe<Custom_Attribute_Schema_Obj_Rel_Insert_Input>;
  fields_config?: InputMaybe<Form_Field_Configuration_Arr_Rel_Insert_Input>;
  fields_ordering?: InputMaybe<Form_Field_Ordering_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.form_configuration" */
export type Form_Configuration_Mutation_Response = {
  __typename?: 'form_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Form_Configuration>;
};

/** input type for inserting object relation for remote table "risksmart.form_configuration" */
export type Form_Configuration_Obj_Rel_Insert_Input = {
  data: Form_Configuration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Form_Configuration_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.form_configuration" */
export type Form_Configuration_On_Conflict = {
  constraint: Form_Configuration_Constraint;
  update_columns?: Array<Form_Configuration_Update_Column>;
  where?: InputMaybe<Form_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.form_configuration". */
export type Form_Configuration_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeSchemaId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  customAttributeSchema?: InputMaybe<Custom_Attribute_Schema_Order_By>;
  fields_config_aggregate?: InputMaybe<Form_Field_Configuration_Aggregate_Order_By>;
  fields_ordering_aggregate?: InputMaybe<Form_Field_Ordering_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.form_configuration" */
export const Form_Configuration_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeSchemaId: 'CustomAttributeSchemaId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Form_Configuration_Select_Column = typeof Form_Configuration_Select_Column[keyof typeof Form_Configuration_Select_Column];
/** input type for updating data in table "risksmart.form_configuration" */
export type Form_Configuration_Set_Input = {
  CustomAttributeSchemaId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** Streaming cursor of the table "form_configuration" */
export type Form_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Configuration_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeSchemaId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** update columns of table "risksmart.form_configuration" */
export const Form_Configuration_Update_Column = {
  /** column name */
  CustomAttributeSchemaId: 'CustomAttributeSchemaId',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Form_Configuration_Update_Column = typeof Form_Configuration_Update_Column[keyof typeof Form_Configuration_Update_Column];
export type Form_Configuration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Form_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Form_Configuration_Bool_Exp;
};

/** columns and relationships of "risksmart.form_field_configuration" */
export type Form_Field_Configuration = {
  __typename?: 'form_field_configuration';
  Conditions?: Maybe<Scalars['jsonb']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  FieldId: Scalars['String']['output'];
  FormConfigurationParentType: Parent_Type_Enum;
  Hidden: Scalars['Boolean']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ReadOnly: Scalars['Boolean']['output'];
  Required: Scalars['Boolean']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  form?: Maybe<Form_Configuration>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};


/** columns and relationships of "risksmart.form_field_configuration" */
export type Form_Field_ConfigurationConditionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Form_Field_Configuration_Max_Order_By>;
  min?: InputMaybe<Form_Field_Configuration_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Form_Field_Configuration_Append_Input = {
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Arr_Rel_Insert_Input = {
  data: Array<Form_Field_Configuration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Form_Field_Configuration_On_Conflict>;
};

/** columns and relationships of "risksmart.form_field_configuration_audit" */
export type Form_Field_Configuration_Audit = {
  __typename?: 'form_field_configuration_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  FieldId: Scalars['String']['output'];
  FormConfigurationParentType: Scalars['String']['output'];
  Hidden: Scalars['Boolean']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ReadOnly: Scalars['Boolean']['output'];
  Required: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.form_field_configuration_audit". All fields are combined with a logical 'AND'. */
export type Form_Field_Configuration_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FieldId?: InputMaybe<String_Comparison_Exp>;
  FormConfigurationParentType?: InputMaybe<String_Comparison_Exp>;
  Hidden?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ReadOnly?: InputMaybe<Boolean_Comparison_Exp>;
  Required?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Field_Configuration_Audit_Bool_Exp>>;
  _not?: InputMaybe<Form_Field_Configuration_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Field_Configuration_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.form_field_configuration_audit". */
export type Form_Field_Configuration_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  FormConfigurationParentType?: InputMaybe<Order_By>;
  Hidden?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ReadOnly?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.form_field_configuration_audit" */
export const Form_Field_Configuration_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  Hidden: 'Hidden',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ReadOnly: 'ReadOnly',
  /** column name */
  Required: 'Required'
} as const;

export type Form_Field_Configuration_Audit_Select_Column = typeof Form_Field_Configuration_Audit_Select_Column[keyof typeof Form_Field_Configuration_Audit_Select_Column];
/** Streaming cursor of the table "form_field_configuration_audit" */
export type Form_Field_Configuration_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Field_Configuration_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Field_Configuration_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Scalars['String']['input']>;
  Hidden?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  Required?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.form_field_configuration". All fields are combined with a logical 'AND'. */
export type Form_Field_Configuration_Bool_Exp = {
  Conditions?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  DefaultValue?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  FieldId?: InputMaybe<String_Comparison_Exp>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  Hidden?: InputMaybe<Boolean_Comparison_Exp>;
  Label?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ReadOnly?: InputMaybe<Boolean_Comparison_Exp>;
  Required?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Field_Configuration_Bool_Exp>>;
  _not?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Field_Configuration_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  form?: InputMaybe<Form_Configuration_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.form_field_configuration" */
export const Form_Field_Configuration_Constraint = {
  /** unique or primary key constraint on columns "FormConfigurationParentType", "OrgKey", "FieldId" */
  FormFieldConfigurationPkey1: 'form_field_configuration_pkey1'
} as const;

export type Form_Field_Configuration_Constraint = typeof Form_Field_Configuration_Constraint[keyof typeof Form_Field_Configuration_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Form_Field_Configuration_Delete_At_Path_Input = {
  Conditions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Form_Field_Configuration_Delete_Elem_Input = {
  Conditions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Form_Field_Configuration_Delete_Key_Input = {
  Conditions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Insert_Input = {
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  Hidden?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  Required?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Form_Configuration_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Mutation_Response = {
  __typename?: 'form_field_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Form_Field_Configuration>;
};

/** on_conflict condition type for table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_On_Conflict = {
  constraint: Form_Field_Configuration_Constraint;
  update_columns?: Array<Form_Field_Configuration_Update_Column>;
  where?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.form_field_configuration". */
export type Form_Field_Configuration_Order_By = {
  Conditions?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  DefaultValue?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  FormConfigurationParentType?: InputMaybe<Order_By>;
  Hidden?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ReadOnly?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  form?: InputMaybe<Form_Configuration_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Form_Field_Configuration_Prepend_Input = {
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.form_field_configuration" */
export const Form_Field_Configuration_Select_Column = {
  /** column name */
  Conditions: 'Conditions',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  DefaultValue: 'DefaultValue',
  /** column name */
  Description: 'Description',
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  Hidden: 'Hidden',
  /** column name */
  Label: 'Label',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ReadOnly: 'ReadOnly',
  /** column name */
  Required: 'Required'
} as const;

export type Form_Field_Configuration_Select_Column = typeof Form_Field_Configuration_Select_Column[keyof typeof Form_Field_Configuration_Select_Column];
/** input type for updating data in table "risksmart.form_field_configuration" */
export type Form_Field_Configuration_Set_Input = {
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  Hidden?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  Required?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "form_field_configuration" */
export type Form_Field_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Field_Configuration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Field_Configuration_Stream_Cursor_Value_Input = {
  Conditions?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  DefaultValue?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  Hidden?: InputMaybe<Scalars['Boolean']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  Required?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "risksmart.form_field_configuration" */
export const Form_Field_Configuration_Update_Column = {
  /** column name */
  Conditions: 'Conditions',
  /** column name */
  DefaultValue: 'DefaultValue',
  /** column name */
  Description: 'Description',
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  Hidden: 'Hidden',
  /** column name */
  Label: 'Label',
  /** column name */
  ReadOnly: 'ReadOnly',
  /** column name */
  Required: 'Required'
} as const;

export type Form_Field_Configuration_Update_Column = typeof Form_Field_Configuration_Update_Column[keyof typeof Form_Field_Configuration_Update_Column];
export type Form_Field_Configuration_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Form_Field_Configuration_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Form_Field_Configuration_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Form_Field_Configuration_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Form_Field_Configuration_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Form_Field_Configuration_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Form_Field_Configuration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Form_Field_Configuration_Bool_Exp;
};

/** columns and relationships of "risksmart.form_field_ordering" */
export type Form_Field_Ordering = {
  __typename?: 'form_field_ordering';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  FieldId: Scalars['String']['output'];
  FormConfigurationParentType: Parent_Type_Enum;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Position: Scalars['Int']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  form?: Maybe<Form_Configuration>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
};

/** order by aggregate values of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Aggregate_Order_By = {
  avg?: InputMaybe<Form_Field_Ordering_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Form_Field_Ordering_Max_Order_By>;
  min?: InputMaybe<Form_Field_Ordering_Min_Order_By>;
  stddev?: InputMaybe<Form_Field_Ordering_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Form_Field_Ordering_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Form_Field_Ordering_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Form_Field_Ordering_Sum_Order_By>;
  var_pop?: InputMaybe<Form_Field_Ordering_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Form_Field_Ordering_Var_Samp_Order_By>;
  variance?: InputMaybe<Form_Field_Ordering_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Arr_Rel_Insert_Input = {
  data: Array<Form_Field_Ordering_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Form_Field_Ordering_On_Conflict>;
};

/** columns and relationships of "risksmart.form_field_ordering_audit" */
export type Form_Field_Ordering_Audit = {
  __typename?: 'form_field_ordering_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  FieldId: Scalars['String']['output'];
  FormConfigurationParentType: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Position: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.form_field_ordering_audit". All fields are combined with a logical 'AND'. */
export type Form_Field_Ordering_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FieldId?: InputMaybe<String_Comparison_Exp>;
  FormConfigurationParentType?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Position?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Field_Ordering_Audit_Bool_Exp>>;
  _not?: InputMaybe<Form_Field_Ordering_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Field_Ordering_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.form_field_ordering_audit". */
export type Form_Field_Ordering_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  FormConfigurationParentType?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Position?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.form_field_ordering_audit" */
export const Form_Field_Ordering_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Position: 'Position'
} as const;

export type Form_Field_Ordering_Audit_Select_Column = typeof Form_Field_Ordering_Audit_Select_Column[keyof typeof Form_Field_Ordering_Audit_Select_Column];
/** Streaming cursor of the table "form_field_ordering_audit" */
export type Form_Field_Ordering_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Field_Ordering_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Field_Ordering_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Position?: InputMaybe<Scalars['Int']['input']>;
};

/** order by avg() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Avg_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.form_field_ordering". All fields are combined with a logical 'AND'. */
export type Form_Field_Ordering_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FieldId?: InputMaybe<String_Comparison_Exp>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Position?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Form_Field_Ordering_Bool_Exp>>;
  _not?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
  _or?: InputMaybe<Array<Form_Field_Ordering_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  form?: InputMaybe<Form_Configuration_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.form_field_ordering" */
export const Form_Field_Ordering_Constraint = {
  /** unique or primary key constraint on columns "FormConfigurationParentType", "OrgKey", "FieldId" */
  FormFieldConfigurationPkey: 'form_field_configuration_pkey'
} as const;

export type Form_Field_Ordering_Constraint = typeof Form_Field_Ordering_Constraint[keyof typeof Form_Field_Ordering_Constraint];
/** input type for incrementing numeric columns in table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Inc_Input = {
  Position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Insert_Input = {
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  Position?: InputMaybe<Scalars['Int']['input']>;
  form?: InputMaybe<Form_Configuration_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Position?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Position?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Mutation_Response = {
  __typename?: 'form_field_ordering_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Form_Field_Ordering>;
};

/** on_conflict condition type for table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_On_Conflict = {
  constraint: Form_Field_Ordering_Constraint;
  update_columns?: Array<Form_Field_Ordering_Update_Column>;
  where?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.form_field_ordering". */
export type Form_Field_Ordering_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FieldId?: InputMaybe<Order_By>;
  FormConfigurationParentType?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Position?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  form?: InputMaybe<Form_Configuration_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.form_field_ordering" */
export const Form_Field_Ordering_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Position: 'Position'
} as const;

export type Form_Field_Ordering_Select_Column = typeof Form_Field_Ordering_Select_Column[keyof typeof Form_Field_Ordering_Select_Column];
/** input type for updating data in table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Set_Input = {
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  Position?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Stddev_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Stddev_Pop_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Stddev_Samp_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "form_field_ordering" */
export type Form_Field_Ordering_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Form_Field_Ordering_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Form_Field_Ordering_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FieldId?: InputMaybe<Scalars['String']['input']>;
  FormConfigurationParentType?: InputMaybe<Parent_Type_Enum>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Position?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Sum_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.form_field_ordering" */
export const Form_Field_Ordering_Update_Column = {
  /** column name */
  FieldId: 'FieldId',
  /** column name */
  FormConfigurationParentType: 'FormConfigurationParentType',
  /** column name */
  Position: 'Position'
} as const;

export type Form_Field_Ordering_Update_Column = typeof Form_Field_Ordering_Update_Column[keyof typeof Form_Field_Ordering_Update_Column];
export type Form_Field_Ordering_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Form_Field_Ordering_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Form_Field_Ordering_Set_Input>;
  /** filter the rows which have to be updated */
  where: Form_Field_Ordering_Bool_Exp;
};

/** order by var_pop() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Var_Pop_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Var_Samp_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.form_field_ordering" */
export type Form_Field_Ordering_Variance_Order_By = {
  Position?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.impact" */
export type Impact = {
  __typename?: 'impact';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  LikelihoodAppetite?: Maybe<Scalars['smallint']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  RatingGuidance?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  SequentialId: Scalars['Int']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  appetites: Array<Appetite>;
  /** An aggregate relationship */
  appetites_aggregate: Appetite_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  parents: Array<Impact_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Impact_Parent_Aggregate;
  /** An array relationship */
  ratings: Array<Impact_Rating>;
  /** An aggregate relationship */
  ratings_aggregate: Impact_Rating_Aggregate;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactAppetitesArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactAppetites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactParentsArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactRatingsArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact" */
export type ImpactRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};

/** aggregated selection of "risksmart.impact" */
export type Impact_Aggregate = {
  __typename?: 'impact_aggregate';
  aggregate?: Maybe<Impact_Aggregate_Fields>;
  nodes: Array<Impact>;
};

/** aggregate fields of "risksmart.impact" */
export type Impact_Aggregate_Fields = {
  __typename?: 'impact_aggregate_fields';
  avg?: Maybe<Impact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Impact_Max_Fields>;
  min?: Maybe<Impact_Min_Fields>;
  stddev?: Maybe<Impact_Stddev_Fields>;
  stddev_pop?: Maybe<Impact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Impact_Stddev_Samp_Fields>;
  sum?: Maybe<Impact_Sum_Fields>;
  var_pop?: Maybe<Impact_Var_Pop_Fields>;
  var_samp?: Maybe<Impact_Var_Samp_Fields>;
  variance?: Maybe<Impact_Variance_Fields>;
};


/** aggregate fields of "risksmart.impact" */
export type Impact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Impact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.impact_audit" */
export type Impact_Audit = {
  __typename?: 'impact_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  LikelihoodAppetite?: Maybe<Scalars['smallint']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  RatingGuidance?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  SequentialId: Scalars['Int']['output'];
};


/** columns and relationships of "risksmart.impact_audit" */
export type Impact_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_audit". All fields are combined with a logical 'AND'. */
export type Impact_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LikelihoodAppetite?: InputMaybe<Smallint_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  RatingGuidance?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Audit_Bool_Exp>>;
  _not?: InputMaybe<Impact_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.impact_audit". */
export type Impact_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  RatingGuidance?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.impact_audit" */
export const Impact_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  RatingGuidance: 'RatingGuidance',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  SequentialId: 'SequentialId'
} as const;

export type Impact_Audit_Select_Column = typeof Impact_Audit_Select_Column[keyof typeof Impact_Audit_Select_Column];
/** Streaming cursor of the table "impact_audit" */
export type Impact_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['smallint']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  RatingGuidance?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate avg on columns */
export type Impact_Avg_Fields = {
  __typename?: 'impact_avg_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.impact". All fields are combined with a logical 'AND'. */
export type Impact_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LikelihoodAppetite?: InputMaybe<Smallint_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  RatingGuidance?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Bool_Exp>>;
  _not?: InputMaybe<Impact_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  appetites?: InputMaybe<Appetite_Bool_Exp>;
  appetites_aggregate?: InputMaybe<Appetite_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Impact_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Impact_Parent_Aggregate_Bool_Exp>;
  ratings?: InputMaybe<Impact_Rating_Bool_Exp>;
  ratings_aggregate?: InputMaybe<Impact_Rating_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.impact" */
export const Impact_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ImpactPkey: 'impact_pkey'
} as const;

export type Impact_Constraint = typeof Impact_Constraint[keyof typeof Impact_Constraint];
/** input type for inserting data into table "risksmart.impact" */
export type Impact_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['smallint']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  RatingGuidance?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  appetites?: InputMaybe<Appetite_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Impact_Parent_Arr_Rel_Insert_Input>;
  ratings?: InputMaybe<Impact_Rating_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating = {
  __typename?: 'impact_internal_audit_rating';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactId: Scalars['uuid']['output'];
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RatedItemId: Scalars['uuid']['output'];
  Rating: Scalars['smallint']['output'];
  SequentialId: Scalars['Int']['output'];
  TestDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  completedBy?: Maybe<User>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  impact: Impact;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parentLinks: Array<Linked_Item>;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
  /** An object relationship */
  ratedItem: Node;
};


/** columns and relationships of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_RatingCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_RatingParentLinksArgs = {
  distinct_on?: InputMaybe<Array<Linked_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Linked_Item_Order_By>>;
  where?: InputMaybe<Linked_Item_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_RatingParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_RatingParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Aggregate = {
  __typename?: 'impact_internal_audit_rating_aggregate';
  aggregate?: Maybe<Impact_Internal_Audit_Rating_Aggregate_Fields>;
  nodes: Array<Impact_Internal_Audit_Rating>;
};

/** aggregate fields of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Aggregate_Fields = {
  __typename?: 'impact_internal_audit_rating_aggregate_fields';
  avg?: Maybe<Impact_Internal_Audit_Rating_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Impact_Internal_Audit_Rating_Max_Fields>;
  min?: Maybe<Impact_Internal_Audit_Rating_Min_Fields>;
  stddev?: Maybe<Impact_Internal_Audit_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<Impact_Internal_Audit_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Impact_Internal_Audit_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<Impact_Internal_Audit_Rating_Sum_Fields>;
  var_pop?: Maybe<Impact_Internal_Audit_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<Impact_Internal_Audit_Rating_Var_Samp_Fields>;
  variance?: Maybe<Impact_Internal_Audit_Rating_Variance_Fields>;
};


/** aggregate fields of "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Impact_Internal_Audit_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Impact_Internal_Audit_Rating_Avg_Fields = {
  __typename?: 'impact_internal_audit_rating_avg_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_internal_audit_rating". All fields are combined with a logical 'AND'. */
export type Impact_Internal_Audit_Rating_Bool_Exp = {
  CompletedBy?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RatedItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Rating?: InputMaybe<Smallint_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Internal_Audit_Rating_Bool_Exp>>;
  _not?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Internal_Audit_Rating_Bool_Exp>>;
  completedBy?: InputMaybe<User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parentLinks?: InputMaybe<Linked_Item_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
  ratedItem?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.impact_internal_audit_rating" */
export const Impact_Internal_Audit_Rating_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ImpactInternalAuditRatingPkey: 'impact_internal_audit_rating_pkey'
} as const;

export type Impact_Internal_Audit_Rating_Constraint = typeof Impact_Internal_Audit_Rating_Constraint[keyof typeof Impact_Internal_Audit_Rating_Constraint];
/** input type for inserting data into table "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Insert_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
  parentLinks?: InputMaybe<Linked_Item_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Impact_Internal_Audit_Rating_Max_Fields = {
  __typename?: 'impact_internal_audit_rating_max_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Impact_Internal_Audit_Rating_Min_Fields = {
  __typename?: 'impact_internal_audit_rating_min_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Mutation_Response = {
  __typename?: 'impact_internal_audit_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Impact_Internal_Audit_Rating>;
};

/** input type for inserting object relation for remote table "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Obj_Rel_Insert_Input = {
  data: Impact_Internal_Audit_Rating_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Impact_Internal_Audit_Rating_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_On_Conflict = {
  constraint: Impact_Internal_Audit_Rating_Constraint;
  update_columns?: Array<Impact_Internal_Audit_Rating_Update_Column>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.impact_internal_audit_rating". */
export type Impact_Internal_Audit_Rating_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  completedBy?: InputMaybe<User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parentLinks_aggregate?: InputMaybe<Linked_Item_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
  ratedItem?: InputMaybe<Node_Order_By>;
};

/** select columns of table "risksmart.impact_internal_audit_rating" */
export const Impact_Internal_Audit_Rating_Select_Column = {
  /** column name */
  CompletedBy: 'CompletedBy',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RatedItemId: 'RatedItemId',
  /** column name */
  Rating: 'Rating',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Impact_Internal_Audit_Rating_Select_Column = typeof Impact_Internal_Audit_Rating_Select_Column[keyof typeof Impact_Internal_Audit_Rating_Select_Column];
/** aggregate stddev on columns */
export type Impact_Internal_Audit_Rating_Stddev_Fields = {
  __typename?: 'impact_internal_audit_rating_stddev_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Impact_Internal_Audit_Rating_Stddev_Pop_Fields = {
  __typename?: 'impact_internal_audit_rating_stddev_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Impact_Internal_Audit_Rating_Stddev_Samp_Fields = {
  __typename?: 'impact_internal_audit_rating_stddev_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "impact_internal_audit_rating" */
export type Impact_Internal_Audit_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Internal_Audit_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Internal_Audit_Rating_Stream_Cursor_Value_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Impact_Internal_Audit_Rating_Sum_Fields = {
  __typename?: 'impact_internal_audit_rating_sum_fields';
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** placeholder for update columns of table "risksmart.impact_internal_audit_rating" (current role has no relevant permissions) */
export const Impact_Internal_Audit_Rating_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Impact_Internal_Audit_Rating_Update_Column = typeof Impact_Internal_Audit_Rating_Update_Column[keyof typeof Impact_Internal_Audit_Rating_Update_Column];
/** aggregate var_pop on columns */
export type Impact_Internal_Audit_Rating_Var_Pop_Fields = {
  __typename?: 'impact_internal_audit_rating_var_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Impact_Internal_Audit_Rating_Var_Samp_Fields = {
  __typename?: 'impact_internal_audit_rating_var_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Impact_Internal_Audit_Rating_Variance_Fields = {
  __typename?: 'impact_internal_audit_rating_variance_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Impact_Max_Fields = {
  __typename?: 'impact_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['smallint']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  RatingGuidance?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Impact_Min_Fields = {
  __typename?: 'impact_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  LikelihoodAppetite?: Maybe<Scalars['smallint']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  RatingGuidance?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "risksmart.impact" */
export type Impact_Mutation_Response = {
  __typename?: 'impact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Impact>;
};

/** input type for inserting object relation for remote table "risksmart.impact" */
export type Impact_Obj_Rel_Insert_Input = {
  data: Impact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Impact_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.impact" */
export type Impact_On_Conflict = {
  constraint: Impact_Constraint;
  update_columns?: Array<Impact_Update_Column>;
  where?: InputMaybe<Impact_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.impact". */
export type Impact_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LikelihoodAppetite?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  RatingGuidance?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  appetites_aggregate?: InputMaybe<Appetite_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Impact_Parent_Aggregate_Order_By>;
  ratings_aggregate?: InputMaybe<Impact_Rating_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.impact_parent" */
export type Impact_Parent = {
  __typename?: 'impact_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ImpactId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  impact?: Maybe<Impact>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
};

/** aggregated selection of "risksmart.impact_parent" */
export type Impact_Parent_Aggregate = {
  __typename?: 'impact_parent_aggregate';
  aggregate?: Maybe<Impact_Parent_Aggregate_Fields>;
  nodes: Array<Impact_Parent>;
};

export type Impact_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Impact_Parent_Aggregate_Bool_Exp_Count>;
};

export type Impact_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Impact_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.impact_parent" */
export type Impact_Parent_Aggregate_Fields = {
  __typename?: 'impact_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Impact_Parent_Max_Fields>;
  min?: Maybe<Impact_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.impact_parent" */
export type Impact_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.impact_parent" */
export type Impact_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Impact_Parent_Max_Order_By>;
  min?: InputMaybe<Impact_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.impact_parent" */
export type Impact_Parent_Arr_Rel_Insert_Input = {
  data: Array<Impact_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Impact_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.impact_parent_audit" */
export type Impact_Parent_Audit = {
  __typename?: 'impact_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ImpactId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.impact_parent_audit". All fields are combined with a logical 'AND'. */
export type Impact_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Impact_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Parent_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.impact_parent_audit". */
export type Impact_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.impact_parent_audit" */
export const Impact_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Impact_Parent_Audit_Select_Column = typeof Impact_Parent_Audit_Select_Column[keyof typeof Impact_Parent_Audit_Select_Column];
/** Streaming cursor of the table "impact_parent_audit" */
export type Impact_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_parent". All fields are combined with a logical 'AND'. */
export type Impact_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Parent_Bool_Exp>>;
  _not?: InputMaybe<Impact_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Parent_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.impact_parent" */
export const Impact_Parent_Constraint = {
  /** unique or primary key constraint on columns "ImpactId", "ParentId" */
  ImpactParentPkey: 'impact_parent_pkey'
} as const;

export type Impact_Parent_Constraint = typeof Impact_Parent_Constraint[keyof typeof Impact_Parent_Constraint];
/** input type for inserting data into table "risksmart.impact_parent" */
export type Impact_Parent_Insert_Input = {
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Impact_Parent_Max_Fields = {
  __typename?: 'impact_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.impact_parent" */
export type Impact_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Impact_Parent_Min_Fields = {
  __typename?: 'impact_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.impact_parent" */
export type Impact_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.impact_parent" */
export type Impact_Parent_On_Conflict = {
  constraint: Impact_Parent_Constraint;
  update_columns?: Array<Impact_Parent_Update_Column>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.impact_parent". */
export type Impact_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
};

/** select columns of table "risksmart.impact_parent" */
export const Impact_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Impact_Parent_Select_Column = typeof Impact_Parent_Select_Column[keyof typeof Impact_Parent_Select_Column];
/** Streaming cursor of the table "impact_parent" */
export type Impact_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.impact_parent" (current role has no relevant permissions) */
export const Impact_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Impact_Parent_Update_Column = typeof Impact_Parent_Update_Column[keyof typeof Impact_Parent_Update_Column];
/** columns and relationships of "risksmart.impact_rating" */
export type Impact_Rating = {
  __typename?: 'impact_rating';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactId: Scalars['uuid']['output'];
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RatedItemId: Scalars['uuid']['output'];
  Rating: Scalars['smallint']['output'];
  RatingType: Scalars['String']['output'];
  SequentialId: Scalars['Int']['output'];
  TestDate: Scalars['timestamptz']['output'];
  /** An array relationship */
  assessmentParents: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentParents_aggregate: Assessment_Result_Parent_Aggregate;
  /** An object relationship */
  completedBy?: Maybe<User>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  impact: Impact;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  ratedItem: Node;
};


/** columns and relationships of "risksmart.impact_rating" */
export type Impact_RatingCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.impact_rating" */
export type Impact_RatingAssessmentParentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact_rating" */
export type Impact_RatingAssessmentParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.impact_rating" */
export type Impact_Rating_Aggregate = {
  __typename?: 'impact_rating_aggregate';
  aggregate?: Maybe<Impact_Rating_Aggregate_Fields>;
  nodes: Array<Impact_Rating>;
};

export type Impact_Rating_Aggregate_Bool_Exp = {
  count?: InputMaybe<Impact_Rating_Aggregate_Bool_Exp_Count>;
};

export type Impact_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Impact_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.impact_rating" */
export type Impact_Rating_Aggregate_Fields = {
  __typename?: 'impact_rating_aggregate_fields';
  avg?: Maybe<Impact_Rating_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Impact_Rating_Max_Fields>;
  min?: Maybe<Impact_Rating_Min_Fields>;
  stddev?: Maybe<Impact_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<Impact_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Impact_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<Impact_Rating_Sum_Fields>;
  var_pop?: Maybe<Impact_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<Impact_Rating_Var_Samp_Fields>;
  variance?: Maybe<Impact_Rating_Variance_Fields>;
};


/** aggregate fields of "risksmart.impact_rating" */
export type Impact_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.impact_rating" */
export type Impact_Rating_Aggregate_Order_By = {
  avg?: InputMaybe<Impact_Rating_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Impact_Rating_Max_Order_By>;
  min?: InputMaybe<Impact_Rating_Min_Order_By>;
  stddev?: InputMaybe<Impact_Rating_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Impact_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Impact_Rating_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Impact_Rating_Sum_Order_By>;
  var_pop?: InputMaybe<Impact_Rating_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Impact_Rating_Var_Samp_Order_By>;
  variance?: InputMaybe<Impact_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.impact_rating" */
export type Impact_Rating_Arr_Rel_Insert_Input = {
  data: Array<Impact_Rating_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Impact_Rating_On_Conflict>;
};

/** columns and relationships of "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit = {
  __typename?: 'impact_rating_audit';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactId: Scalars['uuid']['output'];
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId: Scalars['uuid']['output'];
  Rating: Scalars['smallint']['output'];
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId: Scalars['Int']['output'];
  TestDate: Scalars['timestamptz']['output'];
};


/** columns and relationships of "risksmart.impact_rating_audit" */
export type Impact_Rating_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Aggregate_Order_By = {
  avg?: InputMaybe<Impact_Rating_Audit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Impact_Rating_Audit_Max_Order_By>;
  min?: InputMaybe<Impact_Rating_Audit_Min_Order_By>;
  stddev?: InputMaybe<Impact_Rating_Audit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Impact_Rating_Audit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Impact_Rating_Audit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Impact_Rating_Audit_Sum_Order_By>;
  var_pop?: InputMaybe<Impact_Rating_Audit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Impact_Rating_Audit_Var_Samp_Order_By>;
  variance?: InputMaybe<Impact_Rating_Audit_Variance_Order_By>;
};

/** order by avg() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Avg_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_rating_audit". All fields are combined with a logical 'AND'. */
export type Impact_Rating_Audit_Bool_Exp = {
  CompletedBy?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RatedItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Rating?: InputMaybe<Smallint_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Rating_Audit_Bool_Exp>>;
  _not?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Rating_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Max_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Min_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.impact_rating_audit". */
export type Impact_Rating_Audit_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.impact_rating_audit" */
export const Impact_Rating_Audit_Select_Column = {
  /** column name */
  CompletedBy: 'CompletedBy',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RatedItemId: 'RatedItemId',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Impact_Rating_Audit_Select_Column = typeof Impact_Rating_Audit_Select_Column[keyof typeof Impact_Rating_Audit_Select_Column];
/** order by stddev() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Stddev_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Stddev_Pop_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Stddev_Samp_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "impact_rating_audit" */
export type Impact_Rating_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Rating_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Rating_Audit_Stream_Cursor_Value_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Sum_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Var_Pop_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Var_Samp_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.impact_rating_audit" */
export type Impact_Rating_Audit_Variance_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Impact_Rating_Avg_Fields = {
  __typename?: 'impact_rating_avg_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Avg_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_rating". All fields are combined with a logical 'AND'. */
export type Impact_Rating_Bool_Exp = {
  CompletedBy?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RatedItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Rating?: InputMaybe<Smallint_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Rating_Bool_Exp>>;
  _not?: InputMaybe<Impact_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Rating_Bool_Exp>>;
  assessmentParents?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentParents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  completedBy?: InputMaybe<User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ratedItem?: InputMaybe<Node_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.impact_rating" */
export const Impact_Rating_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ImpactRatingPkey: 'impact_rating_pkey'
} as const;

export type Impact_Rating_Constraint = typeof Impact_Rating_Constraint[keyof typeof Impact_Rating_Constraint];
/** input type for inserting data into table "risksmart.impact_rating" */
export type Impact_Rating_Insert_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  assessmentParents?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Impact_Rating_Max_Fields = {
  __typename?: 'impact_rating_max_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Max_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Impact_Rating_Min_Fields = {
  __typename?: 'impact_rating_min_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Min_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.impact_rating" */
export type Impact_Rating_Mutation_Response = {
  __typename?: 'impact_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Impact_Rating>;
};

/** input type for inserting object relation for remote table "risksmart.impact_rating" */
export type Impact_Rating_Obj_Rel_Insert_Input = {
  data: Impact_Rating_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Impact_Rating_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.impact_rating" */
export type Impact_Rating_On_Conflict = {
  constraint: Impact_Rating_Constraint;
  update_columns?: Array<Impact_Rating_Update_Column>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.impact_rating". */
export type Impact_Rating_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  assessmentParents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  completedBy?: InputMaybe<User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ratedItem?: InputMaybe<Node_Order_By>;
};

/** select columns of table "risksmart.impact_rating" */
export const Impact_Rating_Select_Column = {
  /** column name */
  CompletedBy: 'CompletedBy',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RatedItemId: 'RatedItemId',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Impact_Rating_Select_Column = typeof Impact_Rating_Select_Column[keyof typeof Impact_Rating_Select_Column];
/** aggregate stddev on columns */
export type Impact_Rating_Stddev_Fields = {
  __typename?: 'impact_rating_stddev_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Stddev_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Impact_Rating_Stddev_Pop_Fields = {
  __typename?: 'impact_rating_stddev_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Stddev_Pop_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Impact_Rating_Stddev_Samp_Fields = {
  __typename?: 'impact_rating_stddev_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Stddev_Samp_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "impact_rating" */
export type Impact_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Rating_Stream_Cursor_Value_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Impact_Rating_Sum_Fields = {
  __typename?: 'impact_rating_sum_fields';
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Sum_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "risksmart.impact_rating" (current role has no relevant permissions) */
export const Impact_Rating_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Impact_Rating_Update_Column = typeof Impact_Rating_Update_Column[keyof typeof Impact_Rating_Update_Column];
/** aggregate var_pop on columns */
export type Impact_Rating_Var_Pop_Fields = {
  __typename?: 'impact_rating_var_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Var_Pop_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Impact_Rating_Var_Samp_Fields = {
  __typename?: 'impact_rating_var_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Var_Samp_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Impact_Rating_Variance_Fields = {
  __typename?: 'impact_rating_variance_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.impact_rating" */
export type Impact_Rating_Variance_Order_By = {
  Likelihood?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_Rating = {
  __typename?: 'impact_second_line_rating';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactId: Scalars['uuid']['output'];
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RatedItemId: Scalars['uuid']['output'];
  Rating: Scalars['smallint']['output'];
  SequentialId: Scalars['Int']['output'];
  TestDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  completedBy?: Maybe<User>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  impact: Impact;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
  /** An object relationship */
  ratedItem: Node;
};


/** columns and relationships of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_RatingCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_RatingParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_RatingParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_Rating_Aggregate = {
  __typename?: 'impact_second_line_rating_aggregate';
  aggregate?: Maybe<Impact_Second_Line_Rating_Aggregate_Fields>;
  nodes: Array<Impact_Second_Line_Rating>;
};

/** aggregate fields of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_Rating_Aggregate_Fields = {
  __typename?: 'impact_second_line_rating_aggregate_fields';
  avg?: Maybe<Impact_Second_Line_Rating_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Impact_Second_Line_Rating_Max_Fields>;
  min?: Maybe<Impact_Second_Line_Rating_Min_Fields>;
  stddev?: Maybe<Impact_Second_Line_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<Impact_Second_Line_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Impact_Second_Line_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<Impact_Second_Line_Rating_Sum_Fields>;
  var_pop?: Maybe<Impact_Second_Line_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<Impact_Second_Line_Rating_Var_Samp_Fields>;
  variance?: Maybe<Impact_Second_Line_Rating_Variance_Fields>;
};


/** aggregate fields of "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Impact_Second_Line_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Impact_Second_Line_Rating_Avg_Fields = {
  __typename?: 'impact_second_line_rating_avg_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.impact_second_line_rating". All fields are combined with a logical 'AND'. */
export type Impact_Second_Line_Rating_Bool_Exp = {
  CompletedBy?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactId?: InputMaybe<Uuid_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RatedItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Rating?: InputMaybe<Smallint_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Impact_Second_Line_Rating_Bool_Exp>>;
  _not?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Impact_Second_Line_Rating_Bool_Exp>>;
  completedBy?: InputMaybe<User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  impact?: InputMaybe<Impact_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
  ratedItem?: InputMaybe<Node_Bool_Exp>;
};

/** aggregate max on columns */
export type Impact_Second_Line_Rating_Max_Fields = {
  __typename?: 'impact_second_line_rating_max_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Impact_Second_Line_Rating_Min_Fields = {
  __typename?: 'impact_second_line_rating_min_fields';
  CompletedBy?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ImpactId?: Maybe<Scalars['uuid']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RatedItemId?: Maybe<Scalars['uuid']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.impact_second_line_rating" */
export type Impact_Second_Line_Rating_Mutation_Response = {
  __typename?: 'impact_second_line_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Impact_Second_Line_Rating>;
};

/** Ordering options when selecting data from "risksmart.impact_second_line_rating". */
export type Impact_Second_Line_Rating_Order_By = {
  CompletedBy?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactId?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RatedItemId?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  completedBy?: InputMaybe<User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  impact?: InputMaybe<Impact_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
  ratedItem?: InputMaybe<Node_Order_By>;
};

/** select columns of table "risksmart.impact_second_line_rating" */
export const Impact_Second_Line_Rating_Select_Column = {
  /** column name */
  CompletedBy: 'CompletedBy',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactId: 'ImpactId',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RatedItemId: 'RatedItemId',
  /** column name */
  Rating: 'Rating',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Impact_Second_Line_Rating_Select_Column = typeof Impact_Second_Line_Rating_Select_Column[keyof typeof Impact_Second_Line_Rating_Select_Column];
/** aggregate stddev on columns */
export type Impact_Second_Line_Rating_Stddev_Fields = {
  __typename?: 'impact_second_line_rating_stddev_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Impact_Second_Line_Rating_Stddev_Pop_Fields = {
  __typename?: 'impact_second_line_rating_stddev_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Impact_Second_Line_Rating_Stddev_Samp_Fields = {
  __typename?: 'impact_second_line_rating_stddev_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "impact_second_line_rating" */
export type Impact_Second_Line_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Second_Line_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Second_Line_Rating_Stream_Cursor_Value_Input = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RatedItemId?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['smallint']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Impact_Second_Line_Rating_Sum_Fields = {
  __typename?: 'impact_second_line_rating_sum_fields';
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Impact_Second_Line_Rating_Var_Pop_Fields = {
  __typename?: 'impact_second_line_rating_var_pop_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Impact_Second_Line_Rating_Var_Samp_Fields = {
  __typename?: 'impact_second_line_rating_var_samp_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Impact_Second_Line_Rating_Variance_Fields = {
  __typename?: 'impact_second_line_rating_variance_fields';
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "risksmart.impact" */
export const Impact_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  RatingGuidance: 'RatingGuidance',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  SequentialId: 'SequentialId'
} as const;

export type Impact_Select_Column = typeof Impact_Select_Column[keyof typeof Impact_Select_Column];
/** aggregate stddev on columns */
export type Impact_Stddev_Fields = {
  __typename?: 'impact_stddev_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Impact_Stddev_Pop_Fields = {
  __typename?: 'impact_stddev_pop_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Impact_Stddev_Samp_Fields = {
  __typename?: 'impact_stddev_samp_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "impact" */
export type Impact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Impact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Impact_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['smallint']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  RatingGuidance?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Impact_Sum_Fields = {
  __typename?: 'impact_sum_fields';
  LikelihoodAppetite?: Maybe<Scalars['smallint']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.impact" */
export const Impact_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  LikelihoodAppetite: 'LikelihoodAppetite',
  /** column name */
  Name: 'Name',
  /** column name */
  RatingGuidance: 'RatingGuidance',
  /** column name */
  Rationale: 'Rationale'
} as const;

export type Impact_Update_Column = typeof Impact_Update_Column[keyof typeof Impact_Update_Column];
/** aggregate var_pop on columns */
export type Impact_Var_Pop_Fields = {
  __typename?: 'impact_var_pop_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Impact_Var_Samp_Fields = {
  __typename?: 'impact_var_samp_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Impact_Variance_Fields = {
  __typename?: 'impact_variance_fields';
  LikelihoodAppetite?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.indicator" */
export type Indicator = {
  __typename?: 'indicator';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  LowerAppetiteNum?: Maybe<Scalars['numeric']['output']>;
  LowerToleranceNum?: Maybe<Scalars['numeric']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TargetValueTxt?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Indicator_Type_Enum;
  Unit?: Maybe<Scalars['String']['output']>;
  UpperAppetiteNum?: Maybe<Scalars['numeric']['output']>;
  UpperToleranceNum?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  indicator_type: Indicator_Type;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  parents: Array<Indicator_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Indicator_Parent_Aggregate;
  /** An array relationship */
  results: Array<Indicator_Result>;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
  /** An object relationship */
  scheduleState?: Maybe<Schedule_State>;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorParentsArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorResultsArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Result_Order_By>>;
  where?: InputMaybe<Indicator_Result_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator" */
export type IndicatorTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.indicator" */
export type Indicator_Aggregate_Order_By = {
  avg?: InputMaybe<Indicator_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Indicator_Max_Order_By>;
  min?: InputMaybe<Indicator_Min_Order_By>;
  stddev?: InputMaybe<Indicator_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Indicator_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Indicator_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Indicator_Sum_Order_By>;
  var_pop?: InputMaybe<Indicator_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Indicator_Var_Samp_Order_By>;
  variance?: InputMaybe<Indicator_Variance_Order_By>;
};

/** columns and relationships of "risksmart.indicator_audit" */
export type Indicator_Audit = {
  __typename?: 'indicator_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  LowerAppetiteNum?: Maybe<Scalars['numeric']['output']>;
  LowerToleranceNum?: Maybe<Scalars['numeric']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  TargetValueTxt?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  Unit?: Maybe<Scalars['String']['output']>;
  UpperAppetiteNum?: Maybe<Scalars['numeric']['output']>;
  UpperToleranceNum?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "risksmart.indicator_audit" */
export type Indicator_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_audit". All fields are combined with a logical 'AND'. */
export type Indicator_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LowerAppetiteNum?: InputMaybe<Numeric_Comparison_Exp>;
  LowerToleranceNum?: InputMaybe<Numeric_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TargetValueTxt?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Unit?: InputMaybe<String_Comparison_Exp>;
  UpperAppetiteNum?: InputMaybe<Numeric_Comparison_Exp>;
  UpperToleranceNum?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Audit_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.indicator_audit". */
export type Indicator_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Unit?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.indicator_audit" */
export const Indicator_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  LowerAppetiteNum: 'LowerAppetiteNum',
  /** column name */
  LowerToleranceNum: 'LowerToleranceNum',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TargetValueTxt: 'TargetValueTxt',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type',
  /** column name */
  Unit: 'Unit',
  /** column name */
  UpperAppetiteNum: 'UpperAppetiteNum',
  /** column name */
  UpperToleranceNum: 'UpperToleranceNum'
} as const;

export type Indicator_Audit_Select_Column = typeof Indicator_Audit_Select_Column[keyof typeof Indicator_Audit_Select_Column];
/** Streaming cursor of the table "indicator_audit" */
export type Indicator_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LowerAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  LowerToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Unit?: InputMaybe<Scalars['String']['input']>;
  UpperAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  UpperToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by avg() on columns of table "risksmart.indicator" */
export type Indicator_Avg_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator". All fields are combined with a logical 'AND'. */
export type Indicator_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LowerAppetiteNum?: InputMaybe<Numeric_Comparison_Exp>;
  LowerToleranceNum?: InputMaybe<Numeric_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  TargetValueTxt?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Indicator_Type_Enum_Comparison_Exp>;
  Unit?: InputMaybe<String_Comparison_Exp>;
  UpperAppetiteNum?: InputMaybe<Numeric_Comparison_Exp>;
  UpperToleranceNum?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  indicator_type?: InputMaybe<Indicator_Type_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Indicator_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Bool_Exp>;
  results?: InputMaybe<Indicator_Result_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
  scheduleState?: InputMaybe<Schedule_State_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.indicator" */
export const Indicator_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxIndicatorOrgkeySequentialid: 'idx_indicator_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  IndicatorPkey: 'indicator_pkey'
} as const;

export type Indicator_Constraint = typeof Indicator_Constraint[keyof typeof Indicator_Constraint];
/** input type for inserting data into table "risksmart.indicator" */
export type Indicator_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LowerAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  LowerToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Indicator_Type_Enum>;
  Unit?: InputMaybe<Scalars['String']['input']>;
  UpperAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  UpperToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Indicator_Parent_Arr_Rel_Insert_Input>;
  results?: InputMaybe<Indicator_Result_Arr_Rel_Insert_Input>;
  schedule?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.indicator" */
export type Indicator_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Unit?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.indicator" */
export type Indicator_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Unit?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.indicator" */
export type Indicator_Mutation_Response = {
  __typename?: 'indicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Indicator>;
};

/** input type for inserting object relation for remote table "risksmart.indicator" */
export type Indicator_Obj_Rel_Insert_Input = {
  data: Indicator_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Indicator_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.indicator" */
export type Indicator_On_Conflict = {
  constraint: Indicator_Constraint;
  update_columns?: Array<Indicator_Update_Column>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.indicator". */
export type Indicator_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Unit?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  indicator_type?: InputMaybe<Indicator_Type_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Order_By>;
  results_aggregate?: InputMaybe<Indicator_Result_Aggregate_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
  scheduleState?: InputMaybe<Schedule_State_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.indicator_parent" */
export type Indicator_Parent = {
  __typename?: 'indicator_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  IndicatorId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  indicator?: Maybe<Indicator>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
};

/** aggregated selection of "risksmart.indicator_parent" */
export type Indicator_Parent_Aggregate = {
  __typename?: 'indicator_parent_aggregate';
  aggregate?: Maybe<Indicator_Parent_Aggregate_Fields>;
  nodes: Array<Indicator_Parent>;
};

export type Indicator_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Indicator_Parent_Aggregate_Bool_Exp_Count>;
};

export type Indicator_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Indicator_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.indicator_parent" */
export type Indicator_Parent_Aggregate_Fields = {
  __typename?: 'indicator_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Indicator_Parent_Max_Fields>;
  min?: Maybe<Indicator_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.indicator_parent" */
export type Indicator_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.indicator_parent" */
export type Indicator_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Indicator_Parent_Max_Order_By>;
  min?: InputMaybe<Indicator_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.indicator_parent" */
export type Indicator_Parent_Arr_Rel_Insert_Input = {
  data: Array<Indicator_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Indicator_Parent_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_parent". All fields are combined with a logical 'AND'. */
export type Indicator_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  IndicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Parent_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Parent_Bool_Exp>>;
  control?: InputMaybe<Control_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  indicator?: InputMaybe<Indicator_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.indicator_parent" */
export const Indicator_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "IndicatorId" */
  IndicatorParentPkey: 'indicator_parent_pkey'
} as const;

export type Indicator_Parent_Constraint = typeof Indicator_Parent_Constraint[keyof typeof Indicator_Parent_Constraint];
/** input type for inserting data into table "risksmart.indicator_parent" */
export type Indicator_Parent_Insert_Input = {
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  indicator?: InputMaybe<Indicator_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Indicator_Parent_Max_Fields = {
  __typename?: 'indicator_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  IndicatorId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.indicator_parent" */
export type Indicator_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Indicator_Parent_Min_Fields = {
  __typename?: 'indicator_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  IndicatorId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.indicator_parent" */
export type Indicator_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.indicator_parent" */
export type Indicator_Parent_Mutation_Response = {
  __typename?: 'indicator_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Indicator_Parent>;
};

/** on_conflict condition type for table "risksmart.indicator_parent" */
export type Indicator_Parent_On_Conflict = {
  constraint: Indicator_Parent_Constraint;
  update_columns?: Array<Indicator_Parent_Update_Column>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.indicator_parent". */
export type Indicator_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  control?: InputMaybe<Control_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  indicator?: InputMaybe<Indicator_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.indicator_parent" */
export const Indicator_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  IndicatorId: 'IndicatorId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Indicator_Parent_Select_Column = typeof Indicator_Parent_Select_Column[keyof typeof Indicator_Parent_Select_Column];
/** Streaming cursor of the table "indicator_parent" */
export type Indicator_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.indicator_parent" (current role has no relevant permissions) */
export const Indicator_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Indicator_Parent_Update_Column = typeof Indicator_Parent_Update_Column[keyof typeof Indicator_Parent_Update_Column];
/** columns and relationships of "risksmart.indicator_result" */
export type Indicator_Result = {
  __typename?: 'indicator_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  IndicatorId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OrgKey: Scalars['String']['output'];
  ResultDate: Scalars['timestamptz']['output'];
  TargetValueNum?: Maybe<Scalars['numeric']['output']>;
  TargetValueTxt?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Indicator>;
};


/** columns and relationships of "risksmart.indicator_result" */
export type Indicator_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.indicator_result" */
export type Indicator_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.indicator_result" */
export type Indicator_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.indicator_result" */
export type Indicator_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Indicator_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Indicator_Result_Max_Order_By>;
  min?: InputMaybe<Indicator_Result_Min_Order_By>;
  stddev?: InputMaybe<Indicator_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Indicator_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Indicator_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Indicator_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Indicator_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Indicator_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Indicator_Result_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Indicator_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.indicator_result" */
export type Indicator_Result_Arr_Rel_Insert_Input = {
  data: Array<Indicator_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Indicator_Result_On_Conflict>;
};

/** columns and relationships of "risksmart.indicator_result_audit" */
export type Indicator_Result_Audit = {
  __typename?: 'indicator_result_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  IndicatorId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey: Scalars['String']['output'];
  ResultDate: Scalars['timestamptz']['output'];
  TargetValueNum?: Maybe<Scalars['numeric']['output']>;
  TargetValueTxt?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.indicator_result_audit" */
export type Indicator_Result_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_result_audit". All fields are combined with a logical 'AND'. */
export type Indicator_Result_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IndicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ResultDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TargetValueNum?: InputMaybe<Numeric_Comparison_Exp>;
  TargetValueTxt?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Result_Audit_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Result_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Result_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.indicator_result_audit". */
export type Indicator_Result_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResultDate?: InputMaybe<Order_By>;
  TargetValueNum?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.indicator_result_audit" */
export const Indicator_Result_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  IndicatorId: 'IndicatorId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ResultDate: 'ResultDate',
  /** column name */
  TargetValueNum: 'TargetValueNum',
  /** column name */
  TargetValueTxt: 'TargetValueTxt'
} as const;

export type Indicator_Result_Audit_Select_Column = typeof Indicator_Result_Audit_Select_Column[keyof typeof Indicator_Result_Audit_Select_Column];
/** Streaming cursor of the table "indicator_result_audit" */
export type Indicator_Result_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Result_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Result_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ResultDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
};

/** order by avg() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Avg_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_result". All fields are combined with a logical 'AND'. */
export type Indicator_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IndicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ResultDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TargetValueNum?: InputMaybe<Numeric_Comparison_Exp>;
  TargetValueTxt?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Result_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Result_Bool_Exp>>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Indicator_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.indicator_result" */
export const Indicator_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  IndicatorResultPkey: 'indicator_result_pkey'
} as const;

export type Indicator_Result_Constraint = typeof Indicator_Result_Constraint[keyof typeof Indicator_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Indicator_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Indicator_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Indicator_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.indicator_result" */
export type Indicator_Result_Inc_Input = {
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "risksmart.indicator_result" */
export type Indicator_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ResultDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Indicator_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResultDate?: InputMaybe<Order_By>;
  TargetValueNum?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResultDate?: InputMaybe<Order_By>;
  TargetValueNum?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.indicator_result" */
export type Indicator_Result_Mutation_Response = {
  __typename?: 'indicator_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Indicator_Result>;
};

/** on_conflict condition type for table "risksmart.indicator_result" */
export type Indicator_Result_On_Conflict = {
  constraint: Indicator_Result_Constraint;
  update_columns?: Array<Indicator_Result_Update_Column>;
  where?: InputMaybe<Indicator_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.indicator_result". */
export type Indicator_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResultDate?: InputMaybe<Order_By>;
  TargetValueNum?: InputMaybe<Order_By>;
  TargetValueTxt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Indicator_Order_By>;
};

/** primary key columns input for table: risksmart.indicator_result */
export type Indicator_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Indicator_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.indicator_result" */
export const Indicator_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  IndicatorId: 'IndicatorId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ResultDate: 'ResultDate',
  /** column name */
  TargetValueNum: 'TargetValueNum',
  /** column name */
  TargetValueTxt: 'TargetValueTxt'
} as const;

export type Indicator_Result_Select_Column = typeof Indicator_Result_Select_Column[keyof typeof Indicator_Result_Select_Column];
/** input type for updating data in table "risksmart.indicator_result" */
export type Indicator_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ResultDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Stddev_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Stddev_Pop_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Stddev_Samp_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "indicator_result" */
export type Indicator_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ResultDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Sum_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.indicator_result" */
export const Indicator_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  IndicatorId: 'IndicatorId',
  /** column name */
  ResultDate: 'ResultDate',
  /** column name */
  TargetValueNum: 'TargetValueNum',
  /** column name */
  TargetValueTxt: 'TargetValueTxt'
} as const;

export type Indicator_Result_Update_Column = typeof Indicator_Result_Update_Column[keyof typeof Indicator_Result_Update_Column];
export type Indicator_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Indicator_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Indicator_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Indicator_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Indicator_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Indicator_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Indicator_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Indicator_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Indicator_Result_Bool_Exp;
};

/** order by var_pop() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Var_Pop_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Var_Samp_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.indicator_result" */
export type Indicator_Result_Variance_Order_By = {
  TargetValueNum?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.indicator" */
export const Indicator_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  LowerAppetiteNum: 'LowerAppetiteNum',
  /** column name */
  LowerToleranceNum: 'LowerToleranceNum',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  TargetValueTxt: 'TargetValueTxt',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type',
  /** column name */
  Unit: 'Unit',
  /** column name */
  UpperAppetiteNum: 'UpperAppetiteNum',
  /** column name */
  UpperToleranceNum: 'UpperToleranceNum'
} as const;

export type Indicator_Select_Column = typeof Indicator_Select_Column[keyof typeof Indicator_Select_Column];
/** order by stddev() on columns of table "risksmart.indicator" */
export type Indicator_Stddev_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.indicator" */
export type Indicator_Stddev_Pop_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.indicator" */
export type Indicator_Stddev_Samp_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "indicator" */
export type Indicator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  LowerAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  LowerToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Indicator_Type_Enum>;
  Unit?: InputMaybe<Scalars['String']['input']>;
  UpperAppetiteNum?: InputMaybe<Scalars['numeric']['input']>;
  UpperToleranceNum?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "risksmart.indicator" */
export type Indicator_Sum_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.indicator_type" */
export type Indicator_Type = {
  __typename?: 'indicator_type';
  Comment?: Maybe<Scalars['String']['output']>;
  Value: Scalars['String']['output'];
  /** An array relationship */
  indicator_type: Array<Indicator>;
};


/** columns and relationships of "risksmart.indicator_type" */
export type Indicator_TypeIndicator_TypeArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_type". All fields are combined with a logical 'AND'. */
export type Indicator_Type_Bool_Exp = {
  Comment?: InputMaybe<String_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Indicator_Type_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Type_Bool_Exp>>;
  indicator_type?: InputMaybe<Indicator_Bool_Exp>;
};

export const Indicator_Type_Enum = {
  /** True or false indicator type */
  Boolean: 'boolean',
  /**  Number indicator type */
  Number: 'number',
  /** Text indicator type */
  Text: 'text'
} as const;

export type Indicator_Type_Enum = typeof Indicator_Type_Enum[keyof typeof Indicator_Type_Enum];
/** Boolean expression to compare columns of type "indicator_type_enum". All fields are combined with logical 'AND'. */
export type Indicator_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Indicator_Type_Enum>;
  _in?: InputMaybe<Array<Indicator_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Indicator_Type_Enum>;
  _nin?: InputMaybe<Array<Indicator_Type_Enum>>;
};

/** Ordering options when selecting data from "risksmart.indicator_type". */
export type Indicator_Type_Order_By = {
  Comment?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
  indicator_type_aggregate?: InputMaybe<Indicator_Aggregate_Order_By>;
};

/** select columns of table "risksmart.indicator_type" */
export const Indicator_Type_Select_Column = {
  /** column name */
  Comment: 'Comment',
  /** column name */
  Value: 'Value'
} as const;

export type Indicator_Type_Select_Column = typeof Indicator_Type_Select_Column[keyof typeof Indicator_Type_Select_Column];
/** Streaming cursor of the table "indicator_type" */
export type Indicator_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Type_Stream_Cursor_Value_Input = {
  Comment?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.indicator" */
export const Indicator_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  LowerAppetiteNum: 'LowerAppetiteNum',
  /** column name */
  LowerToleranceNum: 'LowerToleranceNum',
  /** column name */
  TargetValueTxt: 'TargetValueTxt',
  /** column name */
  Title: 'Title',
  /** column name */
  Unit: 'Unit',
  /** column name */
  UpperAppetiteNum: 'UpperAppetiteNum',
  /** column name */
  UpperToleranceNum: 'UpperToleranceNum'
} as const;

export type Indicator_Update_Column = typeof Indicator_Update_Column[keyof typeof Indicator_Update_Column];
/** order by var_pop() on columns of table "risksmart.indicator" */
export type Indicator_Var_Pop_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.indicator" */
export type Indicator_Var_Samp_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.indicator" */
export type Indicator_Variance_Order_By = {
  LowerAppetiteNum?: InputMaybe<Order_By>;
  LowerToleranceNum?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  UpperAppetiteNum?: InputMaybe<Order_By>;
  UpperToleranceNum?: InputMaybe<Order_By>;
};

export type InsertChildImpactRatingOutput = {
  __typename?: 'insertChildImpactRatingOutput';
  Ids: Array<Scalars['uuid']['output']>;
};

export type InsertControlTestResultOutput = {
  __typename?: 'insertControlTestResultOutput';
  Ids: Array<Scalars['uuid']['output']>;
};

/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity = {
  __typename?: 'internal_audit_entity';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  businessArea?: Maybe<Business_Area>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  internalAuditReports: Array<Internal_Audit_Report>;
  /** An aggregate relationship */
  internalAuditReports_aggregate: Internal_Audit_Report_Aggregate;
  /** An array relationship */
  issues: Array<Issue_Parent>;
  /** An aggregate relationship */
  issues_aggregate: Issue_Parent_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityInternalAuditReportsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityInternalAuditReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_entity" */
export type Internal_Audit_EntityTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** aggregated selection of "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Aggregate = {
  __typename?: 'internal_audit_entity_aggregate';
  aggregate?: Maybe<Internal_Audit_Entity_Aggregate_Fields>;
  nodes: Array<Internal_Audit_Entity>;
};

export type Internal_Audit_Entity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Internal_Audit_Entity_Aggregate_Bool_Exp_Count>;
};

export type Internal_Audit_Entity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Aggregate_Fields = {
  __typename?: 'internal_audit_entity_aggregate_fields';
  avg?: Maybe<Internal_Audit_Entity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Internal_Audit_Entity_Max_Fields>;
  min?: Maybe<Internal_Audit_Entity_Min_Fields>;
  stddev?: Maybe<Internal_Audit_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Internal_Audit_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Internal_Audit_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Internal_Audit_Entity_Sum_Fields>;
  var_pop?: Maybe<Internal_Audit_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Internal_Audit_Entity_Var_Samp_Fields>;
  variance?: Maybe<Internal_Audit_Entity_Variance_Fields>;
};


/** aggregate fields of "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Aggregate_Order_By = {
  avg?: InputMaybe<Internal_Audit_Entity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Internal_Audit_Entity_Max_Order_By>;
  min?: InputMaybe<Internal_Audit_Entity_Min_Order_By>;
  stddev?: InputMaybe<Internal_Audit_Entity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Internal_Audit_Entity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Internal_Audit_Entity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Internal_Audit_Entity_Sum_Order_By>;
  var_pop?: InputMaybe<Internal_Audit_Entity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Internal_Audit_Entity_Var_Samp_Order_By>;
  variance?: InputMaybe<Internal_Audit_Entity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Arr_Rel_Insert_Input = {
  data: Array<Internal_Audit_Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Internal_Audit_Entity_On_Conflict>;
};

/** aggregate avg on columns */
export type Internal_Audit_Entity_Avg_Fields = {
  __typename?: 'internal_audit_entity_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.internal_audit_entity". All fields are combined with a logical 'AND'. */
export type Internal_Audit_Entity_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Internal_Audit_Entity_Bool_Exp>>;
  _not?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Internal_Audit_Entity_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  businessArea?: InputMaybe<Business_Area_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  internalAuditReports?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  internalAuditReports_aggregate?: InputMaybe<Internal_Audit_Report_Aggregate_Bool_Exp>;
  issues?: InputMaybe<Issue_Parent_Bool_Exp>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.internal_audit_entity" */
export const Internal_Audit_Entity_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxInternalAuditEntityOrgkeySequentialid: 'idx_internal_audit_entity_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  InternalAuditEntityPkey: 'internal_audit_entity_pkey'
} as const;

export type Internal_Audit_Entity_Constraint = typeof Internal_Audit_Entity_Constraint[keyof typeof Internal_Audit_Entity_Constraint];
/** input type for inserting data into table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  businessArea?: InputMaybe<Business_Area_Obj_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  internalAuditReports?: InputMaybe<Internal_Audit_Report_Arr_Rel_Insert_Input>;
  issues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Internal_Audit_Entity_Max_Fields = {
  __typename?: 'internal_audit_entity_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Internal_Audit_Entity_Min_Fields = {
  __typename?: 'internal_audit_entity_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Mutation_Response = {
  __typename?: 'internal_audit_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Internal_Audit_Entity>;
};

/** input type for inserting object relation for remote table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Obj_Rel_Insert_Input = {
  data: Internal_Audit_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Internal_Audit_Entity_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_On_Conflict = {
  constraint: Internal_Audit_Entity_Constraint;
  update_columns?: Array<Internal_Audit_Entity_Update_Column>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.internal_audit_entity". */
export type Internal_Audit_Entity_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  businessArea?: InputMaybe<Business_Area_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  internalAuditReports_aggregate?: InputMaybe<Internal_Audit_Report_Aggregate_Order_By>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** select columns of table "risksmart.internal_audit_entity" */
export const Internal_Audit_Entity_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Internal_Audit_Entity_Select_Column = typeof Internal_Audit_Entity_Select_Column[keyof typeof Internal_Audit_Entity_Select_Column];
/** aggregate stddev on columns */
export type Internal_Audit_Entity_Stddev_Fields = {
  __typename?: 'internal_audit_entity_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Internal_Audit_Entity_Stddev_Pop_Fields = {
  __typename?: 'internal_audit_entity_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Internal_Audit_Entity_Stddev_Samp_Fields = {
  __typename?: 'internal_audit_entity_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "internal_audit_entity" */
export type Internal_Audit_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Internal_Audit_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Internal_Audit_Entity_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Internal_Audit_Entity_Sum_Fields = {
  __typename?: 'internal_audit_entity_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.internal_audit_entity" */
export const Internal_Audit_Entity_Update_Column = {
  /** column name */
  BusinessAreaId: 'BusinessAreaId',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Title: 'Title'
} as const;

export type Internal_Audit_Entity_Update_Column = typeof Internal_Audit_Entity_Update_Column[keyof typeof Internal_Audit_Entity_Update_Column];
/** aggregate var_pop on columns */
export type Internal_Audit_Entity_Var_Pop_Fields = {
  __typename?: 'internal_audit_entity_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Internal_Audit_Entity_Var_Samp_Fields = {
  __typename?: 'internal_audit_entity_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Internal_Audit_Entity_Variance_Fields = {
  __typename?: 'internal_audit_entity_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.internal_audit_entity" */
export type Internal_Audit_Entity_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_Report = {
  __typename?: 'internal_audit_report';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status?: Maybe<Assessment_Status_Enum>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  assessmentActions: Array<Action_Parent>;
  /** An aggregate relationship */
  assessmentActions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  assessmentActivities: Array<Assessment_Activity>;
  /** An aggregate relationship */
  assessmentActivities_aggregate: Assessment_Activity_Aggregate;
  /** An array relationship */
  assessmentIssues: Array<Issue_Parent>;
  /** An aggregate relationship */
  assessmentIssues_aggregate: Issue_Parent_Aggregate;
  /** An array relationship */
  assessmentResults: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Internal_Audit_Result_Parent_Aggregate;
  /** An object relationship */
  completedByUser?: Maybe<User>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  originatingItem?: Maybe<Node>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.internal_audit_report" */
export type Internal_Audit_ReportTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** aggregated selection of "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Aggregate = {
  __typename?: 'internal_audit_report_aggregate';
  aggregate?: Maybe<Internal_Audit_Report_Aggregate_Fields>;
  nodes: Array<Internal_Audit_Report>;
};

export type Internal_Audit_Report_Aggregate_Bool_Exp = {
  count?: InputMaybe<Internal_Audit_Report_Aggregate_Bool_Exp_Count>;
};

export type Internal_Audit_Report_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Aggregate_Fields = {
  __typename?: 'internal_audit_report_aggregate_fields';
  avg?: Maybe<Internal_Audit_Report_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Internal_Audit_Report_Max_Fields>;
  min?: Maybe<Internal_Audit_Report_Min_Fields>;
  stddev?: Maybe<Internal_Audit_Report_Stddev_Fields>;
  stddev_pop?: Maybe<Internal_Audit_Report_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Internal_Audit_Report_Stddev_Samp_Fields>;
  sum?: Maybe<Internal_Audit_Report_Sum_Fields>;
  var_pop?: Maybe<Internal_Audit_Report_Var_Pop_Fields>;
  var_samp?: Maybe<Internal_Audit_Report_Var_Samp_Fields>;
  variance?: Maybe<Internal_Audit_Report_Variance_Fields>;
};


/** aggregate fields of "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Aggregate_Order_By = {
  avg?: InputMaybe<Internal_Audit_Report_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Internal_Audit_Report_Max_Order_By>;
  min?: InputMaybe<Internal_Audit_Report_Min_Order_By>;
  stddev?: InputMaybe<Internal_Audit_Report_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Internal_Audit_Report_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Internal_Audit_Report_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Internal_Audit_Report_Sum_Order_By>;
  var_pop?: InputMaybe<Internal_Audit_Report_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Internal_Audit_Report_Var_Samp_Order_By>;
  variance?: InputMaybe<Internal_Audit_Report_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Arr_Rel_Insert_Input = {
  data: Array<Internal_Audit_Report_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Internal_Audit_Report_On_Conflict>;
};

/** aggregate avg on columns */
export type Internal_Audit_Report_Avg_Fields = {
  __typename?: 'internal_audit_report_avg_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Avg_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.internal_audit_report". All fields are combined with a logical 'AND'. */
export type Internal_Audit_Report_Bool_Exp = {
  ActualCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CompletedByUser?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  NextTestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  OriginatingItemId?: InputMaybe<Uuid_Comparison_Exp>;
  Outcome?: InputMaybe<Int_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<Assessment_Status_Enum_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  TargetCompletionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Internal_Audit_Report_Bool_Exp>>;
  _not?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Internal_Audit_Report_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assessmentActions?: InputMaybe<Action_Parent_Bool_Exp>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Bool_Exp>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Bool_Exp>;
  assessmentIssues?: InputMaybe<Issue_Parent_Bool_Exp>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  assessmentResults?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
  completedByUser?: InputMaybe<User_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  originatingItem?: InputMaybe<Node_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.internal_audit_report" */
export const Internal_Audit_Report_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxInternalAuditReportOrgkeySequentialid: 'idx_internal_audit_report_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  InternalAuditReportPkey: 'internal_audit_report_pkey'
} as const;

export type Internal_Audit_Report_Constraint = typeof Internal_Audit_Report_Constraint[keyof typeof Internal_Audit_Report_Constraint];
/** input type for inserting data into table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Insert_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  assessmentActions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  assessmentActivities?: InputMaybe<Assessment_Activity_Arr_Rel_Insert_Input>;
  assessmentIssues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Internal_Audit_Report_Max_Fields = {
  __typename?: 'internal_audit_report_max_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Max_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Internal_Audit_Report_Min_Fields = {
  __typename?: 'internal_audit_report_min_fields';
  ActualCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  CompletedByUser?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  NextTestDate?: Maybe<Scalars['timestamptz']['output']>;
  OriginatingItemId?: Maybe<Scalars['uuid']['output']>;
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  TargetCompletionDate?: Maybe<Scalars['timestamptz']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Min_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Mutation_Response = {
  __typename?: 'internal_audit_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Internal_Audit_Report>;
};

/** input type for inserting object relation for remote table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Obj_Rel_Insert_Input = {
  data: Internal_Audit_Report_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Internal_Audit_Report_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_On_Conflict = {
  constraint: Internal_Audit_Report_Constraint;
  update_columns?: Array<Internal_Audit_Report_Update_Column>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.internal_audit_report". */
export type Internal_Audit_Report_Order_By = {
  ActualCompletionDate?: InputMaybe<Order_By>;
  CompletedByUser?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  NextTestDate?: InputMaybe<Order_By>;
  OriginatingItemId?: InputMaybe<Order_By>;
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  TargetCompletionDate?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assessmentActions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  assessmentActivities_aggregate?: InputMaybe<Assessment_Activity_Aggregate_Order_By>;
  assessmentIssues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
  completedByUser?: InputMaybe<User_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  originatingItem?: InputMaybe<Node_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** select columns of table "risksmart.internal_audit_report" */
export const Internal_Audit_Report_Select_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Internal_Audit_Report_Select_Column = typeof Internal_Audit_Report_Select_Column[keyof typeof Internal_Audit_Report_Select_Column];
/** aggregate stddev on columns */
export type Internal_Audit_Report_Stddev_Fields = {
  __typename?: 'internal_audit_report_stddev_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Stddev_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Internal_Audit_Report_Stddev_Pop_Fields = {
  __typename?: 'internal_audit_report_stddev_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Stddev_Pop_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Internal_Audit_Report_Stddev_Samp_Fields = {
  __typename?: 'internal_audit_report_stddev_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Stddev_Samp_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "internal_audit_report" */
export type Internal_Audit_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Internal_Audit_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Internal_Audit_Report_Stream_Cursor_Value_Input = {
  ActualCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CompletedByUser?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  NextTestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  OriginatingItemId?: InputMaybe<Scalars['uuid']['input']>;
  Outcome?: InputMaybe<Scalars['Int']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Assessment_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  TargetCompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Internal_Audit_Report_Sum_Fields = {
  __typename?: 'internal_audit_report_sum_fields';
  Outcome?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Sum_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.internal_audit_report" */
export const Internal_Audit_Report_Update_Column = {
  /** column name */
  ActualCompletionDate: 'ActualCompletionDate',
  /** column name */
  CompletedByUser: 'CompletedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  NextTestDate: 'NextTestDate',
  /** column name */
  OriginatingItemId: 'OriginatingItemId',
  /** column name */
  Outcome: 'Outcome',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status',
  /** column name */
  Summary: 'Summary',
  /** column name */
  TargetCompletionDate: 'TargetCompletionDate',
  /** column name */
  Title: 'Title'
} as const;

export type Internal_Audit_Report_Update_Column = typeof Internal_Audit_Report_Update_Column[keyof typeof Internal_Audit_Report_Update_Column];
/** aggregate var_pop on columns */
export type Internal_Audit_Report_Var_Pop_Fields = {
  __typename?: 'internal_audit_report_var_pop_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Var_Pop_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Internal_Audit_Report_Var_Samp_Fields = {
  __typename?: 'internal_audit_report_var_samp_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Var_Samp_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Internal_Audit_Report_Variance_Fields = {
  __typename?: 'internal_audit_report_variance_fields';
  Outcome?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.internal_audit_report" */
export type Internal_Audit_Report_Variance_Order_By = {
  Outcome?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent = {
  __typename?: 'internal_audit_result_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  ParentType: Parent_Type_Enum;
  ResultType: Parent_Type_Enum;
  /** An object relationship */
  assessment_result?: Maybe<Node>;
  /** An object relationship */
  controlledRiskAssessmentResult?: Maybe<Risk_Controlled_Internal_Audit_Result>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  documentAssessmentResult?: Maybe<Document_Internal_Audit_Result>;
  /** An object relationship */
  impactRating?: Maybe<Impact_Internal_Audit_Rating>;
  /** An object relationship */
  internalAuditReport?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  node?: Maybe<Node>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  obligationAssessmentResult?: Maybe<Obligation_Internal_Audit_Result>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  testResult?: Maybe<Control_Test_Internal_Audit_Result>;
  /** An object relationship */
  uncontrolledRiskAssessmentResult?: Maybe<Risk_Uncontrolled_Internal_Audit_Result>;
};

/** aggregated selection of "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Aggregate = {
  __typename?: 'internal_audit_result_parent_aggregate';
  aggregate?: Maybe<Internal_Audit_Result_Parent_Aggregate_Fields>;
  nodes: Array<Internal_Audit_Result_Parent>;
};

export type Internal_Audit_Result_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp_Count>;
};

export type Internal_Audit_Result_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Aggregate_Fields = {
  __typename?: 'internal_audit_result_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Internal_Audit_Result_Parent_Max_Fields>;
  min?: Maybe<Internal_Audit_Result_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Internal_Audit_Result_Parent_Max_Order_By>;
  min?: InputMaybe<Internal_Audit_Result_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Arr_Rel_Insert_Input = {
  data: Array<Internal_Audit_Result_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Internal_Audit_Result_Parent_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.internal_audit_result_parent". All fields are combined with a logical 'AND'. */
export type Internal_Audit_Result_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  ResultType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Internal_Audit_Result_Parent_Bool_Exp>>;
  _not?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Internal_Audit_Result_Parent_Bool_Exp>>;
  assessment_result?: InputMaybe<Node_Bool_Exp>;
  controlledRiskAssessmentResult?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  documentAssessmentResult?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
  impactRating?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  node?: InputMaybe<Node_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  obligationAssessmentResult?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  testResult?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
  uncontrolledRiskAssessmentResult?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.internal_audit_result_parent" */
export const Internal_Audit_Result_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "Id" */
  InternalAuditResultParentPkey: 'internal_audit_result_parent_pkey'
} as const;

export type Internal_Audit_Result_Parent_Constraint = typeof Internal_Audit_Result_Parent_Constraint[keyof typeof Internal_Audit_Result_Parent_Constraint];
/** input type for inserting data into table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  ResultType?: InputMaybe<Parent_Type_Enum>;
  controlledRiskAssessmentResult?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  documentAssessmentResult?: InputMaybe<Document_Internal_Audit_Result_Obj_Rel_Insert_Input>;
  impactRating?: InputMaybe<Impact_Internal_Audit_Rating_Obj_Rel_Insert_Input>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  obligationAssessmentResult?: InputMaybe<Obligation_Internal_Audit_Result_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  testResult?: InputMaybe<Control_Test_Internal_Audit_Result_Obj_Rel_Insert_Input>;
  uncontrolledRiskAssessmentResult?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Internal_Audit_Result_Parent_Max_Fields = {
  __typename?: 'internal_audit_result_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Internal_Audit_Result_Parent_Min_Fields = {
  __typename?: 'internal_audit_result_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Mutation_Response = {
  __typename?: 'internal_audit_result_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Internal_Audit_Result_Parent>;
};

/** on_conflict condition type for table "risksmart.internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_On_Conflict = {
  constraint: Internal_Audit_Result_Parent_Constraint;
  update_columns?: Array<Internal_Audit_Result_Parent_Update_Column>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.internal_audit_result_parent". */
export type Internal_Audit_Result_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
  assessment_result?: InputMaybe<Node_Order_By>;
  controlledRiskAssessmentResult?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  documentAssessmentResult?: InputMaybe<Document_Internal_Audit_Result_Order_By>;
  impactRating?: InputMaybe<Impact_Internal_Audit_Rating_Order_By>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  node?: InputMaybe<Node_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  obligationAssessmentResult?: InputMaybe<Obligation_Internal_Audit_Result_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  testResult?: InputMaybe<Control_Test_Internal_Audit_Result_Order_By>;
  uncontrolledRiskAssessmentResult?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Order_By>;
};

/** select columns of table "risksmart.internal_audit_result_parent" */
export const Internal_Audit_Result_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType',
  /** column name */
  ResultType: 'ResultType'
} as const;

export type Internal_Audit_Result_Parent_Select_Column = typeof Internal_Audit_Result_Parent_Select_Column[keyof typeof Internal_Audit_Result_Parent_Select_Column];
/** Streaming cursor of the table "internal_audit_result_parent" */
export type Internal_Audit_Result_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Internal_Audit_Result_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Internal_Audit_Result_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  ResultType?: InputMaybe<Parent_Type_Enum>;
};

/** placeholder for update columns of table "risksmart.internal_audit_result_parent" (current role has no relevant permissions) */
export const Internal_Audit_Result_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Internal_Audit_Result_Parent_Update_Column = typeof Internal_Audit_Result_Parent_Update_Column[keyof typeof Internal_Audit_Result_Parent_Update_Column];
/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

/** columns and relationships of "risksmart.issue" */
export type Issue = {
  __typename?: 'issue';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateIdentified: Scalars['timestamptz']['output'];
  DateOccurred: Scalars['timestamptz']['output'];
  Details?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactsCustomer?: Maybe<Scalars['Boolean']['output']>;
  IsExternalIssue?: Maybe<Scalars['Boolean']['output']>;
  Meta?: Maybe<Scalars['json']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RaisedAtTimestamp: Scalars['timestamptz']['output'];
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  Type: Parent_Type_Enum;
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  assessment?: Maybe<Issue_Assessment>;
  /** An array relationship */
  causes: Array<Cause>;
  /** An aggregate relationship */
  causes_aggregate: Cause_Aggregate;
  /** An array relationship */
  consequences: Array<Consequence>;
  /** An aggregate relationship */
  consequences_aggregate: Consequence_Aggregate;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  issueStatus?: Maybe<Issue_Status_View>;
  /** An object relationship */
  issueUpdateSummary?: Maybe<Issue_Update_Summary>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  parents: Array<Issue_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Issue_Parent_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
  /** An array relationship */
  updates: Array<Issue_Update>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueCausesArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueCauses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueConsequencesArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueConsequences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueParentsArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue" */
export type IssueUpdatesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Order_By>>;
  where?: InputMaybe<Issue_Update_Bool_Exp>;
};

/** aggregated selection of "risksmart.issue" */
export type Issue_Aggregate = {
  __typename?: 'issue_aggregate';
  aggregate?: Maybe<Issue_Aggregate_Fields>;
  nodes: Array<Issue>;
};

/** aggregate fields of "risksmart.issue" */
export type Issue_Aggregate_Fields = {
  __typename?: 'issue_aggregate_fields';
  avg?: Maybe<Issue_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Issue_Max_Fields>;
  min?: Maybe<Issue_Min_Fields>;
  stddev?: Maybe<Issue_Stddev_Fields>;
  stddev_pop?: Maybe<Issue_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issue_Stddev_Samp_Fields>;
  sum?: Maybe<Issue_Sum_Fields>;
  var_pop?: Maybe<Issue_Var_Pop_Fields>;
  var_samp?: Maybe<Issue_Var_Samp_Fields>;
  variance?: Maybe<Issue_Variance_Fields>;
};


/** aggregate fields of "risksmart.issue" */
export type Issue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.issue_assessment" */
export type Issue_Assessment = {
  __typename?: 'issue_assessment';
  ActualCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  CertifiedIndividual?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  IssueCausedBySystemIssue?: Maybe<Scalars['Boolean']['output']>;
  IssueCausedByThirdParty?: Maybe<Scalars['Boolean']['output']>;
  IssueType?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentIssueId: Scalars['uuid']['output'];
  PoliciesBreached?: Maybe<Scalars['String']['output']>;
  PolicyBreach?: Maybe<Scalars['Boolean']['output']>;
  PolicyOwner?: Maybe<Scalars['String']['output']>;
  PolicyOwnerCommentary?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  RegulationsBreached?: Maybe<Scalars['String']['output']>;
  RegulatoryBreach?: Maybe<Scalars['Boolean']['output']>;
  Reportable?: Maybe<Scalars['Boolean']['output']>;
  Severity?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: Maybe<Scalars['String']['output']>;
  TargetCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  ThirdPartyResponsible?: Maybe<Scalars['String']['output']>;
  Type: Parent_Type_Enum;
  /** An object relationship */
  certifiedIndividual?: Maybe<User>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Issue>;
  /** An object relationship */
  policyOwner?: Maybe<User>;
};


/** columns and relationships of "risksmart.issue_assessment" */
export type Issue_AssessmentCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.issue_assessment" */
export type Issue_AssessmentDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};

/** aggregated selection of "risksmart.issue_assessment" */
export type Issue_Assessment_Aggregate = {
  __typename?: 'issue_assessment_aggregate';
  aggregate?: Maybe<Issue_Assessment_Aggregate_Fields>;
  nodes: Array<Issue_Assessment>;
};

/** aggregate fields of "risksmart.issue_assessment" */
export type Issue_Assessment_Aggregate_Fields = {
  __typename?: 'issue_assessment_aggregate_fields';
  avg?: Maybe<Issue_Assessment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Issue_Assessment_Max_Fields>;
  min?: Maybe<Issue_Assessment_Min_Fields>;
  stddev?: Maybe<Issue_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Issue_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issue_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Issue_Assessment_Sum_Fields>;
  var_pop?: Maybe<Issue_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Issue_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Issue_Assessment_Variance_Fields>;
};


/** aggregate fields of "risksmart.issue_assessment" */
export type Issue_Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.issue_assessment_audit" */
export type Issue_Assessment_Audit = {
  __typename?: 'issue_assessment_audit';
  Action?: Maybe<Scalars['String']['output']>;
  ActualCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  CertifiedIndividual?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  IssueCausedBySystemIssue?: Maybe<Scalars['Boolean']['output']>;
  IssueCausedByThirdParty?: Maybe<Scalars['Boolean']['output']>;
  IssueType?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId: Scalars['uuid']['output'];
  PoliciesBreached?: Maybe<Scalars['String']['output']>;
  PolicyBreach?: Maybe<Scalars['Boolean']['output']>;
  PolicyOwner?: Maybe<Scalars['String']['output']>;
  PolicyOwnerCommentary?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  RegulationsBreached?: Maybe<Scalars['String']['output']>;
  RegulatoryBreach?: Maybe<Scalars['Boolean']['output']>;
  Reportable?: Maybe<Scalars['Boolean']['output']>;
  Severity?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  SystemResponsible?: Maybe<Scalars['String']['output']>;
  TargetCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  ThirdPartyResponsible?: Maybe<Scalars['String']['output']>;
  Type: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.issue_assessment_audit" */
export type Issue_Assessment_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_assessment_audit". All fields are combined with a logical 'AND'. */
export type Issue_Assessment_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  ActualCloseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CertifiedIndividual?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IssueCausedBySystemIssue?: InputMaybe<Boolean_Comparison_Exp>;
  IssueCausedByThirdParty?: InputMaybe<Boolean_Comparison_Exp>;
  IssueType?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  PoliciesBreached?: InputMaybe<String_Comparison_Exp>;
  PolicyBreach?: InputMaybe<Boolean_Comparison_Exp>;
  PolicyOwner?: InputMaybe<String_Comparison_Exp>;
  PolicyOwnerCommentary?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  RegulationsBreached?: InputMaybe<String_Comparison_Exp>;
  RegulatoryBreach?: InputMaybe<Boolean_Comparison_Exp>;
  Reportable?: InputMaybe<Boolean_Comparison_Exp>;
  Severity?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  SystemResponsible?: InputMaybe<String_Comparison_Exp>;
  TargetCloseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ThirdPartyResponsible?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Assessment_Audit_Bool_Exp>>;
  _not?: InputMaybe<Issue_Assessment_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Assessment_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.issue_assessment_audit". */
export type Issue_Assessment_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  ActualCloseDate?: InputMaybe<Order_By>;
  CertifiedIndividual?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IssueCausedBySystemIssue?: InputMaybe<Order_By>;
  IssueCausedByThirdParty?: InputMaybe<Order_By>;
  IssueType?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  PoliciesBreached?: InputMaybe<Order_By>;
  PolicyBreach?: InputMaybe<Order_By>;
  PolicyOwner?: InputMaybe<Order_By>;
  PolicyOwnerCommentary?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  RegulationsBreached?: InputMaybe<Order_By>;
  RegulatoryBreach?: InputMaybe<Order_By>;
  Reportable?: InputMaybe<Order_By>;
  Severity?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  SystemResponsible?: InputMaybe<Order_By>;
  TargetCloseDate?: InputMaybe<Order_By>;
  ThirdPartyResponsible?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.issue_assessment_audit" */
export const Issue_Assessment_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  ActualCloseDate: 'ActualCloseDate',
  /** column name */
  CertifiedIndividual: 'CertifiedIndividual',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  IssueCausedBySystemIssue: 'IssueCausedBySystemIssue',
  /** column name */
  IssueCausedByThirdParty: 'IssueCausedByThirdParty',
  /** column name */
  IssueType: 'IssueType',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  PoliciesBreached: 'PoliciesBreached',
  /** column name */
  PolicyBreach: 'PolicyBreach',
  /** column name */
  PolicyOwner: 'PolicyOwner',
  /** column name */
  PolicyOwnerCommentary: 'PolicyOwnerCommentary',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  RegulationsBreached: 'RegulationsBreached',
  /** column name */
  RegulatoryBreach: 'RegulatoryBreach',
  /** column name */
  Reportable: 'Reportable',
  /** column name */
  Severity: 'Severity',
  /** column name */
  Status: 'Status',
  /** column name */
  SystemResponsible: 'SystemResponsible',
  /** column name */
  TargetCloseDate: 'TargetCloseDate',
  /** column name */
  ThirdPartyResponsible: 'ThirdPartyResponsible',
  /** column name */
  Type: 'Type'
} as const;

export type Issue_Assessment_Audit_Select_Column = typeof Issue_Assessment_Audit_Select_Column[keyof typeof Issue_Assessment_Audit_Select_Column];
/** Streaming cursor of the table "issue_assessment_audit" */
export type Issue_Assessment_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Assessment_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Assessment_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Issue_Assessment_Avg_Fields = {
  __typename?: 'issue_assessment_avg_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_assessment". All fields are combined with a logical 'AND'. */
export type Issue_Assessment_Bool_Exp = {
  ActualCloseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  CertifiedIndividual?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IssueCausedBySystemIssue?: InputMaybe<Boolean_Comparison_Exp>;
  IssueCausedByThirdParty?: InputMaybe<Boolean_Comparison_Exp>;
  IssueType?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  PoliciesBreached?: InputMaybe<String_Comparison_Exp>;
  PolicyBreach?: InputMaybe<Boolean_Comparison_Exp>;
  PolicyOwner?: InputMaybe<String_Comparison_Exp>;
  PolicyOwnerCommentary?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  RegulationsBreached?: InputMaybe<String_Comparison_Exp>;
  RegulatoryBreach?: InputMaybe<Boolean_Comparison_Exp>;
  Reportable?: InputMaybe<Boolean_Comparison_Exp>;
  Severity?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum_Comparison_Exp>;
  SystemResponsible?: InputMaybe<String_Comparison_Exp>;
  TargetCloseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ThirdPartyResponsible?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Assessment_Bool_Exp>>;
  _not?: InputMaybe<Issue_Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Assessment_Bool_Exp>>;
  certifiedIndividual?: InputMaybe<User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Issue_Bool_Exp>;
  policyOwner?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.issue_assessment" */
export const Issue_Assessment_Constraint = {
  /** unique or primary key constraint on columns "ParentIssueId" */
  IdxIssueAssessmentParentIssueId: 'idx_issueAssessment_parentIssueId',
  /** unique or primary key constraint on columns "Id" */
  IssueAssessmentPkey: 'issue_assessment_pkey'
} as const;

export type Issue_Assessment_Constraint = typeof Issue_Assessment_Constraint[keyof typeof Issue_Assessment_Constraint];
/** input type for inserting data into table "risksmart.issue_assessment" */
export type Issue_Assessment_Insert_Input = {
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Parent_Type_Enum>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Issue_Assessment_Max_Fields = {
  __typename?: 'issue_assessment_max_fields';
  ActualCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  CertifiedIndividual?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  IssueType?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  PoliciesBreached?: Maybe<Scalars['String']['output']>;
  PolicyOwner?: Maybe<Scalars['String']['output']>;
  PolicyOwnerCommentary?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  RegulationsBreached?: Maybe<Scalars['String']['output']>;
  Severity?: Maybe<Scalars['Int']['output']>;
  SystemResponsible?: Maybe<Scalars['String']['output']>;
  TargetCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  ThirdPartyResponsible?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Issue_Assessment_Min_Fields = {
  __typename?: 'issue_assessment_min_fields';
  ActualCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  CertifiedIndividual?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  IssueType?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId?: Maybe<Scalars['uuid']['output']>;
  PoliciesBreached?: Maybe<Scalars['String']['output']>;
  PolicyOwner?: Maybe<Scalars['String']['output']>;
  PolicyOwnerCommentary?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  RegulationsBreached?: Maybe<Scalars['String']['output']>;
  Severity?: Maybe<Scalars['Int']['output']>;
  SystemResponsible?: Maybe<Scalars['String']['output']>;
  TargetCloseDate?: Maybe<Scalars['timestamptz']['output']>;
  ThirdPartyResponsible?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "risksmart.issue_assessment" */
export type Issue_Assessment_Obj_Rel_Insert_Input = {
  data: Issue_Assessment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_Assessment_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.issue_assessment" */
export type Issue_Assessment_On_Conflict = {
  constraint: Issue_Assessment_Constraint;
  update_columns?: Array<Issue_Assessment_Update_Column>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.issue_assessment". */
export type Issue_Assessment_Order_By = {
  ActualCloseDate?: InputMaybe<Order_By>;
  CertifiedIndividual?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IssueCausedBySystemIssue?: InputMaybe<Order_By>;
  IssueCausedByThirdParty?: InputMaybe<Order_By>;
  IssueType?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  PoliciesBreached?: InputMaybe<Order_By>;
  PolicyBreach?: InputMaybe<Order_By>;
  PolicyOwner?: InputMaybe<Order_By>;
  PolicyOwnerCommentary?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  RegulationsBreached?: InputMaybe<Order_By>;
  RegulatoryBreach?: InputMaybe<Order_By>;
  Reportable?: InputMaybe<Order_By>;
  Severity?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  SystemResponsible?: InputMaybe<Order_By>;
  TargetCloseDate?: InputMaybe<Order_By>;
  ThirdPartyResponsible?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  certifiedIndividual?: InputMaybe<User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Issue_Order_By>;
  policyOwner?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.issue_assessment" */
export const Issue_Assessment_Select_Column = {
  /** column name */
  ActualCloseDate: 'ActualCloseDate',
  /** column name */
  CertifiedIndividual: 'CertifiedIndividual',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  IssueCausedBySystemIssue: 'IssueCausedBySystemIssue',
  /** column name */
  IssueCausedByThirdParty: 'IssueCausedByThirdParty',
  /** column name */
  IssueType: 'IssueType',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  PoliciesBreached: 'PoliciesBreached',
  /** column name */
  PolicyBreach: 'PolicyBreach',
  /** column name */
  PolicyOwner: 'PolicyOwner',
  /** column name */
  PolicyOwnerCommentary: 'PolicyOwnerCommentary',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  RegulationsBreached: 'RegulationsBreached',
  /** column name */
  RegulatoryBreach: 'RegulatoryBreach',
  /** column name */
  Reportable: 'Reportable',
  /** column name */
  Severity: 'Severity',
  /** column name */
  Status: 'Status',
  /** column name */
  SystemResponsible: 'SystemResponsible',
  /** column name */
  TargetCloseDate: 'TargetCloseDate',
  /** column name */
  ThirdPartyResponsible: 'ThirdPartyResponsible',
  /** column name */
  Type: 'Type'
} as const;

export type Issue_Assessment_Select_Column = typeof Issue_Assessment_Select_Column[keyof typeof Issue_Assessment_Select_Column];
export const Issue_Assessment_Status_Enum = {
  /** awaiting closure */
  Awaitingclosure: 'awaitingclosure',
  /** Closed */
  Closed: 'closed',
  /** Declined */
  Declined: 'declined',
  /** 1st line approval */
  Firstlineapproval: 'firstlineapproval',
  /** Open */
  Open: 'open',
  /** Pending */
  Pending: 'pending'
} as const;

export type Issue_Assessment_Status_Enum = typeof Issue_Assessment_Status_Enum[keyof typeof Issue_Assessment_Status_Enum];
/** Boolean expression to compare columns of type "issue_assessment_status_enum". All fields are combined with logical 'AND'. */
export type Issue_Assessment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Issue_Assessment_Status_Enum>;
  _in?: InputMaybe<Array<Issue_Assessment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Issue_Assessment_Status_Enum>;
  _nin?: InputMaybe<Array<Issue_Assessment_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Issue_Assessment_Stddev_Fields = {
  __typename?: 'issue_assessment_stddev_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Assessment_Stddev_Pop_Fields = {
  __typename?: 'issue_assessment_stddev_pop_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Assessment_Stddev_Samp_Fields = {
  __typename?: 'issue_assessment_stddev_samp_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "issue_assessment" */
export type Issue_Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Assessment_Stream_Cursor_Value_Input = {
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Parent_Type_Enum>;
};

/** aggregate sum on columns */
export type Issue_Assessment_Sum_Fields = {
  __typename?: 'issue_assessment_sum_fields';
  Severity?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.issue_assessment" */
export const Issue_Assessment_Update_Column = {
  /** column name */
  ActualCloseDate: 'ActualCloseDate',
  /** column name */
  CertifiedIndividual: 'CertifiedIndividual',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  IssueCausedBySystemIssue: 'IssueCausedBySystemIssue',
  /** column name */
  IssueCausedByThirdParty: 'IssueCausedByThirdParty',
  /** column name */
  IssueType: 'IssueType',
  /** column name */
  PoliciesBreached: 'PoliciesBreached',
  /** column name */
  PolicyBreach: 'PolicyBreach',
  /** column name */
  PolicyOwner: 'PolicyOwner',
  /** column name */
  PolicyOwnerCommentary: 'PolicyOwnerCommentary',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  RegulationsBreached: 'RegulationsBreached',
  /** column name */
  RegulatoryBreach: 'RegulatoryBreach',
  /** column name */
  Reportable: 'Reportable',
  /** column name */
  Severity: 'Severity',
  /** column name */
  Status: 'Status',
  /** column name */
  SystemResponsible: 'SystemResponsible',
  /** column name */
  TargetCloseDate: 'TargetCloseDate',
  /** column name */
  ThirdPartyResponsible: 'ThirdPartyResponsible'
} as const;

export type Issue_Assessment_Update_Column = typeof Issue_Assessment_Update_Column[keyof typeof Issue_Assessment_Update_Column];
/** aggregate var_pop on columns */
export type Issue_Assessment_Var_Pop_Fields = {
  __typename?: 'issue_assessment_var_pop_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Issue_Assessment_Var_Samp_Fields = {
  __typename?: 'issue_assessment_var_samp_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Issue_Assessment_Variance_Fields = {
  __typename?: 'issue_assessment_variance_fields';
  Severity?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.issue_audit" */
export type Issue_Audit = {
  __typename?: 'issue_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  DateIdentified: Scalars['timestamptz']['output'];
  DateOccurred: Scalars['timestamptz']['output'];
  Details?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ImpactsCustomer?: Maybe<Scalars['Boolean']['output']>;
  IsExternalIssue?: Maybe<Scalars['Boolean']['output']>;
  Meta?: Maybe<Scalars['json']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RaisedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.issue_audit" */
export type Issue_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.issue_audit" */
export type Issue_AuditMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_audit". All fields are combined with a logical 'AND'. */
export type Issue_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateIdentified?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateOccurred?: InputMaybe<Timestamptz_Comparison_Exp>;
  Details?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactsCustomer?: InputMaybe<Boolean_Comparison_Exp>;
  IsExternalIssue?: InputMaybe<Boolean_Comparison_Exp>;
  Meta?: InputMaybe<Json_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RaisedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Audit_Bool_Exp>>;
  _not?: InputMaybe<Issue_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.issue_audit". */
export type Issue_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateIdentified?: InputMaybe<Order_By>;
  DateOccurred?: InputMaybe<Order_By>;
  Details?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactsCustomer?: InputMaybe<Order_By>;
  IsExternalIssue?: InputMaybe<Order_By>;
  Meta?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RaisedAtTimestamp?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.issue_audit" */
export const Issue_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateIdentified: 'DateIdentified',
  /** column name */
  DateOccurred: 'DateOccurred',
  /** column name */
  Details: 'Details',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactsCustomer: 'ImpactsCustomer',
  /** column name */
  IsExternalIssue: 'IsExternalIssue',
  /** column name */
  Meta: 'Meta',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RaisedAtTimestamp: 'RaisedAtTimestamp',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Issue_Audit_Select_Column = typeof Issue_Audit_Select_Column[keyof typeof Issue_Audit_Select_Column];
/** Streaming cursor of the table "issue_audit" */
export type Issue_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateIdentified?: InputMaybe<Scalars['timestamptz']['input']>;
  DateOccurred?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  IsExternalIssue?: InputMaybe<Scalars['Boolean']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RaisedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate avg on columns */
export type Issue_Avg_Fields = {
  __typename?: 'issue_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue". All fields are combined with a logical 'AND'. */
export type Issue_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  DateIdentified?: InputMaybe<Timestamptz_Comparison_Exp>;
  DateOccurred?: InputMaybe<Timestamptz_Comparison_Exp>;
  Details?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactsCustomer?: InputMaybe<Boolean_Comparison_Exp>;
  IsExternalIssue?: InputMaybe<Boolean_Comparison_Exp>;
  Meta?: InputMaybe<Json_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RaisedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Bool_Exp>>;
  _not?: InputMaybe<Issue_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assessment?: InputMaybe<Issue_Assessment_Bool_Exp>;
  causes?: InputMaybe<Cause_Bool_Exp>;
  causes_aggregate?: InputMaybe<Cause_Aggregate_Bool_Exp>;
  consequences?: InputMaybe<Consequence_Bool_Exp>;
  consequences_aggregate?: InputMaybe<Consequence_Aggregate_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  issueStatus?: InputMaybe<Issue_Status_View_Bool_Exp>;
  issueUpdateSummary?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parents?: InputMaybe<Issue_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
  updates?: InputMaybe<Issue_Update_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.issue" */
export const Issue_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "Type", "OrgKey" */
  IdxIssueOrgkeySequentialid: 'idx_issue_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  IssuePkey: 'issue_pkey'
} as const;

export type Issue_Constraint = typeof Issue_Constraint[keyof typeof Issue_Constraint];
/** input type for inserting data into table "risksmart.issue" */
export type Issue_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateIdentified?: InputMaybe<Scalars['timestamptz']['input']>;
  DateOccurred?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  IsExternalIssue?: InputMaybe<Scalars['Boolean']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  RaisedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Parent_Type_Enum>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  assessment?: InputMaybe<Issue_Assessment_Obj_Rel_Insert_Input>;
  causes?: InputMaybe<Cause_Arr_Rel_Insert_Input>;
  consequences?: InputMaybe<Consequence_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
  updates?: InputMaybe<Issue_Update_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Issue_Max_Fields = {
  __typename?: 'issue_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateIdentified?: Maybe<Scalars['timestamptz']['output']>;
  DateOccurred?: Maybe<Scalars['timestamptz']['output']>;
  Details?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RaisedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Issue_Min_Fields = {
  __typename?: 'issue_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  DateIdentified?: Maybe<Scalars['timestamptz']['output']>;
  DateOccurred?: Maybe<Scalars['timestamptz']['output']>;
  Details?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RaisedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "risksmart.issue" */
export type Issue_Obj_Rel_Insert_Input = {
  data: Issue_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.issue" */
export type Issue_On_Conflict = {
  constraint: Issue_Constraint;
  update_columns?: Array<Issue_Update_Column>;
  where?: InputMaybe<Issue_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.issue". */
export type Issue_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  DateIdentified?: InputMaybe<Order_By>;
  DateOccurred?: InputMaybe<Order_By>;
  Details?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactsCustomer?: InputMaybe<Order_By>;
  IsExternalIssue?: InputMaybe<Order_By>;
  Meta?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RaisedAtTimestamp?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assessment?: InputMaybe<Issue_Assessment_Order_By>;
  causes_aggregate?: InputMaybe<Cause_Aggregate_Order_By>;
  consequences_aggregate?: InputMaybe<Consequence_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  issueStatus?: InputMaybe<Issue_Status_View_Order_By>;
  issueUpdateSummary?: InputMaybe<Issue_Update_Summary_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parents_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
  updates_aggregate?: InputMaybe<Issue_Update_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.issue_parent" */
export type Issue_Parent = {
  __typename?: 'issue_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  IssueId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  ParentType: Parent_Type_Enum;
  /** An object relationship */
  assessment?: Maybe<Assessment>;
  /** An object relationship */
  complianceMonitoringAssessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  internalAuditEntity?: Maybe<Internal_Audit_Entity>;
  /** An object relationship */
  internalAuditReport?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
};

/** aggregated selection of "risksmart.issue_parent" */
export type Issue_Parent_Aggregate = {
  __typename?: 'issue_parent_aggregate';
  aggregate?: Maybe<Issue_Parent_Aggregate_Fields>;
  nodes: Array<Issue_Parent>;
};

export type Issue_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp_Count>;
};

export type Issue_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Issue_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.issue_parent" */
export type Issue_Parent_Aggregate_Fields = {
  __typename?: 'issue_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Issue_Parent_Max_Fields>;
  min?: Maybe<Issue_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.issue_parent" */
export type Issue_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.issue_parent" */
export type Issue_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issue_Parent_Max_Order_By>;
  min?: InputMaybe<Issue_Parent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.issue_parent" */
export type Issue_Parent_Arr_Rel_Insert_Input = {
  data: Array<Issue_Parent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_Parent_On_Conflict>;
};

/** columns and relationships of "risksmart.issue_parent_audit" */
export type Issue_Parent_Audit = {
  __typename?: 'issue_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  IssueId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  ParentType?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "risksmart.issue_parent_audit" */
export type Issue_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issue_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Issue_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_parent_audit". All fields are combined with a logical 'AND'. */
export type Issue_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  IssueId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.issue_parent_audit" */
export type Issue_Parent_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.issue_parent_audit" */
export type Issue_Parent_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.issue_parent_audit". */
export type Issue_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.issue_parent_audit" */
export const Issue_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  IssueId: 'IssueId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Issue_Parent_Audit_Select_Column = typeof Issue_Parent_Audit_Select_Column[keyof typeof Issue_Parent_Audit_Select_Column];
/** Streaming cursor of the table "issue_parent_audit" */
export type Issue_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  IssueId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_parent". All fields are combined with a logical 'AND'. */
export type Issue_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  IssueId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Parent_Bool_Exp>>;
  _not?: InputMaybe<Issue_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Parent_Bool_Exp>>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  control?: InputMaybe<Control_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.issue_parent" */
export const Issue_Parent_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "IssueId" */
  IssueParentPkey: 'issue_parent_pkey'
} as const;

export type Issue_Parent_Constraint = typeof Issue_Parent_Constraint[keyof typeof Issue_Parent_Constraint];
/** input type for inserting data into table "risksmart.issue_parent" */
export type Issue_Parent_Insert_Input = {
  IssueId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input>;
  control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Obj_Rel_Insert_Input>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Issue_Parent_Max_Fields = {
  __typename?: 'issue_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  IssueId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.issue_parent" */
export type Issue_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Issue_Parent_Min_Fields = {
  __typename?: 'issue_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  IssueId?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.issue_parent" */
export type Issue_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.issue_parent" */
export type Issue_Parent_On_Conflict = {
  constraint: Issue_Parent_Constraint;
  update_columns?: Array<Issue_Parent_Update_Column>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.issue_parent". */
export type Issue_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  control?: InputMaybe<Control_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  internalAuditEntity?: InputMaybe<Internal_Audit_Entity_Order_By>;
  internalAuditReport?: InputMaybe<Internal_Audit_Report_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
};

/** select columns of table "risksmart.issue_parent" */
export const Issue_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  IssueId: 'IssueId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType'
} as const;

export type Issue_Parent_Select_Column = typeof Issue_Parent_Select_Column[keyof typeof Issue_Parent_Select_Column];
/** Streaming cursor of the table "issue_parent" */
export type Issue_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  IssueId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
};

/** placeholder for update columns of table "risksmart.issue_parent" (current role has no relevant permissions) */
export const Issue_Parent_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Issue_Parent_Update_Column = typeof Issue_Parent_Update_Column[keyof typeof Issue_Parent_Update_Column];
/** select columns of table "risksmart.issue" */
export const Issue_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateIdentified: 'DateIdentified',
  /** column name */
  DateOccurred: 'DateOccurred',
  /** column name */
  Details: 'Details',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactsCustomer: 'ImpactsCustomer',
  /** column name */
  IsExternalIssue: 'IsExternalIssue',
  /** column name */
  Meta: 'Meta',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RaisedAtTimestamp: 'RaisedAtTimestamp',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Issue_Select_Column = typeof Issue_Select_Column[keyof typeof Issue_Select_Column];
/** columns and relationships of "risksmart.issue_status_view" */
export type Issue_Status_View = {
  __typename?: 'issue_status_view';
  Id?: Maybe<Scalars['uuid']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_status_view". All fields are combined with a logical 'AND'. */
export type Issue_Status_View_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Status_View_Bool_Exp>>;
  _not?: InputMaybe<Issue_Status_View_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Status_View_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.issue_status_view". */
export type Issue_Status_View_Order_By = {
  Id?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Issue_Stddev_Fields = {
  __typename?: 'issue_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Stddev_Pop_Fields = {
  __typename?: 'issue_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Stddev_Samp_Fields = {
  __typename?: 'issue_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "issue" */
export type Issue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateIdentified?: InputMaybe<Scalars['timestamptz']['input']>;
  DateOccurred?: InputMaybe<Scalars['timestamptz']['input']>;
  Details?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactsCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  IsExternalIssue?: InputMaybe<Scalars['Boolean']['input']>;
  Meta?: InputMaybe<Scalars['json']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RaisedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Parent_Type_Enum>;
};

/** aggregate sum on columns */
export type Issue_Sum_Fields = {
  __typename?: 'issue_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "risksmart.issue_update" */
export type Issue_Update = {
  __typename?: 'issue_update';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentIssueId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.issue_update" */
export type Issue_UpdateCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.issue_update" */
export type Issue_UpdateFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.issue_update" */
export type Issue_UpdateFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.issue_update" */
export type Issue_Update_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issue_Update_Max_Order_By>;
  min?: InputMaybe<Issue_Update_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Issue_Update_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.issue_update" */
export type Issue_Update_Arr_Rel_Insert_Input = {
  data: Array<Issue_Update_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_Update_On_Conflict>;
};

/** columns and relationships of "risksmart.issue_update_audit" */
export type Issue_Update_Audit = {
  __typename?: 'issue_update_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentIssueId: Scalars['uuid']['output'];
  Title: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.issue_update_audit" */
export type Issue_Update_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_update_audit". All fields are combined with a logical 'AND'. */
export type Issue_Update_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Update_Audit_Bool_Exp>>;
  _not?: InputMaybe<Issue_Update_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Update_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.issue_update_audit". */
export type Issue_Update_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.issue_update_audit" */
export const Issue_Update_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title'
} as const;

export type Issue_Update_Audit_Select_Column = typeof Issue_Update_Audit_Select_Column[keyof typeof Issue_Update_Audit_Select_Column];
/** Streaming cursor of the table "issue_update_audit" */
export type Issue_Update_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Update_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Update_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_update". All fields are combined with a logical 'AND'. */
export type Issue_Update_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentIssueId?: InputMaybe<Uuid_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Update_Bool_Exp>>;
  _not?: InputMaybe<Issue_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Update_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** update columns of table "risksmart.issue" */
export const Issue_Update_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  DateIdentified: 'DateIdentified',
  /** column name */
  DateOccurred: 'DateOccurred',
  /** column name */
  Details: 'Details',
  /** column name */
  ImpactsCustomer: 'ImpactsCustomer',
  /** column name */
  IsExternalIssue: 'IsExternalIssue',
  /** column name */
  Meta: 'Meta',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Issue_Update_Column = typeof Issue_Update_Column[keyof typeof Issue_Update_Column];
/** unique or primary key constraints on table "risksmart.issue_update" */
export const Issue_Update_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  IssueUpdatePkey: 'issue_update_pkey'
} as const;

export type Issue_Update_Constraint = typeof Issue_Update_Constraint[keyof typeof Issue_Update_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Issue_Update_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Issue_Update_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Issue_Update_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.issue_update" */
export type Issue_Update_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.issue_update" */
export type Issue_Update_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.issue_update" */
export type Issue_Update_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.issue_update" */
export type Issue_Update_Mutation_Response = {
  __typename?: 'issue_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Issue_Update>;
};

/** input type for inserting object relation for remote table "risksmart.issue_update" */
export type Issue_Update_Obj_Rel_Insert_Input = {
  data: Issue_Update_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Issue_Update_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.issue_update" */
export type Issue_Update_On_Conflict = {
  constraint: Issue_Update_Constraint;
  update_columns?: Array<Issue_Update_Update_Column>;
  where?: InputMaybe<Issue_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.issue_update". */
export type Issue_Update_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentIssueId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.issue_update */
export type Issue_Update_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Issue_Update_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.issue_update" */
export const Issue_Update_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title'
} as const;

export type Issue_Update_Select_Column = typeof Issue_Update_Select_Column[keyof typeof Issue_Update_Select_Column];
/** input type for updating data in table "risksmart.issue_update" */
export type Issue_Update_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "issue_update" */
export type Issue_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Update_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.issue_update_summary_view" */
export type Issue_Update_Summary = {
  __typename?: 'issue_update_summary';
  Count?: Maybe<Scalars['bigint']['output']>;
  IssueId?: Maybe<Scalars['uuid']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "risksmart.issue_update_summary_view" */
export type Issue_Update_Summary_Aggregate = {
  __typename?: 'issue_update_summary_aggregate';
  aggregate?: Maybe<Issue_Update_Summary_Aggregate_Fields>;
  nodes: Array<Issue_Update_Summary>;
};

/** aggregate fields of "risksmart.issue_update_summary_view" */
export type Issue_Update_Summary_Aggregate_Fields = {
  __typename?: 'issue_update_summary_aggregate_fields';
  avg?: Maybe<Issue_Update_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Issue_Update_Summary_Max_Fields>;
  min?: Maybe<Issue_Update_Summary_Min_Fields>;
  stddev?: Maybe<Issue_Update_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Issue_Update_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issue_Update_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Issue_Update_Summary_Sum_Fields>;
  var_pop?: Maybe<Issue_Update_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Issue_Update_Summary_Var_Samp_Fields>;
  variance?: Maybe<Issue_Update_Summary_Variance_Fields>;
};


/** aggregate fields of "risksmart.issue_update_summary_view" */
export type Issue_Update_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Update_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Issue_Update_Summary_Avg_Fields = {
  __typename?: 'issue_update_summary_avg_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.issue_update_summary_view". All fields are combined with a logical 'AND'. */
export type Issue_Update_Summary_Bool_Exp = {
  Count?: InputMaybe<Bigint_Comparison_Exp>;
  IssueId?: InputMaybe<Uuid_Comparison_Exp>;
  LatestCreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  LatestDescription?: InputMaybe<String_Comparison_Exp>;
  LatestTitle?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Issue_Update_Summary_Bool_Exp>>;
  _not?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Update_Summary_Bool_Exp>>;
};

/** aggregate max on columns */
export type Issue_Update_Summary_Max_Fields = {
  __typename?: 'issue_update_summary_max_fields';
  Count?: Maybe<Scalars['bigint']['output']>;
  IssueId?: Maybe<Scalars['uuid']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Issue_Update_Summary_Min_Fields = {
  __typename?: 'issue_update_summary_min_fields';
  Count?: Maybe<Scalars['bigint']['output']>;
  IssueId?: Maybe<Scalars['uuid']['output']>;
  LatestCreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  LatestDescription?: Maybe<Scalars['String']['output']>;
  LatestTitle?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.issue_update_summary_view". */
export type Issue_Update_Summary_Order_By = {
  Count?: InputMaybe<Order_By>;
  IssueId?: InputMaybe<Order_By>;
  LatestCreatedAtTimestamp?: InputMaybe<Order_By>;
  LatestDescription?: InputMaybe<Order_By>;
  LatestTitle?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.issue_update_summary_view" */
export const Issue_Update_Summary_Select_Column = {
  /** column name */
  Count: 'Count',
  /** column name */
  IssueId: 'IssueId',
  /** column name */
  LatestCreatedAtTimestamp: 'LatestCreatedAtTimestamp',
  /** column name */
  LatestDescription: 'LatestDescription',
  /** column name */
  LatestTitle: 'LatestTitle'
} as const;

export type Issue_Update_Summary_Select_Column = typeof Issue_Update_Summary_Select_Column[keyof typeof Issue_Update_Summary_Select_Column];
/** aggregate stddev on columns */
export type Issue_Update_Summary_Stddev_Fields = {
  __typename?: 'issue_update_summary_stddev_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Update_Summary_Stddev_Pop_Fields = {
  __typename?: 'issue_update_summary_stddev_pop_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Update_Summary_Stddev_Samp_Fields = {
  __typename?: 'issue_update_summary_stddev_samp_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "issue_update_summary" */
export type Issue_Update_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Update_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Update_Summary_Stream_Cursor_Value_Input = {
  Count?: InputMaybe<Scalars['bigint']['input']>;
  IssueId?: InputMaybe<Scalars['uuid']['input']>;
  LatestCreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  LatestDescription?: InputMaybe<Scalars['String']['input']>;
  LatestTitle?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Issue_Update_Summary_Sum_Fields = {
  __typename?: 'issue_update_summary_sum_fields';
  Count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Issue_Update_Summary_Var_Pop_Fields = {
  __typename?: 'issue_update_summary_var_pop_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Issue_Update_Summary_Var_Samp_Fields = {
  __typename?: 'issue_update_summary_var_samp_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Issue_Update_Summary_Variance_Fields = {
  __typename?: 'issue_update_summary_variance_fields';
  Count?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "risksmart.issue_update" */
export const Issue_Update_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ParentIssueId: 'ParentIssueId',
  /** column name */
  Title: 'Title'
} as const;

export type Issue_Update_Update_Column = typeof Issue_Update_Update_Column[keyof typeof Issue_Update_Update_Column];
export type Issue_Update_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Issue_Update_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Issue_Update_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Issue_Update_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Issue_Update_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Issue_Update_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issue_Update_Set_Input>;
  /** filter the rows which have to be updated */
  where: Issue_Update_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Issue_Var_Pop_Fields = {
  __typename?: 'issue_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Issue_Var_Samp_Fields = {
  __typename?: 'issue_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Issue_Variance_Fields = {
  __typename?: 'issue_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "risksmart.linked_item" */
export type Linked_Item = {
  __typename?: 'linked_item';
  Id: Scalars['uuid']['output'];
  RelationshipType?: Maybe<Scalars['String']['output']>;
  Source: Scalars['uuid']['output'];
  SourceType?: Maybe<Scalars['String']['output']>;
  Target: Scalars['uuid']['output'];
  TargetType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  source_acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  source_action?: Maybe<Action>;
  /** An object relationship */
  source_appetite?: Maybe<Appetite>;
  /** An object relationship */
  source_assessment?: Maybe<Assessment>;
  /** An object relationship */
  source_assessment_activity?: Maybe<Assessment_Activity>;
  /** An object relationship */
  source_cause?: Maybe<Cause>;
  /** An object relationship */
  source_compliance_monitoring_assessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  source_consequence?: Maybe<Consequence>;
  /** An object relationship */
  source_control?: Maybe<Control>;
  /** An object relationship */
  source_control_group?: Maybe<Control_Group>;
  /** An object relationship */
  source_document?: Maybe<Document>;
  /** An object relationship */
  source_impact?: Maybe<Impact>;
  /** An object relationship */
  source_indicator?: Maybe<Indicator>;
  /** An object relationship */
  source_internal_audit_entity?: Maybe<Internal_Audit_Entity>;
  /** An object relationship */
  source_internal_audit_report?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  source_issue?: Maybe<Issue>;
  /** An object relationship */
  source_node?: Maybe<Node>;
  /** An object relationship */
  source_obligation?: Maybe<Obligation>;
  /** An object relationship */
  source_risk?: Maybe<Risk>;
  /** An object relationship */
  source_third_party?: Maybe<Third_Party>;
  /** An object relationship */
  target_acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  target_action?: Maybe<Action>;
  /** An object relationship */
  target_action_update?: Maybe<Action_Update>;
  /** An object relationship */
  target_appetite?: Maybe<Appetite>;
  /** An object relationship */
  target_assessment?: Maybe<Assessment>;
  /** An object relationship */
  target_assessment_activity?: Maybe<Assessment_Activity>;
  /** An object relationship */
  target_cause?: Maybe<Cause>;
  /** An object relationship */
  target_compliance_monitoring_assessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  target_consequence?: Maybe<Consequence>;
  /** An object relationship */
  target_control?: Maybe<Control>;
  /** An object relationship */
  target_control_group?: Maybe<Control_Group>;
  /** An object relationship */
  target_document?: Maybe<Document>;
  /** An object relationship */
  target_impact?: Maybe<Impact>;
  /** An object relationship */
  target_impact_rating?: Maybe<Impact_Rating>;
  /** An object relationship */
  target_indicator?: Maybe<Indicator>;
  /** An object relationship */
  target_internal_audit_entity?: Maybe<Internal_Audit_Entity>;
  /** An object relationship */
  target_internal_audit_report?: Maybe<Internal_Audit_Report>;
  /** An object relationship */
  target_issue?: Maybe<Issue>;
  /** An object relationship */
  target_issue_update?: Maybe<Issue_Update>;
  /** An object relationship */
  target_node?: Maybe<Node>;
  /** An object relationship */
  target_obligation?: Maybe<Obligation>;
  /** An object relationship */
  target_obligation_impact?: Maybe<Obligation_Impact>;
  /** An object relationship */
  target_risk?: Maybe<Risk>;
  /** An object relationship */
  target_test_result?: Maybe<Test_Result>;
  /** An object relationship */
  target_third_party?: Maybe<Third_Party>;
};

/** order by aggregate values of table "risksmart.linked_item" */
export type Linked_Item_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Linked_Item_Max_Order_By>;
  min?: InputMaybe<Linked_Item_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.linked_item" */
export type Linked_Item_Arr_Rel_Insert_Input = {
  data: Array<Linked_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Linked_Item_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.linked_item". All fields are combined with a logical 'AND'. */
export type Linked_Item_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  RelationshipType?: InputMaybe<String_Comparison_Exp>;
  Source?: InputMaybe<Uuid_Comparison_Exp>;
  SourceType?: InputMaybe<String_Comparison_Exp>;
  Target?: InputMaybe<Uuid_Comparison_Exp>;
  TargetType?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Linked_Item_Bool_Exp>>;
  _not?: InputMaybe<Linked_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Linked_Item_Bool_Exp>>;
  source_acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  source_action?: InputMaybe<Action_Bool_Exp>;
  source_appetite?: InputMaybe<Appetite_Bool_Exp>;
  source_assessment?: InputMaybe<Assessment_Bool_Exp>;
  source_assessment_activity?: InputMaybe<Assessment_Activity_Bool_Exp>;
  source_cause?: InputMaybe<Cause_Bool_Exp>;
  source_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  source_consequence?: InputMaybe<Consequence_Bool_Exp>;
  source_control?: InputMaybe<Control_Bool_Exp>;
  source_control_group?: InputMaybe<Control_Group_Bool_Exp>;
  source_document?: InputMaybe<Document_Bool_Exp>;
  source_impact?: InputMaybe<Impact_Bool_Exp>;
  source_indicator?: InputMaybe<Indicator_Bool_Exp>;
  source_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  source_internal_audit_report?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  source_issue?: InputMaybe<Issue_Bool_Exp>;
  source_node?: InputMaybe<Node_Bool_Exp>;
  source_obligation?: InputMaybe<Obligation_Bool_Exp>;
  source_risk?: InputMaybe<Risk_Bool_Exp>;
  source_third_party?: InputMaybe<Third_Party_Bool_Exp>;
  target_acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  target_action?: InputMaybe<Action_Bool_Exp>;
  target_action_update?: InputMaybe<Action_Update_Bool_Exp>;
  target_appetite?: InputMaybe<Appetite_Bool_Exp>;
  target_assessment?: InputMaybe<Assessment_Bool_Exp>;
  target_assessment_activity?: InputMaybe<Assessment_Activity_Bool_Exp>;
  target_cause?: InputMaybe<Cause_Bool_Exp>;
  target_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  target_consequence?: InputMaybe<Consequence_Bool_Exp>;
  target_control?: InputMaybe<Control_Bool_Exp>;
  target_control_group?: InputMaybe<Control_Group_Bool_Exp>;
  target_document?: InputMaybe<Document_Bool_Exp>;
  target_impact?: InputMaybe<Impact_Bool_Exp>;
  target_impact_rating?: InputMaybe<Impact_Rating_Bool_Exp>;
  target_indicator?: InputMaybe<Indicator_Bool_Exp>;
  target_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
  target_internal_audit_report?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
  target_issue?: InputMaybe<Issue_Bool_Exp>;
  target_issue_update?: InputMaybe<Issue_Update_Bool_Exp>;
  target_node?: InputMaybe<Node_Bool_Exp>;
  target_obligation?: InputMaybe<Obligation_Bool_Exp>;
  target_obligation_impact?: InputMaybe<Obligation_Impact_Bool_Exp>;
  target_risk?: InputMaybe<Risk_Bool_Exp>;
  target_test_result?: InputMaybe<Test_Result_Bool_Exp>;
  target_third_party?: InputMaybe<Third_Party_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.linked_item" */
export const Linked_Item_Constraint = {
  /** unique or primary key constraint on columns "Source", "Target" */
  LinkedItemPkey: 'linked_item_pkey'
} as const;

export type Linked_Item_Constraint = typeof Linked_Item_Constraint[keyof typeof Linked_Item_Constraint];
/** input type for inserting data into table "risksmart.linked_item" */
export type Linked_Item_Insert_Input = {
  RelationshipType?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['uuid']['input']>;
  SourceType?: InputMaybe<Scalars['String']['input']>;
  Target?: InputMaybe<Scalars['uuid']['input']>;
  TargetType?: InputMaybe<Scalars['String']['input']>;
  source_acceptance?: InputMaybe<Acceptance_Obj_Rel_Insert_Input>;
  source_action?: InputMaybe<Action_Obj_Rel_Insert_Input>;
  source_appetite?: InputMaybe<Appetite_Obj_Rel_Insert_Input>;
  source_assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  source_assessment_activity?: InputMaybe<Assessment_Activity_Obj_Rel_Insert_Input>;
  source_cause?: InputMaybe<Cause_Obj_Rel_Insert_Input>;
  source_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input>;
  source_consequence?: InputMaybe<Consequence_Obj_Rel_Insert_Input>;
  source_control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  source_control_group?: InputMaybe<Control_Group_Obj_Rel_Insert_Input>;
  source_document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  source_impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
  source_indicator?: InputMaybe<Indicator_Obj_Rel_Insert_Input>;
  source_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Obj_Rel_Insert_Input>;
  source_internal_audit_report?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  source_issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  source_obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  source_risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  source_third_party?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
  target_acceptance?: InputMaybe<Acceptance_Obj_Rel_Insert_Input>;
  target_action?: InputMaybe<Action_Obj_Rel_Insert_Input>;
  target_action_update?: InputMaybe<Action_Update_Obj_Rel_Insert_Input>;
  target_appetite?: InputMaybe<Appetite_Obj_Rel_Insert_Input>;
  target_assessment?: InputMaybe<Assessment_Obj_Rel_Insert_Input>;
  target_assessment_activity?: InputMaybe<Assessment_Activity_Obj_Rel_Insert_Input>;
  target_cause?: InputMaybe<Cause_Obj_Rel_Insert_Input>;
  target_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Obj_Rel_Insert_Input>;
  target_consequence?: InputMaybe<Consequence_Obj_Rel_Insert_Input>;
  target_control?: InputMaybe<Control_Obj_Rel_Insert_Input>;
  target_control_group?: InputMaybe<Control_Group_Obj_Rel_Insert_Input>;
  target_document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  target_impact?: InputMaybe<Impact_Obj_Rel_Insert_Input>;
  target_impact_rating?: InputMaybe<Impact_Rating_Obj_Rel_Insert_Input>;
  target_indicator?: InputMaybe<Indicator_Obj_Rel_Insert_Input>;
  target_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Obj_Rel_Insert_Input>;
  target_internal_audit_report?: InputMaybe<Internal_Audit_Report_Obj_Rel_Insert_Input>;
  target_issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  target_issue_update?: InputMaybe<Issue_Update_Obj_Rel_Insert_Input>;
  target_obligation?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  target_obligation_impact?: InputMaybe<Obligation_Impact_Obj_Rel_Insert_Input>;
  target_risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  target_test_result?: InputMaybe<Test_Result_Obj_Rel_Insert_Input>;
  target_third_party?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.linked_item" */
export type Linked_Item_Max_Order_By = {
  Id?: InputMaybe<Order_By>;
  RelationshipType?: InputMaybe<Order_By>;
  Source?: InputMaybe<Order_By>;
  SourceType?: InputMaybe<Order_By>;
  Target?: InputMaybe<Order_By>;
  TargetType?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.linked_item" */
export type Linked_Item_Min_Order_By = {
  Id?: InputMaybe<Order_By>;
  RelationshipType?: InputMaybe<Order_By>;
  Source?: InputMaybe<Order_By>;
  SourceType?: InputMaybe<Order_By>;
  Target?: InputMaybe<Order_By>;
  TargetType?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.linked_item" */
export type Linked_Item_Mutation_Response = {
  __typename?: 'linked_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Linked_Item>;
};

/** on_conflict condition type for table "risksmart.linked_item" */
export type Linked_Item_On_Conflict = {
  constraint: Linked_Item_Constraint;
  update_columns?: Array<Linked_Item_Update_Column>;
  where?: InputMaybe<Linked_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.linked_item". */
export type Linked_Item_Order_By = {
  Id?: InputMaybe<Order_By>;
  RelationshipType?: InputMaybe<Order_By>;
  Source?: InputMaybe<Order_By>;
  SourceType?: InputMaybe<Order_By>;
  Target?: InputMaybe<Order_By>;
  TargetType?: InputMaybe<Order_By>;
  source_acceptance?: InputMaybe<Acceptance_Order_By>;
  source_action?: InputMaybe<Action_Order_By>;
  source_appetite?: InputMaybe<Appetite_Order_By>;
  source_assessment?: InputMaybe<Assessment_Order_By>;
  source_assessment_activity?: InputMaybe<Assessment_Activity_Order_By>;
  source_cause?: InputMaybe<Cause_Order_By>;
  source_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  source_consequence?: InputMaybe<Consequence_Order_By>;
  source_control?: InputMaybe<Control_Order_By>;
  source_control_group?: InputMaybe<Control_Group_Order_By>;
  source_document?: InputMaybe<Document_Order_By>;
  source_impact?: InputMaybe<Impact_Order_By>;
  source_indicator?: InputMaybe<Indicator_Order_By>;
  source_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Order_By>;
  source_internal_audit_report?: InputMaybe<Internal_Audit_Report_Order_By>;
  source_issue?: InputMaybe<Issue_Order_By>;
  source_node?: InputMaybe<Node_Order_By>;
  source_obligation?: InputMaybe<Obligation_Order_By>;
  source_risk?: InputMaybe<Risk_Order_By>;
  source_third_party?: InputMaybe<Third_Party_Order_By>;
  target_acceptance?: InputMaybe<Acceptance_Order_By>;
  target_action?: InputMaybe<Action_Order_By>;
  target_action_update?: InputMaybe<Action_Update_Order_By>;
  target_appetite?: InputMaybe<Appetite_Order_By>;
  target_assessment?: InputMaybe<Assessment_Order_By>;
  target_assessment_activity?: InputMaybe<Assessment_Activity_Order_By>;
  target_cause?: InputMaybe<Cause_Order_By>;
  target_compliance_monitoring_assessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  target_consequence?: InputMaybe<Consequence_Order_By>;
  target_control?: InputMaybe<Control_Order_By>;
  target_control_group?: InputMaybe<Control_Group_Order_By>;
  target_document?: InputMaybe<Document_Order_By>;
  target_impact?: InputMaybe<Impact_Order_By>;
  target_impact_rating?: InputMaybe<Impact_Rating_Order_By>;
  target_indicator?: InputMaybe<Indicator_Order_By>;
  target_internal_audit_entity?: InputMaybe<Internal_Audit_Entity_Order_By>;
  target_internal_audit_report?: InputMaybe<Internal_Audit_Report_Order_By>;
  target_issue?: InputMaybe<Issue_Order_By>;
  target_issue_update?: InputMaybe<Issue_Update_Order_By>;
  target_node?: InputMaybe<Node_Order_By>;
  target_obligation?: InputMaybe<Obligation_Order_By>;
  target_obligation_impact?: InputMaybe<Obligation_Impact_Order_By>;
  target_risk?: InputMaybe<Risk_Order_By>;
  target_test_result?: InputMaybe<Test_Result_Order_By>;
  target_third_party?: InputMaybe<Third_Party_Order_By>;
};

/** select columns of table "risksmart.linked_item" */
export const Linked_Item_Select_Column = {
  /** column name */
  Id: 'Id',
  /** column name */
  RelationshipType: 'RelationshipType',
  /** column name */
  Source: 'Source',
  /** column name */
  SourceType: 'SourceType',
  /** column name */
  Target: 'Target',
  /** column name */
  TargetType: 'TargetType'
} as const;

export type Linked_Item_Select_Column = typeof Linked_Item_Select_Column[keyof typeof Linked_Item_Select_Column];
/** Streaming cursor of the table "linked_item" */
export type Linked_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Linked_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Linked_Item_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  RelationshipType?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['uuid']['input']>;
  SourceType?: InputMaybe<Scalars['String']['input']>;
  Target?: InputMaybe<Scalars['uuid']['input']>;
  TargetType?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "risksmart.linked_item" (current role has no relevant permissions) */
export const Linked_Item_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Linked_Item_Update_Column = typeof Linked_Item_Update_Column[keyof typeof Linked_Item_Update_Column];
/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  addRiskToEnterpriseRisk?: Maybe<GenericMutationOutput>;
  attestRecord: GenericMutationOutput;
  attestationNotRequired: GenericMutationOutput;
  customRoleInsert?: Maybe<IdOutput>;
  customRoleUpdate?: Maybe<GenericMutationOutput>;
  customRoleUserUpdate?: Maybe<GenericMutationOutput>;
  dataExportCreateSchedule?: Maybe<DataExportCreateScheduleOutput>;
  dataExportTestSchedule?: Maybe<DataExportTestScheduleOutput>;
  dataImportStartImport?: Maybe<DataImportStartImportOutput>;
  dataImportValidate?: Maybe<DataImportValidateOutput>;
  deleteAcceptancesById: GenericMutationOutput;
  deleteActionsById: GenericMutationOutput;
  deleteChildEnterpriseRisk?: Maybe<GenericMutationOutput>;
  deleteChildEntity?: Maybe<GenericMutationOutput>;
  deleteControlsById: GenericMutationOutput;
  deleteDepartmentTypeApi?: Maybe<GenericMutationOutput>;
  deleteDocumentById: GenericMutationOutput;
  deleteFormField?: Maybe<IdOutput>;
  deleteIssuesById: GenericMutationOutput;
  deleteRiskById: GenericMutationOutput;
  deleteTagTypeApi?: Maybe<GenericMutationOutput>;
  deleteUserGroups: GenericMutationOutput;
  deleteWizardById?: Maybe<GenericMutationOutput>;
  /** delete data from the table: "risksmart.acceptance_parent" */
  delete_acceptance_parent?: Maybe<Acceptance_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.acceptance_parent" */
  delete_acceptance_parent_by_pk?: Maybe<Acceptance_Parent>;
  /** delete data from the table: "risksmart.action_parent" */
  delete_action_parent?: Maybe<Action_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.action_parent" */
  delete_action_parent_by_pk?: Maybe<Action_Parent>;
  /** delete data from the table: "risksmart.action_update" */
  delete_action_update?: Maybe<Action_Update_Mutation_Response>;
  /** delete single row from the table: "risksmart.action_update" */
  delete_action_update_by_pk?: Maybe<Action_Update>;
  /** delete data from the table: "risksmart.appetite" */
  delete_appetite?: Maybe<Appetite_Mutation_Response>;
  /** delete single row from the table: "risksmart.appetite" */
  delete_appetite_by_pk?: Maybe<Appetite>;
  /** delete data from the table: "risksmart.appetite_parent" */
  delete_appetite_parent?: Maybe<Appetite_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.appetite_parent" */
  delete_appetite_parent_by_pk?: Maybe<Appetite_Parent>;
  /** delete data from the table: "risksmart.approval" */
  delete_approval?: Maybe<Approval_Mutation_Response>;
  /** delete single row from the table: "risksmart.approval" */
  delete_approval_by_pk?: Maybe<Approval>;
  /** delete data from the table: "risksmart.approval_level" */
  delete_approval_level?: Maybe<Approval_Level_Mutation_Response>;
  /** delete single row from the table: "risksmart.approval_level" */
  delete_approval_level_by_pk?: Maybe<Approval_Level>;
  /** delete data from the table: "risksmart.approver" */
  delete_approver?: Maybe<Approver_Mutation_Response>;
  /** delete single row from the table: "risksmart.approver" */
  delete_approver_by_pk?: Maybe<Approver>;
  /** delete data from the table: "risksmart.assessment" */
  delete_assessment?: Maybe<Assessment_Mutation_Response>;
  /** delete data from the table: "risksmart.assessment_activity" */
  delete_assessment_activity?: Maybe<Assessment_Activity_Mutation_Response>;
  /** delete single row from the table: "risksmart.assessment_activity" */
  delete_assessment_activity_by_pk?: Maybe<Assessment_Activity>;
  /** delete single row from the table: "risksmart.assessment" */
  delete_assessment_by_pk?: Maybe<Assessment>;
  /** delete data from the table: "risksmart.assessment_result_parent" */
  delete_assessment_result_parent?: Maybe<Assessment_Result_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.assessment_result_parent" */
  delete_assessment_result_parent_by_pk?: Maybe<Assessment_Result_Parent>;
  /** delete data from the table: "risksmart.attestation_config" */
  delete_attestation_config?: Maybe<Attestation_Config_Mutation_Response>;
  /** delete single row from the table: "risksmart.attestation_config" */
  delete_attestation_config_by_pk?: Maybe<Attestation_Config>;
  /** delete data from the table: "risksmart.attestation_group" */
  delete_attestation_group?: Maybe<Attestation_Group_Mutation_Response>;
  /** delete single row from the table: "risksmart.attestation_group" */
  delete_attestation_group_by_pk?: Maybe<Attestation_Group>;
  /** delete data from the table: "auth.user_role" */
  delete_auth_user_role?: Maybe<Auth_User_Role_Mutation_Response>;
  /** delete single row from the table: "auth.user_role" */
  delete_auth_user_role_by_pk?: Maybe<Auth_User_Role>;
  /** delete data from the table: "risksmart.business_area" */
  delete_business_area?: Maybe<Business_Area_Mutation_Response>;
  /** delete single row from the table: "risksmart.business_area" */
  delete_business_area_by_pk?: Maybe<Business_Area>;
  /** delete data from the table: "risksmart.cause" */
  delete_cause?: Maybe<Cause_Mutation_Response>;
  /** delete single row from the table: "risksmart.cause" */
  delete_cause_by_pk?: Maybe<Cause>;
  /** delete data from the table: "risksmart.colour_palette" */
  delete_colour_palette?: Maybe<Colour_Palette_Mutation_Response>;
  /** delete single row from the table: "risksmart.colour_palette" */
  delete_colour_palette_by_pk?: Maybe<Colour_Palette>;
  /** delete data from the table: "risksmart.comment" */
  delete_comment?: Maybe<Comment_Mutation_Response>;
  /** delete single row from the table: "risksmart.comment" */
  delete_comment_by_pk?: Maybe<Comment>;
  /** delete data from the table: "risksmart.compliance_monitoring_assessment" */
  delete_compliance_monitoring_assessment?: Maybe<Compliance_Monitoring_Assessment_Mutation_Response>;
  /** delete single row from the table: "risksmart.compliance_monitoring_assessment" */
  delete_compliance_monitoring_assessment_by_pk?: Maybe<Compliance_Monitoring_Assessment>;
  /** delete data from the table: "risksmart.consequence" */
  delete_consequence?: Maybe<Consequence_Mutation_Response>;
  /** delete single row from the table: "risksmart.consequence" */
  delete_consequence_by_pk?: Maybe<Consequence>;
  /** delete data from the table: "risksmart.control_group" */
  delete_control_group?: Maybe<Control_Group_Mutation_Response>;
  /** delete single row from the table: "risksmart.control_group" */
  delete_control_group_by_pk?: Maybe<Control_Group>;
  /** delete data from the table: "risksmart.control_parent" */
  delete_control_parent?: Maybe<Control_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.control_parent" */
  delete_control_parent_by_pk?: Maybe<Control_Parent>;
  /** delete data from the table: "risksmart.control_test_internal_audit_result" */
  delete_control_test_internal_audit_result?: Maybe<Control_Test_Internal_Audit_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.control_test_internal_audit_result" */
  delete_control_test_internal_audit_result_by_pk?: Maybe<Control_Test_Internal_Audit_Result>;
  /** delete data from the table: "risksmart.control_test_second_line_result" */
  delete_control_test_second_line_result?: Maybe<Control_Test_Second_Line_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.control_test_second_line_result" */
  delete_control_test_second_line_result_by_pk?: Maybe<Control_Test_Second_Line_Result>;
  /** delete data from the table: "risksmart.conversation" */
  delete_conversation?: Maybe<Conversation_Mutation_Response>;
  /** delete single row from the table: "risksmart.conversation" */
  delete_conversation_by_pk?: Maybe<Conversation>;
  /** delete data from the table: "risksmart.custom_attribute_schema" */
  delete_custom_attribute_schema?: Maybe<Custom_Attribute_Schema_Mutation_Response>;
  /** delete single row from the table: "risksmart.custom_attribute_schema" */
  delete_custom_attribute_schema_by_pk?: Maybe<Custom_Attribute_Schema>;
  /** delete data from the table: "risksmart.custom_datasource" */
  delete_custom_datasource?: Maybe<Custom_Datasource_Mutation_Response>;
  /** delete single row from the table: "risksmart.custom_datasource" */
  delete_custom_datasource_by_pk?: Maybe<Custom_Datasource>;
  /** delete data from the table: "risksmart.custom_role" */
  delete_custom_role?: Maybe<Custom_Role_Mutation_Response>;
  /** delete data from the table: "risksmart.custom_role_assignment" */
  delete_custom_role_assignment?: Maybe<Custom_Role_Assignment_Mutation_Response>;
  /** delete single row from the table: "risksmart.custom_role_assignment" */
  delete_custom_role_assignment_by_pk?: Maybe<Custom_Role_Assignment>;
  /** delete single row from the table: "risksmart.custom_role" */
  delete_custom_role_by_pk?: Maybe<Custom_Role>;
  /** delete data from the table: "risksmart.custom_role_user" */
  delete_custom_role_user?: Maybe<Custom_Role_User_Mutation_Response>;
  /** delete single row from the table: "risksmart.custom_role_user" */
  delete_custom_role_user_by_pk?: Maybe<Custom_Role_User>;
  /** delete data from the table: "risksmart.dashboard" */
  delete_dashboard?: Maybe<Dashboard_Mutation_Response>;
  /** delete single row from the table: "risksmart.dashboard" */
  delete_dashboard_by_pk?: Maybe<Dashboard>;
  /** delete data from the table: "risksmart.data_export_schedule" */
  delete_data_export_schedule?: Maybe<Data_Export_Schedule_Mutation_Response>;
  /** delete single row from the table: "risksmart.data_export_schedule" */
  delete_data_export_schedule_by_pk?: Maybe<Data_Export_Schedule>;
  /** delete data from the table: "risksmart.data_import" */
  delete_data_import?: Maybe<Data_Import_Mutation_Response>;
  /** delete single row from the table: "risksmart.data_import" */
  delete_data_import_by_pk?: Maybe<Data_Import>;
  /** delete data from the table: "risksmart.data_import_error" */
  delete_data_import_error?: Maybe<Data_Import_Error_Mutation_Response>;
  /** delete single row from the table: "risksmart.data_import_error" */
  delete_data_import_error_by_pk?: Maybe<Data_Import_Error>;
  /** delete data from the table: "risksmart.document_assessment_result" */
  delete_document_assessment_result?: Maybe<Document_Assessment_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.document_assessment_result" */
  delete_document_assessment_result_by_pk?: Maybe<Document_Assessment_Result>;
  /** delete data from the table: "risksmart.document_file" */
  delete_document_file?: Maybe<Document_File_Mutation_Response>;
  /** delete single row from the table: "risksmart.document_file" */
  delete_document_file_by_pk?: Maybe<Document_File>;
  /** delete data from the table: "risksmart.document_internal_audit_result" */
  delete_document_internal_audit_result?: Maybe<Document_Internal_Audit_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.document_internal_audit_result" */
  delete_document_internal_audit_result_by_pk?: Maybe<Document_Internal_Audit_Result>;
  /** delete data from the table: "risksmart.document_linked_document" */
  delete_document_linked_document?: Maybe<Document_Linked_Document_Mutation_Response>;
  /** delete single row from the table: "risksmart.document_linked_document" */
  delete_document_linked_document_by_pk?: Maybe<Document_Linked_Document>;
  /** delete data from the table: "risksmart.document_second_line_result" */
  delete_document_second_line_result?: Maybe<Document_Second_Line_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.document_second_line_result" */
  delete_document_second_line_result_by_pk?: Maybe<Document_Second_Line_Result>;
  /** delete data from the table: "risksmart.enterprise_risk_score" */
  delete_enterprise_risk_score?: Maybe<Enterprise_Risk_Score_Mutation_Response>;
  /** delete single row from the table: "risksmart.enterprise_risk_score" */
  delete_enterprise_risk_score_by_pk?: Maybe<Enterprise_Risk_Score>;
  /** delete data from the table: "risksmart.file" */
  delete_file?: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "risksmart.file" */
  delete_file_by_pk?: Maybe<File>;
  /** delete data from the table: "risksmart.form_configuration" */
  delete_form_configuration?: Maybe<Form_Configuration_Mutation_Response>;
  /** delete data from the table: "risksmart.form_field_configuration" */
  delete_form_field_configuration?: Maybe<Form_Field_Configuration_Mutation_Response>;
  /** delete data from the table: "risksmart.form_field_ordering" */
  delete_form_field_ordering?: Maybe<Form_Field_Ordering_Mutation_Response>;
  /** delete data from the table: "risksmart.impact" */
  delete_impact?: Maybe<Impact_Mutation_Response>;
  /** delete single row from the table: "risksmart.impact" */
  delete_impact_by_pk?: Maybe<Impact>;
  /** delete data from the table: "risksmart.impact_internal_audit_rating" */
  delete_impact_internal_audit_rating?: Maybe<Impact_Internal_Audit_Rating_Mutation_Response>;
  /** delete single row from the table: "risksmart.impact_internal_audit_rating" */
  delete_impact_internal_audit_rating_by_pk?: Maybe<Impact_Internal_Audit_Rating>;
  /** delete data from the table: "risksmart.impact_rating" */
  delete_impact_rating?: Maybe<Impact_Rating_Mutation_Response>;
  /** delete single row from the table: "risksmart.impact_rating" */
  delete_impact_rating_by_pk?: Maybe<Impact_Rating>;
  /** delete data from the table: "risksmart.impact_second_line_rating" */
  delete_impact_second_line_rating?: Maybe<Impact_Second_Line_Rating_Mutation_Response>;
  /** delete single row from the table: "risksmart.impact_second_line_rating" */
  delete_impact_second_line_rating_by_pk?: Maybe<Impact_Second_Line_Rating>;
  /** delete data from the table: "risksmart.indicator" */
  delete_indicator?: Maybe<Indicator_Mutation_Response>;
  /** delete single row from the table: "risksmart.indicator" */
  delete_indicator_by_pk?: Maybe<Indicator>;
  /** delete data from the table: "risksmart.indicator_parent" */
  delete_indicator_parent?: Maybe<Indicator_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.indicator_parent" */
  delete_indicator_parent_by_pk?: Maybe<Indicator_Parent>;
  /** delete data from the table: "risksmart.indicator_result" */
  delete_indicator_result?: Maybe<Indicator_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.indicator_result" */
  delete_indicator_result_by_pk?: Maybe<Indicator_Result>;
  /** delete data from the table: "risksmart.internal_audit_entity" */
  delete_internal_audit_entity?: Maybe<Internal_Audit_Entity_Mutation_Response>;
  /** delete single row from the table: "risksmart.internal_audit_entity" */
  delete_internal_audit_entity_by_pk?: Maybe<Internal_Audit_Entity>;
  /** delete data from the table: "risksmart.internal_audit_report" */
  delete_internal_audit_report?: Maybe<Internal_Audit_Report_Mutation_Response>;
  /** delete single row from the table: "risksmart.internal_audit_report" */
  delete_internal_audit_report_by_pk?: Maybe<Internal_Audit_Report>;
  /** delete data from the table: "risksmart.internal_audit_result_parent" */
  delete_internal_audit_result_parent?: Maybe<Internal_Audit_Result_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.internal_audit_result_parent" */
  delete_internal_audit_result_parent_by_pk?: Maybe<Internal_Audit_Result_Parent>;
  /** delete data from the table: "risksmart.issue_update" */
  delete_issue_update?: Maybe<Issue_Update_Mutation_Response>;
  /** delete single row from the table: "risksmart.issue_update" */
  delete_issue_update_by_pk?: Maybe<Issue_Update>;
  /** delete data from the table: "risksmart.linked_item" */
  delete_linked_item?: Maybe<Linked_Item_Mutation_Response>;
  /** delete single row from the table: "risksmart.linked_item" */
  delete_linked_item_by_pk?: Maybe<Linked_Item>;
  /** delete data from the table: "risksmart.obligation" */
  delete_obligation?: Maybe<Obligation_Mutation_Response>;
  /** delete data from the table: "risksmart.obligation_assessment_result" */
  delete_obligation_assessment_result?: Maybe<Obligation_Assessment_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.obligation_assessment_result" */
  delete_obligation_assessment_result_by_pk?: Maybe<Obligation_Assessment_Result>;
  /** delete single row from the table: "risksmart.obligation" */
  delete_obligation_by_pk?: Maybe<Obligation>;
  /** delete data from the table: "risksmart.obligation_impact" */
  delete_obligation_impact?: Maybe<Obligation_Impact_Mutation_Response>;
  /** delete single row from the table: "risksmart.obligation_impact" */
  delete_obligation_impact_by_pk?: Maybe<Obligation_Impact>;
  /** delete data from the table: "risksmart.obligation_internal_audit_result" */
  delete_obligation_internal_audit_result?: Maybe<Obligation_Internal_Audit_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.obligation_internal_audit_result" */
  delete_obligation_internal_audit_result_by_pk?: Maybe<Obligation_Internal_Audit_Result>;
  /** delete data from the table: "risksmart.obligation_second_line_result" */
  delete_obligation_second_line_result?: Maybe<Obligation_Second_Line_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.obligation_second_line_result" */
  delete_obligation_second_line_result_by_pk?: Maybe<Obligation_Second_Line_Result>;
  /** delete data from the table: "risksmart.organisation_module" */
  delete_organisation_module?: Maybe<Organisation_Module_Mutation_Response>;
  /** delete data from the table: "risksmart.organisation_tab_preference" */
  delete_organisation_tab_preference?: Maybe<Organisation_Tab_Preference_Mutation_Response>;
  /** delete data from the table: "risksmart.questionnaire_invite" */
  delete_questionnaire_invite?: Maybe<Questionnaire_Invite_Mutation_Response>;
  /** delete single row from the table: "risksmart.questionnaire_invite" */
  delete_questionnaire_invite_by_pk?: Maybe<Questionnaire_Invite>;
  /** delete data from the table: "risksmart.questionnaire_template" */
  delete_questionnaire_template?: Maybe<Questionnaire_Template_Mutation_Response>;
  /** delete single row from the table: "risksmart.questionnaire_template" */
  delete_questionnaire_template_by_pk?: Maybe<Questionnaire_Template>;
  /** delete data from the table: "risksmart.questionnaire_template_version" */
  delete_questionnaire_template_version?: Maybe<Questionnaire_Template_Version_Mutation_Response>;
  /** delete single row from the table: "risksmart.questionnaire_template_version" */
  delete_questionnaire_template_version_by_pk?: Maybe<Questionnaire_Template_Version>;
  /** delete data from the table: "risksmart.relation_file" */
  delete_relation_file?: Maybe<Relation_File_Mutation_Response>;
  /** delete single row from the table: "risksmart.relation_file" */
  delete_relation_file_by_pk?: Maybe<Relation_File>;
  /** delete data from the table: "risksmart.risk_assessment_result" */
  delete_risk_assessment_result?: Maybe<Risk_Assessment_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_assessment_result" */
  delete_risk_assessment_result_by_pk?: Maybe<Risk_Assessment_Result>;
  /** delete data from the table: "risksmart.risk_assessment_result_impact" */
  delete_risk_assessment_result_impact?: Maybe<Risk_Assessment_Result_Impact_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_assessment_result_impact" */
  delete_risk_assessment_result_impact_by_pk?: Maybe<Risk_Assessment_Result_Impact>;
  /** delete data from the table: "risksmart.risk_controlled_internal_audit_result" */
  delete_risk_controlled_internal_audit_result?: Maybe<Risk_Controlled_Internal_Audit_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_controlled_internal_audit_result" */
  delete_risk_controlled_internal_audit_result_by_pk?: Maybe<Risk_Controlled_Internal_Audit_Result>;
  /** delete data from the table: "risksmart.risk_controlled_second_line_result" */
  delete_risk_controlled_second_line_result?: Maybe<Risk_Controlled_Second_Line_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_controlled_second_line_result" */
  delete_risk_controlled_second_line_result_by_pk?: Maybe<Risk_Controlled_Second_Line_Result>;
  /** delete data from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  delete_risk_uncontrolled_internal_audit_result?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  delete_risk_uncontrolled_internal_audit_result_by_pk?: Maybe<Risk_Uncontrolled_Internal_Audit_Result>;
  /** delete data from the table: "risksmart.risk_uncontrolled_second_line_result" */
  delete_risk_uncontrolled_second_line_result?: Maybe<Risk_Uncontrolled_Second_Line_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.risk_uncontrolled_second_line_result" */
  delete_risk_uncontrolled_second_line_result_by_pk?: Maybe<Risk_Uncontrolled_Second_Line_Result>;
  delete_scim_domain?: Maybe<DeleteScimDomainOutput>;
  delete_scim_token: DeleteScimTokenOutput;
  /** delete data from the table: "risksmart.second_line_result_parent" */
  delete_second_line_result_parent?: Maybe<Second_Line_Result_Parent_Mutation_Response>;
  /** delete single row from the table: "risksmart.second_line_result_parent" */
  delete_second_line_result_parent_by_pk?: Maybe<Second_Line_Result_Parent>;
  /** delete data from the table: "risksmart.taxonomy" */
  delete_taxonomy?: Maybe<Taxonomy_Mutation_Response>;
  /** delete single row from the table: "risksmart.taxonomy" */
  delete_taxonomy_by_pk?: Maybe<Taxonomy>;
  /** delete data from the table: "risksmart.taxonomy_org" */
  delete_taxonomy_org?: Maybe<Taxonomy_Org_Mutation_Response>;
  /** delete single row from the table: "risksmart.taxonomy_org" */
  delete_taxonomy_org_by_pk?: Maybe<Taxonomy_Org>;
  /** delete data from the table: "risksmart.test_result" */
  delete_test_result?: Maybe<Test_Result_Mutation_Response>;
  /** delete single row from the table: "risksmart.test_result" */
  delete_test_result_by_pk?: Maybe<Test_Result>;
  /** delete data from the table: "risksmart.third_party" */
  delete_third_party?: Maybe<Third_Party_Mutation_Response>;
  /** delete single row from the table: "risksmart.third_party" */
  delete_third_party_by_pk?: Maybe<Third_Party>;
  /** delete data from the table: "risksmart.third_party_contact" */
  delete_third_party_contact?: Maybe<Third_Party_Contact_Mutation_Response>;
  /** delete single row from the table: "risksmart.third_party_contact" */
  delete_third_party_contact_by_pk?: Maybe<Third_Party_Contact>;
  /** delete data from the table: "risksmart.third_party_response" */
  delete_third_party_response?: Maybe<Third_Party_Response_Mutation_Response>;
  /** delete single row from the table: "risksmart.third_party_response" */
  delete_third_party_response_by_pk?: Maybe<Third_Party_Response>;
  /** delete data from the table: "risksmart.user_group_user" */
  delete_user_group_user?: Maybe<User_Group_User_Mutation_Response>;
  /** delete single row from the table: "risksmart.user_group_user" */
  delete_user_group_user_by_pk?: Maybe<User_Group_User>;
  /** delete data from the table: "risksmart.user_tab_preference" */
  delete_user_tab_preference?: Maybe<User_Tab_Preference_Mutation_Response>;
  disconnectSlack: DisconnectSlackOutput;
  insertAssessmentActivityWithLinkedItems?: Maybe<IdOutput>;
  /** insertAssessmentApi */
  insertAssessmentApi?: Maybe<IdOutput>;
  insertChildAcceptance?: Maybe<IdOutput>;
  insertChildAction?: Maybe<IdOutput>;
  insertChildAppetite?: Maybe<IdOutput>;
  insertChildAttestationConfig?: Maybe<IdOutput>;
  insertChildAttestationCycle?: Maybe<IdOutput>;
  insertChildControl?: Maybe<IdOutput>;
  insertChildControlTestInternalAuditResult?: Maybe<InsertControlTestResultOutput>;
  insertChildControlTestSecondLineResult?: Maybe<InsertControlTestResultOutput>;
  insertChildDashboard?: Maybe<IdOutput>;
  /** insertChildDocument */
  insertChildDocument?: Maybe<IdOutput>;
  insertChildDocumentAssessmentResult?: Maybe<InsertChildDocumentAssessmentResultOutput>;
  insertChildDocumentInternalAuditResult?: Maybe<InsertChildDocumentAssessmentResultOutput>;
  insertChildDocumentSecondLineResult?: Maybe<InsertChildDocumentAssessmentResultOutput>;
  insertChildEnterpriseRisk?: Maybe<IdOutput>;
  insertChildEntity?: Maybe<IdOutput>;
  insertChildImpactInternalAuditRating?: Maybe<InsertChildImpactRatingOutput>;
  insertChildImpactRating?: Maybe<InsertChildImpactRatingOutput>;
  insertChildImpactSecondLineRating?: Maybe<InsertChildImpactRatingOutput>;
  insertChildIndicator?: Maybe<IdOutput>;
  insertChildIssue?: Maybe<InsertChildIssueOutput>;
  insertChildIssueAssessment?: Maybe<IdOutput>;
  /** insertChildObligation */
  insertChildObligation?: Maybe<IdOutput>;
  insertChildObligationAssessmentResult?: Maybe<InsertChildObligationAssessmentResultOutput>;
  insertChildObligationChangeAttestation?: Maybe<IdOutput>;
  insertChildObligationInternalAuditResult?: Maybe<InsertChildObligationAssessmentResultOutput>;
  insertChildObligationSecondLineResult?: Maybe<InsertChildObligationAssessmentResultOutput>;
  /** insertChildRisk */
  insertChildRisk?: Maybe<IdOutput>;
  insertChildRiskAssessmentResult?: Maybe<InsertChildRiskAssessmentResultOutput>;
  insertChildRiskInternalAuditResult?: Maybe<InsertChildRiskAssessmentResultOutput>;
  insertChildRiskSecondLineResult?: Maybe<InsertChildRiskAssessmentResultOutput>;
  insertChildWizard?: Maybe<InsertWizardOutput>;
  /** insertComplianceMonitoringAssessmentApi */
  insertComplianceMonitoringAssessmentApi?: Maybe<IdOutput>;
  insertControlTestResult?: Maybe<InsertControlTestResultOutput>;
  insertDocumentVersion?: Maybe<IdOutput>;
  insertFormField?: Maybe<IdOutput>;
  insertImpactApi?: Maybe<IdOutput>;
  insertInternalAudit?: Maybe<IdOutput>;
  /** insertInternalAuditReportApi */
  insertInternalAuditReportApi?: Maybe<IdOutput>;
  insertQuestionnaireInvites: GenericMutationOutput;
  insertQuestionnaireTemplateApi?: Maybe<IdOutput>;
  insertReferenceUser?: Maybe<IdOutput>;
  insertRiskAssessmentResultConfigApi?: Maybe<InsertRiskAssessmentResultConfigApiOutput>;
  /** insertThirdPartyApi */
  insertThirdPartyApi?: Maybe<IdOutput>;
  /** insertThirdPartyContactApi */
  insertThirdPartyContactApi?: Maybe<IdOutput>;
  /** insert data into the table: "risksmart.action_update" */
  insert_action_update?: Maybe<Action_Update_Mutation_Response>;
  /** insert a single row into the table: "risksmart.action_update" */
  insert_action_update_one?: Maybe<Action_Update>;
  /** insert data into the table: "risksmart.aggregation_org" */
  insert_aggregation_org?: Maybe<Aggregation_Org_Mutation_Response>;
  /** insert a single row into the table: "risksmart.aggregation_org" */
  insert_aggregation_org_one?: Maybe<Aggregation_Org>;
  /** insert data into the table: "risksmart.approval" */
  insert_approval?: Maybe<Approval_Mutation_Response>;
  /** insert data into the table: "risksmart.approval_level" */
  insert_approval_level?: Maybe<Approval_Level_Mutation_Response>;
  /** insert a single row into the table: "risksmart.approval_level" */
  insert_approval_level_one?: Maybe<Approval_Level>;
  /** insert a single row into the table: "risksmart.approval" */
  insert_approval_one?: Maybe<Approval>;
  /** insert data into the table: "risksmart.approver" */
  insert_approver?: Maybe<Approver_Mutation_Response>;
  /** insert a single row into the table: "risksmart.approver" */
  insert_approver_one?: Maybe<Approver>;
  /** insert data into the table: "risksmart.assessment_activity" */
  insert_assessment_activity?: Maybe<Assessment_Activity_Mutation_Response>;
  /** insert a single row into the table: "risksmart.assessment_activity" */
  insert_assessment_activity_one?: Maybe<Assessment_Activity>;
  /** insert data into the table: "risksmart.attestation_config" */
  insert_attestation_config?: Maybe<Attestation_Config_Mutation_Response>;
  /** insert a single row into the table: "risksmart.attestation_config" */
  insert_attestation_config_one?: Maybe<Attestation_Config>;
  /** insert data into the table: "risksmart.attestation_cycle" */
  insert_attestation_cycle?: Maybe<Attestation_Cycle_Mutation_Response>;
  /** insert a single row into the table: "risksmart.attestation_cycle" */
  insert_attestation_cycle_one?: Maybe<Attestation_Cycle>;
  /** insert data into the table: "risksmart.attestation_group" */
  insert_attestation_group?: Maybe<Attestation_Group_Mutation_Response>;
  /** insert a single row into the table: "risksmart.attestation_group" */
  insert_attestation_group_one?: Maybe<Attestation_Group>;
  /** insert data into the table: "auth.user_role" */
  insert_auth_user_role?: Maybe<Auth_User_Role_Mutation_Response>;
  /** insert a single row into the table: "auth.user_role" */
  insert_auth_user_role_one?: Maybe<Auth_User_Role>;
  /** insert data into the table: "risksmart.business_area" */
  insert_business_area?: Maybe<Business_Area_Mutation_Response>;
  /** insert a single row into the table: "risksmart.business_area" */
  insert_business_area_one?: Maybe<Business_Area>;
  /** insert data into the table: "risksmart.cause" */
  insert_cause?: Maybe<Cause_Mutation_Response>;
  /** insert a single row into the table: "risksmart.cause" */
  insert_cause_one?: Maybe<Cause>;
  /** insert data into the table: "risksmart.colour_palette" */
  insert_colour_palette?: Maybe<Colour_Palette_Mutation_Response>;
  /** insert a single row into the table: "risksmart.colour_palette" */
  insert_colour_palette_one?: Maybe<Colour_Palette>;
  /** insert data into the table: "risksmart.comment" */
  insert_comment?: Maybe<Comment_Mutation_Response>;
  /** insert a single row into the table: "risksmart.comment" */
  insert_comment_one?: Maybe<Comment>;
  /** insert data into the table: "risksmart.consequence" */
  insert_consequence?: Maybe<Consequence_Mutation_Response>;
  /** insert a single row into the table: "risksmart.consequence" */
  insert_consequence_one?: Maybe<Consequence>;
  /** insert data into the table: "risksmart.control" */
  insert_control?: Maybe<Control_Mutation_Response>;
  /** insert data into the table: "risksmart.control_group" */
  insert_control_group?: Maybe<Control_Group_Mutation_Response>;
  /** insert a single row into the table: "risksmart.control_group" */
  insert_control_group_one?: Maybe<Control_Group>;
  /** insert a single row into the table: "risksmart.control" */
  insert_control_one?: Maybe<Control>;
  /** insert data into the table: "risksmart.control_parent" */
  insert_control_parent?: Maybe<Control_Parent_Mutation_Response>;
  /** insert a single row into the table: "risksmart.control_parent" */
  insert_control_parent_one?: Maybe<Control_Parent>;
  /** insert data into the table: "risksmart.conversation" */
  insert_conversation?: Maybe<Conversation_Mutation_Response>;
  /** insert a single row into the table: "risksmart.conversation" */
  insert_conversation_one?: Maybe<Conversation>;
  /** insert data into the table: "risksmart.custom_attribute_schema" */
  insert_custom_attribute_schema?: Maybe<Custom_Attribute_Schema_Mutation_Response>;
  /** insert a single row into the table: "risksmart.custom_attribute_schema" */
  insert_custom_attribute_schema_one?: Maybe<Custom_Attribute_Schema>;
  /** insert data into the table: "risksmart.custom_datasource" */
  insert_custom_datasource?: Maybe<Custom_Datasource_Mutation_Response>;
  /** insert a single row into the table: "risksmart.custom_datasource" */
  insert_custom_datasource_one?: Maybe<Custom_Datasource>;
  /** insert data into the table: "risksmart.custom_ribbon" */
  insert_custom_ribbon?: Maybe<Custom_Ribbon_Mutation_Response>;
  /** insert a single row into the table: "risksmart.custom_ribbon" */
  insert_custom_ribbon_one?: Maybe<Custom_Ribbon>;
  /** insert data into the table: "risksmart.data_export_schedule" */
  insert_data_export_schedule?: Maybe<Data_Export_Schedule_Mutation_Response>;
  /** insert data into the table: "risksmart.data_export_schedule_execution" */
  insert_data_export_schedule_execution?: Maybe<Data_Export_Schedule_Execution_Mutation_Response>;
  /** insert a single row into the table: "risksmart.data_export_schedule_execution" */
  insert_data_export_schedule_execution_one?: Maybe<Data_Export_Schedule_Execution>;
  /** insert a single row into the table: "risksmart.data_export_schedule" */
  insert_data_export_schedule_one?: Maybe<Data_Export_Schedule>;
  /** insert data into the table: "risksmart.data_import" */
  insert_data_import?: Maybe<Data_Import_Mutation_Response>;
  /** insert data into the table: "risksmart.data_import_error" */
  insert_data_import_error?: Maybe<Data_Import_Error_Mutation_Response>;
  /** insert a single row into the table: "risksmart.data_import_error" */
  insert_data_import_error_one?: Maybe<Data_Import_Error>;
  /** insert a single row into the table: "risksmart.data_import" */
  insert_data_import_one?: Maybe<Data_Import>;
  /** insert data into the table: "risksmart.department_type" */
  insert_department_type?: Maybe<Department_Type_Mutation_Response>;
  /** insert data into the table: "risksmart.department_type_group" */
  insert_department_type_group?: Maybe<Department_Type_Group_Mutation_Response>;
  /** insert a single row into the table: "risksmart.department_type_group" */
  insert_department_type_group_one?: Maybe<Department_Type_Group>;
  /** insert a single row into the table: "risksmart.department_type" */
  insert_department_type_one?: Maybe<Department_Type>;
  /** insert data into the table: "risksmart.document_linked_document" */
  insert_document_linked_document?: Maybe<Document_Linked_Document_Mutation_Response>;
  /** insert a single row into the table: "risksmart.document_linked_document" */
  insert_document_linked_document_one?: Maybe<Document_Linked_Document>;
  /** insert data into the table: "risksmart.file" */
  insert_file?: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "risksmart.file" */
  insert_file_one?: Maybe<File>;
  /** insert data into the table: "risksmart.form_configuration" */
  insert_form_configuration?: Maybe<Form_Configuration_Mutation_Response>;
  /** insert a single row into the table: "risksmart.form_configuration" */
  insert_form_configuration_one?: Maybe<Form_Configuration>;
  /** insert data into the table: "risksmart.form_field_configuration" */
  insert_form_field_configuration?: Maybe<Form_Field_Configuration_Mutation_Response>;
  /** insert a single row into the table: "risksmart.form_field_configuration" */
  insert_form_field_configuration_one?: Maybe<Form_Field_Configuration>;
  /** insert data into the table: "risksmart.form_field_ordering" */
  insert_form_field_ordering?: Maybe<Form_Field_Ordering_Mutation_Response>;
  /** insert a single row into the table: "risksmart.form_field_ordering" */
  insert_form_field_ordering_one?: Maybe<Form_Field_Ordering>;
  /** insert data into the table: "risksmart.indicator_parent" */
  insert_indicator_parent?: Maybe<Indicator_Parent_Mutation_Response>;
  /** insert a single row into the table: "risksmart.indicator_parent" */
  insert_indicator_parent_one?: Maybe<Indicator_Parent>;
  /** insert data into the table: "risksmart.indicator_result" */
  insert_indicator_result?: Maybe<Indicator_Result_Mutation_Response>;
  /** insert a single row into the table: "risksmart.indicator_result" */
  insert_indicator_result_one?: Maybe<Indicator_Result>;
  /** insert data into the table: "risksmart.issue_update" */
  insert_issue_update?: Maybe<Issue_Update_Mutation_Response>;
  /** insert a single row into the table: "risksmart.issue_update" */
  insert_issue_update_one?: Maybe<Issue_Update>;
  /** insert data into the table: "risksmart.obligation_impact" */
  insert_obligation_impact?: Maybe<Obligation_Impact_Mutation_Response>;
  /** insert a single row into the table: "risksmart.obligation_impact" */
  insert_obligation_impact_one?: Maybe<Obligation_Impact>;
  /** insert data into the table: "risksmart.organisation_module" */
  insert_organisation_module?: Maybe<Organisation_Module_Mutation_Response>;
  /** insert a single row into the table: "risksmart.organisation_module" */
  insert_organisation_module_one?: Maybe<Organisation_Module>;
  /** insert data into the table: "risksmart.organisation_tab_preference" */
  insert_organisation_tab_preference?: Maybe<Organisation_Tab_Preference_Mutation_Response>;
  /** insert a single row into the table: "risksmart.organisation_tab_preference" */
  insert_organisation_tab_preference_one?: Maybe<Organisation_Tab_Preference>;
  /** insert data into the table: "risksmart.questionnaire_invite" */
  insert_questionnaire_invite?: Maybe<Questionnaire_Invite_Mutation_Response>;
  /** insert a single row into the table: "risksmart.questionnaire_invite" */
  insert_questionnaire_invite_one?: Maybe<Questionnaire_Invite>;
  /** insert data into the table: "risksmart.questionnaire_template_version" */
  insert_questionnaire_template_version?: Maybe<Questionnaire_Template_Version_Mutation_Response>;
  /** insert a single row into the table: "risksmart.questionnaire_template_version" */
  insert_questionnaire_template_version_one?: Maybe<Questionnaire_Template_Version>;
  /** insert data into the table: "risksmart.relation_file" */
  insert_relation_file?: Maybe<Relation_File_Mutation_Response>;
  /** insert a single row into the table: "risksmart.relation_file" */
  insert_relation_file_one?: Maybe<Relation_File>;
  /** insert data into the table: "risksmart.risk_assessment_result_config" */
  insert_risk_assessment_result_config?: Maybe<Risk_Assessment_Result_Config_Mutation_Response>;
  /** insert a single row into the table: "risksmart.risk_assessment_result_config" */
  insert_risk_assessment_result_config_one?: Maybe<Risk_Assessment_Result_Config>;
  insert_scim_domain: ScimDomainOutput;
  insert_scim_token: ScimTokenOutput;
  /** insert data into the table: "risksmart.tag_type" */
  insert_tag_type?: Maybe<Tag_Type_Mutation_Response>;
  /** insert data into the table: "risksmart.tag_type_group" */
  insert_tag_type_group?: Maybe<Tag_Type_Group_Mutation_Response>;
  /** insert a single row into the table: "risksmart.tag_type_group" */
  insert_tag_type_group_one?: Maybe<Tag_Type_Group>;
  /** insert a single row into the table: "risksmart.tag_type" */
  insert_tag_type_one?: Maybe<Tag_Type>;
  /** insert data into the table: "risksmart.taxonomy" */
  insert_taxonomy?: Maybe<Taxonomy_Mutation_Response>;
  /** insert a single row into the table: "risksmart.taxonomy" */
  insert_taxonomy_one?: Maybe<Taxonomy>;
  /** insert data into the table: "risksmart.taxonomy_org" */
  insert_taxonomy_org?: Maybe<Taxonomy_Org_Mutation_Response>;
  /** insert a single row into the table: "risksmart.taxonomy_org" */
  insert_taxonomy_org_one?: Maybe<Taxonomy_Org>;
  /** insert data into the table: "risksmart.third_party_contact" */
  insert_third_party_contact?: Maybe<Third_Party_Contact_Mutation_Response>;
  /** insert a single row into the table: "risksmart.third_party_contact" */
  insert_third_party_contact_one?: Maybe<Third_Party_Contact>;
  /** insert data into the table: "risksmart.third_party_response" */
  insert_third_party_response?: Maybe<Third_Party_Response_Mutation_Response>;
  /** insert a single row into the table: "risksmart.third_party_response" */
  insert_third_party_response_one?: Maybe<Third_Party_Response>;
  /** insert data into the table: "risksmart.user_group" */
  insert_user_group?: Maybe<User_Group_Mutation_Response>;
  /** insert a single row into the table: "risksmart.user_group" */
  insert_user_group_one?: Maybe<User_Group>;
  /** insert data into the table: "risksmart.user_group_user" */
  insert_user_group_user?: Maybe<User_Group_User_Mutation_Response>;
  /** insert a single row into the table: "risksmart.user_group_user" */
  insert_user_group_user_one?: Maybe<User_Group_User>;
  /** insert data into the table: "risksmart.user_search_preferences" */
  insert_user_search_preferences?: Maybe<User_Search_Preferences_Mutation_Response>;
  /** insert a single row into the table: "risksmart.user_search_preferences" */
  insert_user_search_preferences_one?: Maybe<User_Search_Preferences>;
  /** insert data into the table: "risksmart.user_tab_preference" */
  insert_user_tab_preference?: Maybe<User_Tab_Preference_Mutation_Response>;
  /** insert a single row into the table: "risksmart.user_tab_preference" */
  insert_user_tab_preference_one?: Maybe<User_Tab_Preference>;
  /** insert data into the table: "risksmart.user_table_preferences" */
  insert_user_table_preferences?: Maybe<User_Table_Preferences_Mutation_Response>;
  /** insert a single row into the table: "risksmart.user_table_preferences" */
  insert_user_table_preferences_one?: Maybe<User_Table_Preferences>;
  instantiateChildEnterpriseRisk?: Maybe<GenericMutationOutput>;
  linkItems?: Maybe<LinkItemsOutput>;
  overrideChangeRequest: IdOutput;
  publishQuestionnaireTemplateVersion: GenericMutationOutput;
  recalculateAppetites: RecalculateAppetitesOutput;
  recalculateRiskScores: RecalculateRiskScoresOutput;
  refreshScheduleState: RefreshScheduleStateOutput;
  /** revokeThirdPartyContactAccess */
  revokeThirdPartyContactAccess?: Maybe<RevokeThirdPartyContactAccessOutput>;
  unlinkItems?: Maybe<UnlinkItemsOutput>;
  updateApproverResponses?: Maybe<IdOutput>;
  updateAssessmentActivityWithLinkedItems?: Maybe<IdOutput>;
  /** updateAssessmentApi */
  updateAssessmentApi?: Maybe<GenericMutationOutput>;
  updateChildAcceptance: GenericMutationOutput;
  updateChildAction?: Maybe<UpdateChildActionOutput>;
  updateChildControl?: Maybe<GenericMutationOutput>;
  updateChildDashboard?: Maybe<IdOutput>;
  updateChildDocument?: Maybe<IdOutput>;
  updateChildEnterpriseRisk?: Maybe<GenericMutationOutput>;
  updateChildEntity?: Maybe<GenericMutationOutput>;
  updateChildIndicator?: Maybe<IdOutput>;
  updateChildIssueAssessment?: Maybe<IdOutput>;
  updateChildObligation?: Maybe<IdOutput>;
  updateChildRisk: IdOutput;
  updateChildRiskAssessmentResult?: Maybe<GenericMutationOutput>;
  /** updateComplianceMonitoringAssessmentApi */
  updateComplianceMonitoringAssessmentApi?: Maybe<GenericMutationOutput>;
  updateControlTestInternalAuditResultApi?: Maybe<IdOutput>;
  updateControlTestSecondLineResultApi?: Maybe<IdOutput>;
  updateDocumentVersion?: Maybe<GenericMutationOutput>;
  updateFormField?: Maybe<IdOutput>;
  updateImpactApi?: Maybe<GenericMutationOutput>;
  updateInternalAudit?: Maybe<IdOutput>;
  /** updateInternalAuditReportApi */
  updateInternalAuditReportApi?: Maybe<GenericMutationOutput>;
  updateIssueApi?: Maybe<GenericMutationOutput>;
  updateNotificationPreferences: UpdateNotificationPreferencesOutput;
  updateQuestionnaireTemplateApi?: Maybe<IdOutput>;
  updateRiskAssessmentResultConfigApi?: Maybe<UpdateRiskAssessmentResultConfigApiOutput>;
  updateTestResultApi?: Maybe<IdOutput>;
  /** updateThirdPartyApi */
  updateThirdPartyApi?: Maybe<IdOutput>;
  updateThirdPartyResponseStatusAction: GenericMutationOutput;
  updateWizardById?: Maybe<GenericMutationOutput>;
  /** update data of the table: "risksmart.action_update" */
  update_action_update?: Maybe<Action_Update_Mutation_Response>;
  /** update single row of the table: "risksmart.action_update" */
  update_action_update_by_pk?: Maybe<Action_Update>;
  /** update multiples rows of table: "risksmart.action_update" */
  update_action_update_many?: Maybe<Array<Maybe<Action_Update_Mutation_Response>>>;
  /** update data of the table: "risksmart.aggregation_org" */
  update_aggregation_org?: Maybe<Aggregation_Org_Mutation_Response>;
  /** update single row of the table: "risksmart.aggregation_org" */
  update_aggregation_org_by_pk?: Maybe<Aggregation_Org>;
  /** update multiples rows of table: "risksmart.aggregation_org" */
  update_aggregation_org_many?: Maybe<Array<Maybe<Aggregation_Org_Mutation_Response>>>;
  /** update data of the table: "risksmart.appetite" */
  update_appetite?: Maybe<Appetite_Mutation_Response>;
  /** update single row of the table: "risksmart.appetite" */
  update_appetite_by_pk?: Maybe<Appetite>;
  /** update multiples rows of table: "risksmart.appetite" */
  update_appetite_many?: Maybe<Array<Maybe<Appetite_Mutation_Response>>>;
  /** update data of the table: "risksmart.approval" */
  update_approval?: Maybe<Approval_Mutation_Response>;
  /** update single row of the table: "risksmart.approval" */
  update_approval_by_pk?: Maybe<Approval>;
  /** update data of the table: "risksmart.approval_level" */
  update_approval_level?: Maybe<Approval_Level_Mutation_Response>;
  /** update single row of the table: "risksmart.approval_level" */
  update_approval_level_by_pk?: Maybe<Approval_Level>;
  /** update multiples rows of table: "risksmart.approval_level" */
  update_approval_level_many?: Maybe<Array<Maybe<Approval_Level_Mutation_Response>>>;
  /** update multiples rows of table: "risksmart.approval" */
  update_approval_many?: Maybe<Array<Maybe<Approval_Mutation_Response>>>;
  /** update data of the table: "risksmart.approver" */
  update_approver?: Maybe<Approver_Mutation_Response>;
  /** update single row of the table: "risksmart.approver" */
  update_approver_by_pk?: Maybe<Approver>;
  /** update multiples rows of table: "risksmart.approver" */
  update_approver_many?: Maybe<Array<Maybe<Approver_Mutation_Response>>>;
  /** update data of the table: "risksmart.assessment_activity" */
  update_assessment_activity?: Maybe<Assessment_Activity_Mutation_Response>;
  /** update single row of the table: "risksmart.assessment_activity" */
  update_assessment_activity_by_pk?: Maybe<Assessment_Activity>;
  /** update multiples rows of table: "risksmart.assessment_activity" */
  update_assessment_activity_many?: Maybe<Array<Maybe<Assessment_Activity_Mutation_Response>>>;
  /** update data of the table: "risksmart.attestation_config" */
  update_attestation_config?: Maybe<Attestation_Config_Mutation_Response>;
  /** update single row of the table: "risksmart.attestation_config" */
  update_attestation_config_by_pk?: Maybe<Attestation_Config>;
  /** update multiples rows of table: "risksmart.attestation_config" */
  update_attestation_config_many?: Maybe<Array<Maybe<Attestation_Config_Mutation_Response>>>;
  /** update data of the table: "risksmart.attestation_cycle" */
  update_attestation_cycle?: Maybe<Attestation_Cycle_Mutation_Response>;
  /** update single row of the table: "risksmart.attestation_cycle" */
  update_attestation_cycle_by_pk?: Maybe<Attestation_Cycle>;
  /** update multiples rows of table: "risksmart.attestation_cycle" */
  update_attestation_cycle_many?: Maybe<Array<Maybe<Attestation_Cycle_Mutation_Response>>>;
  /** update data of the table: "risksmart.attestation_group" */
  update_attestation_group?: Maybe<Attestation_Group_Mutation_Response>;
  /** update single row of the table: "risksmart.attestation_group" */
  update_attestation_group_by_pk?: Maybe<Attestation_Group>;
  /** update multiples rows of table: "risksmart.attestation_group" */
  update_attestation_group_many?: Maybe<Array<Maybe<Attestation_Group_Mutation_Response>>>;
  /** update data of the table: "auth.organisation" */
  update_auth_organisation?: Maybe<Auth_Organisation_Mutation_Response>;
  /** update single row of the table: "auth.organisation" */
  update_auth_organisation_by_pk?: Maybe<Auth_Organisation>;
  /** update multiples rows of table: "auth.organisation" */
  update_auth_organisation_many?: Maybe<Array<Maybe<Auth_Organisation_Mutation_Response>>>;
  /** update data of the table: "auth.organisationuser" */
  update_auth_organisationuser?: Maybe<Auth_Organisationuser_Mutation_Response>;
  /** update single row of the table: "auth.organisationuser" */
  update_auth_organisationuser_by_pk?: Maybe<Auth_Organisationuser>;
  /** update multiples rows of table: "auth.organisationuser" */
  update_auth_organisationuser_many?: Maybe<Array<Maybe<Auth_Organisationuser_Mutation_Response>>>;
  /** update data of the table: "auth.user" */
  update_auth_user?: Maybe<Auth_User_Mutation_Response>;
  /** update single row of the table: "auth.user" */
  update_auth_user_by_pk?: Maybe<Auth_User>;
  /** update multiples rows of table: "auth.user" */
  update_auth_user_many?: Maybe<Array<Maybe<Auth_User_Mutation_Response>>>;
  /** update data of the table: "auth.user_role" */
  update_auth_user_role?: Maybe<Auth_User_Role_Mutation_Response>;
  /** update single row of the table: "auth.user_role" */
  update_auth_user_role_by_pk?: Maybe<Auth_User_Role>;
  /** update multiples rows of table: "auth.user_role" */
  update_auth_user_role_many?: Maybe<Array<Maybe<Auth_User_Role_Mutation_Response>>>;
  /** update data of the table: "risksmart.business_area" */
  update_business_area?: Maybe<Business_Area_Mutation_Response>;
  /** update single row of the table: "risksmart.business_area" */
  update_business_area_by_pk?: Maybe<Business_Area>;
  /** update multiples rows of table: "risksmart.business_area" */
  update_business_area_many?: Maybe<Array<Maybe<Business_Area_Mutation_Response>>>;
  /** update data of the table: "risksmart.cause" */
  update_cause?: Maybe<Cause_Mutation_Response>;
  /** update single row of the table: "risksmart.cause" */
  update_cause_by_pk?: Maybe<Cause>;
  /** update multiples rows of table: "risksmart.cause" */
  update_cause_many?: Maybe<Array<Maybe<Cause_Mutation_Response>>>;
  /** update data of the table: "risksmart.colour_palette" */
  update_colour_palette?: Maybe<Colour_Palette_Mutation_Response>;
  /** update single row of the table: "risksmart.colour_palette" */
  update_colour_palette_by_pk?: Maybe<Colour_Palette>;
  /** update multiples rows of table: "risksmart.colour_palette" */
  update_colour_palette_many?: Maybe<Array<Maybe<Colour_Palette_Mutation_Response>>>;
  /** update data of the table: "risksmart.comment" */
  update_comment?: Maybe<Comment_Mutation_Response>;
  /** update single row of the table: "risksmart.comment" */
  update_comment_by_pk?: Maybe<Comment>;
  /** update multiples rows of table: "risksmart.comment" */
  update_comment_many?: Maybe<Array<Maybe<Comment_Mutation_Response>>>;
  /** update data of the table: "risksmart.consequence" */
  update_consequence?: Maybe<Consequence_Mutation_Response>;
  /** update single row of the table: "risksmart.consequence" */
  update_consequence_by_pk?: Maybe<Consequence>;
  /** update multiples rows of table: "risksmart.consequence" */
  update_consequence_many?: Maybe<Array<Maybe<Consequence_Mutation_Response>>>;
  /** update data of the table: "risksmart.control_group" */
  update_control_group?: Maybe<Control_Group_Mutation_Response>;
  /** update single row of the table: "risksmart.control_group" */
  update_control_group_by_pk?: Maybe<Control_Group>;
  /** update multiples rows of table: "risksmart.control_group" */
  update_control_group_many?: Maybe<Array<Maybe<Control_Group_Mutation_Response>>>;
  /** update data of the table: "risksmart.conversation" */
  update_conversation?: Maybe<Conversation_Mutation_Response>;
  /** update single row of the table: "risksmart.conversation" */
  update_conversation_by_pk?: Maybe<Conversation>;
  /** update multiples rows of table: "risksmart.conversation" */
  update_conversation_many?: Maybe<Array<Maybe<Conversation_Mutation_Response>>>;
  /** update data of the table: "risksmart.custom_attribute_schema" */
  update_custom_attribute_schema?: Maybe<Custom_Attribute_Schema_Mutation_Response>;
  /** update single row of the table: "risksmart.custom_attribute_schema" */
  update_custom_attribute_schema_by_pk?: Maybe<Custom_Attribute_Schema>;
  /** update multiples rows of table: "risksmart.custom_attribute_schema" */
  update_custom_attribute_schema_many?: Maybe<Array<Maybe<Custom_Attribute_Schema_Mutation_Response>>>;
  /** update data of the table: "risksmart.custom_datasource" */
  update_custom_datasource?: Maybe<Custom_Datasource_Mutation_Response>;
  /** update single row of the table: "risksmart.custom_datasource" */
  update_custom_datasource_by_pk?: Maybe<Custom_Datasource>;
  /** update multiples rows of table: "risksmart.custom_datasource" */
  update_custom_datasource_many?: Maybe<Array<Maybe<Custom_Datasource_Mutation_Response>>>;
  /** update data of the table: "risksmart.custom_ribbon" */
  update_custom_ribbon?: Maybe<Custom_Ribbon_Mutation_Response>;
  /** update single row of the table: "risksmart.custom_ribbon" */
  update_custom_ribbon_by_pk?: Maybe<Custom_Ribbon>;
  /** update multiples rows of table: "risksmart.custom_ribbon" */
  update_custom_ribbon_many?: Maybe<Array<Maybe<Custom_Ribbon_Mutation_Response>>>;
  /** update data of the table: "risksmart.data_export_schedule" */
  update_data_export_schedule?: Maybe<Data_Export_Schedule_Mutation_Response>;
  /** update single row of the table: "risksmart.data_export_schedule" */
  update_data_export_schedule_by_pk?: Maybe<Data_Export_Schedule>;
  /** update data of the table: "risksmart.data_export_schedule_execution" */
  update_data_export_schedule_execution?: Maybe<Data_Export_Schedule_Execution_Mutation_Response>;
  /** update single row of the table: "risksmart.data_export_schedule_execution" */
  update_data_export_schedule_execution_by_pk?: Maybe<Data_Export_Schedule_Execution>;
  /** update multiples rows of table: "risksmart.data_export_schedule_execution" */
  update_data_export_schedule_execution_many?: Maybe<Array<Maybe<Data_Export_Schedule_Execution_Mutation_Response>>>;
  /** update multiples rows of table: "risksmart.data_export_schedule" */
  update_data_export_schedule_many?: Maybe<Array<Maybe<Data_Export_Schedule_Mutation_Response>>>;
  /** update data of the table: "risksmart.department_type" */
  update_department_type?: Maybe<Department_Type_Mutation_Response>;
  /** update single row of the table: "risksmart.department_type" */
  update_department_type_by_pk?: Maybe<Department_Type>;
  /** update data of the table: "risksmart.department_type_group" */
  update_department_type_group?: Maybe<Department_Type_Group_Mutation_Response>;
  /** update multiples rows of table: "risksmart.department_type_group" */
  update_department_type_group_many?: Maybe<Array<Maybe<Department_Type_Group_Mutation_Response>>>;
  /** update multiples rows of table: "risksmart.department_type" */
  update_department_type_many?: Maybe<Array<Maybe<Department_Type_Mutation_Response>>>;
  /** update data of the table: "risksmart.document_assessment_result" */
  update_document_assessment_result?: Maybe<Document_Assessment_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.document_assessment_result" */
  update_document_assessment_result_by_pk?: Maybe<Document_Assessment_Result>;
  /** update multiples rows of table: "risksmart.document_assessment_result" */
  update_document_assessment_result_many?: Maybe<Array<Maybe<Document_Assessment_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.document_internal_audit_result" */
  update_document_internal_audit_result?: Maybe<Document_Internal_Audit_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.document_internal_audit_result" */
  update_document_internal_audit_result_by_pk?: Maybe<Document_Internal_Audit_Result>;
  /** update multiples rows of table: "risksmart.document_internal_audit_result" */
  update_document_internal_audit_result_many?: Maybe<Array<Maybe<Document_Internal_Audit_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.document_second_line_result" */
  update_document_second_line_result?: Maybe<Document_Second_Line_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.document_second_line_result" */
  update_document_second_line_result_by_pk?: Maybe<Document_Second_Line_Result>;
  /** update multiples rows of table: "risksmart.document_second_line_result" */
  update_document_second_line_result_many?: Maybe<Array<Maybe<Document_Second_Line_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.form_configuration" */
  update_form_configuration?: Maybe<Form_Configuration_Mutation_Response>;
  /** update multiples rows of table: "risksmart.form_configuration" */
  update_form_configuration_many?: Maybe<Array<Maybe<Form_Configuration_Mutation_Response>>>;
  /** update data of the table: "risksmart.form_field_configuration" */
  update_form_field_configuration?: Maybe<Form_Field_Configuration_Mutation_Response>;
  /** update multiples rows of table: "risksmart.form_field_configuration" */
  update_form_field_configuration_many?: Maybe<Array<Maybe<Form_Field_Configuration_Mutation_Response>>>;
  /** update data of the table: "risksmart.form_field_ordering" */
  update_form_field_ordering?: Maybe<Form_Field_Ordering_Mutation_Response>;
  /** update multiples rows of table: "risksmart.form_field_ordering" */
  update_form_field_ordering_many?: Maybe<Array<Maybe<Form_Field_Ordering_Mutation_Response>>>;
  /** update data of the table: "risksmart.indicator_result" */
  update_indicator_result?: Maybe<Indicator_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.indicator_result" */
  update_indicator_result_by_pk?: Maybe<Indicator_Result>;
  /** update multiples rows of table: "risksmart.indicator_result" */
  update_indicator_result_many?: Maybe<Array<Maybe<Indicator_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.issue_update" */
  update_issue_update?: Maybe<Issue_Update_Mutation_Response>;
  /** update single row of the table: "risksmart.issue_update" */
  update_issue_update_by_pk?: Maybe<Issue_Update>;
  /** update multiples rows of table: "risksmart.issue_update" */
  update_issue_update_many?: Maybe<Array<Maybe<Issue_Update_Mutation_Response>>>;
  /** update data of the table: "risksmart.obligation_assessment_result" */
  update_obligation_assessment_result?: Maybe<Obligation_Assessment_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.obligation_assessment_result" */
  update_obligation_assessment_result_by_pk?: Maybe<Obligation_Assessment_Result>;
  /** update multiples rows of table: "risksmart.obligation_assessment_result" */
  update_obligation_assessment_result_many?: Maybe<Array<Maybe<Obligation_Assessment_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.obligation_impact" */
  update_obligation_impact?: Maybe<Obligation_Impact_Mutation_Response>;
  /** update single row of the table: "risksmart.obligation_impact" */
  update_obligation_impact_by_pk?: Maybe<Obligation_Impact>;
  /** update multiples rows of table: "risksmart.obligation_impact" */
  update_obligation_impact_many?: Maybe<Array<Maybe<Obligation_Impact_Mutation_Response>>>;
  /** update data of the table: "risksmart.obligation_internal_audit_result" */
  update_obligation_internal_audit_result?: Maybe<Obligation_Internal_Audit_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.obligation_internal_audit_result" */
  update_obligation_internal_audit_result_by_pk?: Maybe<Obligation_Internal_Audit_Result>;
  /** update multiples rows of table: "risksmart.obligation_internal_audit_result" */
  update_obligation_internal_audit_result_many?: Maybe<Array<Maybe<Obligation_Internal_Audit_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.obligation_second_line_result" */
  update_obligation_second_line_result?: Maybe<Obligation_Second_Line_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.obligation_second_line_result" */
  update_obligation_second_line_result_by_pk?: Maybe<Obligation_Second_Line_Result>;
  /** update multiples rows of table: "risksmart.obligation_second_line_result" */
  update_obligation_second_line_result_many?: Maybe<Array<Maybe<Obligation_Second_Line_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.organisation_module" */
  update_organisation_module?: Maybe<Organisation_Module_Mutation_Response>;
  /** update multiples rows of table: "risksmart.organisation_module" */
  update_organisation_module_many?: Maybe<Array<Maybe<Organisation_Module_Mutation_Response>>>;
  /** update data of the table: "risksmart.organisation_tab_preference" */
  update_organisation_tab_preference?: Maybe<Organisation_Tab_Preference_Mutation_Response>;
  /** update multiples rows of table: "risksmart.organisation_tab_preference" */
  update_organisation_tab_preference_many?: Maybe<Array<Maybe<Organisation_Tab_Preference_Mutation_Response>>>;
  /** update data of the table: "risksmart.questionnaire_template_version" */
  update_questionnaire_template_version?: Maybe<Questionnaire_Template_Version_Mutation_Response>;
  /** update single row of the table: "risksmart.questionnaire_template_version" */
  update_questionnaire_template_version_by_pk?: Maybe<Questionnaire_Template_Version>;
  /** update multiples rows of table: "risksmart.questionnaire_template_version" */
  update_questionnaire_template_version_many?: Maybe<Array<Maybe<Questionnaire_Template_Version_Mutation_Response>>>;
  /** update data of the table: "risksmart.risk_assessment_result_config" */
  update_risk_assessment_result_config?: Maybe<Risk_Assessment_Result_Config_Mutation_Response>;
  /** update single row of the table: "risksmart.risk_assessment_result_config" */
  update_risk_assessment_result_config_by_pk?: Maybe<Risk_Assessment_Result_Config>;
  /** update multiples rows of table: "risksmart.risk_assessment_result_config" */
  update_risk_assessment_result_config_many?: Maybe<Array<Maybe<Risk_Assessment_Result_Config_Mutation_Response>>>;
  /** update data of the table: "risksmart.risk_controlled_internal_audit_result" */
  update_risk_controlled_internal_audit_result?: Maybe<Risk_Controlled_Internal_Audit_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.risk_controlled_internal_audit_result" */
  update_risk_controlled_internal_audit_result_by_pk?: Maybe<Risk_Controlled_Internal_Audit_Result>;
  /** update multiples rows of table: "risksmart.risk_controlled_internal_audit_result" */
  update_risk_controlled_internal_audit_result_many?: Maybe<Array<Maybe<Risk_Controlled_Internal_Audit_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.risk_controlled_second_line_result" */
  update_risk_controlled_second_line_result?: Maybe<Risk_Controlled_Second_Line_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.risk_controlled_second_line_result" */
  update_risk_controlled_second_line_result_by_pk?: Maybe<Risk_Controlled_Second_Line_Result>;
  /** update multiples rows of table: "risksmart.risk_controlled_second_line_result" */
  update_risk_controlled_second_line_result_many?: Maybe<Array<Maybe<Risk_Controlled_Second_Line_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  update_risk_uncontrolled_internal_audit_result?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  update_risk_uncontrolled_internal_audit_result_by_pk?: Maybe<Risk_Uncontrolled_Internal_Audit_Result>;
  /** update multiples rows of table: "risksmart.risk_uncontrolled_internal_audit_result" */
  update_risk_uncontrolled_internal_audit_result_many?: Maybe<Array<Maybe<Risk_Uncontrolled_Internal_Audit_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.risk_uncontrolled_second_line_result" */
  update_risk_uncontrolled_second_line_result?: Maybe<Risk_Uncontrolled_Second_Line_Result_Mutation_Response>;
  /** update single row of the table: "risksmart.risk_uncontrolled_second_line_result" */
  update_risk_uncontrolled_second_line_result_by_pk?: Maybe<Risk_Uncontrolled_Second_Line_Result>;
  /** update multiples rows of table: "risksmart.risk_uncontrolled_second_line_result" */
  update_risk_uncontrolled_second_line_result_many?: Maybe<Array<Maybe<Risk_Uncontrolled_Second_Line_Result_Mutation_Response>>>;
  /** update data of the table: "risksmart.tag_type" */
  update_tag_type?: Maybe<Tag_Type_Mutation_Response>;
  /** update single row of the table: "risksmart.tag_type" */
  update_tag_type_by_pk?: Maybe<Tag_Type>;
  /** update data of the table: "risksmart.tag_type_group" */
  update_tag_type_group?: Maybe<Tag_Type_Group_Mutation_Response>;
  /** update multiples rows of table: "risksmart.tag_type_group" */
  update_tag_type_group_many?: Maybe<Array<Maybe<Tag_Type_Group_Mutation_Response>>>;
  /** update multiples rows of table: "risksmart.tag_type" */
  update_tag_type_many?: Maybe<Array<Maybe<Tag_Type_Mutation_Response>>>;
  /** update data of the table: "risksmart.taxonomy" */
  update_taxonomy?: Maybe<Taxonomy_Mutation_Response>;
  /** update single row of the table: "risksmart.taxonomy" */
  update_taxonomy_by_pk?: Maybe<Taxonomy>;
  /** update multiples rows of table: "risksmart.taxonomy" */
  update_taxonomy_many?: Maybe<Array<Maybe<Taxonomy_Mutation_Response>>>;
  /** update data of the table: "risksmart.third_party_contact" */
  update_third_party_contact?: Maybe<Third_Party_Contact_Mutation_Response>;
  /** update single row of the table: "risksmart.third_party_contact" */
  update_third_party_contact_by_pk?: Maybe<Third_Party_Contact>;
  /** update multiples rows of table: "risksmart.third_party_contact" */
  update_third_party_contact_many?: Maybe<Array<Maybe<Third_Party_Contact_Mutation_Response>>>;
  /** update data of the table: "risksmart.third_party_response" */
  update_third_party_response?: Maybe<Third_Party_Response_Mutation_Response>;
  /** update single row of the table: "risksmart.third_party_response" */
  update_third_party_response_by_pk?: Maybe<Third_Party_Response>;
  /** update multiples rows of table: "risksmart.third_party_response" */
  update_third_party_response_many?: Maybe<Array<Maybe<Third_Party_Response_Mutation_Response>>>;
  /** update data of the table: "risksmart.user_group" */
  update_user_group?: Maybe<User_Group_Mutation_Response>;
  /** update single row of the table: "risksmart.user_group" */
  update_user_group_by_pk?: Maybe<User_Group>;
  /** update multiples rows of table: "risksmart.user_group" */
  update_user_group_many?: Maybe<Array<Maybe<User_Group_Mutation_Response>>>;
  update_user_roles: UpdateUserRolesMutationOutput;
  /** update data of the table: "risksmart.user_search_preferences" */
  update_user_search_preferences?: Maybe<User_Search_Preferences_Mutation_Response>;
  /** update multiples rows of table: "risksmart.user_search_preferences" */
  update_user_search_preferences_many?: Maybe<Array<Maybe<User_Search_Preferences_Mutation_Response>>>;
  /** update data of the table: "risksmart.user_tab_preference" */
  update_user_tab_preference?: Maybe<User_Tab_Preference_Mutation_Response>;
  /** update multiples rows of table: "risksmart.user_tab_preference" */
  update_user_tab_preference_many?: Maybe<Array<Maybe<User_Tab_Preference_Mutation_Response>>>;
  /** update data of the table: "risksmart.user_table_preferences" */
  update_user_table_preferences?: Maybe<User_Table_Preferences_Mutation_Response>;
  /** update multiples rows of table: "risksmart.user_table_preferences" */
  update_user_table_preferences_many?: Maybe<Array<Maybe<User_Table_Preferences_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAddRiskToEnterpriseRiskArgs = {
  objects: Array<AddRiskToEnterpriseRiskInput>;
};


/** mutation root */
export type Mutation_RootAttestRecordArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootAttestationNotRequiredArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCustomRoleInsertArgs = {
  Input?: InputMaybe<CustomRoleInsertInputData>;
};


/** mutation root */
export type Mutation_RootCustomRoleUpdateArgs = {
  Input?: InputMaybe<CustomRoleUpdateInputData>;
};


/** mutation root */
export type Mutation_RootCustomRoleUserUpdateArgs = {
  Input?: InputMaybe<CustomRoleUserUpdateInputData>;
};


/** mutation root */
export type Mutation_RootDataExportCreateScheduleArgs = {
  object: DataExportCreateScheduleInput;
};


/** mutation root */
export type Mutation_RootDataExportTestScheduleArgs = {
  object: DataExportTestScheduleInput;
};


/** mutation root */
export type Mutation_RootDataImportStartImportArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDataImportValidateArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAcceptancesByIdArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteActionsByIdArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteChildEnterpriseRiskArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChildEntityArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteControlsByIdArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteDepartmentTypeApiArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteDocumentByIdArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFormFieldArgs = {
  object: DeleteFormFieldInput;
};


/** mutation root */
export type Mutation_RootDeleteIssuesByIdArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteRiskByIdArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteTagTypeApiArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteUserGroupsArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootDeleteWizardByIdArgs = {
  RiskId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Acceptance_ParentArgs = {
  where: Acceptance_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Acceptance_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Action_ParentArgs = {
  where: Action_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Action_Parent_By_PkArgs = {
  ActionId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Action_UpdateArgs = {
  where: Action_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Action_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AppetiteArgs = {
  where: Appetite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appetite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Appetite_ParentArgs = {
  where: Appetite_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appetite_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ApprovalArgs = {
  where: Approval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Approval_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Approval_LevelArgs = {
  where: Approval_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Approval_Level_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ApproverArgs = {
  where: Approver_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Approver_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AssessmentArgs = {
  where: Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_ActivityArgs = {
  where: Assessment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Activity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Result_ParentArgs = {
  where: Assessment_Result_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Attestation_ConfigArgs = {
  where: Attestation_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attestation_Config_By_PkArgs = {
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Attestation_GroupArgs = {
  where: Attestation_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attestation_Group_By_PkArgs = {
  ConfigId: Scalars['uuid']['input'];
  GroupId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_RoleArgs = {
  where: Auth_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_Role_By_PkArgs = {
  Id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Business_AreaArgs = {
  where: Business_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Area_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CauseArgs = {
  where: Cause_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cause_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Colour_PaletteArgs = {
  where: Colour_Palette_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Colour_Palette_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs = {
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Monitoring_AssessmentArgs = {
  where: Compliance_Monitoring_Assessment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Compliance_Monitoring_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConsequenceArgs = {
  where: Consequence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consequence_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Control_GroupArgs = {
  where: Control_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Control_Group_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Control_ParentArgs = {
  where: Control_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Control_Parent_By_PkArgs = {
  ControlId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Control_Test_Internal_Audit_ResultArgs = {
  where: Control_Test_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Control_Test_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Control_Test_Second_Line_ResultArgs = {
  where: Control_Test_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Control_Test_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConversationArgs = {
  where: Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Conversation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Attribute_SchemaArgs = {
  where: Custom_Attribute_Schema_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Attribute_Schema_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_DatasourceArgs = {
  where: Custom_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Datasource_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_RoleArgs = {
  where: Custom_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Role_AssignmentArgs = {
  where: Custom_Role_Assignment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Role_Assignment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Role_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Role_UserArgs = {
  where: Custom_Role_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Role_User_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DashboardArgs = {
  where: Dashboard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dashboard_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Data_Export_ScheduleArgs = {
  where: Data_Export_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Data_Export_Schedule_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Data_ImportArgs = {
  where: Data_Import_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Data_Import_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Data_Import_ErrorArgs = {
  where: Data_Import_Error_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Data_Import_Error_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Assessment_ResultArgs = {
  where: Document_Assessment_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_FileArgs = {
  where: Document_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_File_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Internal_Audit_ResultArgs = {
  where: Document_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Linked_DocumentArgs = {
  where: Document_Linked_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Linked_Document_By_PkArgs = {
  DocumentId: Scalars['uuid']['input'];
  LinkedDocumentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Second_Line_ResultArgs = {
  where: Document_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enterprise_Risk_ScoreArgs = {
  where: Enterprise_Risk_Score_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enterprise_Risk_Score_By_PkArgs = {
  EnterpriseRiskId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Form_ConfigurationArgs = {
  where: Form_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Form_Field_ConfigurationArgs = {
  where: Form_Field_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Form_Field_OrderingArgs = {
  where: Form_Field_Ordering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ImpactArgs = {
  where: Impact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Impact_Internal_Audit_RatingArgs = {
  where: Impact_Internal_Audit_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Impact_Internal_Audit_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Impact_RatingArgs = {
  where: Impact_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Impact_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Impact_Second_Line_RatingArgs = {
  where: Impact_Second_Line_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Impact_Second_Line_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorArgs = {
  where: Indicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Indicator_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Indicator_ParentArgs = {
  where: Indicator_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Indicator_Parent_By_PkArgs = {
  IndicatorId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Indicator_ResultArgs = {
  where: Indicator_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Indicator_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_EntityArgs = {
  where: Internal_Audit_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_Entity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_ReportArgs = {
  where: Internal_Audit_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_Report_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_Result_ParentArgs = {
  where: Internal_Audit_Result_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Internal_Audit_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Issue_UpdateArgs = {
  where: Issue_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Issue_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Linked_ItemArgs = {
  where: Linked_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Linked_Item_By_PkArgs = {
  Source: Scalars['uuid']['input'];
  Target: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ObligationArgs = {
  where: Obligation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Assessment_ResultArgs = {
  where: Obligation_Assessment_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Obligation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Obligation_ImpactArgs = {
  where: Obligation_Impact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Internal_Audit_ResultArgs = {
  where: Obligation_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Second_Line_ResultArgs = {
  where: Obligation_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Obligation_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_ModuleArgs = {
  where: Organisation_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Tab_PreferenceArgs = {
  where: Organisation_Tab_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_InviteArgs = {
  where: Questionnaire_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Invite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_TemplateArgs = {
  where: Questionnaire_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Template_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Template_VersionArgs = {
  where: Questionnaire_Template_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Template_Version_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Relation_FileArgs = {
  where: Relation_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relation_File_By_PkArgs = {
  FileId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Assessment_ResultArgs = {
  where: Risk_Assessment_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Assessment_Result_ImpactArgs = {
  where: Risk_Assessment_Result_Impact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Assessment_Result_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Controlled_Internal_Audit_ResultArgs = {
  where: Risk_Controlled_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Controlled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Controlled_Second_Line_ResultArgs = {
  where: Risk_Controlled_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Controlled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Uncontrolled_Internal_Audit_ResultArgs = {
  where: Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Uncontrolled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Uncontrolled_Second_Line_ResultArgs = {
  where: Risk_Uncontrolled_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Uncontrolled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scim_DomainArgs = {
  domain: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scim_TokenArgs = {
  keyId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Second_Line_Result_ParentArgs = {
  where: Second_Line_Result_Parent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Second_Line_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaxonomyArgs = {
  where: Taxonomy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Taxonomy_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Taxonomy_OrgArgs = {
  where: Taxonomy_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Taxonomy_Org_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Test_ResultArgs = {
  where: Test_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Third_PartyArgs = {
  where: Third_Party_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_ContactArgs = {
  where: Third_Party_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_Contact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_ResponseArgs = {
  where: Third_Party_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_Response_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Group_UserArgs = {
  where: User_Group_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Group_User_By_PkArgs = {
  UserGroupId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Tab_PreferenceArgs = {
  where: User_Tab_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootInsertAssessmentActivityWithLinkedItemsArgs = {
  ActivityType: Assessment_Activity_Type_Enum;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  IsRCSA?: InputMaybe<Scalars['Boolean']['input']>;
  LinkedItemIds: Array<Scalars['uuid']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId: Scalars['uuid']['input'];
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status: Assessment_Activity_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsertAssessmentApiArgs = {
  object?: InputMaybe<InsertAssessmentInput>;
};


/** mutation root */
export type Mutation_RootInsertChildAcceptanceArgs = {
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateAcceptedFrom: Scalars['timestamptz']['input'];
  DateAcceptedTo: Scalars['timestamptz']['input'];
  Details?: InputMaybe<Scalars['String']['input']>;
  ParentId: Scalars['uuid']['input'];
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildActionArgs = {
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateDue: Scalars['timestamptz']['input'];
  DateRaised: Scalars['timestamptz']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  Status: Action_Status_Enum;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsertChildAppetiteArgs = {
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  ParentIds: Array<Scalars['uuid']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildAttestationConfigArgs = {
  object?: InputMaybe<InsertAttestationConfigInput>;
};


/** mutation root */
export type Mutation_RootInsertChildAttestationCycleArgs = {
  object?: InputMaybe<InsertChildAttestationCycleInput>;
};


/** mutation root */
export type Mutation_RootInsertChildControlArgs = {
  object?: InputMaybe<InsertChildControlInput>;
};


/** mutation root */
export type Mutation_RootInsertChildControlTestInternalAuditResultArgs = {
  ControlIds: Array<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildControlTestSecondLineResultArgs = {
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  ControlIds: Array<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildDashboardArgs = {
  Content: Scalars['jsonb']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Sharing: Dashboard_Sharing_Type_Enum_Action;
};


/** mutation root */
export type Mutation_RootInsertChildDocumentArgs = {
  object?: InputMaybe<InsertChildDocumentInput>;
};


/** mutation root */
export type Mutation_RootInsertChildDocumentAssessmentResultArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentIds: Array<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildDocumentInternalAuditResultArgs = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentIds: Array<Scalars['uuid']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildDocumentSecondLineResultArgs = {
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DocumentIds: Array<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildEnterpriseRiskArgs = {
  object?: InputMaybe<InsertEnterpriseRiskInput>;
};


/** mutation root */
export type Mutation_RootInsertChildEntityArgs = {
  object?: InputMaybe<InsertEntityInput>;
};


/** mutation root */
export type Mutation_RootInsertChildImpactInternalAuditRatingArgs = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  RatedItemId: Scalars['uuid']['input'];
  Ratings: Array<InsertImpactRatingPairInput>;
  TestDate: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootInsertChildImpactRatingArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  RatedItemId: Scalars['uuid']['input'];
  Ratings: Array<InsertImpactRatingPairInput>;
  TestDate: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootInsertChildImpactSecondLineRatingArgs = {
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  RatedItemId: Scalars['uuid']['input'];
  Ratings: Array<InsertImpactRatingPairInput>;
  TestDate: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootInsertChildIndicatorArgs = {
  object?: InputMaybe<InsertChildIndicatorInput>;
};


/** mutation root */
export type Mutation_RootInsertChildIssueArgs = {
  object?: InputMaybe<InsertIssueInput>;
};


/** mutation root */
export type Mutation_RootInsertChildIssueAssessmentArgs = {
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  AssociatedControlIds: Array<Scalars['uuid']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId: Scalars['uuid']['input'];
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PoliciesBreachedIds: Array<Scalars['uuid']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreachedIds: Array<Scalars['uuid']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildObligationArgs = {
  object?: InputMaybe<InsertChildObligationInput>;
};


/** mutation root */
export type Mutation_RootInsertChildObligationAssessmentResultArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ObligationIds: Array<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildObligationChangeAttestationArgs = {
  object: InsertChildObligationChangeAttestationInput;
};


/** mutation root */
export type Mutation_RootInsertChildObligationInternalAuditResultArgs = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  ObligationIds: Array<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildObligationSecondLineResultArgs = {
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ObligationIds: Array<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildRiskArgs = {
  object?: InputMaybe<InsertChildRiskInput>;
};


/** mutation root */
export type Mutation_RootInsertChildRiskAssessmentResultArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Impacts?: InputMaybe<Array<RiskAssessmentResultImpactsInput>>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RiskIds: Array<Scalars['uuid']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildRiskInternalAuditResultArgs = {
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RiskIds: Array<Scalars['uuid']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildRiskSecondLineResultArgs = {
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RiskIds: Array<Scalars['uuid']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootInsertChildWizardArgs = {
  object?: InputMaybe<InsertWizardInput>;
};


/** mutation root */
export type Mutation_RootInsertComplianceMonitoringAssessmentApiArgs = {
  object?: InputMaybe<InsertAssessmentInput>;
};


/** mutation root */
export type Mutation_RootInsertControlTestResultArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  ControlIds: Array<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertDocumentVersionArgs = {
  Content?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentDocumentId: Scalars['uuid']['input'];
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Document_File_Type_Enum>;
  Version?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertFormFieldArgs = {
  object: InsertFormFieldInput;
};


/** mutation root */
export type Mutation_RootInsertImpactApiArgs = {
  object?: InputMaybe<InsertImpactInput>;
};


/** mutation root */
export type Mutation_RootInsertInternalAuditArgs = {
  Input?: InputMaybe<InsertInternalAuditInput>;
};


/** mutation root */
export type Mutation_RootInsertInternalAuditReportApiArgs = {
  object?: InputMaybe<InsertAssessmentInput>;
};


/** mutation root */
export type Mutation_RootInsertQuestionnaireInvitesArgs = {
  Message?: InputMaybe<Scalars['String']['input']>;
  QuestionnaireTemplateVersionIds: Array<Scalars['uuid']['input']>;
  ThirdPartyId: Scalars['uuid']['input'];
  UserEmails: Array<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertQuestionnaireTemplateApiArgs = {
  object?: InputMaybe<InsertQuestionnaireTemplateInput>;
};


/** mutation root */
export type Mutation_RootInsertReferenceUserArgs = {
  Email: Scalars['String']['input'];
  UserName?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootInsertRiskAssessmentResultConfigApiArgs = {
  Config: Scalars['jsonb']['input'];
};


/** mutation root */
export type Mutation_RootInsertThirdPartyApiArgs = {
  object?: InputMaybe<InsertThirdPartyInput>;
};


/** mutation root */
export type Mutation_RootInsertThirdPartyContactApiArgs = {
  Email: Scalars['String']['input'];
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ThirdPartyId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Action_UpdateArgs = {
  objects: Array<Action_Update_Insert_Input>;
  on_conflict?: InputMaybe<Action_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Action_Update_OneArgs = {
  object: Action_Update_Insert_Input;
  on_conflict?: InputMaybe<Action_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Aggregation_OrgArgs = {
  objects: Array<Aggregation_Org_Insert_Input>;
  on_conflict?: InputMaybe<Aggregation_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Aggregation_Org_OneArgs = {
  object: Aggregation_Org_Insert_Input;
  on_conflict?: InputMaybe<Aggregation_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApprovalArgs = {
  objects: Array<Approval_Insert_Input>;
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Approval_LevelArgs = {
  objects: Array<Approval_Level_Insert_Input>;
  on_conflict?: InputMaybe<Approval_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Approval_Level_OneArgs = {
  object: Approval_Level_Insert_Input;
  on_conflict?: InputMaybe<Approval_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Approval_OneArgs = {
  object: Approval_Insert_Input;
  on_conflict?: InputMaybe<Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApproverArgs = {
  objects: Array<Approver_Insert_Input>;
  on_conflict?: InputMaybe<Approver_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Approver_OneArgs = {
  object: Approver_Insert_Input;
  on_conflict?: InputMaybe<Approver_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_ActivityArgs = {
  objects: Array<Assessment_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Activity_OneArgs = {
  object: Assessment_Activity_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_ConfigArgs = {
  objects: Array<Attestation_Config_Insert_Input>;
  on_conflict?: InputMaybe<Attestation_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_Config_OneArgs = {
  object: Attestation_Config_Insert_Input;
  on_conflict?: InputMaybe<Attestation_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_CycleArgs = {
  objects: Array<Attestation_Cycle_Insert_Input>;
  on_conflict?: InputMaybe<Attestation_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_Cycle_OneArgs = {
  object: Attestation_Cycle_Insert_Input;
  on_conflict?: InputMaybe<Attestation_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_GroupArgs = {
  objects: Array<Attestation_Group_Insert_Input>;
  on_conflict?: InputMaybe<Attestation_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attestation_Group_OneArgs = {
  object: Attestation_Group_Insert_Input;
  on_conflict?: InputMaybe<Attestation_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_RoleArgs = {
  objects: Array<Auth_User_Role_Insert_Input>;
  on_conflict?: InputMaybe<Auth_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_Role_OneArgs = {
  object: Auth_User_Role_Insert_Input;
  on_conflict?: InputMaybe<Auth_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_AreaArgs = {
  objects: Array<Business_Area_Insert_Input>;
  on_conflict?: InputMaybe<Business_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Area_OneArgs = {
  object: Business_Area_Insert_Input;
  on_conflict?: InputMaybe<Business_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CauseArgs = {
  objects: Array<Cause_Insert_Input>;
  on_conflict?: InputMaybe<Cause_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cause_OneArgs = {
  object: Cause_Insert_Input;
  on_conflict?: InputMaybe<Cause_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Colour_PaletteArgs = {
  objects: Array<Colour_Palette_Insert_Input>;
  on_conflict?: InputMaybe<Colour_Palette_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Colour_Palette_OneArgs = {
  object: Colour_Palette_Insert_Input;
  on_conflict?: InputMaybe<Colour_Palette_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs = {
  objects: Array<Comment_Insert_Input>;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comment_OneArgs = {
  object: Comment_Insert_Input;
  on_conflict?: InputMaybe<Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConsequenceArgs = {
  objects: Array<Consequence_Insert_Input>;
  on_conflict?: InputMaybe<Consequence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consequence_OneArgs = {
  object: Consequence_Insert_Input;
  on_conflict?: InputMaybe<Consequence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ControlArgs = {
  objects: Array<Control_Insert_Input>;
  on_conflict?: InputMaybe<Control_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Control_GroupArgs = {
  objects: Array<Control_Group_Insert_Input>;
  on_conflict?: InputMaybe<Control_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Control_Group_OneArgs = {
  object: Control_Group_Insert_Input;
  on_conflict?: InputMaybe<Control_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Control_OneArgs = {
  object: Control_Insert_Input;
  on_conflict?: InputMaybe<Control_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Control_ParentArgs = {
  objects: Array<Control_Parent_Insert_Input>;
  on_conflict?: InputMaybe<Control_Parent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Control_Parent_OneArgs = {
  object: Control_Parent_Insert_Input;
  on_conflict?: InputMaybe<Control_Parent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConversationArgs = {
  objects: Array<Conversation_Insert_Input>;
  on_conflict?: InputMaybe<Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Conversation_OneArgs = {
  object: Conversation_Insert_Input;
  on_conflict?: InputMaybe<Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Attribute_SchemaArgs = {
  objects: Array<Custom_Attribute_Schema_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Attribute_Schema_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Attribute_Schema_OneArgs = {
  object: Custom_Attribute_Schema_Insert_Input;
  on_conflict?: InputMaybe<Custom_Attribute_Schema_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_DatasourceArgs = {
  objects: Array<Custom_Datasource_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Datasource_OneArgs = {
  object: Custom_Datasource_Insert_Input;
  on_conflict?: InputMaybe<Custom_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_RibbonArgs = {
  objects: Array<Custom_Ribbon_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Ribbon_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Ribbon_OneArgs = {
  object: Custom_Ribbon_Insert_Input;
  on_conflict?: InputMaybe<Custom_Ribbon_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Export_ScheduleArgs = {
  objects: Array<Data_Export_Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Data_Export_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Export_Schedule_ExecutionArgs = {
  objects: Array<Data_Export_Schedule_Execution_Insert_Input>;
  on_conflict?: InputMaybe<Data_Export_Schedule_Execution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Export_Schedule_Execution_OneArgs = {
  object: Data_Export_Schedule_Execution_Insert_Input;
  on_conflict?: InputMaybe<Data_Export_Schedule_Execution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Export_Schedule_OneArgs = {
  object: Data_Export_Schedule_Insert_Input;
  on_conflict?: InputMaybe<Data_Export_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_ImportArgs = {
  objects: Array<Data_Import_Insert_Input>;
  on_conflict?: InputMaybe<Data_Import_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Import_ErrorArgs = {
  objects: Array<Data_Import_Error_Insert_Input>;
  on_conflict?: InputMaybe<Data_Import_Error_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Import_Error_OneArgs = {
  object: Data_Import_Error_Insert_Input;
  on_conflict?: InputMaybe<Data_Import_Error_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Import_OneArgs = {
  object: Data_Import_Insert_Input;
  on_conflict?: InputMaybe<Data_Import_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_TypeArgs = {
  objects: Array<Department_Type_Insert_Input>;
  on_conflict?: InputMaybe<Department_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Type_GroupArgs = {
  objects: Array<Department_Type_Group_Insert_Input>;
  on_conflict?: InputMaybe<Department_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Type_Group_OneArgs = {
  object: Department_Type_Group_Insert_Input;
  on_conflict?: InputMaybe<Department_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Type_OneArgs = {
  object: Department_Type_Insert_Input;
  on_conflict?: InputMaybe<Department_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Linked_DocumentArgs = {
  objects: Array<Document_Linked_Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_Linked_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Linked_Document_OneArgs = {
  object: Document_Linked_Document_Insert_Input;
  on_conflict?: InputMaybe<Document_Linked_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_ConfigurationArgs = {
  objects: Array<Form_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Form_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_Configuration_OneArgs = {
  object: Form_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Form_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_Field_ConfigurationArgs = {
  objects: Array<Form_Field_Configuration_Insert_Input>;
  on_conflict?: InputMaybe<Form_Field_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_Field_Configuration_OneArgs = {
  object: Form_Field_Configuration_Insert_Input;
  on_conflict?: InputMaybe<Form_Field_Configuration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_Field_OrderingArgs = {
  objects: Array<Form_Field_Ordering_Insert_Input>;
  on_conflict?: InputMaybe<Form_Field_Ordering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Form_Field_Ordering_OneArgs = {
  object: Form_Field_Ordering_Insert_Input;
  on_conflict?: InputMaybe<Form_Field_Ordering_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indicator_ParentArgs = {
  objects: Array<Indicator_Parent_Insert_Input>;
  on_conflict?: InputMaybe<Indicator_Parent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indicator_Parent_OneArgs = {
  object: Indicator_Parent_Insert_Input;
  on_conflict?: InputMaybe<Indicator_Parent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indicator_ResultArgs = {
  objects: Array<Indicator_Result_Insert_Input>;
  on_conflict?: InputMaybe<Indicator_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indicator_Result_OneArgs = {
  object: Indicator_Result_Insert_Input;
  on_conflict?: InputMaybe<Indicator_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_UpdateArgs = {
  objects: Array<Issue_Update_Insert_Input>;
  on_conflict?: InputMaybe<Issue_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_Update_OneArgs = {
  object: Issue_Update_Insert_Input;
  on_conflict?: InputMaybe<Issue_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Obligation_ImpactArgs = {
  objects: Array<Obligation_Impact_Insert_Input>;
  on_conflict?: InputMaybe<Obligation_Impact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Obligation_Impact_OneArgs = {
  object: Obligation_Impact_Insert_Input;
  on_conflict?: InputMaybe<Obligation_Impact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ModuleArgs = {
  objects: Array<Organisation_Module_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Module_OneArgs = {
  object: Organisation_Module_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Tab_PreferenceArgs = {
  objects: Array<Organisation_Tab_Preference_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Tab_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Tab_Preference_OneArgs = {
  object: Organisation_Tab_Preference_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Tab_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_InviteArgs = {
  objects: Array<Questionnaire_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Invite_OneArgs = {
  object: Questionnaire_Invite_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Template_VersionArgs = {
  objects: Array<Questionnaire_Template_Version_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Template_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Template_Version_OneArgs = {
  object: Questionnaire_Template_Version_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Template_Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relation_FileArgs = {
  objects: Array<Relation_File_Insert_Input>;
  on_conflict?: InputMaybe<Relation_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relation_File_OneArgs = {
  object: Relation_File_Insert_Input;
  on_conflict?: InputMaybe<Relation_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Assessment_Result_ConfigArgs = {
  objects: Array<Risk_Assessment_Result_Config_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Assessment_Result_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Assessment_Result_Config_OneArgs = {
  object: Risk_Assessment_Result_Config_Insert_Input;
  on_conflict?: InputMaybe<Risk_Assessment_Result_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scim_DomainArgs = {
  domain: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Scim_TokenArgs = {
  expireInMonths: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Tag_TypeArgs = {
  objects: Array<Tag_Type_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Type_GroupArgs = {
  objects: Array<Tag_Type_Group_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Type_Group_OneArgs = {
  object: Tag_Type_Group_Insert_Input;
  on_conflict?: InputMaybe<Tag_Type_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Type_OneArgs = {
  object: Tag_Type_Insert_Input;
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TaxonomyArgs = {
  objects: Array<Taxonomy_Insert_Input>;
  on_conflict?: InputMaybe<Taxonomy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Taxonomy_OneArgs = {
  object: Taxonomy_Insert_Input;
  on_conflict?: InputMaybe<Taxonomy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Taxonomy_OrgArgs = {
  objects: Array<Taxonomy_Org_Insert_Input>;
  on_conflict?: InputMaybe<Taxonomy_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Taxonomy_Org_OneArgs = {
  object: Taxonomy_Org_Insert_Input;
  on_conflict?: InputMaybe<Taxonomy_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_ContactArgs = {
  objects: Array<Third_Party_Contact_Insert_Input>;
  on_conflict?: InputMaybe<Third_Party_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Contact_OneArgs = {
  object: Third_Party_Contact_Insert_Input;
  on_conflict?: InputMaybe<Third_Party_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_ResponseArgs = {
  objects: Array<Third_Party_Response_Insert_Input>;
  on_conflict?: InputMaybe<Third_Party_Response_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Response_OneArgs = {
  object: Third_Party_Response_Insert_Input;
  on_conflict?: InputMaybe<Third_Party_Response_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_GroupArgs = {
  objects: Array<User_Group_Insert_Input>;
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_OneArgs = {
  object: User_Group_Insert_Input;
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_UserArgs = {
  objects: Array<User_Group_User_Insert_Input>;
  on_conflict?: InputMaybe<User_Group_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_User_OneArgs = {
  object: User_Group_User_Insert_Input;
  on_conflict?: InputMaybe<User_Group_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Search_PreferencesArgs = {
  objects: Array<User_Search_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<User_Search_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Search_Preferences_OneArgs = {
  object: User_Search_Preferences_Insert_Input;
  on_conflict?: InputMaybe<User_Search_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tab_PreferenceArgs = {
  objects: Array<User_Tab_Preference_Insert_Input>;
  on_conflict?: InputMaybe<User_Tab_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tab_Preference_OneArgs = {
  object: User_Tab_Preference_Insert_Input;
  on_conflict?: InputMaybe<User_Tab_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Table_PreferencesArgs = {
  objects: Array<User_Table_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<User_Table_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Table_Preferences_OneArgs = {
  object: User_Table_Preferences_Insert_Input;
  on_conflict?: InputMaybe<User_Table_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInstantiateChildEnterpriseRiskArgs = {
  object?: InputMaybe<InstantiateEnterpriseRiskInput>;
};


/** mutation root */
export type Mutation_RootLinkItemsArgs = {
  Source?: InputMaybe<Scalars['uuid']['input']>;
  Targets: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootOverrideChangeRequestArgs = {
  Approved: Scalars['Boolean']['input'];
  Id: Scalars['uuid']['input'];
  Rationale: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootPublishQuestionnaireTemplateVersionArgs = {
  QuestionnaireTemplateId: Scalars['uuid']['input'];
  QuestionnaireTemplateVersionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootRefreshScheduleStateArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootRevokeThirdPartyContactAccessArgs = {
  ContactIds: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUnlinkItemsArgs = {
  Ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateApproverResponsesArgs = {
  input: UpdateApproverResponsesInput;
};


/** mutation root */
export type Mutation_RootUpdateAssessmentActivityWithLinkedItemsArgs = {
  ActivityType: Assessment_Activity_Type_Enum;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id: Scalars['uuid']['input'];
  IsWizardAction?: InputMaybe<Scalars['Boolean']['input']>;
  LinkedItemIds: Array<Scalars['uuid']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  ParentId: Scalars['uuid']['input'];
  Status: Assessment_Activity_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateAssessmentApiArgs = {
  object?: InputMaybe<UpdateAssessmentInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildAcceptanceArgs = {
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateAcceptedFrom: Scalars['timestamptz']['input'];
  DateAcceptedTo: Scalars['timestamptz']['input'];
  Details?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  LatestModifiedAtTimestamp: Scalars['timestamptz']['input'];
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateChildActionArgs = {
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DateDue: Scalars['timestamptz']['input'];
  DateRaised: Scalars['timestamptz']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  Status: Action_Status_Enum;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  Title: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateChildControlArgs = {
  object?: InputMaybe<UpdateChildControlInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildDashboardArgs = {
  Content: Scalars['jsonb']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  Sharing: Dashboard_Sharing_Type_Enum_Action;
};


/** mutation root */
export type Mutation_RootUpdateChildDocumentArgs = {
  object?: InputMaybe<UpdateChildDocumentInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildEnterpriseRiskArgs = {
  object?: InputMaybe<UpdateEnterpriseRiskInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildEntityArgs = {
  object?: InputMaybe<UpdateEntityInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildIndicatorArgs = {
  object?: InputMaybe<UpdateChildIndicatorInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildIssueAssessmentArgs = {
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  AssociatedControlIds: Array<Scalars['uuid']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  DepartmentTypeIds: Array<Scalars['uuid']['input']>;
  Id: Scalars['uuid']['input'];
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  OriginalTimestamp: Scalars['timestamptz']['input'];
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PoliciesBreachedIds: Array<Scalars['uuid']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  RegulationsBreachedIds: Array<Scalars['uuid']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateChildObligationArgs = {
  object?: InputMaybe<UpdateChildObligationInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildRiskArgs = {
  object?: InputMaybe<UpdateChildRiskInput>;
};


/** mutation root */
export type Mutation_RootUpdateChildRiskAssessmentResultArgs = {
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Impacts?: InputMaybe<Array<RiskAssessmentResultImpactsInput>>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};


/** mutation root */
export type Mutation_RootUpdateComplianceMonitoringAssessmentApiArgs = {
  object?: InputMaybe<UpdateAssessmentInput>;
};


/** mutation root */
export type Mutation_RootUpdateControlTestInternalAuditResultApiArgs = {
  object?: InputMaybe<UpdateTestResultInput>;
};


/** mutation root */
export type Mutation_RootUpdateControlTestSecondLineResultApiArgs = {
  object?: InputMaybe<UpdateTestResultInput>;
};


/** mutation root */
export type Mutation_RootUpdateDocumentVersionArgs = {
  Content?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  Id: Scalars['uuid']['input'];
  LatestModifiedAtTimestamp: Scalars['timestamptz']['input'];
  Link?: InputMaybe<Scalars['String']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Version_Status_Enum>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Type: Document_File_Type_Enum;
  Version: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateFormFieldArgs = {
  object: UpdateFormFieldInput;
};


/** mutation root */
export type Mutation_RootUpdateImpactApiArgs = {
  object?: InputMaybe<UpdateImpactInput>;
};


/** mutation root */
export type Mutation_RootUpdateInternalAuditArgs = {
  Input?: InputMaybe<UpdateInternalAuditInput>;
};


/** mutation root */
export type Mutation_RootUpdateInternalAuditReportApiArgs = {
  object?: InputMaybe<UpdateAssessmentInput>;
};


/** mutation root */
export type Mutation_RootUpdateIssueApiArgs = {
  object?: InputMaybe<UpdateIssueInput>;
};


/** mutation root */
export type Mutation_RootUpdateNotificationPreferencesArgs = {
  preferenceSet: UpdateNotificationPreferencesInput;
};


/** mutation root */
export type Mutation_RootUpdateQuestionnaireTemplateApiArgs = {
  object?: InputMaybe<UpdateQuestionnaireTemplateInput>;
};


/** mutation root */
export type Mutation_RootUpdateRiskAssessmentResultConfigApiArgs = {
  Config: Scalars['jsonb']['input'];
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootUpdateTestResultApiArgs = {
  object?: InputMaybe<UpdateTestResultInput>;
};


/** mutation root */
export type Mutation_RootUpdateThirdPartyApiArgs = {
  object?: InputMaybe<UpdateThirdPartyInput>;
};


/** mutation root */
export type Mutation_RootUpdateThirdPartyResponseStatusActionArgs = {
  Action: Third_Party_Response_Enum_Action;
  Reason?: InputMaybe<Scalars['String']['input']>;
  RequestType?: InputMaybe<Scalars['String']['input']>;
  ResponseIds: Array<Scalars['uuid']['input']>;
  ShareWithRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  ThirdPartyId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdateWizardByIdArgs = {
  object?: InputMaybe<UpdateWizardInput>;
};


/** mutation root */
export type Mutation_RootUpdate_Action_UpdateArgs = {
  _append?: InputMaybe<Action_Update_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Update_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Update_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Update_Delete_Key_Input>;
  _prepend?: InputMaybe<Action_Update_Prepend_Input>;
  _set?: InputMaybe<Action_Update_Set_Input>;
  where: Action_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Update_By_PkArgs = {
  _append?: InputMaybe<Action_Update_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Update_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Update_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Update_Delete_Key_Input>;
  _prepend?: InputMaybe<Action_Update_Prepend_Input>;
  _set?: InputMaybe<Action_Update_Set_Input>;
  pk_columns: Action_Update_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Update_ManyArgs = {
  updates: Array<Action_Update_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Aggregation_OrgArgs = {
  _append?: InputMaybe<Aggregation_Org_Append_Input>;
  _delete_at_path?: InputMaybe<Aggregation_Org_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Aggregation_Org_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Aggregation_Org_Delete_Key_Input>;
  _prepend?: InputMaybe<Aggregation_Org_Prepend_Input>;
  _set?: InputMaybe<Aggregation_Org_Set_Input>;
  where: Aggregation_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Aggregation_Org_By_PkArgs = {
  _append?: InputMaybe<Aggregation_Org_Append_Input>;
  _delete_at_path?: InputMaybe<Aggregation_Org_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Aggregation_Org_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Aggregation_Org_Delete_Key_Input>;
  _prepend?: InputMaybe<Aggregation_Org_Prepend_Input>;
  _set?: InputMaybe<Aggregation_Org_Set_Input>;
  pk_columns: Aggregation_Org_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Aggregation_Org_ManyArgs = {
  updates: Array<Aggregation_Org_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AppetiteArgs = {
  _append?: InputMaybe<Appetite_Append_Input>;
  _delete_at_path?: InputMaybe<Appetite_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Appetite_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Appetite_Delete_Key_Input>;
  _inc?: InputMaybe<Appetite_Inc_Input>;
  _prepend?: InputMaybe<Appetite_Prepend_Input>;
  _set?: InputMaybe<Appetite_Set_Input>;
  where: Appetite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appetite_By_PkArgs = {
  _append?: InputMaybe<Appetite_Append_Input>;
  _delete_at_path?: InputMaybe<Appetite_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Appetite_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Appetite_Delete_Key_Input>;
  _inc?: InputMaybe<Appetite_Inc_Input>;
  _prepend?: InputMaybe<Appetite_Prepend_Input>;
  _set?: InputMaybe<Appetite_Set_Input>;
  pk_columns: Appetite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appetite_ManyArgs = {
  updates: Array<Appetite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalArgs = {
  _set?: InputMaybe<Approval_Set_Input>;
  where: Approval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_By_PkArgs = {
  _set?: InputMaybe<Approval_Set_Input>;
  pk_columns: Approval_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_LevelArgs = {
  _inc?: InputMaybe<Approval_Level_Inc_Input>;
  _set?: InputMaybe<Approval_Level_Set_Input>;
  where: Approval_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_Level_By_PkArgs = {
  _inc?: InputMaybe<Approval_Level_Inc_Input>;
  _set?: InputMaybe<Approval_Level_Set_Input>;
  pk_columns: Approval_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_Level_ManyArgs = {
  updates: Array<Approval_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Approval_ManyArgs = {
  updates: Array<Approval_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApproverArgs = {
  _set?: InputMaybe<Approver_Set_Input>;
  where: Approver_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Approver_By_PkArgs = {
  _set?: InputMaybe<Approver_Set_Input>;
  pk_columns: Approver_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Approver_ManyArgs = {
  updates: Array<Approver_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_ActivityArgs = {
  _append?: InputMaybe<Assessment_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<Assessment_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assessment_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assessment_Activity_Delete_Key_Input>;
  _prepend?: InputMaybe<Assessment_Activity_Prepend_Input>;
  _set?: InputMaybe<Assessment_Activity_Set_Input>;
  where: Assessment_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Activity_By_PkArgs = {
  _append?: InputMaybe<Assessment_Activity_Append_Input>;
  _delete_at_path?: InputMaybe<Assessment_Activity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assessment_Activity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assessment_Activity_Delete_Key_Input>;
  _prepend?: InputMaybe<Assessment_Activity_Prepend_Input>;
  _set?: InputMaybe<Assessment_Activity_Set_Input>;
  pk_columns: Assessment_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Activity_ManyArgs = {
  updates: Array<Assessment_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_ConfigArgs = {
  _set?: InputMaybe<Attestation_Config_Set_Input>;
  where: Attestation_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Config_By_PkArgs = {
  _set?: InputMaybe<Attestation_Config_Set_Input>;
  pk_columns: Attestation_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Config_ManyArgs = {
  updates: Array<Attestation_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_CycleArgs = {
  _set?: InputMaybe<Attestation_Cycle_Set_Input>;
  where: Attestation_Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Cycle_By_PkArgs = {
  _set?: InputMaybe<Attestation_Cycle_Set_Input>;
  pk_columns: Attestation_Cycle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Cycle_ManyArgs = {
  updates: Array<Attestation_Cycle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_GroupArgs = {
  _set?: InputMaybe<Attestation_Group_Set_Input>;
  where: Attestation_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Group_By_PkArgs = {
  _set?: InputMaybe<Attestation_Group_Set_Input>;
  pk_columns: Attestation_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attestation_Group_ManyArgs = {
  updates: Array<Attestation_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_OrganisationArgs = {
  _set?: InputMaybe<Auth_Organisation_Set_Input>;
  where: Auth_Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Organisation_By_PkArgs = {
  _set?: InputMaybe<Auth_Organisation_Set_Input>;
  pk_columns: Auth_Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Organisation_ManyArgs = {
  updates: Array<Auth_Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_OrganisationuserArgs = {
  _set?: InputMaybe<Auth_Organisationuser_Set_Input>;
  where: Auth_Organisationuser_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Organisationuser_By_PkArgs = {
  _set?: InputMaybe<Auth_Organisationuser_Set_Input>;
  pk_columns: Auth_Organisationuser_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Organisationuser_ManyArgs = {
  updates: Array<Auth_Organisationuser_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_UserArgs = {
  _set?: InputMaybe<Auth_User_Set_Input>;
  where: Auth_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_By_PkArgs = {
  _set?: InputMaybe<Auth_User_Set_Input>;
  pk_columns: Auth_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_ManyArgs = {
  updates: Array<Auth_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_RoleArgs = {
  _set?: InputMaybe<Auth_User_Role_Set_Input>;
  where: Auth_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Role_By_PkArgs = {
  _set?: InputMaybe<Auth_User_Role_Set_Input>;
  pk_columns: Auth_User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_Role_ManyArgs = {
  updates: Array<Auth_User_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_AreaArgs = {
  _set?: InputMaybe<Business_Area_Set_Input>;
  where: Business_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Area_By_PkArgs = {
  _set?: InputMaybe<Business_Area_Set_Input>;
  pk_columns: Business_Area_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Area_ManyArgs = {
  updates: Array<Business_Area_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CauseArgs = {
  _append?: InputMaybe<Cause_Append_Input>;
  _delete_at_path?: InputMaybe<Cause_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cause_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cause_Delete_Key_Input>;
  _inc?: InputMaybe<Cause_Inc_Input>;
  _prepend?: InputMaybe<Cause_Prepend_Input>;
  _set?: InputMaybe<Cause_Set_Input>;
  where: Cause_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cause_By_PkArgs = {
  _append?: InputMaybe<Cause_Append_Input>;
  _delete_at_path?: InputMaybe<Cause_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cause_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cause_Delete_Key_Input>;
  _inc?: InputMaybe<Cause_Inc_Input>;
  _prepend?: InputMaybe<Cause_Prepend_Input>;
  _set?: InputMaybe<Cause_Set_Input>;
  pk_columns: Cause_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cause_ManyArgs = {
  updates: Array<Cause_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Colour_PaletteArgs = {
  _append?: InputMaybe<Colour_Palette_Append_Input>;
  _delete_at_path?: InputMaybe<Colour_Palette_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Colour_Palette_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Colour_Palette_Delete_Key_Input>;
  _prepend?: InputMaybe<Colour_Palette_Prepend_Input>;
  _set?: InputMaybe<Colour_Palette_Set_Input>;
  where: Colour_Palette_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Colour_Palette_By_PkArgs = {
  _append?: InputMaybe<Colour_Palette_Append_Input>;
  _delete_at_path?: InputMaybe<Colour_Palette_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Colour_Palette_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Colour_Palette_Delete_Key_Input>;
  _prepend?: InputMaybe<Colour_Palette_Prepend_Input>;
  _set?: InputMaybe<Colour_Palette_Set_Input>;
  pk_columns: Colour_Palette_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Colour_Palette_ManyArgs = {
  updates: Array<Colour_Palette_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  where: Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_By_PkArgs = {
  _set?: InputMaybe<Comment_Set_Input>;
  pk_columns: Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_ManyArgs = {
  updates: Array<Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConsequenceArgs = {
  _append?: InputMaybe<Consequence_Append_Input>;
  _delete_at_path?: InputMaybe<Consequence_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consequence_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consequence_Delete_Key_Input>;
  _inc?: InputMaybe<Consequence_Inc_Input>;
  _prepend?: InputMaybe<Consequence_Prepend_Input>;
  _set?: InputMaybe<Consequence_Set_Input>;
  where: Consequence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consequence_By_PkArgs = {
  _append?: InputMaybe<Consequence_Append_Input>;
  _delete_at_path?: InputMaybe<Consequence_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consequence_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consequence_Delete_Key_Input>;
  _inc?: InputMaybe<Consequence_Inc_Input>;
  _prepend?: InputMaybe<Consequence_Prepend_Input>;
  _set?: InputMaybe<Consequence_Set_Input>;
  pk_columns: Consequence_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consequence_ManyArgs = {
  updates: Array<Consequence_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Control_GroupArgs = {
  _append?: InputMaybe<Control_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Control_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Control_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Control_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Control_Group_Prepend_Input>;
  _set?: InputMaybe<Control_Group_Set_Input>;
  where: Control_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Control_Group_By_PkArgs = {
  _append?: InputMaybe<Control_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Control_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Control_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Control_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Control_Group_Prepend_Input>;
  _set?: InputMaybe<Control_Group_Set_Input>;
  pk_columns: Control_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Control_Group_ManyArgs = {
  updates: Array<Control_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConversationArgs = {
  _set?: InputMaybe<Conversation_Set_Input>;
  where: Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Conversation_By_PkArgs = {
  _set?: InputMaybe<Conversation_Set_Input>;
  pk_columns: Conversation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Conversation_ManyArgs = {
  updates: Array<Conversation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Attribute_SchemaArgs = {
  _append?: InputMaybe<Custom_Attribute_Schema_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Attribute_Schema_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Attribute_Schema_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Attribute_Schema_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Attribute_Schema_Prepend_Input>;
  _set?: InputMaybe<Custom_Attribute_Schema_Set_Input>;
  where: Custom_Attribute_Schema_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Attribute_Schema_By_PkArgs = {
  _append?: InputMaybe<Custom_Attribute_Schema_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Attribute_Schema_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Attribute_Schema_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Attribute_Schema_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Attribute_Schema_Prepend_Input>;
  _set?: InputMaybe<Custom_Attribute_Schema_Set_Input>;
  pk_columns: Custom_Attribute_Schema_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Attribute_Schema_ManyArgs = {
  updates: Array<Custom_Attribute_Schema_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_DatasourceArgs = {
  _append?: InputMaybe<Custom_Datasource_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Datasource_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Datasource_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Datasource_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Datasource_Prepend_Input>;
  _set?: InputMaybe<Custom_Datasource_Set_Input>;
  where: Custom_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Datasource_By_PkArgs = {
  _append?: InputMaybe<Custom_Datasource_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Datasource_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Datasource_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Datasource_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Datasource_Prepend_Input>;
  _set?: InputMaybe<Custom_Datasource_Set_Input>;
  pk_columns: Custom_Datasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Datasource_ManyArgs = {
  updates: Array<Custom_Datasource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_RibbonArgs = {
  _append?: InputMaybe<Custom_Ribbon_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Ribbon_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Ribbon_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Ribbon_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Ribbon_Prepend_Input>;
  _set?: InputMaybe<Custom_Ribbon_Set_Input>;
  where: Custom_Ribbon_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Ribbon_By_PkArgs = {
  _append?: InputMaybe<Custom_Ribbon_Append_Input>;
  _delete_at_path?: InputMaybe<Custom_Ribbon_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Custom_Ribbon_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Custom_Ribbon_Delete_Key_Input>;
  _prepend?: InputMaybe<Custom_Ribbon_Prepend_Input>;
  _set?: InputMaybe<Custom_Ribbon_Set_Input>;
  pk_columns: Custom_Ribbon_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Ribbon_ManyArgs = {
  updates: Array<Custom_Ribbon_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_ScheduleArgs = {
  _set?: InputMaybe<Data_Export_Schedule_Set_Input>;
  where: Data_Export_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_Schedule_By_PkArgs = {
  _set?: InputMaybe<Data_Export_Schedule_Set_Input>;
  pk_columns: Data_Export_Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_Schedule_ExecutionArgs = {
  _set?: InputMaybe<Data_Export_Schedule_Execution_Set_Input>;
  where: Data_Export_Schedule_Execution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_Schedule_Execution_By_PkArgs = {
  _set?: InputMaybe<Data_Export_Schedule_Execution_Set_Input>;
  pk_columns: Data_Export_Schedule_Execution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_Schedule_Execution_ManyArgs = {
  updates: Array<Data_Export_Schedule_Execution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Export_Schedule_ManyArgs = {
  updates: Array<Data_Export_Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Department_TypeArgs = {
  _set?: InputMaybe<Department_Type_Set_Input>;
  where: Department_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Type_By_PkArgs = {
  _set?: InputMaybe<Department_Type_Set_Input>;
  pk_columns: Department_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Type_GroupArgs = {
  _set?: InputMaybe<Department_Type_Group_Set_Input>;
  where: Department_Type_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Type_Group_ManyArgs = {
  updates: Array<Department_Type_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Type_ManyArgs = {
  updates: Array<Department_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Assessment_ResultArgs = {
  _append?: InputMaybe<Document_Assessment_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Assessment_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Assessment_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Assessment_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Assessment_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Assessment_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Assessment_Result_Set_Input>;
  where: Document_Assessment_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Assessment_Result_By_PkArgs = {
  _append?: InputMaybe<Document_Assessment_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Assessment_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Assessment_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Assessment_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Assessment_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Assessment_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Assessment_Result_Set_Input>;
  pk_columns: Document_Assessment_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Assessment_Result_ManyArgs = {
  updates: Array<Document_Assessment_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Internal_Audit_ResultArgs = {
  _append?: InputMaybe<Document_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Internal_Audit_Result_Set_Input>;
  where: Document_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Internal_Audit_Result_By_PkArgs = {
  _append?: InputMaybe<Document_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Internal_Audit_Result_Set_Input>;
  pk_columns: Document_Internal_Audit_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Internal_Audit_Result_ManyArgs = {
  updates: Array<Document_Internal_Audit_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Second_Line_ResultArgs = {
  _append?: InputMaybe<Document_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Second_Line_Result_Set_Input>;
  where: Document_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Second_Line_Result_By_PkArgs = {
  _append?: InputMaybe<Document_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Document_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Document_Second_Line_Result_Set_Input>;
  pk_columns: Document_Second_Line_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Second_Line_Result_ManyArgs = {
  updates: Array<Document_Second_Line_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Form_ConfigurationArgs = {
  _set?: InputMaybe<Form_Configuration_Set_Input>;
  where: Form_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Form_Configuration_ManyArgs = {
  updates: Array<Form_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Form_Field_ConfigurationArgs = {
  _append?: InputMaybe<Form_Field_Configuration_Append_Input>;
  _delete_at_path?: InputMaybe<Form_Field_Configuration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Form_Field_Configuration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Form_Field_Configuration_Delete_Key_Input>;
  _prepend?: InputMaybe<Form_Field_Configuration_Prepend_Input>;
  _set?: InputMaybe<Form_Field_Configuration_Set_Input>;
  where: Form_Field_Configuration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Form_Field_Configuration_ManyArgs = {
  updates: Array<Form_Field_Configuration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Form_Field_OrderingArgs = {
  _inc?: InputMaybe<Form_Field_Ordering_Inc_Input>;
  _set?: InputMaybe<Form_Field_Ordering_Set_Input>;
  where: Form_Field_Ordering_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Form_Field_Ordering_ManyArgs = {
  updates: Array<Form_Field_Ordering_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Indicator_ResultArgs = {
  _append?: InputMaybe<Indicator_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Indicator_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Indicator_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Indicator_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Indicator_Result_Inc_Input>;
  _prepend?: InputMaybe<Indicator_Result_Prepend_Input>;
  _set?: InputMaybe<Indicator_Result_Set_Input>;
  where: Indicator_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Indicator_Result_By_PkArgs = {
  _append?: InputMaybe<Indicator_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Indicator_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Indicator_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Indicator_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Indicator_Result_Inc_Input>;
  _prepend?: InputMaybe<Indicator_Result_Prepend_Input>;
  _set?: InputMaybe<Indicator_Result_Set_Input>;
  pk_columns: Indicator_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Indicator_Result_ManyArgs = {
  updates: Array<Indicator_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_UpdateArgs = {
  _append?: InputMaybe<Issue_Update_Append_Input>;
  _delete_at_path?: InputMaybe<Issue_Update_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Issue_Update_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Issue_Update_Delete_Key_Input>;
  _prepend?: InputMaybe<Issue_Update_Prepend_Input>;
  _set?: InputMaybe<Issue_Update_Set_Input>;
  where: Issue_Update_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_Update_By_PkArgs = {
  _append?: InputMaybe<Issue_Update_Append_Input>;
  _delete_at_path?: InputMaybe<Issue_Update_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Issue_Update_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Issue_Update_Delete_Key_Input>;
  _prepend?: InputMaybe<Issue_Update_Prepend_Input>;
  _set?: InputMaybe<Issue_Update_Set_Input>;
  pk_columns: Issue_Update_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_Update_ManyArgs = {
  updates: Array<Issue_Update_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Assessment_ResultArgs = {
  _append?: InputMaybe<Obligation_Assessment_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Assessment_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Assessment_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Assessment_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Assessment_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Assessment_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Assessment_Result_Set_Input>;
  where: Obligation_Assessment_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Assessment_Result_By_PkArgs = {
  _append?: InputMaybe<Obligation_Assessment_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Assessment_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Assessment_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Assessment_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Assessment_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Assessment_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Assessment_Result_Set_Input>;
  pk_columns: Obligation_Assessment_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Assessment_Result_ManyArgs = {
  updates: Array<Obligation_Assessment_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_ImpactArgs = {
  _append?: InputMaybe<Obligation_Impact_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Impact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Impact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Impact_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Impact_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Impact_Prepend_Input>;
  _set?: InputMaybe<Obligation_Impact_Set_Input>;
  where: Obligation_Impact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Impact_By_PkArgs = {
  _append?: InputMaybe<Obligation_Impact_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Impact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Impact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Impact_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Impact_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Impact_Prepend_Input>;
  _set?: InputMaybe<Obligation_Impact_Set_Input>;
  pk_columns: Obligation_Impact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Impact_ManyArgs = {
  updates: Array<Obligation_Impact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Internal_Audit_ResultArgs = {
  _append?: InputMaybe<Obligation_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Internal_Audit_Result_Set_Input>;
  where: Obligation_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Internal_Audit_Result_By_PkArgs = {
  _append?: InputMaybe<Obligation_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Internal_Audit_Result_Set_Input>;
  pk_columns: Obligation_Internal_Audit_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Internal_Audit_Result_ManyArgs = {
  updates: Array<Obligation_Internal_Audit_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Second_Line_ResultArgs = {
  _append?: InputMaybe<Obligation_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Second_Line_Result_Set_Input>;
  where: Obligation_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Second_Line_Result_By_PkArgs = {
  _append?: InputMaybe<Obligation_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Obligation_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Obligation_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Obligation_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Obligation_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Obligation_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Obligation_Second_Line_Result_Set_Input>;
  pk_columns: Obligation_Second_Line_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Obligation_Second_Line_Result_ManyArgs = {
  updates: Array<Obligation_Second_Line_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ModuleArgs = {
  _append?: InputMaybe<Organisation_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Module_Delete_Key_Input>;
  _prepend?: InputMaybe<Organisation_Module_Prepend_Input>;
  _set?: InputMaybe<Organisation_Module_Set_Input>;
  where: Organisation_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Module_ManyArgs = {
  updates: Array<Organisation_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Tab_PreferenceArgs = {
  _append?: InputMaybe<Organisation_Tab_Preference_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Tab_Preference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Tab_Preference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Tab_Preference_Delete_Key_Input>;
  _prepend?: InputMaybe<Organisation_Tab_Preference_Prepend_Input>;
  _set?: InputMaybe<Organisation_Tab_Preference_Set_Input>;
  where: Organisation_Tab_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Tab_Preference_ManyArgs = {
  updates: Array<Organisation_Tab_Preference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Template_VersionArgs = {
  _append?: InputMaybe<Questionnaire_Template_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaire_Template_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaire_Template_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaire_Template_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Questionnaire_Template_Version_Prepend_Input>;
  _set?: InputMaybe<Questionnaire_Template_Version_Set_Input>;
  where: Questionnaire_Template_Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Template_Version_By_PkArgs = {
  _append?: InputMaybe<Questionnaire_Template_Version_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaire_Template_Version_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaire_Template_Version_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaire_Template_Version_Delete_Key_Input>;
  _prepend?: InputMaybe<Questionnaire_Template_Version_Prepend_Input>;
  _set?: InputMaybe<Questionnaire_Template_Version_Set_Input>;
  pk_columns: Questionnaire_Template_Version_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Template_Version_ManyArgs = {
  updates: Array<Questionnaire_Template_Version_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Assessment_Result_ConfigArgs = {
  _append?: InputMaybe<Risk_Assessment_Result_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Assessment_Result_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Assessment_Result_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Assessment_Result_Config_Delete_Key_Input>;
  _prepend?: InputMaybe<Risk_Assessment_Result_Config_Prepend_Input>;
  _set?: InputMaybe<Risk_Assessment_Result_Config_Set_Input>;
  where: Risk_Assessment_Result_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Assessment_Result_Config_By_PkArgs = {
  _append?: InputMaybe<Risk_Assessment_Result_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Assessment_Result_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Assessment_Result_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Assessment_Result_Config_Delete_Key_Input>;
  _prepend?: InputMaybe<Risk_Assessment_Result_Config_Prepend_Input>;
  _set?: InputMaybe<Risk_Assessment_Result_Config_Set_Input>;
  pk_columns: Risk_Assessment_Result_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Assessment_Result_Config_ManyArgs = {
  updates: Array<Risk_Assessment_Result_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Internal_Audit_ResultArgs = {
  _append?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Set_Input>;
  where: Risk_Controlled_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Internal_Audit_Result_By_PkArgs = {
  _append?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Set_Input>;
  pk_columns: Risk_Controlled_Internal_Audit_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Internal_Audit_Result_ManyArgs = {
  updates: Array<Risk_Controlled_Internal_Audit_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Second_Line_ResultArgs = {
  _append?: InputMaybe<Risk_Controlled_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Controlled_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Controlled_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Controlled_Second_Line_Result_Set_Input>;
  where: Risk_Controlled_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Second_Line_Result_By_PkArgs = {
  _append?: InputMaybe<Risk_Controlled_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Controlled_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Controlled_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Controlled_Second_Line_Result_Set_Input>;
  pk_columns: Risk_Controlled_Second_Line_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Controlled_Second_Line_Result_ManyArgs = {
  updates: Array<Risk_Controlled_Second_Line_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Internal_Audit_ResultArgs = {
  _append?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Set_Input>;
  where: Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Internal_Audit_Result_By_PkArgs = {
  _append?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Set_Input>;
  pk_columns: Risk_Uncontrolled_Internal_Audit_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Internal_Audit_Result_ManyArgs = {
  updates: Array<Risk_Uncontrolled_Internal_Audit_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Second_Line_ResultArgs = {
  _append?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Set_Input>;
  where: Risk_Uncontrolled_Second_Line_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Second_Line_Result_By_PkArgs = {
  _append?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Inc_Input>;
  _prepend?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Prepend_Input>;
  _set?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Set_Input>;
  pk_columns: Risk_Uncontrolled_Second_Line_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Uncontrolled_Second_Line_Result_ManyArgs = {
  updates: Array<Risk_Uncontrolled_Second_Line_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_TypeArgs = {
  _set?: InputMaybe<Tag_Type_Set_Input>;
  where: Tag_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_By_PkArgs = {
  _set?: InputMaybe<Tag_Type_Set_Input>;
  pk_columns: Tag_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_GroupArgs = {
  _set?: InputMaybe<Tag_Type_Group_Set_Input>;
  where: Tag_Type_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_Group_ManyArgs = {
  updates: Array<Tag_Type_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_ManyArgs = {
  updates: Array<Tag_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TaxonomyArgs = {
  _append?: InputMaybe<Taxonomy_Append_Input>;
  _delete_at_path?: InputMaybe<Taxonomy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Taxonomy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Taxonomy_Delete_Key_Input>;
  _prepend?: InputMaybe<Taxonomy_Prepend_Input>;
  _set?: InputMaybe<Taxonomy_Set_Input>;
  where: Taxonomy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Taxonomy_By_PkArgs = {
  _append?: InputMaybe<Taxonomy_Append_Input>;
  _delete_at_path?: InputMaybe<Taxonomy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Taxonomy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Taxonomy_Delete_Key_Input>;
  _prepend?: InputMaybe<Taxonomy_Prepend_Input>;
  _set?: InputMaybe<Taxonomy_Set_Input>;
  pk_columns: Taxonomy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Taxonomy_ManyArgs = {
  updates: Array<Taxonomy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_ContactArgs = {
  _set?: InputMaybe<Third_Party_Contact_Set_Input>;
  where: Third_Party_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Contact_By_PkArgs = {
  _set?: InputMaybe<Third_Party_Contact_Set_Input>;
  pk_columns: Third_Party_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Contact_ManyArgs = {
  updates: Array<Third_Party_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_ResponseArgs = {
  _append?: InputMaybe<Third_Party_Response_Append_Input>;
  _delete_at_path?: InputMaybe<Third_Party_Response_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Third_Party_Response_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Third_Party_Response_Delete_Key_Input>;
  _prepend?: InputMaybe<Third_Party_Response_Prepend_Input>;
  _set?: InputMaybe<Third_Party_Response_Set_Input>;
  where: Third_Party_Response_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Response_By_PkArgs = {
  _append?: InputMaybe<Third_Party_Response_Append_Input>;
  _delete_at_path?: InputMaybe<Third_Party_Response_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Third_Party_Response_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Third_Party_Response_Delete_Key_Input>;
  _prepend?: InputMaybe<Third_Party_Response_Prepend_Input>;
  _set?: InputMaybe<Third_Party_Response_Set_Input>;
  pk_columns: Third_Party_Response_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Response_ManyArgs = {
  updates: Array<Third_Party_Response_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_GroupArgs = {
  _set?: InputMaybe<User_Group_Set_Input>;
  where: User_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_By_PkArgs = {
  _set?: InputMaybe<User_Group_Set_Input>;
  pk_columns: User_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_ManyArgs = {
  updates: Array<User_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgs = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_User_Search_PreferencesArgs = {
  _set?: InputMaybe<User_Search_Preferences_Set_Input>;
  where: User_Search_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Search_Preferences_ManyArgs = {
  updates: Array<User_Search_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tab_PreferenceArgs = {
  _append?: InputMaybe<User_Tab_Preference_Append_Input>;
  _delete_at_path?: InputMaybe<User_Tab_Preference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Tab_Preference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Tab_Preference_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Tab_Preference_Prepend_Input>;
  _set?: InputMaybe<User_Tab_Preference_Set_Input>;
  where: User_Tab_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tab_Preference_ManyArgs = {
  updates: Array<User_Tab_Preference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Table_PreferencesArgs = {
  _append?: InputMaybe<User_Table_Preferences_Append_Input>;
  _delete_at_path?: InputMaybe<User_Table_Preferences_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Table_Preferences_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Table_Preferences_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Table_Preferences_Prepend_Input>;
  _set?: InputMaybe<User_Table_Preferences_Set_Input>;
  where: User_Table_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Table_Preferences_ManyArgs = {
  updates: Array<User_Table_Preferences_Updates>;
};

/** columns and relationships of "risksmart.node" */
export type Node = {
  __typename?: 'node';
  Id: Scalars['uuid']['output'];
  ObjectType: Parent_Type_Enum;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  action?: Maybe<Action>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  control?: Maybe<Control>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  documentFile?: Maybe<Document_File>;
  /** An object relationship */
  indicator?: Maybe<Indicator>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  issue_assessment?: Maybe<Issue_Assessment>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
};


/** columns and relationships of "risksmart.node" */
export type NodeAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};

/** aggregated selection of "risksmart.node" */
export type Node_Aggregate = {
  __typename?: 'node_aggregate';
  aggregate?: Maybe<Node_Aggregate_Fields>;
  nodes: Array<Node>;
};

/** aggregate fields of "risksmart.node" */
export type Node_Aggregate_Fields = {
  __typename?: 'node_aggregate_fields';
  avg?: Maybe<Node_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Node_Max_Fields>;
  min?: Maybe<Node_Min_Fields>;
  stddev?: Maybe<Node_Stddev_Fields>;
  stddev_pop?: Maybe<Node_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Node_Stddev_Samp_Fields>;
  sum?: Maybe<Node_Sum_Fields>;
  var_pop?: Maybe<Node_Var_Pop_Fields>;
  var_samp?: Maybe<Node_Var_Samp_Fields>;
  variance?: Maybe<Node_Variance_Fields>;
};


/** aggregate fields of "risksmart.node" */
export type Node_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Node_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Node_Avg_Fields = {
  __typename?: 'node_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.node". All fields are combined with a logical 'AND'. */
export type Node_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ObjectType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Node_Bool_Exp>>;
  _not?: InputMaybe<Node_Bool_Exp>;
  _or?: InputMaybe<Array<Node_Bool_Exp>>;
  acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  action?: InputMaybe<Action_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  control?: InputMaybe<Control_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  documentFile?: InputMaybe<Document_File_Bool_Exp>;
  indicator?: InputMaybe<Indicator_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  issue_assessment?: InputMaybe<Issue_Assessment_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
};

/** aggregate max on columns */
export type Node_Max_Fields = {
  __typename?: 'node_max_fields';
  Id?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Node_Min_Fields = {
  __typename?: 'node_min_fields';
  Id?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "risksmart.node". */
export type Node_Order_By = {
  Id?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  acceptance?: InputMaybe<Acceptance_Order_By>;
  action?: InputMaybe<Action_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  control?: InputMaybe<Control_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  documentFile?: InputMaybe<Document_File_Order_By>;
  indicator?: InputMaybe<Indicator_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  issue_assessment?: InputMaybe<Issue_Assessment_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
};

/** select columns of table "risksmart.node" */
export const Node_Select_Column = {
  /** column name */
  Id: 'Id',
  /** column name */
  ObjectType: 'ObjectType',
  /** column name */
  SequentialId: 'SequentialId'
} as const;

export type Node_Select_Column = typeof Node_Select_Column[keyof typeof Node_Select_Column];
/** aggregate stddev on columns */
export type Node_Stddev_Fields = {
  __typename?: 'node_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Node_Stddev_Pop_Fields = {
  __typename?: 'node_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Node_Stddev_Samp_Fields = {
  __typename?: 'node_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "node" */
export type Node_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Node_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Node_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ObjectType?: InputMaybe<Parent_Type_Enum>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Node_Sum_Fields = {
  __typename?: 'node_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Node_Var_Pop_Fields = {
  __typename?: 'node_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Node_Var_Samp_Fields = {
  __typename?: 'node_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Node_Variance_Fields = {
  __typename?: 'node_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "risksmart.obligation" */
export type Obligation = {
  __typename?: 'obligation';
  Adherence: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  ExternalId?: Maybe<Scalars['String']['output']>;
  ExternalProvider?: Maybe<Scalars['String']['output']>;
  ExternalSyncedAt?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OrgKey: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  Type: Obligation_Type_Enum;
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  assessmentResults: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Assessment_Result_Parent_Aggregate;
  /** An array relationship */
  changes: Array<Obligation_Change>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An array relationship */
  controls: Array<Control_Parent>;
  /** An aggregate relationship */
  controls_aggregate: Control_Parent_Aggregate;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  impacts: Array<Obligation_Impact>;
  /** An array relationship */
  issues: Array<Issue_Parent>;
  /** An aggregate relationship */
  issues_aggregate: Issue_Parent_Aggregate;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  obligation_type: Obligation_Type;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  parent?: Maybe<Obligation>;
  /** An object relationship */
  parentNode?: Maybe<Node>;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
  /** An object relationship */
  scheduleState?: Maybe<Schedule_State>;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationChangesArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Order_By>>;
  where?: InputMaybe<Obligation_Change_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationControlsArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationImpactsArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Impact_Order_By>>;
  where?: InputMaybe<Obligation_Impact_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationIssuesArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation" */
export type ObligationTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** aggregated selection of "risksmart.obligation" */
export type Obligation_Aggregate = {
  __typename?: 'obligation_aggregate';
  aggregate?: Maybe<Obligation_Aggregate_Fields>;
  nodes: Array<Obligation>;
};

export type Obligation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Obligation_Aggregate_Bool_Exp_Count>;
};

export type Obligation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Obligation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Obligation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.obligation" */
export type Obligation_Aggregate_Fields = {
  __typename?: 'obligation_aggregate_fields';
  avg?: Maybe<Obligation_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Obligation_Max_Fields>;
  min?: Maybe<Obligation_Min_Fields>;
  stddev?: Maybe<Obligation_Stddev_Fields>;
  stddev_pop?: Maybe<Obligation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Obligation_Stddev_Samp_Fields>;
  sum?: Maybe<Obligation_Sum_Fields>;
  var_pop?: Maybe<Obligation_Var_Pop_Fields>;
  var_samp?: Maybe<Obligation_Var_Samp_Fields>;
  variance?: Maybe<Obligation_Variance_Fields>;
};


/** aggregate fields of "risksmart.obligation" */
export type Obligation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.obligation" */
export type Obligation_Aggregate_Order_By = {
  avg?: InputMaybe<Obligation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Obligation_Max_Order_By>;
  min?: InputMaybe<Obligation_Min_Order_By>;
  stddev?: InputMaybe<Obligation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Obligation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Obligation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Obligation_Sum_Order_By>;
  var_pop?: InputMaybe<Obligation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Obligation_Var_Samp_Order_By>;
  variance?: InputMaybe<Obligation_Variance_Order_By>;
};

/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result = {
  __typename?: 'obligation_assessment_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType: Scalars['String']['output'];
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Assessment_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Aggregate = {
  __typename?: 'obligation_assessment_result_aggregate';
  aggregate?: Maybe<Obligation_Assessment_Result_Aggregate_Fields>;
  nodes: Array<Obligation_Assessment_Result>;
};

/** aggregate fields of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Aggregate_Fields = {
  __typename?: 'obligation_assessment_result_aggregate_fields';
  avg?: Maybe<Obligation_Assessment_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Obligation_Assessment_Result_Max_Fields>;
  min?: Maybe<Obligation_Assessment_Result_Min_Fields>;
  stddev?: Maybe<Obligation_Assessment_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Obligation_Assessment_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Obligation_Assessment_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Obligation_Assessment_Result_Sum_Fields>;
  var_pop?: Maybe<Obligation_Assessment_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Obligation_Assessment_Result_Var_Samp_Fields>;
  variance?: Maybe<Obligation_Assessment_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligation_Assessment_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Assessment_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.obligation_assessment_result_audit" */
export type Obligation_Assessment_Result_Audit = {
  __typename?: 'obligation_assessment_result_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "risksmart.obligation_assessment_result_audit" */
export type Obligation_Assessment_Result_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_assessment_result_audit". All fields are combined with a logical 'AND'. */
export type Obligation_Assessment_Result_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Assessment_Result_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.obligation_assessment_result_audit". */
export type Obligation_Assessment_Result_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.obligation_assessment_result_audit" */
export const Obligation_Assessment_Result_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Assessment_Result_Audit_Select_Column = typeof Obligation_Assessment_Result_Audit_Select_Column[keyof typeof Obligation_Assessment_Result_Audit_Select_Column];
/** Streaming cursor of the table "obligation_assessment_result_audit" */
export type Obligation_Assessment_Result_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Assessment_Result_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Assessment_Result_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate avg on columns */
export type Obligation_Assessment_Result_Avg_Fields = {
  __typename?: 'obligation_assessment_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_assessment_result". All fields are combined with a logical 'AND'. */
export type Obligation_Assessment_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Assessment_Result_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Assessment_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.obligation_assessment_result" */
export const Obligation_Assessment_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ObligationAssessmentResultPkey: 'obligation_assessment_result_pkey'
} as const;

export type Obligation_Assessment_Result_Constraint = typeof Obligation_Assessment_Result_Constraint[keyof typeof Obligation_Assessment_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Obligation_Assessment_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Obligation_Assessment_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Obligation_Assessment_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Obligation_Assessment_Result_Max_Fields = {
  __typename?: 'obligation_assessment_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Obligation_Assessment_Result_Min_Fields = {
  __typename?: 'obligation_assessment_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Mutation_Response = {
  __typename?: 'obligation_assessment_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligation_Assessment_Result>;
};

/** input type for inserting object relation for remote table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Obj_Rel_Insert_Input = {
  data: Obligation_Assessment_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligation_Assessment_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_On_Conflict = {
  constraint: Obligation_Assessment_Result_Constraint;
  update_columns?: Array<Obligation_Assessment_Result_Update_Column>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.obligation_assessment_result". */
export type Obligation_Assessment_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.obligation_assessment_result */
export type Obligation_Assessment_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Assessment_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.obligation_assessment_result" */
export const Obligation_Assessment_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Assessment_Result_Select_Column = typeof Obligation_Assessment_Result_Select_Column[keyof typeof Obligation_Assessment_Result_Select_Column];
/** input type for updating data in table "risksmart.obligation_assessment_result" */
export type Obligation_Assessment_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Obligation_Assessment_Result_Stddev_Fields = {
  __typename?: 'obligation_assessment_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Obligation_Assessment_Result_Stddev_Pop_Fields = {
  __typename?: 'obligation_assessment_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Obligation_Assessment_Result_Stddev_Samp_Fields = {
  __typename?: 'obligation_assessment_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "obligation_assessment_result" */
export type Obligation_Assessment_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Assessment_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Assessment_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Obligation_Assessment_Result_Sum_Fields = {
  __typename?: 'obligation_assessment_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.obligation_assessment_result" */
export const Obligation_Assessment_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Assessment_Result_Update_Column = typeof Obligation_Assessment_Result_Update_Column[keyof typeof Obligation_Assessment_Result_Update_Column];
export type Obligation_Assessment_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Obligation_Assessment_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Obligation_Assessment_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Obligation_Assessment_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Obligation_Assessment_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Obligation_Assessment_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Obligation_Assessment_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Obligation_Assessment_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Obligation_Assessment_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Obligation_Assessment_Result_Var_Pop_Fields = {
  __typename?: 'obligation_assessment_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Obligation_Assessment_Result_Var_Samp_Fields = {
  __typename?: 'obligation_assessment_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Obligation_Assessment_Result_Variance_Fields = {
  __typename?: 'obligation_assessment_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.obligation_assessment_status" */
export type Obligation_Assessment_Status = {
  __typename?: 'obligation_assessment_status';
  Comment?: Maybe<Scalars['String']['output']>;
  Value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.obligation_assessment_status". All fields are combined with a logical 'AND'. */
export type Obligation_Assessment_Status_Bool_Exp = {
  Comment?: InputMaybe<String_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Assessment_Status_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Assessment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Assessment_Status_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.obligation_assessment_status". */
export type Obligation_Assessment_Status_Order_By = {
  Comment?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.obligation_assessment_status" */
export const Obligation_Assessment_Status_Select_Column = {
  /** column name */
  Comment: 'Comment',
  /** column name */
  Value: 'Value'
} as const;

export type Obligation_Assessment_Status_Select_Column = typeof Obligation_Assessment_Status_Select_Column[keyof typeof Obligation_Assessment_Status_Select_Column];
/** Streaming cursor of the table "obligation_assessment_status" */
export type Obligation_Assessment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Assessment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Assessment_Status_Stream_Cursor_Value_Input = {
  Comment?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.obligation_audit" */
export type Obligation_Audit = {
  __typename?: 'obligation_audit';
  Adherence?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey: Scalars['String']['output'];
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.obligation_audit" */
export type Obligation_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "risksmart.obligation_audit" */
export type Obligation_Audit_Aggregate = {
  __typename?: 'obligation_audit_aggregate';
  aggregate?: Maybe<Obligation_Audit_Aggregate_Fields>;
  nodes: Array<Obligation_Audit>;
};

/** aggregate fields of "risksmart.obligation_audit" */
export type Obligation_Audit_Aggregate_Fields = {
  __typename?: 'obligation_audit_aggregate_fields';
  avg?: Maybe<Obligation_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Obligation_Audit_Max_Fields>;
  min?: Maybe<Obligation_Audit_Min_Fields>;
  stddev?: Maybe<Obligation_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Obligation_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Obligation_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Obligation_Audit_Sum_Fields>;
  var_pop?: Maybe<Obligation_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Obligation_Audit_Var_Samp_Fields>;
  variance?: Maybe<Obligation_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.obligation_audit" */
export type Obligation_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligation_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Obligation_Audit_Avg_Fields = {
  __typename?: 'obligation_audit_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_audit". All fields are combined with a logical 'AND'. */
export type Obligation_Audit_Bool_Exp = {
  Adherence?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Interpretation?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Audit_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Audit_Bool_Exp>>;
};

/** aggregate max on columns */
export type Obligation_Audit_Max_Fields = {
  __typename?: 'obligation_audit_max_fields';
  Adherence?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Obligation_Audit_Min_Fields = {
  __typename?: 'obligation_audit_min_fields';
  Adherence?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.obligation_audit". */
export type Obligation_Audit_Order_By = {
  Adherence?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Interpretation?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.obligation_audit" */
export const Obligation_Audit_Select_Column = {
  /** column name */
  Adherence: 'Adherence',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  Interpretation: 'Interpretation',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Obligation_Audit_Select_Column = typeof Obligation_Audit_Select_Column[keyof typeof Obligation_Audit_Select_Column];
/** aggregate stddev on columns */
export type Obligation_Audit_Stddev_Fields = {
  __typename?: 'obligation_audit_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Obligation_Audit_Stddev_Pop_Fields = {
  __typename?: 'obligation_audit_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Obligation_Audit_Stddev_Samp_Fields = {
  __typename?: 'obligation_audit_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "obligation_audit" */
export type Obligation_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Audit_Stream_Cursor_Value_Input = {
  Adherence?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Interpretation?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Obligation_Audit_Sum_Fields = {
  __typename?: 'obligation_audit_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Obligation_Audit_Var_Pop_Fields = {
  __typename?: 'obligation_audit_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Obligation_Audit_Var_Samp_Fields = {
  __typename?: 'obligation_audit_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Obligation_Audit_Variance_Fields = {
  __typename?: 'obligation_audit_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Obligation_Avg_Fields = {
  __typename?: 'obligation_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.obligation" */
export type Obligation_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation". All fields are combined with a logical 'AND'. */
export type Obligation_Bool_Exp = {
  Adherence?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  ExternalId?: InputMaybe<String_Comparison_Exp>;
  ExternalProvider?: InputMaybe<String_Comparison_Exp>;
  ExternalSyncedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Interpretation?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Obligation_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  changes?: InputMaybe<Obligation_Change_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  controls?: InputMaybe<Control_Parent_Bool_Exp>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Bool_Exp>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  impacts?: InputMaybe<Obligation_Impact_Bool_Exp>;
  issues?: InputMaybe<Issue_Parent_Bool_Exp>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  obligation_type?: InputMaybe<Obligation_Type_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Obligation_Bool_Exp>;
  parentNode?: InputMaybe<Node_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
  scheduleState?: InputMaybe<Schedule_State_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_Change = {
  __typename?: 'obligation_change';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  EffectiveDate?: Maybe<Scalars['timestamptz']['output']>;
  ExternalId: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ObligationId?: Maybe<Scalars['uuid']['output']>;
  OrgKey: Scalars['String']['output'];
  Reference?: Maybe<Scalars['String']['output']>;
  Regulator?: Maybe<Scalars['String']['output']>;
  SequentialId: Scalars['Int']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  attestations: Array<Obligation_Change_Attestation>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeAttestationsArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Attestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Attestation_Order_By>>;
  where?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_change" */
export type Obligation_ChangeOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.obligation_change" */
export type Obligation_Change_Aggregate_Order_By = {
  avg?: InputMaybe<Obligation_Change_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Obligation_Change_Max_Order_By>;
  min?: InputMaybe<Obligation_Change_Min_Order_By>;
  stddev?: InputMaybe<Obligation_Change_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Obligation_Change_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Obligation_Change_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Obligation_Change_Sum_Order_By>;
  var_pop?: InputMaybe<Obligation_Change_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Obligation_Change_Var_Samp_Order_By>;
  variance?: InputMaybe<Obligation_Change_Variance_Order_By>;
};

/** columns and relationships of "risksmart.obligation_change_attestation" */
export type Obligation_Change_Attestation = {
  __typename?: 'obligation_change_attestation';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ObligationChangeId?: Maybe<Scalars['uuid']['output']>;
  OrgKey: Scalars['String']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  obligation_change?: Maybe<Obligation_Change>;
  /** An object relationship */
  org?: Maybe<Auth_Organisation>;
};

/** order by aggregate values of table "risksmart.obligation_change_attestation" */
export type Obligation_Change_Attestation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Obligation_Change_Attestation_Max_Order_By>;
  min?: InputMaybe<Obligation_Change_Attestation_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_change_attestation". All fields are combined with a logical 'AND'. */
export type Obligation_Change_Attestation_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ObligationChangeId?: InputMaybe<Uuid_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Change_Attestation_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Change_Attestation_Bool_Exp>>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  obligation_change?: InputMaybe<Obligation_Change_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** order by max() on columns of table "risksmart.obligation_change_attestation" */
export type Obligation_Change_Attestation_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationChangeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.obligation_change_attestation" */
export type Obligation_Change_Attestation_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationChangeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.obligation_change_attestation". */
export type Obligation_Change_Attestation_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationChangeId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  obligation_change?: InputMaybe<Obligation_Change_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
};

/** select columns of table "risksmart.obligation_change_attestation" */
export const Obligation_Change_Attestation_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ObligationChangeId: 'ObligationChangeId',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  UserId: 'UserId'
} as const;

export type Obligation_Change_Attestation_Select_Column = typeof Obligation_Change_Attestation_Select_Column[keyof typeof Obligation_Change_Attestation_Select_Column];
/** Streaming cursor of the table "obligation_change_attestation" */
export type Obligation_Change_Attestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Change_Attestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Change_Attestation_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ObligationChangeId?: InputMaybe<Scalars['uuid']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** order by avg() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_change". All fields are combined with a logical 'AND'. */
export type Obligation_Change_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  EffectiveDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ExternalId?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ObligationId?: InputMaybe<Uuid_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<String_Comparison_Exp>;
  Regulator?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Change_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Change_Bool_Exp>>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  attestations?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  org?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
};

/** order by max() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Regulator?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Regulator?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.obligation_change". */
export type Obligation_Change_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  EffectiveDate?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ObligationId?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Regulator?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  attestations_aggregate?: InputMaybe<Obligation_Change_Attestation_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
};

/** select columns of table "risksmart.obligation_change" */
export const Obligation_Change_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  EffectiveDate: 'EffectiveDate',
  /** column name */
  ExternalId: 'ExternalId',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ObligationId: 'ObligationId',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  Reference: 'Reference',
  /** column name */
  Regulator: 'Regulator',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title'
} as const;

export type Obligation_Change_Select_Column = typeof Obligation_Change_Select_Column[keyof typeof Obligation_Change_Select_Column];
/** order by stddev() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "obligation_change" */
export type Obligation_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Change_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ObligationId?: InputMaybe<Scalars['uuid']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  Reference?: InputMaybe<Scalars['String']['input']>;
  Regulator?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.obligation_change" */
export type Obligation_Change_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "risksmart.obligation" */
export const Obligation_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxObligationOrgkeySequentialid: 'idx_obligation_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  ObligationPkey: 'obligation_pkey',
  /** unique or primary key constraint on columns "ExternalProvider", "ExternalId", "OrgKey" */
  UqObligationExternal: 'uq_obligation_external'
} as const;

export type Obligation_Constraint = typeof Obligation_Constraint[keyof typeof Obligation_Constraint];
/** columns and relationships of "risksmart.obligation_impact" */
export type Obligation_Impact = {
  __typename?: 'obligation_impact';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ImpactRating: Scalars['smallint']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentObligationId: Scalars['uuid']['output'];
  /** An object relationship */
  createdBy?: Maybe<User>;
  /** An object relationship */
  modifiedBy?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Obligation>;
};


/** columns and relationships of "risksmart.obligation_impact" */
export type Obligation_ImpactCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "risksmart.obligation_impact" */
export type Obligation_Impact_Aggregate_Order_By = {
  avg?: InputMaybe<Obligation_Impact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Obligation_Impact_Max_Order_By>;
  min?: InputMaybe<Obligation_Impact_Min_Order_By>;
  stddev?: InputMaybe<Obligation_Impact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Obligation_Impact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Obligation_Impact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Obligation_Impact_Sum_Order_By>;
  var_pop?: InputMaybe<Obligation_Impact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Obligation_Impact_Var_Samp_Order_By>;
  variance?: InputMaybe<Obligation_Impact_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Impact_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.obligation_impact" */
export type Obligation_Impact_Arr_Rel_Insert_Input = {
  data: Array<Obligation_Impact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligation_Impact_On_Conflict>;
};

/** columns and relationships of "risksmart.obligation_impact_audit" */
export type Obligation_Impact_Audit = {
  __typename?: 'obligation_impact_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ImpactRating: Scalars['smallint']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentObligationId: Scalars['uuid']['output'];
};


/** columns and relationships of "risksmart.obligation_impact_audit" */
export type Obligation_Impact_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_impact_audit". All fields are combined with a logical 'AND'. */
export type Obligation_Impact_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactRating?: InputMaybe<Smallint_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentObligationId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Impact_Audit_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Impact_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Impact_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.obligation_impact_audit". */
export type Obligation_Impact_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactRating?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentObligationId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.obligation_impact_audit" */
export const Obligation_Impact_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactRating: 'ImpactRating',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentObligationId: 'ParentObligationId'
} as const;

export type Obligation_Impact_Audit_Select_Column = typeof Obligation_Impact_Audit_Select_Column[keyof typeof Obligation_Impact_Audit_Select_Column];
/** Streaming cursor of the table "obligation_impact_audit" */
export type Obligation_Impact_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Impact_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Impact_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactRating?: InputMaybe<Scalars['smallint']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentObligationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by avg() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Avg_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_impact". All fields are combined with a logical 'AND'. */
export type Obligation_Impact_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ImpactRating?: InputMaybe<Smallint_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentObligationId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Impact_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Impact_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Impact_Bool_Exp>>;
  createdBy?: InputMaybe<User_Bool_Exp>;
  modifiedBy?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Obligation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.obligation_impact" */
export const Obligation_Impact_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ObligationImpactPkey: 'obligation_impact_pkey'
} as const;

export type Obligation_Impact_Constraint = typeof Obligation_Impact_Constraint[keyof typeof Obligation_Impact_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Obligation_Impact_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Obligation_Impact_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Obligation_Impact_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.obligation_impact" */
export type Obligation_Impact_Inc_Input = {
  ImpactRating?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "risksmart.obligation_impact" */
export type Obligation_Impact_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ImpactRating?: InputMaybe<Scalars['smallint']['input']>;
  ParentObligationId?: InputMaybe<Scalars['uuid']['input']>;
  parent?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactRating?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentObligationId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactRating?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentObligationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.obligation_impact" */
export type Obligation_Impact_Mutation_Response = {
  __typename?: 'obligation_impact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligation_Impact>;
};

/** input type for inserting object relation for remote table "risksmart.obligation_impact" */
export type Obligation_Impact_Obj_Rel_Insert_Input = {
  data: Obligation_Impact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligation_Impact_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.obligation_impact" */
export type Obligation_Impact_On_Conflict = {
  constraint: Obligation_Impact_Constraint;
  update_columns?: Array<Obligation_Impact_Update_Column>;
  where?: InputMaybe<Obligation_Impact_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.obligation_impact". */
export type Obligation_Impact_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ImpactRating?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentObligationId?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Obligation_Order_By>;
};

/** primary key columns input for table: risksmart.obligation_impact */
export type Obligation_Impact_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Impact_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.obligation_impact" */
export const Obligation_Impact_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactRating: 'ImpactRating',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentObligationId: 'ParentObligationId'
} as const;

export type Obligation_Impact_Select_Column = typeof Obligation_Impact_Select_Column[keyof typeof Obligation_Impact_Select_Column];
/** input type for updating data in table "risksmart.obligation_impact" */
export type Obligation_Impact_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactRating?: InputMaybe<Scalars['smallint']['input']>;
  ParentObligationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Stddev_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Stddev_Pop_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Stddev_Samp_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "obligation_impact" */
export type Obligation_Impact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Impact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Impact_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ImpactRating?: InputMaybe<Scalars['smallint']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentObligationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Sum_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.obligation_impact" */
export const Obligation_Impact_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ImpactRating: 'ImpactRating',
  /** column name */
  ParentObligationId: 'ParentObligationId'
} as const;

export type Obligation_Impact_Update_Column = typeof Obligation_Impact_Update_Column[keyof typeof Obligation_Impact_Update_Column];
export type Obligation_Impact_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Obligation_Impact_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Obligation_Impact_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Obligation_Impact_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Obligation_Impact_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Obligation_Impact_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Obligation_Impact_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Obligation_Impact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Obligation_Impact_Bool_Exp;
};

/** order by var_pop() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Var_Pop_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Var_Samp_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.obligation_impact" */
export type Obligation_Impact_Variance_Order_By = {
  ImpactRating?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "risksmart.obligation" */
export type Obligation_Insert_Input = {
  Adherence?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Interpretation?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Obligation_Type_Enum>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  controls?: InputMaybe<Control_Parent_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  impacts?: InputMaybe<Obligation_Impact_Arr_Rel_Insert_Input>;
  issues?: InputMaybe<Issue_Parent_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Obligation_Obj_Rel_Insert_Input>;
  schedule?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result = {
  __typename?: 'obligation_internal_audit_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Aggregate = {
  __typename?: 'obligation_internal_audit_result_aggregate';
  aggregate?: Maybe<Obligation_Internal_Audit_Result_Aggregate_Fields>;
  nodes: Array<Obligation_Internal_Audit_Result>;
};

/** aggregate fields of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Aggregate_Fields = {
  __typename?: 'obligation_internal_audit_result_aggregate_fields';
  avg?: Maybe<Obligation_Internal_Audit_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Obligation_Internal_Audit_Result_Max_Fields>;
  min?: Maybe<Obligation_Internal_Audit_Result_Min_Fields>;
  stddev?: Maybe<Obligation_Internal_Audit_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Obligation_Internal_Audit_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Obligation_Internal_Audit_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Obligation_Internal_Audit_Result_Sum_Fields>;
  var_pop?: Maybe<Obligation_Internal_Audit_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Obligation_Internal_Audit_Result_Var_Samp_Fields>;
  variance?: Maybe<Obligation_Internal_Audit_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligation_Internal_Audit_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Internal_Audit_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Obligation_Internal_Audit_Result_Avg_Fields = {
  __typename?: 'obligation_internal_audit_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_internal_audit_result". All fields are combined with a logical 'AND'. */
export type Obligation_Internal_Audit_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Internal_Audit_Result_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Internal_Audit_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.obligation_internal_audit_result" */
export const Obligation_Internal_Audit_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ObligationInternalAuditResultPkey: 'obligation_internal_audit_result_pkey'
} as const;

export type Obligation_Internal_Audit_Result_Constraint = typeof Obligation_Internal_Audit_Result_Constraint[keyof typeof Obligation_Internal_Audit_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Obligation_Internal_Audit_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Obligation_Internal_Audit_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Obligation_Internal_Audit_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Obligation_Internal_Audit_Result_Max_Fields = {
  __typename?: 'obligation_internal_audit_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Obligation_Internal_Audit_Result_Min_Fields = {
  __typename?: 'obligation_internal_audit_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Mutation_Response = {
  __typename?: 'obligation_internal_audit_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligation_Internal_Audit_Result>;
};

/** input type for inserting object relation for remote table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Obj_Rel_Insert_Input = {
  data: Obligation_Internal_Audit_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligation_Internal_Audit_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_On_Conflict = {
  constraint: Obligation_Internal_Audit_Result_Constraint;
  update_columns?: Array<Obligation_Internal_Audit_Result_Update_Column>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.obligation_internal_audit_result". */
export type Obligation_Internal_Audit_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.obligation_internal_audit_result */
export type Obligation_Internal_Audit_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Internal_Audit_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.obligation_internal_audit_result" */
export const Obligation_Internal_Audit_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Internal_Audit_Result_Select_Column = typeof Obligation_Internal_Audit_Result_Select_Column[keyof typeof Obligation_Internal_Audit_Result_Select_Column];
/** input type for updating data in table "risksmart.obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Obligation_Internal_Audit_Result_Stddev_Fields = {
  __typename?: 'obligation_internal_audit_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Obligation_Internal_Audit_Result_Stddev_Pop_Fields = {
  __typename?: 'obligation_internal_audit_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Obligation_Internal_Audit_Result_Stddev_Samp_Fields = {
  __typename?: 'obligation_internal_audit_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "obligation_internal_audit_result" */
export type Obligation_Internal_Audit_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Internal_Audit_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Internal_Audit_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Obligation_Internal_Audit_Result_Sum_Fields = {
  __typename?: 'obligation_internal_audit_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.obligation_internal_audit_result" */
export const Obligation_Internal_Audit_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Internal_Audit_Result_Update_Column = typeof Obligation_Internal_Audit_Result_Update_Column[keyof typeof Obligation_Internal_Audit_Result_Update_Column];
export type Obligation_Internal_Audit_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Obligation_Internal_Audit_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Obligation_Internal_Audit_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Obligation_Internal_Audit_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Obligation_Internal_Audit_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Obligation_Internal_Audit_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Obligation_Internal_Audit_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Obligation_Internal_Audit_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Obligation_Internal_Audit_Result_Var_Pop_Fields = {
  __typename?: 'obligation_internal_audit_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Obligation_Internal_Audit_Result_Var_Samp_Fields = {
  __typename?: 'obligation_internal_audit_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Obligation_Internal_Audit_Result_Variance_Fields = {
  __typename?: 'obligation_internal_audit_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Obligation_Max_Fields = {
  __typename?: 'obligation_max_fields';
  Adherence?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExternalId?: Maybe<Scalars['String']['output']>;
  ExternalProvider?: Maybe<Scalars['String']['output']>;
  ExternalSyncedAt?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.obligation" */
export type Obligation_Max_Order_By = {
  Adherence?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  ExternalProvider?: InputMaybe<Order_By>;
  ExternalSyncedAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Interpretation?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Obligation_Min_Fields = {
  __typename?: 'obligation_min_fields';
  Adherence?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExternalId?: Maybe<Scalars['String']['output']>;
  ExternalProvider?: Maybe<Scalars['String']['output']>;
  ExternalSyncedAt?: Maybe<Scalars['timestamptz']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Interpretation?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.obligation" */
export type Obligation_Min_Order_By = {
  Adherence?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  ExternalProvider?: InputMaybe<Order_By>;
  ExternalSyncedAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Interpretation?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.obligation" */
export type Obligation_Mutation_Response = {
  __typename?: 'obligation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligation>;
};

/** input type for inserting object relation for remote table "risksmart.obligation" */
export type Obligation_Obj_Rel_Insert_Input = {
  data: Obligation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Obligation_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.obligation" */
export type Obligation_On_Conflict = {
  constraint: Obligation_Constraint;
  update_columns?: Array<Obligation_Update_Column>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.obligation". */
export type Obligation_Order_By = {
  Adherence?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ExternalId?: InputMaybe<Order_By>;
  ExternalProvider?: InputMaybe<Order_By>;
  ExternalSyncedAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Interpretation?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  changes_aggregate?: InputMaybe<Obligation_Change_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Order_By>;
  createdBy?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  impacts_aggregate?: InputMaybe<Obligation_Impact_Aggregate_Order_By>;
  issues_aggregate?: InputMaybe<Issue_Parent_Aggregate_Order_By>;
  modifiedBy?: InputMaybe<User_Order_By>;
  obligation_type?: InputMaybe<Obligation_Type_Order_By>;
  org?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parent?: InputMaybe<Obligation_Order_By>;
  parentNode?: InputMaybe<Node_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
  scheduleState?: InputMaybe<Schedule_State_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result = {
  __typename?: 'obligation_second_line_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Aggregate = {
  __typename?: 'obligation_second_line_result_aggregate';
  aggregate?: Maybe<Obligation_Second_Line_Result_Aggregate_Fields>;
  nodes: Array<Obligation_Second_Line_Result>;
};

/** aggregate fields of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Aggregate_Fields = {
  __typename?: 'obligation_second_line_result_aggregate_fields';
  avg?: Maybe<Obligation_Second_Line_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Obligation_Second_Line_Result_Max_Fields>;
  min?: Maybe<Obligation_Second_Line_Result_Min_Fields>;
  stddev?: Maybe<Obligation_Second_Line_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Obligation_Second_Line_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Obligation_Second_Line_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Obligation_Second_Line_Result_Sum_Fields>;
  var_pop?: Maybe<Obligation_Second_Line_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Obligation_Second_Line_Result_Var_Samp_Fields>;
  variance?: Maybe<Obligation_Second_Line_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Obligation_Second_Line_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Second_Line_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Obligation_Second_Line_Result_Avg_Fields = {
  __typename?: 'obligation_second_line_result_avg_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_second_line_result". All fields are combined with a logical 'AND'. */
export type Obligation_Second_Line_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Second_Line_Result_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Second_Line_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Obligation_Second_Line_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Obligation_Second_Line_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Obligation_Second_Line_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Inc_Input = {
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Obligation_Second_Line_Result_Max_Fields = {
  __typename?: 'obligation_second_line_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Obligation_Second_Line_Result_Min_Fields = {
  __typename?: 'obligation_second_line_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Mutation_Response = {
  __typename?: 'obligation_second_line_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Obligation_Second_Line_Result>;
};

/** Ordering options when selecting data from "risksmart.obligation_second_line_result". */
export type Obligation_Second_Line_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.obligation_second_line_result */
export type Obligation_Second_Line_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Obligation_Second_Line_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.obligation_second_line_result" */
export const Obligation_Second_Line_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Obligation_Second_Line_Result_Select_Column = typeof Obligation_Second_Line_Result_Select_Column[keyof typeof Obligation_Second_Line_Result_Select_Column];
/** input type for updating data in table "risksmart.obligation_second_line_result" */
export type Obligation_Second_Line_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Obligation_Second_Line_Result_Stddev_Fields = {
  __typename?: 'obligation_second_line_result_stddev_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Obligation_Second_Line_Result_Stddev_Pop_Fields = {
  __typename?: 'obligation_second_line_result_stddev_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Obligation_Second_Line_Result_Stddev_Samp_Fields = {
  __typename?: 'obligation_second_line_result_stddev_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "obligation_second_line_result" */
export type Obligation_Second_Line_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Second_Line_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Second_Line_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Obligation_Second_Line_Result_Sum_Fields = {
  __typename?: 'obligation_second_line_result_sum_fields';
  Rating?: Maybe<Scalars['Int']['output']>;
};

export type Obligation_Second_Line_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Obligation_Second_Line_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Obligation_Second_Line_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Obligation_Second_Line_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Obligation_Second_Line_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Obligation_Second_Line_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Obligation_Second_Line_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Obligation_Second_Line_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Obligation_Second_Line_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Obligation_Second_Line_Result_Var_Pop_Fields = {
  __typename?: 'obligation_second_line_result_var_pop_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Obligation_Second_Line_Result_Var_Samp_Fields = {
  __typename?: 'obligation_second_line_result_var_samp_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Obligation_Second_Line_Result_Variance_Fields = {
  __typename?: 'obligation_second_line_result_variance_fields';
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "risksmart.obligation" */
export const Obligation_Select_Column = {
  /** column name */
  Adherence: 'Adherence',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ExternalId: 'ExternalId',
  /** column name */
  ExternalProvider: 'ExternalProvider',
  /** column name */
  ExternalSyncedAt: 'ExternalSyncedAt',
  /** column name */
  Id: 'Id',
  /** column name */
  Interpretation: 'Interpretation',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Obligation_Select_Column = typeof Obligation_Select_Column[keyof typeof Obligation_Select_Column];
/** aggregate stddev on columns */
export type Obligation_Stddev_Fields = {
  __typename?: 'obligation_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.obligation" */
export type Obligation_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Obligation_Stddev_Pop_Fields = {
  __typename?: 'obligation_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.obligation" */
export type Obligation_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Obligation_Stddev_Samp_Fields = {
  __typename?: 'obligation_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.obligation" */
export type Obligation_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "obligation" */
export type Obligation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Stream_Cursor_Value_Input = {
  Adherence?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ExternalId?: InputMaybe<Scalars['String']['input']>;
  ExternalProvider?: InputMaybe<Scalars['String']['input']>;
  ExternalSyncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Interpretation?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Obligation_Type_Enum>;
};

/** aggregate sum on columns */
export type Obligation_Sum_Fields = {
  __typename?: 'obligation_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.obligation" */
export type Obligation_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.obligation_type" */
export type Obligation_Type = {
  __typename?: 'obligation_type';
  Comment?: Maybe<Scalars['String']['output']>;
  Value: Scalars['String']['output'];
  /** An array relationship */
  obligations: Array<Obligation>;
  /** An aggregate relationship */
  obligations_aggregate: Obligation_Aggregate;
};


/** columns and relationships of "risksmart.obligation_type" */
export type Obligation_TypeObligationsArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


/** columns and relationships of "risksmart.obligation_type" */
export type Obligation_TypeObligations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.obligation_type". All fields are combined with a logical 'AND'. */
export type Obligation_Type_Bool_Exp = {
  Comment?: InputMaybe<String_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Obligation_Type_Bool_Exp>>;
  _not?: InputMaybe<Obligation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Obligation_Type_Bool_Exp>>;
  obligations?: InputMaybe<Obligation_Bool_Exp>;
  obligations_aggregate?: InputMaybe<Obligation_Aggregate_Bool_Exp>;
};

export const Obligation_Type_Enum = {
  /** Chapter */
  Chapter: 'chapter',
  /** Rule */
  Rule: 'rule',
  /** High-level Standard */
  Standard: 'standard'
} as const;

export type Obligation_Type_Enum = typeof Obligation_Type_Enum[keyof typeof Obligation_Type_Enum];
/** Boolean expression to compare columns of type "obligation_type_enum". All fields are combined with logical 'AND'. */
export type Obligation_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Obligation_Type_Enum>;
  _in?: InputMaybe<Array<Obligation_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Obligation_Type_Enum>;
  _nin?: InputMaybe<Array<Obligation_Type_Enum>>;
};

/** Ordering options when selecting data from "risksmart.obligation_type". */
export type Obligation_Type_Order_By = {
  Comment?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
  obligations_aggregate?: InputMaybe<Obligation_Aggregate_Order_By>;
};

/** select columns of table "risksmart.obligation_type" */
export const Obligation_Type_Select_Column = {
  /** column name */
  Comment: 'Comment',
  /** column name */
  Value: 'Value'
} as const;

export type Obligation_Type_Select_Column = typeof Obligation_Type_Select_Column[keyof typeof Obligation_Type_Select_Column];
/** Streaming cursor of the table "obligation_type" */
export type Obligation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Obligation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Obligation_Type_Stream_Cursor_Value_Input = {
  Comment?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.obligation" */
export const Obligation_Update_Column = {
  /** column name */
  Adherence: 'Adherence',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Interpretation: 'Interpretation',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Obligation_Update_Column = typeof Obligation_Update_Column[keyof typeof Obligation_Update_Column];
/** aggregate var_pop on columns */
export type Obligation_Var_Pop_Fields = {
  __typename?: 'obligation_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.obligation" */
export type Obligation_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Obligation_Var_Samp_Fields = {
  __typename?: 'obligation_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.obligation" */
export type Obligation_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Obligation_Variance_Fields = {
  __typename?: 'obligation_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.obligation" */
export type Obligation_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
};

/** column ordering options */
export const Order_By = {
  /** in ascending order, nulls last */
  Asc: 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst: 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast: 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc: 'desc',
  /** in descending order, nulls first */
  DescNullsFirst: 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast: 'desc_nulls_last'
} as const;

export type Order_By = typeof Order_By[keyof typeof Order_By];
/** columns and relationships of "risksmart.organisation_module" */
export type Organisation_Module = {
  __typename?: 'organisation_module';
  ModuleSettings: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.organisation_module" */
export type Organisation_ModuleModuleSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Module_Append_Input = {
  ModuleSettings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.organisation_module". All fields are combined with a logical 'AND'. */
export type Organisation_Module_Bool_Exp = {
  ModuleSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Organisation_Module_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Module_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.organisation_module" */
export const Organisation_Module_Constraint = {
  /** unique or primary key constraint on columns "OrgKey" */
  OrganisationModulePkey: 'organisation_module_pkey'
} as const;

export type Organisation_Module_Constraint = typeof Organisation_Module_Constraint[keyof typeof Organisation_Module_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organisation_Module_Delete_At_Path_Input = {
  ModuleSettings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organisation_Module_Delete_Elem_Input = {
  ModuleSettings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organisation_Module_Delete_Key_Input = {
  ModuleSettings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.organisation_module" */
export type Organisation_Module_Insert_Input = {
  ModuleSettings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "risksmart.organisation_module" */
export type Organisation_Module_Mutation_Response = {
  __typename?: 'organisation_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Module>;
};

/** on_conflict condition type for table "risksmart.organisation_module" */
export type Organisation_Module_On_Conflict = {
  constraint: Organisation_Module_Constraint;
  update_columns?: Array<Organisation_Module_Update_Column>;
  where?: InputMaybe<Organisation_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.organisation_module". */
export type Organisation_Module_Order_By = {
  ModuleSettings?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Module_Prepend_Input = {
  ModuleSettings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.organisation_module" */
export const Organisation_Module_Select_Column = {
  /** column name */
  ModuleSettings: 'ModuleSettings'
} as const;

export type Organisation_Module_Select_Column = typeof Organisation_Module_Select_Column[keyof typeof Organisation_Module_Select_Column];
/** input type for updating data in table "risksmart.organisation_module" */
export type Organisation_Module_Set_Input = {
  ModuleSettings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "organisation_module" */
export type Organisation_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Module_Stream_Cursor_Value_Input = {
  ModuleSettings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.organisation_module" */
export const Organisation_Module_Update_Column = {
  /** column name */
  ModuleSettings: 'ModuleSettings'
} as const;

export type Organisation_Module_Update_Column = typeof Organisation_Module_Update_Column[keyof typeof Organisation_Module_Update_Column];
export type Organisation_Module_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organisation_Module_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organisation_Module_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organisation_Module_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organisation_Module_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organisation_Module_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Module_Bool_Exp;
};

/** columns and relationships of "risksmart.organisation_tab_preference" */
export type Organisation_Tab_Preference = {
  __typename?: 'organisation_tab_preference';
  ObjectType: Parent_Type_Enum;
  Preferences: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.organisation_tab_preference" */
export type Organisation_Tab_PreferencePreferencesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Tab_Preference_Append_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.organisation_tab_preference". All fields are combined with a logical 'AND'. */
export type Organisation_Tab_Preference_Bool_Exp = {
  ObjectType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  Preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Organisation_Tab_Preference_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Tab_Preference_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Tab_Preference_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.organisation_tab_preference" */
export const Organisation_Tab_Preference_Constraint = {
  /** unique or primary key constraint on columns "ObjectType", "OrgKey" */
  OrganisationTabPreferencePkey: 'organisation_tab_preference_pkey'
} as const;

export type Organisation_Tab_Preference_Constraint = typeof Organisation_Tab_Preference_Constraint[keyof typeof Organisation_Tab_Preference_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organisation_Tab_Preference_Delete_At_Path_Input = {
  Preferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organisation_Tab_Preference_Delete_Elem_Input = {
  Preferences?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organisation_Tab_Preference_Delete_Key_Input = {
  Preferences?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.organisation_tab_preference" */
export type Organisation_Tab_Preference_Insert_Input = {
  ObjectType?: InputMaybe<Parent_Type_Enum>;
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "risksmart.organisation_tab_preference" */
export type Organisation_Tab_Preference_Mutation_Response = {
  __typename?: 'organisation_tab_preference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Tab_Preference>;
};

/** on_conflict condition type for table "risksmart.organisation_tab_preference" */
export type Organisation_Tab_Preference_On_Conflict = {
  constraint: Organisation_Tab_Preference_Constraint;
  update_columns?: Array<Organisation_Tab_Preference_Update_Column>;
  where?: InputMaybe<Organisation_Tab_Preference_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.organisation_tab_preference". */
export type Organisation_Tab_Preference_Order_By = {
  ObjectType?: InputMaybe<Order_By>;
  Preferences?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Tab_Preference_Prepend_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.organisation_tab_preference" */
export const Organisation_Tab_Preference_Select_Column = {
  /** column name */
  ObjectType: 'ObjectType',
  /** column name */
  Preferences: 'Preferences'
} as const;

export type Organisation_Tab_Preference_Select_Column = typeof Organisation_Tab_Preference_Select_Column[keyof typeof Organisation_Tab_Preference_Select_Column];
/** input type for updating data in table "risksmart.organisation_tab_preference" */
export type Organisation_Tab_Preference_Set_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "organisation_tab_preference" */
export type Organisation_Tab_Preference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Tab_Preference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Tab_Preference_Stream_Cursor_Value_Input = {
  ObjectType?: InputMaybe<Parent_Type_Enum>;
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.organisation_tab_preference" */
export const Organisation_Tab_Preference_Update_Column = {
  /** column name */
  Preferences: 'Preferences'
} as const;

export type Organisation_Tab_Preference_Update_Column = typeof Organisation_Tab_Preference_Update_Column[keyof typeof Organisation_Tab_Preference_Update_Column];
export type Organisation_Tab_Preference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organisation_Tab_Preference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organisation_Tab_Preference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organisation_Tab_Preference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organisation_Tab_Preference_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organisation_Tab_Preference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Tab_Preference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Tab_Preference_Bool_Exp;
};

/** columns and relationships of "risksmart.owner" */
export type Owner = {
  __typename?: 'owner';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "risksmart.owner" */
export type Owner_Aggregate = {
  __typename?: 'owner_aggregate';
  aggregate?: Maybe<Owner_Aggregate_Fields>;
  nodes: Array<Owner>;
};

export type Owner_Aggregate_Bool_Exp = {
  count?: InputMaybe<Owner_Aggregate_Bool_Exp_Count>;
};

export type Owner_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Owner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Owner_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.owner" */
export type Owner_Aggregate_Fields = {
  __typename?: 'owner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Owner_Max_Fields>;
  min?: Maybe<Owner_Min_Fields>;
};


/** aggregate fields of "risksmart.owner" */
export type Owner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Owner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.owner" */
export type Owner_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Owner_Max_Order_By>;
  min?: InputMaybe<Owner_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.owner" */
export type Owner_Arr_Rel_Insert_Input = {
  data: Array<Owner_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Owner_On_Conflict>;
};

/** columns and relationships of "risksmart.owner_audit" */
export type Owner_Audit = {
  __typename?: 'owner_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
};

/** order by aggregate values of table "risksmart.owner_audit" */
export type Owner_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Owner_Audit_Max_Order_By>;
  min?: InputMaybe<Owner_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.owner_audit". All fields are combined with a logical 'AND'. */
export type Owner_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Owner_Audit_Bool_Exp>>;
  _not?: InputMaybe<Owner_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Owner_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.owner_audit" */
export type Owner_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.owner_audit" */
export type Owner_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.owner_audit". */
export type Owner_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.owner_audit" */
export const Owner_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Owner_Audit_Select_Column = typeof Owner_Audit_Select_Column[keyof typeof Owner_Audit_Select_Column];
/** Streaming cursor of the table "owner_audit" */
export type Owner_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Owner_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Owner_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.owner". All fields are combined with a logical 'AND'. */
export type Owner_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Owner_Bool_Exp>>;
  _not?: InputMaybe<Owner_Bool_Exp>;
  _or?: InputMaybe<Array<Owner_Bool_Exp>>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.owner" */
export const Owner_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "UserId" */
  OwnerPkey: 'owner_pkey'
} as const;

export type Owner_Constraint = typeof Owner_Constraint[keyof typeof Owner_Constraint];
/** columns and relationships of "risksmart.owner_group" */
export type Owner_Group = {
  __typename?: 'owner_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  UserGroupId: Scalars['uuid']['output'];
  /** An object relationship */
  group?: Maybe<User_Group>;
  /** An object relationship */
  organisation: Auth_Organisation;
};

/** aggregated selection of "risksmart.owner_group" */
export type Owner_Group_Aggregate = {
  __typename?: 'owner_group_aggregate';
  aggregate?: Maybe<Owner_Group_Aggregate_Fields>;
  nodes: Array<Owner_Group>;
};

export type Owner_Group_Aggregate_Bool_Exp = {
  count?: InputMaybe<Owner_Group_Aggregate_Bool_Exp_Count>;
};

export type Owner_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Owner_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Owner_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.owner_group" */
export type Owner_Group_Aggregate_Fields = {
  __typename?: 'owner_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Owner_Group_Max_Fields>;
  min?: Maybe<Owner_Group_Min_Fields>;
};


/** aggregate fields of "risksmart.owner_group" */
export type Owner_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Owner_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.owner_group" */
export type Owner_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Owner_Group_Max_Order_By>;
  min?: InputMaybe<Owner_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.owner_group" */
export type Owner_Group_Arr_Rel_Insert_Input = {
  data: Array<Owner_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Owner_Group_On_Conflict>;
};

/** columns and relationships of "risksmart.owner_group_audit" */
export type Owner_Group_Audit = {
  __typename?: 'owner_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
  UserGroupId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risksmart.owner_group_audit" */
export type Owner_Group_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Owner_Group_Audit_Max_Order_By>;
  min?: InputMaybe<Owner_Group_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.owner_group_audit". All fields are combined with a logical 'AND'. */
export type Owner_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Owner_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Owner_Group_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.owner_group_audit" */
export type Owner_Group_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.owner_group_audit" */
export type Owner_Group_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.owner_group_audit". */
export type Owner_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.owner_group_audit" */
export const Owner_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserGroupId: 'UserGroupId'
} as const;

export type Owner_Group_Audit_Select_Column = typeof Owner_Group_Audit_Select_Column[keyof typeof Owner_Group_Audit_Select_Column];
/** Streaming cursor of the table "owner_group_audit" */
export type Owner_Group_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Owner_Group_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Owner_Group_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.owner_group". All fields are combined with a logical 'AND'. */
export type Owner_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Owner_Group_Bool_Exp>>;
  _not?: InputMaybe<Owner_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Owner_Group_Bool_Exp>>;
  group?: InputMaybe<User_Group_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.owner_group" */
export const Owner_Group_Constraint = {
  /** unique or primary key constraint on columns "ParentId", "UserGroupId" */
  OwnerGroupPkey: 'owner_group_pkey'
} as const;

export type Owner_Group_Constraint = typeof Owner_Group_Constraint[keyof typeof Owner_Group_Constraint];
/** input type for inserting data into table "risksmart.owner_group" */
export type Owner_Group_Insert_Input = {
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  group?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Owner_Group_Max_Fields = {
  __typename?: 'owner_group_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.owner_group" */
export type Owner_Group_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Owner_Group_Min_Fields = {
  __typename?: 'owner_group_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.owner_group" */
export type Owner_Group_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.owner_group" */
export type Owner_Group_On_Conflict = {
  constraint: Owner_Group_Constraint;
  update_columns?: Array<Owner_Group_Update_Column>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.owner_group". */
export type Owner_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  group?: InputMaybe<User_Group_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** select columns of table "risksmart.owner_group" */
export const Owner_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserGroupId: 'UserGroupId'
} as const;

export type Owner_Group_Select_Column = typeof Owner_Group_Select_Column[keyof typeof Owner_Group_Select_Column];
/** placeholder for update columns of table "risksmart.owner_group" (current role has no relevant permissions) */
export const Owner_Group_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Owner_Group_Update_Column = typeof Owner_Group_Update_Column[keyof typeof Owner_Group_Update_Column];
/** input type for inserting data into table "risksmart.owner" */
export type Owner_Insert_Input = {
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Owner_Max_Fields = {
  __typename?: 'owner_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.owner" */
export type Owner_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Owner_Min_Fields = {
  __typename?: 'owner_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.owner" */
export type Owner_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.owner" */
export type Owner_On_Conflict = {
  constraint: Owner_Constraint;
  update_columns?: Array<Owner_Update_Column>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.owner". */
export type Owner_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.owner" */
export const Owner_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Owner_Select_Column = typeof Owner_Select_Column[keyof typeof Owner_Select_Column];
/** placeholder for update columns of table "risksmart.owner" (current role has no relevant permissions) */
export const Owner_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Owner_Update_Column = typeof Owner_Update_Column[keyof typeof Owner_Update_Column];
export const Parent_Type_Enum = {
  /** Acceptance */
  Acceptance: 'acceptance',
  /** Action */
  Action: 'action',
  /** Action Update */
  ActionUpdate: 'action_update',
  /** Aggregation settings */
  AggregationOrg: 'aggregation_org',
  /** Appetite */
  Appetite: 'appetite',
  /** Approval result */
  ApprovalResult: 'approval_result',
  /** Assessment */
  Assessment: 'assessment',
  /** Assessment Activity */
  AssessmentActivity: 'assessment_activity',
  /** Generic assessment result parent for register */
  AssessmentResult: 'assessment_result',
  /** Attestation Cycle */
  AttestationCycle: 'attestation_cycle',
  /** Attestation Record */
  AttestationRecord: 'attestation_record',
  /** Audit entities */
  Audit: 'audit',
  /** Business Area */
  BusinessArea: 'business_area',
  /** Cause */
  Cause: 'cause',
  /** Change Request */
  ChangeRequest: 'change_request',
  /** Colour Palette */
  ColourPalette: 'colour_palette',
  /** Compliance Monitoring Assessment */
  ComplianceMonitoringAssessment: 'compliance_monitoring_assessment',
  /** Compliance Monitoring Assessment Result */
  ComplianceMonitoringAssessmentResult: 'compliance_monitoring_assessment_result',
  /** Consequence */
  Consequence: 'consequence',
  /** Control */
  Control: 'control',
  /** Control Group */
  ControlGroup: 'control_group',
  /** Control test internal audit result */
  ControlTestInternalAuditResult: 'control_test_internal_audit_result',
  /** Control test second line result */
  ControlTestSecondLineResult: 'control_test_second_line_result',
  /** Controlled Risk Assessment Result */
  ControlledRiskAssessmentResult: 'controlled_risk_assessment_result',
  /** Conversation */
  Conversation: 'conversation',
  /** Custom attribute schema */
  CustomAttributeSchema: 'custom_attribute_schema',
  /** CustomDatasource */
  CustomDatasource: 'custom_datasource',
  /** Custom Ribbon Item */
  CustomRibbon: 'custom_ribbon',
  /** Custom Role */
  CustomRole: 'custom_role',
  /** Dashboard */
  Dashboard: 'dashboard',
  /** Data Export */
  DataExport: 'data_export',
  /** Data Import */
  DataImport: 'data_import',
  /** Department Type */
  DepartmentType: 'department_type',
  /** Document */
  Document: 'document',
  /** Document Assessment */
  DocumentAssessment: 'document_assessment',
  /** Document Assessment Result */
  DocumentAssessmentResult: 'document_assessment_result',
  /** Document version */
  DocumentFile: 'document_file',
  /** Document internal audit result */
  DocumentInternalAuditResult: 'document_internal_audit_result',
  /** Document second line result */
  DocumentSecondLineResult: 'document_second_line_result',
  /** Enterprise Risk */
  EnterpriseRisk: 'enterprise_risk',
  /** Entity */
  Entity: 'entity',
  /** External API */
  ExternalApi: 'external_api',
  /** Impact */
  Impact: 'impact',
  /** Impact internal audit rating */
  ImpactInternalAuditRating: 'impact_internal_audit_rating',
  /** Impact Parent */
  ImpactParent: 'impact_parent',
  /** Impact rating */
  ImpactRating: 'impact_rating',
  /** Impact second line rating */
  ImpactSecondLineRating: 'impact_second_line_rating',
  /** Indicator */
  Indicator: 'indicator',
  /** Indicator Result */
  IndicatorResult: 'indicator_result',
  /** Internal Audit */
  InternalAuditEntity: 'internal_audit_entity',
  /** Internal Audit Report */
  InternalAuditReport: 'internal_audit_report',
  /** Internal Audit Report Result */
  InternalAuditReportResult: 'internal_audit_report_result',
  /** Issue */
  Issue: 'issue',
  /** Issue Assessment */
  IssueAssessment: 'issue_assessment',
  /** Issue assessment audit */
  IssueAssessmentAudit: 'issue_assessment_audit',
  /** issue assessment breach log */
  IssueAssessmentBreachLog: 'issue_assessment_breach_log',
  /** issue assessment consumer duty */
  IssueAssessmentConsumerDuty: 'issue_assessment_consumer_duty',
  /** issue assessment customer trust */
  IssueAssessmentCustomerTrust: 'issue_assessment_customer_trust',
  /** issue assessment gdpr breach log */
  IssueAssessmentGdprBreachLog: 'issue_assessment_gdpr_breach_log',
  /** issue assessment pci breach log */
  IssueAssessmentPciBreachLog: 'issue_assessment_pci_breach_log',
  /** issue assessment risk event */
  IssueAssessmentRiskEvent: 'issue_assessment_risk_event',
  /** issue assessment sar log */
  IssueAssessmentSarLog: 'issue_assessment_sar_log',
  /** issue breach log */
  IssueBreachLog: 'issue_breach_log',
  /** issue consumer duty */
  IssueConsumerDuty: 'issue_consumer_duty',
  /** issue customer trust */
  IssueCustomerTrust: 'issue_customer_trust',
  /** issue gdpr breach log */
  IssueGdprBreachLog: 'issue_gdpr_breach_log',
  /** issue pci breach log */
  IssuePciBreachLog: 'issue_pci_breach_log',
  /** issue risk event */
  IssueRiskEvent: 'issue_risk_event',
  /** issue sar log */
  IssueSarLog: 'issue_sar_log',
  /** Issue Update */
  IssueUpdate: 'issue_update',
  /** Linked item */
  LinkedItem: 'linked_item',
  /** Multiple datasource reporting */
  MultiReporting: 'multi_reporting',
  /** My items */
  MyItems: 'my_items',
  /** Notification */
  Notification: 'notification',
  /** Obligation */
  Obligation: 'obligation',
  /** Obligation Assessment */
  ObligationAssessment: 'obligation_assessment',
  /** Obligation Assessment Result */
  ObligationAssessmentResult: 'obligation_assessment_result',
  /** Obligation change feed items */
  ObligationChange: 'obligation_change',
  /** Attestations for obligation change feed items */
  ObligationChangeAttestation: 'obligation_change_attestation',
  /** Obligation Impact */
  ObligationImpact: 'obligation_impact',
  /** Obligation internal audit result */
  ObligationInternalAuditResult: 'obligation_internal_audit_result',
  /** Obligation second line result */
  ObligationSecondLineResult: 'obligation_second_line_result',
  /** Organisation shared dashboards */
  OrganisationDashboard: 'organisation_dashboard',
  /** Organisation Modules */
  OrganisationModule: 'organisation_module',
  /** Organisation Tab Preference */
  OrganisationTabPreference: 'organisation_tab_preference',
  /** Public issue form */
  PublicIssueForm: 'public_issue_form',
  /** Public policies */
  PublicPolicies: 'public_policies',
  /** Questionnaire Template */
  QuestionnaireTemplate: 'questionnaire_template',
  /** Questionnaire Template Version */
  QuestionnaireTemplateVersion: 'questionnaire_template_version',
  /** Reports */
  Report: 'report',
  /** Risk */
  Risk: 'risk',
  /** Risk assessment */
  RiskAssessment: 'risk_assessment',
  /** Risk Assessment Result */
  RiskAssessmentResult: 'risk_assessment_result',
  /** Risk Assessment Result Config */
  RiskAssessmentResultConfig: 'risk_assessment_result_config',
  /** Risk Assessment Result Impact */
  RiskAssessmentResultImpact: 'risk_assessment_result_impact',
  /** Risk Controlled Assessment */
  RiskControlledAssessment: 'risk_controlled_assessment',
  /** Risk controlled internal audit result */
  RiskControlledInternalAuditResult: 'risk_controlled_internal_audit_result',
  /** Risk controlled second line result */
  RiskControlledSecondLineResult: 'risk_controlled_second_line_result',
  /** Tier 1 risk */
  RiskTier_1: 'risk_tier_1',
  /** Risk Uncontrolled Assessment */
  RiskUncontrolledAssessment: 'risk_uncontrolled_assessment',
  /** Risk uncontrolled internal audit result */
  RiskUncontrolledInternalAuditResult: 'risk_uncontrolled_internal_audit_result',
  /** Risk uncontrolled second line result */
  RiskUncontrolledSecondLineResult: 'risk_uncontrolled_second_line_result',
  /** Scim Configuration */
  ScimConfiguration: 'scim_configuration',
  /** Settings */
  Settings: 'settings',
  /** Approvals Settings */
  SettingsApprovals: 'settings_approvals',
  /** Audit Settings */
  SettingsAudit: 'settings_audit',
  /** Department Settings */
  SettingsDepartments: 'settings_departments',
  /** Module Settings */
  SettingsModule: 'settings_module',
  /** Tag Settings */
  SettingsTags: 'settings_tags',
  /** User Group Settings */
  SettingsUserGroups: 'settings_user_groups',
  /** User Settings */
  SettingsUsers: 'settings_users',
  /** Tag type */
  TagType: 'tag_type',
  /** Taxonomy */
  Taxonomy: 'taxonomy',
  /** Test Result */
  TestResult: 'test_result',
  /** Third Party */
  ThirdParty: 'third_party',
  /** Third Party Response */
  ThirdPartyResponse: 'third_party_response',
  /** Uncontrolled Risk Assessment Result */
  UncontrolledRiskAssessmentResult: 'uncontrolled_risk_assessment_result',
  /** User Tab Preference */
  UserTabPreference: 'user_tab_preference'
} as const;

export type Parent_Type_Enum = typeof Parent_Type_Enum[keyof typeof Parent_Type_Enum];
/** Boolean expression to compare columns of type "parent_type_enum". All fields are combined with logical 'AND'. */
export type Parent_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parent_Type_Enum>;
  _in?: InputMaybe<Array<Parent_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parent_Type_Enum>;
  _nin?: InputMaybe<Array<Parent_Type_Enum>>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "risksmart.acceptance" */
  acceptance: Array<Acceptance>;
  /** fetch aggregated fields from the table: "risksmart.acceptance" */
  acceptance_aggregate: Acceptance_Aggregate;
  /** fetch data from the table: "risksmart.acceptance_audit" */
  acceptance_audit: Array<Acceptance_Audit>;
  /** fetch data from the table: "risksmart.acceptance_audit" using primary key columns */
  acceptance_audit_by_pk?: Maybe<Acceptance_Audit>;
  /** fetch data from the table: "risksmart.acceptance" using primary key columns */
  acceptance_by_pk?: Maybe<Acceptance>;
  /** fetch data from the table: "risksmart.acceptance_parent" */
  acceptance_parent: Array<Acceptance_Parent>;
  /** fetch aggregated fields from the table: "risksmart.acceptance_parent" */
  acceptance_parent_aggregate: Acceptance_Parent_Aggregate;
  /** fetch data from the table: "risksmart.acceptance_parent_audit" */
  acceptance_parent_audit: Array<Acceptance_Parent_Audit>;
  /** fetch data from the table: "risksmart.acceptance_parent_audit" using primary key columns */
  acceptance_parent_audit_by_pk?: Maybe<Acceptance_Parent_Audit>;
  /** fetch data from the table: "risksmart.acceptance_parent" using primary key columns */
  acceptance_parent_by_pk?: Maybe<Acceptance_Parent>;
  /** fetch data from the table: "risksmart.action" */
  action: Array<Action>;
  /** fetch aggregated fields from the table: "risksmart.action" */
  action_aggregate: Action_Aggregate;
  /** fetch data from the table: "risksmart.action_audit" */
  action_audit: Array<Action_Audit>;
  /** fetch aggregated fields from the table: "risksmart.action_audit" */
  action_audit_aggregate: Action_Audit_Aggregate;
  /** fetch data from the table: "risksmart.action_audit" using primary key columns */
  action_audit_by_pk?: Maybe<Action_Audit>;
  /** fetch data from the table: "risksmart.action" using primary key columns */
  action_by_pk?: Maybe<Action>;
  /** fetch data from the table: "risksmart.action_parent" */
  action_parent: Array<Action_Parent>;
  /** fetch aggregated fields from the table: "risksmart.action_parent" */
  action_parent_aggregate: Action_Parent_Aggregate;
  /** fetch data from the table: "risksmart.action_parent_audit" */
  action_parent_audit: Array<Action_Parent_Audit>;
  /** fetch data from the table: "risksmart.action_parent_audit" using primary key columns */
  action_parent_audit_by_pk?: Maybe<Action_Parent_Audit>;
  /** fetch data from the table: "risksmart.action_parent" using primary key columns */
  action_parent_by_pk?: Maybe<Action_Parent>;
  /** fetch data from the table: "risksmart.action_update" */
  action_update: Array<Action_Update>;
  /** fetch aggregated fields from the table: "risksmart.action_update" */
  action_update_aggregate: Action_Update_Aggregate;
  /** fetch data from the table: "risksmart.action_update_audit" */
  action_update_audit: Array<Action_Update_Audit>;
  /** fetch data from the table: "risksmart.action_update_audit" using primary key columns */
  action_update_audit_by_pk?: Maybe<Action_Update_Audit>;
  /** fetch data from the table: "risksmart.action_update" using primary key columns */
  action_update_by_pk?: Maybe<Action_Update>;
  /** fetch data from the table: "risksmart.action_update_summary_view" */
  action_update_summary: Array<Action_Update_Summary>;
  /** fetch aggregated fields from the table: "risksmart.action_update_summary_view" */
  action_update_summary_aggregate: Action_Update_Summary_Aggregate;
  /** fetch data from the table: "risksmart.aggregation_org" */
  aggregation_org: Array<Aggregation_Org>;
  /** fetch data from the table: "risksmart.aggregation_org" using primary key columns */
  aggregation_org_by_pk?: Maybe<Aggregation_Org>;
  /** fetch data from the table: "risksmart.ancestor_contributor_view" */
  ancestor_contributor: Array<Ancestor_Contributor>;
  /** fetch data from the table: "risksmart.appetite" */
  appetite: Array<Appetite>;
  /** fetch aggregated fields from the table: "risksmart.appetite" */
  appetite_aggregate: Appetite_Aggregate;
  /** fetch data from the table: "risksmart.appetite_audit" */
  appetite_audit: Array<Appetite_Audit>;
  /** fetch data from the table: "risksmart.appetite_audit" using primary key columns */
  appetite_audit_by_pk?: Maybe<Appetite_Audit>;
  /** fetch data from the table: "risksmart.appetite" using primary key columns */
  appetite_by_pk?: Maybe<Appetite>;
  /** fetch data from the table: "risksmart.appetite_parent" */
  appetite_parent: Array<Appetite_Parent>;
  /** fetch aggregated fields from the table: "risksmart.appetite_parent" */
  appetite_parent_aggregate: Appetite_Parent_Aggregate;
  /** fetch data from the table: "risksmart.appetite_parent_audit" */
  appetite_parent_audit: Array<Appetite_Parent_Audit>;
  /** fetch aggregated fields from the table: "risksmart.appetite_parent_audit" */
  appetite_parent_audit_aggregate: Appetite_Parent_Audit_Aggregate;
  /** fetch data from the table: "risksmart.appetite_parent_audit" using primary key columns */
  appetite_parent_audit_by_pk?: Maybe<Appetite_Parent_Audit>;
  /** fetch data from the table: "risksmart.appetite_parent" using primary key columns */
  appetite_parent_by_pk?: Maybe<Appetite_Parent>;
  /** fetch data from the table: "risksmart.approval" */
  approval: Array<Approval>;
  /** fetch data from the table: "risksmart.approval_audit" */
  approval_audit: Array<Approval_Audit>;
  /** fetch data from the table: "risksmart.approval_audit" using primary key columns */
  approval_audit_by_pk?: Maybe<Approval_Audit>;
  /** fetch data from the table: "risksmart.approval" using primary key columns */
  approval_by_pk?: Maybe<Approval>;
  /** fetch data from the table: "risksmart.approval_level" */
  approval_level: Array<Approval_Level>;
  /** fetch data from the table: "risksmart.approval_level_audit" */
  approval_level_audit: Array<Approval_Level_Audit>;
  /** fetch data from the table: "risksmart.approval_level_audit" using primary key columns */
  approval_level_audit_by_pk?: Maybe<Approval_Level_Audit>;
  /** fetch data from the table: "risksmart.approval_level" using primary key columns */
  approval_level_by_pk?: Maybe<Approval_Level>;
  /** fetch data from the table: "risksmart.approver" */
  approver: Array<Approver>;
  /** fetch aggregated fields from the table: "risksmart.approver" */
  approver_aggregate: Approver_Aggregate;
  /** fetch data from the table: "risksmart.approver_audit" */
  approver_audit: Array<Approver_Audit>;
  /** fetch data from the table: "risksmart.approver_audit" using primary key columns */
  approver_audit_by_pk?: Maybe<Approver_Audit>;
  /** fetch data from the table: "risksmart.approver" using primary key columns */
  approver_by_pk?: Maybe<Approver>;
  /** fetch data from the table: "risksmart.assessment" */
  assessment: Array<Assessment>;
  /** fetch data from the table: "risksmart.assessment_activity" */
  assessment_activity: Array<Assessment_Activity>;
  /** fetch aggregated fields from the table: "risksmart.assessment_activity" */
  assessment_activity_aggregate: Assessment_Activity_Aggregate;
  /** fetch data from the table: "risksmart.assessment_activity_audit" */
  assessment_activity_audit: Array<Assessment_Activity_Audit>;
  /** fetch data from the table: "risksmart.assessment_activity_audit" using primary key columns */
  assessment_activity_audit_by_pk?: Maybe<Assessment_Activity_Audit>;
  /** fetch data from the table: "risksmart.assessment_activity" using primary key columns */
  assessment_activity_by_pk?: Maybe<Assessment_Activity>;
  /** fetch aggregated fields from the table: "risksmart.assessment" */
  assessment_aggregate: Assessment_Aggregate;
  /** fetch data from the table: "risksmart.assessment_audit" */
  assessment_audit: Array<Assessment_Audit>;
  /** fetch aggregated fields from the table: "risksmart.assessment_audit" */
  assessment_audit_aggregate: Assessment_Audit_Aggregate;
  /** fetch data from the table: "risksmart.assessment_audit" using primary key columns */
  assessment_audit_by_pk?: Maybe<Assessment_Audit>;
  /** fetch data from the table: "risksmart.assessment" using primary key columns */
  assessment_by_pk?: Maybe<Assessment>;
  /** fetch data from the table: "risksmart.assessment_result_parent" */
  assessment_result_parent: Array<Assessment_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.assessment_result_parent" */
  assessment_result_parent_aggregate: Assessment_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.assessment_result_parent_audit" */
  assessment_result_parent_audit: Array<Assessment_Result_Parent_Audit>;
  /** fetch data from the table: "risksmart.assessment_result_parent_audit" using primary key columns */
  assessment_result_parent_audit_by_pk?: Maybe<Assessment_Result_Parent_Audit>;
  /** fetch data from the table: "risksmart.assessment_result_parent" using primary key columns */
  assessment_result_parent_by_pk?: Maybe<Assessment_Result_Parent>;
  /** fetch data from the table: "risksmart.attestation_config" */
  attestation_config: Array<Attestation_Config>;
  /** fetch data from the table: "risksmart.attestation_config" using primary key columns */
  attestation_config_by_pk?: Maybe<Attestation_Config>;
  /** fetch data from the table: "risksmart.attestation_cycle" */
  attestation_cycle: Array<Attestation_Cycle>;
  /** fetch data from the table: "risksmart.attestation_cycle_audit" */
  attestation_cycle_audit: Array<Attestation_Cycle_Audit>;
  /** fetch data from the table: "risksmart.attestation_cycle" using primary key columns */
  attestation_cycle_by_pk?: Maybe<Attestation_Cycle>;
  /** fetch data from the table: "risksmart.attestation_group" */
  attestation_group: Array<Attestation_Group>;
  /** fetch data from the table: "risksmart.attestation_group" using primary key columns */
  attestation_group_by_pk?: Maybe<Attestation_Group>;
  /** fetch data from the table: "risksmart.attestation_record" */
  attestation_record: Array<Attestation_Record>;
  /** fetch aggregated fields from the table: "risksmart.attestation_record" */
  attestation_record_aggregate: Attestation_Record_Aggregate;
  /** fetch data from the table: "risksmart.attestation_record" using primary key columns */
  attestation_record_by_pk?: Maybe<Attestation_Record>;
  /** fetch data from the table: "risksmart.audit_log_view" */
  audit_log_view: Array<Audit_Log_View>;
  /** fetch aggregated fields from the table: "risksmart.audit_log_view" */
  audit_log_view_aggregate: Audit_Log_View_Aggregate;
  /** fetch data from the table: "auth.organisation" */
  auth_organisation: Array<Auth_Organisation>;
  /** fetch data from the table: "auth.organisation" using primary key columns */
  auth_organisation_by_pk?: Maybe<Auth_Organisation>;
  /** fetch data from the table: "auth.organisationuser" */
  auth_organisationuser: Array<Auth_Organisationuser>;
  /** fetch data from the table: "auth.organisationuser" using primary key columns */
  auth_organisationuser_by_pk?: Maybe<Auth_Organisationuser>;
  /** fetch data from the table: "auth.role_resource_type" */
  auth_role_resource_type: Array<Auth_Role_Resource_Type>;
  /** fetch data from the table: "auth.role_resource_type" using primary key columns */
  auth_role_resource_type_by_pk?: Maybe<Auth_Role_Resource_Type>;
  /** fetch data from the table: "auth.role_type" */
  auth_role_type: Array<Auth_Role_Type>;
  /** fetch data from the table: "auth.role_type" using primary key columns */
  auth_role_type_by_pk?: Maybe<Auth_Role_Type>;
  /** fetch data from the table: "auth.role_type_resource_type" */
  auth_role_type_resource_type: Array<Auth_Role_Type_Resource_Type>;
  /** fetch data from the table: "auth.role_type_resource_type" using primary key columns */
  auth_role_type_resource_type_by_pk?: Maybe<Auth_Role_Type_Resource_Type>;
  /** fetch data from the table: "auth.user" */
  auth_user: Array<Auth_User>;
  /** fetch aggregated fields from the table: "auth.user" */
  auth_user_aggregate: Auth_User_Aggregate;
  /** fetch data from the table: "auth.user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  /** fetch data from the table: "auth.user_role" */
  auth_user_role: Array<Auth_User_Role>;
  /** fetch data from the table: "auth.user_role" using primary key columns */
  auth_user_role_by_pk?: Maybe<Auth_User_Role>;
  available_roles: Array<RoleOutput>;
  /** fetch data from the table: "risksmart.business_area" */
  business_area: Array<Business_Area>;
  /** fetch aggregated fields from the table: "risksmart.business_area" */
  business_area_aggregate: Business_Area_Aggregate;
  /** fetch data from the table: "risksmart.business_area" using primary key columns */
  business_area_by_pk?: Maybe<Business_Area>;
  /** fetch data from the table: "risksmart.cause" */
  cause: Array<Cause>;
  /** fetch aggregated fields from the table: "risksmart.cause" */
  cause_aggregate: Cause_Aggregate;
  /** fetch data from the table: "risksmart.cause_audit" */
  cause_audit: Array<Cause_Audit>;
  /** fetch data from the table: "risksmart.cause_audit" using primary key columns */
  cause_audit_by_pk?: Maybe<Cause_Audit>;
  /** fetch data from the table: "risksmart.cause" using primary key columns */
  cause_by_pk?: Maybe<Cause>;
  /** fetch data from the table: "risksmart.change_request" */
  change_request: Array<Change_Request>;
  /** fetch aggregated fields from the table: "risksmart.change_request" */
  change_request_aggregate: Change_Request_Aggregate;
  /** fetch data from the table: "risksmart.change_request_audit" */
  change_request_audit: Array<Change_Request_Audit>;
  /** fetch data from the table: "risksmart.change_request_audit" using primary key columns */
  change_request_audit_by_pk?: Maybe<Change_Request_Audit>;
  /** fetch data from the table: "risksmart.change_request" using primary key columns */
  change_request_by_pk?: Maybe<Change_Request>;
  /** fetch data from the table: "risksmart.change_request_contributor" */
  change_request_contributor: Array<Change_Request_Contributor>;
  /** fetch data from the table: "risksmart.change_request_contributor" using primary key columns */
  change_request_contributor_by_pk?: Maybe<Change_Request_Contributor>;
  /** fetch data from the table: "risksmart.colour_palette" */
  colour_palette: Array<Colour_Palette>;
  /** fetch aggregated fields from the table: "risksmart.colour_palette" */
  colour_palette_aggregate: Colour_Palette_Aggregate;
  /** fetch data from the table: "risksmart.colour_palette_audit" */
  colour_palette_audit: Array<Colour_Palette_Audit>;
  /** fetch data from the table: "risksmart.colour_palette" using primary key columns */
  colour_palette_by_pk?: Maybe<Colour_Palette>;
  /** fetch data from the table: "risksmart.comment" */
  comment: Array<Comment>;
  /** fetch data from the table: "risksmart.comment_audit" */
  comment_audit: Array<Comment_Audit>;
  /** fetch data from the table: "risksmart.comment_audit" using primary key columns */
  comment_audit_by_pk?: Maybe<Comment_Audit>;
  /** fetch data from the table: "risksmart.comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table: "risksmart.compliance_monitoring_assessment" */
  compliance_monitoring_assessment: Array<Compliance_Monitoring_Assessment>;
  /** fetch aggregated fields from the table: "risksmart.compliance_monitoring_assessment" */
  compliance_monitoring_assessment_aggregate: Compliance_Monitoring_Assessment_Aggregate;
  /** fetch data from the table: "risksmart.compliance_monitoring_assessment" using primary key columns */
  compliance_monitoring_assessment_by_pk?: Maybe<Compliance_Monitoring_Assessment>;
  /** fetch data from the table: "risksmart.consequence" */
  consequence: Array<Consequence>;
  /** fetch aggregated fields from the table: "risksmart.consequence" */
  consequence_aggregate: Consequence_Aggregate;
  /** fetch data from the table: "risksmart.consequence_audit" */
  consequence_audit: Array<Consequence_Audit>;
  /** fetch aggregated fields from the table: "risksmart.consequence_audit" */
  consequence_audit_aggregate: Consequence_Audit_Aggregate;
  /** fetch data from the table: "risksmart.consequence_audit" using primary key columns */
  consequence_audit_by_pk?: Maybe<Consequence_Audit>;
  /** fetch data from the table: "risksmart.consequence" using primary key columns */
  consequence_by_pk?: Maybe<Consequence>;
  /** fetch data from the table: "risksmart.control" */
  control: Array<Control>;
  /** fetch aggregated fields from the table: "risksmart.control" */
  control_aggregate: Control_Aggregate;
  /** fetch data from the table: "risksmart.control_audit" */
  control_audit: Array<Control_Audit>;
  /** fetch data from the table: "risksmart.control_audit" using primary key columns */
  control_audit_by_pk?: Maybe<Control_Audit>;
  /** fetch data from the table: "risksmart.control" using primary key columns */
  control_by_pk?: Maybe<Control>;
  /** fetch data from the table: "risksmart.control_group" */
  control_group: Array<Control_Group>;
  /** fetch aggregated fields from the table: "risksmart.control_group" */
  control_group_aggregate: Control_Group_Aggregate;
  /** fetch data from the table: "risksmart.control_group_audit" */
  control_group_audit: Array<Control_Group_Audit>;
  /** fetch data from the table: "risksmart.control_group_audit" using primary key columns */
  control_group_audit_by_pk?: Maybe<Control_Group_Audit>;
  /** fetch data from the table: "risksmart.control_group" using primary key columns */
  control_group_by_pk?: Maybe<Control_Group>;
  /** fetch data from the table: "risksmart.control_parent" */
  control_parent: Array<Control_Parent>;
  /** fetch aggregated fields from the table: "risksmart.control_parent" */
  control_parent_aggregate: Control_Parent_Aggregate;
  /** fetch data from the table: "risksmart.control_parent_audit" */
  control_parent_audit: Array<Control_Parent_Audit>;
  /** fetch data from the table: "risksmart.control_parent_audit" using primary key columns */
  control_parent_audit_by_pk?: Maybe<Control_Parent_Audit>;
  /** fetch data from the table: "risksmart.control_parent" using primary key columns */
  control_parent_by_pk?: Maybe<Control_Parent>;
  /** fetch data from the table: "risksmart.control_test_internal_audit_result" */
  control_test_internal_audit_result: Array<Control_Test_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.control_test_internal_audit_result" */
  control_test_internal_audit_result_aggregate: Control_Test_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.control_test_internal_audit_result" using primary key columns */
  control_test_internal_audit_result_by_pk?: Maybe<Control_Test_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.control_test_second_line_result" */
  control_test_second_line_result: Array<Control_Test_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.control_test_second_line_result" */
  control_test_second_line_result_aggregate: Control_Test_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.control_test_second_line_result" using primary key columns */
  control_test_second_line_result_by_pk?: Maybe<Control_Test_Second_Line_Result>;
  /** fetch data from the table: "risksmart.conversation" */
  conversation: Array<Conversation>;
  /** fetch data from the table: "risksmart.conversation_audit" */
  conversation_audit: Array<Conversation_Audit>;
  /** fetch data from the table: "risksmart.conversation_audit" using primary key columns */
  conversation_audit_by_pk?: Maybe<Conversation_Audit>;
  /** fetch data from the table: "risksmart.conversation" using primary key columns */
  conversation_by_pk?: Maybe<Conversation>;
  /** fetch data from the table: "risksmart.custom_attribute_schema" */
  custom_attribute_schema: Array<Custom_Attribute_Schema>;
  /** fetch data from the table: "risksmart.custom_attribute_schema_audit" */
  custom_attribute_schema_audit: Array<Custom_Attribute_Schema_Audit>;
  /** fetch data from the table: "risksmart.custom_attribute_schema_audit" using primary key columns */
  custom_attribute_schema_audit_by_pk?: Maybe<Custom_Attribute_Schema_Audit>;
  /** fetch data from the table: "risksmart.custom_attribute_schema" using primary key columns */
  custom_attribute_schema_by_pk?: Maybe<Custom_Attribute_Schema>;
  /** fetch data from the table: "risksmart.custom_datasource" */
  custom_datasource: Array<Custom_Datasource>;
  /** fetch data from the table: "risksmart.custom_datasource" using primary key columns */
  custom_datasource_by_pk?: Maybe<Custom_Datasource>;
  /** fetch data from the table: "risksmart.custom_ribbon" */
  custom_ribbon: Array<Custom_Ribbon>;
  /** fetch data from the table: "risksmart.custom_ribbon_audit" */
  custom_ribbon_audit: Array<Custom_Ribbon_Audit>;
  /** fetch data from the table: "risksmart.custom_ribbon_audit" using primary key columns */
  custom_ribbon_audit_by_pk?: Maybe<Custom_Ribbon_Audit>;
  /** fetch data from the table: "risksmart.custom_ribbon" using primary key columns */
  custom_ribbon_by_pk?: Maybe<Custom_Ribbon>;
  /** fetch data from the table: "risksmart.custom_role" */
  custom_role: Array<Custom_Role>;
  /** fetch aggregated fields from the table: "risksmart.custom_role" */
  custom_role_aggregate: Custom_Role_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_assignment" */
  custom_role_assignment: Array<Custom_Role_Assignment>;
  /** fetch aggregated fields from the table: "risksmart.custom_role_assignment" */
  custom_role_assignment_aggregate: Custom_Role_Assignment_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_assignment_audit" */
  custom_role_assignment_audit: Array<Custom_Role_Assignment_Audit>;
  /** fetch data from the table: "risksmart.custom_role_assignment" using primary key columns */
  custom_role_assignment_by_pk?: Maybe<Custom_Role_Assignment>;
  /** fetch data from the table: "risksmart.custom_role_audit" */
  custom_role_audit: Array<Custom_Role_Audit>;
  /** fetch data from the table: "risksmart.custom_role" using primary key columns */
  custom_role_by_pk?: Maybe<Custom_Role>;
  /** fetch data from the table: "risksmart.custom_role_user" */
  custom_role_user: Array<Custom_Role_User>;
  /** fetch aggregated fields from the table: "risksmart.custom_role_user" */
  custom_role_user_aggregate: Custom_Role_User_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_user_audit" */
  custom_role_user_audit: Array<Custom_Role_User_Audit>;
  /** fetch data from the table: "risksmart.custom_role_user" using primary key columns */
  custom_role_user_by_pk?: Maybe<Custom_Role_User>;
  /** fetch data from the table: "risksmart.dashboard" */
  dashboard: Array<Dashboard>;
  /** fetch data from the table: "risksmart.dashboard_audit" */
  dashboard_audit: Array<Dashboard_Audit>;
  /** fetch data from the table: "risksmart.dashboard_audit" using primary key columns */
  dashboard_audit_by_pk?: Maybe<Dashboard_Audit>;
  /** fetch data from the table: "risksmart.dashboard" using primary key columns */
  dashboard_by_pk?: Maybe<Dashboard>;
  dataExportOneOffExport?: Maybe<DataExportOneOffExportOutput>;
  /** fetch data from the table: "risksmart.data_export_schedule" */
  data_export_schedule: Array<Data_Export_Schedule>;
  /** fetch aggregated fields from the table: "risksmart.data_export_schedule" */
  data_export_schedule_aggregate: Data_Export_Schedule_Aggregate;
  /** fetch data from the table: "risksmart.data_export_schedule_audit" */
  data_export_schedule_audit: Array<Data_Export_Schedule_Audit>;
  /** fetch data from the table: "risksmart.data_export_schedule_audit" using primary key columns */
  data_export_schedule_audit_by_pk?: Maybe<Data_Export_Schedule_Audit>;
  /** fetch data from the table: "risksmart.data_export_schedule" using primary key columns */
  data_export_schedule_by_pk?: Maybe<Data_Export_Schedule>;
  /** fetch data from the table: "risksmart.data_export_schedule_execution" */
  data_export_schedule_execution: Array<Data_Export_Schedule_Execution>;
  /** fetch aggregated fields from the table: "risksmart.data_export_schedule_execution" */
  data_export_schedule_execution_aggregate: Data_Export_Schedule_Execution_Aggregate;
  /** fetch data from the table: "risksmart.data_export_schedule_execution" using primary key columns */
  data_export_schedule_execution_by_pk?: Maybe<Data_Export_Schedule_Execution>;
  /** fetch data from the table: "risksmart.data_import" */
  data_import: Array<Data_Import>;
  /** fetch aggregated fields from the table: "risksmart.data_import" */
  data_import_aggregate: Data_Import_Aggregate;
  /** fetch data from the table: "risksmart.data_import" using primary key columns */
  data_import_by_pk?: Maybe<Data_Import>;
  /** fetch data from the table: "risksmart.data_import_error" */
  data_import_error: Array<Data_Import_Error>;
  /** fetch aggregated fields from the table: "risksmart.data_import_error" */
  data_import_error_aggregate: Data_Import_Error_Aggregate;
  /** fetch data from the table: "risksmart.data_import_error" using primary key columns */
  data_import_error_by_pk?: Maybe<Data_Import_Error>;
  /** fetch data from the table: "risksmart.department_audit" */
  department_audit: Array<Department_Audit>;
  /** fetch data from the table: "risksmart.department_audit" using primary key columns */
  department_audit_by_pk?: Maybe<Department_Audit>;
  /** fetch data from the table: "risksmart.department_type" */
  department_type: Array<Department_Type>;
  /** fetch data from the table: "risksmart.department_type_audit" */
  department_type_audit: Array<Department_Type_Audit>;
  /** fetch data from the table: "risksmart.department_type_audit" using primary key columns */
  department_type_audit_by_pk?: Maybe<Department_Type_Audit>;
  /** fetch data from the table: "risksmart.department_type" using primary key columns */
  department_type_by_pk?: Maybe<Department_Type>;
  /** fetch data from the table: "risksmart.department_type_group" */
  department_type_group: Array<Department_Type_Group>;
  /** fetch data from the table: "risksmart.department_type_group_audit" */
  department_type_group_audit: Array<Department_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.department_type_group_audit" using primary key columns */
  department_type_group_audit_by_pk?: Maybe<Department_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.document" */
  document: Array<Document>;
  /** fetch data from the table: "risksmart.document_assessment_result" */
  document_assessment_result: Array<Document_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_assessment_result" */
  document_assessment_result_aggregate: Document_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_assessment_result_audit" */
  document_assessment_result_audit: Array<Document_Assessment_Result_Audit>;
  /** fetch aggregated fields from the table: "risksmart.document_assessment_result_audit" */
  document_assessment_result_audit_aggregate: Document_Assessment_Result_Audit_Aggregate;
  /** fetch data from the table: "risksmart.document_assessment_result_audit" using primary key columns */
  document_assessment_result_audit_by_pk?: Maybe<Document_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.document_assessment_result" using primary key columns */
  document_assessment_result_by_pk?: Maybe<Document_Assessment_Result>;
  /** fetch data from the table: "risksmart.document_audit" */
  document_audit: Array<Document_Audit>;
  /** fetch data from the table: "risksmart.document_audit" using primary key columns */
  document_audit_by_pk?: Maybe<Document_Audit>;
  /** fetch data from the table: "risksmart.document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "risksmart.document_file" */
  document_file: Array<Document_File>;
  /** fetch data from the table: "risksmart.document_file_audit" */
  document_file_audit: Array<Document_File_Audit>;
  /** fetch data from the table: "risksmart.document_file_audit" using primary key columns */
  document_file_audit_by_pk?: Maybe<Document_File_Audit>;
  /** fetch data from the table: "risksmart.document_file" using primary key columns */
  document_file_by_pk?: Maybe<Document_File>;
  /** fetch data from the table: "risksmart.document_internal_audit_result" */
  document_internal_audit_result: Array<Document_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_internal_audit_result" */
  document_internal_audit_result_aggregate: Document_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_internal_audit_result" using primary key columns */
  document_internal_audit_result_by_pk?: Maybe<Document_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.document_linked_document" */
  document_linked_document: Array<Document_Linked_Document>;
  /** fetch data from the table: "risksmart.document_linked_document_audit" */
  document_linked_document_audit: Array<Document_Linked_Document_Audit>;
  /** fetch data from the table: "risksmart.document_linked_document_audit" using primary key columns */
  document_linked_document_audit_by_pk?: Maybe<Document_Linked_Document_Audit>;
  /** fetch data from the table: "risksmart.document_linked_document" using primary key columns */
  document_linked_document_by_pk?: Maybe<Document_Linked_Document>;
  /** fetch data from the table: "risksmart.document_second_line_result" */
  document_second_line_result: Array<Document_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_second_line_result" */
  document_second_line_result_aggregate: Document_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_second_line_result" using primary key columns */
  document_second_line_result_by_pk?: Maybe<Document_Second_Line_Result>;
  /** fetch data from the table: "risksmart.enterprise_risk" */
  enterprise_risk: Array<Enterprise_Risk>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk" */
  enterprise_risk_aggregate: Enterprise_Risk_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk" using primary key columns */
  enterprise_risk_by_pk?: Maybe<Enterprise_Risk>;
  /** fetch data from the table: "risksmart.enterprise_risk_instance" */
  enterprise_risk_instance: Array<Enterprise_Risk_Instance>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk_instance" */
  enterprise_risk_instance_aggregate: Enterprise_Risk_Instance_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk_instance" using primary key columns */
  enterprise_risk_instance_by_pk?: Maybe<Enterprise_Risk_Instance>;
  /** fetch data from the table: "risksmart.enterprise_risk_score" */
  enterprise_risk_score: Array<Enterprise_Risk_Score>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk_score" */
  enterprise_risk_score_aggregate: Enterprise_Risk_Score_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk_score" using primary key columns */
  enterprise_risk_score_by_pk?: Maybe<Enterprise_Risk_Score>;
  /** fetch data from the table: "risksmart.entity" */
  entity: Array<Entity>;
  /** fetch aggregated fields from the table: "risksmart.entity" */
  entity_aggregate: Entity_Aggregate;
  /** fetch data from the table: "risksmart.entity" using primary key columns */
  entity_by_pk?: Maybe<Entity>;
  /** fetch data from the table: "risksmart.file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "risksmart.file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "risksmart.file_audit" */
  file_audit: Array<File_Audit>;
  /** fetch data from the table: "risksmart.file_audit" using primary key columns */
  file_audit_by_pk?: Maybe<File_Audit>;
  /** fetch data from the table: "risksmart.file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table: "risksmart.form_configuration" */
  form_configuration: Array<Form_Configuration>;
  /** fetch data from the table: "risksmart.form_configuration_audit" */
  form_configuration_audit: Array<Form_Configuration_Audit>;
  /** fetch data from the table: "risksmart.form_field_configuration" */
  form_field_configuration: Array<Form_Field_Configuration>;
  /** fetch data from the table: "risksmart.form_field_configuration_audit" */
  form_field_configuration_audit: Array<Form_Field_Configuration_Audit>;
  /** fetch data from the table: "risksmart.form_field_ordering" */
  form_field_ordering: Array<Form_Field_Ordering>;
  /** fetch data from the table: "risksmart.form_field_ordering_audit" */
  form_field_ordering_audit: Array<Form_Field_Ordering_Audit>;
  getScimConfig: GetScimConfigOutput;
  /** fetch data from the table: "risksmart.impact" */
  impact: Array<Impact>;
  /** fetch aggregated fields from the table: "risksmart.impact" */
  impact_aggregate: Impact_Aggregate;
  /** fetch data from the table: "risksmart.impact_audit" */
  impact_audit: Array<Impact_Audit>;
  /** fetch data from the table: "risksmart.impact_audit" using primary key columns */
  impact_audit_by_pk?: Maybe<Impact_Audit>;
  /** fetch data from the table: "risksmart.impact" using primary key columns */
  impact_by_pk?: Maybe<Impact>;
  /** fetch data from the table: "risksmart.impact_internal_audit_rating" */
  impact_internal_audit_rating: Array<Impact_Internal_Audit_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_internal_audit_rating" */
  impact_internal_audit_rating_aggregate: Impact_Internal_Audit_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_internal_audit_rating" using primary key columns */
  impact_internal_audit_rating_by_pk?: Maybe<Impact_Internal_Audit_Rating>;
  /** fetch data from the table: "risksmart.impact_parent" */
  impact_parent: Array<Impact_Parent>;
  /** fetch aggregated fields from the table: "risksmart.impact_parent" */
  impact_parent_aggregate: Impact_Parent_Aggregate;
  /** fetch data from the table: "risksmart.impact_parent_audit" */
  impact_parent_audit: Array<Impact_Parent_Audit>;
  /** fetch data from the table: "risksmart.impact_parent_audit" using primary key columns */
  impact_parent_audit_by_pk?: Maybe<Impact_Parent_Audit>;
  /** fetch data from the table: "risksmart.impact_parent" using primary key columns */
  impact_parent_by_pk?: Maybe<Impact_Parent>;
  /** fetch data from the table: "risksmart.impact_rating" */
  impact_rating: Array<Impact_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_rating" */
  impact_rating_aggregate: Impact_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_rating_audit" */
  impact_rating_audit: Array<Impact_Rating_Audit>;
  /** fetch data from the table: "risksmart.impact_rating_audit" using primary key columns */
  impact_rating_audit_by_pk?: Maybe<Impact_Rating_Audit>;
  /** fetch data from the table: "risksmart.impact_rating" using primary key columns */
  impact_rating_by_pk?: Maybe<Impact_Rating>;
  /** fetch data from the table: "risksmart.impact_second_line_rating" */
  impact_second_line_rating: Array<Impact_Second_Line_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_second_line_rating" */
  impact_second_line_rating_aggregate: Impact_Second_Line_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_second_line_rating" using primary key columns */
  impact_second_line_rating_by_pk?: Maybe<Impact_Second_Line_Rating>;
  /** fetch data from the table: "risksmart.indicator" */
  indicator: Array<Indicator>;
  /** fetch data from the table: "risksmart.indicator_audit" */
  indicator_audit: Array<Indicator_Audit>;
  /** fetch data from the table: "risksmart.indicator_audit" using primary key columns */
  indicator_audit_by_pk?: Maybe<Indicator_Audit>;
  /** fetch data from the table: "risksmart.indicator" using primary key columns */
  indicator_by_pk?: Maybe<Indicator>;
  /** fetch data from the table: "risksmart.indicator_parent" */
  indicator_parent: Array<Indicator_Parent>;
  /** fetch aggregated fields from the table: "risksmart.indicator_parent" */
  indicator_parent_aggregate: Indicator_Parent_Aggregate;
  /** fetch data from the table: "risksmart.indicator_parent" using primary key columns */
  indicator_parent_by_pk?: Maybe<Indicator_Parent>;
  /** fetch data from the table: "risksmart.indicator_result" */
  indicator_result: Array<Indicator_Result>;
  /** fetch data from the table: "risksmart.indicator_result_audit" */
  indicator_result_audit: Array<Indicator_Result_Audit>;
  /** fetch data from the table: "risksmart.indicator_result_audit" using primary key columns */
  indicator_result_audit_by_pk?: Maybe<Indicator_Result_Audit>;
  /** fetch data from the table: "risksmart.indicator_result" using primary key columns */
  indicator_result_by_pk?: Maybe<Indicator_Result>;
  /** fetch data from the table: "risksmart.indicator_type" */
  indicator_type: Array<Indicator_Type>;
  /** fetch data from the table: "risksmart.indicator_type" using primary key columns */
  indicator_type_by_pk?: Maybe<Indicator_Type>;
  /** fetch data from the table: "risksmart.internal_audit_entity" */
  internal_audit_entity: Array<Internal_Audit_Entity>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_entity" */
  internal_audit_entity_aggregate: Internal_Audit_Entity_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_entity" using primary key columns */
  internal_audit_entity_by_pk?: Maybe<Internal_Audit_Entity>;
  /** fetch data from the table: "risksmart.internal_audit_report" */
  internal_audit_report: Array<Internal_Audit_Report>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_report" */
  internal_audit_report_aggregate: Internal_Audit_Report_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_report" using primary key columns */
  internal_audit_report_by_pk?: Maybe<Internal_Audit_Report>;
  /** fetch data from the table: "risksmart.internal_audit_result_parent" */
  internal_audit_result_parent: Array<Internal_Audit_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_result_parent" */
  internal_audit_result_parent_aggregate: Internal_Audit_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_result_parent" using primary key columns */
  internal_audit_result_parent_by_pk?: Maybe<Internal_Audit_Result_Parent>;
  /** fetch data from the table: "risksmart.issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "risksmart.issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "risksmart.issue_assessment" */
  issue_assessment: Array<Issue_Assessment>;
  /** fetch aggregated fields from the table: "risksmart.issue_assessment" */
  issue_assessment_aggregate: Issue_Assessment_Aggregate;
  /** fetch data from the table: "risksmart.issue_assessment_audit" */
  issue_assessment_audit: Array<Issue_Assessment_Audit>;
  /** fetch data from the table: "risksmart.issue_assessment_audit" using primary key columns */
  issue_assessment_audit_by_pk?: Maybe<Issue_Assessment_Audit>;
  /** fetch data from the table: "risksmart.issue_assessment" using primary key columns */
  issue_assessment_by_pk?: Maybe<Issue_Assessment>;
  /** fetch data from the table: "risksmart.issue_audit" */
  issue_audit: Array<Issue_Audit>;
  /** fetch data from the table: "risksmart.issue_audit" using primary key columns */
  issue_audit_by_pk?: Maybe<Issue_Audit>;
  /** fetch data from the table: "risksmart.issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table: "risksmart.issue_parent" */
  issue_parent: Array<Issue_Parent>;
  /** fetch aggregated fields from the table: "risksmart.issue_parent" */
  issue_parent_aggregate: Issue_Parent_Aggregate;
  /** fetch data from the table: "risksmart.issue_parent_audit" */
  issue_parent_audit: Array<Issue_Parent_Audit>;
  /** fetch data from the table: "risksmart.issue_parent_audit" using primary key columns */
  issue_parent_audit_by_pk?: Maybe<Issue_Parent_Audit>;
  /** fetch data from the table: "risksmart.issue_parent" using primary key columns */
  issue_parent_by_pk?: Maybe<Issue_Parent>;
  /** fetch data from the table: "risksmart.issue_update" */
  issue_update: Array<Issue_Update>;
  /** fetch data from the table: "risksmart.issue_update_audit" */
  issue_update_audit: Array<Issue_Update_Audit>;
  /** fetch data from the table: "risksmart.issue_update_audit" using primary key columns */
  issue_update_audit_by_pk?: Maybe<Issue_Update_Audit>;
  /** fetch data from the table: "risksmart.issue_update" using primary key columns */
  issue_update_by_pk?: Maybe<Issue_Update>;
  /** fetch data from the table: "risksmart.issue_update_summary_view" */
  issue_update_summary: Array<Issue_Update_Summary>;
  /** fetch aggregated fields from the table: "risksmart.issue_update_summary_view" */
  issue_update_summary_aggregate: Issue_Update_Summary_Aggregate;
  /** fetch data from the table: "risksmart.linked_item" */
  linked_item: Array<Linked_Item>;
  /** fetch data from the table: "risksmart.linked_item" using primary key columns */
  linked_item_by_pk?: Maybe<Linked_Item>;
  /** fetch data from the table: "risksmart.node" */
  node: Array<Node>;
  /** fetch aggregated fields from the table: "risksmart.node" */
  node_aggregate: Node_Aggregate;
  /** fetch data from the table: "risksmart.node" using primary key columns */
  node_by_pk?: Maybe<Node>;
  notificationPreferences: NotificationPreferencesOutput;
  /** fetch data from the table: "risksmart.obligation" */
  obligation: Array<Obligation>;
  /** fetch aggregated fields from the table: "risksmart.obligation" */
  obligation_aggregate: Obligation_Aggregate;
  /** fetch data from the table: "risksmart.obligation_assessment_result" */
  obligation_assessment_result: Array<Obligation_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_assessment_result" */
  obligation_assessment_result_aggregate: Obligation_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_assessment_result_audit" */
  obligation_assessment_result_audit: Array<Obligation_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.obligation_assessment_result_audit" using primary key columns */
  obligation_assessment_result_audit_by_pk?: Maybe<Obligation_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.obligation_assessment_result" using primary key columns */
  obligation_assessment_result_by_pk?: Maybe<Obligation_Assessment_Result>;
  /** fetch data from the table: "risksmart.obligation_assessment_status" */
  obligation_assessment_status: Array<Obligation_Assessment_Status>;
  /** fetch data from the table: "risksmart.obligation_assessment_status" using primary key columns */
  obligation_assessment_status_by_pk?: Maybe<Obligation_Assessment_Status>;
  /** fetch data from the table: "risksmart.obligation_audit" */
  obligation_audit: Array<Obligation_Audit>;
  /** fetch aggregated fields from the table: "risksmart.obligation_audit" */
  obligation_audit_aggregate: Obligation_Audit_Aggregate;
  /** fetch data from the table: "risksmart.obligation_audit" using primary key columns */
  obligation_audit_by_pk?: Maybe<Obligation_Audit>;
  /** fetch data from the table: "risksmart.obligation" using primary key columns */
  obligation_by_pk?: Maybe<Obligation>;
  /** fetch data from the table: "risksmart.obligation_change" */
  obligation_change: Array<Obligation_Change>;
  /** fetch data from the table: "risksmart.obligation_change_attestation" */
  obligation_change_attestation: Array<Obligation_Change_Attestation>;
  /** fetch data from the table: "risksmart.obligation_change_attestation" using primary key columns */
  obligation_change_attestation_by_pk?: Maybe<Obligation_Change_Attestation>;
  /** fetch data from the table: "risksmart.obligation_change" using primary key columns */
  obligation_change_by_pk?: Maybe<Obligation_Change>;
  /** fetch data from the table: "risksmart.obligation_impact" */
  obligation_impact: Array<Obligation_Impact>;
  /** fetch data from the table: "risksmart.obligation_impact_audit" */
  obligation_impact_audit: Array<Obligation_Impact_Audit>;
  /** fetch data from the table: "risksmart.obligation_impact_audit" using primary key columns */
  obligation_impact_audit_by_pk?: Maybe<Obligation_Impact_Audit>;
  /** fetch data from the table: "risksmart.obligation_impact" using primary key columns */
  obligation_impact_by_pk?: Maybe<Obligation_Impact>;
  /** fetch data from the table: "risksmart.obligation_internal_audit_result" */
  obligation_internal_audit_result: Array<Obligation_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_internal_audit_result" */
  obligation_internal_audit_result_aggregate: Obligation_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_internal_audit_result" using primary key columns */
  obligation_internal_audit_result_by_pk?: Maybe<Obligation_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.obligation_second_line_result" */
  obligation_second_line_result: Array<Obligation_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_second_line_result" */
  obligation_second_line_result_aggregate: Obligation_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_second_line_result" using primary key columns */
  obligation_second_line_result_by_pk?: Maybe<Obligation_Second_Line_Result>;
  /** fetch data from the table: "risksmart.obligation_type" */
  obligation_type: Array<Obligation_Type>;
  /** fetch data from the table: "risksmart.obligation_type" using primary key columns */
  obligation_type_by_pk?: Maybe<Obligation_Type>;
  /** fetch data from the table: "risksmart.organisation_module" */
  organisation_module: Array<Organisation_Module>;
  /** fetch data from the table: "risksmart.organisation_tab_preference" */
  organisation_tab_preference: Array<Organisation_Tab_Preference>;
  /** fetch data from the table: "risksmart.owner_audit" */
  owner_audit: Array<Owner_Audit>;
  /** fetch data from the table: "risksmart.owner_audit" using primary key columns */
  owner_audit_by_pk?: Maybe<Owner_Audit>;
  /** fetch data from the table: "risksmart.owner_group_audit" */
  owner_group_audit: Array<Owner_Group_Audit>;
  /** fetch data from the table: "risksmart.owner_group_audit" using primary key columns */
  owner_group_audit_by_pk?: Maybe<Owner_Group_Audit>;
  /** fetch data from the table: "risksmart.questionnaire_invite" */
  questionnaire_invite: Array<Questionnaire_Invite>;
  /** fetch data from the table: "risksmart.questionnaire_invite" using primary key columns */
  questionnaire_invite_by_pk?: Maybe<Questionnaire_Invite>;
  /** fetch data from the table: "risksmart.questionnaire_template" */
  questionnaire_template: Array<Questionnaire_Template>;
  /** fetch data from the table: "risksmart.questionnaire_template" using primary key columns */
  questionnaire_template_by_pk?: Maybe<Questionnaire_Template>;
  /** fetch data from the table: "risksmart.questionnaire_template_version" */
  questionnaire_template_version: Array<Questionnaire_Template_Version>;
  /** fetch data from the table: "risksmart.questionnaire_template_version" using primary key columns */
  questionnaire_template_version_by_pk?: Maybe<Questionnaire_Template_Version>;
  /** fetch data from the table: "risksmart.questionnaire_template_version_status" */
  questionnaire_template_version_status: Array<Questionnaire_Template_Version_Status>;
  /** fetch data from the table: "risksmart.questionnaire_template_version_status" using primary key columns */
  questionnaire_template_version_status_by_pk?: Maybe<Questionnaire_Template_Version_Status>;
  /** fetch data from the table: "risksmart.relation_file" */
  relation_file: Array<Relation_File>;
  /** fetch aggregated fields from the table: "risksmart.relation_file" */
  relation_file_aggregate: Relation_File_Aggregate;
  /** fetch data from the table: "risksmart.relation_file_audit" */
  relation_file_audit: Array<Relation_File_Audit>;
  /** fetch data from the table: "risksmart.relation_file" using primary key columns */
  relation_file_by_pk?: Maybe<Relation_File>;
  reportingData?: Maybe<Array<Array<ReportField>>>;
  reportingFilterOptions: Array<ReportingFilterOption>;
  /** fetch data from the table: "risksmart.risk" */
  risk: Array<Risk>;
  /** fetch aggregated fields from the table: "risksmart.risk" */
  risk_aggregate: Risk_Aggregate;
  /** fetch data from the table: "risksmart.risk_assessment_result" */
  risk_assessment_result: Array<Risk_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_assessment_result" */
  risk_assessment_result_aggregate: Risk_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_assessment_result_audit" */
  risk_assessment_result_audit: Array<Risk_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_audit" using primary key columns */
  risk_assessment_result_audit_by_pk?: Maybe<Risk_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result" using primary key columns */
  risk_assessment_result_by_pk?: Maybe<Risk_Assessment_Result>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config" */
  risk_assessment_result_config: Array<Risk_Assessment_Result_Config>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config_audit" */
  risk_assessment_result_config_audit: Array<Risk_Assessment_Result_Config_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config" using primary key columns */
  risk_assessment_result_config_by_pk?: Maybe<Risk_Assessment_Result_Config>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact" */
  risk_assessment_result_impact: Array<Risk_Assessment_Result_Impact>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact_audit" */
  risk_assessment_result_impact_audit: Array<Risk_Assessment_Result_Impact_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact" using primary key columns */
  risk_assessment_result_impact_by_pk?: Maybe<Risk_Assessment_Result_Impact>;
  /** fetch data from the table: "risksmart.risk_audit" */
  risk_audit: Array<Risk_Audit>;
  /** fetch aggregated fields from the table: "risksmart.risk_audit" */
  risk_audit_aggregate: Risk_Audit_Aggregate;
  /** fetch data from the table: "risksmart.risk_audit" using primary key columns */
  risk_audit_by_pk?: Maybe<Risk_Audit>;
  /** fetch data from the table: "risksmart.risk" using primary key columns */
  risk_by_pk?: Maybe<Risk>;
  /** fetch data from the table: "risksmart.risk_controlled_internal_audit_result" */
  risk_controlled_internal_audit_result: Array<Risk_Controlled_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_controlled_internal_audit_result" */
  risk_controlled_internal_audit_result_aggregate: Risk_Controlled_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_controlled_internal_audit_result" using primary key columns */
  risk_controlled_internal_audit_result_by_pk?: Maybe<Risk_Controlled_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.risk_controlled_second_line_result" */
  risk_controlled_second_line_result: Array<Risk_Controlled_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_controlled_second_line_result" */
  risk_controlled_second_line_result_aggregate: Risk_Controlled_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_controlled_second_line_result" using primary key columns */
  risk_controlled_second_line_result_by_pk?: Maybe<Risk_Controlled_Second_Line_Result>;
  /** fetch data from the table: "risksmart.risk_score" */
  risk_score: Array<Risk_Score>;
  /** fetch aggregated fields from the table: "risksmart.risk_score" */
  risk_score_aggregate: Risk_Score_Aggregate;
  /** fetch data from the table: "risksmart.risk_score" using primary key columns */
  risk_score_by_pk?: Maybe<Risk_Score>;
  /** fetch data from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  risk_uncontrolled_internal_audit_result: Array<Risk_Uncontrolled_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  risk_uncontrolled_internal_audit_result_aggregate: Risk_Uncontrolled_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_uncontrolled_internal_audit_result" using primary key columns */
  risk_uncontrolled_internal_audit_result_by_pk?: Maybe<Risk_Uncontrolled_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.risk_uncontrolled_second_line_result" */
  risk_uncontrolled_second_line_result: Array<Risk_Uncontrolled_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_uncontrolled_second_line_result" */
  risk_uncontrolled_second_line_result_aggregate: Risk_Uncontrolled_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_uncontrolled_second_line_result" using primary key columns */
  risk_uncontrolled_second_line_result_by_pk?: Maybe<Risk_Uncontrolled_Second_Line_Result>;
  /** fetch data from the table: "risksmart.indicator_parent_audit" */
  risksmart_indicator_parent_audit: Array<Risksmart_Indicator_Parent_Audit>;
  /** fetch data from the table: "risksmart.indicator_parent_audit" using primary key columns */
  risksmart_indicator_parent_audit_by_pk?: Maybe<Risksmart_Indicator_Parent_Audit>;
  /** fetch data from the table: "risksmart.linked_item_audit" */
  risksmart_linked_item_audit: Array<Risksmart_Linked_Item_Audit>;
  /** fetch data from the table: "risksmart.linked_item_audit" using primary key columns */
  risksmart_linked_item_audit_by_pk?: Maybe<Risksmart_Linked_Item_Audit>;
  /** fetch data from the table: "risksmart.role_access" */
  role_access: Array<Role_Access>;
  /** fetch data from the table: "risksmart.second_line_result_parent" */
  second_line_result_parent: Array<Second_Line_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.second_line_result_parent" */
  second_line_result_parent_aggregate: Second_Line_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.second_line_result_parent" using primary key columns */
  second_line_result_parent_by_pk?: Maybe<Second_Line_Result_Parent>;
  slackNotificationConnection: SlackNotificationConnectionOutput;
  /** fetch data from the table: "risksmart.tab" */
  tab: Array<Tab>;
  /** fetch data from the table: "risksmart.tab" using primary key columns */
  tab_by_pk?: Maybe<Tab>;
  /** fetch data from the table: "risksmart.tag_type" */
  tag_type: Array<Tag_Type>;
  /** fetch data from the table: "risksmart.tag_type_audit" */
  tag_type_audit: Array<Tag_Type_Audit>;
  /** fetch data from the table: "risksmart.tag_type_audit" using primary key columns */
  tag_type_audit_by_pk?: Maybe<Tag_Type_Audit>;
  /** fetch data from the table: "risksmart.tag_type" using primary key columns */
  tag_type_by_pk?: Maybe<Tag_Type>;
  /** fetch data from the table: "risksmart.tag_type_group" */
  tag_type_group: Array<Tag_Type_Group>;
  /** fetch data from the table: "risksmart.tag_type_group_audit" */
  tag_type_group_audit: Array<Tag_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.tag_type_group_audit" using primary key columns */
  tag_type_group_audit_by_pk?: Maybe<Tag_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.taxonomy" */
  taxonomy: Array<Taxonomy>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy" */
  taxonomy_aggregate: Taxonomy_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_audit" */
  taxonomy_audit: Array<Taxonomy_Audit>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy_audit" */
  taxonomy_audit_aggregate: Taxonomy_Audit_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_audit" using primary key columns */
  taxonomy_audit_by_pk?: Maybe<Taxonomy_Audit>;
  /** fetch data from the table: "risksmart.taxonomy" using primary key columns */
  taxonomy_by_pk?: Maybe<Taxonomy>;
  /** fetch data from the table: "risksmart.taxonomy_org" */
  taxonomy_org: Array<Taxonomy_Org>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy_org" */
  taxonomy_org_aggregate: Taxonomy_Org_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_org" using primary key columns */
  taxonomy_org_by_pk?: Maybe<Taxonomy_Org>;
  /** fetch data from the table: "risksmart.test_result" */
  test_result: Array<Test_Result>;
  /** fetch aggregated fields from the table: "risksmart.test_result" */
  test_result_aggregate: Test_Result_Aggregate;
  /** fetch data from the table: "risksmart.test_result_audit" */
  test_result_audit: Array<Test_Result_Audit>;
  /** fetch data from the table: "risksmart.test_result_audit" using primary key columns */
  test_result_audit_by_pk?: Maybe<Test_Result_Audit>;
  /** fetch data from the table: "risksmart.test_result" using primary key columns */
  test_result_by_pk?: Maybe<Test_Result>;
  /** fetch data from the table: "risksmart.third_party" */
  third_party: Array<Third_Party>;
  /** fetch data from the table: "risksmart.third_party" using primary key columns */
  third_party_by_pk?: Maybe<Third_Party>;
  /** fetch data from the table: "risksmart.third_party_contact" */
  third_party_contact: Array<Third_Party_Contact>;
  /** fetch data from the table: "risksmart.third_party_contact_audit" */
  third_party_contact_audit: Array<Third_Party_Contact_Audit>;
  /** fetch data from the table: "risksmart.third_party_contact_audit" using primary key columns */
  third_party_contact_audit_by_pk?: Maybe<Third_Party_Contact_Audit>;
  /** fetch data from the table: "risksmart.third_party_contact" using primary key columns */
  third_party_contact_by_pk?: Maybe<Third_Party_Contact>;
  /** fetch data from the table: "risksmart.third_party_response" */
  third_party_response: Array<Third_Party_Response>;
  /** fetch data from the table: "risksmart.third_party_response" using primary key columns */
  third_party_response_by_pk?: Maybe<Third_Party_Response>;
  /** fetch data from the table: "risksmart.third_party_response_status" */
  third_party_response_status: Array<Third_Party_Response_Status>;
  /** fetch data from the table: "risksmart.third_party_response_status" using primary key columns */
  third_party_response_status_by_pk?: Maybe<Third_Party_Response_Status>;
  /** fetch data from the table: "risksmart.user_view_active" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "risksmart.user_view_active" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "risksmart.user_group" */
  user_group: Array<User_Group>;
  /** fetch data from the table: "risksmart.user_group_audit" */
  user_group_audit: Array<User_Group_Audit>;
  /** fetch data from the table: "risksmart.user_group_audit" using primary key columns */
  user_group_audit_by_pk?: Maybe<User_Group_Audit>;
  /** fetch data from the table: "risksmart.user_group" using primary key columns */
  user_group_by_pk?: Maybe<User_Group>;
  /** fetch data from the table: "risksmart.user_group_user" */
  user_group_user: Array<User_Group_User>;
  /** fetch aggregated fields from the table: "risksmart.user_group_user" */
  user_group_user_aggregate: User_Group_User_Aggregate;
  /** fetch data from the table: "risksmart.user_group_user_audit" */
  user_group_user_audit: Array<User_Group_User_Audit>;
  /** fetch data from the table: "risksmart.user_group_user_audit" using primary key columns */
  user_group_user_audit_by_pk?: Maybe<User_Group_User_Audit>;
  /** fetch data from the table: "risksmart.user_group_user" using primary key columns */
  user_group_user_by_pk?: Maybe<User_Group_User>;
  /** fetch data from the table: "auth.user_role_audit" */
  user_role_audit: Array<User_Role_Audit>;
  /** fetch data from the table: "auth.user_role_audit" using primary key columns */
  user_role_audit_by_pk?: Maybe<User_Role_Audit>;
  /** fetch data from the table: "risksmart.user_search_preferences" */
  user_search_preferences: Array<User_Search_Preferences>;
  /** fetch data from the table: "risksmart.user_search_preferences_audit" */
  user_search_preferences_audit: Array<User_Search_Preferences_Audit>;
  /** fetch data from the table: "risksmart.user_tab_preference" */
  user_tab_preference: Array<User_Tab_Preference>;
  /** fetch data from the table: "risksmart.user_table_preferences" */
  user_table_preferences: Array<User_Table_Preferences>;
  /** fetch data from the table: "risksmart.wizard" */
  wizard: Array<Wizard>;
  /** fetch data from the table: "risksmart.wizard" using primary key columns */
  wizard_by_pk?: Maybe<Wizard>;
};


export type Query_RootAcceptanceArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Order_By>>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};


export type Query_RootAcceptance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Order_By>>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};


export type Query_RootAcceptance_AuditArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Audit_Order_By>>;
  where?: InputMaybe<Acceptance_Audit_Bool_Exp>;
};


export type Query_RootAcceptance_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAcceptance_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAcceptance_ParentArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


export type Query_RootAcceptance_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


export type Query_RootAcceptance_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Audit_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
};


export type Query_RootAcceptance_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAcceptance_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootActionArgs = {
  distinct_on?: InputMaybe<Array<Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Order_By>>;
  where?: InputMaybe<Action_Bool_Exp>;
};


export type Query_RootAction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Order_By>>;
  where?: InputMaybe<Action_Bool_Exp>;
};


export type Query_RootAction_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Audit_Order_By>>;
  where?: InputMaybe<Action_Audit_Bool_Exp>;
};


export type Query_RootAction_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Audit_Order_By>>;
  where?: InputMaybe<Action_Audit_Bool_Exp>;
};


export type Query_RootAction_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAction_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAction_ParentArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


export type Query_RootAction_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


export type Query_RootAction_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Audit_Order_By>>;
  where?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
};


export type Query_RootAction_Parent_Audit_By_PkArgs = {
  ActionId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAction_Parent_By_PkArgs = {
  ActionId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAction_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


export type Query_RootAction_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


export type Query_RootAction_Update_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Audit_Order_By>>;
  where?: InputMaybe<Action_Update_Audit_Bool_Exp>;
};


export type Query_RootAction_Update_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAction_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAction_Update_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Summary_Order_By>>;
  where?: InputMaybe<Action_Update_Summary_Bool_Exp>;
};


export type Query_RootAction_Update_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Summary_Order_By>>;
  where?: InputMaybe<Action_Update_Summary_Bool_Exp>;
};


export type Query_RootAggregation_OrgArgs = {
  distinct_on?: InputMaybe<Array<Aggregation_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregation_Org_Order_By>>;
  where?: InputMaybe<Aggregation_Org_Bool_Exp>;
};


export type Query_RootAggregation_Org_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
};


export type Query_RootAncestor_ContributorArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


export type Query_RootAppetiteArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


export type Query_RootAppetite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


export type Query_RootAppetite_AuditArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Audit_Bool_Exp>;
};


export type Query_RootAppetite_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAppetite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAppetite_ParentArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


export type Query_RootAppetite_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


export type Query_RootAppetite_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


export type Query_RootAppetite_Parent_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


export type Query_RootAppetite_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAppetite_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootApprovalArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Query_RootApproval_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approval_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Audit_Order_By>>;
  where?: InputMaybe<Approval_Audit_Bool_Exp>;
};


export type Query_RootApproval_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootApproval_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootApproval_LevelArgs = {
  distinct_on?: InputMaybe<Array<Approval_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Level_Order_By>>;
  where?: InputMaybe<Approval_Level_Bool_Exp>;
};


export type Query_RootApproval_Level_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approval_Level_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Level_Audit_Order_By>>;
  where?: InputMaybe<Approval_Level_Audit_Bool_Exp>;
};


export type Query_RootApproval_Level_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootApproval_Level_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootApproverArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


export type Query_RootApprover_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


export type Query_RootApprover_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approver_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Audit_Order_By>>;
  where?: InputMaybe<Approver_Audit_Bool_Exp>;
};


export type Query_RootApprover_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootApprover_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAssessmentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Query_RootAssessment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


export type Query_RootAssessment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


export type Query_RootAssessment_Activity_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Audit_Bool_Exp>;
};


export type Query_RootAssessment_Activity_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAssessment_Activity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Query_RootAssessment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Audit_Bool_Exp>;
};


export type Query_RootAssessment_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Audit_Bool_Exp>;
};


export type Query_RootAssessment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootAssessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


export type Query_RootAssessment_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


export type Query_RootAssessment_Result_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
};


export type Query_RootAssessment_Result_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAssessment_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAttestation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Config_Order_By>>;
  where?: InputMaybe<Attestation_Config_Bool_Exp>;
};


export type Query_RootAttestation_Config_By_PkArgs = {
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootAttestation_CycleArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Cycle_Order_By>>;
  where?: InputMaybe<Attestation_Cycle_Bool_Exp>;
};


export type Query_RootAttestation_Cycle_AuditArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Cycle_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Cycle_Audit_Order_By>>;
  where?: InputMaybe<Attestation_Cycle_Audit_Bool_Exp>;
};


export type Query_RootAttestation_Cycle_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAttestation_GroupArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Group_Order_By>>;
  where?: InputMaybe<Attestation_Group_Bool_Exp>;
};


export type Query_RootAttestation_Group_By_PkArgs = {
  ConfigId: Scalars['uuid']['input'];
  GroupId: Scalars['uuid']['input'];
};


export type Query_RootAttestation_RecordArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


export type Query_RootAttestation_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


export type Query_RootAttestation_Record_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootAudit_Log_ViewArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_View_Order_By>>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
};


export type Query_RootAudit_Log_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_View_Order_By>>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
};


export type Query_RootAuth_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisation_Order_By>>;
  where?: InputMaybe<Auth_Organisation_Bool_Exp>;
};


export type Query_RootAuth_Organisation_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
};


export type Query_RootAuth_OrganisationuserArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisationuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisationuser_Order_By>>;
  where?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};


export type Query_RootAuth_Organisationuser_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
  User_Id: Scalars['String']['input'];
};


export type Query_RootAuth_Role_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Resource_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Resource_Type_Bool_Exp>;
};


export type Query_RootAuth_Role_Resource_Type_By_PkArgs = {
  ResourceType: Parent_Type_Enum;
};


export type Query_RootAuth_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Type_Bool_Exp>;
};


export type Query_RootAuth_Role_Type_By_PkArgs = {
  RoleKey: Scalars['String']['input'];
};


export type Query_RootAuth_Role_Type_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
};


export type Query_RootAuth_Role_Type_Resource_Type_By_PkArgs = {
  ResourceType: Scalars['String']['input'];
  RoleKey: Scalars['String']['input'];
};


export type Query_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Query_RootAuth_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Query_RootAuth_User_By_PkArgs = {
  Id: Scalars['String']['input'];
};


export type Query_RootAuth_User_RoleArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Role_Order_By>>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};


export type Query_RootAuth_User_Role_By_PkArgs = {
  Id: Scalars['String']['input'];
};


export type Query_RootBusiness_AreaArgs = {
  distinct_on?: InputMaybe<Array<Business_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Area_Order_By>>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};


export type Query_RootBusiness_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Area_Order_By>>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};


export type Query_RootBusiness_Area_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCauseArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


export type Query_RootCause_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


export type Query_RootCause_AuditArgs = {
  distinct_on?: InputMaybe<Array<Cause_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Audit_Order_By>>;
  where?: InputMaybe<Cause_Audit_Bool_Exp>;
};


export type Query_RootCause_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootCause_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootChange_RequestArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


export type Query_RootChange_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


export type Query_RootChange_Request_AuditArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Audit_Order_By>>;
  where?: InputMaybe<Change_Request_Audit_Bool_Exp>;
};


export type Query_RootChange_Request_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootChange_Request_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootChange_Request_ContributorArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Contributor_Order_By>>;
  where?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
};


export type Query_RootChange_Request_Contributor_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootColour_PaletteArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Order_By>>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};


export type Query_RootColour_Palette_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Order_By>>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};


export type Query_RootColour_Palette_AuditArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Audit_Order_By>>;
  where?: InputMaybe<Colour_Palette_Audit_Bool_Exp>;
};


export type Query_RootColour_Palette_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Query_RootComment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Comment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Audit_Order_By>>;
  where?: InputMaybe<Comment_Audit_Bool_Exp>;
};


export type Query_RootComment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootComment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCompliance_Monitoring_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Monitoring_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Compliance_Monitoring_Assessment_Order_By>>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};


export type Query_RootCompliance_Monitoring_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Monitoring_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Compliance_Monitoring_Assessment_Order_By>>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};


export type Query_RootCompliance_Monitoring_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootConsequenceArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


export type Query_RootConsequence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


export type Query_RootConsequence_AuditArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Audit_Order_By>>;
  where?: InputMaybe<Consequence_Audit_Bool_Exp>;
};


export type Query_RootConsequence_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Audit_Order_By>>;
  where?: InputMaybe<Consequence_Audit_Bool_Exp>;
};


export type Query_RootConsequence_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootConsequence_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootControlArgs = {
  distinct_on?: InputMaybe<Array<Control_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Order_By>>;
  where?: InputMaybe<Control_Bool_Exp>;
};


export type Query_RootControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Order_By>>;
  where?: InputMaybe<Control_Bool_Exp>;
};


export type Query_RootControl_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Audit_Order_By>>;
  where?: InputMaybe<Control_Audit_Bool_Exp>;
};


export type Query_RootControl_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootControl_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootControl_GroupArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Order_By>>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};


export type Query_RootControl_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Order_By>>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};


export type Query_RootControl_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Audit_Order_By>>;
  where?: InputMaybe<Control_Group_Audit_Bool_Exp>;
};


export type Query_RootControl_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootControl_Group_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootControl_ParentArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


export type Query_RootControl_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


export type Query_RootControl_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Audit_Order_By>>;
  where?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
};


export type Query_RootControl_Parent_Audit_By_PkArgs = {
  ControlId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootControl_Parent_By_PkArgs = {
  ControlId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootControl_Test_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootControl_Test_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootControl_Test_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootControl_Test_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
};


export type Query_RootControl_Test_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
};


export type Query_RootControl_Test_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootConversationArgs = {
  distinct_on?: InputMaybe<Array<Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversation_Order_By>>;
  where?: InputMaybe<Conversation_Bool_Exp>;
};


export type Query_RootConversation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Conversation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversation_Audit_Order_By>>;
  where?: InputMaybe<Conversation_Audit_Bool_Exp>;
};


export type Query_RootConversation_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootConversation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Attribute_SchemaArgs = {
  distinct_on?: InputMaybe<Array<Custom_Attribute_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Attribute_Schema_Order_By>>;
  where?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
};


export type Query_RootCustom_Attribute_Schema_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Order_By>>;
  where?: InputMaybe<Custom_Attribute_Schema_Audit_Bool_Exp>;
};


export type Query_RootCustom_Attribute_Schema_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootCustom_Attribute_Schema_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Custom_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Datasource_Order_By>>;
  where?: InputMaybe<Custom_Datasource_Bool_Exp>;
};


export type Query_RootCustom_Datasource_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_RibbonArgs = {
  distinct_on?: InputMaybe<Array<Custom_Ribbon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Ribbon_Order_By>>;
  where?: InputMaybe<Custom_Ribbon_Bool_Exp>;
};


export type Query_RootCustom_Ribbon_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Ribbon_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Ribbon_Audit_Order_By>>;
  where?: InputMaybe<Custom_Ribbon_Audit_Bool_Exp>;
};


export type Query_RootCustom_Ribbon_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootCustom_Ribbon_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_RoleArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Order_By>>;
  where?: InputMaybe<Custom_Role_Bool_Exp>;
};


export type Query_RootCustom_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Order_By>>;
  where?: InputMaybe<Custom_Role_Bool_Exp>;
};


export type Query_RootCustom_Role_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


export type Query_RootCustom_Role_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


export type Query_RootCustom_Role_Assignment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Audit_Bool_Exp>;
};


export type Query_RootCustom_Role_Assignment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Role_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_Audit_Bool_Exp>;
};


export type Query_RootCustom_Role_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Role_UserArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


export type Query_RootCustom_Role_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


export type Query_RootCustom_Role_User_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Audit_Bool_Exp>;
};


export type Query_RootCustom_Role_User_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDashboardArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboard_Order_By>>;
  where?: InputMaybe<Dashboard_Bool_Exp>;
};


export type Query_RootDashboard_AuditArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboard_Audit_Order_By>>;
  where?: InputMaybe<Dashboard_Audit_Bool_Exp>;
};


export type Query_RootDashboard_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDashboard_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootData_Export_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};


export type Query_RootData_Export_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};


export type Query_RootData_Export_Schedule_AuditArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Audit_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Audit_Bool_Exp>;
};


export type Query_RootData_Export_Schedule_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootData_Export_Schedule_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootData_Export_Schedule_ExecutionArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


export type Query_RootData_Export_Schedule_Execution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


export type Query_RootData_Export_Schedule_Execution_By_PkArgs = {
  ExecutionTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootData_ImportArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Order_By>>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};


export type Query_RootData_Import_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Order_By>>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};


export type Query_RootData_Import_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootData_Import_ErrorArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Error_Order_By>>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};


export type Query_RootData_Import_Error_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Error_Order_By>>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};


export type Query_RootData_Import_Error_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDepartment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Audit_Order_By>>;
  where?: InputMaybe<Department_Audit_Bool_Exp>;
};


export type Query_RootDepartment_Audit_By_PkArgs = {
  DepartmentTypeId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootDepartment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Order_By>>;
  where?: InputMaybe<Department_Type_Bool_Exp>;
};


export type Query_RootDepartment_Type_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Audit_Order_By>>;
  where?: InputMaybe<Department_Type_Audit_Bool_Exp>;
};


export type Query_RootDepartment_Type_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDepartment_Type_By_PkArgs = {
  DepartmentTypeId: Scalars['uuid']['input'];
};


export type Query_RootDepartment_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Group_Order_By>>;
  where?: InputMaybe<Department_Type_Group_Bool_Exp>;
};


export type Query_RootDepartment_Type_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Group_Audit_Order_By>>;
  where?: InputMaybe<Department_Type_Group_Audit_Bool_Exp>;
};


export type Query_RootDepartment_Type_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};


export type Query_RootDocument_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};


export type Query_RootDocument_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
};


export type Query_RootDocument_Assessment_Result_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
};


export type Query_RootDocument_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDocument_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDocument_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Audit_Order_By>>;
  where?: InputMaybe<Document_Audit_Bool_Exp>;
};


export type Query_RootDocument_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDocument_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDocument_FileArgs = {
  distinct_on?: InputMaybe<Array<Document_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_File_Order_By>>;
  where?: InputMaybe<Document_File_Bool_Exp>;
};


export type Query_RootDocument_File_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_File_Audit_Order_By>>;
  where?: InputMaybe<Document_File_Audit_Bool_Exp>;
};


export type Query_RootDocument_File_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDocument_File_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDocument_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootDocument_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootDocument_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootDocument_Linked_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Linked_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Linked_Document_Order_By>>;
  where?: InputMaybe<Document_Linked_Document_Bool_Exp>;
};


export type Query_RootDocument_Linked_Document_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Linked_Document_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Linked_Document_Audit_Order_By>>;
  where?: InputMaybe<Document_Linked_Document_Audit_Bool_Exp>;
};


export type Query_RootDocument_Linked_Document_Audit_By_PkArgs = {
  DocumentId: Scalars['uuid']['input'];
  LinkedDocumentId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootDocument_Linked_Document_By_PkArgs = {
  DocumentId: Scalars['uuid']['input'];
  LinkedDocumentId: Scalars['uuid']['input'];
};


export type Query_RootDocument_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
};


export type Query_RootDocument_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
};


export type Query_RootDocument_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootEnterprise_RiskArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootEnterprise_Risk_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_Instance_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};


export type Query_RootEnterprise_Risk_ScoreArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Score_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Score_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};


export type Query_RootEnterprise_Risk_Score_By_PkArgs = {
  EnterpriseRiskId: Scalars['uuid']['input'];
};


export type Query_RootEntityArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Query_RootEntity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Query_RootEntity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AuditArgs = {
  distinct_on?: InputMaybe<Array<File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Audit_Order_By>>;
  where?: InputMaybe<File_Audit_Bool_Exp>;
};


export type Query_RootFile_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootFile_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootForm_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Form_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Configuration_Order_By>>;
  where?: InputMaybe<Form_Configuration_Bool_Exp>;
};


export type Query_RootForm_Configuration_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Configuration_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Configuration_Audit_Order_By>>;
  where?: InputMaybe<Form_Configuration_Audit_Bool_Exp>;
};


export type Query_RootForm_Field_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Configuration_Order_By>>;
  where?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
};


export type Query_RootForm_Field_Configuration_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Configuration_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Configuration_Audit_Order_By>>;
  where?: InputMaybe<Form_Field_Configuration_Audit_Bool_Exp>;
};


export type Query_RootForm_Field_OrderingArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Ordering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Ordering_Order_By>>;
  where?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
};


export type Query_RootForm_Field_Ordering_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Ordering_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Ordering_Audit_Order_By>>;
  where?: InputMaybe<Form_Field_Ordering_Audit_Bool_Exp>;
};


export type Query_RootImpactArgs = {
  distinct_on?: InputMaybe<Array<Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Order_By>>;
  where?: InputMaybe<Impact_Bool_Exp>;
};


export type Query_RootImpact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Order_By>>;
  where?: InputMaybe<Impact_Bool_Exp>;
};


export type Query_RootImpact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Audit_Order_By>>;
  where?: InputMaybe<Impact_Audit_Bool_Exp>;
};


export type Query_RootImpact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootImpact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootImpact_Internal_Audit_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Internal_Audit_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Internal_Audit_Rating_Order_By>>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};


export type Query_RootImpact_Internal_Audit_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Internal_Audit_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Internal_Audit_Rating_Order_By>>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};


export type Query_RootImpact_Internal_Audit_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootImpact_ParentArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


export type Query_RootImpact_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


export type Query_RootImpact_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Audit_Order_By>>;
  where?: InputMaybe<Impact_Parent_Audit_Bool_Exp>;
};


export type Query_RootImpact_Parent_Audit_By_PkArgs = {
  ImpactId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootImpact_Parent_By_PkArgs = {
  ImpactId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootImpact_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


export type Query_RootImpact_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


export type Query_RootImpact_Rating_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Audit_Order_By>>;
  where?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
};


export type Query_RootImpact_Rating_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootImpact_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootImpact_Second_Line_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Second_Line_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Second_Line_Rating_Order_By>>;
  where?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
};


export type Query_RootImpact_Second_Line_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Second_Line_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Second_Line_Rating_Order_By>>;
  where?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
};


export type Query_RootImpact_Second_Line_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIndicatorArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Query_RootIndicator_AuditArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Audit_Order_By>>;
  where?: InputMaybe<Indicator_Audit_Bool_Exp>;
};


export type Query_RootIndicator_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootIndicator_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIndicator_ParentArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


export type Query_RootIndicator_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


export type Query_RootIndicator_Parent_By_PkArgs = {
  IndicatorId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootIndicator_ResultArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Result_Order_By>>;
  where?: InputMaybe<Indicator_Result_Bool_Exp>;
};


export type Query_RootIndicator_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Result_Audit_Order_By>>;
  where?: InputMaybe<Indicator_Result_Audit_Bool_Exp>;
};


export type Query_RootIndicator_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootIndicator_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIndicator_TypeArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Type_Order_By>>;
  where?: InputMaybe<Indicator_Type_Bool_Exp>;
};


export type Query_RootIndicator_Type_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Query_RootInternal_Audit_EntityArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


export type Query_RootInternal_Audit_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


export type Query_RootInternal_Audit_Entity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootInternal_Audit_ReportArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


export type Query_RootInternal_Audit_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


export type Query_RootInternal_Audit_Report_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootInternal_Audit_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


export type Query_RootInternal_Audit_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


export type Query_RootInternal_Audit_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};


export type Query_RootIssue_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};


export type Query_RootIssue_Assessment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Audit_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Audit_Bool_Exp>;
};


export type Query_RootIssue_Assessment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootIssue_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIssue_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Audit_Order_By>>;
  where?: InputMaybe<Issue_Audit_Bool_Exp>;
};


export type Query_RootIssue_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootIssue_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIssue_ParentArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


export type Query_RootIssue_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


export type Query_RootIssue_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Audit_Order_By>>;
  where?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
};


export type Query_RootIssue_Parent_Audit_By_PkArgs = {
  IssueId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootIssue_Parent_By_PkArgs = {
  IssueId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootIssue_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Order_By>>;
  where?: InputMaybe<Issue_Update_Bool_Exp>;
};


export type Query_RootIssue_Update_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Audit_Order_By>>;
  where?: InputMaybe<Issue_Update_Audit_Bool_Exp>;
};


export type Query_RootIssue_Update_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootIssue_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootIssue_Update_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Summary_Order_By>>;
  where?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
};


export type Query_RootIssue_Update_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Summary_Order_By>>;
  where?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
};


export type Query_RootLinked_ItemArgs = {
  distinct_on?: InputMaybe<Array<Linked_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Linked_Item_Order_By>>;
  where?: InputMaybe<Linked_Item_Bool_Exp>;
};


export type Query_RootLinked_Item_By_PkArgs = {
  Source: Scalars['uuid']['input'];
  Target: Scalars['uuid']['input'];
};


export type Query_RootNodeArgs = {
  distinct_on?: InputMaybe<Array<Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Node_Order_By>>;
  where?: InputMaybe<Node_Bool_Exp>;
};


export type Query_RootNode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Node_Order_By>>;
  where?: InputMaybe<Node_Bool_Exp>;
};


export type Query_RootNode_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligationArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


export type Query_RootObligation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


export type Query_RootObligation_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};


export type Query_RootObligation_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};


export type Query_RootObligation_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Audit_Bool_Exp>;
};


export type Query_RootObligation_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootObligation_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_Assessment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Status_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Status_Bool_Exp>;
};


export type Query_RootObligation_Assessment_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Query_RootObligation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Audit_Bool_Exp>;
};


export type Query_RootObligation_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Audit_Bool_Exp>;
};


export type Query_RootObligation_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootObligation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Order_By>>;
  where?: InputMaybe<Obligation_Change_Bool_Exp>;
};


export type Query_RootObligation_Change_AttestationArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Attestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Attestation_Order_By>>;
  where?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
};


export type Query_RootObligation_Change_Attestation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_Change_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_ImpactArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Impact_Order_By>>;
  where?: InputMaybe<Obligation_Impact_Bool_Exp>;
};


export type Query_RootObligation_Impact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Impact_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Impact_Audit_Bool_Exp>;
};


export type Query_RootObligation_Impact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootObligation_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootObligation_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootObligation_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
};


export type Query_RootObligation_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
};


export type Query_RootObligation_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootObligation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Type_Order_By>>;
  where?: InputMaybe<Obligation_Type_Bool_Exp>;
};


export type Query_RootObligation_Type_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Query_RootOrganisation_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Module_Order_By>>;
  where?: InputMaybe<Organisation_Module_Bool_Exp>;
};


export type Query_RootOrganisation_Tab_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Tab_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Tab_Preference_Order_By>>;
  where?: InputMaybe<Organisation_Tab_Preference_Bool_Exp>;
};


export type Query_RootOwner_AuditArgs = {
  distinct_on?: InputMaybe<Array<Owner_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Audit_Order_By>>;
  where?: InputMaybe<Owner_Audit_Bool_Exp>;
};


export type Query_RootOwner_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Query_RootOwner_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Audit_Order_By>>;
  where?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};


export type Query_RootOwner_Group_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
  UserGroupId: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_InviteArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Invite_Order_By>>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};


export type Query_RootQuestionnaire_Invite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Bool_Exp>;
};


export type Query_RootQuestionnaire_Template_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_Template_VersionArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};


export type Query_RootQuestionnaire_Template_Version_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_Template_Version_StatusArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Status_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Status_Bool_Exp>;
};


export type Query_RootQuestionnaire_Template_Version_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Query_RootRelation_FileArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


export type Query_RootRelation_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


export type Query_RootRelation_File_AuditArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Audit_Order_By>>;
  where?: InputMaybe<Relation_File_Audit_Bool_Exp>;
};


export type Query_RootRelation_File_By_PkArgs = {
  FileId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootReportingDataArgs = {
  Input: ReportingDataInput;
};


export type Query_RootReportingFilterOptionsArgs = {
  Input: ReportingFilterOptionsInput;
};


export type Query_RootRiskArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


export type Query_RootRisk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


export type Query_RootRisk_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Audit_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootRisk_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Assessment_Result_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Config_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_Config_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Audit_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_Config_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Assessment_Result_ImpactArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Impact_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_Impact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Audit_Bool_Exp>;
};


export type Query_RootRisk_Assessment_Result_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Audit_Order_By>>;
  where?: InputMaybe<Risk_Audit_Bool_Exp>;
};


export type Query_RootRisk_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Audit_Order_By>>;
  where?: InputMaybe<Risk_Audit_Bool_Exp>;
};


export type Query_RootRisk_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootRisk_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Controlled_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootRisk_Controlled_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootRisk_Controlled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Controlled_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
};


export type Query_RootRisk_Controlled_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
};


export type Query_RootRisk_Controlled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_ScoreArgs = {
  distinct_on?: InputMaybe<Array<Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Score_Order_By>>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};


export type Query_RootRisk_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Score_Order_By>>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};


export type Query_RootRisk_Score_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};


export type Query_RootRisk_Uncontrolled_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootRisk_Uncontrolled_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};


export type Query_RootRisk_Uncontrolled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Uncontrolled_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};


export type Query_RootRisk_Uncontrolled_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};


export type Query_RootRisk_Uncontrolled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootRisksmart_Indicator_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
};


export type Query_RootRisksmart_Indicator_Parent_Audit_By_PkArgs = {
  IndicatorId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootRisksmart_Linked_Item_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Linked_Item_Audit_Bool_Exp>;
};


export type Query_RootRisksmart_Linked_Item_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  Source: Scalars['uuid']['input'];
  Target: Scalars['uuid']['input'];
};


export type Query_RootRole_AccessArgs = {
  distinct_on?: InputMaybe<Array<Role_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Access_Order_By>>;
  where?: InputMaybe<Role_Access_Bool_Exp>;
};


export type Query_RootSecond_Line_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


export type Query_RootSecond_Line_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


export type Query_RootSecond_Line_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Query_RootTabArgs = {
  distinct_on?: InputMaybe<Array<Tab_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tab_Order_By>>;
  where?: InputMaybe<Tab_Bool_Exp>;
};


export type Query_RootTab_By_PkArgs = {
  ParentType: Parent_Type_Enum;
};


export type Query_RootTag_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Query_RootTag_Type_AuditArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Audit_Order_By>>;
  where?: InputMaybe<Tag_Type_Audit_Bool_Exp>;
};


export type Query_RootTag_Type_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTag_Type_By_PkArgs = {
  TagTypeId: Scalars['uuid']['input'];
};


export type Query_RootTag_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Group_Order_By>>;
  where?: InputMaybe<Tag_Type_Group_Bool_Exp>;
};


export type Query_RootTag_Type_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Group_Audit_Order_By>>;
  where?: InputMaybe<Tag_Type_Group_Audit_Bool_Exp>;
};


export type Query_RootTag_Type_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTaxonomyArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Order_By>>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};


export type Query_RootTaxonomy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Order_By>>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};


export type Query_RootTaxonomy_AuditArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Audit_Order_By>>;
  where?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
};


export type Query_RootTaxonomy_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Audit_Order_By>>;
  where?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
};


export type Query_RootTaxonomy_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTaxonomy_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootTaxonomy_OrgArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


export type Query_RootTaxonomy_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


export type Query_RootTaxonomy_Org_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootTest_ResultArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


export type Query_RootTest_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


export type Query_RootTest_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Audit_Order_By>>;
  where?: InputMaybe<Test_Result_Audit_Bool_Exp>;
};


export type Query_RootTest_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootTest_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootThird_PartyArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Order_By>>;
  where?: InputMaybe<Third_Party_Bool_Exp>;
};


export type Query_RootThird_Party_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootThird_Party_ContactArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Contact_Order_By>>;
  where?: InputMaybe<Third_Party_Contact_Bool_Exp>;
};


export type Query_RootThird_Party_Contact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Contact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Contact_Audit_Order_By>>;
  where?: InputMaybe<Third_Party_Contact_Audit_Bool_Exp>;
};


export type Query_RootThird_Party_Contact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootThird_Party_Contact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootThird_Party_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Response_Order_By>>;
  where?: InputMaybe<Third_Party_Response_Bool_Exp>;
};


export type Query_RootThird_Party_Response_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootThird_Party_Response_StatusArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Response_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Response_Status_Order_By>>;
  where?: InputMaybe<Third_Party_Response_Status_Bool_Exp>;
};


export type Query_RootThird_Party_Response_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_GroupArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Query_RootUser_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Audit_Order_By>>;
  where?: InputMaybe<User_Group_Audit_Bool_Exp>;
};


export type Query_RootUser_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootUser_Group_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Query_RootUser_Group_UserArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


export type Query_RootUser_Group_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


export type Query_RootUser_Group_User_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Audit_Order_By>>;
  where?: InputMaybe<User_Group_User_Audit_Bool_Exp>;
};


export type Query_RootUser_Group_User_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  UserGroupId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Query_RootUser_Group_User_By_PkArgs = {
  UserGroupId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Query_RootUser_Role_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Audit_Order_By>>;
  where?: InputMaybe<User_Role_Audit_Bool_Exp>;
};


export type Query_RootUser_Role_Audit_By_PkArgs = {
  Id: Scalars['String']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Query_RootUser_Search_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Search_Preferences_Order_By>>;
  where?: InputMaybe<User_Search_Preferences_Bool_Exp>;
};


export type Query_RootUser_Search_Preferences_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Preferences_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Search_Preferences_Audit_Order_By>>;
  where?: InputMaybe<User_Search_Preferences_Audit_Bool_Exp>;
};


export type Query_RootUser_Tab_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<User_Tab_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tab_Preference_Order_By>>;
  where?: InputMaybe<User_Tab_Preference_Bool_Exp>;
};


export type Query_RootUser_Table_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Table_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Table_Preferences_Order_By>>;
  where?: InputMaybe<User_Table_Preferences_Bool_Exp>;
};


export type Query_RootWizardArgs = {
  distinct_on?: InputMaybe<Array<Wizard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wizard_Order_By>>;
  where?: InputMaybe<Wizard_Bool_Exp>;
};


export type Query_RootWizard_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};

/** columns and relationships of "risksmart.questionnaire_invite" */
export type Questionnaire_Invite = {
  __typename?: 'questionnaire_invite';
  ContactId?: Maybe<Scalars['uuid']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  QuestionnaireTemplateVersionId: Scalars['uuid']['output'];
  ThirdPartyId: Scalars['uuid']['output'];
  UserEmail: Scalars['String']['output'];
  UserId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  contact?: Maybe<Third_Party_Contact>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent: Third_Party_Response;
  /** An object relationship */
  questionnaireTemplateVersion: Questionnaire_Template_Version;
  /** An object relationship */
  thirdParty: Third_Party;
  /** An object relationship */
  user?: Maybe<Auth_User>;
};

/** order by aggregate values of table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Invite_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Invite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Invite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Invite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.questionnaire_invite". All fields are combined with a logical 'AND'. */
export type Questionnaire_Invite_Bool_Exp = {
  ContactId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  QuestionnaireTemplateVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  ThirdPartyId?: InputMaybe<Uuid_Comparison_Exp>;
  UserEmail?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Questionnaire_Invite_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Invite_Bool_Exp>>;
  contact?: InputMaybe<Third_Party_Contact_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Third_Party_Response_Bool_Exp>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.questionnaire_invite" */
export const Questionnaire_Invite_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  QuestionnaireInvitePkey: 'questionnaire_invite_pkey'
} as const;

export type Questionnaire_Invite_Constraint = typeof Questionnaire_Invite_Constraint[keyof typeof Questionnaire_Invite_Constraint];
/** input type for inserting data into table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Insert_Input = {
  ContactId?: InputMaybe<Scalars['uuid']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  QuestionnaireTemplateVersionId?: InputMaybe<Scalars['uuid']['input']>;
  ThirdPartyId?: InputMaybe<Scalars['uuid']['input']>;
  UserEmail?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Third_Party_Contact_Obj_Rel_Insert_Input>;
  parent?: InputMaybe<Third_Party_Response_Obj_Rel_Insert_Input>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Max_Order_By = {
  ContactId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  QuestionnaireTemplateVersionId?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserEmail?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Min_Order_By = {
  ContactId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  QuestionnaireTemplateVersionId?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserEmail?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_Mutation_Response = {
  __typename?: 'questionnaire_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Invite>;
};

/** on_conflict condition type for table "risksmart.questionnaire_invite" */
export type Questionnaire_Invite_On_Conflict = {
  constraint: Questionnaire_Invite_Constraint;
  update_columns?: Array<Questionnaire_Invite_Update_Column>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.questionnaire_invite". */
export type Questionnaire_Invite_Order_By = {
  ContactId?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  QuestionnaireTemplateVersionId?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserEmail?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  contact?: InputMaybe<Third_Party_Contact_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Third_Party_Response_Order_By>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
};

/** select columns of table "risksmart.questionnaire_invite" */
export const Questionnaire_Invite_Select_Column = {
  /** column name */
  ContactId: 'ContactId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  Message: 'Message',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  QuestionnaireTemplateVersionId: 'QuestionnaireTemplateVersionId',
  /** column name */
  ThirdPartyId: 'ThirdPartyId',
  /** column name */
  UserEmail: 'UserEmail',
  /** column name */
  UserId: 'UserId'
} as const;

export type Questionnaire_Invite_Select_Column = typeof Questionnaire_Invite_Select_Column[keyof typeof Questionnaire_Invite_Select_Column];
/** Streaming cursor of the table "questionnaire_invite" */
export type Questionnaire_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Invite_Stream_Cursor_Value_Input = {
  ContactId?: InputMaybe<Scalars['uuid']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  QuestionnaireTemplateVersionId?: InputMaybe<Scalars['uuid']['input']>;
  ThirdPartyId?: InputMaybe<Scalars['uuid']['input']>;
  UserEmail?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.questionnaire_invite" */
export const Questionnaire_Invite_Update_Column = {
  /** column name */
  ContactId: 'ContactId',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  Message: 'Message',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  QuestionnaireTemplateVersionId: 'QuestionnaireTemplateVersionId',
  /** column name */
  ThirdPartyId: 'ThirdPartyId',
  /** column name */
  UserEmail: 'UserEmail',
  /** column name */
  UserId: 'UserId'
} as const;

export type Questionnaire_Invite_Update_Column = typeof Questionnaire_Invite_Update_Column[keyof typeof Questionnaire_Invite_Update_Column];
/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_Template = {
  __typename?: 'questionnaire_template';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
  /** An array relationship */
  versions: Array<Questionnaire_Template_Version>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


/** columns and relationships of "risksmart.questionnaire_template" */
export type Questionnaire_TemplateVersionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.questionnaire_template". All fields are combined with a logical 'AND'. */
export type Questionnaire_Template_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Questionnaire_Template_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Template_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
  versions?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.questionnaire_template" */
export const Questionnaire_Template_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  QuestionnaireTemplatePkey: 'questionnaire_template_pkey'
} as const;

export type Questionnaire_Template_Constraint = typeof Questionnaire_Template_Constraint[keyof typeof Questionnaire_Template_Constraint];
/** input type for inserting data into table "risksmart.questionnaire_template" */
export type Questionnaire_Template_Insert_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
  versions?: InputMaybe<Questionnaire_Template_Version_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.questionnaire_template" */
export type Questionnaire_Template_Mutation_Response = {
  __typename?: 'questionnaire_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Template>;
};

/** input type for inserting object relation for remote table "risksmart.questionnaire_template" */
export type Questionnaire_Template_Obj_Rel_Insert_Input = {
  data: Questionnaire_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Template_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.questionnaire_template" */
export type Questionnaire_Template_On_Conflict = {
  constraint: Questionnaire_Template_Constraint;
  update_columns?: Array<Questionnaire_Template_Update_Column>;
  where?: InputMaybe<Questionnaire_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.questionnaire_template". */
export type Questionnaire_Template_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
  versions_aggregate?: InputMaybe<Questionnaire_Template_Version_Aggregate_Order_By>;
};

/** select columns of table "risksmart.questionnaire_template" */
export const Questionnaire_Template_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Title: 'Title'
} as const;

export type Questionnaire_Template_Select_Column = typeof Questionnaire_Template_Select_Column[keyof typeof Questionnaire_Template_Select_Column];
/** Streaming cursor of the table "questionnaire_template" */
export type Questionnaire_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Template_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.questionnaire_template" */
export const Questionnaire_Template_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Title: 'Title'
} as const;

export type Questionnaire_Template_Update_Column = typeof Questionnaire_Template_Update_Column[keyof typeof Questionnaire_Template_Update_Column];
/** columns and relationships of "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version = {
  __typename?: 'questionnaire_template_version';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  Schema: Scalars['jsonb']['output'];
  Status: Questionnaire_Template_Version_Status_Enum;
  UISchema: Scalars['jsonb']['output'];
  Version: Scalars['String']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  invitations: Array<Questionnaire_Invite>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  parent?: Maybe<Questionnaire_Template>;
};


/** columns and relationships of "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_VersionCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_VersionSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_VersionUiSchemaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_VersionInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Invite_Order_By>>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};

/** order by aggregate values of table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Template_Version_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Template_Version_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Questionnaire_Template_Version_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UISchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Template_Version_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Template_Version_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.questionnaire_template_version". All fields are combined with a logical 'AND'. */
export type Questionnaire_Template_Version_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  Schema?: InputMaybe<Jsonb_Comparison_Exp>;
  Status?: InputMaybe<Questionnaire_Template_Version_Status_Enum_Comparison_Exp>;
  UISchema?: InputMaybe<Jsonb_Comparison_Exp>;
  Version?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Questionnaire_Template_Version_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Template_Version_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  invitations?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  parent?: InputMaybe<Questionnaire_Template_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.questionnaire_template_version" */
export const Questionnaire_Template_Version_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  QuestionnaireTemplateVersionPkey: 'questionnaire_template_version_pkey'
} as const;

export type Questionnaire_Template_Version_Constraint = typeof Questionnaire_Template_Version_Constraint[keyof typeof Questionnaire_Template_Version_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Questionnaire_Template_Version_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
  Schema?: InputMaybe<Array<Scalars['String']['input']>>;
  UISchema?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Questionnaire_Template_Version_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
  Schema?: InputMaybe<Scalars['Int']['input']>;
  UISchema?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Questionnaire_Template_Version_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
  Schema?: InputMaybe<Scalars['String']['input']>;
  UISchema?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  Status?: InputMaybe<Questionnaire_Template_Version_Status_Enum>;
  UISchema?: InputMaybe<Scalars['jsonb']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Questionnaire_Invite_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Questionnaire_Template_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Mutation_Response = {
  __typename?: 'questionnaire_template_version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Template_Version>;
};

/** input type for inserting object relation for remote table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Obj_Rel_Insert_Input = {
  data: Questionnaire_Template_Version_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Template_Version_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_On_Conflict = {
  constraint: Questionnaire_Template_Version_Constraint;
  update_columns?: Array<Questionnaire_Template_Version_Update_Column>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.questionnaire_template_version". */
export type Questionnaire_Template_Version_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  Schema?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  UISchema?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  invitations_aggregate?: InputMaybe<Questionnaire_Invite_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  parent?: InputMaybe<Questionnaire_Template_Order_By>;
};

/** primary key columns input for table: risksmart.questionnaire_template_version */
export type Questionnaire_Template_Version_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Questionnaire_Template_Version_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  UISchema?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.questionnaire_template_version" */
export const Questionnaire_Template_Version_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  Schema: 'Schema',
  /** column name */
  Status: 'Status',
  /** column name */
  UiSchema: 'UISchema',
  /** column name */
  Version: 'Version'
} as const;

export type Questionnaire_Template_Version_Select_Column = typeof Questionnaire_Template_Version_Select_Column[keyof typeof Questionnaire_Template_Version_Select_Column];
/** input type for updating data in table "risksmart.questionnaire_template_version" */
export type Questionnaire_Template_Version_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  Status?: InputMaybe<Questionnaire_Template_Version_Status_Enum>;
  UISchema?: InputMaybe<Scalars['jsonb']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.questionnaire_template_version_status" */
export type Questionnaire_Template_Version_Status = {
  __typename?: 'questionnaire_template_version_status';
  Comment?: Maybe<Scalars['String']['output']>;
  Value: Scalars['String']['output'];
  /** An array relationship */
  questionnaire_template_versions: Array<Questionnaire_Template_Version>;
};


/** columns and relationships of "risksmart.questionnaire_template_version_status" */
export type Questionnaire_Template_Version_StatusQuestionnaire_Template_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.questionnaire_template_version_status". All fields are combined with a logical 'AND'. */
export type Questionnaire_Template_Version_Status_Bool_Exp = {
  Comment?: InputMaybe<String_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Questionnaire_Template_Version_Status_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Template_Version_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Template_Version_Status_Bool_Exp>>;
  questionnaire_template_versions?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};

export const Questionnaire_Template_Version_Status_Enum = {
  /** Archived */
  Archived: 'archived',
  /** Draft */
  Draft: 'draft',
  /** Published */
  Published: 'published'
} as const;

export type Questionnaire_Template_Version_Status_Enum = typeof Questionnaire_Template_Version_Status_Enum[keyof typeof Questionnaire_Template_Version_Status_Enum];
/** Boolean expression to compare columns of type "questionnaire_template_version_status_enum". All fields are combined with logical 'AND'. */
export type Questionnaire_Template_Version_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Questionnaire_Template_Version_Status_Enum>;
  _in?: InputMaybe<Array<Questionnaire_Template_Version_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Questionnaire_Template_Version_Status_Enum>;
  _nin?: InputMaybe<Array<Questionnaire_Template_Version_Status_Enum>>;
};

/** Ordering options when selecting data from "risksmart.questionnaire_template_version_status". */
export type Questionnaire_Template_Version_Status_Order_By = {
  Comment?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
  questionnaire_template_versions_aggregate?: InputMaybe<Questionnaire_Template_Version_Aggregate_Order_By>;
};

/** select columns of table "risksmart.questionnaire_template_version_status" */
export const Questionnaire_Template_Version_Status_Select_Column = {
  /** column name */
  Comment: 'Comment',
  /** column name */
  Value: 'Value'
} as const;

export type Questionnaire_Template_Version_Status_Select_Column = typeof Questionnaire_Template_Version_Status_Select_Column[keyof typeof Questionnaire_Template_Version_Status_Select_Column];
/** Streaming cursor of the table "questionnaire_template_version_status" */
export type Questionnaire_Template_Version_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Template_Version_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Template_Version_Status_Stream_Cursor_Value_Input = {
  Comment?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "questionnaire_template_version" */
export type Questionnaire_Template_Version_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Template_Version_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Template_Version_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Schema?: InputMaybe<Scalars['jsonb']['input']>;
  Status?: InputMaybe<Questionnaire_Template_Version_Status_Enum>;
  UISchema?: InputMaybe<Scalars['jsonb']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.questionnaire_template_version" */
export const Questionnaire_Template_Version_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Schema: 'Schema',
  /** column name */
  Status: 'Status',
  /** column name */
  UiSchema: 'UISchema',
  /** column name */
  Version: 'Version'
} as const;

export type Questionnaire_Template_Version_Update_Column = typeof Questionnaire_Template_Version_Update_Column[keyof typeof Questionnaire_Template_Version_Update_Column];
export type Questionnaire_Template_Version_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Questionnaire_Template_Version_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Questionnaire_Template_Version_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Questionnaire_Template_Version_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Questionnaire_Template_Version_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Questionnaire_Template_Version_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Template_Version_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Template_Version_Bool_Exp;
};

/** columns and relationships of "risksmart.relation_file" */
export type Relation_File = {
  __typename?: 'relation_file';
  ChangeRequestFileOperation?: Maybe<Change_Request_File_Operation_Enum>;
  FileId: Scalars['uuid']['output'];
  ParentId: Scalars['uuid']['output'];
  /** An object relationship */
  acceptance?: Maybe<Acceptance>;
  /** An object relationship */
  action?: Maybe<Action>;
  /** An object relationship */
  appetite?: Maybe<Appetite>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  file?: Maybe<File>;
  /** An object relationship */
  issue?: Maybe<Issue>;
  /** An object relationship */
  issueUpdate?: Maybe<Issue_Update>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  riskAssessmentResult?: Maybe<Risk_Assessment_Result>;
  /** An object relationship */
  testResult?: Maybe<Test_Result>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
  /** An object relationship */
  thirdPartyResponse?: Maybe<Third_Party_Response>;
};

/** aggregated selection of "risksmart.relation_file" */
export type Relation_File_Aggregate = {
  __typename?: 'relation_file_aggregate';
  aggregate?: Maybe<Relation_File_Aggregate_Fields>;
  nodes: Array<Relation_File>;
};

export type Relation_File_Aggregate_Bool_Exp = {
  count?: InputMaybe<Relation_File_Aggregate_Bool_Exp_Count>;
};

export type Relation_File_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Relation_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Relation_File_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.relation_file" */
export type Relation_File_Aggregate_Fields = {
  __typename?: 'relation_file_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Relation_File_Max_Fields>;
  min?: Maybe<Relation_File_Min_Fields>;
};


/** aggregate fields of "risksmart.relation_file" */
export type Relation_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relation_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.relation_file" */
export type Relation_File_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Relation_File_Max_Order_By>;
  min?: InputMaybe<Relation_File_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.relation_file" */
export type Relation_File_Arr_Rel_Insert_Input = {
  data: Array<Relation_File_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Relation_File_On_Conflict>;
};

/** columns and relationships of "risksmart.relation_file_audit" */
export type Relation_File_Audit = {
  __typename?: 'relation_file_audit';
  FileId: Scalars['uuid']['output'];
  ParentId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.relation_file_audit". All fields are combined with a logical 'AND'. */
export type Relation_File_Audit_Bool_Exp = {
  FileId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Relation_File_Audit_Bool_Exp>>;
  _not?: InputMaybe<Relation_File_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Relation_File_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.relation_file_audit". */
export type Relation_File_Audit_Order_By = {
  FileId?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.relation_file_audit" */
export const Relation_File_Audit_Select_Column = {
  /** column name */
  FileId: 'FileId',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Relation_File_Audit_Select_Column = typeof Relation_File_Audit_Select_Column[keyof typeof Relation_File_Audit_Select_Column];
/** Streaming cursor of the table "relation_file_audit" */
export type Relation_File_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relation_File_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relation_File_Audit_Stream_Cursor_Value_Input = {
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.relation_file". All fields are combined with a logical 'AND'. */
export type Relation_File_Bool_Exp = {
  ChangeRequestFileOperation?: InputMaybe<Change_Request_File_Operation_Enum_Comparison_Exp>;
  FileId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Relation_File_Bool_Exp>>;
  _not?: InputMaybe<Relation_File_Bool_Exp>;
  _or?: InputMaybe<Array<Relation_File_Bool_Exp>>;
  acceptance?: InputMaybe<Acceptance_Bool_Exp>;
  action?: InputMaybe<Action_Bool_Exp>;
  appetite?: InputMaybe<Appetite_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  issue?: InputMaybe<Issue_Bool_Exp>;
  issueUpdate?: InputMaybe<Issue_Update_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
  testResult?: InputMaybe<Test_Result_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
  thirdPartyResponse?: InputMaybe<Third_Party_Response_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.relation_file" */
export const Relation_File_Constraint = {
  /** unique or primary key constraint on columns "FileId", "ParentId" */
  RelationFilePkey: 'relation_file_pkey'
} as const;

export type Relation_File_Constraint = typeof Relation_File_Constraint[keyof typeof Relation_File_Constraint];
/** input type for inserting data into table "risksmart.relation_file" */
export type Relation_File_Insert_Input = {
  ChangeRequestFileOperation?: InputMaybe<Change_Request_File_Operation_Enum>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  acceptance?: InputMaybe<Acceptance_Obj_Rel_Insert_Input>;
  action?: InputMaybe<Action_Obj_Rel_Insert_Input>;
  appetite?: InputMaybe<Appetite_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  issue?: InputMaybe<Issue_Obj_Rel_Insert_Input>;
  issueUpdate?: InputMaybe<Issue_Update_Obj_Rel_Insert_Input>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Obj_Rel_Insert_Input>;
  testResult?: InputMaybe<Test_Result_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
  thirdPartyResponse?: InputMaybe<Third_Party_Response_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Relation_File_Max_Fields = {
  __typename?: 'relation_file_max_fields';
  FileId?: Maybe<Scalars['uuid']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.relation_file" */
export type Relation_File_Max_Order_By = {
  FileId?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Relation_File_Min_Fields = {
  __typename?: 'relation_file_min_fields';
  FileId?: Maybe<Scalars['uuid']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.relation_file" */
export type Relation_File_Min_Order_By = {
  FileId?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.relation_file" */
export type Relation_File_Mutation_Response = {
  __typename?: 'relation_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Relation_File>;
};

/** on_conflict condition type for table "risksmart.relation_file" */
export type Relation_File_On_Conflict = {
  constraint: Relation_File_Constraint;
  update_columns?: Array<Relation_File_Update_Column>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.relation_file". */
export type Relation_File_Order_By = {
  ChangeRequestFileOperation?: InputMaybe<Order_By>;
  FileId?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  acceptance?: InputMaybe<Acceptance_Order_By>;
  action?: InputMaybe<Action_Order_By>;
  appetite?: InputMaybe<Appetite_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  file?: InputMaybe<File_Order_By>;
  issue?: InputMaybe<Issue_Order_By>;
  issueUpdate?: InputMaybe<Issue_Update_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Order_By>;
  testResult?: InputMaybe<Test_Result_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
  thirdPartyResponse?: InputMaybe<Third_Party_Response_Order_By>;
};

/** select columns of table "risksmart.relation_file" */
export const Relation_File_Select_Column = {
  /** column name */
  ChangeRequestFileOperation: 'ChangeRequestFileOperation',
  /** column name */
  FileId: 'FileId',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Relation_File_Select_Column = typeof Relation_File_Select_Column[keyof typeof Relation_File_Select_Column];
/** Streaming cursor of the table "relation_file" */
export type Relation_File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relation_File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relation_File_Stream_Cursor_Value_Input = {
  ChangeRequestFileOperation?: InputMaybe<Change_Request_File_Operation_Enum>;
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.relation_file" (current role has no relevant permissions) */
export const Relation_File_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Relation_File_Update_Column = typeof Relation_File_Update_Column[keyof typeof Relation_File_Update_Column];
/** columns and relationships of "risksmart.risk" */
export type Risk = {
  __typename?: 'risk';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Risk_Status_Type_Enum>;
  Tier: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  Treatment?: Maybe<Risk_Treatment_Type_Enum>;
  /** An array relationship */
  acceptances: Array<Acceptance_Parent>;
  /** An aggregate relationship */
  acceptances_aggregate: Acceptance_Parent_Aggregate;
  /** An array relationship */
  actions: Array<Action_Parent>;
  /** An aggregate relationship */
  actions_aggregate: Action_Parent_Aggregate;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  appetites: Array<Appetite_Parent>;
  /** An aggregate relationship */
  appetites_aggregate: Appetite_Parent_Aggregate;
  /** An array relationship */
  assessmentResults: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentResults_aggregate: Assessment_Result_Parent_Aggregate;
  /** An array relationship */
  childRisks: Array<Risk>;
  /** An aggregate relationship */
  childRisks_aggregate: Risk_Aggregate;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An array relationship */
  controls: Array<Control_Parent>;
  /** An aggregate relationship */
  controls_aggregate: Control_Parent_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An object relationship */
  enterpriseRiskInstance?: Maybe<Enterprise_Risk_Instance>;
  /** An array relationship */
  impactRatings: Array<Impact_Rating>;
  /** An aggregate relationship */
  impactRatings_aggregate: Impact_Rating_Aggregate;
  /** An array relationship */
  indicators: Array<Indicator_Parent>;
  /** An aggregate relationship */
  indicators_aggregate: Indicator_Parent_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  parent?: Maybe<Risk>;
  /** An object relationship */
  parentNode?: Maybe<Node>;
  /** An object relationship */
  riskScore?: Maybe<Risk_Score>;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
  /** An object relationship */
  scheduleState?: Maybe<Schedule_State>;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAcceptancesArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAcceptances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskActionsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAppetitesArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAppetites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAssessmentResultsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskAssessmentResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskChildRisksArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskChildRisks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskControlsArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskControls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskImpactRatingsArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskImpactRatings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskIndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskIndicators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk" */
export type RiskTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk" */
export type Risk_Aggregate = {
  __typename?: 'risk_aggregate';
  aggregate?: Maybe<Risk_Aggregate_Fields>;
  nodes: Array<Risk>;
};

export type Risk_Aggregate_Bool_Exp = {
  count?: InputMaybe<Risk_Aggregate_Bool_Exp_Count>;
};

export type Risk_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.risk" */
export type Risk_Aggregate_Fields = {
  __typename?: 'risk_aggregate_fields';
  avg?: Maybe<Risk_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Max_Fields>;
  min?: Maybe<Risk_Min_Fields>;
  stddev?: Maybe<Risk_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Sum_Fields>;
  var_pop?: Maybe<Risk_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Var_Samp_Fields>;
  variance?: Maybe<Risk_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk" */
export type Risk_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.risk" */
export type Risk_Aggregate_Order_By = {
  avg?: InputMaybe<Risk_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Max_Order_By>;
  min?: InputMaybe<Risk_Min_Order_By>;
  stddev?: InputMaybe<Risk_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Risk_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Risk_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Risk_Sum_Order_By>;
  var_pop?: InputMaybe<Risk_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Risk_Var_Samp_Order_By>;
  variance?: InputMaybe<Risk_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.risk" */
export type Risk_Arr_Rel_Insert_Input = {
  data: Array<Risk_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_On_Conflict>;
};

/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result = {
  __typename?: 'risk_assessment_result';
  ControlType: Risk_Assessment_Result_Control_Type_Enum;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType: Scalars['String']['output'];
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An array relationship */
  impacts: Array<Risk_Assessment_Result_Impact>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Assessment_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultImpactsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Impact_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_assessment_result" */
export type Risk_Assessment_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Aggregate = {
  __typename?: 'risk_assessment_result_aggregate';
  aggregate?: Maybe<Risk_Assessment_Result_Aggregate_Fields>;
  nodes: Array<Risk_Assessment_Result>;
};

/** aggregate fields of "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Aggregate_Fields = {
  __typename?: 'risk_assessment_result_aggregate_fields';
  avg?: Maybe<Risk_Assessment_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Assessment_Result_Max_Fields>;
  min?: Maybe<Risk_Assessment_Result_Min_Fields>;
  stddev?: Maybe<Risk_Assessment_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Assessment_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Assessment_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Assessment_Result_Sum_Fields>;
  var_pop?: Maybe<Risk_Assessment_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Assessment_Result_Var_Samp_Fields>;
  variance?: Maybe<Risk_Assessment_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Assessment_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "risksmart.risk_assessment_result_audit" */
export type Risk_Assessment_Result_Audit = {
  __typename?: 'risk_assessment_result_audit';
  ControlType: Scalars['String']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "risksmart.risk_assessment_result_audit" */
export type Risk_Assessment_Result_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result_audit". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Audit_Bool_Exp = {
  ControlType?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result_audit". */
export type Risk_Assessment_Result_Audit_Order_By = {
  ControlType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.risk_assessment_result_audit" */
export const Risk_Assessment_Result_Audit_Select_Column = {
  /** column name */
  ControlType: 'ControlType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Assessment_Result_Audit_Select_Column = typeof Risk_Assessment_Result_Audit_Select_Column[keyof typeof Risk_Assessment_Result_Audit_Select_Column];
/** Streaming cursor of the table "risk_assessment_result_audit" */
export type Risk_Assessment_Result_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Audit_Stream_Cursor_Value_Input = {
  ControlType?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate avg on columns */
export type Risk_Assessment_Result_Avg_Fields = {
  __typename?: 'risk_assessment_result_avg_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Bool_Exp = {
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  impacts?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
};

/** columns and relationships of "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_Config = {
  __typename?: 'risk_assessment_result_config';
  Config: Scalars['jsonb']['output'];
  Id: Scalars['uuid']['output'];
  IsLatest: Scalars['Boolean']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  Version: Scalars['Int']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
};


/** columns and relationships of "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_ConfigConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risk_Assessment_Result_Config_Append_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.risk_assessment_result_config_audit" */
export type Risk_Assessment_Result_Config_Audit = {
  __typename?: 'risk_assessment_result_config_audit';
  Config: Scalars['jsonb']['output'];
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  IsLatest: Scalars['Boolean']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Version: Scalars['Int']['output'];
};


/** columns and relationships of "risksmart.risk_assessment_result_config_audit" */
export type Risk_Assessment_Result_Config_AuditConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result_config_audit". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Config_Audit_Bool_Exp = {
  Config?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsLatest?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Version?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Config_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result_config_audit". */
export type Risk_Assessment_Result_Config_Audit_Order_By = {
  Config?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsLatest?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.risk_assessment_result_config_audit" */
export const Risk_Assessment_Result_Config_Audit_Select_Column = {
  /** column name */
  Config: 'Config',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  IsLatest: 'IsLatest',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Version: 'Version'
} as const;

export type Risk_Assessment_Result_Config_Audit_Select_Column = typeof Risk_Assessment_Result_Config_Audit_Select_Column[keyof typeof Risk_Assessment_Result_Config_Audit_Select_Column];
/** Streaming cursor of the table "risk_assessment_result_config_audit" */
export type Risk_Assessment_Result_Config_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Config_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Config_Audit_Stream_Cursor_Value_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsLatest?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Version?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result_config". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Config_Bool_Exp = {
  Config?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsLatest?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  Version?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Config_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Config_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk_assessment_result_config" */
export const Risk_Assessment_Result_Config_Constraint = {
  /** unique or primary key constraint on columns "OrgKey" */
  IdxRiskAssessmentResultConfigOrgkeyIslatest: 'idx_risk_assessment_result_config_orgkey_islatest',
  /** unique or primary key constraint on columns "Version", "OrgKey" */
  RiskAssessmentResultConfigOrgkeyVersionUnique: 'risk_assessment_result_config_orgkey_version_unique',
  /** unique or primary key constraint on columns "Id" */
  RiskAssessmentResultConfigPkey: 'risk_assessment_result_config_pkey'
} as const;

export type Risk_Assessment_Result_Config_Constraint = typeof Risk_Assessment_Result_Config_Constraint[keyof typeof Risk_Assessment_Result_Config_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risk_Assessment_Result_Config_Delete_At_Path_Input = {
  Config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risk_Assessment_Result_Config_Delete_Elem_Input = {
  Config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risk_Assessment_Result_Config_Delete_Key_Input = {
  Config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_Config_Insert_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_Config_Mutation_Response = {
  __typename?: 'risk_assessment_result_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Assessment_Result_Config>;
};

/** on_conflict condition type for table "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_Config_On_Conflict = {
  constraint: Risk_Assessment_Result_Config_Constraint;
  update_columns?: Array<Risk_Assessment_Result_Config_Update_Column>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result_config". */
export type Risk_Assessment_Result_Config_Order_By = {
  Config?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsLatest?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  Version?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
};

/** primary key columns input for table: risksmart.risk_assessment_result_config */
export type Risk_Assessment_Result_Config_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risk_Assessment_Result_Config_Prepend_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.risk_assessment_result_config" */
export const Risk_Assessment_Result_Config_Select_Column = {
  /** column name */
  Config: 'Config',
  /** column name */
  Id: 'Id',
  /** column name */
  IsLatest: 'IsLatest',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  Version: 'Version'
} as const;

export type Risk_Assessment_Result_Config_Select_Column = typeof Risk_Assessment_Result_Config_Select_Column[keyof typeof Risk_Assessment_Result_Config_Select_Column];
/** input type for updating data in table "risksmart.risk_assessment_result_config" */
export type Risk_Assessment_Result_Config_Set_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "risk_assessment_result_config" */
export type Risk_Assessment_Result_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Config_Stream_Cursor_Value_Input = {
  Config?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsLatest?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Version?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "risksmart.risk_assessment_result_config" */
export const Risk_Assessment_Result_Config_Update_Column = {
  /** column name */
  Config: 'Config'
} as const;

export type Risk_Assessment_Result_Config_Update_Column = typeof Risk_Assessment_Result_Config_Update_Column[keyof typeof Risk_Assessment_Result_Config_Update_Column];
export type Risk_Assessment_Result_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Risk_Assessment_Result_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Risk_Assessment_Result_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Risk_Assessment_Result_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Risk_Assessment_Result_Config_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Risk_Assessment_Result_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Assessment_Result_Config_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Assessment_Result_Config_Bool_Exp;
};

/** unique or primary key constraints on table "risksmart.risk_assessment_result" */
export const Risk_Assessment_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  RiskAssessmentResultPkey: 'risk_assessment_result_pkey'
} as const;

export type Risk_Assessment_Result_Constraint = typeof Risk_Assessment_Result_Constraint[keyof typeof Risk_Assessment_Result_Constraint];
export const Risk_Assessment_Result_Control_Type_Enum = {
  /** Controlled */
  Controlled: 'Controlled',
  /** Uncontrolled */
  Uncontrolled: 'Uncontrolled'
} as const;

export type Risk_Assessment_Result_Control_Type_Enum = typeof Risk_Assessment_Result_Control_Type_Enum[keyof typeof Risk_Assessment_Result_Control_Type_Enum];
/** Boolean expression to compare columns of type "risk_assessment_result_control_type_enum". All fields are combined with logical 'AND'. */
export type Risk_Assessment_Result_Control_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  _in?: InputMaybe<Array<Risk_Assessment_Result_Control_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  _nin?: InputMaybe<Array<Risk_Assessment_Result_Control_Type_Enum>>;
};

/** columns and relationships of "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact = {
  __typename?: 'risk_assessment_result_impact';
  Id: Scalars['uuid']['output'];
  Label: Scalars['String']['output'];
  RiskAssessmentResultId: Scalars['uuid']['output'];
  Value: Scalars['Int']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  riskAssessmentResult: Risk_Assessment_Result;
};

/** order by aggregate values of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Aggregate_Order_By = {
  avg?: InputMaybe<Risk_Assessment_Result_Impact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Assessment_Result_Impact_Max_Order_By>;
  min?: InputMaybe<Risk_Assessment_Result_Impact_Min_Order_By>;
  stddev?: InputMaybe<Risk_Assessment_Result_Impact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Risk_Assessment_Result_Impact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Risk_Assessment_Result_Impact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Risk_Assessment_Result_Impact_Sum_Order_By>;
  var_pop?: InputMaybe<Risk_Assessment_Result_Impact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Risk_Assessment_Result_Impact_Var_Samp_Order_By>;
  variance?: InputMaybe<Risk_Assessment_Result_Impact_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Arr_Rel_Insert_Input = {
  data: Array<Risk_Assessment_Result_Impact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Assessment_Result_Impact_On_Conflict>;
};

/** columns and relationships of "risksmart.risk_assessment_result_impact_audit" */
export type Risk_Assessment_Result_Impact_Audit = {
  __typename?: 'risk_assessment_result_impact_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  Label: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RiskAssessmentResultId: Scalars['uuid']['output'];
  Value: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result_impact_audit". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Impact_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Label?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RiskAssessmentResultId?: InputMaybe<Uuid_Comparison_Exp>;
  Value?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Impact_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result_impact_audit". */
export type Risk_Assessment_Result_Impact_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RiskAssessmentResultId?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.risk_assessment_result_impact_audit" */
export const Risk_Assessment_Result_Impact_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  Label: 'Label',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RiskAssessmentResultId: 'RiskAssessmentResultId',
  /** column name */
  Value: 'Value'
} as const;

export type Risk_Assessment_Result_Impact_Audit_Select_Column = typeof Risk_Assessment_Result_Impact_Audit_Select_Column[keyof typeof Risk_Assessment_Result_Impact_Audit_Select_Column];
/** Streaming cursor of the table "risk_assessment_result_impact_audit" */
export type Risk_Assessment_Result_Impact_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Impact_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Impact_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RiskAssessmentResultId?: InputMaybe<Scalars['uuid']['input']>;
  Value?: InputMaybe<Scalars['Int']['input']>;
};

/** order by avg() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Avg_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_assessment_result_impact". All fields are combined with a logical 'AND'. */
export type Risk_Assessment_Result_Impact_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Label?: InputMaybe<String_Comparison_Exp>;
  RiskAssessmentResultId?: InputMaybe<Uuid_Comparison_Exp>;
  Value?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Assessment_Result_Impact_Bool_Exp>>;
  _not?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Assessment_Result_Impact_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk_assessment_result_impact" */
export const Risk_Assessment_Result_Impact_Constraint = {
  /** unique or primary key constraint on columns "RiskAssessmentResultId", "Label" */
  RiskAssessmentResultImpactParentLabelUnique: 'risk_assessment_result_impact_parent_label_unique',
  /** unique or primary key constraint on columns "Id" */
  RiskAssessmentResultImpactPkey: 'risk_assessment_result_impact_pkey'
} as const;

export type Risk_Assessment_Result_Impact_Constraint = typeof Risk_Assessment_Result_Impact_Constraint[keyof typeof Risk_Assessment_Result_Impact_Constraint];
/** input type for inserting data into table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Insert_Input = {
  Label?: InputMaybe<Scalars['String']['input']>;
  RiskAssessmentResultId?: InputMaybe<Scalars['uuid']['input']>;
  Value?: InputMaybe<Scalars['Int']['input']>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Max_Order_By = {
  Id?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  RiskAssessmentResultId?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Min_Order_By = {
  Id?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  RiskAssessmentResultId?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Mutation_Response = {
  __typename?: 'risk_assessment_result_impact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Assessment_Result_Impact>;
};

/** on_conflict condition type for table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_On_Conflict = {
  constraint: Risk_Assessment_Result_Impact_Constraint;
  update_columns?: Array<Risk_Assessment_Result_Impact_Update_Column>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result_impact". */
export type Risk_Assessment_Result_Impact_Order_By = {
  Id?: InputMaybe<Order_By>;
  Label?: InputMaybe<Order_By>;
  RiskAssessmentResultId?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  riskAssessmentResult?: InputMaybe<Risk_Assessment_Result_Order_By>;
};

/** select columns of table "risksmart.risk_assessment_result_impact" */
export const Risk_Assessment_Result_Impact_Select_Column = {
  /** column name */
  Id: 'Id',
  /** column name */
  Label: 'Label',
  /** column name */
  RiskAssessmentResultId: 'RiskAssessmentResultId',
  /** column name */
  Value: 'Value'
} as const;

export type Risk_Assessment_Result_Impact_Select_Column = typeof Risk_Assessment_Result_Impact_Select_Column[keyof typeof Risk_Assessment_Result_Impact_Select_Column];
/** order by stddev() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Stddev_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Stddev_Pop_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Stddev_Samp_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Impact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Impact_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Label?: InputMaybe<Scalars['String']['input']>;
  RiskAssessmentResultId?: InputMaybe<Scalars['uuid']['input']>;
  Value?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Sum_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.risk_assessment_result_impact" */
export const Risk_Assessment_Result_Impact_Update_Column = {
  /** column name */
  Value: 'Value'
} as const;

export type Risk_Assessment_Result_Impact_Update_Column = typeof Risk_Assessment_Result_Impact_Update_Column[keyof typeof Risk_Assessment_Result_Impact_Update_Column];
/** order by var_pop() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Var_Pop_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Var_Samp_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.risk_assessment_result_impact" */
export type Risk_Assessment_Result_Impact_Variance_Order_By = {
  Value?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Insert_Input = {
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  impacts?: InputMaybe<Risk_Assessment_Result_Impact_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Assessment_Result_Max_Fields = {
  __typename?: 'risk_assessment_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Risk_Assessment_Result_Min_Fields = {
  __typename?: 'risk_assessment_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Mutation_Response = {
  __typename?: 'risk_assessment_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Assessment_Result>;
};

/** input type for inserting object relation for remote table "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_Obj_Rel_Insert_Input = {
  data: Risk_Assessment_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Assessment_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.risk_assessment_result" */
export type Risk_Assessment_Result_On_Conflict = {
  constraint: Risk_Assessment_Result_Constraint;
  update_columns?: Array<Risk_Assessment_Result_Update_Column>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_assessment_result". */
export type Risk_Assessment_Result_Order_By = {
  ControlType?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  impacts_aggregate?: InputMaybe<Risk_Assessment_Result_Impact_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
};

/** select columns of table "risksmart.risk_assessment_result" */
export const Risk_Assessment_Result_Select_Column = {
  /** column name */
  ControlType: 'ControlType',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Assessment_Result_Select_Column = typeof Risk_Assessment_Result_Select_Column[keyof typeof Risk_Assessment_Result_Select_Column];
/** aggregate stddev on columns */
export type Risk_Assessment_Result_Stddev_Fields = {
  __typename?: 'risk_assessment_result_stddev_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Assessment_Result_Stddev_Pop_Fields = {
  __typename?: 'risk_assessment_result_stddev_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Assessment_Result_Stddev_Samp_Fields = {
  __typename?: 'risk_assessment_result_stddev_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_assessment_result" */
export type Risk_Assessment_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Assessment_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Assessment_Result_Stream_Cursor_Value_Input = {
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risk_Assessment_Result_Sum_Fields = {
  __typename?: 'risk_assessment_result_sum_fields';
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.risk_assessment_result" */
export const Risk_Assessment_Result_Update_Column = {
  /** column name */
  ControlType: 'ControlType',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  Rating: 'Rating',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Assessment_Result_Update_Column = typeof Risk_Assessment_Result_Update_Column[keyof typeof Risk_Assessment_Result_Update_Column];
/** aggregate var_pop on columns */
export type Risk_Assessment_Result_Var_Pop_Fields = {
  __typename?: 'risk_assessment_result_var_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Assessment_Result_Var_Samp_Fields = {
  __typename?: 'risk_assessment_result_var_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Assessment_Result_Variance_Fields = {
  __typename?: 'risk_assessment_result_variance_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.risk_audit" */
export type Risk_Audit = {
  __typename?: 'risk_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Tier: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  Treatment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  acceptanceAudits: Array<Acceptance_Parent_Audit>;
  /** An array relationship */
  actionAudits: Array<Action_Parent_Audit>;
  /** An array relationship */
  appetiteAudits: Array<Appetite_Parent_Audit>;
  /** An aggregate relationship */
  appetiteAudits_aggregate: Appetite_Parent_Audit_Aggregate;
  /** An array relationship */
  assessmentResultAudits: Array<Assessment_Result_Parent_Audit>;
  /** An array relationship */
  contributorAudits: Array<Contributor_Audit>;
  /** An aggregate relationship */
  contributorAudits_aggregate: Contributor_Audit_Aggregate;
  /** An array relationship */
  contributorGroupAudits: Array<Contributor_Group_Audit>;
  /** An aggregate relationship */
  contributorGroupAudits_aggregate: Contributor_Group_Audit_Aggregate;
  /** An array relationship */
  controlAudits: Array<Control_Parent_Audit>;
  /** An array relationship */
  departmentAudits: Array<Department_Audit>;
  /** An array relationship */
  impactRatingAudits: Array<Impact_Rating_Audit>;
  /** An array relationship */
  indicatorAudits: Array<Risksmart_Indicator_Parent_Audit>;
  /** An array relationship */
  ownerAudits: Array<Owner_Audit>;
  /** An array relationship */
  ownerGroupAudits: Array<Owner_Group_Audit>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditAcceptanceAuditsArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Audit_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditActionAuditsArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Audit_Order_By>>;
  where?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditAppetiteAuditsArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditAppetiteAudits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditAssessmentResultAuditsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditContributorAuditsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditContributorAudits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditContributorGroupAuditsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditContributorGroupAudits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Audit_Order_By>>;
  where?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditControlAuditsArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Audit_Order_By>>;
  where?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditDepartmentAuditsArgs = {
  distinct_on?: InputMaybe<Array<Department_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Audit_Order_By>>;
  where?: InputMaybe<Department_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditImpactRatingAuditsArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Audit_Order_By>>;
  where?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditIndicatorAuditsArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditOwnerAuditsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Audit_Order_By>>;
  where?: InputMaybe<Owner_Audit_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_audit" */
export type Risk_AuditOwnerGroupAuditsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Audit_Order_By>>;
  where?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_audit" */
export type Risk_Audit_Aggregate = {
  __typename?: 'risk_audit_aggregate';
  aggregate?: Maybe<Risk_Audit_Aggregate_Fields>;
  nodes: Array<Risk_Audit>;
};

/** aggregate fields of "risksmart.risk_audit" */
export type Risk_Audit_Aggregate_Fields = {
  __typename?: 'risk_audit_aggregate_fields';
  avg?: Maybe<Risk_Audit_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Audit_Max_Fields>;
  min?: Maybe<Risk_Audit_Min_Fields>;
  stddev?: Maybe<Risk_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Audit_Sum_Fields>;
  var_pop?: Maybe<Risk_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Audit_Var_Samp_Fields>;
  variance?: Maybe<Risk_Audit_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_audit" */
export type Risk_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Risk_Audit_Avg_Fields = {
  __typename?: 'risk_audit_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_audit". All fields are combined with a logical 'AND'. */
export type Risk_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentRiskId?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Tier?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Treatment?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risk_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Audit_Bool_Exp>>;
  acceptanceAudits?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
  actionAudits?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
  appetiteAudits?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
  appetiteAudits_aggregate?: InputMaybe<Appetite_Parent_Audit_Aggregate_Bool_Exp>;
  assessmentResultAudits?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
  contributorAudits?: InputMaybe<Contributor_Audit_Bool_Exp>;
  contributorAudits_aggregate?: InputMaybe<Contributor_Audit_Aggregate_Bool_Exp>;
  contributorGroupAudits?: InputMaybe<Contributor_Group_Audit_Bool_Exp>;
  contributorGroupAudits_aggregate?: InputMaybe<Contributor_Group_Audit_Aggregate_Bool_Exp>;
  controlAudits?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
  departmentAudits?: InputMaybe<Department_Audit_Bool_Exp>;
  impactRatingAudits?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
  indicatorAudits?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
  ownerAudits?: InputMaybe<Owner_Audit_Bool_Exp>;
  ownerGroupAudits?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};

/** aggregate max on columns */
export type Risk_Audit_Max_Fields = {
  __typename?: 'risk_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Treatment?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Risk_Audit_Min_Fields = {
  __typename?: 'risk_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Treatment?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.risk_audit". */
export type Risk_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentRiskId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Treatment?: InputMaybe<Order_By>;
  acceptanceAudits_aggregate?: InputMaybe<Acceptance_Parent_Audit_Aggregate_Order_By>;
  actionAudits_aggregate?: InputMaybe<Action_Parent_Audit_Aggregate_Order_By>;
  appetiteAudits_aggregate?: InputMaybe<Appetite_Parent_Audit_Aggregate_Order_By>;
  assessmentResultAudits_aggregate?: InputMaybe<Assessment_Result_Parent_Audit_Aggregate_Order_By>;
  contributorAudits_aggregate?: InputMaybe<Contributor_Audit_Aggregate_Order_By>;
  contributorGroupAudits_aggregate?: InputMaybe<Contributor_Group_Audit_Aggregate_Order_By>;
  controlAudits_aggregate?: InputMaybe<Control_Parent_Audit_Aggregate_Order_By>;
  departmentAudits_aggregate?: InputMaybe<Department_Audit_Aggregate_Order_By>;
  impactRatingAudits_aggregate?: InputMaybe<Impact_Rating_Audit_Aggregate_Order_By>;
  indicatorAudits_aggregate?: InputMaybe<Risksmart_Indicator_Parent_Audit_Aggregate_Order_By>;
  ownerAudits_aggregate?: InputMaybe<Owner_Audit_Aggregate_Order_By>;
  ownerGroupAudits_aggregate?: InputMaybe<Owner_Group_Audit_Aggregate_Order_By>;
};

/** select columns of table "risksmart.risk_audit" */
export const Risk_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentRiskId: 'ParentRiskId',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Tier: 'Tier',
  /** column name */
  Title: 'Title',
  /** column name */
  Treatment: 'Treatment'
} as const;

export type Risk_Audit_Select_Column = typeof Risk_Audit_Select_Column[keyof typeof Risk_Audit_Select_Column];
/** aggregate stddev on columns */
export type Risk_Audit_Stddev_Fields = {
  __typename?: 'risk_audit_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Audit_Stddev_Pop_Fields = {
  __typename?: 'risk_audit_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Audit_Stddev_Samp_Fields = {
  __typename?: 'risk_audit_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_audit" */
export type Risk_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentRiskId?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Tier?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Risk_Audit_Sum_Fields = {
  __typename?: 'risk_audit_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Risk_Audit_Var_Pop_Fields = {
  __typename?: 'risk_audit_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Audit_Var_Samp_Fields = {
  __typename?: 'risk_audit_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Audit_Variance_Fields = {
  __typename?: 'risk_audit_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Risk_Avg_Fields = {
  __typename?: 'risk_avg_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.risk" */
export type Risk_Avg_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.risk". All fields are combined with a logical 'AND'. */
export type Risk_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentRiskId?: InputMaybe<Uuid_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<Risk_Status_Type_Enum_Comparison_Exp>;
  Tier?: InputMaybe<Int_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Bool_Exp>>;
  _not?: InputMaybe<Risk_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Bool_Exp>>;
  acceptances?: InputMaybe<Acceptance_Parent_Bool_Exp>;
  acceptances_aggregate?: InputMaybe<Acceptance_Parent_Aggregate_Bool_Exp>;
  actions?: InputMaybe<Action_Parent_Bool_Exp>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Bool_Exp>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  appetites?: InputMaybe<Appetite_Parent_Bool_Exp>;
  appetites_aggregate?: InputMaybe<Appetite_Parent_Aggregate_Bool_Exp>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  childRisks?: InputMaybe<Risk_Bool_Exp>;
  childRisks_aggregate?: InputMaybe<Risk_Aggregate_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  controls?: InputMaybe<Control_Parent_Bool_Exp>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  enterpriseRiskInstance?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
  impactRatings?: InputMaybe<Impact_Rating_Bool_Exp>;
  impactRatings_aggregate?: InputMaybe<Impact_Rating_Aggregate_Bool_Exp>;
  indicators?: InputMaybe<Indicator_Parent_Bool_Exp>;
  indicators_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Risk_Bool_Exp>;
  parentNode?: InputMaybe<Node_Bool_Exp>;
  riskScore?: InputMaybe<Risk_Score_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
  scheduleState?: InputMaybe<Schedule_State_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk" */
export const Risk_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxRiskOrgkeySequentialid: 'idx_risk_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  RiskPkey: 'risk_pkey'
} as const;

export type Risk_Constraint = typeof Risk_Constraint[keyof typeof Risk_Constraint];
/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result = {
  __typename?: 'risk_controlled_internal_audit_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Aggregate = {
  __typename?: 'risk_controlled_internal_audit_result_aggregate';
  aggregate?: Maybe<Risk_Controlled_Internal_Audit_Result_Aggregate_Fields>;
  nodes: Array<Risk_Controlled_Internal_Audit_Result>;
};

/** aggregate fields of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Aggregate_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_aggregate_fields';
  avg?: Maybe<Risk_Controlled_Internal_Audit_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Controlled_Internal_Audit_Result_Max_Fields>;
  min?: Maybe<Risk_Controlled_Internal_Audit_Result_Min_Fields>;
  stddev?: Maybe<Risk_Controlled_Internal_Audit_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Controlled_Internal_Audit_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Controlled_Internal_Audit_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Controlled_Internal_Audit_Result_Sum_Fields>;
  var_pop?: Maybe<Risk_Controlled_Internal_Audit_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Controlled_Internal_Audit_Result_Var_Samp_Fields>;
  variance?: Maybe<Risk_Controlled_Internal_Audit_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risk_Controlled_Internal_Audit_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Risk_Controlled_Internal_Audit_Result_Avg_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_avg_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_controlled_internal_audit_result". All fields are combined with a logical 'AND'. */
export type Risk_Controlled_Internal_Audit_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Bool_Exp>>;
  _not?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk_controlled_internal_audit_result" */
export const Risk_Controlled_Internal_Audit_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  RiskControlledInternalAuditResultPkey: 'risk_controlled_internal_audit_result_pkey'
} as const;

export type Risk_Controlled_Internal_Audit_Result_Constraint = typeof Risk_Controlled_Internal_Audit_Result_Constraint[keyof typeof Risk_Controlled_Internal_Audit_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risk_Controlled_Internal_Audit_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risk_Controlled_Internal_Audit_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risk_Controlled_Internal_Audit_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Inc_Input = {
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Controlled_Internal_Audit_Result_Max_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Risk_Controlled_Internal_Audit_Result_Min_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Mutation_Response = {
  __typename?: 'risk_controlled_internal_audit_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Controlled_Internal_Audit_Result>;
};

/** input type for inserting object relation for remote table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Obj_Rel_Insert_Input = {
  data: Risk_Controlled_Internal_Audit_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Controlled_Internal_Audit_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_On_Conflict = {
  constraint: Risk_Controlled_Internal_Audit_Result_Constraint;
  update_columns?: Array<Risk_Controlled_Internal_Audit_Result_Update_Column>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_controlled_internal_audit_result". */
export type Risk_Controlled_Internal_Audit_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.risk_controlled_internal_audit_result */
export type Risk_Controlled_Internal_Audit_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risk_Controlled_Internal_Audit_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.risk_controlled_internal_audit_result" */
export const Risk_Controlled_Internal_Audit_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Controlled_Internal_Audit_Result_Select_Column = typeof Risk_Controlled_Internal_Audit_Result_Select_Column[keyof typeof Risk_Controlled_Internal_Audit_Result_Select_Column];
/** input type for updating data in table "risksmart.risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Risk_Controlled_Internal_Audit_Result_Stddev_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_stddev_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Controlled_Internal_Audit_Result_Stddev_Pop_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_stddev_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Controlled_Internal_Audit_Result_Stddev_Samp_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_stddev_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_controlled_internal_audit_result" */
export type Risk_Controlled_Internal_Audit_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Controlled_Internal_Audit_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Controlled_Internal_Audit_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risk_Controlled_Internal_Audit_Result_Sum_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_sum_fields';
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.risk_controlled_internal_audit_result" */
export const Risk_Controlled_Internal_Audit_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Controlled_Internal_Audit_Result_Update_Column = typeof Risk_Controlled_Internal_Audit_Result_Update_Column[keyof typeof Risk_Controlled_Internal_Audit_Result_Update_Column];
export type Risk_Controlled_Internal_Audit_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Controlled_Internal_Audit_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risk_Controlled_Internal_Audit_Result_Var_Pop_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_var_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Controlled_Internal_Audit_Result_Var_Samp_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_var_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Controlled_Internal_Audit_Result_Variance_Fields = {
  __typename?: 'risk_controlled_internal_audit_result_variance_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result = {
  __typename?: 'risk_controlled_second_line_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Aggregate = {
  __typename?: 'risk_controlled_second_line_result_aggregate';
  aggregate?: Maybe<Risk_Controlled_Second_Line_Result_Aggregate_Fields>;
  nodes: Array<Risk_Controlled_Second_Line_Result>;
};

/** aggregate fields of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Aggregate_Fields = {
  __typename?: 'risk_controlled_second_line_result_aggregate_fields';
  avg?: Maybe<Risk_Controlled_Second_Line_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Controlled_Second_Line_Result_Max_Fields>;
  min?: Maybe<Risk_Controlled_Second_Line_Result_Min_Fields>;
  stddev?: Maybe<Risk_Controlled_Second_Line_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Controlled_Second_Line_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Controlled_Second_Line_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Controlled_Second_Line_Result_Sum_Fields>;
  var_pop?: Maybe<Risk_Controlled_Second_Line_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Controlled_Second_Line_Result_Var_Samp_Fields>;
  variance?: Maybe<Risk_Controlled_Second_Line_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risk_Controlled_Second_Line_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Risk_Controlled_Second_Line_Result_Avg_Fields = {
  __typename?: 'risk_controlled_second_line_result_avg_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_controlled_second_line_result". All fields are combined with a logical 'AND'. */
export type Risk_Controlled_Second_Line_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Bool_Exp>>;
  _not?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risk_Controlled_Second_Line_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risk_Controlled_Second_Line_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risk_Controlled_Second_Line_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Inc_Input = {
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Risk_Controlled_Second_Line_Result_Max_Fields = {
  __typename?: 'risk_controlled_second_line_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Risk_Controlled_Second_Line_Result_Min_Fields = {
  __typename?: 'risk_controlled_second_line_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Mutation_Response = {
  __typename?: 'risk_controlled_second_line_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Controlled_Second_Line_Result>;
};

/** Ordering options when selecting data from "risksmart.risk_controlled_second_line_result". */
export type Risk_Controlled_Second_Line_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.risk_controlled_second_line_result */
export type Risk_Controlled_Second_Line_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risk_Controlled_Second_Line_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.risk_controlled_second_line_result" */
export const Risk_Controlled_Second_Line_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Controlled_Second_Line_Result_Select_Column = typeof Risk_Controlled_Second_Line_Result_Select_Column[keyof typeof Risk_Controlled_Second_Line_Result_Select_Column];
/** input type for updating data in table "risksmart.risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Risk_Controlled_Second_Line_Result_Stddev_Fields = {
  __typename?: 'risk_controlled_second_line_result_stddev_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Controlled_Second_Line_Result_Stddev_Pop_Fields = {
  __typename?: 'risk_controlled_second_line_result_stddev_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Controlled_Second_Line_Result_Stddev_Samp_Fields = {
  __typename?: 'risk_controlled_second_line_result_stddev_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_controlled_second_line_result" */
export type Risk_Controlled_Second_Line_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Controlled_Second_Line_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Controlled_Second_Line_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risk_Controlled_Second_Line_Result_Sum_Fields = {
  __typename?: 'risk_controlled_second_line_result_sum_fields';
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
};

export type Risk_Controlled_Second_Line_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Risk_Controlled_Second_Line_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Risk_Controlled_Second_Line_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Risk_Controlled_Second_Line_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Risk_Controlled_Second_Line_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Controlled_Second_Line_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Controlled_Second_Line_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risk_Controlled_Second_Line_Result_Var_Pop_Fields = {
  __typename?: 'risk_controlled_second_line_result_var_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Controlled_Second_Line_Result_Var_Samp_Fields = {
  __typename?: 'risk_controlled_second_line_result_var_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Controlled_Second_Line_Result_Variance_Fields = {
  __typename?: 'risk_controlled_second_line_result_variance_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "risksmart.risk" */
export type Risk_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ParentRiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Risk_Status_Type_Enum>;
  Tier?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  acceptances?: InputMaybe<Acceptance_Parent_Arr_Rel_Insert_Input>;
  actions?: InputMaybe<Action_Parent_Arr_Rel_Insert_Input>;
  appetites?: InputMaybe<Appetite_Parent_Arr_Rel_Insert_Input>;
  assessmentResults?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  childRisks?: InputMaybe<Risk_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  controls?: InputMaybe<Control_Parent_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  enterpriseRiskInstance?: InputMaybe<Enterprise_Risk_Instance_Obj_Rel_Insert_Input>;
  impactRatings?: InputMaybe<Impact_Rating_Arr_Rel_Insert_Input>;
  indicators?: InputMaybe<Indicator_Parent_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
  riskScore?: InputMaybe<Risk_Score_Obj_Rel_Insert_Input>;
  schedule?: InputMaybe<Schedule_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Max_Fields = {
  __typename?: 'risk_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.risk" */
export type Risk_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentRiskId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risk_Min_Fields = {
  __typename?: 'risk_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentRiskId?: Maybe<Scalars['uuid']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.risk" */
export type Risk_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentRiskId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "risksmart.risk" */
export type Risk_Obj_Rel_Insert_Input = {
  data: Risk_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.risk" */
export type Risk_On_Conflict = {
  constraint: Risk_Constraint;
  update_columns?: Array<Risk_Update_Column>;
  where?: InputMaybe<Risk_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk". */
export type Risk_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentRiskId?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Treatment?: InputMaybe<Order_By>;
  acceptances_aggregate?: InputMaybe<Acceptance_Parent_Aggregate_Order_By>;
  actions_aggregate?: InputMaybe<Action_Parent_Aggregate_Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  appetites_aggregate?: InputMaybe<Appetite_Parent_Aggregate_Order_By>;
  assessmentResults_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  childRisks_aggregate?: InputMaybe<Risk_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  controls_aggregate?: InputMaybe<Control_Parent_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  enterpriseRiskInstance?: InputMaybe<Enterprise_Risk_Instance_Order_By>;
  impactRatings_aggregate?: InputMaybe<Impact_Rating_Aggregate_Order_By>;
  indicators_aggregate?: InputMaybe<Indicator_Parent_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  parent?: InputMaybe<Risk_Order_By>;
  parentNode?: InputMaybe<Node_Order_By>;
  riskScore?: InputMaybe<Risk_Score_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
  scheduleState?: InputMaybe<Schedule_State_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.risk_score" */
export type Risk_Score = {
  __typename?: 'risk_score';
  InherentImpact?: Maybe<Scalars['float8']['output']>;
  InherentLikelihood?: Maybe<Scalars['float8']['output']>;
  InherentRating?: Maybe<Scalars['Int']['output']>;
  InherentScore?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  OrgKey: Scalars['String']['output'];
  ResidualImpact?: Maybe<Scalars['float8']['output']>;
  ResidualLikelihood?: Maybe<Scalars['float8']['output']>;
  ResidualRating?: Maybe<Scalars['Int']['output']>;
  ResidualScore?: Maybe<Scalars['float8']['output']>;
  RiskId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  risk?: Maybe<Risk>;
};

/** aggregated selection of "risksmart.risk_score" */
export type Risk_Score_Aggregate = {
  __typename?: 'risk_score_aggregate';
  aggregate?: Maybe<Risk_Score_Aggregate_Fields>;
  nodes: Array<Risk_Score>;
};

/** aggregate fields of "risksmart.risk_score" */
export type Risk_Score_Aggregate_Fields = {
  __typename?: 'risk_score_aggregate_fields';
  avg?: Maybe<Risk_Score_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Score_Max_Fields>;
  min?: Maybe<Risk_Score_Min_Fields>;
  stddev?: Maybe<Risk_Score_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Score_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Score_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Score_Sum_Fields>;
  var_pop?: Maybe<Risk_Score_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Score_Var_Samp_Fields>;
  variance?: Maybe<Risk_Score_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_score" */
export type Risk_Score_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Score_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Risk_Score_Avg_Fields = {
  __typename?: 'risk_score_avg_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_score". All fields are combined with a logical 'AND'. */
export type Risk_Score_Bool_Exp = {
  InherentImpact?: InputMaybe<Float8_Comparison_Exp>;
  InherentLikelihood?: InputMaybe<Float8_Comparison_Exp>;
  InherentRating?: InputMaybe<Int_Comparison_Exp>;
  InherentScore?: InputMaybe<Float8_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ResidualImpact?: InputMaybe<Float8_Comparison_Exp>;
  ResidualLikelihood?: InputMaybe<Float8_Comparison_Exp>;
  ResidualRating?: InputMaybe<Int_Comparison_Exp>;
  ResidualScore?: InputMaybe<Float8_Comparison_Exp>;
  RiskId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Score_Bool_Exp>>;
  _not?: InputMaybe<Risk_Score_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Score_Bool_Exp>>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk_score" */
export const Risk_Score_Constraint = {
  /** unique or primary key constraint on columns "RiskId" */
  RiskScorePkey: 'risk_score_pkey'
} as const;

export type Risk_Score_Constraint = typeof Risk_Score_Constraint[keyof typeof Risk_Score_Constraint];
/** input type for inserting data into table "risksmart.risk_score" */
export type Risk_Score_Insert_Input = {
  InherentImpact?: InputMaybe<Scalars['float8']['input']>;
  InherentLikelihood?: InputMaybe<Scalars['float8']['input']>;
  InherentRating?: InputMaybe<Scalars['Int']['input']>;
  InherentScore?: InputMaybe<Scalars['float8']['input']>;
  ResidualImpact?: InputMaybe<Scalars['float8']['input']>;
  ResidualLikelihood?: InputMaybe<Scalars['float8']['input']>;
  ResidualRating?: InputMaybe<Scalars['Int']['input']>;
  ResidualScore?: InputMaybe<Scalars['float8']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<Risk_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Score_Max_Fields = {
  __typename?: 'risk_score_max_fields';
  InherentImpact?: Maybe<Scalars['float8']['output']>;
  InherentLikelihood?: Maybe<Scalars['float8']['output']>;
  InherentRating?: Maybe<Scalars['Int']['output']>;
  InherentScore?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ResidualImpact?: Maybe<Scalars['float8']['output']>;
  ResidualLikelihood?: Maybe<Scalars['float8']['output']>;
  ResidualRating?: Maybe<Scalars['Int']['output']>;
  ResidualScore?: Maybe<Scalars['float8']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Risk_Score_Min_Fields = {
  __typename?: 'risk_score_min_fields';
  InherentImpact?: Maybe<Scalars['float8']['output']>;
  InherentLikelihood?: Maybe<Scalars['float8']['output']>;
  InherentRating?: Maybe<Scalars['Int']['output']>;
  InherentScore?: Maybe<Scalars['float8']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  ResidualImpact?: Maybe<Scalars['float8']['output']>;
  ResidualLikelihood?: Maybe<Scalars['float8']['output']>;
  ResidualRating?: Maybe<Scalars['Int']['output']>;
  ResidualScore?: Maybe<Scalars['float8']['output']>;
  RiskId?: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "risksmart.risk_score" */
export type Risk_Score_Obj_Rel_Insert_Input = {
  data: Risk_Score_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Score_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.risk_score" */
export type Risk_Score_On_Conflict = {
  constraint: Risk_Score_Constraint;
  update_columns?: Array<Risk_Score_Update_Column>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_score". */
export type Risk_Score_Order_By = {
  InherentImpact?: InputMaybe<Order_By>;
  InherentLikelihood?: InputMaybe<Order_By>;
  InherentRating?: InputMaybe<Order_By>;
  InherentScore?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ResidualImpact?: InputMaybe<Order_By>;
  ResidualLikelihood?: InputMaybe<Order_By>;
  ResidualRating?: InputMaybe<Order_By>;
  ResidualScore?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.risk_score" */
export const Risk_Score_Select_Column = {
  /** column name */
  InherentImpact: 'InherentImpact',
  /** column name */
  InherentLikelihood: 'InherentLikelihood',
  /** column name */
  InherentRating: 'InherentRating',
  /** column name */
  InherentScore: 'InherentScore',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ResidualImpact: 'ResidualImpact',
  /** column name */
  ResidualLikelihood: 'ResidualLikelihood',
  /** column name */
  ResidualRating: 'ResidualRating',
  /** column name */
  ResidualScore: 'ResidualScore',
  /** column name */
  RiskId: 'RiskId'
} as const;

export type Risk_Score_Select_Column = typeof Risk_Score_Select_Column[keyof typeof Risk_Score_Select_Column];
/** aggregate stddev on columns */
export type Risk_Score_Stddev_Fields = {
  __typename?: 'risk_score_stddev_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Score_Stddev_Pop_Fields = {
  __typename?: 'risk_score_stddev_pop_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Score_Stddev_Samp_Fields = {
  __typename?: 'risk_score_stddev_samp_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_score" */
export type Risk_Score_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Score_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Score_Stream_Cursor_Value_Input = {
  InherentImpact?: InputMaybe<Scalars['float8']['input']>;
  InherentLikelihood?: InputMaybe<Scalars['float8']['input']>;
  InherentRating?: InputMaybe<Scalars['Int']['input']>;
  InherentScore?: InputMaybe<Scalars['float8']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ResidualImpact?: InputMaybe<Scalars['float8']['input']>;
  ResidualLikelihood?: InputMaybe<Scalars['float8']['input']>;
  ResidualRating?: InputMaybe<Scalars['Int']['input']>;
  ResidualScore?: InputMaybe<Scalars['float8']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Risk_Score_Sum_Fields = {
  __typename?: 'risk_score_sum_fields';
  InherentImpact?: Maybe<Scalars['float8']['output']>;
  InherentLikelihood?: Maybe<Scalars['float8']['output']>;
  InherentRating?: Maybe<Scalars['Int']['output']>;
  InherentScore?: Maybe<Scalars['float8']['output']>;
  ResidualImpact?: Maybe<Scalars['float8']['output']>;
  ResidualLikelihood?: Maybe<Scalars['float8']['output']>;
  ResidualRating?: Maybe<Scalars['Int']['output']>;
  ResidualScore?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "risksmart.risk_score" */
export const Risk_Score_Update_Column = {
  /** column name */
  InherentImpact: 'InherentImpact',
  /** column name */
  InherentLikelihood: 'InherentLikelihood',
  /** column name */
  InherentRating: 'InherentRating',
  /** column name */
  InherentScore: 'InherentScore',
  /** column name */
  ResidualImpact: 'ResidualImpact',
  /** column name */
  ResidualLikelihood: 'ResidualLikelihood',
  /** column name */
  ResidualRating: 'ResidualRating',
  /** column name */
  ResidualScore: 'ResidualScore',
  /** column name */
  RiskId: 'RiskId'
} as const;

export type Risk_Score_Update_Column = typeof Risk_Score_Update_Column[keyof typeof Risk_Score_Update_Column];
/** aggregate var_pop on columns */
export type Risk_Score_Var_Pop_Fields = {
  __typename?: 'risk_score_var_pop_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Score_Var_Samp_Fields = {
  __typename?: 'risk_score_var_samp_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Score_Variance_Fields = {
  __typename?: 'risk_score_variance_fields';
  InherentImpact?: Maybe<Scalars['Float']['output']>;
  InherentLikelihood?: Maybe<Scalars['Float']['output']>;
  InherentRating?: Maybe<Scalars['Float']['output']>;
  InherentScore?: Maybe<Scalars['Float']['output']>;
  ResidualImpact?: Maybe<Scalars['Float']['output']>;
  ResidualLikelihood?: Maybe<Scalars['Float']['output']>;
  ResidualRating?: Maybe<Scalars['Float']['output']>;
  ResidualScore?: Maybe<Scalars['Float']['output']>;
};

export const Risk_Scoring_Model_Enum = {
  /** Control effectiveness averages */
  ControlEffectivenessAverages: 'control_effectiveness_averages',
  /** Default model */
  Default: 'default',
  /** Number of controls with gaps */
  NumberOfControlsWithGaps: 'number_of_controls_with_gaps',
  /** Effectiveness averages for each control type */
  TypedControlEffectivenessAverages: 'typed_control_effectiveness_averages'
} as const;

export type Risk_Scoring_Model_Enum = typeof Risk_Scoring_Model_Enum[keyof typeof Risk_Scoring_Model_Enum];
/** Boolean expression to compare columns of type "risk_scoring_model_enum". All fields are combined with logical 'AND'. */
export type Risk_Scoring_Model_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Scoring_Model_Enum>;
  _in?: InputMaybe<Array<Risk_Scoring_Model_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Scoring_Model_Enum>;
  _nin?: InputMaybe<Array<Risk_Scoring_Model_Enum>>;
};

/** select columns of table "risksmart.risk" */
export const Risk_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentRiskId: 'ParentRiskId',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Tier: 'Tier',
  /** column name */
  Title: 'Title',
  /** column name */
  Treatment: 'Treatment'
} as const;

export type Risk_Select_Column = typeof Risk_Select_Column[keyof typeof Risk_Select_Column];
export const Risk_Status_Type_Enum = {
  /** Active */
  Active: 'active',
  /** Emerging */
  Emerging: 'emerging',
  /** Monitored */
  Monitored: 'monitored',
  /** Retired */
  Retired: 'retired'
} as const;

export type Risk_Status_Type_Enum = typeof Risk_Status_Type_Enum[keyof typeof Risk_Status_Type_Enum];
/** Boolean expression to compare columns of type "risk_status_type_enum". All fields are combined with logical 'AND'. */
export type Risk_Status_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Status_Type_Enum>;
  _in?: InputMaybe<Array<Risk_Status_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Status_Type_Enum>;
  _nin?: InputMaybe<Array<Risk_Status_Type_Enum>>;
};

/** aggregate stddev on columns */
export type Risk_Stddev_Fields = {
  __typename?: 'risk_stddev_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.risk" */
export type Risk_Stddev_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risk_Stddev_Pop_Fields = {
  __typename?: 'risk_stddev_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.risk" */
export type Risk_Stddev_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risk_Stddev_Samp_Fields = {
  __typename?: 'risk_stddev_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.risk" */
export type Risk_Stddev_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "risk" */
export type Risk_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentRiskId?: InputMaybe<Scalars['uuid']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Risk_Status_Type_Enum>;
  Tier?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
};

/** aggregate sum on columns */
export type Risk_Sum_Fields = {
  __typename?: 'risk_sum_fields';
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Tier?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.risk" */
export type Risk_Sum_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

export const Risk_Treatment_Type_Enum = {
  /** Terminate */
  Terminate: 'terminate',
  /** Tolerate */
  Tolerate: 'tolerate',
  /** Transfer */
  Transfer: 'transfer',
  /** Treat */
  Treat: 'treat'
} as const;

export type Risk_Treatment_Type_Enum = typeof Risk_Treatment_Type_Enum[keyof typeof Risk_Treatment_Type_Enum];
/** Boolean expression to compare columns of type "risk_treatment_type_enum". All fields are combined with logical 'AND'. */
export type Risk_Treatment_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Risk_Treatment_Type_Enum>;
  _in?: InputMaybe<Array<Risk_Treatment_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Risk_Treatment_Type_Enum>;
  _nin?: InputMaybe<Array<Risk_Treatment_Type_Enum>>;
};

/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result = {
  __typename?: 'risk_uncontrolled_internal_audit_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Internal_Audit_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Internal_Audit_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Aggregate = {
  __typename?: 'risk_uncontrolled_internal_audit_result_aggregate';
  aggregate?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Aggregate_Fields>;
  nodes: Array<Risk_Uncontrolled_Internal_Audit_Result>;
};

/** aggregate fields of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Aggregate_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_aggregate_fields';
  avg?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Max_Fields>;
  min?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Min_Fields>;
  stddev?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Sum_Fields>;
  var_pop?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Var_Samp_Fields>;
  variance?: Maybe<Risk_Uncontrolled_Internal_Audit_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risk_Uncontrolled_Internal_Audit_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Avg_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_avg_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_uncontrolled_internal_audit_result". All fields are combined with a logical 'AND'. */
export type Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>>;
  _not?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.risk_uncontrolled_internal_audit_result" */
export const Risk_Uncontrolled_Internal_Audit_Result_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  RiskUncontrolledInternalAuditResultPkey: 'risk_uncontrolled_internal_audit_result_pkey'
} as const;

export type Risk_Uncontrolled_Internal_Audit_Result_Constraint = typeof Risk_Uncontrolled_Internal_Audit_Result_Constraint[keyof typeof Risk_Uncontrolled_Internal_Audit_Result_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risk_Uncontrolled_Internal_Audit_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risk_Uncontrolled_Internal_Audit_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risk_Uncontrolled_Internal_Audit_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Inc_Input = {
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parents?: InputMaybe<Internal_Audit_Result_Parent_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Max_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Min_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Mutation_Response = {
  __typename?: 'risk_uncontrolled_internal_audit_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Uncontrolled_Internal_Audit_Result>;
};

/** input type for inserting object relation for remote table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Obj_Rel_Insert_Input = {
  data: Risk_Uncontrolled_Internal_Audit_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_On_Conflict = {
  constraint: Risk_Uncontrolled_Internal_Audit_Result_Constraint;
  update_columns?: Array<Risk_Uncontrolled_Internal_Audit_Result_Update_Column>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.risk_uncontrolled_internal_audit_result". */
export type Risk_Uncontrolled_Internal_Audit_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Internal_Audit_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.risk_uncontrolled_internal_audit_result */
export type Risk_Uncontrolled_Internal_Audit_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risk_Uncontrolled_Internal_Audit_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.risk_uncontrolled_internal_audit_result" */
export const Risk_Uncontrolled_Internal_Audit_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Uncontrolled_Internal_Audit_Result_Select_Column = typeof Risk_Uncontrolled_Internal_Audit_Result_Select_Column[keyof typeof Risk_Uncontrolled_Internal_Audit_Result_Select_Column];
/** input type for updating data in table "risksmart.risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Stddev_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_stddev_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Stddev_Pop_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_stddev_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Stddev_Samp_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_stddev_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_uncontrolled_internal_audit_result" */
export type Risk_Uncontrolled_Internal_Audit_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Uncontrolled_Internal_Audit_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Uncontrolled_Internal_Audit_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Sum_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_sum_fields';
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risksmart.risk_uncontrolled_internal_audit_result" */
export const Risk_Uncontrolled_Internal_Audit_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Uncontrolled_Internal_Audit_Result_Update_Column = typeof Risk_Uncontrolled_Internal_Audit_Result_Update_Column[keyof typeof Risk_Uncontrolled_Internal_Audit_Result_Update_Column];
export type Risk_Uncontrolled_Internal_Audit_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Var_Pop_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_var_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Var_Samp_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_var_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Uncontrolled_Internal_Audit_Result_Variance_Fields = {
  __typename?: 'risk_uncontrolled_internal_audit_result_variance_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result = {
  __typename?: 'risk_uncontrolled_second_line_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Id: Scalars['uuid']['output'];
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  parents: Array<Second_Line_Result_Parent>;
  /** An aggregate relationship */
  parents_aggregate: Second_Line_Result_Parent_Aggregate;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultParentsArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_ResultParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};

/** aggregated selection of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Aggregate = {
  __typename?: 'risk_uncontrolled_second_line_result_aggregate';
  aggregate?: Maybe<Risk_Uncontrolled_Second_Line_Result_Aggregate_Fields>;
  nodes: Array<Risk_Uncontrolled_Second_Line_Result>;
};

/** aggregate fields of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Aggregate_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_aggregate_fields';
  avg?: Maybe<Risk_Uncontrolled_Second_Line_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Uncontrolled_Second_Line_Result_Max_Fields>;
  min?: Maybe<Risk_Uncontrolled_Second_Line_Result_Min_Fields>;
  stddev?: Maybe<Risk_Uncontrolled_Second_Line_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Uncontrolled_Second_Line_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Uncontrolled_Second_Line_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Uncontrolled_Second_Line_Result_Sum_Fields>;
  var_pop?: Maybe<Risk_Uncontrolled_Second_Line_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Uncontrolled_Second_Line_Result_Var_Samp_Fields>;
  variance?: Maybe<Risk_Uncontrolled_Second_Line_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risk_Uncontrolled_Second_Line_Result_Append_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Risk_Uncontrolled_Second_Line_Result_Avg_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_avg_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.risk_uncontrolled_second_line_result". All fields are combined with a logical 'AND'. */
export type Risk_Uncontrolled_Second_Line_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Impact?: InputMaybe<Int_Comparison_Exp>;
  Likelihood?: InputMaybe<Int_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Int_Comparison_Exp>;
  Rationale?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>>;
  _not?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parents?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risk_Uncontrolled_Second_Line_Result_Delete_At_Path_Input = {
  CustomAttributeData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risk_Uncontrolled_Second_Line_Result_Delete_Elem_Input = {
  CustomAttributeData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risk_Uncontrolled_Second_Line_Result_Delete_Key_Input = {
  CustomAttributeData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Inc_Input = {
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Risk_Uncontrolled_Second_Line_Result_Max_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Risk_Uncontrolled_Second_Line_Result_Min_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
  Rationale?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Mutation_Response = {
  __typename?: 'risk_uncontrolled_second_line_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Uncontrolled_Second_Line_Result>;
};

/** Ordering options when selecting data from "risksmart.risk_uncontrolled_second_line_result". */
export type Risk_Uncontrolled_Second_Line_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Impact?: InputMaybe<Order_By>;
  Likelihood?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Rationale?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parents_aggregate?: InputMaybe<Second_Line_Result_Parent_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.risk_uncontrolled_second_line_result */
export type Risk_Uncontrolled_Second_Line_Result_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risk_Uncontrolled_Second_Line_Result_Prepend_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.risk_uncontrolled_second_line_result" */
export const Risk_Uncontrolled_Second_Line_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Id: 'Id',
  /** column name */
  Impact: 'Impact',
  /** column name */
  Likelihood: 'Likelihood',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Rationale: 'Rationale',
  /** column name */
  TestDate: 'TestDate'
} as const;

export type Risk_Uncontrolled_Second_Line_Result_Select_Column = typeof Risk_Uncontrolled_Second_Line_Result_Select_Column[keyof typeof Risk_Uncontrolled_Second_Line_Result_Select_Column];
/** input type for updating data in table "risksmart.risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Set_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Risk_Uncontrolled_Second_Line_Result_Stddev_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_stddev_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Uncontrolled_Second_Line_Result_Stddev_Pop_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_stddev_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Uncontrolled_Second_Line_Result_Stddev_Samp_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_stddev_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_uncontrolled_second_line_result" */
export type Risk_Uncontrolled_Second_Line_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Uncontrolled_Second_Line_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Uncontrolled_Second_Line_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Risk_Uncontrolled_Second_Line_Result_Sum_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_sum_fields';
  Impact?: Maybe<Scalars['Int']['output']>;
  Likelihood?: Maybe<Scalars['Int']['output']>;
  Rating?: Maybe<Scalars['Int']['output']>;
};

export type Risk_Uncontrolled_Second_Line_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Uncontrolled_Second_Line_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risk_Uncontrolled_Second_Line_Result_Var_Pop_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_var_pop_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Uncontrolled_Second_Line_Result_Var_Samp_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_var_samp_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Uncontrolled_Second_Line_Result_Variance_Fields = {
  __typename?: 'risk_uncontrolled_second_line_result_variance_fields';
  Impact?: Maybe<Scalars['Float']['output']>;
  Likelihood?: Maybe<Scalars['Float']['output']>;
  Rating?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "risksmart.risk" */
export const Risk_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  ParentRiskId: 'ParentRiskId',
  /** column name */
  Status: 'Status',
  /** column name */
  Tier: 'Tier',
  /** column name */
  Title: 'Title',
  /** column name */
  Treatment: 'Treatment'
} as const;

export type Risk_Update_Column = typeof Risk_Update_Column[keyof typeof Risk_Update_Column];
/** aggregate var_pop on columns */
export type Risk_Var_Pop_Fields = {
  __typename?: 'risk_var_pop_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.risk" */
export type Risk_Var_Pop_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risk_Var_Samp_Fields = {
  __typename?: 'risk_var_samp_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.risk" */
export type Risk_Var_Samp_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Risk_Variance_Fields = {
  __typename?: 'risk_variance_fields';
  SequentialId?: Maybe<Scalars['Float']['output']>;
  Tier?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.risk" */
export type Risk_Variance_Order_By = {
  SequentialId?: InputMaybe<Order_By>;
  Tier?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.indicator_parent_audit" */
export type Risksmart_Indicator_Parent_Audit = {
  __typename?: 'risksmart_indicator_parent_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  IndicatorId: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risksmart.indicator_parent_audit" */
export type Risksmart_Indicator_Parent_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risksmart_Indicator_Parent_Audit_Max_Order_By>;
  min?: InputMaybe<Risksmart_Indicator_Parent_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.indicator_parent_audit". All fields are combined with a logical 'AND'. */
export type Risksmart_Indicator_Parent_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  IndicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.indicator_parent_audit" */
export type Risksmart_Indicator_Parent_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.indicator_parent_audit" */
export type Risksmart_Indicator_Parent_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.indicator_parent_audit". */
export type Risksmart_Indicator_Parent_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  IndicatorId?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.indicator_parent_audit" */
export const Risksmart_Indicator_Parent_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  IndicatorId: 'IndicatorId',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId'
} as const;

export type Risksmart_Indicator_Parent_Audit_Select_Column = typeof Risksmart_Indicator_Parent_Audit_Select_Column[keyof typeof Risksmart_Indicator_Parent_Audit_Select_Column];
/** Streaming cursor of the table "risksmart_indicator_parent_audit" */
export type Risksmart_Indicator_Parent_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risksmart_Indicator_Parent_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risksmart_Indicator_Parent_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  IndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "risksmart.linked_item_audit" */
export type Risksmart_Linked_Item_Audit = {
  __typename?: 'risksmart_linked_item_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  RelationshipType?: Maybe<Scalars['String']['output']>;
  Source: Scalars['uuid']['output'];
  Target: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.linked_item_audit". All fields are combined with a logical 'AND'. */
export type Risksmart_Linked_Item_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RelationshipType?: InputMaybe<String_Comparison_Exp>;
  Source?: InputMaybe<Uuid_Comparison_Exp>;
  Target?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Bool_Exp>>;
  _not?: InputMaybe<Risksmart_Linked_Item_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.linked_item_audit". */
export type Risksmart_Linked_Item_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RelationshipType?: InputMaybe<Order_By>;
  Source?: InputMaybe<Order_By>;
  Target?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.linked_item_audit" */
export const Risksmart_Linked_Item_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RelationshipType: 'RelationshipType',
  /** column name */
  Source: 'Source',
  /** column name */
  Target: 'Target'
} as const;

export type Risksmart_Linked_Item_Audit_Select_Column = typeof Risksmart_Linked_Item_Audit_Select_Column[keyof typeof Risksmart_Linked_Item_Audit_Select_Column];
/** Streaming cursor of the table "risksmart_linked_item_audit" */
export type Risksmart_Linked_Item_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risksmart_Linked_Item_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risksmart_Linked_Item_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RelationshipType?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['uuid']['input']>;
  Target?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "risksmart.role_access" */
export type Role_Access = {
  __typename?: 'role_access';
  AccessType: Access_Type_Enum;
  ContributorType: Contributor_Type_Enum;
  ObjectType: Parent_Type_Enum;
};

/** Boolean expression to filter rows from the table "risksmart.role_access". All fields are combined with a logical 'AND'. */
export type Role_Access_Bool_Exp = {
  AccessType?: InputMaybe<Access_Type_Enum_Comparison_Exp>;
  ContributorType?: InputMaybe<Contributor_Type_Enum_Comparison_Exp>;
  ObjectType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Role_Access_Bool_Exp>>;
  _not?: InputMaybe<Role_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Access_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.role_access". */
export type Role_Access_Order_By = {
  AccessType?: InputMaybe<Order_By>;
  ContributorType?: InputMaybe<Order_By>;
  ObjectType?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.role_access" */
export const Role_Access_Select_Column = {
  /** column name */
  AccessType: 'AccessType',
  /** column name */
  ContributorType: 'ContributorType',
  /** column name */
  ObjectType: 'ObjectType'
} as const;

export type Role_Access_Select_Column = typeof Role_Access_Select_Column[keyof typeof Role_Access_Select_Column];
/** Streaming cursor of the table "role_access" */
export type Role_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Access_Stream_Cursor_Value_Input = {
  AccessType?: InputMaybe<Access_Type_Enum>;
  ContributorType?: InputMaybe<Contributor_Type_Enum>;
  ObjectType?: InputMaybe<Parent_Type_Enum>;
};

/** columns and relationships of "risksmart.schedule" */
export type Schedule = {
  __typename?: 'schedule';
  Frequency?: Maybe<Test_Frequency_Enum>;
  Id: Scalars['uuid']['output'];
  ManualDueDate?: Maybe<Scalars['timestamptz']['output']>;
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  TimeToCompleteUnit?: Maybe<Unit_Of_Time_Enum>;
  TimeToCompleteValue?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.schedule". All fields are combined with a logical 'AND'. */
export type Schedule_Bool_Exp = {
  Frequency?: InputMaybe<Test_Frequency_Enum_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ManualDueDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TimeToCompleteUnit?: InputMaybe<Unit_Of_Time_Enum_Comparison_Exp>;
  TimeToCompleteValue?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Schedule_Bool_Exp>>;
  _not?: InputMaybe<Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Schedule_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.schedule" */
export const Schedule_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  SchedulePkey: 'schedule_pkey'
} as const;

export type Schedule_Constraint = typeof Schedule_Constraint[keyof typeof Schedule_Constraint];
/** input type for inserting data into table "risksmart.schedule" */
export type Schedule_Insert_Input = {
  Frequency?: InputMaybe<Test_Frequency_Enum>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ManualDueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TimeToCompleteUnit?: InputMaybe<Unit_Of_Time_Enum>;
  TimeToCompleteValue?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting object relation for remote table "risksmart.schedule" */
export type Schedule_Obj_Rel_Insert_Input = {
  data: Schedule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Schedule_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.schedule" */
export type Schedule_On_Conflict = {
  constraint: Schedule_Constraint;
  update_columns?: Array<Schedule_Update_Column>;
  where?: InputMaybe<Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.schedule". */
export type Schedule_Order_By = {
  Frequency?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ManualDueDate?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  TimeToCompleteUnit?: InputMaybe<Order_By>;
  TimeToCompleteValue?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.schedule_state" */
export type Schedule_State = {
  __typename?: 'schedule_state';
  DueDate?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  LatestDate?: Maybe<Scalars['timestamptz']['output']>;
  OverdueDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  schedule?: Maybe<Schedule>;
};

/** Boolean expression to filter rows from the table "risksmart.schedule_state". All fields are combined with a logical 'AND'. */
export type Schedule_State_Bool_Exp = {
  DueDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LatestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  OverdueDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  _and?: InputMaybe<Array<Schedule_State_Bool_Exp>>;
  _not?: InputMaybe<Schedule_State_Bool_Exp>;
  _or?: InputMaybe<Array<Schedule_State_Bool_Exp>>;
  parent?: InputMaybe<Node_Bool_Exp>;
  schedule?: InputMaybe<Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.schedule_state". */
export type Schedule_State_Order_By = {
  DueDate?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LatestDate?: InputMaybe<Order_By>;
  OverdueDate?: InputMaybe<Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  schedule?: InputMaybe<Schedule_Order_By>;
};

/** update columns of table "risksmart.schedule" */
export const Schedule_Update_Column = {
  /** column name */
  Frequency: 'Frequency',
  /** column name */
  ManualDueDate: 'ManualDueDate',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  TimeToCompleteUnit: 'TimeToCompleteUnit',
  /** column name */
  TimeToCompleteValue: 'TimeToCompleteValue'
} as const;

export type Schedule_Update_Column = typeof Schedule_Update_Column[keyof typeof Schedule_Update_Column];
/** columns and relationships of "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent = {
  __typename?: 'second_line_result_parent';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  ParentType: Parent_Type_Enum;
  ResultType: Parent_Type_Enum;
  /** An object relationship */
  assessment_result?: Maybe<Node>;
  /** An object relationship */
  complianceMonitoringAssessment?: Maybe<Compliance_Monitoring_Assessment>;
  /** An object relationship */
  controlledRiskAssessmentResult?: Maybe<Risk_Controlled_Second_Line_Result>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  document?: Maybe<Document>;
  /** An object relationship */
  documentAssessmentResult?: Maybe<Document_Second_Line_Result>;
  /** An object relationship */
  impactRating?: Maybe<Impact_Second_Line_Rating>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  node?: Maybe<Node>;
  /** An object relationship */
  obligation?: Maybe<Obligation>;
  /** An object relationship */
  obligationAssessmentResult?: Maybe<Obligation_Second_Line_Result>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Node>;
  /** An object relationship */
  risk?: Maybe<Risk>;
  /** An object relationship */
  testResult?: Maybe<Control_Test_Second_Line_Result>;
  /** An object relationship */
  uncontrolledRiskAssessmentResult?: Maybe<Risk_Uncontrolled_Second_Line_Result>;
};

/** aggregated selection of "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Aggregate = {
  __typename?: 'second_line_result_parent_aggregate';
  aggregate?: Maybe<Second_Line_Result_Parent_Aggregate_Fields>;
  nodes: Array<Second_Line_Result_Parent>;
};

export type Second_Line_Result_Parent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Second_Line_Result_Parent_Aggregate_Bool_Exp_Count>;
};

export type Second_Line_Result_Parent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Aggregate_Fields = {
  __typename?: 'second_line_result_parent_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Second_Line_Result_Parent_Max_Fields>;
  min?: Maybe<Second_Line_Result_Parent_Min_Fields>;
};


/** aggregate fields of "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Second_Line_Result_Parent_Max_Order_By>;
  min?: InputMaybe<Second_Line_Result_Parent_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.second_line_result_parent". All fields are combined with a logical 'AND'. */
export type Second_Line_Result_Parent_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  ResultType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Second_Line_Result_Parent_Bool_Exp>>;
  _not?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
  _or?: InputMaybe<Array<Second_Line_Result_Parent_Bool_Exp>>;
  assessment_result?: InputMaybe<Node_Bool_Exp>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
  controlledRiskAssessmentResult?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  documentAssessmentResult?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
  impactRating?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  node?: InputMaybe<Node_Bool_Exp>;
  obligation?: InputMaybe<Obligation_Bool_Exp>;
  obligationAssessmentResult?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Node_Bool_Exp>;
  risk?: InputMaybe<Risk_Bool_Exp>;
  testResult?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
  uncontrolledRiskAssessmentResult?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};

/** aggregate max on columns */
export type Second_Line_Result_Parent_Max_Fields = {
  __typename?: 'second_line_result_parent_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Second_Line_Result_Parent_Min_Fields = {
  __typename?: 'second_line_result_parent_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  ParentId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.second_line_result_parent" */
export type Second_Line_Result_Parent_Mutation_Response = {
  __typename?: 'second_line_result_parent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Second_Line_Result_Parent>;
};

/** Ordering options when selecting data from "risksmart.second_line_result_parent". */
export type Second_Line_Result_Parent_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  ParentType?: InputMaybe<Order_By>;
  ResultType?: InputMaybe<Order_By>;
  assessment_result?: InputMaybe<Node_Order_By>;
  complianceMonitoringAssessment?: InputMaybe<Compliance_Monitoring_Assessment_Order_By>;
  controlledRiskAssessmentResult?: InputMaybe<Risk_Controlled_Second_Line_Result_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  documentAssessmentResult?: InputMaybe<Document_Second_Line_Result_Order_By>;
  impactRating?: InputMaybe<Impact_Second_Line_Rating_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  node?: InputMaybe<Node_Order_By>;
  obligation?: InputMaybe<Obligation_Order_By>;
  obligationAssessmentResult?: InputMaybe<Obligation_Second_Line_Result_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Node_Order_By>;
  risk?: InputMaybe<Risk_Order_By>;
  testResult?: InputMaybe<Control_Test_Second_Line_Result_Order_By>;
  uncontrolledRiskAssessmentResult?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Order_By>;
};

/** select columns of table "risksmart.second_line_result_parent" */
export const Second_Line_Result_Parent_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  ParentType: 'ParentType',
  /** column name */
  ResultType: 'ResultType'
} as const;

export type Second_Line_Result_Parent_Select_Column = typeof Second_Line_Result_Parent_Select_Column[keyof typeof Second_Line_Result_Parent_Select_Column];
/** Streaming cursor of the table "second_line_result_parent" */
export type Second_Line_Result_Parent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Second_Line_Result_Parent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Second_Line_Result_Parent_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ParentType?: InputMaybe<Parent_Type_Enum>;
  ResultType?: InputMaybe<Parent_Type_Enum>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "risksmart.acceptance" */
  acceptance: Array<Acceptance>;
  /** fetch aggregated fields from the table: "risksmart.acceptance" */
  acceptance_aggregate: Acceptance_Aggregate;
  /** fetch data from the table: "risksmart.acceptance_audit" */
  acceptance_audit: Array<Acceptance_Audit>;
  /** fetch data from the table: "risksmart.acceptance_audit" using primary key columns */
  acceptance_audit_by_pk?: Maybe<Acceptance_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.acceptance_audit" */
  acceptance_audit_stream: Array<Acceptance_Audit>;
  /** fetch data from the table: "risksmart.acceptance" using primary key columns */
  acceptance_by_pk?: Maybe<Acceptance>;
  /** fetch data from the table: "risksmart.acceptance_parent" */
  acceptance_parent: Array<Acceptance_Parent>;
  /** fetch aggregated fields from the table: "risksmart.acceptance_parent" */
  acceptance_parent_aggregate: Acceptance_Parent_Aggregate;
  /** fetch data from the table: "risksmart.acceptance_parent_audit" */
  acceptance_parent_audit: Array<Acceptance_Parent_Audit>;
  /** fetch data from the table: "risksmart.acceptance_parent_audit" using primary key columns */
  acceptance_parent_audit_by_pk?: Maybe<Acceptance_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.acceptance_parent_audit" */
  acceptance_parent_audit_stream: Array<Acceptance_Parent_Audit>;
  /** fetch data from the table: "risksmart.acceptance_parent" using primary key columns */
  acceptance_parent_by_pk?: Maybe<Acceptance_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.acceptance_parent" */
  acceptance_parent_stream: Array<Acceptance_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.acceptance" */
  acceptance_stream: Array<Acceptance>;
  /** fetch data from the table: "risksmart.action" */
  action: Array<Action>;
  /** fetch aggregated fields from the table: "risksmart.action" */
  action_aggregate: Action_Aggregate;
  /** fetch data from the table: "risksmart.action_audit" */
  action_audit: Array<Action_Audit>;
  /** fetch aggregated fields from the table: "risksmart.action_audit" */
  action_audit_aggregate: Action_Audit_Aggregate;
  /** fetch data from the table: "risksmart.action_audit" using primary key columns */
  action_audit_by_pk?: Maybe<Action_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.action_audit" */
  action_audit_stream: Array<Action_Audit>;
  /** fetch data from the table: "risksmart.action" using primary key columns */
  action_by_pk?: Maybe<Action>;
  /** fetch data from the table: "risksmart.action_parent" */
  action_parent: Array<Action_Parent>;
  /** fetch aggregated fields from the table: "risksmart.action_parent" */
  action_parent_aggregate: Action_Parent_Aggregate;
  /** fetch data from the table: "risksmart.action_parent_audit" */
  action_parent_audit: Array<Action_Parent_Audit>;
  /** fetch data from the table: "risksmart.action_parent_audit" using primary key columns */
  action_parent_audit_by_pk?: Maybe<Action_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.action_parent_audit" */
  action_parent_audit_stream: Array<Action_Parent_Audit>;
  /** fetch data from the table: "risksmart.action_parent" using primary key columns */
  action_parent_by_pk?: Maybe<Action_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.action_parent" */
  action_parent_stream: Array<Action_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.action" */
  action_stream: Array<Action>;
  /** fetch data from the table: "risksmart.action_update" */
  action_update: Array<Action_Update>;
  /** fetch aggregated fields from the table: "risksmart.action_update" */
  action_update_aggregate: Action_Update_Aggregate;
  /** fetch data from the table: "risksmart.action_update_audit" */
  action_update_audit: Array<Action_Update_Audit>;
  /** fetch data from the table: "risksmart.action_update_audit" using primary key columns */
  action_update_audit_by_pk?: Maybe<Action_Update_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.action_update_audit" */
  action_update_audit_stream: Array<Action_Update_Audit>;
  /** fetch data from the table: "risksmart.action_update" using primary key columns */
  action_update_by_pk?: Maybe<Action_Update>;
  /** fetch data from the table in a streaming manner: "risksmart.action_update" */
  action_update_stream: Array<Action_Update>;
  /** fetch data from the table: "risksmart.action_update_summary_view" */
  action_update_summary: Array<Action_Update_Summary>;
  /** fetch aggregated fields from the table: "risksmart.action_update_summary_view" */
  action_update_summary_aggregate: Action_Update_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "risksmart.action_update_summary_view" */
  action_update_summary_stream: Array<Action_Update_Summary>;
  /** fetch data from the table: "risksmart.aggregation_org" */
  aggregation_org: Array<Aggregation_Org>;
  /** fetch data from the table: "risksmart.aggregation_org" using primary key columns */
  aggregation_org_by_pk?: Maybe<Aggregation_Org>;
  /** fetch data from the table in a streaming manner: "risksmart.aggregation_org" */
  aggregation_org_stream: Array<Aggregation_Org>;
  /** fetch data from the table: "risksmart.ancestor_contributor_view" */
  ancestor_contributor: Array<Ancestor_Contributor>;
  /** fetch data from the table in a streaming manner: "risksmart.ancestor_contributor_view" */
  ancestor_contributor_stream: Array<Ancestor_Contributor>;
  /** fetch data from the table: "risksmart.appetite" */
  appetite: Array<Appetite>;
  /** fetch aggregated fields from the table: "risksmart.appetite" */
  appetite_aggregate: Appetite_Aggregate;
  /** fetch data from the table: "risksmart.appetite_audit" */
  appetite_audit: Array<Appetite_Audit>;
  /** fetch data from the table: "risksmart.appetite_audit" using primary key columns */
  appetite_audit_by_pk?: Maybe<Appetite_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.appetite_audit" */
  appetite_audit_stream: Array<Appetite_Audit>;
  /** fetch data from the table: "risksmart.appetite" using primary key columns */
  appetite_by_pk?: Maybe<Appetite>;
  /** fetch data from the table: "risksmart.appetite_parent" */
  appetite_parent: Array<Appetite_Parent>;
  /** fetch aggregated fields from the table: "risksmart.appetite_parent" */
  appetite_parent_aggregate: Appetite_Parent_Aggregate;
  /** fetch data from the table: "risksmart.appetite_parent_audit" */
  appetite_parent_audit: Array<Appetite_Parent_Audit>;
  /** fetch aggregated fields from the table: "risksmart.appetite_parent_audit" */
  appetite_parent_audit_aggregate: Appetite_Parent_Audit_Aggregate;
  /** fetch data from the table: "risksmart.appetite_parent_audit" using primary key columns */
  appetite_parent_audit_by_pk?: Maybe<Appetite_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.appetite_parent_audit" */
  appetite_parent_audit_stream: Array<Appetite_Parent_Audit>;
  /** fetch data from the table: "risksmart.appetite_parent" using primary key columns */
  appetite_parent_by_pk?: Maybe<Appetite_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.appetite_parent" */
  appetite_parent_stream: Array<Appetite_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.appetite" */
  appetite_stream: Array<Appetite>;
  /** fetch data from the table: "risksmart.approval" */
  approval: Array<Approval>;
  /** fetch data from the table: "risksmart.approval_audit" */
  approval_audit: Array<Approval_Audit>;
  /** fetch data from the table: "risksmart.approval_audit" using primary key columns */
  approval_audit_by_pk?: Maybe<Approval_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.approval_audit" */
  approval_audit_stream: Array<Approval_Audit>;
  /** fetch data from the table: "risksmart.approval" using primary key columns */
  approval_by_pk?: Maybe<Approval>;
  /** fetch data from the table: "risksmart.approval_level" */
  approval_level: Array<Approval_Level>;
  /** fetch data from the table: "risksmart.approval_level_audit" */
  approval_level_audit: Array<Approval_Level_Audit>;
  /** fetch data from the table: "risksmart.approval_level_audit" using primary key columns */
  approval_level_audit_by_pk?: Maybe<Approval_Level_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.approval_level_audit" */
  approval_level_audit_stream: Array<Approval_Level_Audit>;
  /** fetch data from the table: "risksmart.approval_level" using primary key columns */
  approval_level_by_pk?: Maybe<Approval_Level>;
  /** fetch data from the table in a streaming manner: "risksmart.approval_level" */
  approval_level_stream: Array<Approval_Level>;
  /** fetch data from the table in a streaming manner: "risksmart.approval" */
  approval_stream: Array<Approval>;
  /** fetch data from the table: "risksmart.approver" */
  approver: Array<Approver>;
  /** fetch aggregated fields from the table: "risksmart.approver" */
  approver_aggregate: Approver_Aggregate;
  /** fetch data from the table: "risksmart.approver_audit" */
  approver_audit: Array<Approver_Audit>;
  /** fetch data from the table: "risksmart.approver_audit" using primary key columns */
  approver_audit_by_pk?: Maybe<Approver_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.approver_audit" */
  approver_audit_stream: Array<Approver_Audit>;
  /** fetch data from the table: "risksmart.approver" using primary key columns */
  approver_by_pk?: Maybe<Approver>;
  /** fetch data from the table in a streaming manner: "risksmart.approver" */
  approver_stream: Array<Approver>;
  /** fetch data from the table: "risksmart.assessment" */
  assessment: Array<Assessment>;
  /** fetch data from the table: "risksmart.assessment_activity" */
  assessment_activity: Array<Assessment_Activity>;
  /** fetch aggregated fields from the table: "risksmart.assessment_activity" */
  assessment_activity_aggregate: Assessment_Activity_Aggregate;
  /** fetch data from the table: "risksmart.assessment_activity_audit" */
  assessment_activity_audit: Array<Assessment_Activity_Audit>;
  /** fetch data from the table: "risksmart.assessment_activity_audit" using primary key columns */
  assessment_activity_audit_by_pk?: Maybe<Assessment_Activity_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment_activity_audit" */
  assessment_activity_audit_stream: Array<Assessment_Activity_Audit>;
  /** fetch data from the table: "risksmart.assessment_activity" using primary key columns */
  assessment_activity_by_pk?: Maybe<Assessment_Activity>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment_activity" */
  assessment_activity_stream: Array<Assessment_Activity>;
  /** fetch aggregated fields from the table: "risksmart.assessment" */
  assessment_aggregate: Assessment_Aggregate;
  /** fetch data from the table: "risksmart.assessment_audit" */
  assessment_audit: Array<Assessment_Audit>;
  /** fetch aggregated fields from the table: "risksmart.assessment_audit" */
  assessment_audit_aggregate: Assessment_Audit_Aggregate;
  /** fetch data from the table: "risksmart.assessment_audit" using primary key columns */
  assessment_audit_by_pk?: Maybe<Assessment_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment_audit" */
  assessment_audit_stream: Array<Assessment_Audit>;
  /** fetch data from the table: "risksmart.assessment" using primary key columns */
  assessment_by_pk?: Maybe<Assessment>;
  /** fetch data from the table: "risksmart.assessment_result_parent" */
  assessment_result_parent: Array<Assessment_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.assessment_result_parent" */
  assessment_result_parent_aggregate: Assessment_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.assessment_result_parent_audit" */
  assessment_result_parent_audit: Array<Assessment_Result_Parent_Audit>;
  /** fetch data from the table: "risksmart.assessment_result_parent_audit" using primary key columns */
  assessment_result_parent_audit_by_pk?: Maybe<Assessment_Result_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment_result_parent_audit" */
  assessment_result_parent_audit_stream: Array<Assessment_Result_Parent_Audit>;
  /** fetch data from the table: "risksmart.assessment_result_parent" using primary key columns */
  assessment_result_parent_by_pk?: Maybe<Assessment_Result_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment_result_parent" */
  assessment_result_parent_stream: Array<Assessment_Result_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.assessment" */
  assessment_stream: Array<Assessment>;
  /** fetch data from the table: "risksmart.attestation_config" */
  attestation_config: Array<Attestation_Config>;
  /** fetch data from the table: "risksmart.attestation_config" using primary key columns */
  attestation_config_by_pk?: Maybe<Attestation_Config>;
  /** fetch data from the table in a streaming manner: "risksmart.attestation_config" */
  attestation_config_stream: Array<Attestation_Config>;
  /** fetch data from the table: "risksmart.attestation_cycle" */
  attestation_cycle: Array<Attestation_Cycle>;
  /** fetch data from the table: "risksmart.attestation_cycle_audit" */
  attestation_cycle_audit: Array<Attestation_Cycle_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.attestation_cycle_audit" */
  attestation_cycle_audit_stream: Array<Attestation_Cycle_Audit>;
  /** fetch data from the table: "risksmart.attestation_cycle" using primary key columns */
  attestation_cycle_by_pk?: Maybe<Attestation_Cycle>;
  /** fetch data from the table in a streaming manner: "risksmart.attestation_cycle" */
  attestation_cycle_stream: Array<Attestation_Cycle>;
  /** fetch data from the table: "risksmart.attestation_group" */
  attestation_group: Array<Attestation_Group>;
  /** fetch data from the table: "risksmart.attestation_group" using primary key columns */
  attestation_group_by_pk?: Maybe<Attestation_Group>;
  /** fetch data from the table in a streaming manner: "risksmart.attestation_group" */
  attestation_group_stream: Array<Attestation_Group>;
  /** fetch data from the table: "risksmart.attestation_record" */
  attestation_record: Array<Attestation_Record>;
  /** fetch aggregated fields from the table: "risksmart.attestation_record" */
  attestation_record_aggregate: Attestation_Record_Aggregate;
  /** fetch data from the table: "risksmart.attestation_record" using primary key columns */
  attestation_record_by_pk?: Maybe<Attestation_Record>;
  /** fetch data from the table in a streaming manner: "risksmart.attestation_record" */
  attestation_record_stream: Array<Attestation_Record>;
  /** fetch data from the table: "risksmart.audit_log_view" */
  audit_log_view: Array<Audit_Log_View>;
  /** fetch aggregated fields from the table: "risksmart.audit_log_view" */
  audit_log_view_aggregate: Audit_Log_View_Aggregate;
  /** fetch data from the table in a streaming manner: "risksmart.audit_log_view" */
  audit_log_view_stream: Array<Audit_Log_View>;
  /** fetch data from the table: "auth.organisation" */
  auth_organisation: Array<Auth_Organisation>;
  /** fetch data from the table: "auth.organisation" using primary key columns */
  auth_organisation_by_pk?: Maybe<Auth_Organisation>;
  /** fetch data from the table in a streaming manner: "auth.organisation" */
  auth_organisation_stream: Array<Auth_Organisation>;
  /** fetch data from the table: "auth.organisationuser" */
  auth_organisationuser: Array<Auth_Organisationuser>;
  /** fetch data from the table: "auth.organisationuser" using primary key columns */
  auth_organisationuser_by_pk?: Maybe<Auth_Organisationuser>;
  /** fetch data from the table in a streaming manner: "auth.organisationuser" */
  auth_organisationuser_stream: Array<Auth_Organisationuser>;
  /** fetch data from the table: "auth.role_resource_type" */
  auth_role_resource_type: Array<Auth_Role_Resource_Type>;
  /** fetch data from the table: "auth.role_resource_type" using primary key columns */
  auth_role_resource_type_by_pk?: Maybe<Auth_Role_Resource_Type>;
  /** fetch data from the table in a streaming manner: "auth.role_resource_type" */
  auth_role_resource_type_stream: Array<Auth_Role_Resource_Type>;
  /** fetch data from the table: "auth.role_type" */
  auth_role_type: Array<Auth_Role_Type>;
  /** fetch data from the table: "auth.role_type" using primary key columns */
  auth_role_type_by_pk?: Maybe<Auth_Role_Type>;
  /** fetch data from the table: "auth.role_type_resource_type" */
  auth_role_type_resource_type: Array<Auth_Role_Type_Resource_Type>;
  /** fetch data from the table: "auth.role_type_resource_type" using primary key columns */
  auth_role_type_resource_type_by_pk?: Maybe<Auth_Role_Type_Resource_Type>;
  /** fetch data from the table in a streaming manner: "auth.role_type_resource_type" */
  auth_role_type_resource_type_stream: Array<Auth_Role_Type_Resource_Type>;
  /** fetch data from the table in a streaming manner: "auth.role_type" */
  auth_role_type_stream: Array<Auth_Role_Type>;
  /** fetch data from the table: "auth.user" */
  auth_user: Array<Auth_User>;
  /** fetch aggregated fields from the table: "auth.user" */
  auth_user_aggregate: Auth_User_Aggregate;
  /** fetch data from the table: "auth.user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  /** fetch data from the table: "auth.user_role" */
  auth_user_role: Array<Auth_User_Role>;
  /** fetch data from the table: "auth.user_role" using primary key columns */
  auth_user_role_by_pk?: Maybe<Auth_User_Role>;
  /** fetch data from the table in a streaming manner: "auth.user_role" */
  auth_user_role_stream: Array<Auth_User_Role>;
  /** fetch data from the table in a streaming manner: "auth.user" */
  auth_user_stream: Array<Auth_User>;
  /** fetch data from the table: "risksmart.business_area" */
  business_area: Array<Business_Area>;
  /** fetch aggregated fields from the table: "risksmart.business_area" */
  business_area_aggregate: Business_Area_Aggregate;
  /** fetch data from the table: "risksmart.business_area" using primary key columns */
  business_area_by_pk?: Maybe<Business_Area>;
  /** fetch data from the table in a streaming manner: "risksmart.business_area" */
  business_area_stream: Array<Business_Area>;
  /** fetch data from the table: "risksmart.cause" */
  cause: Array<Cause>;
  /** fetch aggregated fields from the table: "risksmart.cause" */
  cause_aggregate: Cause_Aggregate;
  /** fetch data from the table: "risksmart.cause_audit" */
  cause_audit: Array<Cause_Audit>;
  /** fetch data from the table: "risksmart.cause_audit" using primary key columns */
  cause_audit_by_pk?: Maybe<Cause_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.cause_audit" */
  cause_audit_stream: Array<Cause_Audit>;
  /** fetch data from the table: "risksmart.cause" using primary key columns */
  cause_by_pk?: Maybe<Cause>;
  /** fetch data from the table in a streaming manner: "risksmart.cause" */
  cause_stream: Array<Cause>;
  /** fetch data from the table: "risksmart.change_request" */
  change_request: Array<Change_Request>;
  /** fetch aggregated fields from the table: "risksmart.change_request" */
  change_request_aggregate: Change_Request_Aggregate;
  /** fetch data from the table: "risksmart.change_request_audit" */
  change_request_audit: Array<Change_Request_Audit>;
  /** fetch data from the table: "risksmart.change_request_audit" using primary key columns */
  change_request_audit_by_pk?: Maybe<Change_Request_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.change_request_audit" */
  change_request_audit_stream: Array<Change_Request_Audit>;
  /** fetch data from the table: "risksmart.change_request" using primary key columns */
  change_request_by_pk?: Maybe<Change_Request>;
  /** fetch data from the table: "risksmart.change_request_contributor" */
  change_request_contributor: Array<Change_Request_Contributor>;
  /** fetch data from the table: "risksmart.change_request_contributor" using primary key columns */
  change_request_contributor_by_pk?: Maybe<Change_Request_Contributor>;
  /** fetch data from the table in a streaming manner: "risksmart.change_request_contributor" */
  change_request_contributor_stream: Array<Change_Request_Contributor>;
  /** fetch data from the table in a streaming manner: "risksmart.change_request" */
  change_request_stream: Array<Change_Request>;
  /** fetch data from the table: "risksmart.colour_palette" */
  colour_palette: Array<Colour_Palette>;
  /** fetch aggregated fields from the table: "risksmart.colour_palette" */
  colour_palette_aggregate: Colour_Palette_Aggregate;
  /** fetch data from the table: "risksmart.colour_palette_audit" */
  colour_palette_audit: Array<Colour_Palette_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.colour_palette_audit" */
  colour_palette_audit_stream: Array<Colour_Palette_Audit>;
  /** fetch data from the table: "risksmart.colour_palette" using primary key columns */
  colour_palette_by_pk?: Maybe<Colour_Palette>;
  /** fetch data from the table in a streaming manner: "risksmart.colour_palette" */
  colour_palette_stream: Array<Colour_Palette>;
  /** fetch data from the table: "risksmart.comment" */
  comment: Array<Comment>;
  /** fetch data from the table: "risksmart.comment_audit" */
  comment_audit: Array<Comment_Audit>;
  /** fetch data from the table: "risksmart.comment_audit" using primary key columns */
  comment_audit_by_pk?: Maybe<Comment_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.comment_audit" */
  comment_audit_stream: Array<Comment_Audit>;
  /** fetch data from the table: "risksmart.comment" using primary key columns */
  comment_by_pk?: Maybe<Comment>;
  /** fetch data from the table in a streaming manner: "risksmart.comment" */
  comment_stream: Array<Comment>;
  /** fetch data from the table: "risksmart.compliance_monitoring_assessment" */
  compliance_monitoring_assessment: Array<Compliance_Monitoring_Assessment>;
  /** fetch aggregated fields from the table: "risksmart.compliance_monitoring_assessment" */
  compliance_monitoring_assessment_aggregate: Compliance_Monitoring_Assessment_Aggregate;
  /** fetch data from the table: "risksmart.compliance_monitoring_assessment" using primary key columns */
  compliance_monitoring_assessment_by_pk?: Maybe<Compliance_Monitoring_Assessment>;
  /** fetch data from the table in a streaming manner: "risksmart.compliance_monitoring_assessment" */
  compliance_monitoring_assessment_stream: Array<Compliance_Monitoring_Assessment>;
  /** fetch data from the table: "risksmart.consequence" */
  consequence: Array<Consequence>;
  /** fetch aggregated fields from the table: "risksmart.consequence" */
  consequence_aggregate: Consequence_Aggregate;
  /** fetch data from the table: "risksmart.consequence_audit" */
  consequence_audit: Array<Consequence_Audit>;
  /** fetch aggregated fields from the table: "risksmart.consequence_audit" */
  consequence_audit_aggregate: Consequence_Audit_Aggregate;
  /** fetch data from the table: "risksmart.consequence_audit" using primary key columns */
  consequence_audit_by_pk?: Maybe<Consequence_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.consequence_audit" */
  consequence_audit_stream: Array<Consequence_Audit>;
  /** fetch data from the table: "risksmart.consequence" using primary key columns */
  consequence_by_pk?: Maybe<Consequence>;
  /** fetch data from the table in a streaming manner: "risksmart.consequence" */
  consequence_stream: Array<Consequence>;
  /** fetch data from the table: "risksmart.control" */
  control: Array<Control>;
  /** fetch aggregated fields from the table: "risksmart.control" */
  control_aggregate: Control_Aggregate;
  /** fetch data from the table: "risksmart.control_audit" */
  control_audit: Array<Control_Audit>;
  /** fetch data from the table: "risksmart.control_audit" using primary key columns */
  control_audit_by_pk?: Maybe<Control_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.control_audit" */
  control_audit_stream: Array<Control_Audit>;
  /** fetch data from the table: "risksmart.control" using primary key columns */
  control_by_pk?: Maybe<Control>;
  /** fetch data from the table: "risksmart.control_group" */
  control_group: Array<Control_Group>;
  /** fetch aggregated fields from the table: "risksmart.control_group" */
  control_group_aggregate: Control_Group_Aggregate;
  /** fetch data from the table: "risksmart.control_group_audit" */
  control_group_audit: Array<Control_Group_Audit>;
  /** fetch data from the table: "risksmart.control_group_audit" using primary key columns */
  control_group_audit_by_pk?: Maybe<Control_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.control_group_audit" */
  control_group_audit_stream: Array<Control_Group_Audit>;
  /** fetch data from the table: "risksmart.control_group" using primary key columns */
  control_group_by_pk?: Maybe<Control_Group>;
  /** fetch data from the table in a streaming manner: "risksmart.control_group" */
  control_group_stream: Array<Control_Group>;
  /** fetch data from the table: "risksmart.control_parent" */
  control_parent: Array<Control_Parent>;
  /** fetch aggregated fields from the table: "risksmart.control_parent" */
  control_parent_aggregate: Control_Parent_Aggregate;
  /** fetch data from the table: "risksmart.control_parent_audit" */
  control_parent_audit: Array<Control_Parent_Audit>;
  /** fetch data from the table: "risksmart.control_parent_audit" using primary key columns */
  control_parent_audit_by_pk?: Maybe<Control_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.control_parent_audit" */
  control_parent_audit_stream: Array<Control_Parent_Audit>;
  /** fetch data from the table: "risksmart.control_parent" using primary key columns */
  control_parent_by_pk?: Maybe<Control_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.control_parent" */
  control_parent_stream: Array<Control_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.control" */
  control_stream: Array<Control>;
  /** fetch data from the table: "risksmart.control_test_internal_audit_result" */
  control_test_internal_audit_result: Array<Control_Test_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.control_test_internal_audit_result" */
  control_test_internal_audit_result_aggregate: Control_Test_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.control_test_internal_audit_result" using primary key columns */
  control_test_internal_audit_result_by_pk?: Maybe<Control_Test_Internal_Audit_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.control_test_internal_audit_result" */
  control_test_internal_audit_result_stream: Array<Control_Test_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.control_test_second_line_result" */
  control_test_second_line_result: Array<Control_Test_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.control_test_second_line_result" */
  control_test_second_line_result_aggregate: Control_Test_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.control_test_second_line_result" using primary key columns */
  control_test_second_line_result_by_pk?: Maybe<Control_Test_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.control_test_second_line_result" */
  control_test_second_line_result_stream: Array<Control_Test_Second_Line_Result>;
  /** fetch data from the table: "risksmart.conversation" */
  conversation: Array<Conversation>;
  /** fetch data from the table: "risksmart.conversation_audit" */
  conversation_audit: Array<Conversation_Audit>;
  /** fetch data from the table: "risksmart.conversation_audit" using primary key columns */
  conversation_audit_by_pk?: Maybe<Conversation_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.conversation_audit" */
  conversation_audit_stream: Array<Conversation_Audit>;
  /** fetch data from the table: "risksmart.conversation" using primary key columns */
  conversation_by_pk?: Maybe<Conversation>;
  /** fetch data from the table in a streaming manner: "risksmart.conversation" */
  conversation_stream: Array<Conversation>;
  /** fetch data from the table: "risksmart.custom_attribute_schema" */
  custom_attribute_schema: Array<Custom_Attribute_Schema>;
  /** fetch data from the table: "risksmart.custom_attribute_schema_audit" */
  custom_attribute_schema_audit: Array<Custom_Attribute_Schema_Audit>;
  /** fetch data from the table: "risksmart.custom_attribute_schema_audit" using primary key columns */
  custom_attribute_schema_audit_by_pk?: Maybe<Custom_Attribute_Schema_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_attribute_schema_audit" */
  custom_attribute_schema_audit_stream: Array<Custom_Attribute_Schema_Audit>;
  /** fetch data from the table: "risksmart.custom_attribute_schema" using primary key columns */
  custom_attribute_schema_by_pk?: Maybe<Custom_Attribute_Schema>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_attribute_schema" */
  custom_attribute_schema_stream: Array<Custom_Attribute_Schema>;
  /** fetch data from the table: "risksmart.custom_datasource" */
  custom_datasource: Array<Custom_Datasource>;
  /** fetch data from the table: "risksmart.custom_datasource" using primary key columns */
  custom_datasource_by_pk?: Maybe<Custom_Datasource>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_datasource" */
  custom_datasource_stream: Array<Custom_Datasource>;
  /** fetch data from the table: "risksmart.custom_ribbon" */
  custom_ribbon: Array<Custom_Ribbon>;
  /** fetch data from the table: "risksmart.custom_ribbon_audit" */
  custom_ribbon_audit: Array<Custom_Ribbon_Audit>;
  /** fetch data from the table: "risksmart.custom_ribbon_audit" using primary key columns */
  custom_ribbon_audit_by_pk?: Maybe<Custom_Ribbon_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_ribbon_audit" */
  custom_ribbon_audit_stream: Array<Custom_Ribbon_Audit>;
  /** fetch data from the table: "risksmart.custom_ribbon" using primary key columns */
  custom_ribbon_by_pk?: Maybe<Custom_Ribbon>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_ribbon" */
  custom_ribbon_stream: Array<Custom_Ribbon>;
  /** fetch data from the table: "risksmart.custom_role" */
  custom_role: Array<Custom_Role>;
  /** fetch aggregated fields from the table: "risksmart.custom_role" */
  custom_role_aggregate: Custom_Role_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_assignment" */
  custom_role_assignment: Array<Custom_Role_Assignment>;
  /** fetch aggregated fields from the table: "risksmart.custom_role_assignment" */
  custom_role_assignment_aggregate: Custom_Role_Assignment_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_assignment_audit" */
  custom_role_assignment_audit: Array<Custom_Role_Assignment_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role_assignment_audit" */
  custom_role_assignment_audit_stream: Array<Custom_Role_Assignment_Audit>;
  /** fetch data from the table: "risksmart.custom_role_assignment" using primary key columns */
  custom_role_assignment_by_pk?: Maybe<Custom_Role_Assignment>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role_assignment" */
  custom_role_assignment_stream: Array<Custom_Role_Assignment>;
  /** fetch data from the table: "risksmart.custom_role_audit" */
  custom_role_audit: Array<Custom_Role_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role_audit" */
  custom_role_audit_stream: Array<Custom_Role_Audit>;
  /** fetch data from the table: "risksmart.custom_role" using primary key columns */
  custom_role_by_pk?: Maybe<Custom_Role>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role" */
  custom_role_stream: Array<Custom_Role>;
  /** fetch data from the table: "risksmart.custom_role_user" */
  custom_role_user: Array<Custom_Role_User>;
  /** fetch aggregated fields from the table: "risksmart.custom_role_user" */
  custom_role_user_aggregate: Custom_Role_User_Aggregate;
  /** fetch data from the table: "risksmart.custom_role_user_audit" */
  custom_role_user_audit: Array<Custom_Role_User_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role_user_audit" */
  custom_role_user_audit_stream: Array<Custom_Role_User_Audit>;
  /** fetch data from the table: "risksmart.custom_role_user" using primary key columns */
  custom_role_user_by_pk?: Maybe<Custom_Role_User>;
  /** fetch data from the table in a streaming manner: "risksmart.custom_role_user" */
  custom_role_user_stream: Array<Custom_Role_User>;
  /** fetch data from the table: "risksmart.dashboard" */
  dashboard: Array<Dashboard>;
  /** fetch data from the table: "risksmart.dashboard_audit" */
  dashboard_audit: Array<Dashboard_Audit>;
  /** fetch data from the table: "risksmart.dashboard_audit" using primary key columns */
  dashboard_audit_by_pk?: Maybe<Dashboard_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.dashboard_audit" */
  dashboard_audit_stream: Array<Dashboard_Audit>;
  /** fetch data from the table: "risksmart.dashboard" using primary key columns */
  dashboard_by_pk?: Maybe<Dashboard>;
  /** fetch data from the table in a streaming manner: "risksmart.dashboard" */
  dashboard_stream: Array<Dashboard>;
  /** fetch data from the table: "risksmart.data_export_schedule" */
  data_export_schedule: Array<Data_Export_Schedule>;
  /** fetch aggregated fields from the table: "risksmart.data_export_schedule" */
  data_export_schedule_aggregate: Data_Export_Schedule_Aggregate;
  /** fetch data from the table: "risksmart.data_export_schedule_audit" */
  data_export_schedule_audit: Array<Data_Export_Schedule_Audit>;
  /** fetch data from the table: "risksmart.data_export_schedule_audit" using primary key columns */
  data_export_schedule_audit_by_pk?: Maybe<Data_Export_Schedule_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.data_export_schedule_audit" */
  data_export_schedule_audit_stream: Array<Data_Export_Schedule_Audit>;
  /** fetch data from the table: "risksmart.data_export_schedule" using primary key columns */
  data_export_schedule_by_pk?: Maybe<Data_Export_Schedule>;
  /** fetch data from the table: "risksmart.data_export_schedule_execution" */
  data_export_schedule_execution: Array<Data_Export_Schedule_Execution>;
  /** fetch aggregated fields from the table: "risksmart.data_export_schedule_execution" */
  data_export_schedule_execution_aggregate: Data_Export_Schedule_Execution_Aggregate;
  /** fetch data from the table: "risksmart.data_export_schedule_execution" using primary key columns */
  data_export_schedule_execution_by_pk?: Maybe<Data_Export_Schedule_Execution>;
  /** fetch data from the table in a streaming manner: "risksmart.data_export_schedule_execution" */
  data_export_schedule_execution_stream: Array<Data_Export_Schedule_Execution>;
  /** fetch data from the table in a streaming manner: "risksmart.data_export_schedule" */
  data_export_schedule_stream: Array<Data_Export_Schedule>;
  /** fetch data from the table: "risksmart.data_import" */
  data_import: Array<Data_Import>;
  /** fetch aggregated fields from the table: "risksmart.data_import" */
  data_import_aggregate: Data_Import_Aggregate;
  /** fetch data from the table: "risksmart.data_import" using primary key columns */
  data_import_by_pk?: Maybe<Data_Import>;
  /** fetch data from the table: "risksmart.data_import_error" */
  data_import_error: Array<Data_Import_Error>;
  /** fetch aggregated fields from the table: "risksmart.data_import_error" */
  data_import_error_aggregate: Data_Import_Error_Aggregate;
  /** fetch data from the table: "risksmart.data_import_error" using primary key columns */
  data_import_error_by_pk?: Maybe<Data_Import_Error>;
  /** fetch data from the table in a streaming manner: "risksmart.data_import_error" */
  data_import_error_stream: Array<Data_Import_Error>;
  /** fetch data from the table in a streaming manner: "risksmart.data_import" */
  data_import_stream: Array<Data_Import>;
  /** fetch data from the table: "risksmart.department_audit" */
  department_audit: Array<Department_Audit>;
  /** fetch data from the table: "risksmart.department_audit" using primary key columns */
  department_audit_by_pk?: Maybe<Department_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.department_audit" */
  department_audit_stream: Array<Department_Audit>;
  /** fetch data from the table: "risksmart.department_type" */
  department_type: Array<Department_Type>;
  /** fetch data from the table: "risksmart.department_type_audit" */
  department_type_audit: Array<Department_Type_Audit>;
  /** fetch data from the table: "risksmart.department_type_audit" using primary key columns */
  department_type_audit_by_pk?: Maybe<Department_Type_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.department_type_audit" */
  department_type_audit_stream: Array<Department_Type_Audit>;
  /** fetch data from the table: "risksmart.department_type" using primary key columns */
  department_type_by_pk?: Maybe<Department_Type>;
  /** fetch data from the table: "risksmart.department_type_group" */
  department_type_group: Array<Department_Type_Group>;
  /** fetch data from the table: "risksmart.department_type_group_audit" */
  department_type_group_audit: Array<Department_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.department_type_group_audit" using primary key columns */
  department_type_group_audit_by_pk?: Maybe<Department_Type_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.department_type_group_audit" */
  department_type_group_audit_stream: Array<Department_Type_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.department_type_group" */
  department_type_group_stream: Array<Department_Type_Group>;
  /** fetch data from the table in a streaming manner: "risksmart.department_type" */
  department_type_stream: Array<Department_Type>;
  /** fetch data from the table: "risksmart.document" */
  document: Array<Document>;
  /** fetch data from the table: "risksmart.document_assessment_result" */
  document_assessment_result: Array<Document_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_assessment_result" */
  document_assessment_result_aggregate: Document_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_assessment_result_audit" */
  document_assessment_result_audit: Array<Document_Assessment_Result_Audit>;
  /** fetch aggregated fields from the table: "risksmart.document_assessment_result_audit" */
  document_assessment_result_audit_aggregate: Document_Assessment_Result_Audit_Aggregate;
  /** fetch data from the table: "risksmart.document_assessment_result_audit" using primary key columns */
  document_assessment_result_audit_by_pk?: Maybe<Document_Assessment_Result_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.document_assessment_result_audit" */
  document_assessment_result_audit_stream: Array<Document_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.document_assessment_result" using primary key columns */
  document_assessment_result_by_pk?: Maybe<Document_Assessment_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.document_assessment_result" */
  document_assessment_result_stream: Array<Document_Assessment_Result>;
  /** fetch data from the table: "risksmart.document_audit" */
  document_audit: Array<Document_Audit>;
  /** fetch data from the table: "risksmart.document_audit" using primary key columns */
  document_audit_by_pk?: Maybe<Document_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.document_audit" */
  document_audit_stream: Array<Document_Audit>;
  /** fetch data from the table: "risksmart.document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "risksmart.document_file" */
  document_file: Array<Document_File>;
  /** fetch data from the table: "risksmart.document_file_audit" */
  document_file_audit: Array<Document_File_Audit>;
  /** fetch data from the table: "risksmart.document_file_audit" using primary key columns */
  document_file_audit_by_pk?: Maybe<Document_File_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.document_file_audit" */
  document_file_audit_stream: Array<Document_File_Audit>;
  /** fetch data from the table: "risksmart.document_file" using primary key columns */
  document_file_by_pk?: Maybe<Document_File>;
  /** fetch data from the table in a streaming manner: "risksmart.document_file" */
  document_file_stream: Array<Document_File>;
  /** fetch data from the table: "risksmart.document_internal_audit_result" */
  document_internal_audit_result: Array<Document_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_internal_audit_result" */
  document_internal_audit_result_aggregate: Document_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_internal_audit_result" using primary key columns */
  document_internal_audit_result_by_pk?: Maybe<Document_Internal_Audit_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.document_internal_audit_result" */
  document_internal_audit_result_stream: Array<Document_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.document_linked_document" */
  document_linked_document: Array<Document_Linked_Document>;
  /** fetch data from the table: "risksmart.document_linked_document_audit" */
  document_linked_document_audit: Array<Document_Linked_Document_Audit>;
  /** fetch data from the table: "risksmart.document_linked_document_audit" using primary key columns */
  document_linked_document_audit_by_pk?: Maybe<Document_Linked_Document_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.document_linked_document_audit" */
  document_linked_document_audit_stream: Array<Document_Linked_Document_Audit>;
  /** fetch data from the table: "risksmart.document_linked_document" using primary key columns */
  document_linked_document_by_pk?: Maybe<Document_Linked_Document>;
  /** fetch data from the table in a streaming manner: "risksmart.document_linked_document" */
  document_linked_document_stream: Array<Document_Linked_Document>;
  /** fetch data from the table: "risksmart.document_second_line_result" */
  document_second_line_result: Array<Document_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.document_second_line_result" */
  document_second_line_result_aggregate: Document_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.document_second_line_result" using primary key columns */
  document_second_line_result_by_pk?: Maybe<Document_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.document_second_line_result" */
  document_second_line_result_stream: Array<Document_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "risksmart.enterprise_risk" */
  enterprise_risk: Array<Enterprise_Risk>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk" */
  enterprise_risk_aggregate: Enterprise_Risk_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk" using primary key columns */
  enterprise_risk_by_pk?: Maybe<Enterprise_Risk>;
  /** fetch data from the table: "risksmart.enterprise_risk_instance" */
  enterprise_risk_instance: Array<Enterprise_Risk_Instance>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk_instance" */
  enterprise_risk_instance_aggregate: Enterprise_Risk_Instance_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk_instance" using primary key columns */
  enterprise_risk_instance_by_pk?: Maybe<Enterprise_Risk_Instance>;
  /** fetch data from the table in a streaming manner: "risksmart.enterprise_risk_instance" */
  enterprise_risk_instance_stream: Array<Enterprise_Risk_Instance>;
  /** fetch data from the table: "risksmart.enterprise_risk_score" */
  enterprise_risk_score: Array<Enterprise_Risk_Score>;
  /** fetch aggregated fields from the table: "risksmart.enterprise_risk_score" */
  enterprise_risk_score_aggregate: Enterprise_Risk_Score_Aggregate;
  /** fetch data from the table: "risksmart.enterprise_risk_score" using primary key columns */
  enterprise_risk_score_by_pk?: Maybe<Enterprise_Risk_Score>;
  /** fetch data from the table in a streaming manner: "risksmart.enterprise_risk_score" */
  enterprise_risk_score_stream: Array<Enterprise_Risk_Score>;
  /** fetch data from the table in a streaming manner: "risksmart.enterprise_risk" */
  enterprise_risk_stream: Array<Enterprise_Risk>;
  /** fetch data from the table: "risksmart.entity" */
  entity: Array<Entity>;
  /** fetch aggregated fields from the table: "risksmart.entity" */
  entity_aggregate: Entity_Aggregate;
  /** fetch data from the table: "risksmart.entity" using primary key columns */
  entity_by_pk?: Maybe<Entity>;
  /** fetch data from the table in a streaming manner: "risksmart.entity" */
  entity_stream: Array<Entity>;
  /** fetch data from the table: "risksmart.file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "risksmart.file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "risksmart.file_audit" */
  file_audit: Array<File_Audit>;
  /** fetch data from the table: "risksmart.file_audit" using primary key columns */
  file_audit_by_pk?: Maybe<File_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.file_audit" */
  file_audit_stream: Array<File_Audit>;
  /** fetch data from the table: "risksmart.file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table in a streaming manner: "risksmart.file" */
  file_stream: Array<File>;
  /** fetch data from the table: "risksmart.form_configuration" */
  form_configuration: Array<Form_Configuration>;
  /** fetch data from the table: "risksmart.form_configuration_audit" */
  form_configuration_audit: Array<Form_Configuration_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_configuration_audit" */
  form_configuration_audit_stream: Array<Form_Configuration_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_configuration" */
  form_configuration_stream: Array<Form_Configuration>;
  /** fetch data from the table: "risksmart.form_field_configuration" */
  form_field_configuration: Array<Form_Field_Configuration>;
  /** fetch data from the table: "risksmart.form_field_configuration_audit" */
  form_field_configuration_audit: Array<Form_Field_Configuration_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_field_configuration_audit" */
  form_field_configuration_audit_stream: Array<Form_Field_Configuration_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_field_configuration" */
  form_field_configuration_stream: Array<Form_Field_Configuration>;
  /** fetch data from the table: "risksmart.form_field_ordering" */
  form_field_ordering: Array<Form_Field_Ordering>;
  /** fetch data from the table: "risksmart.form_field_ordering_audit" */
  form_field_ordering_audit: Array<Form_Field_Ordering_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_field_ordering_audit" */
  form_field_ordering_audit_stream: Array<Form_Field_Ordering_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.form_field_ordering" */
  form_field_ordering_stream: Array<Form_Field_Ordering>;
  /** fetch data from the table: "risksmart.impact" */
  impact: Array<Impact>;
  /** fetch aggregated fields from the table: "risksmart.impact" */
  impact_aggregate: Impact_Aggregate;
  /** fetch data from the table: "risksmart.impact_audit" */
  impact_audit: Array<Impact_Audit>;
  /** fetch data from the table: "risksmart.impact_audit" using primary key columns */
  impact_audit_by_pk?: Maybe<Impact_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_audit" */
  impact_audit_stream: Array<Impact_Audit>;
  /** fetch data from the table: "risksmart.impact" using primary key columns */
  impact_by_pk?: Maybe<Impact>;
  /** fetch data from the table: "risksmart.impact_internal_audit_rating" */
  impact_internal_audit_rating: Array<Impact_Internal_Audit_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_internal_audit_rating" */
  impact_internal_audit_rating_aggregate: Impact_Internal_Audit_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_internal_audit_rating" using primary key columns */
  impact_internal_audit_rating_by_pk?: Maybe<Impact_Internal_Audit_Rating>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_internal_audit_rating" */
  impact_internal_audit_rating_stream: Array<Impact_Internal_Audit_Rating>;
  /** fetch data from the table: "risksmart.impact_parent" */
  impact_parent: Array<Impact_Parent>;
  /** fetch aggregated fields from the table: "risksmart.impact_parent" */
  impact_parent_aggregate: Impact_Parent_Aggregate;
  /** fetch data from the table: "risksmart.impact_parent_audit" */
  impact_parent_audit: Array<Impact_Parent_Audit>;
  /** fetch data from the table: "risksmart.impact_parent_audit" using primary key columns */
  impact_parent_audit_by_pk?: Maybe<Impact_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_parent_audit" */
  impact_parent_audit_stream: Array<Impact_Parent_Audit>;
  /** fetch data from the table: "risksmart.impact_parent" using primary key columns */
  impact_parent_by_pk?: Maybe<Impact_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_parent" */
  impact_parent_stream: Array<Impact_Parent>;
  /** fetch data from the table: "risksmart.impact_rating" */
  impact_rating: Array<Impact_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_rating" */
  impact_rating_aggregate: Impact_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_rating_audit" */
  impact_rating_audit: Array<Impact_Rating_Audit>;
  /** fetch data from the table: "risksmart.impact_rating_audit" using primary key columns */
  impact_rating_audit_by_pk?: Maybe<Impact_Rating_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_rating_audit" */
  impact_rating_audit_stream: Array<Impact_Rating_Audit>;
  /** fetch data from the table: "risksmart.impact_rating" using primary key columns */
  impact_rating_by_pk?: Maybe<Impact_Rating>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_rating" */
  impact_rating_stream: Array<Impact_Rating>;
  /** fetch data from the table: "risksmart.impact_second_line_rating" */
  impact_second_line_rating: Array<Impact_Second_Line_Rating>;
  /** fetch aggregated fields from the table: "risksmart.impact_second_line_rating" */
  impact_second_line_rating_aggregate: Impact_Second_Line_Rating_Aggregate;
  /** fetch data from the table: "risksmart.impact_second_line_rating" using primary key columns */
  impact_second_line_rating_by_pk?: Maybe<Impact_Second_Line_Rating>;
  /** fetch data from the table in a streaming manner: "risksmart.impact_second_line_rating" */
  impact_second_line_rating_stream: Array<Impact_Second_Line_Rating>;
  /** fetch data from the table in a streaming manner: "risksmart.impact" */
  impact_stream: Array<Impact>;
  /** fetch data from the table: "risksmart.indicator" */
  indicator: Array<Indicator>;
  /** fetch data from the table: "risksmart.indicator_audit" */
  indicator_audit: Array<Indicator_Audit>;
  /** fetch data from the table: "risksmart.indicator_audit" using primary key columns */
  indicator_audit_by_pk?: Maybe<Indicator_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_audit" */
  indicator_audit_stream: Array<Indicator_Audit>;
  /** fetch data from the table: "risksmart.indicator" using primary key columns */
  indicator_by_pk?: Maybe<Indicator>;
  /** fetch data from the table: "risksmart.indicator_parent" */
  indicator_parent: Array<Indicator_Parent>;
  /** fetch aggregated fields from the table: "risksmart.indicator_parent" */
  indicator_parent_aggregate: Indicator_Parent_Aggregate;
  /** fetch data from the table: "risksmart.indicator_parent" using primary key columns */
  indicator_parent_by_pk?: Maybe<Indicator_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_parent" */
  indicator_parent_stream: Array<Indicator_Parent>;
  /** fetch data from the table: "risksmart.indicator_result" */
  indicator_result: Array<Indicator_Result>;
  /** fetch data from the table: "risksmart.indicator_result_audit" */
  indicator_result_audit: Array<Indicator_Result_Audit>;
  /** fetch data from the table: "risksmart.indicator_result_audit" using primary key columns */
  indicator_result_audit_by_pk?: Maybe<Indicator_Result_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_result_audit" */
  indicator_result_audit_stream: Array<Indicator_Result_Audit>;
  /** fetch data from the table: "risksmart.indicator_result" using primary key columns */
  indicator_result_by_pk?: Maybe<Indicator_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_result" */
  indicator_result_stream: Array<Indicator_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator" */
  indicator_stream: Array<Indicator>;
  /** fetch data from the table: "risksmart.indicator_type" */
  indicator_type: Array<Indicator_Type>;
  /** fetch data from the table: "risksmart.indicator_type" using primary key columns */
  indicator_type_by_pk?: Maybe<Indicator_Type>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_type" */
  indicator_type_stream: Array<Indicator_Type>;
  /** fetch data from the table: "risksmart.internal_audit_entity" */
  internal_audit_entity: Array<Internal_Audit_Entity>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_entity" */
  internal_audit_entity_aggregate: Internal_Audit_Entity_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_entity" using primary key columns */
  internal_audit_entity_by_pk?: Maybe<Internal_Audit_Entity>;
  /** fetch data from the table in a streaming manner: "risksmart.internal_audit_entity" */
  internal_audit_entity_stream: Array<Internal_Audit_Entity>;
  /** fetch data from the table: "risksmart.internal_audit_report" */
  internal_audit_report: Array<Internal_Audit_Report>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_report" */
  internal_audit_report_aggregate: Internal_Audit_Report_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_report" using primary key columns */
  internal_audit_report_by_pk?: Maybe<Internal_Audit_Report>;
  /** fetch data from the table in a streaming manner: "risksmart.internal_audit_report" */
  internal_audit_report_stream: Array<Internal_Audit_Report>;
  /** fetch data from the table: "risksmart.internal_audit_result_parent" */
  internal_audit_result_parent: Array<Internal_Audit_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.internal_audit_result_parent" */
  internal_audit_result_parent_aggregate: Internal_Audit_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.internal_audit_result_parent" using primary key columns */
  internal_audit_result_parent_by_pk?: Maybe<Internal_Audit_Result_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.internal_audit_result_parent" */
  internal_audit_result_parent_stream: Array<Internal_Audit_Result_Parent>;
  /** fetch data from the table: "risksmart.issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "risksmart.issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "risksmart.issue_assessment" */
  issue_assessment: Array<Issue_Assessment>;
  /** fetch aggregated fields from the table: "risksmart.issue_assessment" */
  issue_assessment_aggregate: Issue_Assessment_Aggregate;
  /** fetch data from the table: "risksmart.issue_assessment_audit" */
  issue_assessment_audit: Array<Issue_Assessment_Audit>;
  /** fetch data from the table: "risksmart.issue_assessment_audit" using primary key columns */
  issue_assessment_audit_by_pk?: Maybe<Issue_Assessment_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_assessment_audit" */
  issue_assessment_audit_stream: Array<Issue_Assessment_Audit>;
  /** fetch data from the table: "risksmart.issue_assessment" using primary key columns */
  issue_assessment_by_pk?: Maybe<Issue_Assessment>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_assessment" */
  issue_assessment_stream: Array<Issue_Assessment>;
  /** fetch data from the table: "risksmart.issue_audit" */
  issue_audit: Array<Issue_Audit>;
  /** fetch data from the table: "risksmart.issue_audit" using primary key columns */
  issue_audit_by_pk?: Maybe<Issue_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_audit" */
  issue_audit_stream: Array<Issue_Audit>;
  /** fetch data from the table: "risksmart.issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table: "risksmart.issue_parent" */
  issue_parent: Array<Issue_Parent>;
  /** fetch aggregated fields from the table: "risksmart.issue_parent" */
  issue_parent_aggregate: Issue_Parent_Aggregate;
  /** fetch data from the table: "risksmart.issue_parent_audit" */
  issue_parent_audit: Array<Issue_Parent_Audit>;
  /** fetch data from the table: "risksmart.issue_parent_audit" using primary key columns */
  issue_parent_audit_by_pk?: Maybe<Issue_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_parent_audit" */
  issue_parent_audit_stream: Array<Issue_Parent_Audit>;
  /** fetch data from the table: "risksmart.issue_parent" using primary key columns */
  issue_parent_by_pk?: Maybe<Issue_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_parent" */
  issue_parent_stream: Array<Issue_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.issue" */
  issue_stream: Array<Issue>;
  /** fetch data from the table: "risksmart.issue_update" */
  issue_update: Array<Issue_Update>;
  /** fetch data from the table: "risksmart.issue_update_audit" */
  issue_update_audit: Array<Issue_Update_Audit>;
  /** fetch data from the table: "risksmart.issue_update_audit" using primary key columns */
  issue_update_audit_by_pk?: Maybe<Issue_Update_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_update_audit" */
  issue_update_audit_stream: Array<Issue_Update_Audit>;
  /** fetch data from the table: "risksmart.issue_update" using primary key columns */
  issue_update_by_pk?: Maybe<Issue_Update>;
  /** fetch data from the table in a streaming manner: "risksmart.issue_update" */
  issue_update_stream: Array<Issue_Update>;
  /** fetch data from the table: "risksmart.issue_update_summary_view" */
  issue_update_summary: Array<Issue_Update_Summary>;
  /** fetch aggregated fields from the table: "risksmart.issue_update_summary_view" */
  issue_update_summary_aggregate: Issue_Update_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "risksmart.issue_update_summary_view" */
  issue_update_summary_stream: Array<Issue_Update_Summary>;
  /** fetch data from the table: "risksmart.linked_item" */
  linked_item: Array<Linked_Item>;
  /** fetch data from the table: "risksmart.linked_item" using primary key columns */
  linked_item_by_pk?: Maybe<Linked_Item>;
  /** fetch data from the table in a streaming manner: "risksmart.linked_item" */
  linked_item_stream: Array<Linked_Item>;
  /** fetch data from the table: "risksmart.node" */
  node: Array<Node>;
  /** fetch aggregated fields from the table: "risksmart.node" */
  node_aggregate: Node_Aggregate;
  /** fetch data from the table: "risksmart.node" using primary key columns */
  node_by_pk?: Maybe<Node>;
  /** fetch data from the table in a streaming manner: "risksmart.node" */
  node_stream: Array<Node>;
  /** fetch data from the table: "risksmart.obligation" */
  obligation: Array<Obligation>;
  /** fetch aggregated fields from the table: "risksmart.obligation" */
  obligation_aggregate: Obligation_Aggregate;
  /** fetch data from the table: "risksmart.obligation_assessment_result" */
  obligation_assessment_result: Array<Obligation_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_assessment_result" */
  obligation_assessment_result_aggregate: Obligation_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_assessment_result_audit" */
  obligation_assessment_result_audit: Array<Obligation_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.obligation_assessment_result_audit" using primary key columns */
  obligation_assessment_result_audit_by_pk?: Maybe<Obligation_Assessment_Result_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_assessment_result_audit" */
  obligation_assessment_result_audit_stream: Array<Obligation_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.obligation_assessment_result" using primary key columns */
  obligation_assessment_result_by_pk?: Maybe<Obligation_Assessment_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_assessment_result" */
  obligation_assessment_result_stream: Array<Obligation_Assessment_Result>;
  /** fetch data from the table: "risksmart.obligation_assessment_status" */
  obligation_assessment_status: Array<Obligation_Assessment_Status>;
  /** fetch data from the table: "risksmart.obligation_assessment_status" using primary key columns */
  obligation_assessment_status_by_pk?: Maybe<Obligation_Assessment_Status>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_assessment_status" */
  obligation_assessment_status_stream: Array<Obligation_Assessment_Status>;
  /** fetch data from the table: "risksmart.obligation_audit" */
  obligation_audit: Array<Obligation_Audit>;
  /** fetch aggregated fields from the table: "risksmart.obligation_audit" */
  obligation_audit_aggregate: Obligation_Audit_Aggregate;
  /** fetch data from the table: "risksmart.obligation_audit" using primary key columns */
  obligation_audit_by_pk?: Maybe<Obligation_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_audit" */
  obligation_audit_stream: Array<Obligation_Audit>;
  /** fetch data from the table: "risksmart.obligation" using primary key columns */
  obligation_by_pk?: Maybe<Obligation>;
  /** fetch data from the table: "risksmart.obligation_change" */
  obligation_change: Array<Obligation_Change>;
  /** fetch data from the table: "risksmart.obligation_change_attestation" */
  obligation_change_attestation: Array<Obligation_Change_Attestation>;
  /** fetch data from the table: "risksmart.obligation_change_attestation" using primary key columns */
  obligation_change_attestation_by_pk?: Maybe<Obligation_Change_Attestation>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_change_attestation" */
  obligation_change_attestation_stream: Array<Obligation_Change_Attestation>;
  /** fetch data from the table: "risksmart.obligation_change" using primary key columns */
  obligation_change_by_pk?: Maybe<Obligation_Change>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_change" */
  obligation_change_stream: Array<Obligation_Change>;
  /** fetch data from the table: "risksmart.obligation_impact" */
  obligation_impact: Array<Obligation_Impact>;
  /** fetch data from the table: "risksmart.obligation_impact_audit" */
  obligation_impact_audit: Array<Obligation_Impact_Audit>;
  /** fetch data from the table: "risksmart.obligation_impact_audit" using primary key columns */
  obligation_impact_audit_by_pk?: Maybe<Obligation_Impact_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_impact_audit" */
  obligation_impact_audit_stream: Array<Obligation_Impact_Audit>;
  /** fetch data from the table: "risksmart.obligation_impact" using primary key columns */
  obligation_impact_by_pk?: Maybe<Obligation_Impact>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_impact" */
  obligation_impact_stream: Array<Obligation_Impact>;
  /** fetch data from the table: "risksmart.obligation_internal_audit_result" */
  obligation_internal_audit_result: Array<Obligation_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_internal_audit_result" */
  obligation_internal_audit_result_aggregate: Obligation_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_internal_audit_result" using primary key columns */
  obligation_internal_audit_result_by_pk?: Maybe<Obligation_Internal_Audit_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_internal_audit_result" */
  obligation_internal_audit_result_stream: Array<Obligation_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.obligation_second_line_result" */
  obligation_second_line_result: Array<Obligation_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.obligation_second_line_result" */
  obligation_second_line_result_aggregate: Obligation_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.obligation_second_line_result" using primary key columns */
  obligation_second_line_result_by_pk?: Maybe<Obligation_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_second_line_result" */
  obligation_second_line_result_stream: Array<Obligation_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation" */
  obligation_stream: Array<Obligation>;
  /** fetch data from the table: "risksmart.obligation_type" */
  obligation_type: Array<Obligation_Type>;
  /** fetch data from the table: "risksmart.obligation_type" using primary key columns */
  obligation_type_by_pk?: Maybe<Obligation_Type>;
  /** fetch data from the table in a streaming manner: "risksmart.obligation_type" */
  obligation_type_stream: Array<Obligation_Type>;
  /** fetch data from the table: "risksmart.organisation_module" */
  organisation_module: Array<Organisation_Module>;
  /** fetch data from the table in a streaming manner: "risksmart.organisation_module" */
  organisation_module_stream: Array<Organisation_Module>;
  /** fetch data from the table: "risksmart.organisation_tab_preference" */
  organisation_tab_preference: Array<Organisation_Tab_Preference>;
  /** fetch data from the table in a streaming manner: "risksmart.organisation_tab_preference" */
  organisation_tab_preference_stream: Array<Organisation_Tab_Preference>;
  /** fetch data from the table: "risksmart.owner_audit" */
  owner_audit: Array<Owner_Audit>;
  /** fetch data from the table: "risksmart.owner_audit" using primary key columns */
  owner_audit_by_pk?: Maybe<Owner_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.owner_audit" */
  owner_audit_stream: Array<Owner_Audit>;
  /** fetch data from the table: "risksmart.owner_group_audit" */
  owner_group_audit: Array<Owner_Group_Audit>;
  /** fetch data from the table: "risksmart.owner_group_audit" using primary key columns */
  owner_group_audit_by_pk?: Maybe<Owner_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.owner_group_audit" */
  owner_group_audit_stream: Array<Owner_Group_Audit>;
  /** fetch data from the table: "risksmart.questionnaire_invite" */
  questionnaire_invite: Array<Questionnaire_Invite>;
  /** fetch data from the table: "risksmart.questionnaire_invite" using primary key columns */
  questionnaire_invite_by_pk?: Maybe<Questionnaire_Invite>;
  /** fetch data from the table in a streaming manner: "risksmart.questionnaire_invite" */
  questionnaire_invite_stream: Array<Questionnaire_Invite>;
  /** fetch data from the table: "risksmart.questionnaire_template" */
  questionnaire_template: Array<Questionnaire_Template>;
  /** fetch data from the table: "risksmart.questionnaire_template" using primary key columns */
  questionnaire_template_by_pk?: Maybe<Questionnaire_Template>;
  /** fetch data from the table in a streaming manner: "risksmart.questionnaire_template" */
  questionnaire_template_stream: Array<Questionnaire_Template>;
  /** fetch data from the table: "risksmart.questionnaire_template_version" */
  questionnaire_template_version: Array<Questionnaire_Template_Version>;
  /** fetch data from the table: "risksmart.questionnaire_template_version" using primary key columns */
  questionnaire_template_version_by_pk?: Maybe<Questionnaire_Template_Version>;
  /** fetch data from the table: "risksmart.questionnaire_template_version_status" */
  questionnaire_template_version_status: Array<Questionnaire_Template_Version_Status>;
  /** fetch data from the table: "risksmart.questionnaire_template_version_status" using primary key columns */
  questionnaire_template_version_status_by_pk?: Maybe<Questionnaire_Template_Version_Status>;
  /** fetch data from the table in a streaming manner: "risksmart.questionnaire_template_version_status" */
  questionnaire_template_version_status_stream: Array<Questionnaire_Template_Version_Status>;
  /** fetch data from the table in a streaming manner: "risksmart.questionnaire_template_version" */
  questionnaire_template_version_stream: Array<Questionnaire_Template_Version>;
  /** fetch data from the table: "risksmart.relation_file" */
  relation_file: Array<Relation_File>;
  /** fetch aggregated fields from the table: "risksmart.relation_file" */
  relation_file_aggregate: Relation_File_Aggregate;
  /** fetch data from the table: "risksmart.relation_file_audit" */
  relation_file_audit: Array<Relation_File_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.relation_file_audit" */
  relation_file_audit_stream: Array<Relation_File_Audit>;
  /** fetch data from the table: "risksmart.relation_file" using primary key columns */
  relation_file_by_pk?: Maybe<Relation_File>;
  /** fetch data from the table in a streaming manner: "risksmart.relation_file" */
  relation_file_stream: Array<Relation_File>;
  /** fetch data from the table: "risksmart.risk" */
  risk: Array<Risk>;
  /** fetch aggregated fields from the table: "risksmart.risk" */
  risk_aggregate: Risk_Aggregate;
  /** fetch data from the table: "risksmart.risk_assessment_result" */
  risk_assessment_result: Array<Risk_Assessment_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_assessment_result" */
  risk_assessment_result_aggregate: Risk_Assessment_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_assessment_result_audit" */
  risk_assessment_result_audit: Array<Risk_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_audit" using primary key columns */
  risk_assessment_result_audit_by_pk?: Maybe<Risk_Assessment_Result_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result_audit" */
  risk_assessment_result_audit_stream: Array<Risk_Assessment_Result_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result" using primary key columns */
  risk_assessment_result_by_pk?: Maybe<Risk_Assessment_Result>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config" */
  risk_assessment_result_config: Array<Risk_Assessment_Result_Config>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config_audit" */
  risk_assessment_result_config_audit: Array<Risk_Assessment_Result_Config_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result_config_audit" */
  risk_assessment_result_config_audit_stream: Array<Risk_Assessment_Result_Config_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_config" using primary key columns */
  risk_assessment_result_config_by_pk?: Maybe<Risk_Assessment_Result_Config>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result_config" */
  risk_assessment_result_config_stream: Array<Risk_Assessment_Result_Config>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact" */
  risk_assessment_result_impact: Array<Risk_Assessment_Result_Impact>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact_audit" */
  risk_assessment_result_impact_audit: Array<Risk_Assessment_Result_Impact_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result_impact_audit" */
  risk_assessment_result_impact_audit_stream: Array<Risk_Assessment_Result_Impact_Audit>;
  /** fetch data from the table: "risksmart.risk_assessment_result_impact" using primary key columns */
  risk_assessment_result_impact_by_pk?: Maybe<Risk_Assessment_Result_Impact>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result_impact" */
  risk_assessment_result_impact_stream: Array<Risk_Assessment_Result_Impact>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_assessment_result" */
  risk_assessment_result_stream: Array<Risk_Assessment_Result>;
  /** fetch data from the table: "risksmart.risk_audit" */
  risk_audit: Array<Risk_Audit>;
  /** fetch aggregated fields from the table: "risksmart.risk_audit" */
  risk_audit_aggregate: Risk_Audit_Aggregate;
  /** fetch data from the table: "risksmart.risk_audit" using primary key columns */
  risk_audit_by_pk?: Maybe<Risk_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_audit" */
  risk_audit_stream: Array<Risk_Audit>;
  /** fetch data from the table: "risksmart.risk" using primary key columns */
  risk_by_pk?: Maybe<Risk>;
  /** fetch data from the table: "risksmart.risk_controlled_internal_audit_result" */
  risk_controlled_internal_audit_result: Array<Risk_Controlled_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_controlled_internal_audit_result" */
  risk_controlled_internal_audit_result_aggregate: Risk_Controlled_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_controlled_internal_audit_result" using primary key columns */
  risk_controlled_internal_audit_result_by_pk?: Maybe<Risk_Controlled_Internal_Audit_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_controlled_internal_audit_result" */
  risk_controlled_internal_audit_result_stream: Array<Risk_Controlled_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.risk_controlled_second_line_result" */
  risk_controlled_second_line_result: Array<Risk_Controlled_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_controlled_second_line_result" */
  risk_controlled_second_line_result_aggregate: Risk_Controlled_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_controlled_second_line_result" using primary key columns */
  risk_controlled_second_line_result_by_pk?: Maybe<Risk_Controlled_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_controlled_second_line_result" */
  risk_controlled_second_line_result_stream: Array<Risk_Controlled_Second_Line_Result>;
  /** fetch data from the table: "risksmart.risk_score" */
  risk_score: Array<Risk_Score>;
  /** fetch aggregated fields from the table: "risksmart.risk_score" */
  risk_score_aggregate: Risk_Score_Aggregate;
  /** fetch data from the table: "risksmart.risk_score" using primary key columns */
  risk_score_by_pk?: Maybe<Risk_Score>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_score" */
  risk_score_stream: Array<Risk_Score>;
  /** fetch data from the table in a streaming manner: "risksmart.risk" */
  risk_stream: Array<Risk>;
  /** fetch data from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  risk_uncontrolled_internal_audit_result: Array<Risk_Uncontrolled_Internal_Audit_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_uncontrolled_internal_audit_result" */
  risk_uncontrolled_internal_audit_result_aggregate: Risk_Uncontrolled_Internal_Audit_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_uncontrolled_internal_audit_result" using primary key columns */
  risk_uncontrolled_internal_audit_result_by_pk?: Maybe<Risk_Uncontrolled_Internal_Audit_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_uncontrolled_internal_audit_result" */
  risk_uncontrolled_internal_audit_result_stream: Array<Risk_Uncontrolled_Internal_Audit_Result>;
  /** fetch data from the table: "risksmart.risk_uncontrolled_second_line_result" */
  risk_uncontrolled_second_line_result: Array<Risk_Uncontrolled_Second_Line_Result>;
  /** fetch aggregated fields from the table: "risksmart.risk_uncontrolled_second_line_result" */
  risk_uncontrolled_second_line_result_aggregate: Risk_Uncontrolled_Second_Line_Result_Aggregate;
  /** fetch data from the table: "risksmart.risk_uncontrolled_second_line_result" using primary key columns */
  risk_uncontrolled_second_line_result_by_pk?: Maybe<Risk_Uncontrolled_Second_Line_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.risk_uncontrolled_second_line_result" */
  risk_uncontrolled_second_line_result_stream: Array<Risk_Uncontrolled_Second_Line_Result>;
  /** fetch data from the table: "risksmart.indicator_parent_audit" */
  risksmart_indicator_parent_audit: Array<Risksmart_Indicator_Parent_Audit>;
  /** fetch data from the table: "risksmart.indicator_parent_audit" using primary key columns */
  risksmart_indicator_parent_audit_by_pk?: Maybe<Risksmart_Indicator_Parent_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.indicator_parent_audit" */
  risksmart_indicator_parent_audit_stream: Array<Risksmart_Indicator_Parent_Audit>;
  /** fetch data from the table: "risksmart.linked_item_audit" */
  risksmart_linked_item_audit: Array<Risksmart_Linked_Item_Audit>;
  /** fetch data from the table: "risksmart.linked_item_audit" using primary key columns */
  risksmart_linked_item_audit_by_pk?: Maybe<Risksmart_Linked_Item_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.linked_item_audit" */
  risksmart_linked_item_audit_stream: Array<Risksmart_Linked_Item_Audit>;
  /** fetch data from the table: "risksmart.role_access" */
  role_access: Array<Role_Access>;
  /** fetch data from the table in a streaming manner: "risksmart.role_access" */
  role_access_stream: Array<Role_Access>;
  /** fetch data from the table: "risksmart.second_line_result_parent" */
  second_line_result_parent: Array<Second_Line_Result_Parent>;
  /** fetch aggregated fields from the table: "risksmart.second_line_result_parent" */
  second_line_result_parent_aggregate: Second_Line_Result_Parent_Aggregate;
  /** fetch data from the table: "risksmart.second_line_result_parent" using primary key columns */
  second_line_result_parent_by_pk?: Maybe<Second_Line_Result_Parent>;
  /** fetch data from the table in a streaming manner: "risksmart.second_line_result_parent" */
  second_line_result_parent_stream: Array<Second_Line_Result_Parent>;
  /** fetch data from the table: "risksmart.tab" */
  tab: Array<Tab>;
  /** fetch data from the table: "risksmart.tab" using primary key columns */
  tab_by_pk?: Maybe<Tab>;
  /** fetch data from the table in a streaming manner: "risksmart.tab" */
  tab_stream: Array<Tab>;
  /** fetch data from the table: "risksmart.tag_type" */
  tag_type: Array<Tag_Type>;
  /** fetch data from the table: "risksmart.tag_type_audit" */
  tag_type_audit: Array<Tag_Type_Audit>;
  /** fetch data from the table: "risksmart.tag_type_audit" using primary key columns */
  tag_type_audit_by_pk?: Maybe<Tag_Type_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.tag_type_audit" */
  tag_type_audit_stream: Array<Tag_Type_Audit>;
  /** fetch data from the table: "risksmart.tag_type" using primary key columns */
  tag_type_by_pk?: Maybe<Tag_Type>;
  /** fetch data from the table: "risksmart.tag_type_group" */
  tag_type_group: Array<Tag_Type_Group>;
  /** fetch data from the table: "risksmart.tag_type_group_audit" */
  tag_type_group_audit: Array<Tag_Type_Group_Audit>;
  /** fetch data from the table: "risksmart.tag_type_group_audit" using primary key columns */
  tag_type_group_audit_by_pk?: Maybe<Tag_Type_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.tag_type_group_audit" */
  tag_type_group_audit_stream: Array<Tag_Type_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.tag_type_group" */
  tag_type_group_stream: Array<Tag_Type_Group>;
  /** fetch data from the table in a streaming manner: "risksmart.tag_type" */
  tag_type_stream: Array<Tag_Type>;
  /** fetch data from the table: "risksmart.taxonomy" */
  taxonomy: Array<Taxonomy>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy" */
  taxonomy_aggregate: Taxonomy_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_audit" */
  taxonomy_audit: Array<Taxonomy_Audit>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy_audit" */
  taxonomy_audit_aggregate: Taxonomy_Audit_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_audit" using primary key columns */
  taxonomy_audit_by_pk?: Maybe<Taxonomy_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.taxonomy_audit" */
  taxonomy_audit_stream: Array<Taxonomy_Audit>;
  /** fetch data from the table: "risksmart.taxonomy" using primary key columns */
  taxonomy_by_pk?: Maybe<Taxonomy>;
  /** fetch data from the table: "risksmart.taxonomy_org" */
  taxonomy_org: Array<Taxonomy_Org>;
  /** fetch aggregated fields from the table: "risksmart.taxonomy_org" */
  taxonomy_org_aggregate: Taxonomy_Org_Aggregate;
  /** fetch data from the table: "risksmart.taxonomy_org" using primary key columns */
  taxonomy_org_by_pk?: Maybe<Taxonomy_Org>;
  /** fetch data from the table in a streaming manner: "risksmart.taxonomy_org" */
  taxonomy_org_stream: Array<Taxonomy_Org>;
  /** fetch data from the table in a streaming manner: "risksmart.taxonomy" */
  taxonomy_stream: Array<Taxonomy>;
  /** fetch data from the table: "risksmart.test_result" */
  test_result: Array<Test_Result>;
  /** fetch aggregated fields from the table: "risksmart.test_result" */
  test_result_aggregate: Test_Result_Aggregate;
  /** fetch data from the table: "risksmart.test_result_audit" */
  test_result_audit: Array<Test_Result_Audit>;
  /** fetch data from the table: "risksmart.test_result_audit" using primary key columns */
  test_result_audit_by_pk?: Maybe<Test_Result_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.test_result_audit" */
  test_result_audit_stream: Array<Test_Result_Audit>;
  /** fetch data from the table: "risksmart.test_result" using primary key columns */
  test_result_by_pk?: Maybe<Test_Result>;
  /** fetch data from the table in a streaming manner: "risksmart.test_result" */
  test_result_stream: Array<Test_Result>;
  /** fetch data from the table: "risksmart.third_party" */
  third_party: Array<Third_Party>;
  /** fetch data from the table: "risksmart.third_party" using primary key columns */
  third_party_by_pk?: Maybe<Third_Party>;
  /** fetch data from the table: "risksmart.third_party_contact" */
  third_party_contact: Array<Third_Party_Contact>;
  /** fetch data from the table: "risksmart.third_party_contact_audit" */
  third_party_contact_audit: Array<Third_Party_Contact_Audit>;
  /** fetch data from the table: "risksmart.third_party_contact_audit" using primary key columns */
  third_party_contact_audit_by_pk?: Maybe<Third_Party_Contact_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.third_party_contact_audit" */
  third_party_contact_audit_stream: Array<Third_Party_Contact_Audit>;
  /** fetch data from the table: "risksmart.third_party_contact" using primary key columns */
  third_party_contact_by_pk?: Maybe<Third_Party_Contact>;
  /** fetch data from the table in a streaming manner: "risksmart.third_party_contact" */
  third_party_contact_stream: Array<Third_Party_Contact>;
  /** fetch data from the table: "risksmart.third_party_response" */
  third_party_response: Array<Third_Party_Response>;
  /** fetch data from the table: "risksmart.third_party_response" using primary key columns */
  third_party_response_by_pk?: Maybe<Third_Party_Response>;
  /** fetch data from the table: "risksmart.third_party_response_status" */
  third_party_response_status: Array<Third_Party_Response_Status>;
  /** fetch data from the table: "risksmart.third_party_response_status" using primary key columns */
  third_party_response_status_by_pk?: Maybe<Third_Party_Response_Status>;
  /** fetch data from the table in a streaming manner: "risksmart.third_party_response_status" */
  third_party_response_status_stream: Array<Third_Party_Response_Status>;
  /** fetch data from the table in a streaming manner: "risksmart.third_party_response" */
  third_party_response_stream: Array<Third_Party_Response>;
  /** fetch data from the table in a streaming manner: "risksmart.third_party" */
  third_party_stream: Array<Third_Party>;
  /** fetch data from the table: "risksmart.user_view_active" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "risksmart.user_view_active" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "risksmart.user_group" */
  user_group: Array<User_Group>;
  /** fetch data from the table: "risksmart.user_group_audit" */
  user_group_audit: Array<User_Group_Audit>;
  /** fetch data from the table: "risksmart.user_group_audit" using primary key columns */
  user_group_audit_by_pk?: Maybe<User_Group_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.user_group_audit" */
  user_group_audit_stream: Array<User_Group_Audit>;
  /** fetch data from the table: "risksmart.user_group" using primary key columns */
  user_group_by_pk?: Maybe<User_Group>;
  /** fetch data from the table in a streaming manner: "risksmart.user_group" */
  user_group_stream: Array<User_Group>;
  /** fetch data from the table: "risksmart.user_group_user" */
  user_group_user: Array<User_Group_User>;
  /** fetch aggregated fields from the table: "risksmart.user_group_user" */
  user_group_user_aggregate: User_Group_User_Aggregate;
  /** fetch data from the table: "risksmart.user_group_user_audit" */
  user_group_user_audit: Array<User_Group_User_Audit>;
  /** fetch data from the table: "risksmart.user_group_user_audit" using primary key columns */
  user_group_user_audit_by_pk?: Maybe<User_Group_User_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.user_group_user_audit" */
  user_group_user_audit_stream: Array<User_Group_User_Audit>;
  /** fetch data from the table: "risksmart.user_group_user" using primary key columns */
  user_group_user_by_pk?: Maybe<User_Group_User>;
  /** fetch data from the table in a streaming manner: "risksmart.user_group_user" */
  user_group_user_stream: Array<User_Group_User>;
  /** fetch data from the table: "auth.user_role_audit" */
  user_role_audit: Array<User_Role_Audit>;
  /** fetch data from the table: "auth.user_role_audit" using primary key columns */
  user_role_audit_by_pk?: Maybe<User_Role_Audit>;
  /** fetch data from the table in a streaming manner: "auth.user_role_audit" */
  user_role_audit_stream: Array<User_Role_Audit>;
  /** fetch data from the table: "risksmart.user_search_preferences" */
  user_search_preferences: Array<User_Search_Preferences>;
  /** fetch data from the table: "risksmart.user_search_preferences_audit" */
  user_search_preferences_audit: Array<User_Search_Preferences_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.user_search_preferences_audit" */
  user_search_preferences_audit_stream: Array<User_Search_Preferences_Audit>;
  /** fetch data from the table in a streaming manner: "risksmart.user_search_preferences" */
  user_search_preferences_stream: Array<User_Search_Preferences>;
  /** fetch data from the table in a streaming manner: "risksmart.user_view_active" */
  user_stream: Array<User>;
  /** fetch data from the table: "risksmart.user_tab_preference" */
  user_tab_preference: Array<User_Tab_Preference>;
  /** fetch data from the table in a streaming manner: "risksmart.user_tab_preference" */
  user_tab_preference_stream: Array<User_Tab_Preference>;
  /** fetch data from the table: "risksmart.user_table_preferences" */
  user_table_preferences: Array<User_Table_Preferences>;
  /** fetch data from the table in a streaming manner: "risksmart.user_table_preferences" */
  user_table_preferences_stream: Array<User_Table_Preferences>;
  /** fetch data from the table: "risksmart.wizard" */
  wizard: Array<Wizard>;
  /** fetch data from the table: "risksmart.wizard" using primary key columns */
  wizard_by_pk?: Maybe<Wizard>;
  /** fetch data from the table in a streaming manner: "risksmart.wizard" */
  wizard_stream: Array<Wizard>;
};


export type Subscription_RootAcceptanceArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Order_By>>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};


export type Subscription_RootAcceptance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Order_By>>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};


export type Subscription_RootAcceptance_AuditArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Audit_Order_By>>;
  where?: InputMaybe<Acceptance_Audit_Bool_Exp>;
};


export type Subscription_RootAcceptance_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAcceptance_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Acceptance_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Acceptance_Audit_Bool_Exp>;
};


export type Subscription_RootAcceptance_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAcceptance_ParentArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


export type Subscription_RootAcceptance_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


export type Subscription_RootAcceptance_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Acceptance_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Acceptance_Parent_Audit_Order_By>>;
  where?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAcceptance_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAcceptance_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Acceptance_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Acceptance_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAcceptance_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAcceptance_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Acceptance_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Acceptance_Parent_Bool_Exp>;
};


export type Subscription_RootAcceptance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Acceptance_Stream_Cursor_Input>>;
  where?: InputMaybe<Acceptance_Bool_Exp>;
};


export type Subscription_RootActionArgs = {
  distinct_on?: InputMaybe<Array<Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Order_By>>;
  where?: InputMaybe<Action_Bool_Exp>;
};


export type Subscription_RootAction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Order_By>>;
  where?: InputMaybe<Action_Bool_Exp>;
};


export type Subscription_RootAction_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Audit_Order_By>>;
  where?: InputMaybe<Action_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Audit_Order_By>>;
  where?: InputMaybe<Action_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAction_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Audit_Bool_Exp>;
};


export type Subscription_RootAction_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAction_ParentArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


export type Subscription_RootAction_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Order_By>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


export type Subscription_RootAction_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Parent_Audit_Order_By>>;
  where?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Parent_Audit_By_PkArgs = {
  ActionId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAction_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Parent_By_PkArgs = {
  ActionId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAction_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Parent_Bool_Exp>;
};


export type Subscription_RootAction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Bool_Exp>;
};


export type Subscription_RootAction_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


export type Subscription_RootAction_Update_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Order_By>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


export type Subscription_RootAction_Update_AuditArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Audit_Order_By>>;
  where?: InputMaybe<Action_Update_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Update_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAction_Update_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Update_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Update_Audit_Bool_Exp>;
};


export type Subscription_RootAction_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAction_Update_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Update_Bool_Exp>;
};


export type Subscription_RootAction_Update_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Summary_Order_By>>;
  where?: InputMaybe<Action_Update_Summary_Bool_Exp>;
};


export type Subscription_RootAction_Update_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Action_Update_Summary_Order_By>>;
  where?: InputMaybe<Action_Update_Summary_Bool_Exp>;
};


export type Subscription_RootAction_Update_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Action_Update_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Update_Summary_Bool_Exp>;
};


export type Subscription_RootAggregation_OrgArgs = {
  distinct_on?: InputMaybe<Array<Aggregation_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregation_Org_Order_By>>;
  where?: InputMaybe<Aggregation_Org_Bool_Exp>;
};


export type Subscription_RootAggregation_Org_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
};


export type Subscription_RootAggregation_Org_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Aggregation_Org_Stream_Cursor_Input>>;
  where?: InputMaybe<Aggregation_Org_Bool_Exp>;
};


export type Subscription_RootAncestor_ContributorArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


export type Subscription_RootAncestor_Contributor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ancestor_Contributor_Stream_Cursor_Input>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


export type Subscription_RootAppetiteArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


export type Subscription_RootAppetite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Order_By>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


export type Subscription_RootAppetite_AuditArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Audit_Bool_Exp>;
};


export type Subscription_RootAppetite_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAppetite_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appetite_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Appetite_Audit_Bool_Exp>;
};


export type Subscription_RootAppetite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAppetite_ParentArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


export type Subscription_RootAppetite_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


export type Subscription_RootAppetite_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAppetite_Parent_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appetite_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appetite_Parent_Audit_Order_By>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAppetite_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAppetite_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appetite_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Appetite_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAppetite_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAppetite_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appetite_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Appetite_Parent_Bool_Exp>;
};


export type Subscription_RootAppetite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appetite_Stream_Cursor_Input>>;
  where?: InputMaybe<Appetite_Bool_Exp>;
};


export type Subscription_RootApprovalArgs = {
  distinct_on?: InputMaybe<Array<Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Order_By>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Subscription_RootApproval_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approval_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Audit_Order_By>>;
  where?: InputMaybe<Approval_Audit_Bool_Exp>;
};


export type Subscription_RootApproval_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootApproval_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approval_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Approval_Audit_Bool_Exp>;
};


export type Subscription_RootApproval_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootApproval_LevelArgs = {
  distinct_on?: InputMaybe<Array<Approval_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Level_Order_By>>;
  where?: InputMaybe<Approval_Level_Bool_Exp>;
};


export type Subscription_RootApproval_Level_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approval_Level_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approval_Level_Audit_Order_By>>;
  where?: InputMaybe<Approval_Level_Audit_Bool_Exp>;
};


export type Subscription_RootApproval_Level_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootApproval_Level_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approval_Level_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Approval_Level_Audit_Bool_Exp>;
};


export type Subscription_RootApproval_Level_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootApproval_Level_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approval_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Approval_Level_Bool_Exp>;
};


export type Subscription_RootApproval_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approval_Stream_Cursor_Input>>;
  where?: InputMaybe<Approval_Bool_Exp>;
};


export type Subscription_RootApproverArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


export type Subscription_RootApprover_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


export type Subscription_RootApprover_AuditArgs = {
  distinct_on?: InputMaybe<Array<Approver_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Audit_Order_By>>;
  where?: InputMaybe<Approver_Audit_Bool_Exp>;
};


export type Subscription_RootApprover_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootApprover_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approver_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Approver_Audit_Bool_Exp>;
};


export type Subscription_RootApprover_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootApprover_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Approver_Stream_Cursor_Input>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


export type Subscription_RootAssessmentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAssessment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


export type Subscription_RootAssessment_Activity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


export type Subscription_RootAssessment_Activity_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Activity_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Activity_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Activity_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Activity_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAssessment_Activity_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Activity_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Activity_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Activity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Activity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Activity_Bool_Exp>;
};


export type Subscription_RootAssessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Order_By>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAssessment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootAssessment_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


export type Subscription_RootAssessment_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


export type Subscription_RootAssessment_Result_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Audit_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Result_Parent_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Result_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Result_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Result_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootAssessment_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Result_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Result_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


export type Subscription_RootAssessment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Bool_Exp>;
};


export type Subscription_RootAttestation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Config_Order_By>>;
  where?: InputMaybe<Attestation_Config_Bool_Exp>;
};


export type Subscription_RootAttestation_Config_By_PkArgs = {
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootAttestation_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attestation_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Attestation_Config_Bool_Exp>;
};


export type Subscription_RootAttestation_CycleArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Cycle_Order_By>>;
  where?: InputMaybe<Attestation_Cycle_Bool_Exp>;
};


export type Subscription_RootAttestation_Cycle_AuditArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Cycle_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Cycle_Audit_Order_By>>;
  where?: InputMaybe<Attestation_Cycle_Audit_Bool_Exp>;
};


export type Subscription_RootAttestation_Cycle_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attestation_Cycle_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Attestation_Cycle_Audit_Bool_Exp>;
};


export type Subscription_RootAttestation_Cycle_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAttestation_Cycle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attestation_Cycle_Stream_Cursor_Input>>;
  where?: InputMaybe<Attestation_Cycle_Bool_Exp>;
};


export type Subscription_RootAttestation_GroupArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Group_Order_By>>;
  where?: InputMaybe<Attestation_Group_Bool_Exp>;
};


export type Subscription_RootAttestation_Group_By_PkArgs = {
  ConfigId: Scalars['uuid']['input'];
  GroupId: Scalars['uuid']['input'];
};


export type Subscription_RootAttestation_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attestation_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Attestation_Group_Bool_Exp>;
};


export type Subscription_RootAttestation_RecordArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


export type Subscription_RootAttestation_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attestation_Record_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attestation_Record_Order_By>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


export type Subscription_RootAttestation_Record_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootAttestation_Record_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attestation_Record_Stream_Cursor_Input>>;
  where?: InputMaybe<Attestation_Record_Bool_Exp>;
};


export type Subscription_RootAudit_Log_ViewArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_View_Order_By>>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
};


export type Subscription_RootAudit_Log_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_View_Order_By>>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
};


export type Subscription_RootAudit_Log_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Log_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
};


export type Subscription_RootAuth_OrganisationArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisation_Order_By>>;
  where?: InputMaybe<Auth_Organisation_Bool_Exp>;
};


export type Subscription_RootAuth_Organisation_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
};


export type Subscription_RootAuth_Organisation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Organisation_Bool_Exp>;
};


export type Subscription_RootAuth_OrganisationuserArgs = {
  distinct_on?: InputMaybe<Array<Auth_Organisationuser_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Organisationuser_Order_By>>;
  where?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};


export type Subscription_RootAuth_Organisationuser_By_PkArgs = {
  OrgKey: Scalars['String']['input'];
  User_Id: Scalars['String']['input'];
};


export type Subscription_RootAuth_Organisationuser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Organisationuser_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Organisationuser_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Resource_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Resource_Type_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Resource_Type_By_PkArgs = {
  ResourceType: Parent_Type_Enum;
};


export type Subscription_RootAuth_Role_Resource_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Role_Resource_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Role_Resource_Type_Bool_Exp>;
};


export type Subscription_RootAuth_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Type_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Type_By_PkArgs = {
  RoleKey: Scalars['String']['input'];
};


export type Subscription_RootAuth_Role_Type_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Role_Type_Resource_Type_Order_By>>;
  where?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Type_Resource_Type_By_PkArgs = {
  ResourceType: Scalars['String']['input'];
  RoleKey: Scalars['String']['input'];
};


export type Subscription_RootAuth_Role_Type_Resource_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Role_Type_Resource_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Role_Type_Resource_Type_Bool_Exp>;
};


export type Subscription_RootAuth_Role_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Role_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Role_Type_Bool_Exp>;
};


export type Subscription_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootAuth_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootAuth_User_By_PkArgs = {
  Id: Scalars['String']['input'];
};


export type Subscription_RootAuth_User_RoleArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_User_Role_Order_By>>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};


export type Subscription_RootAuth_User_Role_By_PkArgs = {
  Id: Scalars['String']['input'];
};


export type Subscription_RootAuth_User_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_User_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Role_Bool_Exp>;
};


export type Subscription_RootAuth_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootBusiness_AreaArgs = {
  distinct_on?: InputMaybe<Array<Business_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Area_Order_By>>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};


export type Subscription_RootBusiness_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Business_Area_Order_By>>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};


export type Subscription_RootBusiness_Area_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootBusiness_Area_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Business_Area_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Area_Bool_Exp>;
};


export type Subscription_RootCauseArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


export type Subscription_RootCause_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cause_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Order_By>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


export type Subscription_RootCause_AuditArgs = {
  distinct_on?: InputMaybe<Array<Cause_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cause_Audit_Order_By>>;
  where?: InputMaybe<Cause_Audit_Bool_Exp>;
};


export type Subscription_RootCause_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootCause_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cause_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Cause_Audit_Bool_Exp>;
};


export type Subscription_RootCause_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCause_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cause_Stream_Cursor_Input>>;
  where?: InputMaybe<Cause_Bool_Exp>;
};


export type Subscription_RootChange_RequestArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


export type Subscription_RootChange_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Order_By>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


export type Subscription_RootChange_Request_AuditArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Audit_Order_By>>;
  where?: InputMaybe<Change_Request_Audit_Bool_Exp>;
};


export type Subscription_RootChange_Request_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootChange_Request_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Change_Request_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Change_Request_Audit_Bool_Exp>;
};


export type Subscription_RootChange_Request_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootChange_Request_ContributorArgs = {
  distinct_on?: InputMaybe<Array<Change_Request_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Change_Request_Contributor_Order_By>>;
  where?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
};


export type Subscription_RootChange_Request_Contributor_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootChange_Request_Contributor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Change_Request_Contributor_Stream_Cursor_Input>>;
  where?: InputMaybe<Change_Request_Contributor_Bool_Exp>;
};


export type Subscription_RootChange_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Change_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Change_Request_Bool_Exp>;
};


export type Subscription_RootColour_PaletteArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Order_By>>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};


export type Subscription_RootColour_Palette_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Order_By>>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};


export type Subscription_RootColour_Palette_AuditArgs = {
  distinct_on?: InputMaybe<Array<Colour_Palette_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Colour_Palette_Audit_Order_By>>;
  where?: InputMaybe<Colour_Palette_Audit_Bool_Exp>;
};


export type Subscription_RootColour_Palette_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Colour_Palette_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Colour_Palette_Audit_Bool_Exp>;
};


export type Subscription_RootColour_Palette_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootColour_Palette_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Colour_Palette_Stream_Cursor_Input>>;
  where?: InputMaybe<Colour_Palette_Bool_Exp>;
};


export type Subscription_RootCommentArgs = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootComment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Comment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Audit_Order_By>>;
  where?: InputMaybe<Comment_Audit_Bool_Exp>;
};


export type Subscription_RootComment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootComment_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comment_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Comment_Audit_Bool_Exp>;
};


export type Subscription_RootComment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootComment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Comment_Bool_Exp>;
};


export type Subscription_RootCompliance_Monitoring_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Monitoring_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Compliance_Monitoring_Assessment_Order_By>>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};


export type Subscription_RootCompliance_Monitoring_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Compliance_Monitoring_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Compliance_Monitoring_Assessment_Order_By>>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};


export type Subscription_RootCompliance_Monitoring_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCompliance_Monitoring_Assessment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Compliance_Monitoring_Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Compliance_Monitoring_Assessment_Bool_Exp>;
};


export type Subscription_RootConsequenceArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


export type Subscription_RootConsequence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Order_By>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


export type Subscription_RootConsequence_AuditArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Audit_Order_By>>;
  where?: InputMaybe<Consequence_Audit_Bool_Exp>;
};


export type Subscription_RootConsequence_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consequence_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consequence_Audit_Order_By>>;
  where?: InputMaybe<Consequence_Audit_Bool_Exp>;
};


export type Subscription_RootConsequence_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootConsequence_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consequence_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Consequence_Audit_Bool_Exp>;
};


export type Subscription_RootConsequence_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootConsequence_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consequence_Stream_Cursor_Input>>;
  where?: InputMaybe<Consequence_Bool_Exp>;
};


export type Subscription_RootControlArgs = {
  distinct_on?: InputMaybe<Array<Control_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Order_By>>;
  where?: InputMaybe<Control_Bool_Exp>;
};


export type Subscription_RootControl_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Order_By>>;
  where?: InputMaybe<Control_Bool_Exp>;
};


export type Subscription_RootControl_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Audit_Order_By>>;
  where?: InputMaybe<Control_Audit_Bool_Exp>;
};


export type Subscription_RootControl_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootControl_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Audit_Bool_Exp>;
};


export type Subscription_RootControl_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootControl_GroupArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Order_By>>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};


export type Subscription_RootControl_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Order_By>>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};


export type Subscription_RootControl_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Group_Audit_Order_By>>;
  where?: InputMaybe<Control_Group_Audit_Bool_Exp>;
};


export type Subscription_RootControl_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootControl_Group_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Group_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Group_Audit_Bool_Exp>;
};


export type Subscription_RootControl_Group_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootControl_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Group_Bool_Exp>;
};


export type Subscription_RootControl_ParentArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


export type Subscription_RootControl_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Order_By>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


export type Subscription_RootControl_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Control_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Parent_Audit_Order_By>>;
  where?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootControl_Parent_Audit_By_PkArgs = {
  ControlId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootControl_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootControl_Parent_By_PkArgs = {
  ControlId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootControl_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Parent_Bool_Exp>;
};


export type Subscription_RootControl_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Bool_Exp>;
};


export type Subscription_RootControl_Test_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootControl_Test_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootControl_Test_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootControl_Test_Internal_Audit_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Test_Internal_Audit_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Test_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootControl_Test_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootControl_Test_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Control_Test_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Control_Test_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootControl_Test_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootControl_Test_Second_Line_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Control_Test_Second_Line_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Control_Test_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootConversationArgs = {
  distinct_on?: InputMaybe<Array<Conversation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversation_Order_By>>;
  where?: InputMaybe<Conversation_Bool_Exp>;
};


export type Subscription_RootConversation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Conversation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Conversation_Audit_Order_By>>;
  where?: InputMaybe<Conversation_Audit_Bool_Exp>;
};


export type Subscription_RootConversation_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootConversation_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Conversation_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Conversation_Audit_Bool_Exp>;
};


export type Subscription_RootConversation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootConversation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Conversation_Stream_Cursor_Input>>;
  where?: InputMaybe<Conversation_Bool_Exp>;
};


export type Subscription_RootCustom_Attribute_SchemaArgs = {
  distinct_on?: InputMaybe<Array<Custom_Attribute_Schema_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Attribute_Schema_Order_By>>;
  where?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
};


export type Subscription_RootCustom_Attribute_Schema_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Attribute_Schema_Audit_Order_By>>;
  where?: InputMaybe<Custom_Attribute_Schema_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Attribute_Schema_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootCustom_Attribute_Schema_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Attribute_Schema_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Attribute_Schema_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Attribute_Schema_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Attribute_Schema_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Attribute_Schema_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Attribute_Schema_Bool_Exp>;
};


export type Subscription_RootCustom_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Custom_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Datasource_Order_By>>;
  where?: InputMaybe<Custom_Datasource_Bool_Exp>;
};


export type Subscription_RootCustom_Datasource_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Datasource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Datasource_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Datasource_Bool_Exp>;
};


export type Subscription_RootCustom_RibbonArgs = {
  distinct_on?: InputMaybe<Array<Custom_Ribbon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Ribbon_Order_By>>;
  where?: InputMaybe<Custom_Ribbon_Bool_Exp>;
};


export type Subscription_RootCustom_Ribbon_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Ribbon_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Ribbon_Audit_Order_By>>;
  where?: InputMaybe<Custom_Ribbon_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Ribbon_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootCustom_Ribbon_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Ribbon_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Ribbon_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Ribbon_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Ribbon_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Ribbon_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Ribbon_Bool_Exp>;
};


export type Subscription_RootCustom_RoleArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Order_By>>;
  where?: InputMaybe<Custom_Role_Bool_Exp>;
};


export type Subscription_RootCustom_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Order_By>>;
  where?: InputMaybe<Custom_Role_Bool_Exp>;
};


export type Subscription_RootCustom_Role_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


export type Subscription_RootCustom_Role_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


export type Subscription_RootCustom_Role_Assignment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Assignment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Assignment_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_Assignment_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_Assignment_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_Assignment_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_Assignment_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_Assignment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Role_Assignment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_Assignment_Bool_Exp>;
};


export type Subscription_RootCustom_Role_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Role_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_Bool_Exp>;
};


export type Subscription_RootCustom_Role_UserArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


export type Subscription_RootCustom_Role_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


export type Subscription_RootCustom_Role_User_AuditArgs = {
  distinct_on?: InputMaybe<Array<Custom_Role_User_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Role_User_Audit_Order_By>>;
  where?: InputMaybe<Custom_Role_User_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_User_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_User_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_User_Audit_Bool_Exp>;
};


export type Subscription_RootCustom_Role_User_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Role_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Role_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Role_User_Bool_Exp>;
};


export type Subscription_RootDashboardArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboard_Order_By>>;
  where?: InputMaybe<Dashboard_Bool_Exp>;
};


export type Subscription_RootDashboard_AuditArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dashboard_Audit_Order_By>>;
  where?: InputMaybe<Dashboard_Audit_Bool_Exp>;
};


export type Subscription_RootDashboard_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDashboard_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dashboard_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Dashboard_Audit_Bool_Exp>;
};


export type Subscription_RootDashboard_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDashboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Dashboard_Bool_Exp>;
};


export type Subscription_RootData_Export_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_AuditArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Audit_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Audit_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootData_Export_Schedule_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Export_Schedule_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Export_Schedule_Audit_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootData_Export_Schedule_ExecutionArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_Execution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Export_Schedule_Execution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Export_Schedule_Execution_Order_By>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_Execution_By_PkArgs = {
  ExecutionTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootData_Export_Schedule_Execution_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Export_Schedule_Execution_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Export_Schedule_Execution_Bool_Exp>;
};


export type Subscription_RootData_Export_Schedule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Export_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Export_Schedule_Bool_Exp>;
};


export type Subscription_RootData_ImportArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Order_By>>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};


export type Subscription_RootData_Import_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Order_By>>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};


export type Subscription_RootData_Import_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootData_Import_ErrorArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Error_Order_By>>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};


export type Subscription_RootData_Import_Error_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Import_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Import_Error_Order_By>>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};


export type Subscription_RootData_Import_Error_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootData_Import_Error_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Import_Error_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Import_Error_Bool_Exp>;
};


export type Subscription_RootData_Import_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Import_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Import_Bool_Exp>;
};


export type Subscription_RootDepartment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Audit_Order_By>>;
  where?: InputMaybe<Department_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_Audit_By_PkArgs = {
  DepartmentTypeId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootDepartment_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Order_By>>;
  where?: InputMaybe<Department_Type_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Audit_Order_By>>;
  where?: InputMaybe<Department_Type_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDepartment_Type_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Type_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Type_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_By_PkArgs = {
  DepartmentTypeId: Scalars['uuid']['input'];
};


export type Subscription_RootDepartment_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Group_Order_By>>;
  where?: InputMaybe<Department_Type_Group_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Department_Type_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Type_Group_Audit_Order_By>>;
  where?: InputMaybe<Department_Type_Group_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDepartment_Type_Group_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Type_Group_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Type_Group_Audit_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Type_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Type_Group_Bool_Exp>;
};


export type Subscription_RootDepartment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Type_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_Result_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDocument_Assessment_Result_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Assessment_Result_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Assessment_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Assessment_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootDocument_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Audit_Order_By>>;
  where?: InputMaybe<Document_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDocument_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_FileArgs = {
  distinct_on?: InputMaybe<Array<Document_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_File_Order_By>>;
  where?: InputMaybe<Document_File_Bool_Exp>;
};


export type Subscription_RootDocument_File_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_File_Audit_Order_By>>;
  where?: InputMaybe<Document_File_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_File_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDocument_File_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_File_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_File_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_File_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_File_Bool_Exp>;
};


export type Subscription_RootDocument_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Internal_Audit_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Internal_Audit_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Linked_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Linked_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Linked_Document_Order_By>>;
  where?: InputMaybe<Document_Linked_Document_Bool_Exp>;
};


export type Subscription_RootDocument_Linked_Document_AuditArgs = {
  distinct_on?: InputMaybe<Array<Document_Linked_Document_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Linked_Document_Audit_Order_By>>;
  where?: InputMaybe<Document_Linked_Document_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Linked_Document_Audit_By_PkArgs = {
  DocumentId: Scalars['uuid']['input'];
  LinkedDocumentId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootDocument_Linked_Document_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Linked_Document_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Linked_Document_Audit_Bool_Exp>;
};


export type Subscription_RootDocument_Linked_Document_By_PkArgs = {
  DocumentId: Scalars['uuid']['input'];
  LinkedDocumentId: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Linked_Document_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Linked_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Linked_Document_Bool_Exp>;
};


export type Subscription_RootDocument_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Document_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootDocument_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Second_Line_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Second_Line_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootEnterprise_RiskArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootEnterprise_Risk_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Instance_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_Instance_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};


export type Subscription_RootEnterprise_Risk_Instance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enterprise_Risk_Instance_Stream_Cursor_Input>>;
  where?: InputMaybe<Enterprise_Risk_Instance_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_ScoreArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Score_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enterprise_Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enterprise_Risk_Score_Order_By>>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_Score_By_PkArgs = {
  EnterpriseRiskId: Scalars['uuid']['input'];
};


export type Subscription_RootEnterprise_Risk_Score_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enterprise_Risk_Score_Stream_Cursor_Input>>;
  where?: InputMaybe<Enterprise_Risk_Score_Bool_Exp>;
};


export type Subscription_RootEnterprise_Risk_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enterprise_Risk_Stream_Cursor_Input>>;
  where?: InputMaybe<Enterprise_Risk_Bool_Exp>;
};


export type Subscription_RootEntityArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootEntity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootEntity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootEntity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AuditArgs = {
  distinct_on?: InputMaybe<Array<File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Audit_Order_By>>;
  where?: InputMaybe<File_Audit_Bool_Exp>;
};


export type Subscription_RootFile_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootFile_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Audit_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootForm_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Form_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Configuration_Order_By>>;
  where?: InputMaybe<Form_Configuration_Bool_Exp>;
};


export type Subscription_RootForm_Configuration_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Configuration_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Configuration_Audit_Order_By>>;
  where?: InputMaybe<Form_Configuration_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Configuration_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Configuration_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Configuration_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Configuration_Bool_Exp>;
};


export type Subscription_RootForm_Field_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Configuration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Configuration_Order_By>>;
  where?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
};


export type Subscription_RootForm_Field_Configuration_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Configuration_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Configuration_Audit_Order_By>>;
  where?: InputMaybe<Form_Field_Configuration_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Field_Configuration_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Field_Configuration_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Field_Configuration_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Field_Configuration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Field_Configuration_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Field_Configuration_Bool_Exp>;
};


export type Subscription_RootForm_Field_OrderingArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Ordering_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Ordering_Order_By>>;
  where?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
};


export type Subscription_RootForm_Field_Ordering_AuditArgs = {
  distinct_on?: InputMaybe<Array<Form_Field_Ordering_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Form_Field_Ordering_Audit_Order_By>>;
  where?: InputMaybe<Form_Field_Ordering_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Field_Ordering_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Field_Ordering_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Field_Ordering_Audit_Bool_Exp>;
};


export type Subscription_RootForm_Field_Ordering_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Form_Field_Ordering_Stream_Cursor_Input>>;
  where?: InputMaybe<Form_Field_Ordering_Bool_Exp>;
};


export type Subscription_RootImpactArgs = {
  distinct_on?: InputMaybe<Array<Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Order_By>>;
  where?: InputMaybe<Impact_Bool_Exp>;
};


export type Subscription_RootImpact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Order_By>>;
  where?: InputMaybe<Impact_Bool_Exp>;
};


export type Subscription_RootImpact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Audit_Order_By>>;
  where?: InputMaybe<Impact_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootImpact_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Internal_Audit_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Internal_Audit_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Internal_Audit_Rating_Order_By>>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Internal_Audit_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Internal_Audit_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Internal_Audit_Rating_Order_By>>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Internal_Audit_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Internal_Audit_Rating_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Internal_Audit_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Internal_Audit_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_ParentArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


export type Subscription_RootImpact_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Order_By>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


export type Subscription_RootImpact_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Parent_Audit_Order_By>>;
  where?: InputMaybe<Impact_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_Parent_Audit_By_PkArgs = {
  ImpactId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_Parent_By_PkArgs = {
  ImpactId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Parent_Bool_Exp>;
};


export type Subscription_RootImpact_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Order_By>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Rating_AuditArgs = {
  distinct_on?: InputMaybe<Array<Impact_Rating_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Rating_Audit_Order_By>>;
  where?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_Rating_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootImpact_Rating_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Rating_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Rating_Audit_Bool_Exp>;
};


export type Subscription_RootImpact_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Rating_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Second_Line_RatingArgs = {
  distinct_on?: InputMaybe<Array<Impact_Second_Line_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Second_Line_Rating_Order_By>>;
  where?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Second_Line_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Impact_Second_Line_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Impact_Second_Line_Rating_Order_By>>;
  where?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_Second_Line_Rating_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootImpact_Second_Line_Rating_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Second_Line_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Second_Line_Rating_Bool_Exp>;
};


export type Subscription_RootImpact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Impact_Stream_Cursor_Input>>;
  where?: InputMaybe<Impact_Bool_Exp>;
};


export type Subscription_RootIndicatorArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Subscription_RootIndicator_AuditArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Audit_Order_By>>;
  where?: InputMaybe<Indicator_Audit_Bool_Exp>;
};


export type Subscription_RootIndicator_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootIndicator_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Audit_Bool_Exp>;
};


export type Subscription_RootIndicator_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootIndicator_ParentArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


export type Subscription_RootIndicator_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Parent_Order_By>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


export type Subscription_RootIndicator_Parent_By_PkArgs = {
  IndicatorId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootIndicator_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Parent_Bool_Exp>;
};


export type Subscription_RootIndicator_ResultArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Result_Order_By>>;
  where?: InputMaybe<Indicator_Result_Bool_Exp>;
};


export type Subscription_RootIndicator_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Result_Audit_Order_By>>;
  where?: InputMaybe<Indicator_Result_Audit_Bool_Exp>;
};


export type Subscription_RootIndicator_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootIndicator_Result_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Result_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Result_Audit_Bool_Exp>;
};


export type Subscription_RootIndicator_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootIndicator_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Result_Bool_Exp>;
};


export type Subscription_RootIndicator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Subscription_RootIndicator_TypeArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Type_Order_By>>;
  where?: InputMaybe<Indicator_Type_Bool_Exp>;
};


export type Subscription_RootIndicator_Type_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Subscription_RootIndicator_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Type_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_EntityArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Entity_Order_By>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Entity_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootInternal_Audit_Entity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Internal_Audit_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Internal_Audit_Entity_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_ReportArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Report_Order_By>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Report_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootInternal_Audit_Report_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Internal_Audit_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Internal_Audit_Report_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Internal_Audit_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Internal_Audit_Result_Parent_Order_By>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


export type Subscription_RootInternal_Audit_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootInternal_Audit_Result_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Internal_Audit_Result_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Internal_Audit_Result_Parent_Bool_Exp>;
};


export type Subscription_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};


export type Subscription_RootIssue_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};


export type Subscription_RootIssue_Assessment_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Assessment_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Assessment_Audit_Order_By>>;
  where?: InputMaybe<Issue_Assessment_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Assessment_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootIssue_Assessment_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Assessment_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Assessment_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Assessment_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_Assessment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
};


export type Subscription_RootIssue_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Audit_Order_By>>;
  where?: InputMaybe<Issue_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootIssue_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_ParentArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


export type Subscription_RootIssue_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Order_By>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


export type Subscription_RootIssue_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Parent_Audit_Order_By>>;
  where?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Parent_Audit_By_PkArgs = {
  IssueId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Parent_By_PkArgs = {
  IssueId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Parent_Bool_Exp>;
};


export type Subscription_RootIssue_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Order_By>>;
  where?: InputMaybe<Issue_Update_Bool_Exp>;
};


export type Subscription_RootIssue_Update_AuditArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Audit_Order_By>>;
  where?: InputMaybe<Issue_Update_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Update_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootIssue_Update_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Update_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Update_Audit_Bool_Exp>;
};


export type Subscription_RootIssue_Update_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootIssue_Update_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Update_Bool_Exp>;
};


export type Subscription_RootIssue_Update_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Summary_Order_By>>;
  where?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
};


export type Subscription_RootIssue_Update_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Update_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Issue_Update_Summary_Order_By>>;
  where?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
};


export type Subscription_RootIssue_Update_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Issue_Update_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Update_Summary_Bool_Exp>;
};


export type Subscription_RootLinked_ItemArgs = {
  distinct_on?: InputMaybe<Array<Linked_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Linked_Item_Order_By>>;
  where?: InputMaybe<Linked_Item_Bool_Exp>;
};


export type Subscription_RootLinked_Item_By_PkArgs = {
  Source: Scalars['uuid']['input'];
  Target: Scalars['uuid']['input'];
};


export type Subscription_RootLinked_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Linked_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Linked_Item_Bool_Exp>;
};


export type Subscription_RootNodeArgs = {
  distinct_on?: InputMaybe<Array<Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Node_Order_By>>;
  where?: InputMaybe<Node_Bool_Exp>;
};


export type Subscription_RootNode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Node_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Node_Order_By>>;
  where?: InputMaybe<Node_Bool_Exp>;
};


export type Subscription_RootNode_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootNode_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Node_Stream_Cursor_Input>>;
  where?: InputMaybe<Node_Bool_Exp>;
};


export type Subscription_RootObligationArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


export type Subscription_RootObligation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Order_By>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootObligation_Assessment_Result_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Assessment_Result_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Assessment_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Assessment_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Assessment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Assessment_Status_Order_By>>;
  where?: InputMaybe<Obligation_Assessment_Status_Bool_Exp>;
};


export type Subscription_RootObligation_Assessment_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Subscription_RootObligation_Assessment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Assessment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Assessment_Status_Bool_Exp>;
};


export type Subscription_RootObligation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootObligation_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Order_By>>;
  where?: InputMaybe<Obligation_Change_Bool_Exp>;
};


export type Subscription_RootObligation_Change_AttestationArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Change_Attestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Change_Attestation_Order_By>>;
  where?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
};


export type Subscription_RootObligation_Change_Attestation_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Change_Attestation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Change_Attestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Change_Attestation_Bool_Exp>;
};


export type Subscription_RootObligation_Change_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Change_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Change_Bool_Exp>;
};


export type Subscription_RootObligation_ImpactArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Impact_Order_By>>;
  where?: InputMaybe<Obligation_Impact_Bool_Exp>;
};


export type Subscription_RootObligation_Impact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Impact_Audit_Order_By>>;
  where?: InputMaybe<Obligation_Impact_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Impact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootObligation_Impact_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Impact_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Impact_Audit_Bool_Exp>;
};


export type Subscription_RootObligation_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Impact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Impact_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Impact_Bool_Exp>;
};


export type Subscription_RootObligation_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Internal_Audit_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Internal_Audit_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootObligation_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootObligation_Second_Line_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Second_Line_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootObligation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Bool_Exp>;
};


export type Subscription_RootObligation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Obligation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Obligation_Type_Order_By>>;
  where?: InputMaybe<Obligation_Type_Bool_Exp>;
};


export type Subscription_RootObligation_Type_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Subscription_RootObligation_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Obligation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Obligation_Type_Bool_Exp>;
};


export type Subscription_RootOrganisation_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Module_Order_By>>;
  where?: InputMaybe<Organisation_Module_Bool_Exp>;
};


export type Subscription_RootOrganisation_Module_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Module_Bool_Exp>;
};


export type Subscription_RootOrganisation_Tab_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Tab_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Tab_Preference_Order_By>>;
  where?: InputMaybe<Organisation_Tab_Preference_Bool_Exp>;
};


export type Subscription_RootOrganisation_Tab_Preference_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Tab_Preference_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Tab_Preference_Bool_Exp>;
};


export type Subscription_RootOwner_AuditArgs = {
  distinct_on?: InputMaybe<Array<Owner_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Audit_Order_By>>;
  where?: InputMaybe<Owner_Audit_Bool_Exp>;
};


export type Subscription_RootOwner_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Subscription_RootOwner_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Owner_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Owner_Audit_Bool_Exp>;
};


export type Subscription_RootOwner_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Audit_Order_By>>;
  where?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};


export type Subscription_RootOwner_Group_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
  UserGroupId: Scalars['uuid']['input'];
};


export type Subscription_RootOwner_Group_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Owner_Group_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Owner_Group_Audit_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_InviteArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Invite_Order_By>>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Invite_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionnaire_Invite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Template_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionnaire_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Template_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Template_VersionArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Template_Version_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionnaire_Template_Version_StatusArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Template_Version_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Template_Version_Status_Order_By>>;
  where?: InputMaybe<Questionnaire_Template_Version_Status_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Template_Version_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Subscription_RootQuestionnaire_Template_Version_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Template_Version_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Template_Version_Status_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Template_Version_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Template_Version_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
};


export type Subscription_RootRelation_FileArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


export type Subscription_RootRelation_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


export type Subscription_RootRelation_File_AuditArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Audit_Order_By>>;
  where?: InputMaybe<Relation_File_Audit_Bool_Exp>;
};


export type Subscription_RootRelation_File_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relation_File_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Relation_File_Audit_Bool_Exp>;
};


export type Subscription_RootRelation_File_By_PkArgs = {
  FileId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootRelation_File_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relation_File_Stream_Cursor_Input>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


export type Subscription_RootRiskArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


export type Subscription_RootRisk_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Order_By>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootRisk_Assessment_Result_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Assessment_Result_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Config_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Config_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Config_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Config_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Config_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Config_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Assessment_Result_Config_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Config_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_ImpactArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Impact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Impact_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Impact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Assessment_Result_Impact_Audit_Order_By>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Impact_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Impact_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_Impact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Assessment_Result_Impact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Impact_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Impact_Bool_Exp>;
};


export type Subscription_RootRisk_Assessment_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Assessment_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Assessment_Result_Bool_Exp>;
};


export type Subscription_RootRisk_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risk_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Audit_Order_By>>;
  where?: InputMaybe<Risk_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Audit_Order_By>>;
  where?: InputMaybe<Risk_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootRisk_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Audit_Bool_Exp>;
};


export type Subscription_RootRisk_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Controlled_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Controlled_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Controlled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Controlled_Internal_Audit_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Controlled_Internal_Audit_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Controlled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Controlled_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Controlled_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Controlled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Controlled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Controlled_Second_Line_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Controlled_Second_Line_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Controlled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisk_ScoreArgs = {
  distinct_on?: InputMaybe<Array<Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Score_Order_By>>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};


export type Subscription_RootRisk_Score_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Score_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Score_Order_By>>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};


export type Subscription_RootRisk_Score_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Score_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Score_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Score_Bool_Exp>;
};


export type Subscription_RootRisk_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Internal_Audit_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Internal_Audit_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Internal_Audit_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Internal_Audit_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Uncontrolled_Internal_Audit_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Uncontrolled_Internal_Audit_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Second_Line_ResultArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Second_Line_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Uncontrolled_Second_Line_Result_Order_By>>;
  where?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisk_Uncontrolled_Second_Line_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Uncontrolled_Second_Line_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Uncontrolled_Second_Line_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Uncontrolled_Second_Line_Result_Bool_Exp>;
};


export type Subscription_RootRisksmart_Indicator_Parent_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Indicator_Parent_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootRisksmart_Indicator_Parent_Audit_By_PkArgs = {
  IndicatorId: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootRisksmart_Indicator_Parent_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risksmart_Indicator_Parent_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risksmart_Indicator_Parent_Audit_Bool_Exp>;
};


export type Subscription_RootRisksmart_Linked_Item_AuditArgs = {
  distinct_on?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risksmart_Linked_Item_Audit_Order_By>>;
  where?: InputMaybe<Risksmart_Linked_Item_Audit_Bool_Exp>;
};


export type Subscription_RootRisksmart_Linked_Item_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  Source: Scalars['uuid']['input'];
  Target: Scalars['uuid']['input'];
};


export type Subscription_RootRisksmart_Linked_Item_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risksmart_Linked_Item_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Risksmart_Linked_Item_Audit_Bool_Exp>;
};


export type Subscription_RootRole_AccessArgs = {
  distinct_on?: InputMaybe<Array<Role_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Access_Order_By>>;
  where?: InputMaybe<Role_Access_Bool_Exp>;
};


export type Subscription_RootRole_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Access_Bool_Exp>;
};


export type Subscription_RootSecond_Line_Result_ParentArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


export type Subscription_RootSecond_Line_Result_Parent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Second_Line_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Second_Line_Result_Parent_Order_By>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


export type Subscription_RootSecond_Line_Result_Parent_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
};


export type Subscription_RootSecond_Line_Result_Parent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Second_Line_Result_Parent_Stream_Cursor_Input>>;
  where?: InputMaybe<Second_Line_Result_Parent_Bool_Exp>;
};


export type Subscription_RootTabArgs = {
  distinct_on?: InputMaybe<Array<Tab_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tab_Order_By>>;
  where?: InputMaybe<Tab_Bool_Exp>;
};


export type Subscription_RootTab_By_PkArgs = {
  ParentType: Parent_Type_Enum;
};


export type Subscription_RootTab_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tab_Stream_Cursor_Input>>;
  where?: InputMaybe<Tab_Bool_Exp>;
};


export type Subscription_RootTag_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Subscription_RootTag_Type_AuditArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Audit_Order_By>>;
  where?: InputMaybe<Tag_Type_Audit_Bool_Exp>;
};


export type Subscription_RootTag_Type_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootTag_Type_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Type_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Type_Audit_Bool_Exp>;
};


export type Subscription_RootTag_Type_By_PkArgs = {
  TagTypeId: Scalars['uuid']['input'];
};


export type Subscription_RootTag_Type_GroupArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Group_Order_By>>;
  where?: InputMaybe<Tag_Type_Group_Bool_Exp>;
};


export type Subscription_RootTag_Type_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Group_Audit_Order_By>>;
  where?: InputMaybe<Tag_Type_Group_Audit_Bool_Exp>;
};


export type Subscription_RootTag_Type_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootTag_Type_Group_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Type_Group_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Type_Group_Audit_Bool_Exp>;
};


export type Subscription_RootTag_Type_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Type_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Type_Group_Bool_Exp>;
};


export type Subscription_RootTag_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Subscription_RootTaxonomyArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Order_By>>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};


export type Subscription_RootTaxonomy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Order_By>>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};


export type Subscription_RootTaxonomy_AuditArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Audit_Order_By>>;
  where?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
};


export type Subscription_RootTaxonomy_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Audit_Order_By>>;
  where?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
};


export type Subscription_RootTaxonomy_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootTaxonomy_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taxonomy_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
};


export type Subscription_RootTaxonomy_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootTaxonomy_OrgArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


export type Subscription_RootTaxonomy_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


export type Subscription_RootTaxonomy_Org_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootTaxonomy_Org_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taxonomy_Org_Stream_Cursor_Input>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


export type Subscription_RootTaxonomy_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Taxonomy_Stream_Cursor_Input>>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};


export type Subscription_RootTest_ResultArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


export type Subscription_RootTest_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Order_By>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


export type Subscription_RootTest_Result_AuditArgs = {
  distinct_on?: InputMaybe<Array<Test_Result_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test_Result_Audit_Order_By>>;
  where?: InputMaybe<Test_Result_Audit_Bool_Exp>;
};


export type Subscription_RootTest_Result_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootTest_Result_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Test_Result_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Result_Audit_Bool_Exp>;
};


export type Subscription_RootTest_Result_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootTest_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Test_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};


export type Subscription_RootThird_PartyArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Order_By>>;
  where?: InputMaybe<Third_Party_Bool_Exp>;
};


export type Subscription_RootThird_Party_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootThird_Party_ContactArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Contact_Order_By>>;
  where?: InputMaybe<Third_Party_Contact_Bool_Exp>;
};


export type Subscription_RootThird_Party_Contact_AuditArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Contact_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Contact_Audit_Order_By>>;
  where?: InputMaybe<Third_Party_Contact_Audit_Bool_Exp>;
};


export type Subscription_RootThird_Party_Contact_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootThird_Party_Contact_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Contact_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Contact_Audit_Bool_Exp>;
};


export type Subscription_RootThird_Party_Contact_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootThird_Party_Contact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Contact_Bool_Exp>;
};


export type Subscription_RootThird_Party_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Response_Order_By>>;
  where?: InputMaybe<Third_Party_Response_Bool_Exp>;
};


export type Subscription_RootThird_Party_Response_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootThird_Party_Response_StatusArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Response_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Response_Status_Order_By>>;
  where?: InputMaybe<Third_Party_Response_Status_Bool_Exp>;
};


export type Subscription_RootThird_Party_Response_Status_By_PkArgs = {
  Value: Scalars['String']['input'];
};


export type Subscription_RootThird_Party_Response_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Response_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Response_Status_Bool_Exp>;
};


export type Subscription_RootThird_Party_Response_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Response_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Response_Bool_Exp>;
};


export type Subscription_RootThird_Party_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_GroupArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Order_By>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Subscription_RootUser_Group_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Audit_Order_By>>;
  where?: InputMaybe<User_Group_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Group_Audit_By_PkArgs = {
  Id: Scalars['uuid']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootUser_Group_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Group_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Group_By_PkArgs = {
  Id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};


export type Subscription_RootUser_Group_UserArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


export type Subscription_RootUser_Group_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


export type Subscription_RootUser_Group_User_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Audit_Order_By>>;
  where?: InputMaybe<User_Group_User_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Group_User_Audit_By_PkArgs = {
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
  UserGroupId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Subscription_RootUser_Group_User_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Group_User_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_User_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Group_User_By_PkArgs = {
  UserGroupId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
};


export type Subscription_RootUser_Group_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Group_User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


export type Subscription_RootUser_Role_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Role_Audit_Order_By>>;
  where?: InputMaybe<User_Role_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Role_Audit_By_PkArgs = {
  Id: Scalars['String']['input'];
  ModifiedAtTimestamp: Scalars['timestamptz']['input'];
};


export type Subscription_RootUser_Role_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Role_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Role_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Search_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Search_Preferences_Order_By>>;
  where?: InputMaybe<User_Search_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_Search_Preferences_AuditArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Preferences_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Search_Preferences_Audit_Order_By>>;
  where?: InputMaybe<User_Search_Preferences_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Search_Preferences_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Search_Preferences_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Search_Preferences_Audit_Bool_Exp>;
};


export type Subscription_RootUser_Search_Preferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Search_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Search_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_Tab_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<User_Tab_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tab_Preference_Order_By>>;
  where?: InputMaybe<User_Tab_Preference_Bool_Exp>;
};


export type Subscription_RootUser_Tab_Preference_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Tab_Preference_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Tab_Preference_Bool_Exp>;
};


export type Subscription_RootUser_Table_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Table_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Table_Preferences_Order_By>>;
  where?: InputMaybe<User_Table_Preferences_Bool_Exp>;
};


export type Subscription_RootUser_Table_Preferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Table_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Table_Preferences_Bool_Exp>;
};


export type Subscription_RootWizardArgs = {
  distinct_on?: InputMaybe<Array<Wizard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Wizard_Order_By>>;
  where?: InputMaybe<Wizard_Bool_Exp>;
};


export type Subscription_RootWizard_By_PkArgs = {
  RiskId: Scalars['uuid']['input'];
};


export type Subscription_RootWizard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Wizard_Stream_Cursor_Input>>;
  where?: InputMaybe<Wizard_Bool_Exp>;
};

/** columns and relationships of "risksmart.tab" */
export type Tab = {
  __typename?: 'tab';
  ParentType: Parent_Type_Enum;
  Tabs: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.tab" */
export type TabTabsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.tab". All fields are combined with a logical 'AND'. */
export type Tab_Bool_Exp = {
  ParentType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  Tabs?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Tab_Bool_Exp>>;
  _not?: InputMaybe<Tab_Bool_Exp>;
  _or?: InputMaybe<Array<Tab_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.tab". */
export type Tab_Order_By = {
  ParentType?: InputMaybe<Order_By>;
  Tabs?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.tab" */
export const Tab_Select_Column = {
  /** column name */
  ParentType: 'ParentType',
  /** column name */
  Tabs: 'Tabs'
} as const;

export type Tab_Select_Column = typeof Tab_Select_Column[keyof typeof Tab_Select_Column];
/** Streaming cursor of the table "tab" */
export type Tab_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tab_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tab_Stream_Cursor_Value_Input = {
  ParentType?: InputMaybe<Parent_Type_Enum>;
  Tabs?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.tag" */
export type Tag = {
  __typename?: 'tag';
  ParentId: Scalars['uuid']['output'];
  TagTypeId: Scalars['uuid']['output'];
  /** An object relationship */
  type?: Maybe<Tag_Type>;
};

/** order by aggregate values of table "risksmart.tag" */
export type Tag_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Max_Order_By>;
  min?: InputMaybe<Tag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.tag" */
export type Tag_Arr_Rel_Insert_Input = {
  data: Array<Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  TagTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Tag_Bool_Exp>>;
  _not?: InputMaybe<Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Bool_Exp>>;
  type?: InputMaybe<Tag_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.tag" */
export const Tag_Constraint = {
  /** unique or primary key constraint on columns "TagTypeId", "ParentId" */
  TagPkey: 'tag_pkey'
} as const;

export type Tag_Constraint = typeof Tag_Constraint[keyof typeof Tag_Constraint];
/** input type for inserting data into table "risksmart.tag" */
export type Tag_Insert_Input = {
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Tag_Type_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.tag" */
export type Tag_Max_Order_By = {
  ParentId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.tag" */
export type Tag_Min_Order_By = {
  ParentId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "risksmart.tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.tag". */
export type Tag_Order_By = {
  ParentId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Tag_Type_Order_By>;
};

/** select columns of table "risksmart.tag" */
export const Tag_Select_Column = {
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  TagTypeId: 'TagTypeId'
} as const;

export type Tag_Select_Column = typeof Tag_Select_Column[keyof typeof Tag_Select_Column];
/** columns and relationships of "risksmart.tag_type" */
export type Tag_Type = {
  __typename?: 'tag_type';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  TagTypeGroupId?: Maybe<Scalars['uuid']['output']>;
  TagTypeId: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  tag_type_group?: Maybe<Tag_Type_Group>;
};

/** order by aggregate values of table "risksmart.tag_type" */
export type Tag_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Type_Max_Order_By>;
  min?: InputMaybe<Tag_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.tag_type" */
export type Tag_Type_Arr_Rel_Insert_Input = {
  data: Array<Tag_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};

/** columns and relationships of "risksmart.tag_type_audit" */
export type Tag_Type_Audit = {
  __typename?: 'tag_type_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  TagTypeGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.tag_type_audit". All fields are combined with a logical 'AND'. */
export type Tag_Type_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  TagTypeGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Tag_Type_Audit_Bool_Exp>>;
  _not?: InputMaybe<Tag_Type_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Type_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.tag_type_audit". */
export type Tag_Type_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  TagTypeGroupId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.tag_type_audit" */
export const Tag_Type_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  TagTypeGroupId: 'TagTypeGroupId'
} as const;

export type Tag_Type_Audit_Select_Column = typeof Tag_Type_Audit_Select_Column[keyof typeof Tag_Type_Audit_Select_Column];
/** Streaming cursor of the table "tag_type_audit" */
export type Tag_Type_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Type_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Type_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.tag_type". All fields are combined with a logical 'AND'. */
export type Tag_Type_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  TagTypeGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  TagTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Tag_Type_Bool_Exp>>;
  _not?: InputMaybe<Tag_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Type_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  tag_type_group?: InputMaybe<Tag_Type_Group_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.tag_type" */
export const Tag_Type_Constraint = {
  /** unique or primary key constraint on columns "Name", "OrgKey" */
  IxTagTypeOrgkeyTitle: 'ix_tag_type_orgkey_title',
  /** unique or primary key constraint on columns "Id" */
  TagTypePkey: 'tag_type_pkey'
} as const;

export type Tag_Type_Constraint = typeof Tag_Type_Constraint[keyof typeof Tag_Type_Constraint];
/** columns and relationships of "risksmart.tag_type_group" */
export type Tag_Type_Group = {
  __typename?: 'tag_type_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  /** An array relationship */
  tag_types: Array<Tag_Type>;
};


/** columns and relationships of "risksmart.tag_type_group" */
export type Tag_Type_GroupTag_TypesArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};

/** columns and relationships of "risksmart.tag_type_group_audit" */
export type Tag_Type_Group_Audit = {
  __typename?: 'tag_type_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.tag_type_group_audit". All fields are combined with a logical 'AND'. */
export type Tag_Type_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tag_Type_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<Tag_Type_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Type_Group_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.tag_type_group_audit". */
export type Tag_Type_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.tag_type_group_audit" */
export const Tag_Type_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Tag_Type_Group_Audit_Select_Column = typeof Tag_Type_Group_Audit_Select_Column[keyof typeof Tag_Type_Group_Audit_Select_Column];
/** Streaming cursor of the table "tag_type_group_audit" */
export type Tag_Type_Group_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Type_Group_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Type_Group_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.tag_type_group". All fields are combined with a logical 'AND'. */
export type Tag_Type_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Tag_Type_Group_Bool_Exp>>;
  _not?: InputMaybe<Tag_Type_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Type_Group_Bool_Exp>>;
  tag_types?: InputMaybe<Tag_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.tag_type_group" */
export const Tag_Type_Group_Constraint = {
  /** unique or primary key constraint on columns "Name", "OrgKey" */
  TagTypeGroupPkey: 'TagTypeGroup_pkey',
  /** unique or primary key constraint on columns "Id" */
  TagTypeGroupIdKey: 'tag_type_group_Id_key'
} as const;

export type Tag_Type_Group_Constraint = typeof Tag_Type_Group_Constraint[keyof typeof Tag_Type_Group_Constraint];
/** input type for inserting data into table "risksmart.tag_type_group" */
export type Tag_Type_Group_Insert_Input = {
  Name?: InputMaybe<Scalars['String']['input']>;
  tag_types?: InputMaybe<Tag_Type_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.tag_type_group" */
export type Tag_Type_Group_Mutation_Response = {
  __typename?: 'tag_type_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Type_Group>;
};

/** input type for inserting object relation for remote table "risksmart.tag_type_group" */
export type Tag_Type_Group_Obj_Rel_Insert_Input = {
  data: Tag_Type_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Type_Group_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.tag_type_group" */
export type Tag_Type_Group_On_Conflict = {
  constraint: Tag_Type_Group_Constraint;
  update_columns?: Array<Tag_Type_Group_Update_Column>;
  where?: InputMaybe<Tag_Type_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.tag_type_group". */
export type Tag_Type_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  tag_types_aggregate?: InputMaybe<Tag_Type_Aggregate_Order_By>;
};

/** select columns of table "risksmart.tag_type_group" */
export const Tag_Type_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name'
} as const;

export type Tag_Type_Group_Select_Column = typeof Tag_Type_Group_Select_Column[keyof typeof Tag_Type_Group_Select_Column];
/** input type for updating data in table "risksmart.tag_type_group" */
export type Tag_Type_Group_Set_Input = {
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tag_type_group" */
export type Tag_Type_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Type_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Type_Group_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.tag_type_group" */
export const Tag_Type_Group_Update_Column = {
  /** column name */
  Name: 'Name'
} as const;

export type Tag_Type_Group_Update_Column = typeof Tag_Type_Group_Update_Column[keyof typeof Tag_Type_Group_Update_Column];
export type Tag_Type_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Type_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Type_Group_Bool_Exp;
};

/** input type for inserting data into table "risksmart.tag_type" */
export type Tag_Type_Insert_Input = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  tag_type_group?: InputMaybe<Tag_Type_Group_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.tag_type" */
export type Tag_Type_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  TagTypeGroupId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.tag_type" */
export type Tag_Type_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  TagTypeGroupId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.tag_type" */
export type Tag_Type_Mutation_Response = {
  __typename?: 'tag_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Type>;
};

/** input type for inserting object relation for remote table "risksmart.tag_type" */
export type Tag_Type_Obj_Rel_Insert_Input = {
  data: Tag_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.tag_type" */
export type Tag_Type_On_Conflict = {
  constraint: Tag_Type_Constraint;
  update_columns?: Array<Tag_Type_Update_Column>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.tag_type". */
export type Tag_Type_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  TagTypeGroupId?: InputMaybe<Order_By>;
  TagTypeId?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  tag_type_group?: InputMaybe<Tag_Type_Group_Order_By>;
};

/** primary key columns input for table: risksmart.tag_type */
export type Tag_Type_Pk_Columns_Input = {
  TagTypeId: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.tag_type" */
export const Tag_Type_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  TagTypeGroupId: 'TagTypeGroupId',
  /** column name */
  TagTypeId: 'TagTypeId'
} as const;

export type Tag_Type_Select_Column = typeof Tag_Type_Select_Column[keyof typeof Tag_Type_Select_Column];
/** input type for updating data in table "risksmart.tag_type" */
export type Tag_Type_Set_Input = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "tag_type" */
export type Tag_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Type_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  TagTypeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risksmart.tag_type" */
export const Tag_Type_Update_Column = {
  /** column name */
  Description: 'Description',
  /** column name */
  Name: 'Name',
  /** column name */
  TagTypeGroupId: 'TagTypeGroupId'
} as const;

export type Tag_Type_Update_Column = typeof Tag_Type_Update_Column[keyof typeof Tag_Type_Update_Column];
export type Tag_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Type_Bool_Exp;
};

/** placeholder for update columns of table "risksmart.tag" (current role has no relevant permissions) */
export const Tag_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Tag_Update_Column = typeof Tag_Update_Column[keyof typeof Tag_Update_Column];
/** columns and relationships of "risksmart.taxonomy" */
export type Taxonomy = {
  __typename?: 'taxonomy';
  Common: Scalars['jsonb']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  InternalAuditRating: Scalars['jsonb']['output'];
  Library: Scalars['jsonb']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Rating: Scalars['jsonb']['output'];
  Taxonomy: Scalars['jsonb']['output'];
  /** An array relationship */
  organisations: Array<Taxonomy_Org>;
  /** An aggregate relationship */
  organisations_aggregate: Taxonomy_Org_Aggregate;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyCommonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyInternalAuditRatingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyLibraryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyRatingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyTaxonomyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


/** columns and relationships of "risksmart.taxonomy" */
export type TaxonomyOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};

/** aggregated selection of "risksmart.taxonomy" */
export type Taxonomy_Aggregate = {
  __typename?: 'taxonomy_aggregate';
  aggregate?: Maybe<Taxonomy_Aggregate_Fields>;
  nodes: Array<Taxonomy>;
};

/** aggregate fields of "risksmart.taxonomy" */
export type Taxonomy_Aggregate_Fields = {
  __typename?: 'taxonomy_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Taxonomy_Max_Fields>;
  min?: Maybe<Taxonomy_Min_Fields>;
};


/** aggregate fields of "risksmart.taxonomy" */
export type Taxonomy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taxonomy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Taxonomy_Append_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_Audit = {
  __typename?: 'taxonomy_audit';
  Common: Scalars['jsonb']['output'];
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  InternalAuditRating?: Maybe<Scalars['jsonb']['output']>;
  Library: Scalars['jsonb']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Rating: Scalars['jsonb']['output'];
  Taxonomy: Scalars['jsonb']['output'];
  /** An array relationship */
  organisations: Array<Taxonomy_Org>;
  /** An aggregate relationship */
  organisations_aggregate: Taxonomy_Org_Aggregate;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditCommonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditInternalAuditRatingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditLibraryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditRatingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditTaxonomyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};


/** columns and relationships of "risksmart.taxonomy_audit" */
export type Taxonomy_AuditOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Taxonomy_Org_Order_By>>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};

/** aggregated selection of "risksmart.taxonomy_audit" */
export type Taxonomy_Audit_Aggregate = {
  __typename?: 'taxonomy_audit_aggregate';
  aggregate?: Maybe<Taxonomy_Audit_Aggregate_Fields>;
  nodes: Array<Taxonomy_Audit>;
};

/** aggregate fields of "risksmart.taxonomy_audit" */
export type Taxonomy_Audit_Aggregate_Fields = {
  __typename?: 'taxonomy_audit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Taxonomy_Audit_Max_Fields>;
  min?: Maybe<Taxonomy_Audit_Min_Fields>;
};


/** aggregate fields of "risksmart.taxonomy_audit" */
export type Taxonomy_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taxonomy_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.taxonomy_audit". All fields are combined with a logical 'AND'. */
export type Taxonomy_Audit_Bool_Exp = {
  Common?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InternalAuditRating?: InputMaybe<Jsonb_Comparison_Exp>;
  Library?: InputMaybe<Jsonb_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Jsonb_Comparison_Exp>;
  Taxonomy?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Taxonomy_Audit_Bool_Exp>>;
  _not?: InputMaybe<Taxonomy_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Taxonomy_Audit_Bool_Exp>>;
  organisations?: InputMaybe<Taxonomy_Org_Bool_Exp>;
  organisations_aggregate?: InputMaybe<Taxonomy_Org_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Taxonomy_Audit_Max_Fields = {
  __typename?: 'taxonomy_audit_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Taxonomy_Audit_Min_Fields = {
  __typename?: 'taxonomy_audit_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.taxonomy_audit". */
export type Taxonomy_Audit_Order_By = {
  Common?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InternalAuditRating?: InputMaybe<Order_By>;
  Library?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Taxonomy?: InputMaybe<Order_By>;
  organisations_aggregate?: InputMaybe<Taxonomy_Org_Aggregate_Order_By>;
};

/** select columns of table "risksmart.taxonomy_audit" */
export const Taxonomy_Audit_Select_Column = {
  /** column name */
  Common: 'Common',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  InternalAuditRating: 'InternalAuditRating',
  /** column name */
  Library: 'Library',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Taxonomy: 'Taxonomy'
} as const;

export type Taxonomy_Audit_Select_Column = typeof Taxonomy_Audit_Select_Column[keyof typeof Taxonomy_Audit_Select_Column];
/** Streaming cursor of the table "taxonomy_audit" */
export type Taxonomy_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taxonomy_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taxonomy_Audit_Stream_Cursor_Value_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.taxonomy". All fields are combined with a logical 'AND'. */
export type Taxonomy_Bool_Exp = {
  Common?: InputMaybe<Jsonb_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InternalAuditRating?: InputMaybe<Jsonb_Comparison_Exp>;
  Library?: InputMaybe<Jsonb_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Rating?: InputMaybe<Jsonb_Comparison_Exp>;
  Taxonomy?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Taxonomy_Bool_Exp>>;
  _not?: InputMaybe<Taxonomy_Bool_Exp>;
  _or?: InputMaybe<Array<Taxonomy_Bool_Exp>>;
  organisations?: InputMaybe<Taxonomy_Org_Bool_Exp>;
  organisations_aggregate?: InputMaybe<Taxonomy_Org_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.taxonomy" */
export const Taxonomy_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  TaxonomyPkey: 'taxonomy_pkey'
} as const;

export type Taxonomy_Constraint = typeof Taxonomy_Constraint[keyof typeof Taxonomy_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Taxonomy_Delete_At_Path_Input = {
  Common?: InputMaybe<Array<Scalars['String']['input']>>;
  InternalAuditRating?: InputMaybe<Array<Scalars['String']['input']>>;
  Library?: InputMaybe<Array<Scalars['String']['input']>>;
  Rating?: InputMaybe<Array<Scalars['String']['input']>>;
  Taxonomy?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Taxonomy_Delete_Elem_Input = {
  Common?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['Int']['input']>;
  Library?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Taxonomy?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Taxonomy_Delete_Key_Input = {
  Common?: InputMaybe<Scalars['String']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['String']['input']>;
  Library?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['String']['input']>;
  Taxonomy?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.taxonomy" */
export type Taxonomy_Insert_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
  organisations?: InputMaybe<Taxonomy_Org_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Taxonomy_Max_Fields = {
  __typename?: 'taxonomy_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Taxonomy_Min_Fields = {
  __typename?: 'taxonomy_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "risksmart.taxonomy" */
export type Taxonomy_Mutation_Response = {
  __typename?: 'taxonomy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Taxonomy>;
};

/** input type for inserting object relation for remote table "risksmart.taxonomy" */
export type Taxonomy_Obj_Rel_Insert_Input = {
  data: Taxonomy_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Taxonomy_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.taxonomy" */
export type Taxonomy_On_Conflict = {
  constraint: Taxonomy_Constraint;
  update_columns?: Array<Taxonomy_Update_Column>;
  where?: InputMaybe<Taxonomy_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.taxonomy". */
export type Taxonomy_Order_By = {
  Common?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InternalAuditRating?: InputMaybe<Order_By>;
  Library?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Rating?: InputMaybe<Order_By>;
  Taxonomy?: InputMaybe<Order_By>;
  organisations_aggregate?: InputMaybe<Taxonomy_Org_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.taxonomy_org" */
export type Taxonomy_Org = {
  __typename?: 'taxonomy_org';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  Locale: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OrgKey: Scalars['String']['output'];
  OrgName: Scalars['String']['output'];
  TaxonomyId: Scalars['uuid']['output'];
  /** An object relationship */
  taxonomy: Taxonomy;
};

/** aggregated selection of "risksmart.taxonomy_org" */
export type Taxonomy_Org_Aggregate = {
  __typename?: 'taxonomy_org_aggregate';
  aggregate?: Maybe<Taxonomy_Org_Aggregate_Fields>;
  nodes: Array<Taxonomy_Org>;
};

export type Taxonomy_Org_Aggregate_Bool_Exp = {
  count?: InputMaybe<Taxonomy_Org_Aggregate_Bool_Exp_Count>;
};

export type Taxonomy_Org_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Taxonomy_Org_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.taxonomy_org" */
export type Taxonomy_Org_Aggregate_Fields = {
  __typename?: 'taxonomy_org_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Taxonomy_Org_Max_Fields>;
  min?: Maybe<Taxonomy_Org_Min_Fields>;
};


/** aggregate fields of "risksmart.taxonomy_org" */
export type Taxonomy_Org_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Taxonomy_Org_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Taxonomy_Org_Max_Order_By>;
  min?: InputMaybe<Taxonomy_Org_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Arr_Rel_Insert_Input = {
  data: Array<Taxonomy_Org_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Taxonomy_Org_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risksmart.taxonomy_org". All fields are combined with a logical 'AND'. */
export type Taxonomy_Org_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Locale?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  OrgName?: InputMaybe<String_Comparison_Exp>;
  TaxonomyId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Taxonomy_Org_Bool_Exp>>;
  _not?: InputMaybe<Taxonomy_Org_Bool_Exp>;
  _or?: InputMaybe<Array<Taxonomy_Org_Bool_Exp>>;
  taxonomy?: InputMaybe<Taxonomy_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.taxonomy_org" */
export const Taxonomy_Org_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  TaxonomyOrgPkey: 'taxonomy_org_pkey'
} as const;

export type Taxonomy_Org_Constraint = typeof Taxonomy_Org_Constraint[keyof typeof Taxonomy_Org_Constraint];
/** input type for inserting data into table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Insert_Input = {
  Locale?: InputMaybe<Scalars['String']['input']>;
  OrgName?: InputMaybe<Scalars['String']['input']>;
  TaxonomyId?: InputMaybe<Scalars['uuid']['input']>;
  taxonomy?: InputMaybe<Taxonomy_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Taxonomy_Org_Max_Fields = {
  __typename?: 'taxonomy_org_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Locale?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  OrgName?: Maybe<Scalars['String']['output']>;
  TaxonomyId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Locale?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OrgName?: InputMaybe<Order_By>;
  TaxonomyId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Taxonomy_Org_Min_Fields = {
  __typename?: 'taxonomy_org_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  Locale?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  OrgName?: Maybe<Scalars['String']['output']>;
  TaxonomyId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Locale?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OrgName?: InputMaybe<Order_By>;
  TaxonomyId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.taxonomy_org" */
export type Taxonomy_Org_Mutation_Response = {
  __typename?: 'taxonomy_org_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Taxonomy_Org>;
};

/** on_conflict condition type for table "risksmart.taxonomy_org" */
export type Taxonomy_Org_On_Conflict = {
  constraint: Taxonomy_Org_Constraint;
  update_columns?: Array<Taxonomy_Org_Update_Column>;
  where?: InputMaybe<Taxonomy_Org_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.taxonomy_org". */
export type Taxonomy_Org_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Locale?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  OrgName?: InputMaybe<Order_By>;
  TaxonomyId?: InputMaybe<Order_By>;
  taxonomy?: InputMaybe<Taxonomy_Order_By>;
};

/** select columns of table "risksmart.taxonomy_org" */
export const Taxonomy_Org_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  Locale: 'Locale',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  OrgName: 'OrgName',
  /** column name */
  TaxonomyId: 'TaxonomyId'
} as const;

export type Taxonomy_Org_Select_Column = typeof Taxonomy_Org_Select_Column[keyof typeof Taxonomy_Org_Select_Column];
/** Streaming cursor of the table "taxonomy_org" */
export type Taxonomy_Org_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taxonomy_Org_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taxonomy_Org_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Locale?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  OrgName?: InputMaybe<Scalars['String']['input']>;
  TaxonomyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "risksmart.taxonomy_org" (current role has no relevant permissions) */
export const Taxonomy_Org_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type Taxonomy_Org_Update_Column = typeof Taxonomy_Org_Update_Column[keyof typeof Taxonomy_Org_Update_Column];
/** primary key columns input for table: risksmart.taxonomy */
export type Taxonomy_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Taxonomy_Prepend_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.taxonomy" */
export const Taxonomy_Select_Column = {
  /** column name */
  Common: 'Common',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  InternalAuditRating: 'InternalAuditRating',
  /** column name */
  Library: 'Library',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Taxonomy: 'Taxonomy'
} as const;

export type Taxonomy_Select_Column = typeof Taxonomy_Select_Column[keyof typeof Taxonomy_Select_Column];
/** input type for updating data in table "risksmart.taxonomy" */
export type Taxonomy_Set_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "taxonomy" */
export type Taxonomy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Taxonomy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Taxonomy_Stream_Cursor_Value_Input = {
  Common?: InputMaybe<Scalars['jsonb']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  InternalAuditRating?: InputMaybe<Scalars['jsonb']['input']>;
  Library?: InputMaybe<Scalars['jsonb']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Rating?: InputMaybe<Scalars['jsonb']['input']>;
  Taxonomy?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.taxonomy" */
export const Taxonomy_Update_Column = {
  /** column name */
  Common: 'Common',
  /** column name */
  Description: 'Description',
  /** column name */
  InternalAuditRating: 'InternalAuditRating',
  /** column name */
  Library: 'Library',
  /** column name */
  Rating: 'Rating',
  /** column name */
  Taxonomy: 'Taxonomy'
} as const;

export type Taxonomy_Update_Column = typeof Taxonomy_Update_Column[keyof typeof Taxonomy_Update_Column];
export type Taxonomy_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Taxonomy_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Taxonomy_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Taxonomy_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Taxonomy_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Taxonomy_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Taxonomy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Taxonomy_Bool_Exp;
};

export const Test_Frequency_Enum = {
  /** Ad Hoc */
  Adhoc: 'adhoc',
  /** Annually */
  Annually: 'annually',
  /** Bi-Annually */
  Biannually: 'biannually',
  /**  Daily */
  Daily: 'daily',
  /** Fortnightly */
  Fortnightly: 'fortnightly',
  /** Four Weekly */
  Fourweekly: 'fourweekly',
  /** Monthly */
  Monthly: 'monthly',
  /** Quarterly */
  Quarterly: 'quarterly',
  /** Weekly */
  Weekly: 'weekly'
} as const;

export type Test_Frequency_Enum = typeof Test_Frequency_Enum[keyof typeof Test_Frequency_Enum];
/** Boolean expression to compare columns of type "test_frequency_enum". All fields are combined with logical 'AND'. */
export type Test_Frequency_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Test_Frequency_Enum>;
  _in?: InputMaybe<Array<Test_Frequency_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Test_Frequency_Enum>;
  _nin?: InputMaybe<Array<Test_Frequency_Enum>>;
};

/** columns and relationships of "risksmart.test_result" */
export type Test_Result = {
  __typename?: 'test_result';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId: Scalars['uuid']['output'];
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  RatingType: Scalars['String']['output'];
  SequentialId: Scalars['Int']['output'];
  Submitter: Scalars['String']['output'];
  TestDate: Scalars['timestamptz']['output'];
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  assessmentParents: Array<Assessment_Result_Parent>;
  /** An aggregate relationship */
  assessmentParents_aggregate: Assessment_Result_Parent_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  parent?: Maybe<Control>;
  /** An object relationship */
  submitter?: Maybe<User>;
};


/** columns and relationships of "risksmart.test_result" */
export type Test_ResultCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.test_result" */
export type Test_ResultAssessmentParentsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.test_result" */
export type Test_ResultAssessmentParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Result_Parent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Result_Parent_Order_By>>;
  where?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
};


/** columns and relationships of "risksmart.test_result" */
export type Test_ResultFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.test_result" */
export type Test_ResultFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};

/** aggregated selection of "risksmart.test_result" */
export type Test_Result_Aggregate = {
  __typename?: 'test_result_aggregate';
  aggregate?: Maybe<Test_Result_Aggregate_Fields>;
  nodes: Array<Test_Result>;
};

export type Test_Result_Aggregate_Bool_Exp = {
  count?: InputMaybe<Test_Result_Aggregate_Bool_Exp_Count>;
};

export type Test_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Test_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Test_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.test_result" */
export type Test_Result_Aggregate_Fields = {
  __typename?: 'test_result_aggregate_fields';
  avg?: Maybe<Test_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Test_Result_Max_Fields>;
  min?: Maybe<Test_Result_Min_Fields>;
  stddev?: Maybe<Test_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Result_Sum_Fields>;
  var_pop?: Maybe<Test_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Result_Var_Samp_Fields>;
  variance?: Maybe<Test_Result_Variance_Fields>;
};


/** aggregate fields of "risksmart.test_result" */
export type Test_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.test_result" */
export type Test_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Result_Max_Order_By>;
  min?: InputMaybe<Test_Result_Min_Order_By>;
  stddev?: InputMaybe<Test_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Result_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.test_result" */
export type Test_Result_Arr_Rel_Insert_Input = {
  data: Array<Test_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Result_On_Conflict>;
};

/** columns and relationships of "risksmart.test_result_audit" */
export type Test_Result_Audit = {
  __typename?: 'test_result_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId: Scalars['uuid']['output'];
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter: Scalars['String']['output'];
  TestDate: Scalars['timestamptz']['output'];
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "risksmart.test_result_audit" */
export type Test_Result_AuditCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Result_Audit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Result_Audit_Max_Order_By>;
  min?: InputMaybe<Test_Result_Audit_Min_Order_By>;
  stddev?: InputMaybe<Test_Result_Audit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Result_Audit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Result_Audit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Result_Audit_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Result_Audit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Result_Audit_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Result_Audit_Variance_Order_By>;
};

/** order by avg() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Avg_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.test_result_audit". All fields are combined with a logical 'AND'. */
export type Test_Result_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DesignEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OverallEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  ParentControlId?: InputMaybe<Uuid_Comparison_Exp>;
  PerformanceEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Submitter?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TestType?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Test_Result_Audit_Bool_Exp>>;
  _not?: InputMaybe<Test_Result_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Result_Audit_Bool_Exp>>;
};

/** order by max() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "risksmart.test_result_audit". */
export type Test_Result_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.test_result_audit" */
export const Test_Result_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Test_Result_Audit_Select_Column = typeof Test_Result_Audit_Select_Column[keyof typeof Test_Result_Audit_Select_Column];
/** order by stddev() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Stddev_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Stddev_Pop_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Stddev_Samp_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "test_result_audit" */
export type Test_Result_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Result_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Result_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Sum_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Var_Pop_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Var_Samp_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "risksmart.test_result_audit" */
export type Test_Result_Audit_Variance_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Test_Result_Avg_Fields = {
  __typename?: 'test_result_avg_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "risksmart.test_result" */
export type Test_Result_Avg_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risksmart.test_result". All fields are combined with a logical 'AND'. */
export type Test_Result_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DesignEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OverallEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  ParentControlId?: InputMaybe<Uuid_Comparison_Exp>;
  PerformanceEffectiveness?: InputMaybe<Int_Comparison_Exp>;
  RatingType?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Submitter?: InputMaybe<String_Comparison_Exp>;
  TestDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  TestType?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Test_Result_Bool_Exp>>;
  _not?: InputMaybe<Test_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Result_Bool_Exp>>;
  assessmentParents?: InputMaybe<Assessment_Result_Parent_Bool_Exp>;
  assessmentParents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  parent?: InputMaybe<Control_Bool_Exp>;
  submitter?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.test_result" */
export const Test_Result_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxTestResultOrgkeySequentialid: 'idx_test_result_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  TestResultPkey: 'test_result_pkey'
} as const;

export type Test_Result_Constraint = typeof Test_Result_Constraint[keyof typeof Test_Result_Constraint];
/** input type for inserting data into table "risksmart.test_result" */
export type Test_Result_Insert_Input = {
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  assessmentParents?: InputMaybe<Assessment_Result_Parent_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Control_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Test_Result_Max_Fields = {
  __typename?: 'test_result_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.test_result" */
export type Test_Result_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Result_Min_Fields = {
  __typename?: 'test_result_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['uuid']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  ParentControlId?: Maybe<Scalars['uuid']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  RatingType?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Submitter?: Maybe<Scalars['String']['output']>;
  TestDate?: Maybe<Scalars['timestamptz']['output']>;
  TestType?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.test_result" */
export type Test_Result_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.test_result" */
export type Test_Result_Mutation_Response = {
  __typename?: 'test_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Result>;
};

/** input type for inserting object relation for remote table "risksmart.test_result" */
export type Test_Result_Obj_Rel_Insert_Input = {
  data: Test_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Result_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.test_result" */
export type Test_Result_On_Conflict = {
  constraint: Test_Result_Constraint;
  update_columns?: Array<Test_Result_Update_Column>;
  where?: InputMaybe<Test_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.test_result". */
export type Test_Result_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DesignEffectiveness?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  ParentControlId?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  RatingType?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Submitter?: InputMaybe<Order_By>;
  TestDate?: InputMaybe<Order_By>;
  TestType?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  assessmentParents_aggregate?: InputMaybe<Assessment_Result_Parent_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  parent?: InputMaybe<Control_Order_By>;
  submitter?: InputMaybe<User_Order_By>;
};

/** select columns of table "risksmart.test_result" */
export const Test_Result_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  RatingType: 'RatingType',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Test_Result_Select_Column = typeof Test_Result_Select_Column[keyof typeof Test_Result_Select_Column];
/** aggregate stddev on columns */
export type Test_Result_Stddev_Fields = {
  __typename?: 'test_result_stddev_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "risksmart.test_result" */
export type Test_Result_Stddev_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Test_Result_Stddev_Pop_Fields = {
  __typename?: 'test_result_stddev_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "risksmart.test_result" */
export type Test_Result_Stddev_Pop_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Test_Result_Stddev_Samp_Fields = {
  __typename?: 'test_result_stddev_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "risksmart.test_result" */
export type Test_Result_Stddev_Samp_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "test_result" */
export type Test_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Result_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ParentControlId?: InputMaybe<Scalars['uuid']['input']>;
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  RatingType?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Test_Result_Sum_Fields = {
  __typename?: 'test_result_sum_fields';
  DesignEffectiveness?: Maybe<Scalars['Int']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Int']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Int']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "risksmart.test_result" */
export type Test_Result_Sum_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** update columns of table "risksmart.test_result" */
export const Test_Result_Update_Column = {
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  DesignEffectiveness: 'DesignEffectiveness',
  /** column name */
  OverallEffectiveness: 'OverallEffectiveness',
  /** column name */
  ParentControlId: 'ParentControlId',
  /** column name */
  PerformanceEffectiveness: 'PerformanceEffectiveness',
  /** column name */
  Submitter: 'Submitter',
  /** column name */
  TestDate: 'TestDate',
  /** column name */
  TestType: 'TestType',
  /** column name */
  Title: 'Title'
} as const;

export type Test_Result_Update_Column = typeof Test_Result_Update_Column[keyof typeof Test_Result_Update_Column];
/** aggregate var_pop on columns */
export type Test_Result_Var_Pop_Fields = {
  __typename?: 'test_result_var_pop_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "risksmart.test_result" */
export type Test_Result_Var_Pop_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Test_Result_Var_Samp_Fields = {
  __typename?: 'test_result_var_samp_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "risksmart.test_result" */
export type Test_Result_Var_Samp_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Test_Result_Variance_Fields = {
  __typename?: 'test_result_variance_fields';
  DesignEffectiveness?: Maybe<Scalars['Float']['output']>;
  OverallEffectiveness?: Maybe<Scalars['Float']['output']>;
  PerformanceEffectiveness?: Maybe<Scalars['Float']['output']>;
  SequentialId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "risksmart.test_result" */
export type Test_Result_Variance_Order_By = {
  DesignEffectiveness?: InputMaybe<Order_By>;
  OverallEffectiveness?: InputMaybe<Order_By>;
  PerformanceEffectiveness?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
};

/** columns and relationships of "risksmart.third_party" */
export type Third_Party = {
  __typename?: 'third_party';
  Address?: Maybe<Scalars['String']['output']>;
  CityTown?: Maybe<Scalars['String']['output']>;
  CompaniesHouseNumber?: Maybe<Scalars['String']['output']>;
  CompanyDomain?: Maybe<Scalars['String']['output']>;
  CompanyName?: Maybe<Scalars['String']['output']>;
  ContactEmail?: Maybe<Scalars['String']['output']>;
  ContactName?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Criticality?: Maybe<Scalars['Int']['output']>;
  CustomAttributeData?: Maybe<Scalars['jsonb']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Postcode?: Maybe<Scalars['String']['output']>;
  PrimaryContactName?: Maybe<Scalars['String']['output']>;
  SequentialId?: Maybe<Scalars['Int']['output']>;
  Status: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contacts: Array<Third_Party_Contact>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  departments: Array<Department>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An array relationship */
  tags: Array<Tag>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyCustomAttributeDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyContactsArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Contact_Order_By>>;
  where?: InputMaybe<Third_Party_Contact_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party" */
export type Third_PartyTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "risksmart.third_party". All fields are combined with a logical 'AND'. */
export type Third_Party_Bool_Exp = {
  Address?: InputMaybe<String_Comparison_Exp>;
  CityTown?: InputMaybe<String_Comparison_Exp>;
  CompaniesHouseNumber?: InputMaybe<String_Comparison_Exp>;
  CompanyDomain?: InputMaybe<String_Comparison_Exp>;
  CompanyName?: InputMaybe<String_Comparison_Exp>;
  ContactEmail?: InputMaybe<String_Comparison_Exp>;
  ContactName?: InputMaybe<String_Comparison_Exp>;
  Country?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Criticality?: InputMaybe<Int_Comparison_Exp>;
  CustomAttributeData?: InputMaybe<Jsonb_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Postcode?: InputMaybe<String_Comparison_Exp>;
  PrimaryContactName?: InputMaybe<String_Comparison_Exp>;
  SequentialId?: InputMaybe<Int_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Third_Party_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contacts?: InputMaybe<Third_Party_Contact_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.third_party" */
export const Third_Party_Constraint = {
  /** unique or primary key constraint on columns "SequentialId", "OrgKey" */
  IdxThirdPartyOrgkeySequentialid: 'idx_third_party_orgkey_sequentialid',
  /** unique or primary key constraint on columns "Id" */
  ThirdPartyPkey: 'third_party_pkey'
} as const;

export type Third_Party_Constraint = typeof Third_Party_Constraint[keyof typeof Third_Party_Constraint];
/** columns and relationships of "risksmart.third_party_contact" */
export type Third_Party_Contact = {
  __typename?: 'third_party_contact';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Email: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  IsRevoked: Scalars['Boolean']['output'];
  JobTitle?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  ThirdPartyId: Scalars['uuid']['output'];
  UserId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An object relationship */
  thirdParty: Third_Party;
  /** An object relationship */
  user?: Maybe<User>;
};

/** order by aggregate values of table "risksmart.third_party_contact" */
export type Third_Party_Contact_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Third_Party_Contact_Max_Order_By>;
  min?: InputMaybe<Third_Party_Contact_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.third_party_contact" */
export type Third_Party_Contact_Arr_Rel_Insert_Input = {
  data: Array<Third_Party_Contact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Third_Party_Contact_On_Conflict>;
};

/** columns and relationships of "risksmart.third_party_contact_audit" */
export type Third_Party_Contact_Audit = {
  __typename?: 'third_party_contact_audit';
  Action?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Email: Scalars['String']['output'];
  Id: Scalars['uuid']['output'];
  IsRevoked: Scalars['Boolean']['output'];
  JobTitle?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  OrgKey: Scalars['String']['output'];
  ThirdPartyId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.third_party_contact_audit". All fields are combined with a logical 'AND'. */
export type Third_Party_Contact_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsRevoked?: InputMaybe<Boolean_Comparison_Exp>;
  JobTitle?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  ThirdPartyId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Third_Party_Contact_Audit_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Contact_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Contact_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.third_party_contact_audit". */
export type Third_Party_Contact_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsRevoked?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.third_party_contact_audit" */
export const Third_Party_Contact_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Email: 'Email',
  /** column name */
  Id: 'Id',
  /** column name */
  IsRevoked: 'IsRevoked',
  /** column name */
  JobTitle: 'JobTitle',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  ThirdPartyId: 'ThirdPartyId'
} as const;

export type Third_Party_Contact_Audit_Select_Column = typeof Third_Party_Contact_Audit_Select_Column[keyof typeof Third_Party_Contact_Audit_Select_Column];
/** Streaming cursor of the table "third_party_contact_audit" */
export type Third_Party_Contact_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Contact_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Contact_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ThirdPartyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.third_party_contact". All fields are combined with a logical 'AND'. */
export type Third_Party_Contact_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsRevoked?: InputMaybe<Boolean_Comparison_Exp>;
  JobTitle?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  ThirdPartyId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Third_Party_Contact_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Contact_Bool_Exp>>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.third_party_contact" */
export const Third_Party_Contact_Constraint = {
  /** unique or primary key constraint on columns "ThirdPartyId", "Email" */
  ThirdPartyContactEmailUnique: 'third_party_contact_email_unique',
  /** unique or primary key constraint on columns "Id" */
  ThirdPartyContactPkey: 'third_party_contact_pkey'
} as const;

export type Third_Party_Contact_Constraint = typeof Third_Party_Contact_Constraint[keyof typeof Third_Party_Contact_Constraint];
/** input type for inserting data into table "risksmart.third_party_contact" */
export type Third_Party_Contact_Insert_Input = {
  Email?: InputMaybe<Scalars['String']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ThirdPartyId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "risksmart.third_party_contact" */
export type Third_Party_Contact_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "risksmart.third_party_contact" */
export type Third_Party_Contact_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.third_party_contact" */
export type Third_Party_Contact_Mutation_Response = {
  __typename?: 'third_party_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party_Contact>;
};

/** input type for inserting object relation for remote table "risksmart.third_party_contact" */
export type Third_Party_Contact_Obj_Rel_Insert_Input = {
  data: Third_Party_Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Third_Party_Contact_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.third_party_contact" */
export type Third_Party_Contact_On_Conflict = {
  constraint: Third_Party_Contact_Constraint;
  update_columns?: Array<Third_Party_Contact_Update_Column>;
  where?: InputMaybe<Third_Party_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.third_party_contact". */
export type Third_Party_Contact_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsRevoked?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ThirdPartyId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: risksmart.third_party_contact */
export type Third_Party_Contact_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.third_party_contact" */
export const Third_Party_Contact_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Email: 'Email',
  /** column name */
  Id: 'Id',
  /** column name */
  IsRevoked: 'IsRevoked',
  /** column name */
  JobTitle: 'JobTitle',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  ThirdPartyId: 'ThirdPartyId',
  /** column name */
  UserId: 'UserId'
} as const;

export type Third_Party_Contact_Select_Column = typeof Third_Party_Contact_Select_Column[keyof typeof Third_Party_Contact_Select_Column];
/** input type for updating data in table "risksmart.third_party_contact" */
export type Third_Party_Contact_Set_Input = {
  IsRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "third_party_contact" */
export type Third_Party_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Contact_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  IsRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  ThirdPartyId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.third_party_contact" */
export const Third_Party_Contact_Update_Column = {
  /** column name */
  IsRevoked: 'IsRevoked',
  /** column name */
  JobTitle: 'JobTitle',
  /** column name */
  Name: 'Name'
} as const;

export type Third_Party_Contact_Update_Column = typeof Third_Party_Contact_Update_Column[keyof typeof Third_Party_Contact_Update_Column];
export type Third_Party_Contact_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Third_Party_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Third_Party_Contact_Bool_Exp;
};

/** input type for inserting data into table "risksmart.third_party" */
export type Third_Party_Insert_Input = {
  Address?: InputMaybe<Scalars['String']['input']>;
  CityTown?: InputMaybe<Scalars['String']['input']>;
  CompaniesHouseNumber?: InputMaybe<Scalars['String']['input']>;
  CompanyDomain?: InputMaybe<Scalars['String']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  ContactEmail?: InputMaybe<Scalars['String']['input']>;
  ContactName?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  PrimaryContactName?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Third_Party_Contact_Arr_Rel_Insert_Input>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  departments?: InputMaybe<Department_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.third_party" */
export type Third_Party_Mutation_Response = {
  __typename?: 'third_party_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party>;
};

/** input type for inserting object relation for remote table "risksmart.third_party" */
export type Third_Party_Obj_Rel_Insert_Input = {
  data: Third_Party_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Third_Party_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.third_party" */
export type Third_Party_On_Conflict = {
  constraint: Third_Party_Constraint;
  update_columns?: Array<Third_Party_Update_Column>;
  where?: InputMaybe<Third_Party_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.third_party". */
export type Third_Party_Order_By = {
  Address?: InputMaybe<Order_By>;
  CityTown?: InputMaybe<Order_By>;
  CompaniesHouseNumber?: InputMaybe<Order_By>;
  CompanyDomain?: InputMaybe<Order_By>;
  CompanyName?: InputMaybe<Order_By>;
  ContactEmail?: InputMaybe<Order_By>;
  ContactName?: InputMaybe<Order_By>;
  Country?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Criticality?: InputMaybe<Order_By>;
  CustomAttributeData?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Postcode?: InputMaybe<Order_By>;
  PrimaryContactName?: InputMaybe<Order_By>;
  SequentialId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contacts_aggregate?: InputMaybe<Third_Party_Contact_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By>;
};

/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_Response = {
  __typename?: 'third_party_response';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  ParentId: Scalars['uuid']['output'];
  QuestionnaireTemplateVersionId: Scalars['uuid']['output'];
  RecallReason?: Maybe<Scalars['String']['output']>;
  ResponseData: Scalars['jsonb']['output'];
  StartDate?: Maybe<Scalars['timestamptz']['output']>;
  Status: Third_Party_Response_Status_Enum;
  /** An array relationship */
  ancestorContributors: Array<Ancestor_Contributor>;
  /** An array relationship */
  contributorGroups: Array<Contributor_Group>;
  /** An aggregate relationship */
  contributorGroups_aggregate: Contributor_Group_Aggregate;
  /** An array relationship */
  contributors: Array<Contributor>;
  /** An aggregate relationship */
  contributors_aggregate: Contributor_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An array relationship */
  files: Array<Relation_File>;
  /** An aggregate relationship */
  files_aggregate: Relation_File_Aggregate;
  /** An array relationship */
  invitees: Array<Questionnaire_Invite>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  ownerGroups: Array<Owner_Group>;
  /** An aggregate relationship */
  ownerGroups_aggregate: Owner_Group_Aggregate;
  /** An array relationship */
  owners: Array<Owner>;
  /** An aggregate relationship */
  owners_aggregate: Owner_Aggregate;
  /** An object relationship */
  questionnaireTemplateVersion?: Maybe<Questionnaire_Template_Version>;
  /** An object relationship */
  thirdParty?: Maybe<Third_Party>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseResponseDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseAncestorContributorsArgs = {
  distinct_on?: InputMaybe<Array<Ancestor_Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ancestor_Contributor_Order_By>>;
  where?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseContributorGroupsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseContributorGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Group_Order_By>>;
  where?: InputMaybe<Contributor_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseContributorsArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseContributors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contributor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contributor_Order_By>>;
  where?: InputMaybe<Contributor_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseFilesArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relation_File_Order_By>>;
  where?: InputMaybe<Relation_File_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseInviteesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Invite_Order_By>>;
  where?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseOwnerGroupsArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseOwnerGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Group_Order_By>>;
  where?: InputMaybe<Owner_Group_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseOwnersArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


/** columns and relationships of "risksmart.third_party_response" */
export type Third_Party_ResponseOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Third_Party_Response_Append_Input = {
  ResponseData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.third_party_response". All fields are combined with a logical 'AND'. */
export type Third_Party_Response_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  ParentId?: InputMaybe<Uuid_Comparison_Exp>;
  QuestionnaireTemplateVersionId?: InputMaybe<Uuid_Comparison_Exp>;
  RecallReason?: InputMaybe<String_Comparison_Exp>;
  ResponseData?: InputMaybe<Jsonb_Comparison_Exp>;
  StartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  Status?: InputMaybe<Third_Party_Response_Status_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Third_Party_Response_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Response_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Response_Bool_Exp>>;
  ancestorContributors?: InputMaybe<Ancestor_Contributor_Bool_Exp>;
  contributorGroups?: InputMaybe<Contributor_Group_Bool_Exp>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Bool_Exp>;
  contributors?: InputMaybe<Contributor_Bool_Exp>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  files?: InputMaybe<Relation_File_Bool_Exp>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Bool_Exp>;
  invitees?: InputMaybe<Questionnaire_Invite_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  ownerGroups?: InputMaybe<Owner_Group_Bool_Exp>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Bool_Exp>;
  owners?: InputMaybe<Owner_Bool_Exp>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Bool_Exp>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
  thirdParty?: InputMaybe<Third_Party_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.third_party_response" */
export const Third_Party_Response_Constraint = {
  /** unique or primary key constraint on columns "Id" */
  ThirdPartyResponsePkey: 'third_party_response_pkey'
} as const;

export type Third_Party_Response_Constraint = typeof Third_Party_Response_Constraint[keyof typeof Third_Party_Response_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Third_Party_Response_Delete_At_Path_Input = {
  ResponseData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Third_Party_Response_Delete_Elem_Input = {
  ResponseData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Third_Party_Response_Delete_Key_Input = {
  ResponseData?: InputMaybe<Scalars['String']['input']>;
};

export const Third_Party_Response_Enum_Action = {
  /** Approve */
  Approve: 'approve',
  /** Recall */
  Recall: 'recall',
  /** Reject */
  Reject: 'reject',
  /** Request More Information */
  RequestMoreInformation: 'request_more_information'
} as const;

export type Third_Party_Response_Enum_Action = typeof Third_Party_Response_Enum_Action[keyof typeof Third_Party_Response_Enum_Action];
/** input type for inserting data into table "risksmart.third_party_response" */
export type Third_Party_Response_Insert_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  QuestionnaireTemplateVersionId?: InputMaybe<Scalars['uuid']['input']>;
  RecallReason?: InputMaybe<Scalars['String']['input']>;
  ResponseData?: InputMaybe<Scalars['jsonb']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Third_Party_Response_Status_Enum>;
  contributorGroups?: InputMaybe<Contributor_Group_Arr_Rel_Insert_Input>;
  contributors?: InputMaybe<Contributor_Arr_Rel_Insert_Input>;
  files?: InputMaybe<Relation_File_Arr_Rel_Insert_Input>;
  invitees?: InputMaybe<Questionnaire_Invite_Arr_Rel_Insert_Input>;
  ownerGroups?: InputMaybe<Owner_Group_Arr_Rel_Insert_Input>;
  owners?: InputMaybe<Owner_Arr_Rel_Insert_Input>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Obj_Rel_Insert_Input>;
  thirdParty?: InputMaybe<Third_Party_Obj_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.third_party_response" */
export type Third_Party_Response_Mutation_Response = {
  __typename?: 'third_party_response_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party_Response>;
};

/** input type for inserting object relation for remote table "risksmart.third_party_response" */
export type Third_Party_Response_Obj_Rel_Insert_Input = {
  data: Third_Party_Response_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Third_Party_Response_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.third_party_response" */
export type Third_Party_Response_On_Conflict = {
  constraint: Third_Party_Response_Constraint;
  update_columns?: Array<Third_Party_Response_Update_Column>;
  where?: InputMaybe<Third_Party_Response_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.third_party_response". */
export type Third_Party_Response_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  ParentId?: InputMaybe<Order_By>;
  QuestionnaireTemplateVersionId?: InputMaybe<Order_By>;
  RecallReason?: InputMaybe<Order_By>;
  ResponseData?: InputMaybe<Order_By>;
  StartDate?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  ancestorContributors_aggregate?: InputMaybe<Ancestor_Contributor_Aggregate_Order_By>;
  contributorGroups_aggregate?: InputMaybe<Contributor_Group_Aggregate_Order_By>;
  contributors_aggregate?: InputMaybe<Contributor_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  files_aggregate?: InputMaybe<Relation_File_Aggregate_Order_By>;
  invitees_aggregate?: InputMaybe<Questionnaire_Invite_Aggregate_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  ownerGroups_aggregate?: InputMaybe<Owner_Group_Aggregate_Order_By>;
  owners_aggregate?: InputMaybe<Owner_Aggregate_Order_By>;
  questionnaireTemplateVersion?: InputMaybe<Questionnaire_Template_Version_Order_By>;
  thirdParty?: InputMaybe<Third_Party_Order_By>;
};

/** primary key columns input for table: risksmart.third_party_response */
export type Third_Party_Response_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Third_Party_Response_Prepend_Input = {
  ResponseData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.third_party_response" */
export const Third_Party_Response_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ExpiresAt: 'ExpiresAt',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  QuestionnaireTemplateVersionId: 'QuestionnaireTemplateVersionId',
  /** column name */
  RecallReason: 'RecallReason',
  /** column name */
  ResponseData: 'ResponseData',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status'
} as const;

export type Third_Party_Response_Select_Column = typeof Third_Party_Response_Select_Column[keyof typeof Third_Party_Response_Select_Column];
/** input type for updating data in table "risksmart.third_party_response" */
export type Third_Party_Response_Set_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  QuestionnaireTemplateVersionId?: InputMaybe<Scalars['uuid']['input']>;
  RecallReason?: InputMaybe<Scalars['String']['input']>;
  ResponseData?: InputMaybe<Scalars['jsonb']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Third_Party_Response_Status_Enum>;
};

/** columns and relationships of "risksmart.third_party_response_status" */
export type Third_Party_Response_Status = {
  __typename?: 'third_party_response_status';
  Comment: Scalars['String']['output'];
  Value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.third_party_response_status". All fields are combined with a logical 'AND'. */
export type Third_Party_Response_Status_Bool_Exp = {
  Comment?: InputMaybe<String_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Third_Party_Response_Status_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Response_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Response_Status_Bool_Exp>>;
};

export const Third_Party_Response_Status_Enum = {
  /** Awaiting review */
  AwaitingReview: 'awaiting_review',
  /** Completed */
  Completed: 'completed',
  /** Expired */
  Expired: 'expired',
  /** In progress */
  InProgress: 'in_progress',
  /** Not started */
  NotStarted: 'not_started',
  /** The response has been recalled by a user */
  Recalled: 'recalled',
  /** Rejected */
  Rejected: 'rejected'
} as const;

export type Third_Party_Response_Status_Enum = typeof Third_Party_Response_Status_Enum[keyof typeof Third_Party_Response_Status_Enum];
/** Boolean expression to compare columns of type "third_party_response_status_enum". All fields are combined with logical 'AND'. */
export type Third_Party_Response_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Third_Party_Response_Status_Enum>;
  _in?: InputMaybe<Array<Third_Party_Response_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Third_Party_Response_Status_Enum>;
  _nin?: InputMaybe<Array<Third_Party_Response_Status_Enum>>;
};

/** Ordering options when selecting data from "risksmart.third_party_response_status". */
export type Third_Party_Response_Status_Order_By = {
  Comment?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.third_party_response_status" */
export const Third_Party_Response_Status_Select_Column = {
  /** column name */
  Comment: 'Comment',
  /** column name */
  Value: 'Value'
} as const;

export type Third_Party_Response_Status_Select_Column = typeof Third_Party_Response_Status_Select_Column[keyof typeof Third_Party_Response_Status_Select_Column];
/** Streaming cursor of the table "third_party_response_status" */
export type Third_Party_Response_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Response_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Response_Status_Stream_Cursor_Value_Input = {
  Comment?: InputMaybe<Scalars['String']['input']>;
  Value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "third_party_response" */
export type Third_Party_Response_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Response_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Response_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  QuestionnaireTemplateVersionId?: InputMaybe<Scalars['uuid']['input']>;
  RecallReason?: InputMaybe<Scalars['String']['input']>;
  ResponseData?: InputMaybe<Scalars['jsonb']['input']>;
  StartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Status?: InputMaybe<Third_Party_Response_Status_Enum>;
};

/** update columns of table "risksmart.third_party_response" */
export const Third_Party_Response_Update_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ExpiresAt: 'ExpiresAt',
  /** column name */
  ParentId: 'ParentId',
  /** column name */
  QuestionnaireTemplateVersionId: 'QuestionnaireTemplateVersionId',
  /** column name */
  RecallReason: 'RecallReason',
  /** column name */
  ResponseData: 'ResponseData',
  /** column name */
  StartDate: 'StartDate',
  /** column name */
  Status: 'Status'
} as const;

export type Third_Party_Response_Update_Column = typeof Third_Party_Response_Update_Column[keyof typeof Third_Party_Response_Update_Column];
export type Third_Party_Response_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Third_Party_Response_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Third_Party_Response_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Third_Party_Response_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Third_Party_Response_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Third_Party_Response_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Third_Party_Response_Set_Input>;
  /** filter the rows which have to be updated */
  where: Third_Party_Response_Bool_Exp;
};

/** select columns of table "risksmart.third_party" */
export const Third_Party_Select_Column = {
  /** column name */
  Address: 'Address',
  /** column name */
  CityTown: 'CityTown',
  /** column name */
  CompaniesHouseNumber: 'CompaniesHouseNumber',
  /** column name */
  CompanyDomain: 'CompanyDomain',
  /** column name */
  CompanyName: 'CompanyName',
  /** column name */
  ContactEmail: 'ContactEmail',
  /** column name */
  ContactName: 'ContactName',
  /** column name */
  Country: 'Country',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Criticality: 'Criticality',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Postcode: 'Postcode',
  /** column name */
  PrimaryContactName: 'PrimaryContactName',
  /** column name */
  SequentialId: 'SequentialId',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Third_Party_Select_Column = typeof Third_Party_Select_Column[keyof typeof Third_Party_Select_Column];
/** Streaming cursor of the table "third_party" */
export type Third_Party_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Stream_Cursor_Value_Input = {
  Address?: InputMaybe<Scalars['String']['input']>;
  CityTown?: InputMaybe<Scalars['String']['input']>;
  CompaniesHouseNumber?: InputMaybe<Scalars['String']['input']>;
  CompanyDomain?: InputMaybe<Scalars['String']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  ContactEmail?: InputMaybe<Scalars['String']['input']>;
  ContactName?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Postcode?: InputMaybe<Scalars['String']['input']>;
  PrimaryContactName?: InputMaybe<Scalars['String']['input']>;
  SequentialId?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.third_party" */
export const Third_Party_Update_Column = {
  /** column name */
  Address: 'Address',
  /** column name */
  CityTown: 'CityTown',
  /** column name */
  CompaniesHouseNumber: 'CompaniesHouseNumber',
  /** column name */
  CompanyDomain: 'CompanyDomain',
  /** column name */
  CompanyName: 'CompanyName',
  /** column name */
  ContactEmail: 'ContactEmail',
  /** column name */
  ContactName: 'ContactName',
  /** column name */
  Country: 'Country',
  /** column name */
  Criticality: 'Criticality',
  /** column name */
  CustomAttributeData: 'CustomAttributeData',
  /** column name */
  Description: 'Description',
  /** column name */
  Postcode: 'Postcode',
  /** column name */
  PrimaryContactName: 'PrimaryContactName',
  /** column name */
  Status: 'Status',
  /** column name */
  Title: 'Title',
  /** column name */
  Type: 'Type'
} as const;

export type Third_Party_Update_Column = typeof Third_Party_Update_Column[keyof typeof Third_Party_Update_Column];
/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export const Unit_Of_Time_Enum = {
  /** Day */
  Day: 'day',
  /** Week */
  Week: 'week'
} as const;

export type Unit_Of_Time_Enum = typeof Unit_Of_Time_Enum[keyof typeof Unit_Of_Time_Enum];
/** Boolean expression to compare columns of type "unit_of_time_enum". All fields are combined with logical 'AND'. */
export type Unit_Of_Time_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Unit_Of_Time_Enum>;
  _in?: InputMaybe<Array<Unit_Of_Time_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Unit_Of_Time_Enum>;
  _nin?: InputMaybe<Array<Unit_Of_Time_Enum>>;
};

/** columns and relationships of "risksmart.user_view_active" */
export type User = {
  __typename?: 'user';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  IsCustomerSupport?: Maybe<Scalars['Boolean']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  group_memberships: Array<User_Group_User>;
  /** An aggregate relationship */
  group_memberships_aggregate: User_Group_User_Aggregate;
};


/** columns and relationships of "risksmart.user_view_active" */
export type UserGroup_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


/** columns and relationships of "risksmart.user_view_active" */
export type UserGroup_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};

/** aggregated selection of "risksmart.user_view_active" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "risksmart.user_view_active" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "risksmart.user_view_active" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_view_active". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  AuthConnection?: InputMaybe<String_Comparison_Exp>;
  BusinessUnit_Id?: InputMaybe<Uuid_Comparison_Exp>;
  Department?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  FirstName?: InputMaybe<String_Comparison_Exp>;
  FriendlyName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<String_Comparison_Exp>;
  IsCustomerSupport?: InputMaybe<Boolean_Comparison_Exp>;
  JobTitle?: InputMaybe<String_Comparison_Exp>;
  LastName?: InputMaybe<String_Comparison_Exp>;
  LastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  OfficeLocation?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  UserName?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  group_memberships?: InputMaybe<User_Group_User_Bool_Exp>;
  group_memberships_aggregate?: InputMaybe<User_Group_User_Aggregate_Bool_Exp>;
};

/** columns and relationships of "risksmart.user_group" */
export type User_Group = {
  __typename?: 'user_group';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  OwnerContributor: Scalars['Boolean']['output'];
  /** An array relationship */
  approvers: Array<Approver>;
  /** An aggregate relationship */
  approvers_aggregate: Approver_Aggregate;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  modifiedByUser?: Maybe<User>;
  /** An object relationship */
  organisation: Auth_Organisation;
  /** An array relationship */
  users: Array<User_Group_User>;
  /** An aggregate relationship */
  users_aggregate: User_Group_User_Aggregate;
};


/** columns and relationships of "risksmart.user_group" */
export type User_GroupApproversArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


/** columns and relationships of "risksmart.user_group" */
export type User_GroupApprovers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approver_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Approver_Order_By>>;
  where?: InputMaybe<Approver_Bool_Exp>;
};


/** columns and relationships of "risksmart.user_group" */
export type User_GroupUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};


/** columns and relationships of "risksmart.user_group" */
export type User_GroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_User_Order_By>>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};

/** columns and relationships of "risksmart.user_group_audit" */
export type User_Group_Audit = {
  __typename?: 'user_group_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Id: Scalars['uuid']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  OwnerContributor?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_group_audit". All fields are combined with a logical 'AND'. */
export type User_Group_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerContributor?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Group_Audit_Bool_Exp>>;
  _not?: InputMaybe<User_Group_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.user_group_audit". */
export type User_Group_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerContributor?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.user_group_audit" */
export const User_Group_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Email: 'Email',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  OwnerContributor: 'OwnerContributor'
} as const;

export type User_Group_Audit_Select_Column = typeof User_Group_Audit_Select_Column[keyof typeof User_Group_Audit_Select_Column];
/** Streaming cursor of the table "user_group_audit" */
export type User_Group_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_group". All fields are combined with a logical 'AND'. */
export type User_Group_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerContributor?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Group_Bool_Exp>>;
  _not?: InputMaybe<User_Group_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_Bool_Exp>>;
  approvers?: InputMaybe<Approver_Bool_Exp>;
  approvers_aggregate?: InputMaybe<Approver_Aggregate_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  modifiedByUser?: InputMaybe<User_Bool_Exp>;
  organisation?: InputMaybe<Auth_Organisation_Bool_Exp>;
  users?: InputMaybe<User_Group_User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Group_User_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.user_group" */
export const User_Group_Constraint = {
  /** unique or primary key constraint on columns "Name", "OrgKey" */
  UniqueOrgkeyNameConstraint: 'unique_orgkey_name_constraint',
  /** unique or primary key constraint on columns "Id" */
  UserGroupPkey: 'user_group_pkey'
} as const;

export type User_Group_Constraint = typeof User_Group_Constraint[keyof typeof User_Group_Constraint];
/** input type for inserting data into table "risksmart.user_group" */
export type User_Group_Insert_Input = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
  approvers?: InputMaybe<Approver_Arr_Rel_Insert_Input>;
  users?: InputMaybe<User_Group_User_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "risksmart.user_group" */
export type User_Group_Mutation_Response = {
  __typename?: 'user_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Group>;
};

/** input type for inserting object relation for remote table "risksmart.user_group" */
export type User_Group_Obj_Rel_Insert_Input = {
  data: User_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Group_On_Conflict>;
};

/** on_conflict condition type for table "risksmart.user_group" */
export type User_Group_On_Conflict = {
  constraint: User_Group_Constraint;
  update_columns?: Array<User_Group_Update_Column>;
  where?: InputMaybe<User_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.user_group". */
export type User_Group_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerContributor?: InputMaybe<Order_By>;
  approvers_aggregate?: InputMaybe<Approver_Aggregate_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  modifiedByUser?: InputMaybe<User_Order_By>;
  organisation?: InputMaybe<Auth_Organisation_Order_By>;
  users_aggregate?: InputMaybe<User_Group_User_Aggregate_Order_By>;
};

/** primary key columns input for table: risksmart.user_group */
export type User_Group_Pk_Columns_Input = {
  Id: Scalars['uuid']['input'];
};

/** select columns of table "risksmart.user_group" */
export const User_Group_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Description: 'Description',
  /** column name */
  Email: 'Email',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  Name: 'Name',
  /** column name */
  OwnerContributor: 'OwnerContributor'
} as const;

export type User_Group_Select_Column = typeof User_Group_Select_Column[keyof typeof User_Group_Select_Column];
/** input type for updating data in table "risksmart.user_group" */
export type User_Group_Set_Input = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "user_group" */
export type User_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['uuid']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "risksmart.user_group" */
export const User_Group_Update_Column = {
  /** column name */
  Description: 'Description',
  /** column name */
  Email: 'Email',
  /** column name */
  Name: 'Name',
  /** column name */
  OwnerContributor: 'OwnerContributor'
} as const;

export type User_Group_Update_Column = typeof User_Group_Update_Column[keyof typeof User_Group_Update_Column];
export type User_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Group_Bool_Exp;
};

/** columns and relationships of "risksmart.user_group_user" */
export type User_Group_User = {
  __typename?: 'user_group_user';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  UserGroupId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
  /** An object relationship */
  authUsers: Auth_User;
  /** An object relationship */
  createdByUser?: Maybe<User>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userGroups: User_Group;
};

/** aggregated selection of "risksmart.user_group_user" */
export type User_Group_User_Aggregate = {
  __typename?: 'user_group_user_aggregate';
  aggregate?: Maybe<User_Group_User_Aggregate_Fields>;
  nodes: Array<User_Group_User>;
};

export type User_Group_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Group_User_Aggregate_Bool_Exp_Count>;
};

export type User_Group_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Group_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Group_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risksmart.user_group_user" */
export type User_Group_User_Aggregate_Fields = {
  __typename?: 'user_group_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Group_User_Max_Fields>;
  min?: Maybe<User_Group_User_Min_Fields>;
};


/** aggregate fields of "risksmart.user_group_user" */
export type User_Group_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Group_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risksmart.user_group_user" */
export type User_Group_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Group_User_Max_Order_By>;
  min?: InputMaybe<User_Group_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risksmart.user_group_user" */
export type User_Group_User_Arr_Rel_Insert_Input = {
  data: Array<User_Group_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Group_User_On_Conflict>;
};

/** columns and relationships of "risksmart.user_group_user_audit" */
export type User_Group_User_Audit = {
  __typename?: 'user_group_user_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserGroupId: Scalars['uuid']['output'];
  UserId: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.user_group_user_audit". All fields are combined with a logical 'AND'. */
export type User_Group_User_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Group_User_Audit_Bool_Exp>>;
  _not?: InputMaybe<User_Group_User_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_User_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.user_group_user_audit". */
export type User_Group_User_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.user_group_user_audit" */
export const User_Group_User_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type User_Group_User_Audit_Select_Column = typeof User_Group_User_Audit_Select_Column[keyof typeof User_Group_User_Audit_Select_Column];
/** Streaming cursor of the table "user_group_user_audit" */
export type User_Group_User_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_User_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_User_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_group_user". All fields are combined with a logical 'AND'. */
export type User_Group_User_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  UserGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Group_User_Bool_Exp>>;
  _not?: InputMaybe<User_Group_User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_User_Bool_Exp>>;
  authUsers?: InputMaybe<Auth_User_Bool_Exp>;
  createdByUser?: InputMaybe<User_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userGroups?: InputMaybe<User_Group_Bool_Exp>;
};

/** unique or primary key constraints on table "risksmart.user_group_user" */
export const User_Group_User_Constraint = {
  /** unique or primary key constraint on columns "UserGroupId", "UserId" */
  UserGroupUserPkey: 'user_group_user_pkey'
} as const;

export type User_Group_User_Constraint = typeof User_Group_User_Constraint[keyof typeof User_Group_User_Constraint];
/** input type for inserting data into table "risksmart.user_group_user" */
export type User_Group_User_Insert_Input = {
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
  userGroups?: InputMaybe<User_Group_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Group_User_Max_Fields = {
  __typename?: 'user_group_user_max_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "risksmart.user_group_user" */
export type User_Group_User_Max_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Group_User_Min_Fields = {
  __typename?: 'user_group_user_min_fields';
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  ModifiedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  UserGroupId?: Maybe<Scalars['uuid']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "risksmart.user_group_user" */
export type User_Group_User_Min_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risksmart.user_group_user" */
export type User_Group_User_Mutation_Response = {
  __typename?: 'user_group_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Group_User>;
};

/** on_conflict condition type for table "risksmart.user_group_user" */
export type User_Group_User_On_Conflict = {
  constraint: User_Group_User_Constraint;
  update_columns?: Array<User_Group_User_Update_Column>;
  where?: InputMaybe<User_Group_User_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.user_group_user". */
export type User_Group_User_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  UserGroupId?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
  authUsers?: InputMaybe<Auth_User_Order_By>;
  createdByUser?: InputMaybe<User_Order_By>;
  user?: InputMaybe<User_Order_By>;
  userGroups?: InputMaybe<User_Group_Order_By>;
};

/** select columns of table "risksmart.user_group_user" */
export const User_Group_User_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  UserGroupId: 'UserGroupId',
  /** column name */
  UserId: 'UserId'
} as const;

export type User_Group_User_Select_Column = typeof User_Group_User_Select_Column[keyof typeof User_Group_User_Select_Column];
/** Streaming cursor of the table "user_group_user" */
export type User_Group_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_User_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "risksmart.user_group_user" (current role has no relevant permissions) */
export const User_Group_User_Update_Column = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type User_Group_User_Update_Column = typeof User_Group_User_Update_Column[keyof typeof User_Group_User_Update_Column];
/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  AuthConnection?: Maybe<Scalars['String']['output']>;
  BusinessUnit_Id?: Maybe<Scalars['uuid']['output']>;
  Department?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FriendlyName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LastSeen?: Maybe<Scalars['timestamptz']['output']>;
  OfficeLocation?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "risksmart.user_view_active". */
export type User_Order_By = {
  AuthConnection?: InputMaybe<Order_By>;
  BusinessUnit_Id?: InputMaybe<Order_By>;
  Department?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FriendlyName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsCustomerSupport?: InputMaybe<Order_By>;
  JobTitle?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  LastSeen?: InputMaybe<Order_By>;
  OfficeLocation?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  UserName?: InputMaybe<Order_By>;
  group_memberships_aggregate?: InputMaybe<User_Group_User_Aggregate_Order_By>;
};

/** columns and relationships of "auth.user_role_audit" */
export type User_Role_Audit = {
  __typename?: 'user_role_audit';
  Action?: Maybe<Scalars['String']['output']>;
  CreatedAtTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  CreatedByUser?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser?: Maybe<Scalars['String']['output']>;
  OrgKey?: Maybe<Scalars['String']['output']>;
  RoleKey?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "auth.user_role_audit". All fields are combined with a logical 'AND'. */
export type User_Role_Audit_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<String_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  OrgKey?: InputMaybe<String_Comparison_Exp>;
  RoleKey?: InputMaybe<String_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Role_Audit_Bool_Exp>>;
  _not?: InputMaybe<User_Role_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<User_Role_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "auth.user_role_audit". */
export type User_Role_Audit_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  OrgKey?: InputMaybe<Order_By>;
  RoleKey?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "auth.user_role_audit" */
export const User_Role_Audit_Select_Column = {
  /** column name */
  Action: 'Action',
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  Id: 'Id',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  OrgKey: 'OrgKey',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  UserId: 'UserId'
} as const;

export type User_Role_Audit_Select_Column = typeof User_Role_Audit_Select_Column[keyof typeof User_Role_Audit_Select_Column];
/** Streaming cursor of the table "user_role_audit" */
export type User_Role_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Role_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Role_Audit_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']['input']>;
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  UserId?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.user_search_preferences" */
export type User_Search_Preferences = {
  __typename?: 'user_search_preferences';
  FilterByActivePlatformUsers: Scalars['Boolean']['output'];
  RecentUserIds: Array<Scalars['String']['output']>;
  ShowArchivedUsers: Scalars['Boolean']['output'];
  ShowDirectoryDepartment: Scalars['Boolean']['output'];
  ShowGroups: Scalars['Boolean']['output'];
  ShowInheritedContributors: Scalars['Boolean']['output'];
  ShowUserEmail: Scalars['Boolean']['output'];
  ShowUserJobTitle: Scalars['Boolean']['output'];
  ShowUserLocation: Scalars['Boolean']['output'];
  ShowUserPlatformRole: Scalars['Boolean']['output'];
};

/** columns and relationships of "risksmart.user_search_preferences_audit" */
export type User_Search_Preferences_Audit = {
  __typename?: 'user_search_preferences_audit';
  CreatedAtTimestamp: Scalars['timestamptz']['output'];
  CreatedByUser: Scalars['String']['output'];
  FilterByActivePlatformUsers: Scalars['Boolean']['output'];
  ModifiedAtTimestamp: Scalars['timestamptz']['output'];
  ModifiedByUser: Scalars['String']['output'];
  RecentUserIds: Array<Scalars['String']['output']>;
  ShowArchivedUsers: Scalars['Boolean']['output'];
  ShowDirectoryDepartment: Scalars['Boolean']['output'];
  ShowGroups: Scalars['Boolean']['output'];
  ShowUserEmail: Scalars['Boolean']['output'];
  ShowUserJobTitle: Scalars['Boolean']['output'];
  ShowUserLocation: Scalars['Boolean']['output'];
  ShowUserPlatformRole: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "risksmart.user_search_preferences_audit". All fields are combined with a logical 'AND'. */
export type User_Search_Preferences_Audit_Bool_Exp = {
  CreatedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  CreatedByUser?: InputMaybe<String_Comparison_Exp>;
  FilterByActivePlatformUsers?: InputMaybe<Boolean_Comparison_Exp>;
  ModifiedAtTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  ModifiedByUser?: InputMaybe<String_Comparison_Exp>;
  RecentUserIds?: InputMaybe<String_Array_Comparison_Exp>;
  ShowArchivedUsers?: InputMaybe<Boolean_Comparison_Exp>;
  ShowDirectoryDepartment?: InputMaybe<Boolean_Comparison_Exp>;
  ShowGroups?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserEmail?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserJobTitle?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserLocation?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserPlatformRole?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Search_Preferences_Audit_Bool_Exp>>;
  _not?: InputMaybe<User_Search_Preferences_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<User_Search_Preferences_Audit_Bool_Exp>>;
};

/** Ordering options when selecting data from "risksmart.user_search_preferences_audit". */
export type User_Search_Preferences_Audit_Order_By = {
  CreatedAtTimestamp?: InputMaybe<Order_By>;
  CreatedByUser?: InputMaybe<Order_By>;
  FilterByActivePlatformUsers?: InputMaybe<Order_By>;
  ModifiedAtTimestamp?: InputMaybe<Order_By>;
  ModifiedByUser?: InputMaybe<Order_By>;
  RecentUserIds?: InputMaybe<Order_By>;
  ShowArchivedUsers?: InputMaybe<Order_By>;
  ShowDirectoryDepartment?: InputMaybe<Order_By>;
  ShowGroups?: InputMaybe<Order_By>;
  ShowUserEmail?: InputMaybe<Order_By>;
  ShowUserJobTitle?: InputMaybe<Order_By>;
  ShowUserLocation?: InputMaybe<Order_By>;
  ShowUserPlatformRole?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.user_search_preferences_audit" */
export const User_Search_Preferences_Audit_Select_Column = {
  /** column name */
  CreatedAtTimestamp: 'CreatedAtTimestamp',
  /** column name */
  CreatedByUser: 'CreatedByUser',
  /** column name */
  FilterByActivePlatformUsers: 'FilterByActivePlatformUsers',
  /** column name */
  ModifiedAtTimestamp: 'ModifiedAtTimestamp',
  /** column name */
  ModifiedByUser: 'ModifiedByUser',
  /** column name */
  RecentUserIds: 'RecentUserIds',
  /** column name */
  ShowArchivedUsers: 'ShowArchivedUsers',
  /** column name */
  ShowDirectoryDepartment: 'ShowDirectoryDepartment',
  /** column name */
  ShowGroups: 'ShowGroups',
  /** column name */
  ShowUserEmail: 'ShowUserEmail',
  /** column name */
  ShowUserJobTitle: 'ShowUserJobTitle',
  /** column name */
  ShowUserLocation: 'ShowUserLocation',
  /** column name */
  ShowUserPlatformRole: 'ShowUserPlatformRole'
} as const;

export type User_Search_Preferences_Audit_Select_Column = typeof User_Search_Preferences_Audit_Select_Column[keyof typeof User_Search_Preferences_Audit_Select_Column];
/** Streaming cursor of the table "user_search_preferences_audit" */
export type User_Search_Preferences_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Search_Preferences_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Search_Preferences_Audit_Stream_Cursor_Value_Input = {
  CreatedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CreatedByUser?: InputMaybe<Scalars['String']['input']>;
  FilterByActivePlatformUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ModifiedAtTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  ModifiedByUser?: InputMaybe<Scalars['String']['input']>;
  RecentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ShowArchivedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ShowDirectoryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  ShowGroups?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserPlatformRole?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_search_preferences". All fields are combined with a logical 'AND'. */
export type User_Search_Preferences_Bool_Exp = {
  FilterByActivePlatformUsers?: InputMaybe<Boolean_Comparison_Exp>;
  RecentUserIds?: InputMaybe<String_Array_Comparison_Exp>;
  ShowArchivedUsers?: InputMaybe<Boolean_Comparison_Exp>;
  ShowDirectoryDepartment?: InputMaybe<Boolean_Comparison_Exp>;
  ShowGroups?: InputMaybe<Boolean_Comparison_Exp>;
  ShowInheritedContributors?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserEmail?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserJobTitle?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserLocation?: InputMaybe<Boolean_Comparison_Exp>;
  ShowUserPlatformRole?: InputMaybe<Boolean_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Search_Preferences_Bool_Exp>>;
  _not?: InputMaybe<User_Search_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<User_Search_Preferences_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.user_search_preferences" */
export const User_Search_Preferences_Constraint = {
  /** unique or primary key constraint on columns "CreatedByUser", "OrgKey" */
  RecentUsersPkey: 'recent_users_pkey'
} as const;

export type User_Search_Preferences_Constraint = typeof User_Search_Preferences_Constraint[keyof typeof User_Search_Preferences_Constraint];
/** input type for inserting data into table "risksmart.user_search_preferences" */
export type User_Search_Preferences_Insert_Input = {
  FilterByActivePlatformUsers?: InputMaybe<Scalars['Boolean']['input']>;
  RecentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ShowArchivedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ShowDirectoryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  ShowGroups?: InputMaybe<Scalars['Boolean']['input']>;
  ShowInheritedContributors?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserPlatformRole?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "risksmart.user_search_preferences" */
export type User_Search_Preferences_Mutation_Response = {
  __typename?: 'user_search_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Search_Preferences>;
};

/** on_conflict condition type for table "risksmart.user_search_preferences" */
export type User_Search_Preferences_On_Conflict = {
  constraint: User_Search_Preferences_Constraint;
  update_columns?: Array<User_Search_Preferences_Update_Column>;
  where?: InputMaybe<User_Search_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.user_search_preferences". */
export type User_Search_Preferences_Order_By = {
  FilterByActivePlatformUsers?: InputMaybe<Order_By>;
  RecentUserIds?: InputMaybe<Order_By>;
  ShowArchivedUsers?: InputMaybe<Order_By>;
  ShowDirectoryDepartment?: InputMaybe<Order_By>;
  ShowGroups?: InputMaybe<Order_By>;
  ShowInheritedContributors?: InputMaybe<Order_By>;
  ShowUserEmail?: InputMaybe<Order_By>;
  ShowUserJobTitle?: InputMaybe<Order_By>;
  ShowUserLocation?: InputMaybe<Order_By>;
  ShowUserPlatformRole?: InputMaybe<Order_By>;
};

/** select columns of table "risksmart.user_search_preferences" */
export const User_Search_Preferences_Select_Column = {
  /** column name */
  FilterByActivePlatformUsers: 'FilterByActivePlatformUsers',
  /** column name */
  RecentUserIds: 'RecentUserIds',
  /** column name */
  ShowArchivedUsers: 'ShowArchivedUsers',
  /** column name */
  ShowDirectoryDepartment: 'ShowDirectoryDepartment',
  /** column name */
  ShowGroups: 'ShowGroups',
  /** column name */
  ShowInheritedContributors: 'ShowInheritedContributors',
  /** column name */
  ShowUserEmail: 'ShowUserEmail',
  /** column name */
  ShowUserJobTitle: 'ShowUserJobTitle',
  /** column name */
  ShowUserLocation: 'ShowUserLocation',
  /** column name */
  ShowUserPlatformRole: 'ShowUserPlatformRole'
} as const;

export type User_Search_Preferences_Select_Column = typeof User_Search_Preferences_Select_Column[keyof typeof User_Search_Preferences_Select_Column];
/** input type for updating data in table "risksmart.user_search_preferences" */
export type User_Search_Preferences_Set_Input = {
  FilterByActivePlatformUsers?: InputMaybe<Scalars['Boolean']['input']>;
  RecentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ShowArchivedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ShowDirectoryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  ShowGroups?: InputMaybe<Scalars['Boolean']['input']>;
  ShowInheritedContributors?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserPlatformRole?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "user_search_preferences" */
export type User_Search_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Search_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Search_Preferences_Stream_Cursor_Value_Input = {
  FilterByActivePlatformUsers?: InputMaybe<Scalars['Boolean']['input']>;
  RecentUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ShowArchivedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ShowDirectoryDepartment?: InputMaybe<Scalars['Boolean']['input']>;
  ShowGroups?: InputMaybe<Scalars['Boolean']['input']>;
  ShowInheritedContributors?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
  ShowUserPlatformRole?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "risksmart.user_search_preferences" */
export const User_Search_Preferences_Update_Column = {
  /** column name */
  FilterByActivePlatformUsers: 'FilterByActivePlatformUsers',
  /** column name */
  RecentUserIds: 'RecentUserIds',
  /** column name */
  ShowArchivedUsers: 'ShowArchivedUsers',
  /** column name */
  ShowDirectoryDepartment: 'ShowDirectoryDepartment',
  /** column name */
  ShowGroups: 'ShowGroups',
  /** column name */
  ShowInheritedContributors: 'ShowInheritedContributors',
  /** column name */
  ShowUserEmail: 'ShowUserEmail',
  /** column name */
  ShowUserJobTitle: 'ShowUserJobTitle',
  /** column name */
  ShowUserLocation: 'ShowUserLocation',
  /** column name */
  ShowUserPlatformRole: 'ShowUserPlatformRole'
} as const;

export type User_Search_Preferences_Update_Column = typeof User_Search_Preferences_Update_Column[keyof typeof User_Search_Preferences_Update_Column];
export type User_Search_Preferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Search_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Search_Preferences_Bool_Exp;
};

/** select columns of table "risksmart.user_view_active" */
export const User_Select_Column = {
  /** column name */
  AuthConnection: 'AuthConnection',
  /** column name */
  BusinessUnitId: 'BusinessUnit_Id',
  /** column name */
  Department: 'Department',
  /** column name */
  Email: 'Email',
  /** column name */
  FirstName: 'FirstName',
  /** column name */
  FriendlyName: 'FriendlyName',
  /** column name */
  Id: 'Id',
  /** column name */
  IsCustomerSupport: 'IsCustomerSupport',
  /** column name */
  JobTitle: 'JobTitle',
  /** column name */
  LastName: 'LastName',
  /** column name */
  LastSeen: 'LastSeen',
  /** column name */
  OfficeLocation: 'OfficeLocation',
  /** column name */
  RoleKey: 'RoleKey',
  /** column name */
  Status: 'Status',
  /** column name */
  UserName: 'UserName'
} as const;

export type User_Select_Column = typeof User_Select_Column[keyof typeof User_Select_Column];
export const User_Status_Enum = {
  /** Active */
  Active: 'active',
  /** Archived */
  Archived: 'archived'
} as const;

export type User_Status_Enum = typeof User_Status_Enum[keyof typeof User_Status_Enum];
/** Boolean expression to compare columns of type "user_status_enum". All fields are combined with logical 'AND'. */
export type User_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Status_Enum>;
  _in?: InputMaybe<Array<User_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Status_Enum>;
  _nin?: InputMaybe<Array<User_Status_Enum>>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  AuthConnection?: InputMaybe<Scalars['String']['input']>;
  BusinessUnit_Id?: InputMaybe<Scalars['uuid']['input']>;
  Department?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  FriendlyName?: InputMaybe<Scalars['String']['input']>;
  Id?: InputMaybe<Scalars['String']['input']>;
  IsCustomerSupport?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  OfficeLocation?: InputMaybe<Scalars['String']['input']>;
  RoleKey?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
  UserName?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "risksmart.user_tab_preference" */
export type User_Tab_Preference = {
  __typename?: 'user_tab_preference';
  ObjectType: Parent_Type_Enum;
  Preferences: Scalars['jsonb']['output'];
};


/** columns and relationships of "risksmart.user_tab_preference" */
export type User_Tab_PreferencePreferencesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Tab_Preference_Append_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_tab_preference". All fields are combined with a logical 'AND'. */
export type User_Tab_Preference_Bool_Exp = {
  ObjectType?: InputMaybe<Parent_Type_Enum_Comparison_Exp>;
  Preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Tab_Preference_Bool_Exp>>;
  _not?: InputMaybe<User_Tab_Preference_Bool_Exp>;
  _or?: InputMaybe<Array<User_Tab_Preference_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.user_tab_preference" */
export const User_Tab_Preference_Constraint = {
  /** unique or primary key constraint on columns "ObjectType", "CreatedByUser", "OrgKey" */
  UserTabPreferencePkey: 'user_tab_preference_pkey'
} as const;

export type User_Tab_Preference_Constraint = typeof User_Tab_Preference_Constraint[keyof typeof User_Tab_Preference_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Tab_Preference_Delete_At_Path_Input = {
  Preferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Tab_Preference_Delete_Elem_Input = {
  Preferences?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Tab_Preference_Delete_Key_Input = {
  Preferences?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.user_tab_preference" */
export type User_Tab_Preference_Insert_Input = {
  ObjectType?: InputMaybe<Parent_Type_Enum>;
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "risksmart.user_tab_preference" */
export type User_Tab_Preference_Mutation_Response = {
  __typename?: 'user_tab_preference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Tab_Preference>;
};

/** on_conflict condition type for table "risksmart.user_tab_preference" */
export type User_Tab_Preference_On_Conflict = {
  constraint: User_Tab_Preference_Constraint;
  update_columns?: Array<User_Tab_Preference_Update_Column>;
  where?: InputMaybe<User_Tab_Preference_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.user_tab_preference". */
export type User_Tab_Preference_Order_By = {
  ObjectType?: InputMaybe<Order_By>;
  Preferences?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Tab_Preference_Prepend_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.user_tab_preference" */
export const User_Tab_Preference_Select_Column = {
  /** column name */
  ObjectType: 'ObjectType',
  /** column name */
  Preferences: 'Preferences'
} as const;

export type User_Tab_Preference_Select_Column = typeof User_Tab_Preference_Select_Column[keyof typeof User_Tab_Preference_Select_Column];
/** input type for updating data in table "risksmart.user_tab_preference" */
export type User_Tab_Preference_Set_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "user_tab_preference" */
export type User_Tab_Preference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Tab_Preference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Tab_Preference_Stream_Cursor_Value_Input = {
  ObjectType?: InputMaybe<Parent_Type_Enum>;
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "risksmart.user_tab_preference" */
export const User_Tab_Preference_Update_Column = {
  /** column name */
  Preferences: 'Preferences'
} as const;

export type User_Tab_Preference_Update_Column = typeof User_Tab_Preference_Update_Column[keyof typeof User_Tab_Preference_Update_Column];
export type User_Tab_Preference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Tab_Preference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Tab_Preference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Tab_Preference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Tab_Preference_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Tab_Preference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Tab_Preference_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Tab_Preference_Bool_Exp;
};

/** columns and relationships of "risksmart.user_table_preferences" */
export type User_Table_Preferences = {
  __typename?: 'user_table_preferences';
  Preferences: Scalars['jsonb']['output'];
  TableId: Scalars['String']['output'];
};


/** columns and relationships of "risksmart.user_table_preferences" */
export type User_Table_PreferencesPreferencesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Table_Preferences_Append_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "risksmart.user_table_preferences". All fields are combined with a logical 'AND'. */
export type User_Table_Preferences_Bool_Exp = {
  Preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  TableId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Table_Preferences_Bool_Exp>>;
  _not?: InputMaybe<User_Table_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<User_Table_Preferences_Bool_Exp>>;
};

/** unique or primary key constraints on table "risksmart.user_table_preferences" */
export const User_Table_Preferences_Constraint = {
  /** unique or primary key constraint on columns "TableId", "CreatedByUser", "OrgKey" */
  UserTablePreferencesPkey: 'user_table_preferences_pkey'
} as const;

export type User_Table_Preferences_Constraint = typeof User_Table_Preferences_Constraint[keyof typeof User_Table_Preferences_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Table_Preferences_Delete_At_Path_Input = {
  Preferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Table_Preferences_Delete_Elem_Input = {
  Preferences?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Table_Preferences_Delete_Key_Input = {
  Preferences?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "risksmart.user_table_preferences" */
export type User_Table_Preferences_Insert_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
  TableId?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "risksmart.user_table_preferences" */
export type User_Table_Preferences_Mutation_Response = {
  __typename?: 'user_table_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Table_Preferences>;
};

/** on_conflict condition type for table "risksmart.user_table_preferences" */
export type User_Table_Preferences_On_Conflict = {
  constraint: User_Table_Preferences_Constraint;
  update_columns?: Array<User_Table_Preferences_Update_Column>;
  where?: InputMaybe<User_Table_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.user_table_preferences". */
export type User_Table_Preferences_Order_By = {
  Preferences?: InputMaybe<Order_By>;
  TableId?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Table_Preferences_Prepend_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "risksmart.user_table_preferences" */
export const User_Table_Preferences_Select_Column = {
  /** column name */
  Preferences: 'Preferences',
  /** column name */
  TableId: 'TableId'
} as const;

export type User_Table_Preferences_Select_Column = typeof User_Table_Preferences_Select_Column[keyof typeof User_Table_Preferences_Select_Column];
/** input type for updating data in table "risksmart.user_table_preferences" */
export type User_Table_Preferences_Set_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "user_table_preferences" */
export type User_Table_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Table_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Table_Preferences_Stream_Cursor_Value_Input = {
  Preferences?: InputMaybe<Scalars['jsonb']['input']>;
  TableId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "risksmart.user_table_preferences" */
export const User_Table_Preferences_Update_Column = {
  /** column name */
  Preferences: 'Preferences'
} as const;

export type User_Table_Preferences_Update_Column = typeof User_Table_Preferences_Update_Column[keyof typeof User_Table_Preferences_Update_Column];
export type User_Table_Preferences_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Table_Preferences_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Table_Preferences_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Table_Preferences_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Table_Preferences_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Table_Preferences_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Table_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Table_Preferences_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export const Version_Status_Enum = {
  /** Archived */
  Archived: 'archived',
  /** Draft */
  Draft: 'draft',
  /** Pending Approval */
  PendingApproval: 'pending_approval',
  /** Published */
  Published: 'published'
} as const;

export type Version_Status_Enum = typeof Version_Status_Enum[keyof typeof Version_Status_Enum];
/** Boolean expression to compare columns of type "version_status_enum". All fields are combined with logical 'AND'. */
export type Version_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Version_Status_Enum>;
  _in?: InputMaybe<Array<Version_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Version_Status_Enum>;
  _nin?: InputMaybe<Array<Version_Status_Enum>>;
};

/** columns and relationships of "risksmart.wizard" */
export type Wizard = {
  __typename?: 'wizard';
  ActivityId?: Maybe<Scalars['uuid']['output']>;
  AssessmentId?: Maybe<Scalars['uuid']['output']>;
  CurrentStep: Scalars['Int']['output'];
  RiskId: Scalars['uuid']['output'];
  Status: Wizard_Status_Enum;
  /** An object relationship */
  activity?: Maybe<Assessment_Activity>;
  /** An object relationship */
  assessment?: Maybe<Assessment>;
  /** An object relationship */
  parent?: Maybe<Risk>;
};

/** Boolean expression to filter rows from the table "risksmart.wizard". All fields are combined with a logical 'AND'. */
export type Wizard_Bool_Exp = {
  ActivityId?: InputMaybe<Uuid_Comparison_Exp>;
  AssessmentId?: InputMaybe<Uuid_Comparison_Exp>;
  CurrentStep?: InputMaybe<Int_Comparison_Exp>;
  RiskId?: InputMaybe<Uuid_Comparison_Exp>;
  Status?: InputMaybe<Wizard_Status_Enum_Comparison_Exp>;
  _and?: InputMaybe<Array<Wizard_Bool_Exp>>;
  _not?: InputMaybe<Wizard_Bool_Exp>;
  _or?: InputMaybe<Array<Wizard_Bool_Exp>>;
  activity?: InputMaybe<Assessment_Activity_Bool_Exp>;
  assessment?: InputMaybe<Assessment_Bool_Exp>;
  parent?: InputMaybe<Risk_Bool_Exp>;
};

/** Ordering options when selecting data from "risksmart.wizard". */
export type Wizard_Order_By = {
  ActivityId?: InputMaybe<Order_By>;
  AssessmentId?: InputMaybe<Order_By>;
  CurrentStep?: InputMaybe<Order_By>;
  RiskId?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  activity?: InputMaybe<Assessment_Activity_Order_By>;
  assessment?: InputMaybe<Assessment_Order_By>;
  parent?: InputMaybe<Risk_Order_By>;
};

/** select columns of table "risksmart.wizard" */
export const Wizard_Select_Column = {
  /** column name */
  ActivityId: 'ActivityId',
  /** column name */
  AssessmentId: 'AssessmentId',
  /** column name */
  CurrentStep: 'CurrentStep',
  /** column name */
  RiskId: 'RiskId',
  /** column name */
  Status: 'Status'
} as const;

export type Wizard_Select_Column = typeof Wizard_Select_Column[keyof typeof Wizard_Select_Column];
export const Wizard_Status_Enum = {
  /** InProgress */
  InProgress: 'inProgress',
  /** Planned */
  Planned: 'planned'
} as const;

export type Wizard_Status_Enum = typeof Wizard_Status_Enum[keyof typeof Wizard_Status_Enum];
/** Boolean expression to compare columns of type "wizard_status_enum". All fields are combined with logical 'AND'. */
export type Wizard_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Wizard_Status_Enum>;
  _in?: InputMaybe<Array<Wizard_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Wizard_Status_Enum>;
  _nin?: InputMaybe<Array<Wizard_Status_Enum>>;
};

/** Streaming cursor of the table "wizard" */
export type Wizard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Wizard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Wizard_Stream_Cursor_Value_Input = {
  ActivityId?: InputMaybe<Scalars['uuid']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  CurrentStep?: InputMaybe<Scalars['Int']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  Status?: InputMaybe<Wizard_Status_Enum>;
};

export type AcceptancePartsFragment = { __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined };

export type DeleteAcceptancesMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteAcceptancesMutation = { __typename?: 'mutation_root', deleteAcceptancesById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetAcceptanceAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAcceptanceAuditByIdQuery = { __typename?: 'query_root', acceptance_audit: Array<{ __typename?: 'acceptance_audit', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetAcceptanceByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetAcceptanceByIdQuery = { __typename?: 'query_root', acceptance: Array<{ __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> };

export type GetAcceptancesQueryVariables = Exact<{
  where?: Acceptance_Bool_Exp;
}>;


export type GetAcceptancesQuery = { __typename?: 'query_root', acceptance: Array<{ __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, requestedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, requestedByUserGroup?: { __typename?: 'user_group', Name: string } | null | undefined, approvedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, approvedByUserGroup?: { __typename?: 'user_group', Name: string } | null | undefined, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, Tier: number, Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, changeRequests: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string }> }> };

export type GetAcceptancesByParentRiskIdQueryVariables = Exact<{
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetAcceptancesByParentRiskIdQuery = { __typename?: 'query_root', acceptance: Array<{ __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, requestedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, requestedByUserGroup?: { __typename?: 'user_group', Name: string } | null | undefined, approvedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, approvedByUserGroup?: { __typename?: 'user_group', Name: string } | null | undefined, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, Tier: number, Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, changeRequests: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string }> }> };

export type InsertAcceptanceMutationVariables = Exact<{
  DateAcceptedFrom: Scalars['timestamptz']['input'];
  DateAcceptedTo: Scalars['timestamptz']['input'];
  Details?: InputMaybe<Scalars['String']['input']>;
  ParentId: Scalars['uuid']['input'];
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertAcceptanceMutation = { __typename?: 'mutation_root', insertChildAcceptance?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateAcceptanceMutationVariables = Exact<{
  DateAcceptedFrom: Scalars['timestamptz']['input'];
  DateAcceptedTo: Scalars['timestamptz']['input'];
  Details?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Acceptance_Status_Enum>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  ApprovedByUser?: InputMaybe<Scalars['String']['input']>;
  ApprovedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  RequestedByUser?: InputMaybe<Scalars['String']['input']>;
  RequestedByUserGroup?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateAcceptanceMutation = { __typename?: 'mutation_root', updateChildAcceptance: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type ActionPartsFragment = { __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined };

export type DeleteActionsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteActionsMutation = { __typename?: 'mutation_root', deleteActionsById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetActionAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetActionAuditByIdQuery = { __typename?: 'query_root', action_audit: Array<{ __typename?: 'action_audit', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetActionByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetActionByIdQuery = { __typename?: 'query_root', action: Array<{ __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetActionsQueryVariables = Exact<{
  where?: Action_Bool_Exp;
}>;


export type GetActionsQuery = { __typename?: 'query_root', action: Array<{ __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, parents: Array<{ __typename?: 'action_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string } | null | undefined, risk?: { __typename?: 'risk', Title: string } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, issue?: { __typename?: 'issue', Title: string } | null | undefined, document?: { __typename?: 'document', Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string } | null | undefined, internalAuditEntity?: { __typename?: 'internal_audit_entity', Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Title: string } | null | undefined, thirdParty?: { __typename?: 'third_party', Title: string } | null | undefined }>, actionUpdateSummary?: { __typename?: 'action_update_summary', Count?: any | null | undefined, LatestDescription?: string | null | undefined, LatestTitle?: string | null | undefined, LatestCreatedAtTimestamp?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetWidgetActionsByPriorityQueryVariables = Exact<{
  where?: InputMaybe<Action_Bool_Exp>;
}>;


export type GetWidgetActionsByPriorityQuery = { __typename?: 'query_root', action: Array<{ __typename?: 'action', Priority?: number | null | undefined }> };

export type InsertChildActionMutationVariables = Exact<{
  DateDue: Scalars['timestamptz']['input'];
  Title: Scalars['String']['input'];
  Status: Action_Status_Enum;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DateRaised: Scalars['timestamptz']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ContributorUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  TagTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InsertChildActionMutation = { __typename?: 'mutation_root', insertChildAction?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type GetOverdueActionCountQueryVariables = Exact<{
  where?: InputMaybe<Action_Bool_Exp>;
}>;


export type GetOverdueActionCountQuery = { __typename?: 'query_root', action_aggregate: { __typename?: 'action_aggregate', aggregate?: { __typename?: 'action_aggregate_fields', count: number } | null | undefined } };

export type UpdateActionMutationVariables = Exact<{
  DateDue: Scalars['timestamptz']['input'];
  Title: Scalars['String']['input'];
  Status: Action_Status_Enum;
  Priority?: InputMaybe<Scalars['Int']['input']>;
  Id: Scalars['uuid']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  DateRaised: Scalars['timestamptz']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  ClosedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ContributorUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  OwnerUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  TagTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateActionMutation = { __typename?: 'mutation_root', updateChildAction?: { __typename?: 'UpdateChildActionOutput', affected_rows: number, change_request_id?: string | null | undefined } | null | undefined };

export type ActionUpdatePartsFragment = { __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined };

export type DeleteActionUpdatesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteActionUpdatesMutation = { __typename?: 'mutation_root', delete_file?: { __typename?: 'file_mutation_response', affected_rows: number } | null | undefined, delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined, delete_action_update?: { __typename?: 'action_update_mutation_response', affected_rows: number } | null | undefined };

export type GetActionUpdateAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetActionUpdateAuditByIdQuery = { __typename?: 'query_root', action_update_audit: Array<{ __typename?: 'action_update_audit', Description?: string | null | undefined, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetActionUpdateByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetActionUpdateByIdQuery = { __typename?: 'query_root', action_update: Array<{ __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetActionUpdatesByParentActionIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetActionUpdatesByParentActionIdQuery = { __typename?: 'query_root', action_update: Array<{ __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertActionUpdateMutationVariables = Exact<{
  Description: Scalars['String']['input'];
  ParentActionId: Scalars['uuid']['input'];
  Title: Scalars['String']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertActionUpdateMutation = { __typename?: 'mutation_root', insert_action_update_one?: { __typename?: 'action_update', Id: string } | null | undefined };

export type UpdateActionUpdateMutationVariables = Exact<{
  Description: Scalars['String']['input'];
  ParentActionId: Scalars['uuid']['input'];
  Title: Scalars['String']['input'];
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateActionUpdateMutation = { __typename?: 'mutation_root', update_action_update?: { __typename?: 'action_update_mutation_response', affected_rows: number } | null | undefined };

export type GetAggregationSettingsForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAggregationSettingsForOrgQuery = { __typename?: 'query_root', aggregation_org: Array<{ __typename?: 'aggregation_org', RiskScoringModel?: Risk_Scoring_Model_Enum | null | undefined, Appetite?: Appetite_Model_Enum | null | undefined, Config?: any | null | undefined }> };

export type GetRiskScoresSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetRiskScoresSubscription = { __typename?: 'subscription_root', risk: Array<{ __typename?: 'risk', Id: string, Tier: number, inherent: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined }>, residual: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined }>, riskScore?: { __typename?: 'risk_score', ResidualScore?: number | null | undefined, InherentScore?: number | null | undefined, ResidualRating?: number | null | undefined, InherentRating?: number | null | undefined, ResidualImpact?: number | null | undefined, ResidualLikelihood?: number | null | undefined, InherentImpact?: number | null | undefined, InherentLikelihood?: number | null | undefined, ModifiedAtTimestamp: string } | null | undefined }> };

export type UpdateAggregationSettingsForOrgMutationVariables = Exact<{
  RiskScoringModel?: InputMaybe<Risk_Scoring_Model_Enum>;
  AppetiteCascadingModel?: InputMaybe<Appetite_Model_Enum>;
  Config?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateAggregationSettingsForOrgMutation = { __typename?: 'mutation_root', insert_aggregation_org?: { __typename?: 'aggregation_org_mutation_response', affected_rows: number } | null | undefined };

export type AncestorContributorPartsFragment = { __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined };

export type AppetitePartsFragment = { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined };

export type DeleteAppetitesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteAppetitesMutation = { __typename?: 'mutation_root', delete_file?: { __typename?: 'file_mutation_response', affected_rows: number } | null | undefined, delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined, delete_appetite?: { __typename?: 'appetite_mutation_response', affected_rows: number } | null | undefined };

export type GetActiveAppetitesByParentIdQueryVariables = Exact<{
  parentId: Scalars['uuid']['input'];
}>;


export type GetActiveAppetitesByParentIdQuery = { __typename?: 'query_root', appetite_parent: Array<{ __typename?: 'appetite_parent', Status?: Appetite_Status_Enum | null | undefined, appetite?: { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined, impact?: { __typename?: 'impact', Id: string, Name: string } | null | undefined } | null | undefined }> };

export type GetActiveRiskAppetitesQueryVariables = Exact<{
  where?: Appetite_Parent_Bool_Exp;
}>;


export type GetActiveRiskAppetitesQuery = { __typename?: 'query_root', appetite_parent: Array<{ __typename?: 'appetite_parent', Status?: Appetite_Status_Enum | null | undefined, appetite?: { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined, risk?: { __typename?: 'risk', Id: string, Tier: number, Title: string, SequentialId?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, assessmentResults: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', Rating?: number | null | undefined } | null | undefined }>, riskScore?: { __typename?: 'risk_score', InherentScore?: number | null | undefined, ResidualScore?: number | null | undefined, InherentRating?: number | null | undefined, ResidualRating?: number | null | undefined } | null | undefined } | null | undefined }> };

export type GetAppetiteAuditByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetAppetiteAuditByIdQuery = { __typename?: 'query_root', appetite_audit: Array<{ __typename?: 'appetite_audit', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetAppetiteByIdQueryVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetAppetiteByIdQuery = { __typename?: 'query_root', appetite: Array<{ __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, impact?: { __typename?: 'impact', Id: string } | null | undefined, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetAppetitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppetitesQuery = { __typename?: 'query_root', appetite: Array<{ __typename?: 'appetite', Id: string, SequentialId: number, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetAppetitesByRiskIdQueryVariables = Exact<{
  riskId: Scalars['uuid']['input'];
}>;


export type GetAppetitesByRiskIdQuery = { __typename?: 'query_root', appetite_parent: Array<{ __typename?: 'appetite_parent', Status?: Appetite_Status_Enum | null | undefined, appetite?: { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact?: { __typename?: 'impact', Id: string, Name: string } | null | undefined } | null | undefined }> };

export type GetAppetitesGroupedByImpactQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppetitesGroupedByImpactQuery = { __typename?: 'query_root', impact: Array<{ __typename?: 'impact', Id: string, appetites: Array<{ __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> }> };

export type InsertAppetiteMutationVariables = Exact<{
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  ParentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertAppetiteMutation = { __typename?: 'mutation_root', insertChildAppetite?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateAppetiteMutationVariables = Exact<{
  LowerAppetite?: InputMaybe<Scalars['Int']['input']>;
  Statement?: InputMaybe<Scalars['String']['input']>;
  UpperAppetite?: InputMaybe<Scalars['Int']['input']>;
  ImpactAppetite?: InputMaybe<Scalars['Int']['input']>;
  LikelihoodAppetite?: InputMaybe<Scalars['Int']['input']>;
  Id: Scalars['uuid']['input'];
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  EffectiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  AppetiteType?: InputMaybe<Appetite_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  ImpactId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateAppetiteMutation = { __typename?: 'mutation_root', update_appetite?: { __typename?: 'appetite_mutation_response', affected_rows: number } | null | undefined };

export type GetChangeRequestsByApprovalQueryVariables = Exact<{
  approvalId: Scalars['uuid']['input'];
}>;


export type GetChangeRequestsByApprovalQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', Id: string }> };

export type DeleteApprovalMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteApprovalMutation = { __typename?: 'mutation_root', delete_approval?: { __typename?: 'approval_mutation_response', affected_rows: number } | null | undefined };

export type GetApprovalAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetApprovalAuditByIdQuery = { __typename?: 'query_root', approval_audit: Array<{ __typename?: 'approval_audit', Id: string, Workflow: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CreatedAtTimestamp: string, CreatedByUser: string, InFlightEditRule: string }> };

export type GetApprovalByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetApprovalByIdQuery = { __typename?: 'query_root', approval?: { __typename?: 'approval', Id: string, Workflow: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum, levels: Array<{ __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, approvers: Array<{ __typename?: 'approver', Id: string, UserId?: string | null | undefined, UserGroupId?: string | null | undefined, OwnerApprover?: boolean | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, createdBy?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined } | null | undefined };

export type GetGlobalApprovalsQueryVariables = Exact<{
  global?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetGlobalApprovalsQuery = { __typename?: 'query_root', approval: Array<{ __typename?: 'approval', Id: string, Workflow: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, createdBy?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, levels: Array<{ __typename?: 'approval_level', Id: string }> }> };

export type InsertApprovalMutationVariables = Exact<{
  approval: Approval_Insert_Input;
}>;


export type InsertApprovalMutation = { __typename?: 'mutation_root', insert_approval_one?: { __typename?: 'approval', Id: string } | null | undefined };

export type UpdateApprovalMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  approval: Approval_Set_Input;
  updateLevels: Array<Approval_Level_Updates> | Approval_Level_Updates;
  insertLevels: Array<Approval_Level_Insert_Input> | Approval_Level_Insert_Input;
  insertApprovers: Array<Approver_Insert_Input> | Approver_Insert_Input;
  deleteLevelIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  deleteApproverIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateApprovalMutation = { __typename?: 'mutation_root', update_approval_by_pk?: { __typename?: 'approval', Id: string } | null | undefined, delete_approval_level?: { __typename?: 'approval_level_mutation_response', affected_rows: number } | null | undefined, delete_approver?: { __typename?: 'approver_mutation_response', affected_rows: number } | null | undefined, update_approval_level_many?: Array<{ __typename?: 'approval_level_mutation_response', affected_rows: number } | null | undefined> | null | undefined, insert_approval_level?: { __typename?: 'approval_level_mutation_response', affected_rows: number } | null | undefined, insert_approver?: { __typename?: 'approver_mutation_response', affected_rows: number } | null | undefined };

export type AssessmentActivityPartsFragment = { __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined };

export type DeleteAssessmentActivitiesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteAssessmentActivitiesMutation = { __typename?: 'mutation_root', delete_assessment_activity?: { __typename?: 'assessment_activity_mutation_response', affected_rows: number } | null | undefined };

export type GetAssessmentActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentActivitiesQuery = { __typename?: 'query_root', assessment_activity: Array<{ __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, parentRisk?: { __typename?: 'risk', Title: string, SequentialId?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined } | null | undefined, assignedUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetAssessmentActivitiesByParentIdQueryVariables = Exact<{
  AssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentActivitiesByParentIdQuery = { __typename?: 'query_root', assessment_activity: Array<{ __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, assignedUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetAssessmentActivityAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAssessmentActivityAuditByIdQuery = { __typename?: 'query_root', assessment_activity_audit: Array<{ __typename?: 'assessment_activity_audit', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: string | null | undefined, ActivityType: string, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined }> };

export type GetAssessmentActivityByIdQueryVariables = Exact<{
  AssessmentActivityId: Scalars['uuid']['input'];
}>;


export type GetAssessmentActivityByIdQuery = { __typename?: 'query_root', assessment_activity: Array<{ __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, linked_item: Array<{ __typename?: 'linked_item', Id: string, Source: string, Target: string, target_control?: { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_control_group?: { __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined } | null | undefined, target_obligation?: { __typename?: 'obligation', Adherence: string, Description: string, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: Obligation_Type_Enum, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ExternalId?: string | null | undefined, ExternalProvider?: string | null | undefined, ExternalSyncedAt?: string | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_document?: { __typename?: 'document', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_risk?: { __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_assessment_activity?: { __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined, target_assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined, target_impact?: { __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined } | null | undefined, target_obligation_impact?: { __typename?: 'obligation_impact', Id: string, Description: string, ParentObligationId: string } | null | undefined, target_impact_rating?: { __typename?: 'impact_rating', Id: string, impact: { __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined } } | null | undefined, target_action?: { __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined } | null | undefined, target_indicator?: { __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_acceptance?: { __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined } | null | undefined, target_appetite?: { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined } | null | undefined, target_issue?: { __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum } | null | undefined }> };

export type GetAssessmentRcsaActivitiesByParentIdQueryVariables = Exact<{
  AssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentRcsaActivitiesByParentIdQuery = { __typename?: 'query_root', assessment_activity: Array<{ __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, parentRisk?: { __typename?: 'risk', Title: string, SequentialId?: number | null | undefined } | null | undefined, assignedUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertAssessmentActivityWithLinkedItemsMutationVariables = Exact<{
  ActivityType: Assessment_Activity_Type_Enum;
  ParentId: Scalars['uuid']['input'];
  Status: Assessment_Activity_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  LinkedItemIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  IsRCSA?: InputMaybe<Scalars['Boolean']['input']>;
  RiskId?: InputMaybe<Scalars['uuid']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InsertAssessmentActivityWithLinkedItemsMutation = { __typename?: 'mutation_root', insertAssessmentActivityWithLinkedItems?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateAssessmentActivityWithLinkedItemsMutationVariables = Exact<{
  ActivityType: Assessment_Activity_Type_Enum;
  Status: Assessment_Activity_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  CompletionDate?: InputMaybe<Scalars['timestamptz']['input']>;
  AssignedUser?: InputMaybe<Scalars['String']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  Id: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
  LinkedItemIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  IsWizardAction?: InputMaybe<Scalars['Boolean']['input']>;
  OwnerUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  OwnerGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateAssessmentActivityWithLinkedItemsMutation = { __typename?: 'mutation_root', updateAssessmentActivityWithLinkedItems?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type DocumentAssessmentResultPartsFragment = { __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type ObligationAssessmentResultPartsFragment = { __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type RiskAssessmentResultPartsFragment = { __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type DocumentInternalAuditResultPartsFragment = { __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type ObligationInternalAuditResultPartsFragment = { __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type RiskControlledInternalAuditResultPartsFragment = { __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type RiskUncontrolledInternalAuditResultPartsFragment = { __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type DocumentSecondLineResultPartsFragment = { __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type ObligationSecondLineResultPartsFragment = { __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type RiskControlledSecondLineResultPartsFragment = { __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type RiskUncontrolledSecondLineResultPartsFragment = { __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined };

export type DeleteAssessmentResultsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteAssessmentResultsMutation = { __typename?: 'mutation_root', delete_document_assessment_result?: { __typename?: 'document_assessment_result_mutation_response', affected_rows: number } | null | undefined, delete_obligation_assessment_result?: { __typename?: 'obligation_assessment_result_mutation_response', affected_rows: number } | null | undefined, delete_risk_assessment_result?: { __typename?: 'risk_assessment_result_mutation_response', affected_rows: number } | null | undefined, delete_test_result?: { __typename?: 'test_result_mutation_response', affected_rows: number } | null | undefined, delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined };

export type GetAllAssessmentResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssessmentResultsQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, assessments: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status: Assessment_Status_Enum, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, documents: Array<{ __typename?: 'assessment_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, assessments: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status: Assessment_Status_Enum, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, obligations: Array<{ __typename?: 'assessment_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_assessment_result: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, assessments: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status: Assessment_Status_Enum, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, risks: Array<{ __typename?: 'assessment_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetAssessmentResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAssessmentResultByIdQuery = { __typename?: 'query_root', assessment_result_parent: Array<{ __typename?: 'assessment_result_parent', Id: string, ParentId: string, ResultType: Parent_Type_Enum, ParentType: Parent_Type_Enum, obligationAssessmentResult?: { __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, documentAssessmentResult?: { __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, testResult?: { __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number } | null | undefined, impactRating?: { __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined } | null | undefined }> };

export type GetAssessmentResultParentAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAssessmentResultParentAuditByIdQuery = { __typename?: 'query_root', assessment_result_parent_audit: Array<{ __typename?: 'assessment_result_parent_audit', Id: string, ParentId: string, ResultType: string, ParentType: string, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string }> };

export type GetAssessmentResultsByParentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentResultsByParentIdQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, risk_assessment_result: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, test_result: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parent?: { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Id: string, Name: string }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }>, issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, consequences: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Type?: Consequence_Type_Enum | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, certifiedIndividual?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, parents: Array<{ __typename?: 'issue_parent', obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }> }>, impact: Array<{ __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ratings: Array<{ __typename?: 'impact_rating', Rating: number, RatedItemId: string, ratedItem: { __typename?: 'node', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined } }>, appetites: Array<{ __typename?: 'appetite', ImpactId?: string | null | undefined, Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> }>, action: Array<{ __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, parents: Array<{ __typename?: 'action_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, risk?: { __typename?: 'risk', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, issue?: { __typename?: 'issue', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }>, updates: Array<{ __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined }>, updates_aggregate: { __typename?: 'action_update_aggregate', aggregate?: { __typename?: 'action_update_aggregate_fields', count: number } | null | undefined }, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetDocumentAssessmentResultAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDocumentAssessmentResultAuditByIdQuery = { __typename?: 'query_root', document_assessment_result_audit: Array<{ __typename?: 'document_assessment_result_audit', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string }> };

export type GetDocumentAssessmentResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDocumentAssessmentResultByIdQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetDocumentAssessmentResultsByParentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetDocumentAssessmentResultsByParentIdQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestDocumentAssessmentResultByDocumentIdQueryVariables = Exact<{
  DocumentId: Scalars['uuid']['input'];
}>;


export type GetLatestDocumentAssessmentResultByDocumentIdQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }> };

export type GetLatestDocumentAssessmentResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestDocumentAssessmentResultsQuery = { __typename?: 'query_root', document_assessment_result: Array<{ __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string, assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }> };

export type GetLatestObligationAssessmentResultByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetLatestObligationAssessmentResultByObligationIdQuery = { __typename?: 'query_root', obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }> };

export type GetLatestObligationAssessmentResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestObligationAssessmentResultsQuery = { __typename?: 'query_root', obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string, assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }> };

export type GetLatestRiskScoresByRiskIdSubscriptionVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetLatestRiskScoresByRiskIdSubscription = { __typename?: 'subscription_root', risk_score: Array<{ __typename?: 'risk_score', ResidualScore?: number | null | undefined, InherentScore?: number | null | undefined, ResidualRating?: number | null | undefined, InherentRating?: number | null | undefined, ResidualImpact?: number | null | undefined, ResidualLikelihood?: number | null | undefined, InherentImpact?: number | null | undefined, InherentLikelihood?: number | null | undefined, ModifiedAtTimestamp: string }> };

export type GetObligationAssessmentResultAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObligationAssessmentResultAuditByIdQuery = { __typename?: 'query_root', obligation_assessment_result_audit: Array<{ __typename?: 'obligation_assessment_result_audit', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string }> };

export type GetObligationAssessmentResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObligationAssessmentResultByIdQuery = { __typename?: 'query_root', obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetObligationAssessmentResultsByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetObligationAssessmentResultsByObligationIdQuery = { __typename?: 'query_root', obligation_assessment_result: Array<{ __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetRiskAssessmentResultAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetRiskAssessmentResultAuditByIdQuery = { __typename?: 'query_root', risk_assessment_result_audit: Array<{ __typename?: 'risk_assessment_result_audit', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: string, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string }> };

export type GetRiskAssessmentResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetRiskAssessmentResultByIdQuery = { __typename?: 'query_root', risk_assessment_result: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetRiskAssessmentResultsByControlTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskAssessmentResultsByControlTypeQuery = { __typename?: 'query_root', controlled: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string, risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Id: string, Title: string } | null | undefined }> }>, uncontrolled: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string, risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Id: string, Title: string } | null | undefined }> }> };

export type GetRiskAssessmentResultsByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetRiskAssessmentResultsByRiskIdQuery = { __typename?: 'query_root', risk_assessment_result: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetRiskAssessmentResultsByRiskIdAndControlTypeQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
  ControlType: Risk_Assessment_Result_Control_Type_Enum;
}>;


export type GetRiskAssessmentResultsByRiskIdAndControlTypeQuery = { __typename?: 'query_root', risk_assessment_result: Array<{ __typename?: 'risk_assessment_result', Id: string, Rating?: number | null | undefined, Likelihood?: number | null | undefined, Impact?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetRiskScoresByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetRiskScoresByRiskIdQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Tier: number }>, inherent: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }>, residual: Array<{ __typename?: 'risk_assessment_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined } | null | undefined }> }> };

export type InsertDocumentAssessmentResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  DocumentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertDocumentAssessmentResultMutation = { __typename?: 'mutation_root', insertChildDocumentAssessmentResult?: { __typename?: 'InsertChildDocumentAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertChildImpactRatingMutationVariables = Exact<{
  Ratings: Array<InsertImpactRatingPairInput> | InsertImpactRatingPairInput;
  TestDate: Scalars['timestamptz']['input'];
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  RatedItemId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  CompletedBy: Scalars['String']['input'];
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertChildImpactRatingMutation = { __typename?: 'mutation_root', insertChildImpactRating?: { __typename?: 'insertChildImpactRatingOutput', Ids: Array<string> } | null | undefined };

export type InsertObligationAssessmentResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  ObligationIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertObligationAssessmentResultMutation = { __typename?: 'mutation_root', insertChildObligationAssessmentResult?: { __typename?: 'InsertChildObligationAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertRiskAssessmentResultsMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  RiskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertRiskAssessmentResultsMutation = { __typename?: 'mutation_root', insertChildRiskAssessmentResult?: { __typename?: 'InsertChildRiskAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type UpdateDocumentAssessmentResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateDocumentAssessmentResultMutation = { __typename?: 'mutation_root', update_document_assessment_result?: { __typename?: 'document_assessment_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateObligationAssessmentResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateObligationAssessmentResultMutation = { __typename?: 'mutation_root', update_obligation_assessment_result?: { __typename?: 'obligation_assessment_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateRiskAssessmentResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateRiskAssessmentResultMutation = { __typename?: 'mutation_root', updateChildRiskAssessmentResult?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type AssessmentPartsFragment = { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined };

export type DeleteAssessmentsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteAssessmentsMutation = { __typename?: 'mutation_root', delete_assessment?: { __typename?: 'assessment_mutation_response', affected_rows: number } | null | undefined };

export type GetAssessmentAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAssessmentAuditByIdQuery = { __typename?: 'query_root', assessment_audit: Array<{ __typename?: 'assessment_audit', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: string | null | undefined, Outcome?: number | null | undefined }> };

export type GetAssessmentByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetAssessmentByIdQuery = { __typename?: 'query_root', assessment: Array<{ __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetAssessmentsQueryVariables = Exact<{
  where?: Assessment_Bool_Exp;
}>;


export type GetAssessmentsQuery = { __typename?: 'query_root', assessment: Array<{ __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, assessedItems: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, obligationAssessmentResult?: { __typename?: 'obligation_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined }> } | null | undefined, documentAssessmentResult?: { __typename?: 'document_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined }> } | null | undefined }> }> };

export type InsertAssessmentMutationVariables = Exact<{
  object: InsertAssessmentInput;
}>;


export type InsertAssessmentMutation = { __typename?: 'mutation_root', insertAssessmentApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateAssessmentMutationVariables = Exact<{
  object: UpdateAssessmentInput;
}>;


export type UpdateAssessmentMutation = { __typename?: 'mutation_root', updateAssessmentApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type AttestationConfigPartsFragment = { __typename?: 'attestation_config', RequireGlobalAttestation: boolean, AttestationTimeLimit?: any | null | undefined, PromptText?: string | null | undefined, groups: Array<{ __typename?: 'attestation_group', GroupId: string, group: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } }> };

export type AttestationGroupPartsFragment = { __typename?: 'attestation_group', GroupId: string, group: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } };

export type GetAttestationConfigQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAttestationConfigQuery = { __typename?: 'query_root', attestation_config: Array<{ __typename?: 'attestation_config', RequireGlobalAttestation: boolean, AttestationTimeLimit?: any | null | undefined, PromptText?: string | null | undefined, groups: Array<{ __typename?: 'attestation_group', GroupId: string, group: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } }> }>, document_file: Array<{ __typename?: 'document_file', Id: string, Version: string, Status: Version_Status_Enum, PublishedDate?: string | null | undefined }> };

export type GetGlobalUsersAndGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalUsersAndGroupsQuery = { __typename?: 'query_root', globalUsers: { __typename?: 'user_aggregate', aggregate?: { __typename?: 'user_aggregate_fields', count: number } | null | undefined, nodes: Array<{ __typename?: 'user', Id?: string | null | undefined }> }, userGroups: Array<{ __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> }> };

export type InsertAttestationConfigMutationVariables = Exact<{
  object?: InputMaybe<InsertAttestationConfigInput>;
}>;


export type InsertAttestationConfigMutation = { __typename?: 'mutation_root', insertChildAttestationConfig?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type AttestationCyclePartsFragment = { __typename?: 'attestation_cycle', AllowCarryForward: boolean, CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ParentId: string, Status: string, records: Array<{ __typename?: 'attestation_record', AttestationStatus: Attestation_Record_Status_Enum, ExpiresAt?: string | null | undefined, UserId: string }>, parent: { __typename?: 'document_file', Version: string, Id: string, parent?: { __typename?: 'document', Title: string, Id: string } | null | undefined } };

export type GetAttestationCycleRegisterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAttestationCycleRegisterQuery = { __typename?: 'query_root', attestation_cycle: Array<{ __typename?: 'attestation_cycle', AllowCarryForward: boolean, CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ParentId: string, Status: string, records: Array<{ __typename?: 'attestation_record', AttestationStatus: Attestation_Record_Status_Enum, ExpiresAt?: string | null | undefined, UserId: string }>, parent: { __typename?: 'document_file', Version: string, Id: string, parent?: { __typename?: 'document', Title: string, Id: string } | null | undefined } }> };

export type GetAttestationCyclesQueryVariables = Exact<{
  where: Attestation_Cycle_Bool_Exp;
  orderBy?: InputMaybe<Array<Attestation_Cycle_Order_By> | Attestation_Cycle_Order_By>;
}>;


export type GetAttestationCyclesQuery = { __typename?: 'query_root', attestation_cycle: Array<{ __typename?: 'attestation_cycle', AllowCarryForward: boolean, CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ParentId: string, Status: string, records: Array<{ __typename?: 'attestation_record', AttestationStatus: Attestation_Record_Status_Enum, ExpiresAt?: string | null | undefined, UserId: string }>, parent: { __typename?: 'document_file', Version: string, Id: string, parent?: { __typename?: 'document', Title: string, Id: string } | null | undefined } }> };

export type GetActiveAttestationCycleQueryVariables = Exact<{
  parentDocumentId: Scalars['uuid']['input'];
}>;


export type GetActiveAttestationCycleQuery = { __typename?: 'query_root', attestation_cycle: Array<{ __typename?: 'attestation_cycle', Id: string, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Status: string, AllowCarryForward: boolean, parent: { __typename?: 'document_file', Id: string, ParentDocumentId: string } }> };

export type InsertAttestationCycleMutationVariables = Exact<{
  AllowCarryForward: Scalars['Boolean']['input'];
  DocumentId: Scalars['uuid']['input'];
  attestationConfig?: InputMaybe<InsertAttestationConfigInput>;
}>;


export type InsertAttestationCycleMutation = { __typename?: 'mutation_root', insertChildAttestationCycle?: { __typename?: 'IdOutput', Id: string } | null | undefined, insertChildAttestationConfig?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type AttestMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type AttestMutation = { __typename?: 'mutation_root', attestRecord: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetAttestationStatusQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
  UserId: Scalars['String']['input'];
}>;


export type GetAttestationStatusQuery = { __typename?: 'query_root', attestation_record: Array<{ __typename?: 'attestation_record', Id: string, AttestationStatus: Attestation_Record_Status_Enum, config?: { __typename?: 'attestation_config', PromptText?: string | null | undefined } | null | undefined }> };

export type GetPolicyAttestationRecordsQueryVariables = Exact<{
  where?: Attestation_Record_Bool_Exp;
}>;


export type GetPolicyAttestationRecordsQuery = { __typename?: 'query_root', attestation_record: Array<{ __typename?: 'attestation_record', Id: string, ExpiresAt?: string | null | undefined, Active: boolean, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, AttestationStatus: Attestation_Record_Status_Enum, AttestedAt?: string | null | undefined, UserId: string, NodeId: string, CycleId?: string | null | undefined, carriedForwardFromRecord?: { __typename?: 'attestation_record', node: { __typename?: 'node', documentFile?: { __typename?: 'document_file', Id: string, Version: string } | null | undefined } } | null | undefined, user: { __typename?: 'auth_user', Id: string, FirstName?: string | null | undefined, LastName?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined, Department?: string | null | undefined }, node: { __typename?: 'node', documentFile?: { __typename?: 'document_file', Id: string, Version: string, parent?: { __typename?: 'document', Id: string, Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } }> };

export type GetPolicyAttestationRecordsForDocumentQueryVariables = Exact<{
  documentFileId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetPolicyAttestationRecordsForDocumentQuery = { __typename?: 'query_root', attestation_record: Array<{ __typename?: 'attestation_record', ExpiresAt?: string | null | undefined, Active: boolean, CreatedAtTimestamp: string, AttestationStatus: Attestation_Record_Status_Enum, AttestedAt?: string | null | undefined, UserId: string, NodeId: string, CycleId?: string | null | undefined, carriedForwardFromRecord?: { __typename?: 'attestation_record', node: { __typename?: 'node', Id: string, documentFile?: { __typename?: 'document_file', Id: string, Version: string } | null | undefined } } | null | undefined, user: { __typename?: 'auth_user', Id: string, FriendlyName?: string | null | undefined, Email?: string | null | undefined }, node: { __typename?: 'node', documentFile?: { __typename?: 'document_file', Id: string, Version: string, parent?: { __typename?: 'document', Id: string, Title: string } | null | undefined } | null | undefined } }> };

export type AttestationNotRequiredMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AttestationNotRequiredMutation = { __typename?: 'mutation_root', attestationNotRequired: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetAuditLogsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Audit_Log_View_Order_By> | Audit_Log_View_Order_By>;
  where?: InputMaybe<Audit_Log_View_Bool_Exp>;
}>;


export type GetAuditLogsQuery = { __typename?: 'query_root', audit_log_view: Array<{ __typename?: 'audit_log_view', Action?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, ObjectType?: string | null | undefined, Item?: string | null | undefined, Id?: string | null | undefined, OrgKey?: string | null | undefined, PerformedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetBusinessAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessAreasQuery = { __typename?: 'query_root', business_area: Array<{ __typename?: 'business_area', Id: string, Title: string, SequentialId: number, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type CausePartsFragment = { __typename?: 'cause', ModifiedByUser: string, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined };

export type DeleteCausesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteCausesMutation = { __typename?: 'mutation_root', delete_cause?: { __typename?: 'cause_mutation_response', affected_rows: number } | null | undefined };

export type GetCauseAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetCauseAuditByIdQuery = { __typename?: 'query_root', cause_audit: Array<{ __typename?: 'cause_audit', ModifiedByUser?: string | null | undefined, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetCauseByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetCauseByIdQuery = { __typename?: 'query_root', cause: Array<{ __typename?: 'cause', ModifiedByUser: string, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetCausesQueryVariables = Exact<{
  where?: Cause_Bool_Exp;
}>;


export type GetCausesQuery = { __typename?: 'query_root', cause: Array<{ __typename?: 'cause', ModifiedByUser: string, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, issue?: { __typename?: 'issue', Type: Parent_Type_Enum, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', IssueType?: string | null | undefined, ActualCloseDate?: string | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, Severity?: number | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined } | null | undefined }> };

export type GetCausesByParentIssueIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetCausesByParentIssueIdQuery = { __typename?: 'query_root', cause: Array<{ __typename?: 'cause', ModifiedByUser: string, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type InsertCauseMutationVariables = Exact<{
  Title?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertCauseMutation = { __typename?: 'mutation_root', insert_cause?: { __typename?: 'cause_mutation_response', returning: Array<{ __typename?: 'cause', Id: string }> } | null | undefined };

export type UpdateCauseMutationVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Significance?: InputMaybe<Scalars['Int']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateCauseMutation = { __typename?: 'mutation_root', update_cause?: { __typename?: 'cause_mutation_response', affected_rows: number } | null | undefined };

export type GetChangeRequestByIdSubscriptionVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetChangeRequestByIdSubscription = { __typename?: 'subscription_root', change_request_by_pk?: { __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> } | null | undefined };

export type GetChangeRequestByParentIdSubscriptionVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetChangeRequestByParentIdSubscription = { __typename?: 'subscription_root', change_request: Array<{ __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> }> };

export type ChangeRequestPartsFragment = { __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> };

export type GetApprovalLevelsQueryVariables = Exact<{
  Workflow: Scalars['String']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetApprovalLevelsQuery = { __typename?: 'query_root', levels: Array<{ __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, approvers: Array<{ __typename?: 'approver', Id: string, UserId?: string | null | undefined, UserGroupId?: string | null | undefined, OwnerApprover?: boolean | null | undefined, group?: { __typename?: 'user_group', Id: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined }> }> };

export type GetChangeRequestAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetChangeRequestAuditByIdQuery = { __typename?: 'query_root', change_request_audit: Array<{ __typename?: 'change_request_audit', Id: string, SequentialId?: number | null | undefined, ParentId?: string | null | undefined, Type: string, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: string, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined }> };

export type GetChangeRequestsQueryVariables = Exact<{
  where?: Change_Request_Bool_Exp;
  currentUserId: Scalars['String']['input'];
}>;


export type GetChangeRequestsQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ParentId: string, parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', SequentialId?: number | null | undefined, Id: string, Title: string, owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined }> } | null | undefined, risk?: { __typename?: 'risk', Title: string, owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string, owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined, action?: { __typename?: 'action', Title: string, owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, Title: string, SequentialId?: number | null | undefined, owners: Array<{ __typename?: 'owner', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, createdBy?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum, Id: string, Workflow: string } | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Name: string, Id: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined } }>, currentUserOwnerList: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined }> }> };

export type GetPendingChangeRequestsQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetPendingChangeRequestsQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> }> };

export type GetMostRecentNonPendingChangeRequestQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetMostRecentNonPendingChangeRequestQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> }> };

export type GetLivePendingChangeRequestsSubscriptionVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetLivePendingChangeRequestsSubscription = { __typename?: 'subscription_root', change_request: Array<{ __typename?: 'change_request', Id: string, SequentialId?: number | null | undefined, ParentId: string, Type: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, RequestedChanges?: any | null | undefined, ChangeRequestStatus: Approval_Status_Enum, Comment: string, OverriddenByUser?: string | null | undefined, OverriddenAtTimestamp?: string | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined, Email?: string | null | undefined } | null | undefined, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, risk?: { __typename?: 'risk', Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Title: string, parents: Array<{ __typename?: 'acceptance_parent', risk?: { __typename?: 'risk', Id: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, action?: { __typename?: 'action', Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string, owners: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, ContributorType?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined } | null | undefined } | null | undefined, requestedFileChanges: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, contributors: Array<{ __typename?: 'change_request_contributor', user?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined } | null | undefined }>, responses: Array<{ __typename?: 'approver_response', Id: string, Approved?: boolean | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, ApprovedByUser?: string | null | undefined, ApprovedAtTimestamp?: string | null | undefined, Comment?: string | null | undefined, approver: { __typename?: 'approver', Id: string, OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum, SequenceOrder: number, approval?: { __typename?: 'approval', Id: string, ParentId?: string | null | undefined, Workflow: string, InFlightEditRule: Approval_In_Flight_Edit_Rule_Enum } | null | undefined } | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Email?: string | null | undefined, Id?: string | null | undefined } | null | undefined, group?: { __typename?: 'user_group', Id: string, Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> } | null | undefined } }> }> };

export type OverrideChangeRequestByIdMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Approved: Scalars['Boolean']['input'];
  Rationale: Scalars['String']['input'];
}>;


export type OverrideChangeRequestByIdMutation = { __typename?: 'mutation_root', overrideChangeRequest: { __typename?: 'IdOutput', Id: string } };

export type UpdateApproverResponsesMutationVariables = Exact<{
  input: UpdateApproverResponsesInput;
}>;


export type UpdateApproverResponsesMutation = { __typename?: 'mutation_root', updateApproverResponses?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type GetColourPalettesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetColourPalettesQuery = { __typename?: 'query_root', colour_palette: Array<{ __typename?: 'colour_palette', Id: string, Name: string, Settings: any }> };

export type InsertColourPaletteMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Settings: Scalars['jsonb']['input'];
}>;


export type InsertColourPaletteMutation = { __typename?: 'mutation_root', insert_colour_palette_one?: { __typename?: 'colour_palette', Id: string } | null | undefined };

export type UpdateColourPaletteMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  Settings: Scalars['jsonb']['input'];
}>;


export type UpdateColourPaletteMutation = { __typename?: 'mutation_root', update_colour_palette_by_pk?: { __typename?: 'colour_palette', Id: string } | null | undefined };

export type DeleteCommentMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', delete_comment_by_pk?: { __typename?: 'comment', Id: string } | null | undefined };

export type DeleteConversationMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteConversationMutation = { __typename?: 'mutation_root', delete_comment?: { __typename?: 'comment_mutation_response', affected_rows: number } | null | undefined, delete_conversation_by_pk?: { __typename?: 'conversation', Id: string } | null | undefined };

export type DeleteConversationsMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteConversationsMutation = { __typename?: 'mutation_root', delete_comment?: { __typename?: 'comment_mutation_response', affected_rows: number } | null | undefined, delete_conversation?: { __typename?: 'conversation_mutation_response', affected_rows: number } | null | undefined };

export type GetCommentAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetCommentAuditByIdQuery = { __typename?: 'query_root', comment_audit: Array<{ __typename?: 'comment_audit', Id: string, Content: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedByUser: string }> };

export type GetCommentsByConversationIdQueryVariables = Exact<{
  ConversationId: Scalars['uuid']['input'];
}>;


export type GetCommentsByConversationIdQuery = { __typename?: 'query_root', comment: Array<{ __typename?: 'comment', Id: string, Content: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedByUser: string, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetConversationAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetConversationAuditByIdQuery = { __typename?: 'query_root', conversation_audit: Array<{ __typename?: 'conversation_audit', Id: string, IsResolved?: boolean | null | undefined, ParentId?: string | null | undefined, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedByUser: string }> };

export type InsertCommentMutationVariables = Exact<{
  Content: Scalars['String']['input'];
  ConversationId: Scalars['uuid']['input'];
}>;


export type InsertCommentMutation = { __typename?: 'mutation_root', insert_comment_one?: { __typename?: 'comment', Id: string } | null | undefined };

export type InsertConversationMutationVariables = Exact<{
  Content: Scalars['String']['input'];
  ParentId: Scalars['uuid']['input'];
}>;


export type InsertConversationMutation = { __typename?: 'mutation_root', insert_conversation_one?: { __typename?: 'conversation', Id: string } | null | undefined };

export type ResolveConversationMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type ResolveConversationMutation = { __typename?: 'mutation_root', update_conversation_by_pk?: { __typename?: 'conversation', Id: string } | null | undefined };

export type UpdateCommentMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Content: Scalars['String']['input'];
}>;


export type UpdateCommentMutation = { __typename?: 'mutation_root', update_comment_by_pk?: { __typename?: 'comment', Id: string } | null | undefined };

export type ComplianceMonitoringAssessmentPartsFragment = { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined };

export type DeleteComplianceMonitoringAssessmentsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteComplianceMonitoringAssessmentsMutation = { __typename?: 'mutation_root', delete_compliance_monitoring_assessment?: { __typename?: 'compliance_monitoring_assessment_mutation_response', affected_rows: number } | null | undefined };

export type GetAllComplianceMonitoringAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllComplianceMonitoringAssessmentsQuery = { __typename?: 'query_root', compliance_monitoring_assessment: Array<{ __typename?: 'compliance_monitoring_assessment', Title: string, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, NextTestDate?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, Outcome?: number | null | undefined }> };

export type GetComplianceMonitoringAssessmentByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetComplianceMonitoringAssessmentByIdQuery = { __typename?: 'query_root', compliance_monitoring_assessment: Array<{ __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetComplianceMonitoringAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComplianceMonitoringAssessmentsQuery = { __typename?: 'query_root', compliance_monitoring_assessment: Array<{ __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, assessedItems: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, obligationAssessmentResult?: { __typename?: 'obligation_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined }> } | null | undefined, documentAssessmentResult?: { __typename?: 'document_assessment_result', Id: string, parents: Array<{ __typename?: 'assessment_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined }> } | null | undefined }> }> };

export type InsertComplianceMonitoringAssessmentMutationVariables = Exact<{
  object: InsertAssessmentInput;
}>;


export type InsertComplianceMonitoringAssessmentMutation = { __typename?: 'mutation_root', insertComplianceMonitoringAssessmentApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateComplianceMonitoringAssessmentMutationVariables = Exact<{
  object: UpdateAssessmentInput;
}>;


export type UpdateComplianceMonitoringAssessmentMutation = { __typename?: 'mutation_root', updateComplianceMonitoringAssessmentApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type ConsequencePartsFragment = { __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, Type?: Consequence_Type_Enum | null | undefined };

export type DeleteConsequencesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteConsequencesMutation = { __typename?: 'mutation_root', delete_consequence?: { __typename?: 'consequence_mutation_response', affected_rows: number } | null | undefined };

export type GetConsequenceAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetConsequenceAuditByIdQuery = { __typename?: 'query_root', consequence_audit: Array<{ __typename?: 'consequence_audit', CostType: string, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Type?: string | null | undefined }> };

export type GetConsequenceByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetConsequenceByIdQuery = { __typename?: 'query_root', consequence: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, Type?: Consequence_Type_Enum | null | undefined }> };

export type GetConsequencesQueryVariables = Exact<{
  where?: Consequence_Bool_Exp;
}>;


export type GetConsequencesQuery = { __typename?: 'query_root', consequence: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, Type?: Consequence_Type_Enum | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, issue?: { __typename?: 'issue', Type: Parent_Type_Enum, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', IssueType?: string | null | undefined, ActualCloseDate?: string | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, Severity?: number | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined }> };

export type GetConsequencesByParentIssueIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetConsequencesByParentIssueIdQuery = { __typename?: 'query_root', consequence: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, Type?: Consequence_Type_Enum | null | undefined }> };

export type InsertConsequenceMutationVariables = Exact<{
  Title?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  CostType?: InputMaybe<Cost_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Type?: InputMaybe<Consequence_Type_Enum>;
}>;


export type InsertConsequenceMutation = { __typename?: 'mutation_root', insert_consequence_one?: { __typename?: 'consequence', Id: string } | null | undefined };

export type UpdateConsequenceMutationVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Criticality?: InputMaybe<Scalars['Int']['input']>;
  CostType?: InputMaybe<Cost_Type_Enum>;
  CostValue?: InputMaybe<Scalars['numeric']['input']>;
  ParentIssueId?: InputMaybe<Scalars['uuid']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Type?: InputMaybe<Consequence_Type_Enum>;
}>;


export type UpdateConsequenceMutation = { __typename?: 'mutation_root', update_consequence?: { __typename?: 'consequence_mutation_response', affected_rows: number } | null | undefined };

export type AddControlParentsMutationVariables = Exact<{
  objects: Array<Control_Parent_Insert_Input> | Control_Parent_Insert_Input;
}>;


export type AddControlParentsMutation = { __typename?: 'mutation_root', insert_control_parent?: { __typename?: 'control_parent_mutation_response', affected_rows: number } | null | undefined };

export type ControlPartsFragment = { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined };

export type DeleteControlsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteControlsMutation = { __typename?: 'mutation_root', deleteControlsById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetControlAuditByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetControlAuditByIdQuery = { __typename?: 'query_root', control_audit: Array<{ __typename?: 'control_audit', CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetControlByIdQueryVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetControlByIdQuery = { __typename?: 'query_root', control: Array<{ __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetControlsQueryVariables = Exact<{
  where?: Control_Bool_Exp;
}>;


export type GetControlsQuery = { __typename?: 'query_root', control: Array<{ __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined, DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, open_issue_aggregate: { __typename?: 'issue_parent_aggregate', aggregate?: { __typename?: 'issue_parent_aggregate_fields', count: number } | null | undefined }, issues_aggregate: { __typename?: 'issue_parent_aggregate', aggregate?: { __typename?: 'issue_parent_aggregate_fields', count: number } | null | undefined }, indicators_aggregate: { __typename?: 'indicator_parent_aggregate', aggregate?: { __typename?: 'indicator_parent_aggregate_fields', count: number } | null | undefined }, testResults: Array<{ __typename?: 'test_result', OverallEffectiveness?: number | null | undefined, DesignEffectiveness?: number | null | undefined, PerformanceEffectiveness?: number | null | undefined, TestDate: string, Id: string }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, parents: Array<{ __typename?: 'control_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string } | null | undefined, risk?: { __typename?: 'risk', Title: string } | null | undefined, thirdParty?: { __typename?: 'third_party', Title: string } | null | undefined, group?: { __typename?: 'control_group', Id: string, Title: string } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetControlsBasicQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlsBasicQuery = { __typename?: 'query_root', control: Array<{ __typename?: 'control', Id: string, Title: string, SequentialId?: number | null | undefined }>, node: Array<{ __typename?: 'node', Id: string, SequentialId?: number | null | undefined }> };

export type GetControlsByUserQueryVariables = Exact<{
  _eq?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetControlsByUserQuery = { __typename?: 'query_root', control: Array<{ __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type InsertChildControlMutationVariables = Exact<{
  object?: InputMaybe<InsertChildControlInput>;
}>;


export type InsertChildControlMutation = { __typename?: 'mutation_root', insertChildControl?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type RemoveParentControlsMutationVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
  ControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type RemoveParentControlsMutation = { __typename?: 'mutation_root', delete_control_parent?: { __typename?: 'control_parent_mutation_response', affected_rows: number } | null | undefined };

export type UpdateControlMutationVariables = Exact<{
  object?: InputMaybe<UpdateChildControlInput>;
}>;


export type UpdateControlMutation = { __typename?: 'mutation_root', updateChildControl?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type ControlGroupPartsFragment = { __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined };

export type DeleteControlGroupMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  original_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeleteControlGroupMutation = { __typename?: 'mutation_root', delete_control_group?: { __typename?: 'control_group_mutation_response', affected_rows: number } | null | undefined };

export type GetControlGroupAuditByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetControlGroupAuditByIdQuery = { __typename?: 'query_root', control_group_audit: Array<{ __typename?: 'control_group_audit', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetControlGroupByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetControlGroupByIdQuery = { __typename?: 'query_root', control_group: Array<{ __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetControlGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlGroupsQuery = { __typename?: 'query_root', control_group: Array<{ __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetControlGroupsByTitleQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type GetControlGroupsByTitleQuery = { __typename?: 'query_root', control_group: Array<{ __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetControlGroupsFlatQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlGroupsFlatQuery = { __typename?: 'query_root', control_group: Array<{ __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, controls_aggregate: { __typename?: 'control_parent_aggregate', aggregate?: { __typename?: 'control_parent_aggregate_fields', count: number } | null | undefined }, owner?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertControlGroupMutationVariables = Exact<{
  Title: Scalars['String']['input'];
  Description: Scalars['String']['input'];
  Owner: Scalars['String']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertControlGroupMutation = { __typename?: 'mutation_root', insert_control_group_one?: { __typename?: 'control_group', Id: string } | null | undefined };

export type UpdateControlGroupMutationVariables = Exact<{
  Description: Scalars['String']['input'];
  Owner: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateControlGroupMutation = { __typename?: 'mutation_root', update_control_group?: { __typename?: 'control_group_mutation_response', affected_rows: number } | null | undefined };

export type GetCustomAttributeSchemaAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetCustomAttributeSchemaAuditByIdQuery = { __typename?: 'query_root', custom_attribute_schema_audit: Array<{ __typename?: 'custom_attribute_schema_audit', ModifiedByUser: string, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string, Id: string, Schema: any, Title?: string | null | undefined, UiSchema: any }> };

export type DeleteCustomDatasourceMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteCustomDatasourceMutation = { __typename?: 'mutation_root', delete_custom_datasource_by_pk?: { __typename?: 'custom_datasource', Id: string } | null | undefined };

export type GetCustomDatasourceByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetCustomDatasourceByIdQuery = { __typename?: 'query_root', custom_datasource_by_pk?: { __typename?: 'custom_datasource', Title: string, Id: string, Filters?: any | null | undefined, Datasources: any, Fields?: any | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string } | null | undefined };

export type GetCustomDatasourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomDatasourcesQuery = { __typename?: 'query_root', custom_datasource: Array<{ __typename?: 'custom_datasource', Title: string, Id: string, Filters?: any | null | undefined, Datasources: any, Fields?: any | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertCustomDataSourceMutationVariables = Exact<{
  customDatasource: Custom_Datasource_Insert_Input;
}>;


export type InsertCustomDataSourceMutation = { __typename?: 'mutation_root', insert_custom_datasource_one?: { __typename?: 'custom_datasource', Id: string } | null | undefined };

export type UpdateCustomDatasourceMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Data: Custom_Datasource_Set_Input;
}>;


export type UpdateCustomDatasourceMutation = { __typename?: 'mutation_root', update_custom_datasource_by_pk?: { __typename?: 'custom_datasource', Id: string } | null | undefined };

export type GetCustomRibbonAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetCustomRibbonAuditByIdQuery = { __typename?: 'query_root', custom_ribbon_audit: Array<{ __typename?: 'custom_ribbon_audit', ModifiedByUser: string, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string, Id: string, Filters: any, ParentType: string }> };

export type GetRibbonItemsByParentTypeQueryVariables = Exact<{
  parentType: Parent_Type_Enum;
}>;


export type GetRibbonItemsByParentTypeQuery = { __typename?: 'query_root', custom_ribbon: Array<{ __typename?: 'custom_ribbon', Id: string, ParentType: Parent_Type_Enum, Filters: any, ModifiedAtTimestamp: string }> };

export type InsertRibbonItemsByParentTypeMutationVariables = Exact<{
  parentType: Parent_Type_Enum;
  filters: Scalars['jsonb']['input'];
}>;


export type InsertRibbonItemsByParentTypeMutation = { __typename?: 'mutation_root', insert_custom_ribbon_one?: { __typename?: 'custom_ribbon', Id: string } | null | undefined };

export type UpdateRibbonItemsByParentTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  originalTimestamp: Scalars['timestamptz']['input'];
  parentType: Parent_Type_Enum;
  filters: Scalars['jsonb']['input'];
}>;


export type UpdateRibbonItemsByParentTypeMutation = { __typename?: 'mutation_root', update_custom_ribbon?: { __typename?: 'custom_ribbon_mutation_response', affected_rows: number } | null | undefined };

export type CustomRoleUserUpdateMutationVariables = Exact<{
  input?: InputMaybe<CustomRoleUserUpdateInputData>;
}>;


export type CustomRoleUserUpdateMutation = { __typename?: 'mutation_root', customRoleUserUpdate?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DeleteCustomRoleMutationVariables = Exact<{
  filter: Custom_Role_Bool_Exp;
}>;


export type DeleteCustomRoleMutation = { __typename?: 'mutation_root', delete_custom_role?: { __typename?: 'custom_role_mutation_response', affected_rows: number } | null | undefined };

export type GetCustomRoleByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetCustomRoleByIdQuery = { __typename?: 'query_root', custom_role: Array<{ __typename?: 'custom_role', Id: string, RoleName: string, Description?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, customRoleUsers: Array<{ __typename?: 'custom_role_user', UserId: string, Id: string }>, customRoleAssignments: Array<{ __typename?: 'custom_role_assignment', RoleTypeKey: string, Id: string }> }> };

export type GetCustomRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomRolesQuery = { __typename?: 'query_root', custom_role: Array<{ __typename?: 'custom_role', Id: string, RoleName: string, Description?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, customRoleUsers_aggregate: { __typename?: 'custom_role_user_aggregate', aggregate?: { __typename?: 'custom_role_user_aggregate_fields', count: number } | null | undefined } }> };

export type InsertCustomRoleMutationVariables = Exact<{
  input?: InputMaybe<CustomRoleInsertInputData>;
}>;


export type InsertCustomRoleMutation = { __typename?: 'mutation_root', customRoleInsert?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateCustomRoleMutationVariables = Exact<{
  input?: InputMaybe<CustomRoleUpdateInputData>;
}>;


export type UpdateCustomRoleMutation = { __typename?: 'mutation_root', customRoleUpdate?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DashboardPartsFragment = { __typename?: 'dashboard', Id: string, Name: string, Description?: string | null | undefined, Sharing: Dashboard_Sharing_Type_Enum, Content?: any | null | undefined, CreatedByUser?: string | null | undefined };

export type DeleteDashboardMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardMutation = { __typename?: 'mutation_root', delete_dashboard_by_pk?: { __typename?: 'dashboard', Id: string } | null | undefined };

export type GetDashboardAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDashboardAuditByIdQuery = { __typename?: 'query_root', dashboard_audit: Array<{ __typename?: 'dashboard_audit', Id: string, Name?: string | null | undefined, Description?: string | null | undefined, Sharing?: string | null | undefined, Content?: any | null | undefined, CreatedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string }> };

export type GetDashboardByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDashboardByIdQuery = { __typename?: 'query_root', dashboard_by_pk?: { __typename?: 'dashboard', Id: string, Name: string, Description?: string | null | undefined, Sharing: Dashboard_Sharing_Type_Enum, Content?: any | null | undefined, CreatedByUser?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> } | null | undefined };

export type GetDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardsQuery = { __typename?: 'query_root', dashboard: Array<{ __typename?: 'dashboard', Id: string, Name: string, Description?: string | null | undefined, Sharing: Dashboard_Sharing_Type_Enum, Content?: any | null | undefined, CreatedByUser?: string | null | undefined }> };

export type GetMyItemsDashboardQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  actionFilterConditions: Action_Bool_Exp;
  riskFilterConditions: Risk_Bool_Exp;
  indicatorFilterConditions: Indicator_Bool_Exp;
  documentFilterConditions: Document_Bool_Exp;
  assessmentFilterConditions: Assessment_Bool_Exp;
  controlFilterConditions: Control_Bool_Exp;
  issueFilterConditions: Issue_Bool_Exp;
  assessmentActivityFilterConditions: Assessment_Activity_Bool_Exp;
  obligationFilterConditions: Obligation_Bool_Exp;
}>;


export type GetMyItemsDashboardQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, CreatedAtTimestamp: string, Id: string, responses: Array<{ __typename?: 'approver_response', Approved?: boolean | null | undefined, approver: { __typename?: 'approver', OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum } | null | undefined, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined, user?: { __typename?: 'user', Id?: string | null | undefined } | null | undefined } }>, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, Title: string } | null | undefined } | null | undefined, action?: { __typename?: 'action', Id: string, Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Id: string, Title: string } | null | undefined, control?: { __typename?: 'control', Id: string, Title: string } | null | undefined, issue?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, currentUserOwnerList: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined }> }>, action: Array<{ __typename?: 'action', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, risk: Array<{ __typename?: 'risk', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, indicator: Array<{ __typename?: 'indicator', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, document: Array<{ __typename?: 'document', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, assessment: Array<{ __typename?: 'assessment', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, assessment_activity: Array<{ __typename?: 'assessment_activity', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, control: Array<{ __typename?: 'control', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, issue: Array<{ __typename?: 'issue', Id: string, assessment?: { __typename?: 'issue_assessment', Status?: Issue_Assessment_Status_Enum | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, attestation_record_aggregate: { __typename?: 'attestation_record_aggregate', aggregate?: { __typename?: 'attestation_record_aggregate_fields', count: number } | null | undefined }, obligation: Array<{ __typename?: 'obligation', Id: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }> };

export type InsertDashboardMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  Sharing: Dashboard_Sharing_Type_Enum_Action;
  Content: Scalars['jsonb']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  ContributorUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InsertDashboardMutation = { __typename?: 'mutation_root', insertChildDashboard?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type MyItemsAncestorContributorsPartsFragment = { __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined };

export type MyItemsChangeRequestPartsFragment = { __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, CreatedAtTimestamp: string, Id: string, responses: Array<{ __typename?: 'approver_response', Approved?: boolean | null | undefined, approver: { __typename?: 'approver', OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum } | null | undefined, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined, user?: { __typename?: 'user', Id?: string | null | undefined } | null | undefined } }>, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, Title: string } | null | undefined } | null | undefined, action?: { __typename?: 'action', Id: string, Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Id: string, Title: string } | null | undefined, control?: { __typename?: 'control', Id: string, Title: string } | null | undefined, issue?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, currentUserOwnerList: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined }> };

export type MyItemsContributorGroupPartsFragment = { __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined };

export type MyItemsOwnerGroupPartsFragment = { __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined };

export type UpdateDashboardMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  Sharing: Dashboard_Sharing_Type_Enum_Action;
  Content: Scalars['jsonb']['input'];
  ContributorUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ContributorGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateDashboardMutation = { __typename?: 'mutation_root', updateChildDashboard?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type DataExportCreateScheduleMutationVariables = Exact<{
  object: DataExportCreateScheduleInput;
}>;


export type DataExportCreateScheduleMutation = { __typename?: 'mutation_root', dataExportCreateSchedule?: { __typename?: 'DataExportCreateScheduleOutput', message: string } | null | undefined };

export type DataExportOneOffExportQueryVariables = Exact<{ [key: string]: never; }>;


export type DataExportOneOffExportQuery = { __typename?: 'query_root', dataExportOneOffExport?: { __typename?: 'DataExportOneOffExportOutput', message: string, downloadUrl: string, expiresInSeconds: number } | null | undefined };

export type GetActiveDataExportScheduleSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetActiveDataExportScheduleSubscription = { __typename?: 'subscription_root', data_export_schedule: Array<{ __typename?: 'data_export_schedule', Id: string, Frequency: Data_Export_Schedule_Frequency_Enum, StartTimestamp: string, EndTimestamp?: string | null | undefined, StorageType: Data_Export_Schedule_Storage_Type_Enum }> };

export type GetDataExportScheduleExecutionsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetDataExportScheduleExecutionsSubscription = { __typename?: 'subscription_root', data_export_schedule_execution: Array<{ __typename?: 'data_export_schedule_execution', ParentId: string, ExecutionTimestamp: string, Status: Data_Export_Schedule_Execution_Status_Enum, Errors?: string | null | undefined, dataExportSchedule?: { __typename?: 'data_export_schedule', Frequency: Data_Export_Schedule_Frequency_Enum, StartTimestamp: string, EndTimestamp?: string | null | undefined } | null | undefined }> };

export type DataExportTestScheduleMutationVariables = Exact<{
  object: DataExportTestScheduleInput;
}>;


export type DataExportTestScheduleMutation = { __typename?: 'mutation_root', dataExportTestSchedule?: { __typename?: 'DataExportTestScheduleOutput', message: string } | null | undefined };

export type DataImportStartImportMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DataImportStartImportMutation = { __typename?: 'mutation_root', dataImportStartImport?: { __typename?: 'DataImportStartImportOutput', message: string } | null | undefined };

export type DataImportValidateMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DataImportValidateMutation = { __typename?: 'mutation_root', dataImportValidate?: { __typename?: 'DataImportValidateOutput', message: string } | null | undefined };

export type DeleteDataImportByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDataImportByIdMutation = { __typename?: 'mutation_root', delete_data_import?: { __typename?: 'data_import_mutation_response', affected_rows: number } | null | undefined };

export type GetDataImportByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDataImportByIdQuery = { __typename?: 'query_root', data_import: Array<{ __typename?: 'data_import', Id: string, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetDataImportErrorsQueryVariables = Exact<{
  dataImportId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetDataImportErrorsQuery = { __typename?: 'query_root', data_import_error: Array<{ __typename?: 'data_import_error', RowNumber: number, ImportObject: string, DataImportId?: string | null | undefined, Message: string }> };

export type GetDataImportStatusSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDataImportStatusSubscription = { __typename?: 'subscription_root', data_import: Array<{ __typename?: 'data_import', Status: Data_Import_Status_Enum }> };

export type GetDataImportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataImportsQuery = { __typename?: 'query_root', data_import: Array<{ __typename?: 'data_import', Id: string, Status: Data_Import_Status_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertDataImportMutationVariables = Exact<{ [key: string]: never; }>;


export type InsertDataImportMutation = { __typename?: 'mutation_root', insert_data_import_one?: { __typename?: 'data_import', Id: string } | null | undefined };

export type DeleteDepartmentTypesMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteDepartmentTypesMutation = { __typename?: 'mutation_root', deleteDepartmentTypeApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DepartmentPartsFragment = { __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined };

export type GetDepartmentAuditByIdQueryVariables = Exact<{
  DepartmentTypeId: Scalars['uuid']['input'];
  ParentId: Scalars['uuid']['input'];
}>;


export type GetDepartmentAuditByIdQuery = { __typename?: 'query_root', department_audit: Array<{ __typename?: 'department_audit', DepartmentTypeId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined }> };

export type GetDepartmentTypeByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetDepartmentTypeByIdQuery = { __typename?: 'query_root', department_type: Array<{ __typename?: 'department_type', DepartmentTypeId: string, Name: string, Description?: string | null | undefined, ModifiedAtTimestamp: string, DepartmentTypeGroupId?: string | null | undefined, department_type_group?: { __typename?: 'department_type_group', Id: string, Name: string } | null | undefined }> };

export type GetDepartmentTypesByNameQueryVariables = Exact<{
  Name: Scalars['String']['input'];
}>;


export type GetDepartmentTypesByNameQuery = { __typename?: 'query_root', department_type: Array<{ __typename?: 'department_type', Name: string, DepartmentTypeId: string }> };

export type GetDepartmentTypeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentTypeGroupsQuery = { __typename?: 'query_root', department_type_group: Array<{ __typename?: 'department_type_group', Id: string, Name: string }> };

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentsQuery = { __typename?: 'query_root', department_type: Array<{ __typename?: 'department_type', DepartmentTypeId: string, Name: string, Description?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, department_type_group?: { __typename?: 'department_type_group', Id: string, Name: string } | null | undefined }> };

export type InsertDepartmentTypeGroupByNameMutationVariables = Exact<{
  Name?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertDepartmentTypeGroupByNameMutation = { __typename?: 'mutation_root', insert_department_type_group_one?: { __typename?: 'department_type_group', Id: string } | null | undefined };

export type InsertDepartmentTypeWithGroupNameMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  DepartmentGroupName?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertDepartmentTypeWithGroupNameMutation = { __typename?: 'mutation_root', insert_department_type_one?: { __typename?: 'department_type', DepartmentTypeId: string } | null | undefined };

export type InsertDepartmentTypeWithOptionalGroupIdMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertDepartmentTypeWithOptionalGroupIdMutation = { __typename?: 'mutation_root', insert_department_type_one?: { __typename?: 'department_type', DepartmentTypeId: string } | null | undefined };

export type UpdateDepartmentTypeMutationVariables = Exact<{
  DepartmentTypeId: Scalars['uuid']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  DepartmentTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateDepartmentTypeMutation = { __typename?: 'mutation_root', update_department_type?: { __typename?: 'department_type_mutation_response', affected_rows: number } | null | undefined };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'mutation_root', deleteDocumentById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type DocumentPartsFragment = { __typename?: 'document', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined };

export type GetDocumentAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocumentAuditByIdQuery = { __typename?: 'query_root', document_audit: Array<{ __typename?: 'document_audit', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetDocumentByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocumentByIdQuery = { __typename?: 'query_root', document: Array<{ __typename?: 'document', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, linkedDocuments: Array<{ __typename?: 'document_linked_document', LinkedDocumentId: string, child?: { __typename?: 'document', Title: string } | null | undefined }>, attestationConfig?: { __typename?: 'attestation_config', RequireGlobalAttestation: boolean, AttestationTimeLimit?: any | null | undefined, PromptText?: string | null | undefined, groups: Array<{ __typename?: 'attestation_group', GroupId: string, group: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } }> } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, latestDraftVersion: Array<{ __typename?: 'document_file', Id: string, Status: Version_Status_Enum }>, latestPublishedVersion: Array<{ __typename?: 'document_file', Id: string, Status: Version_Status_Enum }>, parent?: { __typename?: 'document', Title: string } | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetDocumentListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentListQuery = { __typename?: 'query_root', document: Array<{ __typename?: 'document', Id: string, Title: string }> };

export type GetDocumentsQueryVariables = Exact<{
  where?: Document_Bool_Exp;
  filesWhere?: InputMaybe<Document_File_Bool_Exp>;
  documentAssessmentResultsWhere?: InputMaybe<Document_Assessment_Result_Bool_Exp>;
  includeAssessmentResultsHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDocumentsQuery = { __typename?: 'query_root', document: Array<{ __typename?: 'document', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, parent?: { __typename?: 'document', Title: string } | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined, DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, documentFiles: Array<{ __typename?: 'document_file', Status: Version_Status_Enum, ReviewDate?: string | null | undefined, NextReviewDate?: string | null | undefined, changeRequests: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string }> }>, latestPublishedVersion: Array<{ __typename?: 'document_file', PublishedDate?: string | null | undefined }>, assessmentResults?: Array<{ __typename?: 'assessment_result_parent', ParentId: string, documentAssessmentResult?: { __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, TestDate?: string | null | undefined, CreatedAtTimestamp: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }>, assessment_result_parent: Array<{ __typename?: 'assessment_result_parent', documentAssessmentResult?: { __typename?: 'document_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string }> } | null | undefined }> };

export type InsertDocumentMutationVariables = Exact<{
  object?: InputMaybe<InsertChildDocumentInput>;
}>;


export type InsertDocumentMutation = { __typename?: 'mutation_root', insertChildDocument?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateDocumentMutationVariables = Exact<{
  object?: InputMaybe<UpdateChildDocumentInput>;
}>;


export type UpdateDocumentMutation = { __typename?: 'mutation_root', updateChildDocument?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type DocumentRelationFilePartsFragment = { __typename?: 'document_file', CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Version: string, Type: Document_File_Type_Enum };

export type PublicDocumentRelationFilePartsFragment = { __typename?: 'document_file', CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Version: string, Type: Document_File_Type_Enum, PublishedDate?: string | null | undefined };

export type DeleteDocumentFilesMutationVariables = Exact<{
  documentFileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteDocumentFilesMutation = { __typename?: 'mutation_root', delete_file?: { __typename?: 'file_mutation_response', affected_rows: number } | null | undefined, delete_document_file?: { __typename?: 'document_file_mutation_response', affected_rows: number } | null | undefined };

export type GetDocumentFileAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocumentFileAuditByIdQuery = { __typename?: 'query_root', document_file_audit: Array<{ __typename?: 'document_file_audit', CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: string, Summary?: string | null | undefined, Version: string, Type: string }> };

export type GetDocumentFileByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocumentFileByIdQuery = { __typename?: 'query_root', document_file: Array<{ __typename?: 'document_file', Content?: string | null | undefined, Link?: string | null | undefined, Version: string, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Type: Document_File_Type_Enum, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined, parent?: { __typename?: 'document', Id: string, Title: string, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }> } | null | undefined, changeRequests: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string }> }> };

export type GetDocumentFilesByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['uuid']['input'];
}>;


export type GetDocumentFilesByDocumentIdQuery = { __typename?: 'query_root', document_file: Array<{ __typename?: 'document_file', Content?: string | null | undefined, Link?: string | null | undefined, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Version: string, Type: Document_File_Type_Enum, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined, reviewedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, changeRequests: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, ModifiedAtTimestamp: string }> }> };

export type GetDocumentFileQueryVariables = Exact<{
  where?: InputMaybe<Document_File_Bool_Exp>;
}>;


export type GetDocumentFileQuery = { __typename?: 'query_root', document_file: Array<{ __typename?: 'document_file', Id: string, Version: string, Content?: string | null | undefined, Type: Document_File_Type_Enum, Link?: string | null | undefined, FileId?: string | null | undefined, CustomAttributeData?: any | null | undefined, PublishedDate?: string | null | undefined, file?: { __typename?: 'file', FileName: string } | null | undefined, parent?: { __typename?: 'document', Title: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, linkedDocuments: Array<{ __typename?: 'document_linked_document', child?: { __typename?: 'document', Id: string, Title: string } | null | undefined }> } | null | undefined }> };

export type GetLatestPublicDocumentFileByDocumentIdQueryVariables = Exact<{
  documentId: Scalars['uuid']['input'];
}>;


export type GetLatestPublicDocumentFileByDocumentIdQuery = { __typename?: 'query_root', document_file: Array<{ __typename?: 'document_file', Link?: string | null | undefined, Content?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Version: string, Type: Document_File_Type_Enum, PublishedDate?: string | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined, reviewedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'document', Title: string, DocumentType: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> };

export type GetPublicDocumentFilesQueryVariables = Exact<{
  currentUserId: Scalars['String']['input'];
}>;


export type GetPublicDocumentFilesQuery = { __typename?: 'query_root', document_file: Array<{ __typename?: 'document_file', Link?: string | null | undefined, Content?: string | null | undefined, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, FileId?: string | null | undefined, Id: string, ModifiedByUser: string, NextReviewDate?: string | null | undefined, ParentDocumentId: string, ReasonForReview?: string | null | undefined, ReviewDate?: string | null | undefined, ReviewedBy?: string | null | undefined, Status: Version_Status_Enum, Summary?: string | null | undefined, Version: string, Type: Document_File_Type_Enum, PublishedDate?: string | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined, reviewedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'document', Title: string, DocumentType: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, attestations: Array<{ __typename?: 'attestation_record', AttestationStatus: Attestation_Record_Status_Enum, ExpiresAt?: string | null | undefined, Active: boolean }> }> };

export type InsertDocumentVersionMutationVariables = Exact<{
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ParentDocumentId: Scalars['uuid']['input'];
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
  Content?: InputMaybe<Scalars['String']['input']>;
  Type?: InputMaybe<Document_File_Type_Enum>;
  Link?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertDocumentVersionMutation = { __typename?: 'mutation_root', insertDocumentVersion?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateDocumentVersionMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  FileId?: InputMaybe<Scalars['uuid']['input']>;
  LatestModifiedAtTimestamp: Scalars['timestamptz']['input'];
  NextReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReasonForReview?: InputMaybe<Scalars['String']['input']>;
  ReviewDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ReviewedBy?: InputMaybe<Scalars['String']['input']>;
  Status: Version_Status_Enum;
  Summary?: InputMaybe<Scalars['String']['input']>;
  Version: Scalars['String']['input'];
  Content?: InputMaybe<Scalars['String']['input']>;
  Type: Document_File_Type_Enum;
  Link?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateDocumentVersionMutation = { __typename?: 'mutation_root', updateDocumentVersion?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type AddRiskToEnterpriseRiskMutationVariables = Exact<{
  objects: Array<AddRiskToEnterpriseRiskInput> | AddRiskToEnterpriseRiskInput;
}>;


export type AddRiskToEnterpriseRiskMutation = { __typename?: 'mutation_root', addRiskToEnterpriseRisk?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetEnterpriseRisksQueryVariables = Exact<{
  where?: Enterprise_Risk_Bool_Exp;
}>;


export type GetEnterpriseRisksQuery = { __typename?: 'query_root', enterprise_risk: Array<{ __typename?: 'enterprise_risk', Id: string, SequentialId: number, Title: string, Description: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Treatment?: Risk_Treatment_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, Tier: number, ParentId?: string | null | undefined, score?: { __typename?: 'enterprise_risk_score', InherentScoreMean?: number | null | undefined, InherentScoreMedian?: Array<number> | null | undefined, InherentScoreWorstCase?: number | null | undefined, ResidualScoreMean?: number | null | undefined, ResidualScoreMedian?: Array<number> | null | undefined, ResidualScoreWorstCase?: number | null | undefined, InherentRatingMean?: number | null | undefined, InherentRatingMedian?: Array<number> | null | undefined, InherentRatingWorstCase?: number | null | undefined, ResidualRatingMean?: number | null | undefined, ResidualRatingMedian?: Array<number> | null | undefined, ResidualRatingWorstCase?: number | null | undefined } | null | undefined, parent?: { __typename?: 'enterprise_risk', Id: string, Title: string } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetEnterpriseRiskByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetEnterpriseRiskByIdQuery = { __typename?: 'query_root', enterprise_risk: Array<{ __typename?: 'enterprise_risk', Id: string, SequentialId: number, Title: string, Description: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Treatment?: Risk_Treatment_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, Tier: number, ParentId?: string | null | undefined, children: Array<{ __typename?: 'enterprise_risk', Id: string }>, parent?: { __typename?: 'enterprise_risk', Id: string, Title: string } | null | undefined }> };

export type DeleteEnterpriseRiskMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteEnterpriseRiskMutation = { __typename?: 'mutation_root', deleteChildEnterpriseRisk?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type InsertEnterpriseRiskMutationVariables = Exact<{
  Title: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Tier: Scalars['Int']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertEnterpriseRiskMutation = { __typename?: 'mutation_root', insertChildEnterpriseRisk?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateEnterpriseRiskMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Title: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  Treatment?: InputMaybe<Risk_Treatment_Type_Enum>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  Tier: Scalars['Int']['input'];
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateEnterpriseRiskMutation = { __typename?: 'mutation_root', updateChildEnterpriseRisk?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetEnterpriseRisksByTierQueryVariables = Exact<{
  Tier: Scalars['Int']['input'];
}>;


export type GetEnterpriseRisksByTierQuery = { __typename?: 'query_root', enterprise_risk: Array<{ __typename?: 'enterprise_risk', Id: string, SequentialId: number, Title: string }> };

export type GetEnterpriseRisksFlatQueryVariables = Exact<{
  where?: Enterprise_Risk_Bool_Exp;
}>;


export type GetEnterpriseRisksFlatQuery = { __typename?: 'query_root', enterprise_risk: Array<{ __typename?: 'enterprise_risk', Id: string, SequentialId: number, Title: string, Tier: number, Treatment?: Risk_Treatment_Type_Enum | null | undefined, ParentId?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Description: string, score?: { __typename?: 'enterprise_risk_score', InherentScoreMean?: number | null | undefined, InherentScoreMedian?: Array<number> | null | undefined, InherentScoreWorstCase?: number | null | undefined, ResidualScoreMean?: number | null | undefined, ResidualScoreMedian?: Array<number> | null | undefined, ResidualScoreWorstCase?: number | null | undefined, InherentRatingMean?: number | null | undefined, InherentRatingMedian?: Array<number> | null | undefined, InherentRatingWorstCase?: number | null | undefined, ResidualRatingMean?: number | null | undefined, ResidualRatingMedian?: Array<number> | null | undefined, ResidualRatingWorstCase?: number | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InstatiateEnterpriseRiskMutationVariables = Exact<{
  EnterpriseRiskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  Entities: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InstatiateEnterpriseRiskMutation = { __typename?: 'mutation_root', instantiateChildEnterpriseRisk?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntitiesQuery = { __typename?: 'query_root', entity: Array<{ __typename?: 'entity', Id: string, Name: string, Description?: string | null | undefined, ParentId?: string | null | undefined, Weight: number, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'entity', Id: string, Name: string } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, children: Array<{ __typename?: 'entity', Id: string, Name: string }> }> };

export type GetEntityByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetEntityByIdQuery = { __typename?: 'query_root', entity_by_pk?: { __typename?: 'entity', Id: string, Name: string, Description?: string | null | undefined, ParentId?: string | null | undefined, Weight: number, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'entity', Id: string, Name: string } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined };

export type InsertEntityMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight: Scalars['numeric']['input'];
  owners: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ownerGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InsertEntityMutation = { __typename?: 'mutation_root', insertChildEntity?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateEntityMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  ParentId?: InputMaybe<Scalars['uuid']['input']>;
  Weight: Scalars['numeric']['input'];
  owners: Array<Scalars['String']['input']> | Scalars['String']['input'];
  ownerGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateEntityMutation = { __typename?: 'mutation_root', updateChildEntity?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DeleteEntityMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteEntityMutation = { __typename?: 'mutation_root', deleteChildEntity?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type FilePartsFragment = { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string };

export type DeleteRelationFileByIdMutationVariables = Exact<{
  parentIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  fileIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteRelationFileByIdMutation = { __typename?: 'mutation_root', delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined };

export type GetFileAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetFileAuditByIdQuery = { __typename?: 'query_root', file_audit: Array<{ __typename?: 'file_audit', Id: string, FileName: string, FileSize: number, Meta?: any | null | undefined, ContentType: string, CreatedByUser?: string | null | undefined, CreatedAtTimestamp: string, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string }> };

export type GetFileByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetFileByIdQuery = { __typename?: 'query_root', file_by_pk?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined };

export type FormConfigurationPartsFragment = { __typename?: 'form_configuration', ParentType: Parent_Type_Enum, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, customAttributeSchema?: { __typename?: 'custom_attribute_schema', UiSchema: any, Schema: any, Id: string } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, fields_config: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }> };

export type GetFormConfigurationQueryVariables = Exact<{
  where?: Form_Configuration_Bool_Exp;
}>;


export type GetFormConfigurationQuery = { __typename?: 'query_root', form_configuration: Array<{ __typename?: 'form_configuration', ParentType: Parent_Type_Enum, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, customAttributeSchema?: { __typename?: 'custom_attribute_schema', UiSchema: any, Schema: any, Id: string } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, fields_config: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }> }> };

export type GetFormConfigurationAuditQueryVariables = Exact<{
  parentType: Scalars['String']['input'];
}>;


export type GetFormConfigurationAuditQuery = { __typename?: 'query_root', form_configuration_audit: Array<{ __typename?: 'form_configuration_audit', ParentType: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string, CustomAttributeSchemaId?: string | null | undefined }> };

export type GetFormConfigurationByParentTypeQueryVariables = Exact<{
  parentTypes: Array<Parent_Type_Enum> | Parent_Type_Enum;
}>;


export type GetFormConfigurationByParentTypeQuery = { __typename?: 'query_root', form_configuration: Array<{ __typename?: 'form_configuration', ParentType: Parent_Type_Enum, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, customAttributeSchema?: { __typename?: 'custom_attribute_schema', UiSchema: any, Schema: any, Id: string } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, fields_config: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }> }> };

export type DeleteFormFieldMutationVariables = Exact<{
  object: DeleteFormFieldInput;
}>;


export type DeleteFormFieldMutation = { __typename?: 'mutation_root', deleteFormField?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type InsertFormFieldMutationVariables = Exact<{
  object: InsertFormFieldInput;
}>;


export type InsertFormFieldMutation = { __typename?: 'mutation_root', insertFormField?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateFormFieldMutationVariables = Exact<{
  object: UpdateFormFieldInput;
}>;


export type UpdateFormFieldMutation = { __typename?: 'mutation_root', updateFormField?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type GetAllFormsCustomisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFormsCustomisationQuery = { __typename?: 'query_root', form_configuration: Array<{ __typename?: 'form_configuration', ParentType: Parent_Type_Enum, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, customAttributeSchema?: { __typename?: 'custom_attribute_schema', UiSchema: any, Schema: any, Id: string } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, fields_config: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }> }>, form_field_configuration: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined }>, form_field_ordering: Array<{ __typename?: 'form_field_ordering', FieldId: string, Position: number, FormConfigurationParentType: Parent_Type_Enum }> };

export type GetFormCustomisationQueryVariables = Exact<{
  parentTypes: Array<Parent_Type_Enum> | Parent_Type_Enum;
}>;


export type GetFormCustomisationQuery = { __typename?: 'query_root', form_configuration: Array<{ __typename?: 'form_configuration', ParentType: Parent_Type_Enum, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, customAttributeSchema?: { __typename?: 'custom_attribute_schema', UiSchema: any, Schema: any, Id: string } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, fields_config: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }> }>, form_field_configuration: Array<{ __typename?: 'form_field_configuration', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, FormConfigurationParentType: Parent_Type_Enum, Label?: string | null | undefined, Description?: string | null | undefined, Conditions?: any | null | undefined }>, form_field_ordering: Array<{ __typename?: 'form_field_ordering', FieldId: string, Position: number, FormConfigurationParentType: Parent_Type_Enum }> };

export type GetFormFieldConfigurationAuditByParentTypeQueryVariables = Exact<{
  parentType: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
}>;


export type GetFormFieldConfigurationAuditByParentTypeQuery = { __typename?: 'query_root', form_field_configuration_audit: Array<{ __typename?: 'form_field_configuration_audit', FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, FormConfigurationParentType: string }> };

export type GetFormFieldOptionsByParentTypeQueryVariables = Exact<{
  parentTypes: Array<Parent_Type_Enum> | Parent_Type_Enum;
}>;


export type GetFormFieldOptionsByParentTypeQuery = { __typename?: 'query_root', form_field_configuration: Array<{ __typename?: 'form_field_configuration', FormConfigurationParentType: Parent_Type_Enum, FieldId: string, Hidden: boolean, Required: boolean, ReadOnly: boolean, DefaultValue?: string | null | undefined, Label?: string | null | undefined, Description?: string | null | undefined }> };

export type GetFormFieldOrderingAuditByIdQueryVariables = Exact<{
  parentType: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
}>;


export type GetFormFieldOrderingAuditByIdQuery = { __typename?: 'query_root', form_field_ordering_audit: Array<{ __typename?: 'form_field_ordering_audit', FieldId: string, Position: number, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string }> };

export type InsertFormFieldPositionsMutationVariables = Exact<{
  parentType: Parent_Type_Enum;
  fieldConfig: Array<Form_Field_Ordering_Insert_Input> | Form_Field_Ordering_Insert_Input;
  fieldIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InsertFormFieldPositionsMutation = { __typename?: 'mutation_root', insert_form_configuration_one?: { __typename?: 'form_configuration', CreatedAtTimestamp: string } | null | undefined, delete_form_field_ordering?: { __typename?: 'form_field_ordering_mutation_response', affected_rows: number } | null | undefined };

export type UpdateFormFieldPositionsMutationVariables = Exact<{
  parentType: Parent_Type_Enum;
  fieldConfig: Array<Form_Field_Ordering_Insert_Input> | Form_Field_Ordering_Insert_Input;
  fieldIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateFormFieldPositionsMutation = { __typename?: 'mutation_root', update_form_configuration?: { __typename?: 'form_configuration_mutation_response', affected_rows: number } | null | undefined, insert_form_field_ordering?: { __typename?: 'form_field_ordering_mutation_response', returning: Array<{ __typename?: 'form_field_ordering', FieldId: string }> } | null | undefined, delete_form_field_ordering?: { __typename?: 'form_field_ordering_mutation_response', affected_rows: number } | null | undefined };

export type GetOwnersAndContributorsQueryVariables = Exact<{
  parentId: Scalars['uuid']['input'];
}>;


export type GetOwnersAndContributorsQuery = { __typename?: 'query_root', ancestor_contributor: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined, UserGroupId?: string | null | undefined, ContributorType?: string | null | undefined }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined, Status?: string | null | undefined, RoleKey?: string | null | undefined, Email?: string | null | undefined, Department?: string | null | undefined, JobTitle?: string | null | undefined, OfficeLocation?: string | null | undefined, LastSeen?: string | null | undefined, IsCustomerSupport?: boolean | null | undefined }> };

export type DeleteImpactRatingMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteImpactRatingMutation = { __typename?: 'mutation_root', delete_impact_rating?: { __typename?: 'impact_rating_mutation_response', affected_rows: number } | null | undefined };

export type DeleteImpactRatingsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteImpactRatingsMutation = { __typename?: 'mutation_root', delete_impact_rating?: { __typename?: 'impact_rating_mutation_response', affected_rows: number } | null | undefined };

export type GetImpactRatingAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImpactRatingAuditByIdQuery = { __typename?: 'query_root', impact_rating_audit: Array<{ __typename?: 'impact_rating_audit', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined }> };

export type GetImpactRatingByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImpactRatingByIdQuery = { __typename?: 'query_root', impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetInternalAuditImpactRatingByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetInternalAuditImpactRatingByIdQuery = { __typename?: 'query_root', impact_internal_audit_rating: Array<{ __typename?: 'impact_internal_audit_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetSecondLineImpactRatingByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSecondLineImpactRatingByIdQuery = { __typename?: 'query_root', impact_second_line_rating: Array<{ __typename?: 'impact_second_line_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetImpactRatingCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactRatingCountQuery = { __typename?: 'query_root', impact_rating_aggregate: { __typename?: 'impact_rating_aggregate', aggregate?: { __typename?: 'impact_rating_aggregate_fields', count: number } | null | undefined } };

export type GetImpactRatingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactRatingsQuery = { __typename?: 'query_root', impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Id: string, Name: string }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }> };

export type GetImpactRatingsByImpactIdQueryVariables = Exact<{
  impactId: Scalars['uuid']['input'];
}>;


export type GetImpactRatingsByImpactIdQuery = { __typename?: 'query_root', impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Name: string, Rationale?: string | null | undefined }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }> };

export type GetImpactRatingsByRatedItemIdQueryVariables = Exact<{
  ratedItemId: Scalars['uuid']['input'];
}>;


export type GetImpactRatingsByRatedItemIdQuery = { __typename?: 'query_root', impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Name: string, Rationale?: string | null | undefined }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }> };

export type GetImpactRatingsWithAppetitesQueryVariables = Exact<{
  today: Scalars['timestamptz']['input'];
}>;


export type GetImpactRatingsWithAppetitesQuery = { __typename?: 'query_root', impact_rating: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Id: string, Name: string }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string, likelihoodAppetite: Array<{ __typename?: 'appetite_parent', appetite?: { __typename?: 'appetite', LikelihoodAppetite?: number | null | undefined, EffectiveDate?: string | null | undefined } | null | undefined }>, impactAppetites: Array<{ __typename?: 'appetite_parent', appetite?: { __typename?: 'appetite', ImpactId?: string | null | undefined, ImpactAppetite?: number | null | undefined, EffectiveDate?: string | null | undefined } | null | undefined }> } | null | undefined } }> };

export type GetLatestImpactRatingsForRatedImpactsByRatedItemIdQueryVariables = Exact<{
  RatedItemId: Scalars['uuid']['input'];
}>;


export type GetLatestImpactRatingsForRatedImpactsByRatedItemIdQuery = { __typename?: 'query_root', impact: Array<{ __typename?: 'impact', Name: string, Rationale?: string | null | undefined, ratings: Array<{ __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> }> };

export type ImpactRatingPartsFragment = { __typename?: 'impact_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined };

export type ImpactInternalAuditRatingPartsFragment = { __typename?: 'impact_internal_audit_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined };

export type ImpactSecondLineRatingPartsFragment = { __typename?: 'impact_second_line_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined };

export type InsertChildImpactRatingsMutationVariables = Exact<{
  Ratings: Array<InsertImpactRatingPairInput> | InsertImpactRatingPairInput;
  TestDate: Scalars['timestamptz']['input'];
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  RatedItemId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertChildImpactRatingsMutation = { __typename?: 'mutation_root', insertChildImpactRating?: { __typename?: 'insertChildImpactRatingOutput', Ids: Array<string> } | null | undefined };

export type DeleteImpactMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteImpactMutation = { __typename?: 'mutation_root', delete_impact_rating?: { __typename?: 'impact_rating_mutation_response', affected_rows: number } | null | undefined, delete_impact?: { __typename?: 'impact_mutation_response', affected_rows: number } | null | undefined };

export type GetImpactAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImpactAuditByIdQuery = { __typename?: 'query_root', impact_audit: Array<{ __typename?: 'impact_audit', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined }> };

export type GetImpactByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImpactByIdQuery = { __typename?: 'query_root', impact: Array<{ __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetImpactCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactCountQuery = { __typename?: 'query_root', impact_aggregate: { __typename?: 'impact_aggregate', aggregate?: { __typename?: 'impact_aggregate_fields', count: number } | null | undefined } };

export type GetImpactListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactListQuery = { __typename?: 'query_root', impact: Array<{ __typename?: 'impact', Id: string, SequentialId: number, Name: string, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined }> };

export type GetImpactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactsQuery = { __typename?: 'query_root', impact: Array<{ __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ratings: Array<{ __typename?: 'impact_rating', Rating: number, RatedItemId: string, ratedItem: { __typename?: 'node', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined } }>, appetites: Array<{ __typename?: 'appetite', ImpactId?: string | null | undefined, Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> }> };

export type ImpactPartsFragment = { __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined };

export type InsertImpactMutationVariables = Exact<{
  object: InsertImpactInput;
}>;


export type InsertImpactMutation = { __typename?: 'mutation_root', insertImpactApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateImpactMutationVariables = Exact<{
  object: UpdateImpactInput;
}>;


export type UpdateImpactMutation = { __typename?: 'mutation_root', updateImpactApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DeleteIndicatorResultsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteIndicatorResultsMutation = { __typename?: 'mutation_root', delete_indicator_result?: { __typename?: 'indicator_result_mutation_response', affected_rows: number } | null | undefined };

export type GetIndicatorResultAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetIndicatorResultAuditByIdQuery = { __typename?: 'query_root', indicator_result_audit: Array<{ __typename?: 'indicator_result_audit', Description?: string | null | undefined, Id: string, ResultDate: string, TargetValueNum?: number | null | undefined, TargetValueTxt?: string | null | undefined, CustomAttributeData?: any | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string, CreatedByUser: string, CreatedAtTimestamp: string }> };

export type GetIndicatorResultByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetIndicatorResultByIdQuery = { __typename?: 'query_root', indicator_result: Array<{ __typename?: 'indicator_result', Description?: string | null | undefined, Id: string, ResultDate: string, TargetValueNum?: number | null | undefined, TargetValueTxt?: string | null | undefined, CustomAttributeData?: any | null | undefined, modifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'indicator', Type: Indicator_Type_Enum } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetIndicatorResultsByIndicatorIdQueryVariables = Exact<{
  indicatorId: Scalars['uuid']['input'];
}>;


export type GetIndicatorResultsByIndicatorIdQuery = { __typename?: 'query_root', indicator_result: Array<{ __typename?: 'indicator_result', Description?: string | null | undefined, Id: string, ResultDate: string, TargetValueNum?: number | null | undefined, TargetValueTxt?: string | null | undefined, CustomAttributeData?: any | null | undefined, modifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'indicator', Type: Indicator_Type_Enum } | null | undefined }> };

export type InsertIndicatorResultMutationVariables = Exact<{
  Description?: InputMaybe<Scalars['String']['input']>;
  IndicatorId: Scalars['uuid']['input'];
  ResultDate: Scalars['timestamptz']['input'];
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertIndicatorResultMutation = { __typename?: 'mutation_root', insert_indicator_result_one?: { __typename?: 'indicator_result', Id: string } | null | undefined };

export type UpdateIndicatorResultMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  ResultDate: Scalars['timestamptz']['input'];
  TargetValueNum?: InputMaybe<Scalars['numeric']['input']>;
  TargetValueTxt?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateIndicatorResultMutation = { __typename?: 'mutation_root', update_indicator_result?: { __typename?: 'indicator_result_mutation_response', returning: Array<{ __typename?: 'indicator_result', Id: string }> } | null | undefined };

export type DeleteIndicatorsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteIndicatorsMutation = { __typename?: 'mutation_root', delete_indicator_result?: { __typename?: 'indicator_result_mutation_response', affected_rows: number } | null | undefined, delete_indicator?: { __typename?: 'indicator_mutation_response', affected_rows: number } | null | undefined };

export type GetIndicatorAuditByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetIndicatorAuditByIdQuery = { __typename?: 'query_root', indicator_audit: Array<{ __typename?: 'indicator_audit', SequentialId?: number | null | undefined, Type: string, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser?: string | null | undefined, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined }> };

export type GetIndicatorByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetIndicatorByIdQuery = { __typename?: 'query_root', indicator: Array<{ __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetIndicatorTitlesByParentIdQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetIndicatorTitlesByParentIdQuery = { __typename?: 'query_root', indicator: Array<{ __typename?: 'indicator', Title: string, Id: string }> };

export type GetIndicatorsQueryVariables = Exact<{
  where?: Indicator_Bool_Exp;
  resultsWhere?: Indicator_Result_Bool_Exp;
}>;


export type GetIndicatorsQuery = { __typename?: 'query_root', indicator: Array<{ __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined, DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, orderedResults: Array<{ __typename?: 'indicator_result', TargetValueNum?: number | null | undefined, TargetValueTxt?: string | null | undefined, ResultDate: string }>, parents: Array<{ __typename?: 'indicator_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, risk?: { __typename?: 'risk', Title: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetIndicatorsByParentIdQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetIndicatorsByParentIdQuery = { __typename?: 'query_root', indicator: Array<{ __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, orderedResults: Array<{ __typename?: 'indicator_result', TargetValueNum?: number | null | undefined, TargetValueTxt?: string | null | undefined, ResultDate: string }>, parents: Array<{ __typename?: 'indicator_parent', control?: { __typename?: 'control', Title: string } | null | undefined, risk?: { __typename?: 'risk', Title: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type IndicatorPartsFragment = { __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined };

export type InsertIndicatorMutationVariables = Exact<{
  object?: InputMaybe<InsertChildIndicatorInput>;
}>;


export type InsertIndicatorMutation = { __typename?: 'mutation_root', insertChildIndicator?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateIndicatorMutationVariables = Exact<{
  object?: InputMaybe<UpdateChildIndicatorInput>;
}>;


export type UpdateIndicatorMutation = { __typename?: 'mutation_root', updateChildIndicator?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type DeleteInternalAuditsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteInternalAuditsMutation = { __typename?: 'mutation_root', delete_internal_audit_entity?: { __typename?: 'internal_audit_entity_mutation_response', affected_rows: number } | null | undefined };

export type GetInternalAuditByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetInternalAuditByIdQuery = { __typename?: 'query_root', internal_audit_entity: Array<{ __typename?: 'internal_audit_entity', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, CustomAttributeData?: any | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, businessArea?: { __typename?: 'business_area', Title: string, SequentialId: number, Id: string } | null | undefined }> };

export type GetInternalAuditsQueryVariables = Exact<{
  where?: Internal_Audit_Entity_Bool_Exp;
}>;


export type GetInternalAuditsQuery = { __typename?: 'query_root', internal_audit_entity: Array<{ __typename?: 'internal_audit_entity', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, CustomAttributeData?: any | null | undefined, actions: Array<{ __typename?: 'action_parent', action?: { __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined } | null | undefined }>, internalAuditReports: Array<{ __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined }>, issues: Array<{ __typename?: 'issue_parent', issue?: { __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum } | null | undefined } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, businessArea?: { __typename?: 'business_area', Title: string, SequentialId: number, Id: string } | null | undefined }> };

export type GetLinkedRisksByInternalAuditIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLinkedRisksByInternalAuditIdQuery = { __typename?: 'query_root', linked_risks: Array<{ __typename?: 'linked_item', Id: string, risk?: { __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'risk', Title: string } | null | undefined, parentNode?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, appetites: Array<{ __typename?: 'appetite_parent', appetite?: { __typename?: 'appetite', LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined } | null | undefined }>, impactRatings: Array<{ __typename?: 'impact_rating', Rating: number, ImpactId: string }>, impactRatingsForTrend: Array<{ __typename?: 'impact_rating', ImpactId: string, Rating: number, TestDate: string }>, assessmentResults: Array<{ __typename?: 'assessment_result_parent', ParentId: string, riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, Likelihood?: number | null | undefined, Impact?: number | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, TestDate?: string | null | undefined } | null | undefined }>, controls_aggregate: { __typename?: 'control_parent_aggregate', aggregate?: { __typename?: 'control_parent_aggregate_fields', count: number } | null | undefined }, indicators_aggregate: { __typename?: 'indicator_parent_aggregate', aggregate?: { __typename?: 'indicator_parent_aggregate_fields', count: number } | null | undefined }, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined }> };

export type InsertInternalAuditMutationVariables = Exact<{
  Input?: InputMaybe<InsertInternalAuditInput>;
}>;


export type InsertInternalAuditMutation = { __typename?: 'mutation_root', insertInternalAudit?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type InternalAuditEntityPartsFragment = { __typename?: 'internal_audit_entity', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, CustomAttributeData?: any | null | undefined, businessArea?: { __typename?: 'business_area', Title: string, SequentialId: number, Id: string } | null | undefined };

export type UpdateInternalAuditMutationVariables = Exact<{
  Input?: InputMaybe<UpdateInternalAuditInput>;
}>;


export type UpdateInternalAuditMutation = { __typename?: 'mutation_root', updateInternalAudit?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type InternalAuditReportPartsFragment = { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined };

export type DeleteInternalAuditReportsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteInternalAuditReportsMutation = { __typename?: 'mutation_root', delete_internal_audit_report?: { __typename?: 'internal_audit_report_mutation_response', affected_rows: number } | null | undefined };

export type GetInternalAuditReportByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetInternalAuditReportByIdQuery = { __typename?: 'query_root', internal_audit_report: Array<{ __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type GetInternalAuditReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInternalAuditReportsQuery = { __typename?: 'query_root', internal_audit_report: Array<{ __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, assessedItems: Array<{ __typename?: 'internal_audit_result_parent', controlledRiskAssessmentResult?: { __typename?: 'risk_controlled_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, uncontrolledRiskAssessmentResult?: { __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, obligationAssessmentResult?: { __typename?: 'obligation_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined }> } | null | undefined, documentAssessmentResult?: { __typename?: 'document_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined }> } | null | undefined }> }> };

export type GetInternalAuditReportsByOriginatingItemIdQueryVariables = Exact<{
  OriginatingItemId: Scalars['uuid']['input'];
}>;


export type GetInternalAuditReportsByOriginatingItemIdQuery = { __typename?: 'query_root', internal_audit_report: Array<{ __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, assessedItems: Array<{ __typename?: 'internal_audit_result_parent', controlledRiskAssessmentResult?: { __typename?: 'risk_controlled_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, uncontrolledRiskAssessmentResult?: { __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined }> } | null | undefined, obligationAssessmentResult?: { __typename?: 'obligation_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined }> } | null | undefined, documentAssessmentResult?: { __typename?: 'document_internal_audit_result', Id: string, parents: Array<{ __typename?: 'internal_audit_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined }> } | null | undefined }> }> };

export type InsertInternalAuditReportMutationVariables = Exact<{
  object: InsertAssessmentInput;
}>;


export type InsertInternalAuditReportMutation = { __typename?: 'mutation_root', insertInternalAuditReportApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateInternalAuditReportMutationVariables = Exact<{
  object: UpdateAssessmentInput;
}>;


export type UpdateInternalAuditReportMutation = { __typename?: 'mutation_root', updateInternalAuditReportApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type DeleteInternalAuditResultsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteInternalAuditResultsMutation = { __typename?: 'mutation_root', delete_document_internal_audit_result?: { __typename?: 'document_internal_audit_result_mutation_response', affected_rows: number } | null | undefined, delete_obligation_internal_audit_result?: { __typename?: 'obligation_internal_audit_result_mutation_response', affected_rows: number } | null | undefined, delete_risk_controlled_internal_audit_result?: { __typename?: 'risk_controlled_internal_audit_result_mutation_response', affected_rows: number } | null | undefined, delete_risk_uncontrolled_internal_audit_result?: { __typename?: 'risk_uncontrolled_internal_audit_result_mutation_response', affected_rows: number } | null | undefined, delete_control_test_internal_audit_result?: { __typename?: 'control_test_internal_audit_result_mutation_response', affected_rows: number } | null | undefined, delete_impact_internal_audit_rating?: { __typename?: 'impact_internal_audit_rating_mutation_response', affected_rows: number } | null | undefined };

export type GetAllInternalAuditReportResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInternalAuditReportResultsQuery = { __typename?: 'query_root', document_internal_audit_result: Array<{ __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, internalAuditReports: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, documents: Array<{ __typename?: 'internal_audit_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, obligation_internal_audit_result: Array<{ __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, internalAuditReports: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, obligations: Array<{ __typename?: 'internal_audit_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_uncontrolled_internal_audit_result: Array<{ __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, internalAuditReports: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, risks: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_controlled_internal_audit_result: Array<{ __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, internalAuditReports: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, risks: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetDocumentInternalAuditResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDocumentInternalAuditResultByIdQuery = { __typename?: 'query_root', document_internal_audit_result: Array<{ __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery = { __typename?: 'query_root', document_internal_audit_result: Array<{ __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetInternalAuditReportObligationAssessmentResultsByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery = { __typename?: 'query_root', obligation_internal_audit_result: Array<{ __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetInternalAuditReportRiskAssessmentResultsByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetInternalAuditReportRiskAssessmentResultsByRiskIdQuery = { __typename?: 'query_root', risk_controlled_internal_audit_result: Array<{ __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }>, risk_uncontrolled_internal_audit_result: Array<{ __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetInternalAuditReportTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetInternalAuditReportTestResultsByControlIdQuery = { __typename?: 'query_root', control_test_internal_audit_result: Array<{ __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetInternalAuditResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetInternalAuditResultByIdQuery = { __typename?: 'query_root', internal_audit_result_parent: Array<{ __typename?: 'internal_audit_result_parent', Id: string, ParentId: string, ResultType: Parent_Type_Enum, ParentType: Parent_Type_Enum, obligationAssessmentResult?: { __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, documentAssessmentResult?: { __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, controlledRiskAssessmentResult?: { __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, uncontrolledRiskAssessmentResult?: { __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, testResult?: { __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number } | null | undefined, impactRating?: { __typename?: 'impact_internal_audit_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined } | null | undefined }> };

export type GetInternalAuditResultsByParentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetInternalAuditResultsByParentIdQuery = { __typename?: 'query_root', document_internal_audit_result: Array<{ __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, obligation_internal_audit_result: Array<{ __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, risk_controlled_internal_audit_result: Array<{ __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, risk_uncontrolled_internal_audit_result: Array<{ __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, control_test_internal_audit_result: Array<{ __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parent?: { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, impact_internal_audit_rating: Array<{ __typename?: 'impact_internal_audit_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Id: string, Name: string }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }>, issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, consequences: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Type?: Consequence_Type_Enum | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, certifiedIndividual?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, parents: Array<{ __typename?: 'issue_parent', obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }> }>, impact: Array<{ __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ratings: Array<{ __typename?: 'impact_rating', Rating: number, RatedItemId: string, ratedItem: { __typename?: 'node', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined } }>, appetites: Array<{ __typename?: 'appetite', ImpactId?: string | null | undefined, Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> }>, action: Array<{ __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, parents: Array<{ __typename?: 'action_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, risk?: { __typename?: 'risk', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, issue?: { __typename?: 'issue', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }>, updates: Array<{ __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined }>, updates_aggregate: { __typename?: 'action_update_aggregate', aggregate?: { __typename?: 'action_update_aggregate_fields', count: number } | null | undefined }, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetInternalAuditTestResultByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetInternalAuditTestResultByIdQuery = { __typename?: 'query_root', control_test_internal_audit_result: Array<{ __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetLatestInternalAuditReportDocumentAssessmentResultByDocumentIdQueryVariables = Exact<{
  DocumentId: Scalars['uuid']['input'];
}>;


export type GetLatestInternalAuditReportDocumentAssessmentResultByDocumentIdQuery = { __typename?: 'query_root', document_internal_audit_result: Array<{ __typename?: 'document_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQuery = { __typename?: 'query_root', obligation_internal_audit_result: Array<{ __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdQuery = { __typename?: 'query_root', uncontrolled: Array<{ __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }>, controlled: Array<{ __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestInternalAuditReportTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLatestInternalAuditReportTestResultsByControlIdQuery = { __typename?: 'query_root', control_test_internal_audit_result: Array<{ __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'internal_audit_result_parent', internalAuditReport?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetObligationInternalAuditResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObligationInternalAuditResultByIdQuery = { __typename?: 'query_root', obligation_internal_audit_result: Array<{ __typename?: 'obligation_internal_audit_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetRiskInternalAuditResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetRiskInternalAuditResultByIdQuery = { __typename?: 'query_root', risk_controlled_internal_audit_result: Array<{ __typename?: 'risk_controlled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_uncontrolled_internal_audit_result: Array<{ __typename?: 'risk_uncontrolled_internal_audit_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'internal_audit_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type InsertInternalAuditTestResultMutationVariables = Exact<{
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertInternalAuditTestResultMutation = { __typename?: 'mutation_root', insertChildControlTestInternalAuditResult?: { __typename?: 'insertControlTestResultOutput', Ids: Array<string> } | null | undefined };

export type InsertDocumentInternalAuditResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  DocumentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertDocumentInternalAuditResultMutation = { __typename?: 'mutation_root', insertChildDocumentInternalAuditResult?: { __typename?: 'InsertChildDocumentAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertInternalAuditImpactRatingMutationVariables = Exact<{
  Ratings: Array<InsertImpactRatingPairInput> | InsertImpactRatingPairInput;
  TestDate: Scalars['timestamptz']['input'];
  InternalAuditReportId: Scalars['uuid']['input'];
  RatedItemId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertInternalAuditImpactRatingMutation = { __typename?: 'mutation_root', insertChildImpactInternalAuditRating?: { __typename?: 'insertChildImpactRatingOutput', Ids: Array<string> } | null | undefined };

export type InsertObligationInternalAuditResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  InternalAuditReportId: Scalars['uuid']['input'];
  ObligationIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertObligationInternalAuditResultMutation = { __typename?: 'mutation_root', insertChildObligationInternalAuditResult?: { __typename?: 'InsertChildObligationAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertRiskInternalAuditResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  InternalAuditReportId: Scalars['uuid']['input'];
  RiskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertRiskInternalAuditResultMutation = { __typename?: 'mutation_root', insertChildRiskInternalAuditResult?: { __typename?: 'InsertChildRiskAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type UpdateControlTestInternalAuditResultMutationVariables = Exact<{
  object?: InputMaybe<UpdateTestResultInput>;
}>;


export type UpdateControlTestInternalAuditResultMutation = { __typename?: 'mutation_root', updateControlTestInternalAuditResultApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateDocumentInternalAuditResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateDocumentInternalAuditResultMutation = { __typename?: 'mutation_root', update_document_internal_audit_result?: { __typename?: 'document_internal_audit_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateObligationInternalAuditResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateObligationInternalAuditResultMutation = { __typename?: 'mutation_root', update_obligation_internal_audit_result?: { __typename?: 'obligation_internal_audit_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateControlledRiskInternalAuditResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateControlledRiskInternalAuditResultMutation = { __typename?: 'mutation_root', update_risk_controlled_internal_audit_result?: { __typename?: 'risk_controlled_internal_audit_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateUncontrolledRiskInternalAuditResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateUncontrolledRiskInternalAuditResultMutation = { __typename?: 'mutation_root', update_risk_uncontrolled_internal_audit_result?: { __typename?: 'risk_uncontrolled_internal_audit_result_mutation_response', affected_rows: number } | null | undefined };

export type DeleteIssuesMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteIssuesMutation = { __typename?: 'mutation_root', deleteIssuesById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetIssueAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetIssueAuditByIdQuery = { __typename?: 'query_root', issue_audit: Array<{ __typename?: 'issue_audit', RaisedAtTimestamp?: string | null | undefined, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetIssueByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetIssueByIdQuery = { __typename?: 'query_root', issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetIssuesQueryVariables = Exact<{
  where?: Issue_Bool_Exp;
}>;


export type GetIssuesQuery = { __typename?: 'query_root', issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, consequences: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Type?: Consequence_Type_Enum | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, certifiedIndividual?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, parents: Array<{ __typename?: 'issue_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string } | null | undefined, document?: { __typename?: 'document', Title: string } | null | undefined, control?: { __typename?: 'control', Title: string } | null | undefined, thirdParty?: { __typename?: 'third_party', Title: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string } | null | undefined, internalAuditEntity?: { __typename?: 'internal_audit_entity', Title: string } | null | undefined, internalAuditReport?: { __typename?: 'internal_audit_report', Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Title: string } | null | undefined, risk?: { __typename?: 'risk', Title: string } | null | undefined }>, issueUpdateSummary?: { __typename?: 'issue_update_summary', Count?: any | null | undefined, LatestTitle?: string | null | undefined, LatestDescription?: string | null | undefined, LatestCreatedAtTimestamp?: string | null | undefined } | null | undefined }> };

export type GetIssuesByParentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
  Type: Parent_Type_Enum;
}>;


export type GetIssuesByParentIdQuery = { __typename?: 'query_root', issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetOldestOpenIssueDateQueryVariables = Exact<{
  where?: InputMaybe<Issue_Bool_Exp>;
}>;


export type GetOldestOpenIssueDateQuery = { __typename?: 'query_root', issue: Array<{ __typename?: 'issue', CreatedAtTimestamp: string }> };

export type GetWidgetIssueCausesQueryVariables = Exact<{
  where: Issue_Bool_Exp;
}>;


export type GetWidgetIssueCausesQuery = { __typename?: 'query_root', issue: Array<{ __typename?: 'issue', causes: Array<{ __typename?: 'cause', Title: string }> }> };

export type GetWidgetIssuesByTypeQueryVariables = Exact<{
  where: Issue_Assessment_Bool_Exp;
}>;


export type GetWidgetIssuesByTypeQuery = { __typename?: 'query_root', issue_assessment: Array<{ __typename?: 'issue_assessment', IssueType?: string | null | undefined }> };

export type InsertChildIssueMutationVariables = Exact<{
  object: InsertIssueInput;
}>;


export type InsertChildIssueMutation = { __typename?: 'mutation_root', insertChildIssue?: { __typename?: 'InsertChildIssueOutput', Id: string, SequentialId: number } | null | undefined };

export type IssuePartsFragment = { __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum };

export type SimplifiedIssuePartsFragment = { __typename?: 'issue', Id: string, Title: string };

export type BreachedIssuesPartsFragment = { __typename?: 'issue_parent', issue?: { __typename?: 'issue', Id: string, Title: string } | null | undefined };

export type GetOpenIssueAssessmentCountQueryVariables = Exact<{
  where?: InputMaybe<Issue_Assessment_Bool_Exp>;
}>;


export type GetOpenIssueAssessmentCountQuery = { __typename?: 'query_root', issue_assessment_aggregate: { __typename?: 'issue_assessment_aggregate', aggregate?: { __typename?: 'issue_assessment_aggregate_fields', count: number } | null | undefined } };

export type UpdateIssueMutationVariables = Exact<{
  object: UpdateIssueInput;
}>;


export type UpdateIssueMutation = { __typename?: 'mutation_root', updateIssueApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetIssueAssessmentAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetIssueAssessmentAuditByIdQuery = { __typename?: 'query_root', issue_assessment_audit: Array<{ __typename?: 'issue_assessment_audit', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: string | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, Id: string, Type: string, CustomAttributeData?: any | null | undefined }> };

export type GetIssueAssessmentByParentIdQueryVariables = Exact<{
  parentIssueId: Scalars['uuid']['input'];
}>;


export type GetIssueAssessmentByParentIdQuery = { __typename?: 'query_root', issue_assessment: Array<{ __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum, policyOwner?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, certifiedIndividual?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, issue: Array<{ __typename?: 'issue', owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, issue_parent: Array<{ __typename?: 'issue_parent', IssueId: string, ParentId: string, obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, parent?: { __typename?: 'node', ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined }> };

export type InsertIssueAssessmentMutationVariables = Exact<{
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  ParentIssueId: Scalars['uuid']['input'];
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  RegulationsBreachedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  AssociatedControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  PoliciesBreachedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InsertIssueAssessmentMutation = { __typename?: 'mutation_root', insertChildIssueAssessment?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type IssueAssessmentPartsFragment = { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum };

export type UpdateIssueAssessmentMutationVariables = Exact<{
  ActualCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ThirdPartyResponsible?: InputMaybe<Scalars['String']['input']>;
  TargetCloseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  PolicyOwnerCommentary?: InputMaybe<Scalars['String']['input']>;
  CertifiedIndividual?: InputMaybe<Scalars['String']['input']>;
  IssueCausedBySystemIssue?: InputMaybe<Scalars['Boolean']['input']>;
  IssueCausedByThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  IssueType?: InputMaybe<Scalars['String']['input']>;
  PoliciesBreached?: InputMaybe<Scalars['String']['input']>;
  PolicyOwner?: InputMaybe<Scalars['String']['input']>;
  PolicyBreach?: InputMaybe<Scalars['Boolean']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  RegulatoryBreach?: InputMaybe<Scalars['Boolean']['input']>;
  RegulationsBreached?: InputMaybe<Scalars['String']['input']>;
  Reportable?: InputMaybe<Scalars['Boolean']['input']>;
  Severity?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Issue_Assessment_Status_Enum>;
  SystemResponsible?: InputMaybe<Scalars['String']['input']>;
  OriginalTimestamp: Scalars['timestamptz']['input'];
  Id: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TagTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  DepartmentTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  RegulationsBreachedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  PoliciesBreachedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  AssociatedControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateIssueAssessmentMutation = { __typename?: 'mutation_root', updateChildIssueAssessment?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type GetIssueAssessmentHistoryQueryVariables = Exact<{
  where?: InputMaybe<Issue_Assessment_Audit_Bool_Exp>;
}>;


export type GetIssueAssessmentHistoryQuery = { __typename?: 'query_root', issue_assessment_audit: Array<{ __typename?: 'issue_assessment_audit', Status?: string | null | undefined, ParentIssueId: string, ModifiedAtTimestamp: string, Action?: string | null | undefined }> };

export type DeleteIssueUpdatesMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteIssueUpdatesMutation = { __typename?: 'mutation_root', delete_file?: { __typename?: 'file_mutation_response', affected_rows: number } | null | undefined, delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined, delete_issue_update?: { __typename?: 'issue_update_mutation_response', affected_rows: number } | null | undefined };

export type GetIssueUpdateAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetIssueUpdateAuditByIdQuery = { __typename?: 'query_root', issue_update_audit: Array<{ __typename?: 'issue_update_audit', Description?: string | null | undefined, Id: string, ParentIssueId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined }> };

export type GetIssueUpdateByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetIssueUpdateByIdQuery = { __typename?: 'query_root', issue_update: Array<{ __typename?: 'issue_update', Description: string, Id: string, ParentIssueId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetIssueUpdatesByParentIssueIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetIssueUpdatesByParentIssueIdQuery = { __typename?: 'query_root', issue_update: Array<{ __typename?: 'issue_update', Description: string, Id: string, ParentIssueId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type InsertIssueUpdateMutationVariables = Exact<{
  ParentIssueId: Scalars['uuid']['input'];
  Description: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertIssueUpdateMutation = { __typename?: 'mutation_root', insert_issue_update_one?: { __typename?: 'issue_update', Id: string } | null | undefined };

export type IssueUpdatePartsFragment = { __typename?: 'issue_update', Description: string, Id: string, ParentIssueId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined };

export type UpdateIssueUpdateMutationVariables = Exact<{
  ParentIssueId: Scalars['uuid']['input'];
  Description: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateIssueUpdateMutation = { __typename?: 'mutation_root', update_issue_update?: { __typename?: 'issue_update_mutation_response', affected_rows: number } | null | undefined };

export type DeleteLinkedItemsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteLinkedItemsMutation = { __typename?: 'mutation_root', unlinkItems?: { __typename?: 'UnlinkItemsOutput', Ids?: Array<string | null | undefined> | null | undefined } | null | undefined };

export type GetLinkedItemAuditQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetLinkedItemAuditQuery = { __typename?: 'query_root', risksmart_linked_item_audit: Array<{ __typename?: 'risksmart_linked_item_audit', Id?: string | null | undefined, Source: string, Target: string, ModifiedAtTimestamp: string, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined }> };

export type GetLinkedItemRisksQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetLinkedItemRisksQuery = { __typename?: 'query_root', linked_item: Array<{ __typename?: 'linked_item', Id: string, Source: string, Target: string, target_risk?: { __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined }> };

export type GetLinkedItemsQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
  IncludeInternalAudit: Scalars['Boolean']['input'];
  IncludeCompliance: Scalars['Boolean']['input'];
}>;


export type GetLinkedItemsQuery = { __typename?: 'query_root', linked_item: Array<{ __typename?: 'linked_item', Id: string, Source: string, Target: string, RelationshipType?: string | null | undefined, target_node?: { __typename?: 'node', ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, target_control?: { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_control_group?: { __typename?: 'control_group', Description: string, Id: string, Owner: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, ModifiedByUser: string, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined } | null | undefined, target_obligation?: { __typename?: 'obligation', Adherence: string, Description: string, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: Obligation_Type_Enum, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ExternalId?: string | null | undefined, ExternalProvider?: string | null | undefined, ExternalSyncedAt?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_document?: { __typename?: 'document', Id: string, Title: string, DocumentType: string, Purpose?: string | null | undefined, ParentDocument?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_risk?: { __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EntityId: string, entity?: { __typename?: 'entity', Id: string, Name: string, ParentId?: string | null | undefined } | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_assessment_activity?: { __typename?: 'assessment_activity', Title?: string | null | undefined, Id: string, ParentId: string, Summary?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, ActivityType: Assessment_Activity_Type_Enum, CompletionDate?: string | null | undefined, AssignedUser?: string | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, IsRCSA: boolean, RiskId?: string | null | undefined, parentInternalAuditReport?: { __typename?: 'internal_audit_report', Id: string } | null | undefined, parentAssessment?: { __typename?: 'assessment', Id: string } | null | undefined, parentComplianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined, target_assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined, target_internal_audit_report?: { __typename?: 'internal_audit_report', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined, target_internal_audit_entity?: { __typename?: 'internal_audit_entity', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, CustomAttributeData?: any | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, businessArea?: { __typename?: 'business_area', Title: string, SequentialId: number, Id: string } | null | undefined } | null | undefined, target_impact?: { __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined, target_obligation_impact?: { __typename?: 'obligation_impact', Id: string, Description: string, ParentObligationId: string } | null | undefined, target_impact_rating?: { __typename?: 'impact_rating', Id: string, impact: { __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } } | null | undefined, target_action?: { __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined, target_indicator?: { __typename?: 'indicator', SequentialId?: number | null | undefined, Type: Indicator_Type_Enum, UpperToleranceNum?: number | null | undefined, Unit?: string | null | undefined, Title: string, TargetValueTxt?: string | null | undefined, LowerToleranceNum?: number | null | undefined, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, LowerAppetiteNum?: number | null | undefined, UpperAppetiteNum?: number | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, target_acceptance?: { __typename?: 'acceptance', DateAcceptedFrom: string, DateAcceptedTo: string, Details?: string | null | undefined, Id: string, Status: Acceptance_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ApprovedByUser?: string | null | undefined, ApprovedByUserGroup?: string | null | undefined, RequestedByUser?: string | null | undefined, RequestedByUserGroup?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined } | null | undefined, target_appetite?: { __typename?: 'appetite', Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, ImpactId?: string | null | undefined } | null | undefined, target_issue?: { __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined, target_consequence?: { __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Criticality?: number | null | undefined, Description?: string | null | undefined, Id: string, ParentIssueId: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, Type?: Consequence_Type_Enum | null | undefined } | null | undefined, target_cause?: { __typename?: 'cause', ModifiedByUser: string, CreatedByUser?: string | null | undefined, Title: string, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Significance?: number | null | undefined, ParentIssueId: string, Id: string, Description?: string | null | undefined, CustomAttributeData?: any | null | undefined } | null | undefined, target_test_result?: { __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number } | null | undefined, target_action_update?: { __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined } | null | undefined, target_issue_update?: { __typename?: 'issue_update', Description: string, Id: string, ParentIssueId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, issue?: { __typename?: 'issue', Type: Parent_Type_Enum } | null | undefined } | null | undefined, target_third_party?: { __typename?: 'third_party', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CompanyName?: string | null | undefined, CompaniesHouseNumber?: string | null | undefined, Address?: string | null | undefined, CityTown?: string | null | undefined, Postcode?: string | null | undefined, Country?: string | null | undefined, PrimaryContactName?: string | null | undefined, ContactName?: string | null | undefined, ContactEmail?: string | null | undefined, CompanyDomain?: string | null | undefined, Type: string, Status: string, Criticality?: number | null | undefined, CreatedByUser: string, CustomAttributeData?: any | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> } | null | undefined }> };

export type LinkItemsMutationVariables = Exact<{
  Source: Scalars['uuid']['input'];
  Targets: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type LinkItemsMutation = { __typename?: 'mutation_root', linkItems?: { __typename?: 'LinkItemsOutput', Links: Array<{ __typename?: 'LinkItemRecordOutput', Source: string, Target: string, RelationshipType: string }> } | null | undefined };

export type GetModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesQuery = { __typename?: 'query_root', organisation_module: Array<{ __typename?: 'organisation_module', ModuleSettings: any }> };

export type UpdateModulesMutationVariables = Exact<{
  ModuleSettings: Scalars['jsonb']['input'];
}>;


export type UpdateModulesMutation = { __typename?: 'mutation_root', insert_organisation_module?: { __typename?: 'organisation_module_mutation_response', affected_rows: number } | null | undefined };

export type GetMyDueItemsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  date: Scalars['timestamptz']['input'];
  riskFilterConditions: Risk_Bool_Exp;
  actionFilterConditions: Action_Bool_Exp;
  assessmentFilterConditions: Assessment_Bool_Exp;
  controlFilterConditions: Control_Bool_Exp;
  issueFilterConditions: Issue_Bool_Exp;
  assessmentActivityFilterConditions: Assessment_Activity_Bool_Exp;
  documentFilterConditions: Document_Bool_Exp;
  obligationFilterConditions: Obligation_Bool_Exp;
}>;


export type GetMyDueItemsQuery = { __typename?: 'query_root', change_request: Array<{ __typename?: 'change_request', ChangeRequestStatus: Approval_Status_Enum, CreatedAtTimestamp: string, Id: string, responses: Array<{ __typename?: 'approver_response', Approved?: boolean | null | undefined, approver: { __typename?: 'approver', OwnerApprover?: boolean | null | undefined, level?: { __typename?: 'approval_level', Id: string, ApprovalRuleType: Approval_Rule_Type_Enum } | null | undefined, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined, user?: { __typename?: 'user', Id?: string | null | undefined } | null | undefined } }>, parent?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, documentFile?: { __typename?: 'document_file', Version: string, parent?: { __typename?: 'document', Id: string, Title: string } | null | undefined } | null | undefined, action?: { __typename?: 'action', Id: string, Title: string } | null | undefined, issue_assessment?: { __typename?: 'issue_assessment', parent?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, acceptance?: { __typename?: 'acceptance', Id: string, Title: string } | null | undefined, control?: { __typename?: 'control', Id: string, Title: string } | null | undefined, issue?: { __typename?: 'issue', Id: string, Title: string } | null | undefined } | null | undefined, currentUserOwnerList: Array<{ __typename?: 'ancestor_contributor', UserId?: string | null | undefined }> }>, risk: Array<{ __typename?: 'risk', Id: string, Title: string, scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, action: Array<{ __typename?: 'action', Id: string, DateDue: string, Title: string, Status: Action_Status_Enum, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, assessment: Array<{ __typename?: 'assessment', Id: string, Title: string, TargetCompletionDate?: string | null | undefined, Status: Assessment_Status_Enum, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, control: Array<{ __typename?: 'control', Id: string, Title: string, scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, issue: Array<{ __typename?: 'issue', Id: string, Title: string, assessment?: { __typename?: 'issue_assessment', TargetCloseDate?: string | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, assessment_activity: Array<{ __typename?: 'assessment_activity', Id: string, Title?: string | null | undefined, RiskId?: string | null | undefined, Status?: Assessment_Activity_Status_Enum | null | undefined, parentRisk?: { __typename?: 'risk', scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined } | null | undefined } | null | undefined }>, attestation_record: Array<{ __typename?: 'attestation_record', ExpiresAt?: string | null | undefined, AttestationStatus: Attestation_Record_Status_Enum, node: { __typename?: 'node', documentFile?: { __typename?: 'document_file', parent?: { __typename?: 'document', Id: string, Title: string } | null | undefined } | null | undefined } }>, document: Array<{ __typename?: 'document', Id: string, Title: string, scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }>, obligation: Array<{ __typename?: 'obligation', Id: string, Title: string, scheduleState?: { __typename?: 'schedule_state', DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }> }> };

export type GetMyItemsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetMyItemsQuery = { __typename?: 'query_root', obligation: Array<{ __typename?: 'obligation', Id: string, Title: string, Description: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, risk: Array<{ __typename?: 'risk', Id: string, Title: string, Description?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, action: Array<{ __typename?: 'action', Id: string, Title: string, Description?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, control: Array<{ __typename?: 'control', Id: string, Title: string, Description?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, indicator: Array<{ __typename?: 'indicator', Id: string, Title: string, Description?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, issue: Array<{ __typename?: 'issue', Id: string, Title: string, Details?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, document: Array<{ __typename?: 'document', Id: string, Title: string, Purpose?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }>, assessment: Array<{ __typename?: 'assessment', Id: string, Title: string, Summary?: string | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetAcceptanceCountQueryVariables = Exact<{
  where?: Acceptance_Bool_Exp;
}>;


export type GetAcceptanceCountQuery = { __typename?: 'query_root', acceptance_aggregate: { __typename?: 'acceptance_aggregate', aggregate?: { __typename?: 'acceptance_aggregate_fields', count: number } | null | undefined } };

export type GetAppetiteCountQueryVariables = Exact<{
  where?: Risk_Bool_Exp;
}>;


export type GetAppetiteCountQuery = { __typename?: 'query_root', risk_aggregate: { __typename?: 'risk_aggregate', aggregate?: { __typename?: 'risk_aggregate_fields', count: number } | null | undefined } };

export type GetAssessmentActivityCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentActivityCountQuery = { __typename?: 'query_root', assessment_activity_aggregate: { __typename?: 'assessment_activity_aggregate', aggregate?: { __typename?: 'assessment_activity_aggregate_fields', count: number } | null | undefined } };

export type GetAssessmentCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentCountQuery = { __typename?: 'query_root', assessment_aggregate: { __typename?: 'assessment_aggregate', aggregate?: { __typename?: 'assessment_aggregate_fields', count: number } | null | undefined } };

export type GetAssessmentResultCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentResultCountQuery = { __typename?: 'query_root', risk_assessment_result_aggregate: { __typename?: 'risk_assessment_result_aggregate', aggregate?: { __typename?: 'risk_assessment_result_aggregate_fields', count: number } | null | undefined }, document_assessment_result_aggregate: { __typename?: 'document_assessment_result_aggregate', aggregate?: { __typename?: 'document_assessment_result_aggregate_fields', count: number } | null | undefined }, obligation_assessment_result_aggregate: { __typename?: 'obligation_assessment_result_aggregate', aggregate?: { __typename?: 'obligation_assessment_result_aggregate_fields', count: number } | null | undefined } };

export type GetCauseCountQueryVariables = Exact<{
  where?: Cause_Bool_Exp;
}>;


export type GetCauseCountQuery = { __typename?: 'query_root', cause_aggregate: { __typename?: 'cause_aggregate', aggregate?: { __typename?: 'cause_aggregate_fields', count: number } | null | undefined } };

export type GetComplianceMonitoringAssessmentCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComplianceMonitoringAssessmentCountQuery = { __typename?: 'query_root', compliance_monitoring_assessment_aggregate: { __typename?: 'compliance_monitoring_assessment_aggregate', aggregate?: { __typename?: 'compliance_monitoring_assessment_aggregate_fields', count: number } | null | undefined } };

export type GetComplianceMonitoringAssessmentResultCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComplianceMonitoringAssessmentResultCountQuery = { __typename?: 'query_root', risk_controlled_second_line_result_aggregate: { __typename?: 'risk_controlled_second_line_result_aggregate', aggregate?: { __typename?: 'risk_controlled_second_line_result_aggregate_fields', count: number } | null | undefined }, risk_uncontrolled_second_line_result_aggregate: { __typename?: 'risk_uncontrolled_second_line_result_aggregate', aggregate?: { __typename?: 'risk_uncontrolled_second_line_result_aggregate_fields', count: number } | null | undefined }, document_second_line_result_aggregate: { __typename?: 'document_second_line_result_aggregate', aggregate?: { __typename?: 'document_second_line_result_aggregate_fields', count: number } | null | undefined }, obligation_second_line_result_aggregate: { __typename?: 'obligation_second_line_result_aggregate', aggregate?: { __typename?: 'obligation_second_line_result_aggregate_fields', count: number } | null | undefined } };

export type GetConsequenceCountQueryVariables = Exact<{
  where?: Consequence_Bool_Exp;
}>;


export type GetConsequenceCountQuery = { __typename?: 'query_root', consequence_aggregate: { __typename?: 'consequence_aggregate', aggregate?: { __typename?: 'consequence_aggregate_fields', count: number } | null | undefined } };

export type GetControlCountQueryVariables = Exact<{
  where?: Control_Bool_Exp;
}>;


export type GetControlCountQuery = { __typename?: 'query_root', control_aggregate: { __typename?: 'control_aggregate', aggregate?: { __typename?: 'control_aggregate_fields', count: number } | null | undefined } };

export type GetControlGroupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlGroupCountQuery = { __typename?: 'query_root', control_group_aggregate: { __typename?: 'control_group_aggregate', aggregate?: { __typename?: 'control_group_aggregate_fields', count: number } | null | undefined } };

export type GetInternalAuditReportCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInternalAuditReportCountQuery = { __typename?: 'query_root', internal_audit_report_aggregate: { __typename?: 'internal_audit_report_aggregate', aggregate?: { __typename?: 'internal_audit_report_aggregate_fields', count: number } | null | undefined } };

export type GetInternalAuditReportResultCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInternalAuditReportResultCountQuery = { __typename?: 'query_root', risk_controlled_internal_audit_result_aggregate: { __typename?: 'risk_controlled_internal_audit_result_aggregate', aggregate?: { __typename?: 'risk_controlled_internal_audit_result_aggregate_fields', count: number } | null | undefined }, risk_uncontrolled_internal_audit_result_aggregate: { __typename?: 'risk_uncontrolled_internal_audit_result_aggregate', aggregate?: { __typename?: 'risk_uncontrolled_internal_audit_result_aggregate_fields', count: number } | null | undefined }, document_internal_audit_result_aggregate: { __typename?: 'document_internal_audit_result_aggregate', aggregate?: { __typename?: 'document_internal_audit_result_aggregate_fields', count: number } | null | undefined }, obligation_internal_audit_result_aggregate: { __typename?: 'obligation_internal_audit_result_aggregate', aggregate?: { __typename?: 'obligation_internal_audit_result_aggregate_fields', count: number } | null | undefined } };

export type GetIssueCountQueryVariables = Exact<{
  where?: Issue_Bool_Exp;
}>;


export type GetIssueCountQuery = { __typename?: 'query_root', issue_aggregate: { __typename?: 'issue_aggregate', aggregate?: { __typename?: 'issue_aggregate_fields', count: number } | null | undefined } };

export type GetRiskCountQueryVariables = Exact<{
  where?: Risk_Bool_Exp;
}>;


export type GetRiskCountQuery = { __typename?: 'query_root', risk_aggregate: { __typename?: 'risk_aggregate', aggregate?: { __typename?: 'risk_aggregate_fields', count: number } | null | undefined } };

export type GetTestResultCountQueryVariables = Exact<{
  where?: Test_Result_Bool_Exp;
}>;


export type GetTestResultCountQuery = { __typename?: 'query_root', test_result_aggregate: { __typename?: 'test_result_aggregate', aggregate?: { __typename?: 'test_result_aggregate_fields', count: number } | null | undefined } };

export type GetObjectTypeByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObjectTypeByIdQuery = { __typename?: 'query_root', node?: { __typename?: 'node', ObjectType: Parent_Type_Enum } | null | undefined };

export type DisconnectSlackMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectSlackMutation = { __typename?: 'mutation_root', disconnectSlack: { __typename?: 'DisconnectSlackOutput', message: string } };

export type GetNotificationListDetailsQueryVariables = Exact<{
  issueIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  actionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  riskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  controlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  documentFileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  documentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  indicatorIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetNotificationListDetailsQuery = { __typename?: 'query_root', action: Array<{ __typename?: 'action', Id: string, SequentialId?: number | null | undefined, Title: string }>, issue: Array<{ __typename?: 'issue', Id: string, SequentialId?: number | null | undefined, Title: string }>, risk: Array<{ __typename?: 'risk', Id: string, SequentialId?: number | null | undefined, Title: string }>, control: Array<{ __typename?: 'control', Id: string, SequentialId?: number | null | undefined, Title: string }>, document_file: Array<{ __typename?: 'document_file', Id: string, ParentDocumentId: string }>, document: Array<{ __typename?: 'document', Id: string, SequentialId?: number | null | undefined, Title: string }>, indicator: Array<{ __typename?: 'indicator', Id: string, SequentialId?: number | null | undefined, Title: string }> };

export type GetNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationPreferencesQuery = { __typename?: 'query_root', notificationPreferences: { __typename?: 'NotificationPreferencesOutput', categories?: any | null | undefined, channel_types?: any | null | undefined, id: string, workflows?: any | null | undefined }, slackNotificationConnection: { __typename?: 'SlackNotificationConnectionOutput', connected: boolean } };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  preferenceSet: UpdateNotificationPreferencesInput;
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'mutation_root', updateNotificationPreferences: { __typename?: 'UpdateNotificationPreferencesOutput', message: string } };

export type DeleteObligationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteObligationMutation = { __typename?: 'mutation_root', delete_obligation_impact?: { __typename?: 'obligation_impact_mutation_response', affected_rows: number } | null | undefined, delete_obligation?: { __typename?: 'obligation_mutation_response', affected_rows: number } | null | undefined };

export type GetObligationAuditByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObligationAuditByIdQuery = { __typename?: 'query_root', obligation_audit: Array<{ __typename?: 'obligation_audit', Adherence?: string | null | undefined, Description?: string | null | undefined, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser?: string | null | undefined }> };

export type GetObligationByIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetObligationByIdQuery = { __typename?: 'query_root', obligation: Array<{ __typename?: 'obligation', Adherence: string, Description: string, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: Obligation_Type_Enum, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ExternalId?: string | null | undefined, ExternalProvider?: string | null | undefined, ExternalSyncedAt?: string | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined } | null | undefined, CreatedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, ModifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, Parent?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, parentNode?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetObligationListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetObligationListQuery = { __typename?: 'query_root', obligation: Array<{ __typename?: 'obligation', Id: string, Title: string, SequentialId?: number | null | undefined }>, node: Array<{ __typename?: 'node', Id: string, SequentialId?: number | null | undefined }> };

export type GetObligationsQueryVariables = Exact<{
  where?: Obligation_Bool_Exp;
  obligationAssessmentResultsWhere?: InputMaybe<Obligation_Assessment_Result_Bool_Exp>;
  includeAssessmentResultsHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetObligationsQuery = { __typename?: 'query_root', obligation: Array<{ __typename?: 'obligation', CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Adherence: string, Description: string, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: Obligation_Type_Enum, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, ExternalId?: string | null | undefined, ExternalProvider?: string | null | undefined, ExternalSyncedAt?: string | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined, DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, CreatedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, ModifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, Parent?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, parentNode?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, controls_aggregate: { __typename?: 'control_parent_aggregate', aggregate?: { __typename?: 'control_parent_aggregate_fields', count: number } | null | undefined }, BreachedIssues: Array<{ __typename?: 'issue_parent', issue?: { __typename?: 'issue', Id: string, Title: string } | null | undefined }>, assessmentResults?: Array<{ __typename?: 'assessment_result_parent', ParentId: string, obligationAssessmentResult?: { __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, TestDate?: string | null | undefined, CreatedAtTimestamp: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }>, assessment_result_parent: Array<{ __typename?: 'assessment_result_parent', obligationAssessmentResult?: { __typename?: 'obligation_assessment_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, parents: Array<{ __typename?: 'assessment_result_parent', ParentId: string }> } | null | undefined }> };

export type GetObligationsByTypeQueryVariables = Exact<{
  type: Obligation_Type_Enum;
}>;


export type GetObligationsByTypeQuery = { __typename?: 'query_root', obligation: Array<{ __typename?: 'obligation', Title: string, SequentialId?: number | null | undefined, Id: string }> };

export type InsertObligationMutationVariables = Exact<{
  object?: InputMaybe<InsertChildObligationInput>;
}>;


export type InsertObligationMutation = { __typename?: 'mutation_root', insertChildObligation?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type ObligationPartsFragment = { __typename?: 'obligation', Adherence: string, Description: string, Id: string, Interpretation?: string | null | undefined, ParentId?: string | null | undefined, Title: string, Type: Obligation_Type_Enum, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, ModifiedAtTimestamp: string, ModifiedByUser: string, ExternalId?: string | null | undefined, ExternalProvider?: string | null | undefined, ExternalSyncedAt?: string | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined };

export type UpdateObligationMutationVariables = Exact<{
  object?: InputMaybe<UpdateChildObligationInput>;
}>;


export type UpdateObligationMutation = { __typename?: 'mutation_root', updateChildObligation?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type GetObligationChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetObligationChangesQuery = { __typename?: 'query_root', obligation_change: Array<{ __typename?: 'obligation_change', Id: string, SequentialId: number, Title?: string | null | undefined, Description?: string | null | undefined, ObligationId?: string | null | undefined, ExternalId: string, EffectiveDate?: string | null | undefined, Regulator?: string | null | undefined, Reference?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser: string, ModifiedByUser: string, obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, createdBy?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, modifiedBy?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, attestations: Array<{ __typename?: 'obligation_change_attestation', UserId: string }>, actions: Array<{ __typename?: 'action_parent', action?: { __typename?: 'action', Id: string, Title: string, SequentialId?: number | null | undefined } | null | undefined }> }> };

export type DeleteImpactsMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteImpactsMutation = { __typename?: 'mutation_root', delete_obligation_impact?: { __typename?: 'obligation_impact_mutation_response', affected_rows: number } | null | undefined };

export type GetObligationImpactAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetObligationImpactAuditByIdQuery = { __typename?: 'query_root', obligation_impact_audit: Array<{ __typename?: 'obligation_impact_audit', Id: string, Description: string, ImpactRating: number, CustomAttributeData?: any | null | undefined, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp: string }> };

export type GetObligationImpactByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetObligationImpactByIdQuery = { __typename?: 'query_root', obligation_impact: Array<{ __typename?: 'obligation_impact', Id: string, Description: string, ImpactRating: number, CustomAttributeData?: any | null | undefined }> };

export type GetObligationImpactsByParentIdQueryVariables = Exact<{
  _eq: Scalars['uuid']['input'];
}>;


export type GetObligationImpactsByParentIdQuery = { __typename?: 'query_root', obligation_impact: Array<{ __typename?: 'obligation_impact', CreatedAtTimestamp: string, CreatedByUser: string, Description: string, Id: string, ImpactRating: number, ModifiedAtTimestamp: string, ModifiedByUser: string, ParentObligationId: string, CustomAttributeData?: any | null | undefined, parent?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, createdBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertObligationImpactMutationVariables = Exact<{
  Description: Scalars['String']['input'];
  ImpactRating: Scalars['smallint']['input'];
  ParentObligationId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertObligationImpactMutation = { __typename?: 'mutation_root', insert_obligation_impact_one?: { __typename?: 'obligation_impact', Id: string } | null | undefined };

export type UpdateObligationImpactMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  ImpactRating: Scalars['smallint']['input'];
  Description: Scalars['String']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateObligationImpactMutation = { __typename?: 'mutation_root', update_obligation_impact?: { __typename?: 'obligation_impact_mutation_response', affected_rows: number } | null | undefined };

export type GetOrganisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationQuery = { __typename?: 'query_root', auth_organisation: Array<{ __typename?: 'auth_organisation', Meta?: any | null | undefined, ScimEnabled: boolean }> };

export type UpdateOrganisationMutationVariables = Exact<{
  OrgKey?: InputMaybe<Scalars['String']['input']>;
  ScimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateOrganisationMutation = { __typename?: 'mutation_root', update_auth_organisation?: { __typename?: 'auth_organisation_mutation_response', affected_rows: number } | null | undefined };

export type GetQuestionnaireInvitesQueryVariables = Exact<{
  thirdPartyId: Scalars['uuid']['input'];
}>;


export type GetQuestionnaireInvitesQuery = { __typename?: 'query_root', questionnaire_invite: Array<{ __typename?: 'questionnaire_invite', Id: string, UserEmail: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, parent: { __typename?: 'third_party_response', Id: string, Status: Third_Party_Response_Status_Enum, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined, ResponseData: any }, thirdParty: { __typename?: 'third_party', Id: string, Title: string }, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, questionnaireTemplateVersion: { __typename?: 'questionnaire_template_version', Id: string, Version: string, parent?: { __typename?: 'questionnaire_template', Title: string } | null | undefined } }> };

export type InsertQuestionnaireInvitesMutationVariables = Exact<{
  thirdPartyId: Scalars['uuid']['input'];
  users: Array<Scalars['String']['input']> | Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  questionnaires: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InsertQuestionnaireInvitesMutation = { __typename?: 'mutation_root', insertQuestionnaireInvites: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type DeleteQuestionnaireTemplateVersionsMutationVariables = Exact<{
  questionnaireTemplateVersionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteQuestionnaireTemplateVersionsMutation = { __typename?: 'mutation_root', delete_questionnaire_template_version?: { __typename?: 'questionnaire_template_version_mutation_response', affected_rows: number } | null | undefined };

export type GetLatestQuestionnaireTemplateVersionQueryVariables = Exact<{
  where?: InputMaybe<Questionnaire_Template_Version_Bool_Exp>;
}>;


export type GetLatestQuestionnaireTemplateVersionQuery = { __typename?: 'query_root', questionnaire_template_version: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, ParentId: string, Schema: any, UISchema: any, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'questionnaire_template', Id: string, Title: string } | null | undefined }> };

export type GetQuestionnaireTemplateVersionByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetQuestionnaireTemplateVersionByIdQuery = { __typename?: 'query_root', questionnaire_template_version?: { __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, ParentId: string, Schema: any, UISchema: any, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'questionnaire_template', Id: string, Title: string } | null | undefined } | null | undefined };

export type GetQuestionnaireTemplateVersionsByQuestionnaireTemplateIdQueryVariables = Exact<{
  questionnaireTemplateId: Scalars['uuid']['input'];
}>;


export type GetQuestionnaireTemplateVersionsByQuestionnaireTemplateIdQuery = { __typename?: 'query_root', questionnaire_template_version: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, ParentId: string, Schema: any, UISchema: any, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, createdByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined }> };

export type InsertQuestionnaireTemplateVersionMutationVariables = Exact<{
  object: Questionnaire_Template_Version_Insert_Input;
}>;


export type InsertQuestionnaireTemplateVersionMutation = { __typename?: 'mutation_root', insert_questionnaire_template_version_one?: { __typename?: 'questionnaire_template_version', Id: string } | null | undefined };

export type PublishQuestionnaireTemplateVersionMutationVariables = Exact<{
  questionnaireTemplateId: Scalars['uuid']['input'];
  questionnaireTemplateVersionId: Scalars['uuid']['input'];
}>;


export type PublishQuestionnaireTemplateVersionMutation = { __typename?: 'mutation_root', publishQuestionnaireTemplateVersion: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type UpdateQuestionnaireTemplateVersionMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  object: Questionnaire_Template_Version_Set_Input;
}>;


export type UpdateQuestionnaireTemplateVersionMutation = { __typename?: 'mutation_root', update_questionnaire_template_version_by_pk?: { __typename?: 'questionnaire_template_version', Id: string } | null | undefined };

export type DeleteQuestionnaireTemplateMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteQuestionnaireTemplateMutation = { __typename?: 'mutation_root', delete_questionnaire_template_version?: { __typename?: 'questionnaire_template_version_mutation_response', affected_rows: number } | null | undefined, delete_questionnaire_template_by_pk?: { __typename?: 'questionnaire_template', Id: string } | null | undefined };

export type GetQuestionnaireTemplateByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetQuestionnaireTemplateByIdQuery = { __typename?: 'query_root', questionnaire_template?: { __typename?: 'questionnaire_template', Id: string, Title: string, Description?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, draftVersions: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }>, nonDraftVersions: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }>, publishedVersion: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }> } | null | undefined };

export type GetQuestionnaireTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Questionnaire_Template_Bool_Exp>;
}>;


export type GetQuestionnaireTemplatesQuery = { __typename?: 'query_root', questionnaire_template: Array<{ __typename?: 'questionnaire_template', Id: string, Title: string, Description?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, createdByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', Id?: string | null | undefined, FriendlyName?: string | null | undefined } | null | undefined, draftVersions: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }>, nonDraftVersions: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }>, publishedVersion: Array<{ __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum }> }> };

export type InsertQuestionnaireTemplateMutationVariables = Exact<{
  object?: InputMaybe<InsertQuestionnaireTemplateInput>;
}>;


export type InsertQuestionnaireTemplateMutation = { __typename?: 'mutation_root', insertQuestionnaireTemplateApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type QuestionnaireTemplatePartsFragment = { __typename?: 'questionnaire_template', Id: string, Title: string, Description?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined };

export type UpdateQuestionnaireTemplateMutationVariables = Exact<{
  object?: InputMaybe<UpdateQuestionnaireTemplateInput>;
}>;


export type UpdateQuestionnaireTemplateMutation = { __typename?: 'mutation_root', updateQuestionnaireTemplateApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type RelationFilePartsFragment = { __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined };

export type GetReportingDataQueryVariables = Exact<{
  Input: ReportingDataInput;
}>;


export type GetReportingDataQuery = { __typename?: 'query_root', reportingData?: Array<Array<{ __typename?: 'ReportField', value?: any | null | undefined, meta?: any | null | undefined }>> | null | undefined };

export type GetReportingFilterOptionsQueryVariables = Exact<{
  Input: ReportingFilterOptionsInput;
}>;


export type GetReportingFilterOptionsQuery = { __typename?: 'query_root', reportingFilterOptions: Array<{ __typename?: 'ReportingFilterOption', value: string }> };

export type DeleteRiskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRiskMutation = { __typename?: 'mutation_root', deleteRiskById: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type EnterpriseRiskInstanceWithEntityHierarchyPartsFragment = { __typename?: 'enterprise_risk_instance', EntityId: string, EnterpriseRiskId?: string | null | undefined, entity?: { __typename?: 'entity', Id: string, Name: string, ParentId?: string | null | undefined } | null | undefined };

export type GetRiskAuditByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetRiskAuditByIdQuery = { __typename?: 'query_root', risk_audit: Array<{ __typename?: 'risk_audit', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: string | null | undefined, Status?: string | null | undefined, ModifiedByUser?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetRiskByIdQueryVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetRiskByIdQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined } | null | undefined, parent?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, parentNode?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, assessmentResults: Array<{ __typename?: 'assessment_result_parent', riskAssessmentResult?: { __typename?: 'risk_assessment_result', ControlType: Risk_Assessment_Result_Control_Type_Enum, Rating?: number | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EnterpriseRiskId?: string | null | undefined, EntityId: string } | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetRiskListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskListQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined }>, node: Array<{ __typename?: 'node', Id: string, SequentialId?: number | null | undefined }> };

export type GetRiskListOnlyOptimizedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskListOnlyOptimizedQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined }> };

export type GetRiskListOnlyWithEntitiesOptimizedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskListOnlyWithEntitiesOptimizedQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EntityId: string, EnterpriseRiskId?: string | null | undefined, entity?: { __typename?: 'entity', Id: string, Name: string, ParentId?: string | null | undefined } | null | undefined } | null | undefined }> };

export type GetRiskListOptimizedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskListOptimizedQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined }>, node: Array<{ __typename?: 'node', Id: string, SequentialId?: number | null | undefined }> };

export type GetRiskListWithEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskListWithEntitiesQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EntityId: string, EnterpriseRiskId?: string | null | undefined, entity?: { __typename?: 'entity', Id: string, Name: string, ParentId?: string | null | undefined } | null | undefined } | null | undefined }>, node: Array<{ __typename?: 'node', Id: string, SequentialId?: number | null | undefined }> };

export type GetRiskWithOwnContributionsQueryVariables = Exact<{
  currentUserId: Scalars['String']['input'];
}>;


export type GetRiskWithOwnContributionsQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, SequentialId?: number | null | undefined, Title: string, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }> };

export type GetRisksByTierQueryVariables = Exact<{
  where: Risk_Bool_Exp;
}>;


export type GetRisksByTierQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, SequentialId?: number | null | undefined, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EnterpriseRiskId?: string | null | undefined, EntityId: string, entity?: { __typename?: 'entity', Id: string, Name: string } | null | undefined } | null | undefined }> };

export type GetRisksFlatQueryVariables = Exact<{
  where?: Risk_Bool_Exp;
  riskAssessmentResultsWhere?: Risk_Assessment_Result_Bool_Exp;
}>;


export type GetRisksFlatQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, scheduleState?: { __typename?: 'schedule_state', LatestDate?: string | null | undefined, DueDate?: string | null | undefined, OverdueDate?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'risk', Title: string } | null | undefined, parentNode?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, appetites: Array<{ __typename?: 'appetite_parent', appetite?: { __typename?: 'appetite', LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined } | null | undefined }>, impactRatings: Array<{ __typename?: 'impact_rating', ImpactId: string, Rating: number }>, impactRatingsForTrend: Array<{ __typename?: 'impact_rating', ImpactId: string, Rating: number, TestDate: string }>, assessmentResults: Array<{ __typename?: 'assessment_result_parent', ParentId: string, riskAssessmentResult?: { __typename?: 'risk_assessment_result', Id: string, Rating?: number | null | undefined, ControlType: Risk_Assessment_Result_Control_Type_Enum, Likelihood?: number | null | undefined, Impact?: number | null | undefined, CustomAttributeData?: any | null | undefined, CreatedAtTimestamp: string, TestDate?: string | null | undefined } | null | undefined }>, controls_aggregate: { __typename?: 'control_parent_aggregate', aggregate?: { __typename?: 'control_parent_aggregate_fields', count: number } | null | undefined }, indicators_aggregate: { __typename?: 'indicator_parent_aggregate', aggregate?: { __typename?: 'indicator_parent_aggregate_fields', count: number } | null | undefined }, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', entity?: { __typename?: 'entity', Id: string, Name: string } | null | undefined, enterpriseRisk?: { __typename?: 'enterprise_risk', Id: string, Title: string } | null | undefined } | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetRisksWithAncestorContributorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRisksWithAncestorContributorsQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type GetRisksWithAncestorContributorsAndEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRisksWithAncestorContributorsAndEntitiesQuery = { __typename?: 'query_root', risk: Array<{ __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, enterpriseRiskInstance?: { __typename?: 'enterprise_risk_instance', EntityId: string, EnterpriseRiskId?: string | null | undefined, entity?: { __typename?: 'entity', Id: string, Name: string, ParentId?: string | null | undefined } | null | undefined } | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined }> };

export type InsertRiskMutationVariables = Exact<{
  object?: InputMaybe<InsertChildRiskInput>;
}>;


export type InsertRiskMutation = { __typename?: 'mutation_root', insertChildRisk?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type RiskPartsFragment = { __typename?: 'risk', Id: string, Title: string, Tier: number, Description?: string | null | undefined, ParentRiskId?: string | null | undefined, CreatedByUser?: string | null | undefined, Treatment?: Risk_Treatment_Type_Enum | null | undefined, Status?: Risk_Status_Type_Enum | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined };

export type UpdateRiskMutationVariables = Exact<{
  object?: InputMaybe<UpdateChildRiskInput>;
}>;


export type UpdateRiskMutation = { __typename?: 'mutation_root', updateChildRisk: { __typename?: 'IdOutput', Id: string } };

export type GetRiskAssessmentResultConfigAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRiskAssessmentResultConfigAuditByIdQuery = { __typename?: 'query_root', risk_assessment_result_config_audit: Array<{ __typename?: 'risk_assessment_result_config_audit', Id: string, Version: number, Config: any, IsLatest: boolean, CreatedByUser: string, CreatedAtTimestamp?: string | null | undefined, ModifiedByUser: string, ModifiedAtTimestamp: string }> };

export type GetRiskAssessmentResultImpactAuditByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRiskAssessmentResultImpactAuditByIdQuery = { __typename?: 'query_root', risk_assessment_result_impact_audit: Array<{ __typename?: 'risk_assessment_result_impact_audit', Id: string, RiskAssessmentResultId: string, Label: string, Value: number, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string }> };

export type GetRoleAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleAccessQuery = { __typename?: 'query_root', role_access: Array<{ __typename?: 'role_access', AccessType: Access_Type_Enum, ContributorType: Contributor_Type_Enum, ObjectType: Parent_Type_Enum }> };

export type GetAvailableRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableRolesQuery = { __typename?: 'query_root', available_roles: Array<{ __typename?: 'RoleOutput', id: string, name: string, description: string }> };

export type GetDefaultRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultRolesQuery = { __typename?: 'query_root', auth_role_type: Array<{ __typename?: 'auth_role_type', RoleKey: string, Description?: string | null | undefined, Name: string, Category: string, resourceTypes: Array<{ __typename?: 'auth_role_type_resource_type', resourceType: { __typename?: 'auth_role_resource_type', ResourceType: Parent_Type_Enum } }> }> };

export type SchedulePartsFragment = { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined };

export type DeleteScimDomainMutationVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type DeleteScimDomainMutation = { __typename?: 'mutation_root', delete_scim_domain?: { __typename?: 'DeleteScimDomainOutput', updatedDomains: Array<{ __typename?: 'ScimDomainOutput', domain: string, createdOn: string }> } | null | undefined };

export type DeleteScimTokenMutationVariables = Exact<{
  keyId: Scalars['String']['input'];
}>;


export type DeleteScimTokenMutation = { __typename?: 'mutation_root', delete_scim_token: { __typename?: 'DeleteScimTokenOutput', keyId: string } };

export type GetScimConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScimConfigQuery = { __typename?: 'query_root', getScimConfig: { __typename?: 'GetScimConfigOutput', legacyTokens: boolean, domains: Array<{ __typename?: 'ScimDomainOutput', domain: string, createdOn: string }>, tokens: Array<{ __typename?: 'ScimTokenOutput', keyId: string, orgKey: string, token: string, createdOn: string, expiresOn: string, status: string }> } };

export type InsertScimDomainMutationVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type InsertScimDomainMutation = { __typename?: 'mutation_root', insert_scim_domain: { __typename?: 'ScimDomainOutput', domain: string, createdOn: string } };

export type InsertScimTokenMutationVariables = Exact<{
  expireInMonths: Scalars['String']['input'];
}>;


export type InsertScimTokenMutation = { __typename?: 'mutation_root', insert_scim_token: { __typename?: 'ScimTokenOutput', keyId: string, orgKey: string, token: string, createdOn: string, expiresOn: string, status: string } };

export type DeleteSecondLineResultsMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteSecondLineResultsMutation = { __typename?: 'mutation_root', delete_document_second_line_result?: { __typename?: 'document_second_line_result_mutation_response', affected_rows: number } | null | undefined, delete_obligation_second_line_result?: { __typename?: 'obligation_second_line_result_mutation_response', affected_rows: number } | null | undefined, delete_risk_controlled_second_line_result?: { __typename?: 'risk_controlled_second_line_result_mutation_response', affected_rows: number } | null | undefined, delete_risk_uncontrolled_second_line_result?: { __typename?: 'risk_uncontrolled_second_line_result_mutation_response', affected_rows: number } | null | undefined, delete_control_test_second_line_result?: { __typename?: 'control_test_second_line_result_mutation_response', affected_rows: number } | null | undefined, delete_impact_second_line_rating?: { __typename?: 'impact_second_line_rating_mutation_response', affected_rows: number } | null | undefined };

export type GetAllComplianceMonitoringAssessmentResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllComplianceMonitoringAssessmentResultsQuery = { __typename?: 'query_root', document_second_line_result: Array<{ __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, complianceMonitoringAssessments: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, documents: Array<{ __typename?: 'second_line_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, obligation_second_line_result: Array<{ __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, complianceMonitoringAssessments: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, obligations: Array<{ __typename?: 'second_line_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_controlled_second_line_result: Array<{ __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, complianceMonitoringAssessments: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, risks: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_uncontrolled_second_line_result: Array<{ __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, complianceMonitoringAssessments: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string, ActualCompletionDate?: string | null | undefined, StartDate?: string | null | undefined, Status?: Assessment_Status_Enum | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }>, risks: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetComplianceMonitoringAssessmentTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetComplianceMonitoringAssessmentTestResultsByControlIdQuery = { __typename?: 'query_root', control_test_second_line_result: Array<{ __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentIdQuery = { __typename?: 'query_root', document_second_line_result: Array<{ __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetComplianceMonitoringAssessmentObligationAssessmentResultsByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetComplianceMonitoringAssessmentObligationAssessmentResultsByObligationIdQuery = { __typename?: 'query_root', obligation_second_line_result: Array<{ __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQuery = { __typename?: 'query_root', risk_controlled_second_line_result: Array<{ __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }>, risk_uncontrolled_second_line_result: Array<{ __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetDocumentSecondLineResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetDocumentSecondLineResultByIdQuery = { __typename?: 'query_root', document_second_line_result: Array<{ __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentIdQueryVariables = Exact<{
  DocumentId: Scalars['uuid']['input'];
}>;


export type GetLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentIdQuery = { __typename?: 'query_root', document_second_line_result: Array<{ __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationIdQueryVariables = Exact<{
  ObligationId: Scalars['uuid']['input'];
}>;


export type GetLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationIdQuery = { __typename?: 'query_root', obligation_second_line_result: Array<{ __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQuery = { __typename?: 'query_root', uncontrolled: Array<{ __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }>, controlled: Array<{ __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetLatestComplianceMonitoringAssessmentTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLatestComplianceMonitoringAssessmentTestResultsByControlIdQuery = { __typename?: 'query_root', control_test_second_line_result: Array<{ __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, parents: Array<{ __typename?: 'second_line_result_parent', complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp?: string | null | undefined, CreatedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp?: string | null | undefined, ModifiedByUser?: string | null | undefined, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status?: Assessment_Status_Enum | null | undefined, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetObligationSecondLineResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetObligationSecondLineResultByIdQuery = { __typename?: 'query_root', obligation_second_line_result: Array<{ __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetRiskSecondLineResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetRiskSecondLineResultByIdQuery = { __typename?: 'query_root', risk_controlled_second_line_result: Array<{ __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, risk_uncontrolled_second_line_result: Array<{ __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, complianceMonitoringAssessment?: { __typename?: 'compliance_monitoring_assessment', Id: string, Title: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetSecondLineResultByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetSecondLineResultByIdQuery = { __typename?: 'query_root', second_line_result_parent: Array<{ __typename?: 'second_line_result_parent', Id: string, ParentId: string, ResultType: Parent_Type_Enum, ParentType: Parent_Type_Enum, obligationAssessmentResult?: { __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, documentAssessmentResult?: { __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, controlledRiskAssessmentResult?: { __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, uncontrolledRiskAssessmentResult?: { __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined } | null | undefined, testResult?: { __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number } | null | undefined, impactRating?: { __typename?: 'impact_second_line_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined } | null | undefined }> };

export type GetSecondLineResultsByParentIdQueryVariables = Exact<{
  ParentId: Scalars['uuid']['input'];
}>;


export type GetSecondLineResultsByParentIdQuery = { __typename?: 'query_root', document_second_line_result: Array<{ __typename?: 'document_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', document?: { __typename?: 'document', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, obligation_second_line_result: Array<{ __typename?: 'obligation_second_line_result', Id: string, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', obligation?: { __typename?: 'obligation', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, risk_controlled_second_line_result: Array<{ __typename?: 'risk_controlled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, risk_uncontrolled_second_line_result: Array<{ __typename?: 'risk_uncontrolled_second_line_result', Id: string, Likelihood?: number | null | undefined, Impact?: number | null | undefined, Rating?: number | null | undefined, CustomAttributeData?: any | null | undefined, Rationale?: string | null | undefined, TestDate?: string | null | undefined, parents: Array<{ __typename?: 'second_line_result_parent', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined, node?: { __typename?: 'node', Id: string, SequentialId?: number | null | undefined, ObjectType: Parent_Type_Enum } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> }>, control_test_second_line_result: Array<{ __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parent?: { __typename?: 'control', CreatedByUser?: string | null | undefined, ModifiedByUser: string, Description?: string | null | undefined, Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, Type?: Control_Type_Enum | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, schedule?: { __typename?: 'schedule', Id: string, Frequency?: Test_Frequency_Enum | null | undefined, ManualDueDate?: string | null | undefined, StartDate?: string | null | undefined, TimeToCompleteValue?: number | null | undefined, TimeToCompleteUnit?: Unit_Of_Time_Enum | null | undefined } | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }>, impact_second_line_rating: Array<{ __typename?: 'impact_second_line_rating', CreatedAtTimestamp: string, CreatedByUser: string, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, Rating: number, RatedItemId: string, ImpactId: string, TestDate: string, CompletedBy?: string | null | undefined, Likelihood?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, completedBy?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, impact: { __typename?: 'impact', Id: string, Name: string }, ratedItem: { __typename?: 'node', ObjectType: Parent_Type_Enum, risk?: { __typename?: 'risk', Title: string } | null | undefined } }>, issue: Array<{ __typename?: 'issue', RaisedAtTimestamp: string, DateIdentified: string, DateOccurred: string, Details?: string | null | undefined, Id: string, ImpactsCustomer?: boolean | null | undefined, IsExternalIssue?: boolean | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, SequentialId?: number | null | undefined, CustomAttributeData?: any | null | undefined, Meta?: any | null | undefined, Type: Parent_Type_Enum, consequences: Array<{ __typename?: 'consequence', CostType: Cost_Type_Enum, CostValue: number, Type?: Consequence_Type_Enum | null | undefined }>, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, assessment?: { __typename?: 'issue_assessment', ActualCloseDate?: string | null | undefined, CertifiedIndividual?: string | null | undefined, IssueCausedBySystemIssue?: boolean | null | undefined, IssueCausedByThirdParty?: boolean | null | undefined, IssueType?: string | null | undefined, ParentIssueId: string, PoliciesBreached?: string | null | undefined, PolicyBreach?: boolean | null | undefined, PolicyOwner?: string | null | undefined, PolicyOwnerCommentary?: string | null | undefined, Rationale?: string | null | undefined, RegulatoryBreach?: boolean | null | undefined, RegulationsBreached?: string | null | undefined, Reportable?: boolean | null | undefined, Severity?: number | null | undefined, Status?: Issue_Assessment_Status_Enum | null | undefined, SystemResponsible?: string | null | undefined, TargetCloseDate?: string | null | undefined, ThirdPartyResponsible?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, Id: string, CustomAttributeData?: any | null | undefined, Type: Parent_Type_Enum, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, certifiedIndividual?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> } | null | undefined, actions_aggregate: { __typename?: 'action_parent_aggregate', aggregate?: { __typename?: 'action_parent_aggregate_fields', count: number } | null | undefined }, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, parents: Array<{ __typename?: 'issue_parent', obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }> }>, impact: Array<{ __typename?: 'impact', CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, Rationale?: string | null | undefined, RatingGuidance?: string | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, Name: string, CustomAttributeData?: any | null | undefined, SequentialId: number, LikelihoodAppetite?: number | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ratings: Array<{ __typename?: 'impact_rating', Rating: number, RatedItemId: string, ratedItem: { __typename?: 'node', risk?: { __typename?: 'risk', Id: string, Title: string } | null | undefined } }>, appetites: Array<{ __typename?: 'appetite', ImpactId?: string | null | undefined, Id: string, LowerAppetite?: number | null | undefined, UpperAppetite?: number | null | undefined, ImpactAppetite?: number | null | undefined, LikelihoodAppetite?: number | null | undefined, Statement?: string | null | undefined, EffectiveDate?: string | null | undefined, AppetiteType: Appetite_Type_Enum, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, parents: Array<{ __typename?: 'appetite_parent', risk?: { __typename?: 'risk', Id: string } | null | undefined }> }> }>, action: Array<{ __typename?: 'action', DateDue: string, DateRaised: string, Description?: string | null | undefined, Id: string, Priority?: number | null | undefined, Status: Action_Status_Enum, ModifiedAtTimestamp: string, CreatedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, ClosedDate?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined, parents: Array<{ __typename?: 'action_parent', parent?: { __typename?: 'node', Id: string, ObjectType: Parent_Type_Enum, SequentialId?: number | null | undefined } | null | undefined, obligation?: { __typename?: 'obligation', Title: string, Id: string } | null | undefined, risk?: { __typename?: 'risk', Title: string, Id: string } | null | undefined, control?: { __typename?: 'control', Title: string, Id: string } | null | undefined, issue?: { __typename?: 'issue', Title: string, Id: string } | null | undefined, document?: { __typename?: 'document', Title: string, Id: string } | null | undefined, assessment?: { __typename?: 'assessment', Title: string, Id: string } | null | undefined }>, updates: Array<{ __typename?: 'action_update', Description: string, Id: string, ParentActionId: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title: string, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined }>, updates_aggregate: { __typename?: 'action_update_aggregate', aggregate?: { __typename?: 'action_update_aggregate_fields', count: number } | null | undefined }, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetSecondLineTestResultByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetSecondLineTestResultByIdQuery = { __typename?: 'query_root', control_test_second_line_result: Array<{ __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type InsertDocumentSecondLineResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  DocumentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertDocumentSecondLineResultMutation = { __typename?: 'mutation_root', insertChildDocumentSecondLineResult?: { __typename?: 'InsertChildDocumentAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertObligationSecondLineResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  ObligationIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertObligationSecondLineResultMutation = { __typename?: 'mutation_root', insertChildObligationSecondLineResult?: { __typename?: 'InsertChildObligationAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertChildRiskSecondLineResultMutationVariables = Exact<{
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Impact?: InputMaybe<Scalars['Int']['input']>;
  ControlType?: InputMaybe<Risk_Assessment_Result_Control_Type_Enum>;
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  RiskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertChildRiskSecondLineResultMutation = { __typename?: 'mutation_root', insertChildRiskSecondLineResult?: { __typename?: 'InsertChildRiskAssessmentResultOutput', Ids: Array<string> } | null | undefined };

export type InsertSecondLineControlTestResultMutationVariables = Exact<{
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertSecondLineControlTestResultMutation = { __typename?: 'mutation_root', insertChildControlTestSecondLineResult?: { __typename?: 'insertControlTestResultOutput', Ids: Array<string> } | null | undefined };

export type InsertSecondLineImpactRatingMutationVariables = Exact<{
  Ratings: Array<InsertImpactRatingPairInput> | InsertImpactRatingPairInput;
  TestDate: Scalars['timestamptz']['input'];
  ComplianceMonitoringAssessmentId: Scalars['uuid']['input'];
  RatedItemId: Scalars['uuid']['input'];
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
  CompletedBy?: InputMaybe<Scalars['String']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertSecondLineImpactRatingMutation = { __typename?: 'mutation_root', insertChildImpactSecondLineRating?: { __typename?: 'insertChildImpactRatingOutput', Ids: Array<string> } | null | undefined };

export type UpdateControlTestSecondLineResultApiMutationVariables = Exact<{
  object?: InputMaybe<UpdateTestResultInput>;
}>;


export type UpdateControlTestSecondLineResultApiMutation = { __typename?: 'mutation_root', updateControlTestSecondLineResultApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateDocumentSecondLineResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateDocumentSecondLineResultMutation = { __typename?: 'mutation_root', update_document_second_line_result?: { __typename?: 'document_second_line_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateObligationSecondLineResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateObligationSecondLineResultMutation = { __typename?: 'mutation_root', update_obligation_second_line_result?: { __typename?: 'obligation_second_line_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateControlledRiskSecondLineResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateControlledRiskSecondLineResultMutation = { __typename?: 'mutation_root', update_risk_controlled_second_line_result?: { __typename?: 'risk_controlled_second_line_result_mutation_response', affected_rows: number } | null | undefined };

export type UpdateUncontrolledRiskSecondLineResultMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Impact?: InputMaybe<Scalars['Int']['input']>;
  Likelihood?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  Rationale?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateUncontrolledRiskSecondLineResultMutation = { __typename?: 'mutation_root', update_risk_uncontrolled_second_line_result?: { __typename?: 'risk_uncontrolled_second_line_result_mutation_response', affected_rows: number } | null | undefined };

export type GetDefaultTabsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultTabsQuery = { __typename?: 'query_root', tab: Array<{ __typename?: 'tab', ParentType: Parent_Type_Enum, Tabs: any }>, organisation_tab_preference: Array<{ __typename?: 'organisation_tab_preference', ObjectType: Parent_Type_Enum, Preferences: any }>, user_tab_preference: Array<{ __typename?: 'user_tab_preference', ObjectType: Parent_Type_Enum, Preferences: any }> };

export type GetOrganisationTabPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationTabPreferencesQuery = { __typename?: 'query_root', organisation_tab_preference: Array<{ __typename?: 'organisation_tab_preference', ObjectType: Parent_Type_Enum, Preferences: any }> };

export type GetUserTabPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTabPreferencesQuery = { __typename?: 'query_root', user_tab_preference: Array<{ __typename?: 'user_tab_preference', ObjectType: Parent_Type_Enum, Preferences: any }> };

export type ResetTabPreferencesMutationVariables = Exact<{
  ObjectType: Parent_Type_Enum;
}>;


export type ResetTabPreferencesMutation = { __typename?: 'mutation_root', delete_organisation_tab_preference?: { __typename?: 'organisation_tab_preference_mutation_response', affected_rows: number } | null | undefined, delete_user_tab_preference?: { __typename?: 'user_tab_preference_mutation_response', affected_rows: number } | null | undefined };

export type UpdateOrganisationTabPreferencesMutationVariables = Exact<{
  ObjectType: Parent_Type_Enum;
  Preferences: Scalars['jsonb']['input'];
}>;


export type UpdateOrganisationTabPreferencesMutation = { __typename?: 'mutation_root', insert_organisation_tab_preference?: { __typename?: 'organisation_tab_preference_mutation_response', affected_rows: number } | null | undefined, delete_user_tab_preference?: { __typename?: 'user_tab_preference_mutation_response', affected_rows: number } | null | undefined };

export type UpdateUserTabPreferencesMutationVariables = Exact<{
  ObjectType: Parent_Type_Enum;
  Preferences: Scalars['jsonb']['input'];
}>;


export type UpdateUserTabPreferencesMutation = { __typename?: 'mutation_root', insert_user_tab_preference?: { __typename?: 'user_tab_preference_mutation_response', affected_rows: number } | null | undefined };

export type DeleteTagTypesMutationVariables = Exact<{
  Ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteTagTypesMutation = { __typename?: 'mutation_root', deleteTagTypeApi?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetTagTypeByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTagTypeByIdQuery = { __typename?: 'query_root', tag_type: Array<{ __typename?: 'tag_type', TagTypeId: string, Name: string, Description?: string | null | undefined, ModifiedAtTimestamp: string, TagTypeGroupId?: string | null | undefined, tag_type_group?: { __typename?: 'tag_type_group', Id: string, Name: string } | null | undefined }> };

export type GetTagTypesByNameQueryVariables = Exact<{
  Name: Scalars['String']['input'];
}>;


export type GetTagTypesByNameQuery = { __typename?: 'query_root', tag_type: Array<{ __typename?: 'tag_type', Name: string, TagTypeId: string }> };

export type GetTagTypeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagTypeGroupsQuery = { __typename?: 'query_root', tag_type_group: Array<{ __typename?: 'tag_type_group', Id: string, Name: string }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'query_root', tag_type: Array<{ __typename?: 'tag_type', TagTypeId: string, Name: string, Description?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, tag_type_group?: { __typename?: 'tag_type_group', Id: string, Name: string } | null | undefined }> };

export type InsertTagTypeGroupByNameMutationVariables = Exact<{
  Name?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertTagTypeGroupByNameMutation = { __typename?: 'mutation_root', insert_tag_type_group_one?: { __typename?: 'tag_type_group', Id: string } | null | undefined };

export type InsertTagTypeWithGroupNameMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  TagGroupName?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertTagTypeWithGroupNameMutation = { __typename?: 'mutation_root', insert_tag_type_one?: { __typename?: 'tag_type', TagTypeId: string } | null | undefined };

export type InsertTagTypeWithOptionalGroupIdMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Description?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertTagTypeWithOptionalGroupIdMutation = { __typename?: 'mutation_root', insert_tag_type_one?: { __typename?: 'tag_type', TagTypeId: string } | null | undefined };

export type TagPartsFragment = { __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined };

export type UpdateTagTypeMutationVariables = Exact<{
  TagTypeId: Scalars['uuid']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  TagTypeGroupId?: InputMaybe<Scalars['uuid']['input']>;
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateTagTypeMutation = { __typename?: 'mutation_root', update_tag_type?: { __typename?: 'tag_type_mutation_response', affected_rows: number } | null | undefined };

export type DeleteTaxonomyOrgMutationVariables = Exact<{
  TaxonomyId: Scalars['uuid']['input'];
  OrgKey: Scalars['String']['input'];
}>;


export type DeleteTaxonomyOrgMutation = { __typename?: 'mutation_root', delete_taxonomy_org?: { __typename?: 'taxonomy_org_mutation_response', affected_rows: number } | null | undefined, delete_taxonomy?: { __typename?: 'taxonomy_mutation_response', affected_rows: number } | null | undefined };

export type GetTaxonomyByLocaleAndOrgQueryVariables = Exact<{
  Locale: Scalars['String']['input'];
  OrgKey: Scalars['String']['input'];
}>;


export type GetTaxonomyByLocaleAndOrgQuery = { __typename?: 'query_root', taxonomy_org: Array<{ __typename?: 'taxonomy_org', Id: string, Locale: string, OrgName: string, TaxonomyId: string, taxonomy: { __typename?: 'taxonomy', Common: any, Description: string, ModifiedAtTimestamp: string, Id: string, Library: any, Rating: any, Taxonomy: any, InternalAuditRating: any, organisations_aggregate: { __typename?: 'taxonomy_org_aggregate', aggregate?: { __typename?: 'taxonomy_org_aggregate_fields', count: number } | null | undefined } } }> };

export type InsertTaxonomyMutationVariables = Exact<{ [key: string]: never; }>;


export type InsertTaxonomyMutation = { __typename?: 'mutation_root', insert_taxonomy_one?: { __typename?: 'taxonomy', Id: string } | null | undefined };

export type UpdateTaxonomyMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Common: Scalars['jsonb']['input'];
  Library: Scalars['jsonb']['input'];
  Rating: Scalars['jsonb']['input'];
  Taxonomy: Scalars['jsonb']['input'];
  InternalAuditRating: Scalars['jsonb']['input'];
  OriginalTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateTaxonomyMutation = { __typename?: 'mutation_root', update_taxonomy?: { __typename?: 'taxonomy_mutation_response', affected_rows: number } | null | undefined };

export type GetTaxonomyAuditQueryVariables = Exact<{
  Locale: Scalars['String']['input'];
  OrgKey: Scalars['String']['input'];
}>;


export type GetTaxonomyAuditQuery = { __typename?: 'query_root', taxonomy_audit: Array<{ __typename?: 'taxonomy_audit', Description: string, Id: string, Common: any, Library: any, Rating: any, Taxonomy: any, InternalAuditRating?: any | null | undefined, ModifiedAtTimestamp: string, organisations_aggregate: { __typename?: 'taxonomy_org_aggregate', aggregate?: { __typename?: 'taxonomy_org_aggregate_fields', count: number } | null | undefined } }> };

export type DeleteTestResultsMutationVariables = Exact<{
  Ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteTestResultsMutation = { __typename?: 'mutation_root', delete_relation_file?: { __typename?: 'relation_file_mutation_response', affected_rows: number } | null | undefined, delete_test_result?: { __typename?: 'test_result_mutation_response', affected_rows: number } | null | undefined };

export type GetLatestTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLatestTestResultsByControlIdQuery = { __typename?: 'query_root', test_result: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, assessmentParents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetTestResultAuditByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTestResultAuditByIdQuery = { __typename?: 'query_root', test_result_audit: Array<{ __typename?: 'test_result_audit', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, CustomAttributeData?: any | null | undefined, SequentialId?: number | null | undefined }> };

export type GetTestResultByIdQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTestResultByIdQuery = { __typename?: 'query_root', test_result: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> }> };

export type GetTestResultsQueryVariables = Exact<{
  where?: Test_Result_Bool_Exp;
}>;


export type GetTestResultsQuery = { __typename?: 'query_root', test_result: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'control', Id: string, Title: string, SequentialId?: number | null | undefined, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', ManualDueDate?: string | null | undefined } | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files_aggregate: { __typename?: 'relation_file_aggregate', aggregate?: { __typename?: 'relation_file_aggregate_fields', count: number } | null | undefined } }> };

export type GetTestResultsByControlIdQueryVariables = Exact<{
  controlId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTestResultsByControlIdQuery = { __typename?: 'query_root', test_result: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }>, assessmentParents: Array<{ __typename?: 'assessment_result_parent', assessment?: { __typename?: 'assessment', ActualCompletionDate?: string | null | undefined, CompletedByUser?: string | null | undefined, CreatedAtTimestamp: string, CreatedByUser: string, CustomAttributeData?: any | null | undefined, Id: string, ModifiedAtTimestamp: string, ModifiedByUser: string, NextTestDate?: string | null | undefined, OriginatingItemId?: string | null | undefined, SequentialId?: number | null | undefined, StartDate?: string | null | undefined, Summary?: string | null | undefined, TargetCompletionDate?: string | null | undefined, Title: string, Status: Assessment_Status_Enum, Outcome?: number | null | undefined, completedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined } | null | undefined }> }> };

export type GetWidgetTestResultsQueryVariables = Exact<{
  where: Test_Result_Bool_Exp;
  controlWhere?: InputMaybe<Control_Bool_Exp>;
}>;


export type GetWidgetTestResultsQuery = { __typename?: 'query_root', control: Array<{ __typename?: 'control', testResults: Array<{ __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number, submitter?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, parent?: { __typename?: 'control', Id: string, Title: string, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, schedule?: { __typename?: 'schedule', ManualDueDate?: string | null | undefined } | null | undefined } | null | undefined, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, files_aggregate: { __typename?: 'relation_file_aggregate', aggregate?: { __typename?: 'relation_file_aggregate_fields', count: number } | null | undefined } }> }> };

export type InsertControlTestResultMutationVariables = Exact<{
  Description?: InputMaybe<Scalars['String']['input']>;
  DesignEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  OverallEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  ControlIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  PerformanceEffectiveness?: InputMaybe<Scalars['Int']['input']>;
  AssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  Submitter?: InputMaybe<Scalars['String']['input']>;
  TestDate?: InputMaybe<Scalars['timestamptz']['input']>;
  TestType?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  CustomAttributeData?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertControlTestResultMutation = { __typename?: 'mutation_root', insertControlTestResult?: { __typename?: 'insertControlTestResultOutput', Ids: Array<string> } | null | undefined };

export type TestResultPartsFragment = { __typename?: 'test_result', Description?: string | null | undefined, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number };

export type ControlTestInternalAuditResultPartsFragment = { __typename?: 'control_test_internal_audit_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number };

export type ControlTestSecondLineResultPartsFragment = { __typename?: 'control_test_second_line_result', Description: string, DesignEffectiveness?: number | null | undefined, Id: string, OverallEffectiveness?: number | null | undefined, ParentControlId: string, PerformanceEffectiveness?: number | null | undefined, Submitter: string, TestDate: string, TestType?: string | null | undefined, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, Title?: string | null | undefined, CreatedByUser: string, ModifiedByUser: string, CustomAttributeData?: any | null | undefined, SequentialId: number };

export type UpdateTestResultMutationVariables = Exact<{
  object?: InputMaybe<UpdateTestResultInput>;
}>;


export type UpdateTestResultMutation = { __typename?: 'mutation_root', updateTestResultApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type CreateThirdPartyMutationVariables = Exact<{
  object: InsertThirdPartyInput;
}>;


export type CreateThirdPartyMutation = { __typename?: 'mutation_root', insertThirdPartyApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type DeleteThirdPartyMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type DeleteThirdPartyMutation = { __typename?: 'mutation_root', delete_questionnaire_invite?: { __typename?: 'questionnaire_invite_mutation_response', affected_rows: number } | null | undefined, delete_third_party_response?: { __typename?: 'third_party_response_mutation_response', affected_rows: number } | null | undefined, delete_third_party_by_pk?: { __typename?: 'third_party', Id: string } | null | undefined };

export type GetThirdPartiesQueryVariables = Exact<{
  where?: Third_Party_Bool_Exp;
}>;


export type GetThirdPartiesQuery = { __typename?: 'query_root', third_party: Array<{ __typename?: 'third_party', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CompanyName?: string | null | undefined, CompaniesHouseNumber?: string | null | undefined, Address?: string | null | undefined, CityTown?: string | null | undefined, Postcode?: string | null | undefined, Country?: string | null | undefined, PrimaryContactName?: string | null | undefined, ContactName?: string | null | undefined, ContactEmail?: string | null | undefined, CompanyDomain?: string | null | undefined, Type: string, Status: string, Criticality?: number | null | undefined, CreatedByUser: string, CustomAttributeData?: any | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }> }> };

export type GetThirdPartyByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetThirdPartyByIdQuery = { __typename?: 'query_root', third_party?: { __typename?: 'third_party', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CompanyName?: string | null | undefined, CompaniesHouseNumber?: string | null | undefined, Address?: string | null | undefined, CityTown?: string | null | undefined, Postcode?: string | null | undefined, Country?: string | null | undefined, PrimaryContactName?: string | null | undefined, ContactName?: string | null | undefined, ContactEmail?: string | null | undefined, CompanyDomain?: string | null | undefined, Type: string, Status: string, Criticality?: number | null | undefined, CreatedByUser: string, CustomAttributeData?: any | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, owners: Array<{ __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, contributors: Array<{ __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined }>, ownerGroups: Array<{ __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, contributorGroups: Array<{ __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined }>, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }>, tags: Array<{ __typename?: 'tag', ParentId: string, TagTypeId: string, type?: { __typename?: 'tag_type', Description?: string | null | undefined, Name: string } | null | undefined }>, departments: Array<{ __typename?: 'department', ParentId: string, DepartmentTypeId: string, type?: { __typename?: 'department_type', Description?: string | null | undefined, Name: string } | null | undefined }>, files: Array<{ __typename?: 'relation_file', ParentId: string, ChangeRequestFileOperation?: Change_Request_File_Operation_Enum | null | undefined, file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string } | null | undefined }> } | null | undefined };

export type GetThirdPartyResponseByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetThirdPartyResponseByIdQuery = { __typename?: 'query_root', third_party_response_by_pk?: { __typename?: 'third_party_response', ResponseData: any, Status: Third_Party_Response_Status_Enum, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, QuestionnaireTemplateVersionId: string, ParentId: string, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined, invitees: Array<{ __typename?: 'questionnaire_invite', UserId?: string | null | undefined, UserEmail: string, user?: { __typename?: 'auth_user', Email?: string | null | undefined } | null | undefined }>, thirdParty?: { __typename?: 'third_party', Id: string, Title: string, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> } | null | undefined, questionnaireTemplateVersion?: { __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, Schema: any, UISchema: any, parent?: { __typename?: 'questionnaire_template', Title: string } | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string, Meta?: any | null | undefined } | null | undefined }> } | null | undefined };

export type GetThirdPartyResponseSubscriptionByIdSubscriptionVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetThirdPartyResponseSubscriptionByIdSubscription = { __typename?: 'subscription_root', third_party_response_by_pk?: { __typename?: 'third_party_response', ResponseData: any, Status: Third_Party_Response_Status_Enum, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, QuestionnaireTemplateVersionId: string, ParentId: string, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined, invitees: Array<{ __typename?: 'questionnaire_invite', UserId?: string | null | undefined, UserEmail: string, user?: { __typename?: 'auth_user', Email?: string | null | undefined } | null | undefined }>, thirdParty?: { __typename?: 'third_party', Id: string, Title: string, ancestorContributors: Array<{ __typename?: 'ancestor_contributor', ContributorType?: string | null | undefined, UserId?: string | null | undefined, Id?: string | null | undefined, AncestorId?: string | null | undefined, UserGroupId?: string | null | undefined, user?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, user_group?: { __typename?: 'user_group', Name: string } | null | undefined }> } | null | undefined, questionnaireTemplateVersion?: { __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, Schema: any, UISchema: any, parent?: { __typename?: 'questionnaire_template', Title: string } | null | undefined } | null | undefined, files: Array<{ __typename?: 'relation_file', file?: { __typename?: 'file', ContentType: string, FileName: string, FileSize: number, Id: string, CreatedAtTimestamp: string, CreatedByUser?: string | null | undefined, ModifiedAtTimestamp: string, ModifiedByUser: string, Meta?: any | null | undefined } | null | undefined }> } | null | undefined };

export type GetThirdPartyResponsesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetThirdPartyResponsesSubscription = { __typename?: 'subscription_root', third_party_response: Array<{ __typename?: 'third_party_response', Id: string, ResponseData: any, Status: Third_Party_Response_Status_Enum, CreatedByUser: string, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, QuestionnaireTemplateVersionId: string, ParentId: string, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined, invitees: Array<{ __typename?: 'questionnaire_invite', UserId?: string | null | undefined, UserEmail: string, user?: { __typename?: 'auth_user', Email?: string | null | undefined } | null | undefined }>, thirdParty?: { __typename?: 'third_party', Id: string, Title: string } | null | undefined, questionnaireTemplateVersion?: { __typename?: 'questionnaire_template_version', Id: string, Version: string, Status: Questionnaire_Template_Version_Status_Enum, parent?: { __typename?: 'questionnaire_template', Title: string } | null | undefined } | null | undefined }> };

export type GetThirdPartyResponsesByThirdPartySubscriptionVariables = Exact<{
  ThirdPartyId: Scalars['uuid']['input'];
}>;


export type GetThirdPartyResponsesByThirdPartySubscription = { __typename?: 'subscription_root', third_party_response: Array<{ __typename?: 'third_party_response', Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, ParentId: string, QuestionnaireTemplateVersionId: string, Status: Third_Party_Response_Status_Enum, ResponseData: any, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined, invitees: Array<{ __typename?: 'questionnaire_invite', UserEmail: string, UserId?: string | null | undefined, user?: { __typename?: 'auth_user', FriendlyName?: string | null | undefined } | null | undefined }>, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, questionnaireTemplateVersion?: { __typename?: 'questionnaire_template_version', Id: string, Version: string, parent?: { __typename?: 'questionnaire_template', Title: string } | null | undefined } | null | undefined }> };

export type ThirdPartyPartsFragment = { __typename?: 'third_party', Id: string, SequentialId?: number | null | undefined, Title: string, Description?: string | null | undefined, CompanyName?: string | null | undefined, CompaniesHouseNumber?: string | null | undefined, Address?: string | null | undefined, CityTown?: string | null | undefined, Postcode?: string | null | undefined, Country?: string | null | undefined, PrimaryContactName?: string | null | undefined, ContactName?: string | null | undefined, ContactEmail?: string | null | undefined, CompanyDomain?: string | null | undefined, Type: string, Status: string, Criticality?: number | null | undefined, CreatedByUser: string, CustomAttributeData?: any | null | undefined, ModifiedByUser: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string };

export type ThirdPartyResponsePartsFragment = { __typename?: 'third_party_response', Id: string, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, ParentId: string, QuestionnaireTemplateVersionId: string, Status: Third_Party_Response_Status_Enum, ResponseData: any, StartDate?: string | null | undefined, ExpiresAt?: string | null | undefined };

export type UpdateThirdPartyMutationVariables = Exact<{
  object: UpdateThirdPartyInput;
}>;


export type UpdateThirdPartyMutation = { __typename?: 'mutation_root', updateThirdPartyApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type UpdateThirdPartyResponseMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  Status: Third_Party_Response_Status_Enum;
}>;


export type UpdateThirdPartyResponseMutation = { __typename?: 'mutation_root', update_third_party_response_by_pk?: { __typename?: 'third_party_response', Id: string } | null | undefined };

export type UpdateThirdPartyResponseStatusMutationVariables = Exact<{
  Action: Third_Party_Response_Enum_Action;
  ResponseIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  Reason?: InputMaybe<Scalars['String']['input']>;
  RequestType?: InputMaybe<Scalars['String']['input']>;
  ShareWithRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  ThirdPartyId: Scalars['uuid']['input'];
}>;


export type UpdateThirdPartyResponseStatusMutation = { __typename?: 'mutation_root', updateThirdPartyResponseStatusAction: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetThirdPartyContactsByThirdPartyIdQueryVariables = Exact<{
  ThirdPartyId: Scalars['uuid']['input'];
}>;


export type GetThirdPartyContactsByThirdPartyIdQuery = { __typename?: 'query_root', third_party_contact: Array<{ __typename?: 'third_party_contact', Id: string, ThirdPartyId: string, Email: string, Name?: string | null | undefined, JobTitle?: string | null | undefined, IsRevoked: boolean, user?: { __typename?: 'user', LastSeen?: string | null | undefined } | null | undefined }> };

export type GetActiveThirdPartyContactsQueryVariables = Exact<{
  ThirdPartyId: Scalars['uuid']['input'];
}>;


export type GetActiveThirdPartyContactsQuery = { __typename?: 'query_root', third_party_contact: Array<{ __typename?: 'third_party_contact', Id: string, Email: string, Name?: string | null | undefined, JobTitle?: string | null | undefined }> };

export type InsertThirdPartyContactApiMutationVariables = Exact<{
  ThirdPartyId: Scalars['uuid']['input'];
  Email: Scalars['String']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
  JobTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertThirdPartyContactApiMutation = { __typename?: 'mutation_root', insertThirdPartyContactApi?: { __typename?: 'IdOutput', Id: string } | null | undefined };

export type RevokeThirdPartyContactAccessMutationVariables = Exact<{
  ContactIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type RevokeThirdPartyContactAccessMutation = { __typename?: 'mutation_root', revokeThirdPartyContactAccess?: { __typename?: 'RevokeThirdPartyContactAccessOutput', results: Array<{ __typename?: 'RevokeThirdPartyContactAccessResultOutput', Id: string, IsRevoked: boolean, Message: string }> } | null | undefined };

export type ContributorGroupPartsFragment = { __typename?: 'contributor_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined };

export type DeleteUserGroupUsersMutationVariables = Exact<{
  UserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  UserGroupId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteUserGroupUsersMutation = { __typename?: 'mutation_root', delete_user_group_user?: { __typename?: 'user_group_user_mutation_response', affected_rows: number } | null | undefined };

export type DeleteUserGroupsMutationVariables = Exact<{
  UserGroupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteUserGroupsMutation = { __typename?: 'mutation_root', deleteUserGroups: { __typename?: 'GenericMutationOutput', affected_rows: number } };

export type GetUserGroupByIdQueryVariables = Exact<{
  Id: Scalars['uuid']['input'];
}>;


export type GetUserGroupByIdQuery = { __typename?: 'query_root', user_group: Array<{ __typename?: 'user_group', Id: string, Name: string, Description?: string | null | undefined, Email?: string | null | undefined, OwnerContributor: boolean, ModifiedAtTimestamp: string, approvers_aggregate: { __typename?: 'approver_aggregate', aggregate?: { __typename?: 'approver_aggregate_fields', count: number } | null | undefined } }> };

export type GetUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsQuery = { __typename?: 'query_root', user_group: Array<{ __typename?: 'user_group', Id: string, Name: string, Email?: string | null | undefined, Description?: string | null | undefined, OwnerContributor: boolean, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, users_aggregate: { __typename?: 'user_group_user_aggregate', aggregate?: { __typename?: 'user_group_user_aggregate_fields', count: number } | null | undefined } }> };

export type GetUserGroupsWithApproversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsWithApproversQuery = { __typename?: 'query_root', user_group: Array<{ __typename?: 'user_group', Id: string, Name: string, Email?: string | null | undefined, Description?: string | null | undefined, OwnerContributor: boolean, CreatedAtTimestamp: string, ModifiedAtTimestamp: string, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, modifiedByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined, users_aggregate: { __typename?: 'user_group_user_aggregate', aggregate?: { __typename?: 'user_group_user_aggregate_fields', count: number } | null | undefined }, approvers_aggregate: { __typename?: 'approver_aggregate', aggregate?: { __typename?: 'approver_aggregate_fields', count: number } | null | undefined } }> };

export type GetUsersByGroupIdQueryVariables = Exact<{
  GroupId: Scalars['uuid']['input'];
}>;


export type GetUsersByGroupIdQuery = { __typename?: 'query_root', user_group: Array<{ __typename?: 'user_group', users: Array<{ __typename?: 'user_group_user', CreatedAtTimestamp: string, authUsers: { __typename?: 'auth_user', Id: string, FirstName?: string | null | undefined, LastName?: string | null | undefined, Email?: string | null | undefined, RoleKey?: string | null | undefined, Status?: User_Status_Enum | null | undefined, FriendlyName?: string | null | undefined }, createdByUser?: { __typename?: 'user', FriendlyName?: string | null | undefined } | null | undefined }> }> };

export type InsertUserGroupMutationVariables = Exact<{
  Name: Scalars['String']['input'];
  Email?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertUserGroupMutation = { __typename?: 'mutation_root', insert_user_group_one?: { __typename?: 'user_group', Id: string } | null | undefined };

export type InsertUserGroupUsersMutationVariables = Exact<{
  objects: Array<User_Group_User_Insert_Input> | User_Group_User_Insert_Input;
}>;


export type InsertUserGroupUsersMutation = { __typename?: 'mutation_root', insert_user_group_user?: { __typename?: 'user_group_user_mutation_response', affected_rows: number } | null | undefined };

export type OwnerGroupPartsFragment = { __typename?: 'owner_group', UserGroupId: string, group?: { __typename?: 'user_group', Name: string, users: Array<{ __typename?: 'user_group_user', UserId: string }> } | null | undefined };

export type UpdateUserGroupMutationVariables = Exact<{
  Id: Scalars['uuid']['input'];
  OriginalTimestamp: Scalars['timestamptz']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  Description?: InputMaybe<Scalars['String']['input']>;
  OwnerContributor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserGroupMutation = { __typename?: 'mutation_root', update_user_group?: { __typename?: 'user_group_mutation_response', affected_rows: number } | null | undefined };

export type GetUserSearchPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSearchPreferencesQuery = { __typename?: 'query_root', user_search_preferences: Array<{ __typename?: 'user_search_preferences', RecentUserIds: Array<string>, ShowGroups: boolean, FilterByActivePlatformUsers: boolean, ShowUserPlatformRole: boolean, ShowUserJobTitle: boolean, ShowDirectoryDepartment: boolean, ShowUserLocation: boolean, ShowUserEmail: boolean, ShowArchivedUsers: boolean, ShowInheritedContributors: boolean }> };

export type GetUserSearchPreferencesAuditByIdQueryVariables = Exact<{
  Id: Scalars['String']['input'];
}>;


export type GetUserSearchPreferencesAuditByIdQuery = { __typename?: 'query_root', user_search_preferences_audit: Array<{ __typename?: 'user_search_preferences_audit', RecentUserIds: Array<string>, ShowGroups: boolean, FilterByActivePlatformUsers: boolean, ShowUserPlatformRole: boolean, ShowUserJobTitle: boolean, ShowDirectoryDepartment: boolean, ShowUserLocation: boolean, ShowUserEmail: boolean, ShowArchivedUsers: boolean, CreatedByUser: string, CreatedAtTimestamp: string, ModifiedByUser: string, ModifiedAtTimestamp: string }> };

export type UpsertRecentUsersMutationVariables = Exact<{
  RecentUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpsertRecentUsersMutation = { __typename?: 'mutation_root', insert_user_search_preferences?: { __typename?: 'user_search_preferences_mutation_response', affected_rows: number } | null | undefined };

export type UpsertUserSearchPreferencesMutationVariables = Exact<{
  ShowGroups: Scalars['Boolean']['input'];
  FilterByActivePlatformUsers: Scalars['Boolean']['input'];
  ShowUserPlatformRole: Scalars['Boolean']['input'];
  ShowUserJobTitle: Scalars['Boolean']['input'];
  ShowDirectoryDepartment: Scalars['Boolean']['input'];
  ShowUserLocation: Scalars['Boolean']['input'];
  ShowUserEmail: Scalars['Boolean']['input'];
  ShowArchivedUsers: Scalars['Boolean']['input'];
  ShowInheritedContributors: Scalars['Boolean']['input'];
}>;


export type UpsertUserSearchPreferencesMutation = { __typename?: 'mutation_root', insert_user_search_preferences?: { __typename?: 'user_search_preferences_mutation_response', affected_rows: number } | null | undefined };

export type GetUserTablePreferencesQueryVariables = Exact<{
  TableId: Scalars['String']['input'];
}>;


export type GetUserTablePreferencesQuery = { __typename?: 'query_root', user_table_preferences: Array<{ __typename?: 'user_table_preferences', Preferences: any }> };

export type UpsertUserTablePreferencesMutationVariables = Exact<{
  Preferences: Scalars['jsonb']['input'];
  TableId: Scalars['String']['input'];
}>;


export type UpsertUserTablePreferencesMutation = { __typename?: 'mutation_root', insert_user_table_preferences?: { __typename?: 'user_table_preferences_mutation_response', affected_rows: number } | null | undefined };

export type ContributorPartsFragment = { __typename?: 'contributor', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined };

export type GetAuthUserByIdQueryVariables = Exact<{
  Id: Scalars['String']['input'];
}>;


export type GetAuthUserByIdQuery = { __typename?: 'query_root', auth_user_by_pk?: { __typename?: 'auth_user', Id: string, FirstName?: string | null | undefined, LastName?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined, Status?: User_Status_Enum | null | undefined, CreatedOn?: string | null | undefined, DisplayName?: string | null | undefined, JobTitle?: string | null | undefined, Department?: string | null | undefined, OfficeLocation?: string | null | undefined, RoleKey?: string | null | undefined, organisationusers: Array<{ __typename?: 'auth_organisationuser', RoleKey?: string | null | undefined, LastSeen?: string | null | undefined, External_Id?: string | null | undefined }> } | null | undefined };

export type GetAuthUserByIdWithRolesQueryVariables = Exact<{
  Id: Scalars['String']['input'];
}>;


export type GetAuthUserByIdWithRolesQuery = { __typename?: 'query_root', auth_user_by_pk?: { __typename?: 'auth_user', Id: string, FirstName?: string | null | undefined, LastName?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined, Status?: User_Status_Enum | null | undefined, CreatedOn?: string | null | undefined, DisplayName?: string | null | undefined, JobTitle?: string | null | undefined, Department?: string | null | undefined, OfficeLocation?: string | null | undefined, RoleKey?: string | null | undefined, organisationusers: Array<{ __typename?: 'auth_organisationuser', RoleKey?: string | null | undefined, LastSeen?: string | null | undefined, External_Id?: string | null | undefined }>, customRoles: Array<{ __typename?: 'custom_role_user', role: { __typename?: 'custom_role', RoleName: string, Id: string, Description?: string | null | undefined } }> } | null | undefined };

export type GetAuthUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Auth_User_Order_By> | Auth_User_Order_By>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
}>;


export type GetAuthUsersQuery = { __typename?: 'query_root', auth_user: Array<{ __typename?: 'auth_user', Id: string, FirstName?: string | null | undefined, LastName?: string | null | undefined, FriendlyName?: string | null | undefined, Email?: string | null | undefined, RoleKey?: string | null | undefined, Status?: User_Status_Enum | null | undefined, CreatedOn?: string | null | undefined, LastSeen?: string | null | undefined, DisplayName?: string | null | undefined, JobTitle?: string | null | undefined, Department?: string | null | undefined, OfficeLocation?: string | null | undefined, CreatedByUser?: string | null | undefined, ModifiedByUser?: string | null | undefined, ModifiedAtTimestamp?: string | null | undefined, IsCustomerSupport?: boolean | null | undefined, organisationusers: Array<{ __typename?: 'auth_organisationuser', RoleKey?: string | null | undefined, LastSeen?: string | null | undefined }>, userGroupUsers: Array<{ __typename?: 'user_group_user', userGroups: { __typename?: 'user_group', Id: string, Name: string } }>, customRoles: Array<{ __typename?: 'custom_role_user', role: { __typename?: 'custom_role', RoleName: string, Id: string, Description?: string | null | undefined } }> }>, auth_user_aggregate: { __typename?: 'auth_user_aggregate', aggregate?: { __typename?: 'auth_user_aggregate_fields', count: number } | null | undefined } };

export type OwnerPartsFragment = { __typename?: 'owner', UserId: string, user?: { __typename?: 'user', FriendlyName?: string | null | undefined, Id?: string | null | undefined } | null | undefined };

export type UpdateUserRolesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateUserRolesMutation = { __typename?: 'mutation_root', update_user_roles: { __typename?: 'UpdateUserRolesMutationOutput', roles: Array<{ __typename?: 'RoleOutput', id: string, name: string, description: string } | null | undefined> } };

export type DeleteWizardMutationVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type DeleteWizardMutation = { __typename?: 'mutation_root', deleteWizardById?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export type GetWizardByIdQueryVariables = Exact<{
  RiskId: Scalars['uuid']['input'];
}>;


export type GetWizardByIdQuery = { __typename?: 'query_root', wizard: Array<{ __typename?: 'wizard', RiskId: string, CurrentStep: number, AssessmentId?: string | null | undefined, ActivityId?: string | null | undefined, Status: Wizard_Status_Enum }> };

export type GetWizardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWizardsQuery = { __typename?: 'query_root', wizard: Array<{ __typename?: 'wizard', RiskId: string }> };

export type InsertWizardMutationVariables = Exact<{
  object?: InputMaybe<InsertWizardInput>;
}>;


export type InsertWizardMutation = { __typename?: 'mutation_root', insertChildWizard?: { __typename?: 'InsertWizardOutput', RiskId: string } | null | undefined };

export type UpdateWizardMutationVariables = Exact<{
  object?: InputMaybe<UpdateWizardInput>;
}>;


export type UpdateWizardMutation = { __typename?: 'mutation_root', updateWizardById?: { __typename?: 'GenericMutationOutput', affected_rows: number } | null | undefined };

export const AcceptancePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]} as unknown as DocumentNode<AcceptancePartsFragment, unknown>;
export const ActionPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]} as unknown as DocumentNode<ActionPartsFragment, unknown>;
export const ActionUpdatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<ActionUpdatePartsFragment, unknown>;
export const AncestorContributorPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<AncestorContributorPartsFragment, unknown>;
export const AppetitePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}}]} as unknown as DocumentNode<AppetitePartsFragment, unknown>;
export const AssessmentActivityPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}}]} as unknown as DocumentNode<AssessmentActivityPartsFragment, unknown>;
export const DocumentAssessmentResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<DocumentAssessmentResultPartsFragment, unknown>;
export const ObligationAssessmentResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<ObligationAssessmentResultPartsFragment, unknown>;
export const RiskAssessmentResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<RiskAssessmentResultPartsFragment, unknown>;
export const DocumentInternalAuditResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<DocumentInternalAuditResultPartsFragment, unknown>;
export const ObligationInternalAuditResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<ObligationInternalAuditResultPartsFragment, unknown>;
export const RiskControlledInternalAuditResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<RiskControlledInternalAuditResultPartsFragment, unknown>;
export const RiskUncontrolledInternalAuditResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<RiskUncontrolledInternalAuditResultPartsFragment, unknown>;
export const DocumentSecondLineResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<DocumentSecondLineResultPartsFragment, unknown>;
export const ObligationSecondLineResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<ObligationSecondLineResultPartsFragment, unknown>;
export const RiskControlledSecondLineResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<RiskControlledSecondLineResultPartsFragment, unknown>;
export const RiskUncontrolledSecondLineResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<RiskUncontrolledSecondLineResultPartsFragment, unknown>;
export const AssessmentPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<AssessmentPartsFragment, unknown>;
export const AttestationGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<AttestationGroupPartsFragment, unknown>;
export const AttestationConfigPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationConfigParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_config"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RequireGlobalAttestation"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationTimeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"PromptText"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationGroupParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<AttestationConfigPartsFragment, unknown>;
export const AttestationCyclePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationCycleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_cycle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AllowCarryForward"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<AttestationCyclePartsFragment, unknown>;
export const CausePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CauseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cause"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<CausePartsFragment, unknown>;
export const FilePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]} as unknown as DocumentNode<FilePartsFragment, unknown>;
export const RelationFilePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]} as unknown as DocumentNode<RelationFilePartsFragment, unknown>;
export const ChangeRequestPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<ChangeRequestPartsFragment, unknown>;
export const ComplianceMonitoringAssessmentPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<ComplianceMonitoringAssessmentPartsFragment, unknown>;
export const ConsequencePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsequenceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"consequence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<ConsequencePartsFragment, unknown>;
export const SchedulePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<SchedulePartsFragment, unknown>;
export const ControlPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<ControlPartsFragment, unknown>;
export const ControlGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<ControlGroupPartsFragment, unknown>;
export const DashboardPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Sharing"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}}]}}]} as unknown as DocumentNode<DashboardPartsFragment, unknown>;
export const MyItemsAncestorContributorsPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsAncestorContributorsParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}}]}}]} as unknown as DocumentNode<MyItemsAncestorContributorsPartsFragment, unknown>;
export const MyItemsChangeRequestPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentUserOwnerList"},"name":{"kind":"Name","value":"parentOwnerAndContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UserId"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]} as unknown as DocumentNode<MyItemsChangeRequestPartsFragment, unknown>;
export const MyItemsContributorGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<MyItemsContributorGroupPartsFragment, unknown>;
export const MyItemsOwnerGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<MyItemsOwnerGroupPartsFragment, unknown>;
export const DepartmentPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<DepartmentPartsFragment, unknown>;
export const DocumentPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<DocumentPartsFragment, unknown>;
export const DocumentRelationFilePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<DocumentRelationFilePartsFragment, unknown>;
export const PublicDocumentRelationFilePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicDocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}}]}}]} as unknown as DocumentNode<PublicDocumentRelationFilePartsFragment, unknown>;
export const FormConfigurationPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormConfigurationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAttributeSchema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}}]}}]} as unknown as DocumentNode<FormConfigurationPartsFragment, unknown>;
export const ImpactRatingPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<ImpactRatingPartsFragment, unknown>;
export const ImpactInternalAuditRatingPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_internal_audit_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<ImpactInternalAuditRatingPartsFragment, unknown>;
export const ImpactSecondLineRatingPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_second_line_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<ImpactSecondLineRatingPartsFragment, unknown>;
export const ImpactPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}}]} as unknown as DocumentNode<ImpactPartsFragment, unknown>;
export const IndicatorPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<IndicatorPartsFragment, unknown>;
export const InternalAuditEntityPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditEntityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"businessArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InternalAuditEntityPartsFragment, unknown>;
export const InternalAuditReportPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<InternalAuditReportPartsFragment, unknown>;
export const IssuePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<IssuePartsFragment, unknown>;
export const SimplifiedIssuePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimplifiedIssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]} as unknown as DocumentNode<SimplifiedIssuePartsFragment, unknown>;
export const BreachedIssuesPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreachedIssuesParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_parent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimplifiedIssueParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimplifiedIssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]} as unknown as DocumentNode<BreachedIssuesPartsFragment, unknown>;
export const IssueAssessmentPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<IssueAssessmentPartsFragment, unknown>;
export const IssueUpdatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<IssueUpdatePartsFragment, unknown>;
export const ObligationPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalProvider"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<ObligationPartsFragment, unknown>;
export const QuestionnaireTemplatePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionnaireTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<QuestionnaireTemplatePartsFragment, unknown>;
export const EnterpriseRiskInstanceWithEntityHierarchyPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}}]}}]} as unknown as DocumentNode<EnterpriseRiskInstanceWithEntityHierarchyPartsFragment, unknown>;
export const RiskPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}}]} as unknown as DocumentNode<RiskPartsFragment, unknown>;
export const TagPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]} as unknown as DocumentNode<TagPartsFragment, unknown>;
export const TestResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]} as unknown as DocumentNode<TestResultPartsFragment, unknown>;
export const ControlTestInternalAuditResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]} as unknown as DocumentNode<ControlTestInternalAuditResultPartsFragment, unknown>;
export const ControlTestSecondLineResultPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]} as unknown as DocumentNode<ControlTestSecondLineResultPartsFragment, unknown>;
export const ThirdPartyPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"CompaniesHouseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"Address"}},{"kind":"Field","name":{"kind":"Name","value":"CityTown"}},{"kind":"Field","name":{"kind":"Name","value":"Postcode"}},{"kind":"Field","name":{"kind":"Name","value":"Country"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyDomain"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]} as unknown as DocumentNode<ThirdPartyPartsFragment, unknown>;
export const ThirdPartyResponsePartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyResponseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party_response"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}}]}}]} as unknown as DocumentNode<ThirdPartyResponsePartsFragment, unknown>;
export const ContributorGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<ContributorGroupPartsFragment, unknown>;
export const OwnerGroupPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<OwnerGroupPartsFragment, unknown>;
export const ContributorPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<ContributorPartsFragment, unknown>;
export const OwnerPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<OwnerPartsFragment, unknown>;
export const DeleteAcceptancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAcceptances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAcceptancesById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAcceptancesMutation, DeleteAcceptancesMutationVariables>;
export const GetAcceptanceAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAcceptanceAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptance_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetAcceptanceAuditByIdQuery, GetAcceptanceAuditByIdQueryVariables>;
export const GetAcceptanceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAcceptanceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptanceParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAcceptanceByIdQuery, GetAcceptanceByIdQueryVariables>;
export const GetAcceptancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAcceptances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptanceParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUserGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByUserGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ChangeRequestStatus"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAcceptancesQuery, GetAcceptancesQueryVariables>;
export const GetAcceptancesByParentRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAcceptancesByParentRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptanceParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedByUserGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvedByUserGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ChangeRequestStatus"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAcceptancesByParentRiskIdQuery, GetAcceptancesByParentRiskIdQueryVariables>;
export const InsertAcceptanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAcceptance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Details"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance_status_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUserGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUserGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildAcceptance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DateAcceptedFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateAcceptedTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"Details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Details"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"ApprovedByUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"ApprovedByUserGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUserGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"RequestedByUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"RequestedByUserGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUserGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAcceptanceMutation, InsertAcceptanceMutationVariables>;
export const UpdateAcceptanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAcceptance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Details"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance_status_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUserGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUserGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildAcceptance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"LatestModifiedAtTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateAcceptedFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateAcceptedTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateAcceptedTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"Details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Details"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"ApprovedByUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"ApprovedByUserGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ApprovedByUserGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"RequestedByUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"RequestedByUserGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RequestedByUserGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAcceptanceMutation, UpdateAcceptanceMutationVariables>;
export const DeleteActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteActionsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteActionsMutation, DeleteActionsMutationVariables>;
export const GetActionAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetActionAuditByIdQuery, GetActionAuditByIdQueryVariables>;
export const GetActionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetActionByIdQuery, GetActionByIdQueryVariables>;
export const GetActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionUpdateSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Count"}},{"kind":"Field","name":{"kind":"Name","value":"LatestDescription"}},{"kind":"Field","name":{"kind":"Name","value":"LatestTitle"}},{"kind":"Field","name":{"kind":"Name","value":"LatestCreatedAtTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetActionsQuery, GetActionsQueryVariables>;
export const GetWidgetActionsByPriorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetActionsByPriority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"action_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Priority"}}]}}]}}]} as unknown as DocumentNode<GetWidgetActionsByPriorityQuery, GetWidgetActionsByPriorityQueryVariables>;
export const InsertChildActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateDue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Priority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateRaised"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ClosedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateDue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateDue"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Priority"}}},{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateRaised"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateRaised"}}},{"kind":"Argument","name":{"kind":"Name","value":"ClosedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ClosedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TagTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"DepartmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertChildActionMutation, InsertChildActionMutationVariables>;
export const GetOverdueActionCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOverdueActionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"action_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOverdueActionCountQuery, GetOverdueActionCountQueryVariables>;
export const UpdateActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateDue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Priority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DateRaised"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ClosedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"OriginalTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateDue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateDue"}}},{"kind":"Argument","name":{"kind":"Name","value":"DateRaised"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DateRaised"}}},{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"Priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Priority"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"ClosedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ClosedDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TagTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"DepartmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"change_request_id"}}]}}]}}]} as unknown as DocumentNode<UpdateActionMutation, UpdateActionMutationVariables>;
export const DeleteActionUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteActionUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relationFile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_action_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteActionUpdatesMutation, DeleteActionUpdatesMutationVariables>;
export const GetActionUpdateAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionUpdateAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_update_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetActionUpdateAuditByIdQuery, GetActionUpdateAuditByIdQueryVariables>;
export const GetActionUpdateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionUpdateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetActionUpdateByIdQuery, GetActionUpdateByIdQueryVariables>;
export const GetActionUpdatesByParentActionIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActionUpdatesByParentActionId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentActionId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetActionUpdatesByParentActionIdQuery, GetActionUpdatesByParentActionIdQueryVariables>;
export const InsertActionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertActionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentActionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_action_update_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentActionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentActionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertActionUpdateMutation, InsertActionUpdateMutationVariables>;
export const UpdateActionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateActionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentActionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_action_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentActionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentActionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateActionUpdateMutation, UpdateActionUpdateMutationVariables>;
export const GetAggregationSettingsForOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAggregationSettingsForOrg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregation_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RiskScoringModel"}},{"kind":"Field","name":{"kind":"Name","value":"Appetite"}},{"kind":"Field","name":{"kind":"Name","value":"Config"}}]}}]}}]} as unknown as DocumentNode<GetAggregationSettingsForOrgQuery, GetAggregationSettingsForOrgQueryVariables>;
export const GetRiskScoresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getRiskScores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","alias":{"kind":"Name","value":"inherent"},"name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Uncontrolled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residual"},"name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Controlled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ResidualScore"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScore"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRating"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRating"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualImpact"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualLikelihood"}},{"kind":"Field","name":{"kind":"Name","value":"InherentImpact"}},{"kind":"Field","name":{"kind":"Name","value":"InherentLikelihood"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetRiskScoresSubscription, GetRiskScoresSubscriptionVariables>;
export const UpdateAggregationSettingsForOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAggregationSettingsForOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskScoringModel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_scoring_model_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteCascadingModel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"appetite_model_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_aggregation_org"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RiskScoringModel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskScoringModel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Appetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteCascadingModel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Config"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"aggregation_org_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RiskScoringModel"},{"kind":"EnumValue","value":"Appetite"},{"kind":"EnumValue","value":"Config"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAggregationSettingsForOrgMutation, UpdateAggregationSettingsForOrgMutationVariables>;
export const DeleteAppetitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAppetites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relationFile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_appetite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAppetitesMutation, DeleteAppetitesMutationVariables>;
export const GetActiveAppetitesByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveAppetitesByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}}]} as unknown as DocumentNode<GetActiveAppetitesByParentIdQuery, GetActiveAppetitesByParentIdQueryVariables>;
export const GetActiveRiskAppetitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveRiskAppetites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"appetite_parent_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Controlled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"InherentScore"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScore"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRating"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRating"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveRiskAppetitesQuery, GetActiveRiskAppetitesQueryVariables>;
export const GetAppetiteAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetiteAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetAppetiteAuditByIdQuery, GetAppetiteAuditByIdQueryVariables>;
export const GetAppetiteByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetiteById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetAppetiteByIdQuery, GetAppetiteByIdQueryVariables>;
export const GetAppetitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetAppetitesQuery, GetAppetitesQueryVariables>;
export const GetAppetitesByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetitesByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"riskId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}}]} as unknown as DocumentNode<GetAppetitesByRiskIdQuery, GetAppetitesByRiskIdQueryVariables>;
export const GetAppetitesGroupedByImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetitesGroupedByImpact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}}]} as unknown as DocumentNode<GetAppetitesGroupedByImpactQuery, GetAppetitesGroupedByImpactQueryVariables>;
export const InsertAppetiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAppetite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LowerAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Statement"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UpperAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LikelihoodAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"appetite_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"EffectiveDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildAppetite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"LowerAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LowerAppetite"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"Statement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Statement"}}},{"kind":"Argument","name":{"kind":"Name","value":"UpperAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UpperAppetite"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"EffectiveDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteType"}}},{"kind":"Argument","name":{"kind":"Name","value":"ImpactAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactAppetite"}}},{"kind":"Argument","name":{"kind":"Name","value":"LikelihoodAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LikelihoodAppetite"}}},{"kind":"Argument","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAppetiteMutation, InsertAppetiteMutationVariables>;
export const UpdateAppetiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAppetite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LowerAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Statement"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UpperAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LikelihoodAppetite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"EffectiveDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"appetite_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_appetite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"LowerAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LowerAppetite"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Statement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Statement"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"UpperAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UpperAppetite"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"EffectiveDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AppetiteType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactAppetite"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"LikelihoodAppetite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LikelihoodAppetite"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAppetiteMutation, UpdateAppetiteMutationVariables>;
export const GetChangeRequestsByApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangeRequestsByApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approver"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ApprovalId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvalId"}}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<GetChangeRequestsByApprovalQuery, GetChangeRequestsByApprovalQueryVariables>;
export const DeleteApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_approval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteApprovalMutation, DeleteApprovalMutationVariables>;
export const GetApprovalAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getApprovalAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}}]} as unknown as DocumentNode<GetApprovalAuditByIdQuery, GetApprovalAuditByIdQueryVariables>;
export const GetApprovalByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getApprovalById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"approval"},"name":{"kind":"Name","value":"approval_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"SequenceOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"approvers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetApprovalByIdQuery, GetApprovalByIdQueryVariables>;
export const GetGlobalApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGlobalApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"global"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"Variable","name":{"kind":"Name","value":"global"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Workflow"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"Variable","name":{"kind":"Name","value":"global"}}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"SequenceOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<GetGlobalApprovalsQuery, GetGlobalApprovalsQueryVariables>;
export const InsertApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"approval_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_approval_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertApprovalMutation, InsertApprovalMutationVariables>;
export const UpdateApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"approval_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateLevels"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"approval_level_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertLevels"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"approval_level_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertApprovers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"approver_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLevelIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteApproverIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_approval_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approval"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_approval_level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLevelIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_approver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteApproverIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_approval_level_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateLevels"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_approval_level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertLevels"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_approver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertApprovers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateApprovalMutation, UpdateApprovalMutationVariables>;
export const DeleteAssessmentActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAssessmentActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAssessmentActivitiesMutation, DeleteAssessmentActivitiesMutationVariables>;
export const GetAssessmentActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentAssessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}},{"kind":"Field","name":{"kind":"Name","value":"parentRisk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentActivitiesQuery, GetAssessmentActivitiesQueryVariables>;
export const GetAssessmentActivitiesByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentActivitiesByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"IsRCSA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentActivitiesByParentIdQuery, GetAssessmentActivitiesByParentIdQueryVariables>;
export const GetAssessmentActivityAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentActivityAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentActivityAuditByIdQuery, GetAssessmentActivityAuditByIdQueryVariables>;
export const GetAssessmentActivityByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentActivityById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentActivityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentActivityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linked_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentActivityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Source"}},{"kind":"Field","name":{"kind":"Name","value":"Target"}},{"kind":"Field","name":{"kind":"Name","value":"target_control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_control_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_assessment_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_obligation_impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentObligationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_impact_rating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndicatorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptanceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalProvider"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<GetAssessmentActivityByIdQuery, GetAssessmentActivityByIdQueryVariables>;
export const GetAssessmentRcsaActivitiesByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentRCSAActivitiesByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"IsRCSA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}},{"kind":"Field","name":{"kind":"Name","value":"parentRisk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentRcsaActivitiesByParentIdQuery, GetAssessmentRcsaActivitiesByParentIdQueryVariables>;
export const InsertAssessmentActivityWithLinkedItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAssessmentActivityWithLinkedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ActivityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletionDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssignedUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LinkedItemIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IsRCSA"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAssessmentActivityWithLinkedItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ActivityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ActivityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletionDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletionDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssignedUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssignedUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"LinkedItemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LinkedItemIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"IsRCSA"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IsRCSA"}}},{"kind":"Argument","name":{"kind":"Name","value":"RiskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAssessmentActivityWithLinkedItemsMutation, InsertAssessmentActivityWithLinkedItemsMutationVariables>;
export const UpdateAssessmentActivityWithLinkedItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssessmentActivityWithLinkedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ActivityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletionDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssignedUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LinkedItemIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IsWizardAction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssessmentActivityWithLinkedItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ActivityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ActivityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletionDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletionDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssignedUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssignedUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"OriginalTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"LinkedItemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LinkedItemIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"IsWizardAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IsWizardAction"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"OwnerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateAssessmentActivityWithLinkedItemsMutation, UpdateAssessmentActivityWithLinkedItemsMutationVariables>;
export const DeleteAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAssessmentResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAssessmentResultsMutation, DeleteAssessmentResultsMutationVariables>;
export const GetAllAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllAssessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"assessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"documents"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"assessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"obligations"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"assessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risks"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetAllAssessmentResultsQuery, GetAllAssessmentResultsQueryVariables>;
export const GetAssessmentResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_result_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ResultType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetAssessmentResultByIdQuery, GetAssessmentResultByIdQueryVariables>;
export const GetAssessmentResultParentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentResultParentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_result_parent_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ResultType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentResultParentAuditByIdQuery, GetAssessmentResultParentAuditByIdQueryVariables>;
export const GetAssessmentResultsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentResultsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessmentParents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessmentParents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"consequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifiedIndividual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RatedItemId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetAssessmentResultsByParentIdQuery, GetAssessmentResultsByParentIdQueryVariables>;
export const GetDocumentAssessmentResultAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAssessmentResultAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetDocumentAssessmentResultAuditByIdQuery, GetDocumentAssessmentResultAuditByIdQueryVariables>;
export const GetDocumentAssessmentResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAssessmentResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetDocumentAssessmentResultByIdQuery, GetDocumentAssessmentResultByIdQueryVariables>;
export const GetDocumentAssessmentResultsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAssessmentResultsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetDocumentAssessmentResultsByParentIdQuery, GetDocumentAssessmentResultsByParentIdQueryVariables>;
export const GetLatestDocumentAssessmentResultByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestDocumentAssessmentResultByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestDocumentAssessmentResultByDocumentIdQuery, GetLatestDocumentAssessmentResultByDocumentIdQueryVariables>;
export const GetLatestDocumentAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestDocumentAssessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestDocumentAssessmentResultsQuery, GetLatestDocumentAssessmentResultsQueryVariables>;
export const GetLatestObligationAssessmentResultByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestObligationAssessmentResultByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestObligationAssessmentResultByObligationIdQuery, GetLatestObligationAssessmentResultByObligationIdQueryVariables>;
export const GetLatestObligationAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestObligationAssessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestObligationAssessmentResultsQuery, GetLatestObligationAssessmentResultsQueryVariables>;
export const GetLatestRiskScoresByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getLatestRiskScoresByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_score"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RiskId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ResidualScore"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScore"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRating"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRating"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualImpact"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualLikelihood"}},{"kind":"Field","name":{"kind":"Name","value":"InherentImpact"}},{"kind":"Field","name":{"kind":"Name","value":"InherentLikelihood"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetLatestRiskScoresByRiskIdSubscription, GetLatestRiskScoresByRiskIdSubscriptionVariables>;
export const GetObligationAssessmentResultAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationAssessmentResultAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetObligationAssessmentResultAuditByIdQuery, GetObligationAssessmentResultAuditByIdQueryVariables>;
export const GetObligationAssessmentResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationAssessmentResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetObligationAssessmentResultByIdQuery, GetObligationAssessmentResultByIdQueryVariables>;
export const GetObligationAssessmentResultsByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationAssessmentResultsByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetObligationAssessmentResultsByObligationIdQuery, GetObligationAssessmentResultsByObligationIdQueryVariables>;
export const GetRiskAssessmentResultAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultAuditByIdQuery, GetRiskAssessmentResultAuditByIdQueryVariables>;
export const GetRiskAssessmentResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultByIdQuery, GetRiskAssessmentResultByIdQueryVariables>;
export const GetRiskAssessmentResultsByControlTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultsByControlType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"controlled"},"name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Controlled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uncontrolled"},"name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Uncontrolled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultsByControlTypeQuery, GetRiskAssessmentResultsByControlTypeQueryVariables>;
export const GetRiskAssessmentResultsByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultsByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultsByRiskIdQuery, GetRiskAssessmentResultsByRiskIdQueryVariables>;
export const GetRiskAssessmentResultsByRiskIdAndControlTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultsByRiskIdAndControlType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result_control_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultsByRiskIdAndControlTypeQuery, GetRiskAssessmentResultsByRiskIdAndControlTypeQueryVariables>;
export const GetRiskScoresByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskScoresByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Tier"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inherent"},"name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Uncontrolled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residual"},"name":{"kind":"Name","value":"risk_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"Controlled"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskAssessmentResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskAssessmentResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetRiskScoresByRiskIdQuery, GetRiskScoresByRiskIdQueryVariables>;
export const InsertDocumentAssessmentResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDocumentAssessmentResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildDocumentAssessmentResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"DocumentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertDocumentAssessmentResultMutation, InsertDocumentAssessmentResultMutationVariables>;
export const InsertChildImpactRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildImpactRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertImpactRatingPairInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildImpactRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Ratings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertChildImpactRatingMutation, InsertChildImpactRatingMutationVariables>;
export const InsertObligationAssessmentResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertObligationAssessmentResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildObligationAssessmentResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ObligationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertObligationAssessmentResultMutation, InsertObligationAssessmentResultMutationVariables>;
export const InsertRiskAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertRiskAssessmentResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result_control_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildRiskAssessmentResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"RiskIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertRiskAssessmentResultsMutation, InsertRiskAssessmentResultsMutationVariables>;
export const UpdateDocumentAssessmentResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocumentAssessmentResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_document_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentAssessmentResultMutation, UpdateDocumentAssessmentResultMutationVariables>;
export const UpdateObligationAssessmentResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateObligationAssessmentResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_obligation_assessment_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateObligationAssessmentResultMutation, UpdateObligationAssessmentResultMutationVariables>;
export const UpdateRiskAssessmentResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRiskAssessmentResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildRiskAssessmentResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateRiskAssessmentResultMutation, UpdateRiskAssessmentResultMutationVariables>;
export const DeleteAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteAssessmentsMutation, DeleteAssessmentsMutationVariables>;
export const GetAssessmentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]}}]} as unknown as DocumentNode<GetAssessmentAuditByIdQuery, GetAssessmentAuditByIdQueryVariables>;
export const GetAssessmentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetAssessmentByIdQuery, GetAssessmentByIdQueryVariables>;
export const GetAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assessedItems"},"name":{"kind":"Name","value":"assessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetAssessmentsQuery, GetAssessmentsQueryVariables>;
export const InsertAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAssessmentApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAssessmentMutation, InsertAssessmentMutationVariables>;
export const UpdateAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssessmentApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAssessmentMutation, UpdateAssessmentMutationVariables>;
export const GetAttestationConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAttestationConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationConfigParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentDocumentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationConfigParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_config"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RequireGlobalAttestation"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationTimeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"PromptText"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationGroupParts"}}]}}]}}]} as unknown as DocumentNode<GetAttestationConfigQuery, GetAttestationConfigQueryVariables>;
export const GetGlobalUsersAndGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGlobalUsersAndGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"globalUsers"},"name":{"kind":"Name","value":"user_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IsCustomerSupport"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userGroups"},"name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetGlobalUsersAndGroupsQuery, GetGlobalUsersAndGroupsQueryVariables>;
export const InsertAttestationConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAttestationConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertAttestationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildAttestationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAttestationConfigMutation, InsertAttestationConfigMutationVariables>;
export const GetAttestationCycleRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAttestationCycleRegister"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationCycleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationCycleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_cycle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AllowCarryForward"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAttestationCycleRegisterQuery, GetAttestationCycleRegisterQueryVariables>;
export const GetAttestationCyclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAttestationCycles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_cycle_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_cycle_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_cycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationCycleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationCycleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_cycle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AllowCarryForward"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAttestationCyclesQuery, GetAttestationCyclesQueryVariables>;
export const GetActiveAttestationCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveAttestationCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_cycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"active","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentDocumentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"AllowCarryForward"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveAttestationCycleQuery, GetActiveAttestationCycleQueryVariables>;
export const InsertAttestationCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAttestationCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AllowCarryForward"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attestationConfig"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertAttestationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildAttestationCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AllowCarryForward"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AllowCarryForward"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"DocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertChildAttestationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attestationConfig"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertAttestationCycleMutation, InsertAttestationCycleMutationVariables>;
export const AttestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"attest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AttestMutation, AttestMutationVariables>;
export const GetAttestationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAttestationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"NodeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UserId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PromptText"}}]}}]}}]}}]} as unknown as DocumentNode<GetAttestationStatusQuery, GetAttestationStatusQueryVariables>;
export const GetPolicyAttestationRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPolicyAttestationRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_record_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Active"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"NodeId"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"ExpiresAt"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"Active"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"AttestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"NodeId"}},{"kind":"Field","name":{"kind":"Name","value":"CycleId"}},{"kind":"Field","name":{"kind":"Name","value":"carriedForwardFromRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Department"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetPolicyAttestationRecordsQuery, GetPolicyAttestationRecordsQueryVariables>;
export const GetPolicyAttestationRecordsForDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPolicyAttestationRecordsForDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestation_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"node"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document_file"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"NodeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFileId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Active"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"NodeId"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"ExpiresAt"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"Active"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"AttestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"NodeId"}},{"kind":"Field","name":{"kind":"Name","value":"CycleId"}},{"kind":"Field","name":{"kind":"Name","value":"carriedForwardFromRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPolicyAttestationRecordsForDocumentQuery, GetPolicyAttestationRecordsForDocumentQueryVariables>;
export const AttestationNotRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"attestationNotRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attestationNotRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AttestationNotRequiredMutation, AttestationNotRequiredMutationVariables>;
export const GetAuditLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuditLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"audit_log_view_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"audit_log_view_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audit_log_view"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Action"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"PerformedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"Item"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OrgKey"}}]}}]}}]} as unknown as DocumentNode<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetBusinessAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBusinessAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetBusinessAreasQuery, GetBusinessAreasQueryVariables>;
export const DeleteCausesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCauses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteCausesMutation, DeleteCausesMutationVariables>;
export const GetCauseAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCauseAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetCauseAuditByIdQuery, GetCauseAuditByIdQueryVariables>;
export const GetCauseByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCauseById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetCauseByIdQuery, GetCauseByIdQueryVariables>;
export const GetCausesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCauses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cause_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CauseParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CauseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cause"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetCausesQuery, GetCausesQueryVariables>;
export const GetCausesByParentIssueIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCausesByParentIssueId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetCausesByParentIssueIdQuery, GetCausesByParentIssueIdQueryVariables>;
export const InsertCauseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertCause"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Significance"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Significance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Significance"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertCauseMutation, InsertCauseMutationVariables>;
export const UpdateCauseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCause"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Significance"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cause"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Significance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Significance"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateCauseMutation, UpdateCauseMutationVariables>;
export const GetChangeRequestByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getChangeRequestById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeRequestParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChangeRequestByIdSubscription, GetChangeRequestByIdSubscriptionVariables>;
export const GetChangeRequestByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getChangeRequestByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeRequestParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChangeRequestByParentIdSubscription, GetChangeRequestByParentIdSubscriptionVariables>;
export const GetApprovalLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getApprovalLevels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Workflow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"levels"},"name":{"kind":"Name","value":"approval_level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approval"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Workflow"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Workflow"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Workflow"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Workflow"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approval"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"SequenceOrder"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"approvers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetApprovalLevelsQuery, GetApprovalLevelsQueryVariables>;
export const GetChangeRequestAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangeRequestAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetChangeRequestAuditByIdQuery, GetChangeRequestAuditByIdQueryVariables>;
export const GetChangeRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChangeRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"change_request_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentUserOwnerList"},"name":{"kind":"Name","value":"parentOwnerAndContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UserId"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetChangeRequestsQuery, GetChangeRequestsQueryVariables>;
export const GetPendingChangeRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPendingChangeRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeRequestParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPendingChangeRequestsQuery, GetPendingChangeRequestsQueryVariables>;
export const GetMostRecentNonPendingChangeRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMostRecentNonPendingChangeRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeRequestParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMostRecentNonPendingChangeRequestQuery, GetMostRecentNonPendingChangeRequestQueryVariables>;
export const GetLivePendingChangeRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getLivePendingChangeRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeRequestParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"owners"},"name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedChanges"}},{"kind":"Field","name":{"kind":"Name","value":"requestedFileChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenByUser"}},{"kind":"Field","name":{"kind":"Name","value":"OverriddenAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Comment"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}},{"kind":"Field","name":{"kind":"Name","value":"SequenceOrder"}},{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Workflow"}},{"kind":"Field","name":{"kind":"Name","value":"InFlightEditRule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLivePendingChangeRequestsSubscription, GetLivePendingChangeRequestsSubscriptionVariables>;
export const OverrideChangeRequestByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"overrideChangeRequestById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Approved"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overrideChangeRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"Approved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Approved"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<OverrideChangeRequestByIdMutation, OverrideChangeRequestByIdMutationVariables>;
export const UpdateApproverResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateApproverResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateApproverResponsesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApproverResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateApproverResponsesMutation, UpdateApproverResponsesMutationVariables>;
export const GetColourPalettesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getColourPalettes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colour_palette"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Settings"}}]}}]}}]} as unknown as DocumentNode<GetColourPalettesQuery, GetColourPalettesQueryVariables>;
export const InsertColourPaletteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertColourPalette"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_colour_palette_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Settings"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertColourPaletteMutation, InsertColourPaletteMutationVariables>;
export const UpdateColourPaletteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateColourPalette"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_colour_palette_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Settings"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateColourPaletteMutation, UpdateColourPaletteMutationVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_comment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_comment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ConversationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_conversation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteConversationMutation, DeleteConversationMutationVariables>;
export const DeleteConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_comment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ConversationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_conversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteConversationsMutation, DeleteConversationsMutationVariables>;
export const GetCommentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCommentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]}}]} as unknown as DocumentNode<GetCommentAuditByIdQuery, GetCommentAuditByIdQueryVariables>;
export const GetCommentsByConversationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCommentsByConversationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ConversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ConversationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ConversationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetCommentsByConversationIdQuery, GetCommentsByConversationIdQueryVariables>;
export const GetConversationAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConversationAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"IsResolved"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]}}]} as unknown as DocumentNode<GetConversationAuditByIdQuery, GetConversationAuditByIdQueryVariables>;
export const InsertCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ConversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_comment_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ConversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ConversationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertCommentMutation, InsertCommentMutationVariables>;
export const InsertConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_conversation_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertConversationMutation, InsertConversationMutationVariables>;
export const ResolveConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_conversation_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IsResolved"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<ResolveConversationMutation, ResolveConversationMutationVariables>;
export const UpdateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_comment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DeleteComplianceMonitoringAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteComplianceMonitoringAssessments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_compliance_monitoring_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteComplianceMonitoringAssessmentsMutation, DeleteComplianceMonitoringAssessmentsMutationVariables>;
export const GetAllComplianceMonitoringAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllComplianceMonitoringAssessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_monitoring_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]}}]} as unknown as DocumentNode<GetAllComplianceMonitoringAssessmentsQuery, GetAllComplianceMonitoringAssessmentsQueryVariables>;
export const GetComplianceMonitoringAssessmentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_monitoring_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentByIdQuery, GetComplianceMonitoringAssessmentByIdQueryVariables>;
export const GetComplianceMonitoringAssessmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_monitoring_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assessedItems"},"name":{"kind":"Name","value":"assessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentsQuery, GetComplianceMonitoringAssessmentsQueryVariables>;
export const InsertComplianceMonitoringAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertComplianceMonitoringAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertComplianceMonitoringAssessmentApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertComplianceMonitoringAssessmentMutation, InsertComplianceMonitoringAssessmentMutationVariables>;
export const UpdateComplianceMonitoringAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateComplianceMonitoringAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComplianceMonitoringAssessmentApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateComplianceMonitoringAssessmentMutation, UpdateComplianceMonitoringAssessmentMutationVariables>;
export const DeleteConsequencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteConsequences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_consequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteConsequencesMutation, DeleteConsequencesMutationVariables>;
export const GetConsequenceAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConsequenceAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consequence_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]}}]} as unknown as DocumentNode<GetConsequenceAuditByIdQuery, GetConsequenceAuditByIdQueryVariables>;
export const GetConsequenceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConsequenceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsequenceParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsequenceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"consequence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<GetConsequenceByIdQuery, GetConsequenceByIdQueryVariables>;
export const GetConsequencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConsequences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"consequence_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsequenceParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsequenceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"consequence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]} as unknown as DocumentNode<GetConsequencesQuery, GetConsequencesQueryVariables>;
export const GetConsequencesByParentIssueIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConsequencesByParentIssueId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsequenceParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsequenceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"consequence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]} as unknown as DocumentNode<GetConsequencesByParentIssueIdQuery, GetConsequencesByParentIssueIdQueryVariables>;
export const InsertConsequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertConsequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Criticality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CostValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CostType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"cost_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"consequence_type_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_consequence_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Criticality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Criticality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CostValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CostValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CostType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CostType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertConsequenceMutation, InsertConsequenceMutationVariables>;
export const UpdateConsequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConsequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Criticality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CostType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"cost_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CostValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"consequence_type_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_consequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Criticality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Criticality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CostType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CostType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CostValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CostValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateConsequenceMutation, UpdateConsequenceMutationVariables>;
export const AddControlParentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addControlParents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"control_parent_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_control_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AddControlParentsMutation, AddControlParentsMutationVariables>;
export const DeleteControlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteControls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteControlsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteControlsMutation, DeleteControlsMutationVariables>;
export const GetControlAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetControlAuditByIdQuery, GetControlAuditByIdQueryVariables>;
export const GetControlByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetControlByIdQuery, GetControlByIdQueryVariables>;
export const GetControlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"control_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"open_issue_aggregate"},"name":{"kind":"Name","value":"issues_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetControlsQuery, GetControlsQueryVariables>;
export const GetControlsBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlsBasic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"control"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetControlsBasicQuery, GetControlsBasicQueryVariables>;
export const GetControlsByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlsByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}}]} as unknown as DocumentNode<GetControlsByUserQuery, GetControlsByUserQueryVariables>;
export const InsertChildControlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildControl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertChildControlInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildControl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertChildControlMutation, InsertChildControlMutationVariables>;
export const RemoveParentControlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeParentControls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_control_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RemoveParentControlsMutation, RemoveParentControlsMutationVariables>;
export const UpdateControlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChildControlInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildControl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateControlMutation, UpdateControlMutationVariables>;
export const DeleteControlGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteControlGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"original_timestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_control_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"original_timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteControlGroupMutation, DeleteControlGroupMutationVariables>;
export const GetControlGroupAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroupAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetControlGroupAuditByIdQuery, GetControlGroupAuditByIdQueryVariables>;
export const GetControlGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetControlGroupByIdQuery, GetControlGroupByIdQueryVariables>;
export const GetControlGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetControlGroupsQuery, GetControlGroupsQueryVariables>;
export const GetControlGroupsByTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroupsByTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetControlGroupsByTitleQuery, GetControlGroupsByTitleQueryVariables>;
export const GetControlGroupsFlatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroupsFlat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}},{"kind":"Field","name":{"kind":"Name","value":"controls_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetControlGroupsFlatQuery, GetControlGroupsFlatQueryVariables>;
export const InsertControlGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertControlGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_control_group_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Owner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertControlGroupMutation, InsertControlGroupMutationVariables>;
export const UpdateControlGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControlGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_control_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Owner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateControlGroupMutation, UpdateControlGroupMutationVariables>;
export const GetCustomAttributeSchemaAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomAttributeSchemaAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_attribute_schema_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}}]}}]}}]} as unknown as DocumentNode<GetCustomAttributeSchemaAuditByIdQuery, GetCustomAttributeSchemaAuditByIdQueryVariables>;
export const DeleteCustomDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCustomDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_custom_datasource_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteCustomDatasourceMutation, DeleteCustomDatasourceMutationVariables>;
export const GetCustomDatasourceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomDatasourceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_datasource_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Filters"}},{"kind":"Field","name":{"kind":"Name","value":"Datasources"}},{"kind":"Field","name":{"kind":"Name","value":"Fields"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetCustomDatasourceByIdQuery, GetCustomDatasourceByIdQueryVariables>;
export const GetCustomDatasourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomDatasources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_datasource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Filters"}},{"kind":"Field","name":{"kind":"Name","value":"Datasources"}},{"kind":"Field","name":{"kind":"Name","value":"Fields"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomDatasourcesQuery, GetCustomDatasourcesQueryVariables>;
export const InsertCustomDataSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertCustomDataSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customDatasource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"custom_datasource_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_custom_datasource_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customDatasource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertCustomDataSourceMutation, InsertCustomDataSourceMutationVariables>;
export const UpdateCustomDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"custom_datasource_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_custom_datasource_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomDatasourceMutation, UpdateCustomDatasourceMutationVariables>;
export const GetCustomRibbonAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomRibbonAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_ribbon_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Filters"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}}]}}]}}]} as unknown as DocumentNode<GetCustomRibbonAuditByIdQuery, GetCustomRibbonAuditByIdQueryVariables>;
export const GetRibbonItemsByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRibbonItemsByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_ribbon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Filters"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetRibbonItemsByParentTypeQuery, GetRibbonItemsByParentTypeQueryVariables>;
export const InsertRibbonItemsByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertRibbonItemsByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_custom_ribbon_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Filters"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"idx_customribbon_orgkey_parenttype"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertRibbonItemsByParentTypeMutation, InsertRibbonItemsByParentTypeMutationVariables>;
export const UpdateRibbonItemsByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRibbonItemsByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_custom_ribbon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateRibbonItemsByParentTypeMutation, UpdateRibbonItemsByParentTypeMutationVariables>;
export const CustomRoleUserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"customRoleUserUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomRoleUserUpdateInputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customRoleUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CustomRoleUserUpdateMutation, CustomRoleUserUpdateMutationVariables>;
export const DeleteCustomRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCustomRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"custom_role_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_custom_role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>;
export const GetCustomRoleByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomRoleById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"RoleName"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"customRoleUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customRoleAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleTypeKey"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomRoleByIdQuery, GetCustomRoleByIdQueryVariables>;
export const GetCustomRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custom_role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"RoleName"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"customRoleUsers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomRolesQuery, GetCustomRolesQueryVariables>;
export const InsertCustomRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertCustomRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomRoleInsertInputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customRoleInsert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertCustomRoleMutation, InsertCustomRoleMutationVariables>;
export const UpdateCustomRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomRoleUpdateInputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customRoleUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>;
export const DeleteDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteDashboardMutation, DeleteDashboardMutationVariables>;
export const GetDashboardAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Sharing"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetDashboardAuditByIdQuery, GetDashboardAuditByIdQueryVariables>;
export const GetDashboardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Sharing"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetDashboardByIdQuery, GetDashboardByIdQueryVariables>;
export const GetDashboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Sharing"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}}]}}]} as unknown as DocumentNode<GetDashboardsQuery, GetDashboardsQueryVariables>;
export const GetMyItemsDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMyItemsDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"indicatorFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indicator_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"document_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"control_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentActivityFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obligationFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsChangeRequestParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"actionFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"closed"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"riskFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indicatorFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"assessmentActivityFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IsRCSA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"complete"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"issueFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"closed"}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attestation_record_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AttestationStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"obligationFilterConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentUserOwnerList"},"name":{"kind":"Name","value":"parentOwnerAndContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UserId"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyItemsDashboardQuery, GetMyItemsDashboardQueryVariables>;
export const InsertDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Sharing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_sharing_type_enum_action"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"Sharing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Sharing"}}},{"kind":"Argument","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertDashboardMutation, InsertDashboardMutationVariables>;
export const UpdateDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Sharing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_sharing_type_enum_action"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}},{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"Argument","name":{"kind":"Name","value":"Sharing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Sharing"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorUserIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ContributorGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContributorGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardMutation, UpdateDashboardMutationVariables>;
export const DataExportCreateScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dataExportCreateSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataExportCreateScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataExportCreateSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DataExportCreateScheduleMutation, DataExportCreateScheduleMutationVariables>;
export const DataExportOneOffExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataExportOneOffExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataExportOneOffExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiresInSeconds"}}]}}]}}]} as unknown as DocumentNode<DataExportOneOffExportQuery, DataExportOneOffExportQueryVariables>;
export const GetActiveDataExportScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getActiveDataExportSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_export_schedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"StartTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"EndTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"StorageType"}}]}}]}}]} as unknown as DocumentNode<GetActiveDataExportScheduleSubscription, GetActiveDataExportScheduleSubscriptionVariables>;
export const GetDataExportScheduleExecutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getDataExportScheduleExecutions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_export_schedule_execution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ExecutionTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Errors"}},{"kind":"Field","name":{"kind":"Name","value":"dataExportSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"StartTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"EndTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetDataExportScheduleExecutionsSubscription, GetDataExportScheduleExecutionsSubscriptionVariables>;
export const DataExportTestScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dataExportTestSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataExportTestScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataExportTestSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DataExportTestScheduleMutation, DataExportTestScheduleMutationVariables>;
export const DataImportStartImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dataImportStartImport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportStartImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DataImportStartImportMutation, DataImportStartImportMutationVariables>;
export const DataImportValidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dataImportValidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportValidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DataImportValidateMutation, DataImportValidateMutationVariables>;
export const DeleteDataImportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDataImportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_data_import"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDataImportByIdMutation, DeleteDataImportByIdMutationVariables>;
export const GetDataImportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDataImportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_import"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetDataImportByIdQuery, GetDataImportByIdQueryVariables>;
export const GetDataImportErrorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDataImportErrors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataImportId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_import_error"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DataImportId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataImportId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RowNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ImportObject"}},{"kind":"Field","name":{"kind":"Name","value":"DataImportId"}},{"kind":"Field","name":{"kind":"Name","value":"Message"}}]}}]}}]} as unknown as DocumentNode<GetDataImportErrorsQuery, GetDataImportErrorsQueryVariables>;
export const GetDataImportStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getDataImportStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_import"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]} as unknown as DocumentNode<GetDataImportStatusSubscription, GetDataImportStatusSubscriptionVariables>;
export const GetDataImportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDataImports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_import"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetDataImportsQuery, GetDataImportsQueryVariables>;
export const InsertDataImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDataImport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_data_import_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertDataImportMutation, InsertDataImportMutationVariables>;
export const DeleteDepartmentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDepartmentTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDepartmentTypeApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDepartmentTypesMutation, DeleteDepartmentTypesMutationVariables>;
export const GetDepartmentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DepartmentTypeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]}}]} as unknown as DocumentNode<GetDepartmentAuditByIdQuery, GetDepartmentAuditByIdQueryVariables>;
export const GetDepartmentTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDepartmentTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DepartmentTypeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"department_type_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDepartmentTypeByIdQuery, GetDepartmentTypeByIdQueryVariables>;
export const GetDepartmentTypesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentTypesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]}}]} as unknown as DocumentNode<GetDepartmentTypesByNameQuery, GetDepartmentTypesByNameQueryVariables>;
export const GetDepartmentTypeGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentTypeGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department_type_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetDepartmentTypeGroupsQuery, GetDepartmentTypeGroupsQueryVariables>;
export const GetDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department_type_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const InsertDepartmentTypeGroupByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDepartmentTypeGroupByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_department_type_group_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"DepartmentTypeGroup_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"Name"}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertDepartmentTypeGroupByNameMutation, InsertDepartmentTypeGroupByNameMutationVariables>;
export const InsertDepartmentTypeWithGroupNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDepartmentTypeWithGroupName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentGroupName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_department_type_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department_type_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentGroupName"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"DepartmentTypeGroup_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"Name"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]}}]} as unknown as DocumentNode<InsertDepartmentTypeWithGroupNameMutation, InsertDepartmentTypeWithGroupNameMutationVariables>;
export const InsertDepartmentTypeWithOptionalGroupIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDepartmentTypeWithOptionalGroupId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_department_type_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"DepartmentTypeGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]}}]} as unknown as DocumentNode<InsertDepartmentTypeWithOptionalGroupIdMutation, InsertDepartmentTypeWithOptionalGroupIdMutationVariables>;
export const UpdateDepartmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDepartmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_department_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DepartmentTypeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"DepartmentTypeGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDepartmentTypeMutation, UpdateDepartmentTypeMutationVariables>;
export const DeleteDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocumentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const GetDocumentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetDocumentAuditByIdQuery, GetDocumentAuditByIdQueryVariables>;
export const GetDocumentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentParts"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LinkedDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attestationConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationConfigParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestDraftVersion"},"name":{"kind":"Name","value":"documentFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"draft"},{"kind":"EnumValue","value":"pending_approval"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestPublishedVersion"},"name":{"kind":"Name","value":"documentFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"archived"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AttestationConfigParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"attestation_config"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RequireGlobalAttestation"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationTimeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"PromptText"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttestationGroupParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetDocumentByIdQuery, GetDocumentByIdQueryVariables>;
export const GetDocumentListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]} as unknown as DocumentNode<GetDocumentListQuery, GetDocumentListQueryVariables>;
export const GetDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"document_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"document_file_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentAssessmentResultsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"document_assessment_result_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAssessmentResultsHistory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentParts"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"changeRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ChangeRequestStatus"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestPublishedVersion"},"name":{"kind":"Name","value":"documentFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"PublishedDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"PublishedDate"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"documentAssessmentResultsWhere"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAssessmentResultsHistory"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment_result_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ParentId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const InsertDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertChildDocumentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertDocumentMutation, InsertDocumentMutationVariables>;
export const UpdateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChildDocumentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const DeleteDocumentFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDocumentFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFileIds"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFileIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDocumentFilesMutation, DeleteDocumentFilesMutationVariables>;
export const GetDocumentFileAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentFileAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]}}]} as unknown as DocumentNode<GetDocumentFileAuditByIdQuery, GetDocumentFileAuditByIdQueryVariables>;
export const GetDocumentFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentRelationFileParts"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ChangeRequestStatus"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<GetDocumentFileByIdQuery, GetDocumentFileByIdQueryVariables>;
export const GetDocumentFilesByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentFilesByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentDocumentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentRelationFileParts"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ChangeRequestStatus"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ChangeRequestStatus"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]} as unknown as DocumentNode<GetDocumentFilesByDocumentIdQuery, GetDocumentFilesByDocumentIdQueryVariables>;
export const GetDocumentFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"document_file_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]} as unknown as DocumentNode<GetDocumentFileQuery, GetDocumentFileQueryVariables>;
export const GetLatestPublicDocumentFileByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestPublicDocumentFileByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"published"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentDocumentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicDocumentRelationFileParts"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicDocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestPublicDocumentFileByDocumentIdQuery, GetLatestPublicDocumentFileByDocumentIdQueryVariables>;
export const GetPublicDocumentFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPublicDocumentFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"published"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicDocumentRelationFileParts"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"reviewedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attestations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"Active"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicDocumentRelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"FileId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"ReasonForReview"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewDate"}},{"kind":"Field","name":{"kind":"Name","value":"ReviewedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"PublishedDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetPublicDocumentFilesQuery, GetPublicDocumentFilesQueryVariables>;
export const InsertDocumentVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDocumentVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"FileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"NextReviewDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReasonForReview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReviewDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReviewedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"document_file_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Link"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertDocumentVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"FileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"FileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"NextReviewDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"NextReviewDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentDocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentDocumentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReasonForReview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReasonForReview"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReviewDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReviewDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReviewedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReviewedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}}},{"kind":"Argument","name":{"kind":"Name","value":"Version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Version"}}},{"kind":"Argument","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}},{"kind":"Argument","name":{"kind":"Name","value":"Type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}},{"kind":"Argument","name":{"kind":"Name","value":"Link"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Link"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertDocumentVersionMutation, InsertDocumentVersionMutationVariables>;
export const UpdateDocumentVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocumentVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"FileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"LatestModifiedAtTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"NextReviewDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReasonForReview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReviewDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ReviewedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"version_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"document_file_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Link"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NextReviewDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"NextReviewDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReasonForReview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReasonForReview"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReviewDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReviewDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ReviewedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ReviewedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Summary"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"Version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Version"}}},{"kind":"Argument","name":{"kind":"Name","value":"FileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"FileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Content"}}},{"kind":"Argument","name":{"kind":"Name","value":"Type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}},{"kind":"Argument","name":{"kind":"Name","value":"Link"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Link"}}},{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"LatestModifiedAtTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"LatestModifiedAtTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentVersionMutation, UpdateDocumentVersionMutationVariables>;
export const AddRiskToEnterpriseRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addRiskToEnterpriseRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRiskToEnterpriseRiskInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addRiskToEnterpriseRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AddRiskToEnterpriseRiskMutation, AddRiskToEnterpriseRiskMutationVariables>;
export const GetEnterpriseRisksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEnterpriseRisks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise_risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"InherentScoreMean"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScoreMedian"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScoreWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreMean"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreMedian"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingMean"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingMedian"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingMean"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingMedian"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingWorstCase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnterpriseRisksQuery, GetEnterpriseRisksQueryVariables>;
export const GetEnterpriseRiskByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEnterpriseRiskById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise_risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnterpriseRiskByIdQuery, GetEnterpriseRiskByIdQueryVariables>;
export const DeleteEnterpriseRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEnterpriseRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChildEnterpriseRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteEnterpriseRiskMutation, DeleteEnterpriseRiskMutationVariables>;
export const InsertEnterpriseRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertEnterpriseRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Treatment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_treatment_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildEnterpriseRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Treatment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Treatment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Tier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertEnterpriseRiskMutation, InsertEnterpriseRiskMutationVariables>;
export const UpdateEnterpriseRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEnterpriseRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Treatment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_treatment_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildEnterpriseRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Treatment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Treatment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Tier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateEnterpriseRiskMutation, UpdateEnterpriseRiskMutationVariables>;
export const GetEnterpriseRisksByTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEnterpriseRisksByTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise_risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Tier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Tier"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]} as unknown as DocumentNode<GetEnterpriseRisksByTierQuery, GetEnterpriseRisksByTierQueryVariables>;
export const GetEnterpriseRisksFlatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEnterpriseRisksFlat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise_risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"InherentScoreMean"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScoreMedian"}},{"kind":"Field","name":{"kind":"Name","value":"InherentScoreWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreMean"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreMedian"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualScoreWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingMean"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingMedian"}},{"kind":"Field","name":{"kind":"Name","value":"InherentRatingWorstCase"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingMean"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingMedian"}},{"kind":"Field","name":{"kind":"Name","value":"ResidualRatingWorstCase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnterpriseRisksFlatQuery, GetEnterpriseRisksFlatQueryVariables>;
export const InstatiateEnterpriseRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"instatiateEnterpriseRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"EnterpriseRiskIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Entities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instantiateChildEnterpriseRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EnterpriseRiskIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"EnterpriseRiskIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Entities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Entities"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InstatiateEnterpriseRiskMutation, InstatiateEnterpriseRiskMutationVariables>;
export const GetEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Weight"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetEntitiesQuery, GetEntitiesQueryVariables>;
export const GetEntityByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEntityById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Weight"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetEntityByIdQuery, GetEntityByIdQueryVariables>;
export const InsertEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Weight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owners"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerGroups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Weight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owners"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owners"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerGroups"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertEntityMutation, InsertEntityMutationVariables>;
export const UpdateEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Weight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owners"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerGroups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Weight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"owners"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owners"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerGroups"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const DeleteEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChildEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteEntityMutation, DeleteEntityMutationVariables>;
export const DeleteRelationFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRelationFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FileId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteRelationFileByIdMutation, DeleteRelationFileByIdMutationVariables>;
export const GetFileAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetFileAuditByIdQuery, GetFileAuditByIdQueryVariables>;
export const GetFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]} as unknown as DocumentNode<GetFileByIdQuery, GetFileByIdQueryVariables>;
export const GetFormConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormConfigurationParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormConfigurationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAttributeSchema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}}]}}]} as unknown as DocumentNode<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>;
export const GetFormConfigurationAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormConfigurationAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_configuration_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeSchemaId"}}]}}]}}]} as unknown as DocumentNode<GetFormConfigurationAuditQuery, GetFormConfigurationAuditQueryVariables>;
export const GetFormConfigurationByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormConfigurationByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormConfigurationParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormConfigurationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAttributeSchema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}}]}}]} as unknown as DocumentNode<GetFormConfigurationByParentTypeQuery, GetFormConfigurationByParentTypeQueryVariables>;
export const DeleteFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFormFieldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>;
export const InsertFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertFormFieldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertFormFieldMutation, InsertFormFieldMutationVariables>;
export const UpdateFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFormFieldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>;
export const GetAllFormsCustomisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllFormsCustomisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormConfigurationParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form_field_configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form_field_ordering"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Position"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormConfigurationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAttributeSchema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}}]}}]} as unknown as DocumentNode<GetAllFormsCustomisationQuery, GetAllFormsCustomisationQueryVariables>;
export const GetFormCustomisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormCustomisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormConfigurationParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form_field_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form_field_ordering"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Position"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormConfigurationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"form_configuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAttributeSchema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Conditions"}}]}}]}}]} as unknown as DocumentNode<GetFormCustomisationQuery, GetFormCustomisationQueryVariables>;
export const GetFormFieldConfigurationAuditByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormFieldConfigurationAuditByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_field_configuration_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"FieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}}]}}]}}]} as unknown as DocumentNode<GetFormFieldConfigurationAuditByParentTypeQuery, GetFormFieldConfigurationAuditByParentTypeQueryVariables>;
export const GetFormFieldOptionsByParentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormFieldOptionsByParentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_field_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTypes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FormConfigurationParentType"}},{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Hidden"}},{"kind":"Field","name":{"kind":"Name","value":"Required"}},{"kind":"Field","name":{"kind":"Name","value":"ReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}}]}}]} as unknown as DocumentNode<GetFormFieldOptionsByParentTypeQuery, GetFormFieldOptionsByParentTypeQueryVariables>;
export const GetFormFieldOrderingAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormFieldOrderingAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_field_ordering_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"FieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}},{"kind":"Field","name":{"kind":"Name","value":"Position"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetFormFieldOrderingAuditByIdQuery, GetFormFieldOrderingAuditByIdQueryVariables>;
export const InsertFormFieldPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertFormFieldPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldConfig"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"form_field_ordering_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_form_configuration_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fields_ordering"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldConfig"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Position"},{"kind":"EnumValue","value":"FieldId"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"form_field_configuration_pkey"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"form_configuration_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ParentType"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_form_field_ordering"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertFormFieldPositionsMutation, InsertFormFieldPositionsMutationVariables>;
export const UpdateFormFieldPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFormFieldPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldConfig"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"form_field_ordering_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_form_configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_form_field_ordering"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldConfig"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Position"},{"kind":"EnumValue","value":"FormConfigurationParentType"},{"kind":"EnumValue","value":"FieldId"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"form_field_configuration_pkey"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FieldId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_form_field_ordering"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"FormConfigurationParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateFormFieldPositionsMutation, UpdateFormFieldPositionsMutationVariables>;
export const GetOwnersAndContributorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOwnersAndContributors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ancestor_contributor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}}]}}]}}]} as unknown as DocumentNode<GetOwnersAndContributorsQuery, GetOwnersAndContributorsQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FriendlyName"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RoleKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"ThirdPartyRespondent","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RoleKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Department"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"OfficeLocation"}},{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"IsCustomerSupport"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const DeleteImpactRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteImpactRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteImpactRatingMutation, DeleteImpactRatingMutationVariables>;
export const DeleteImpactRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteImpactRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteImpactRatingsMutation, DeleteImpactRatingsMutationVariables>;
export const GetImpactRatingAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]}}]} as unknown as DocumentNode<GetImpactRatingAuditByIdQuery, GetImpactRatingAuditByIdQueryVariables>;
export const GetImpactRatingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetImpactRatingByIdQuery, GetImpactRatingByIdQueryVariables>;
export const GetInternalAuditImpactRatingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditImpactRatingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_internal_audit_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_internal_audit_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetInternalAuditImpactRatingByIdQuery, GetInternalAuditImpactRatingByIdQueryVariables>;
export const GetSecondLineImpactRatingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSecondLineImpactRatingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_second_line_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_second_line_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetSecondLineImpactRatingByIdQuery, GetSecondLineImpactRatingByIdQueryVariables>;
export const GetImpactRatingCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetImpactRatingCountQuery, GetImpactRatingCountQueryVariables>;
export const GetImpactRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetImpactRatingsQuery, GetImpactRatingsQueryVariables>;
export const GetImpactRatingsByImpactIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingsByImpactId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"impactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"impactId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetImpactRatingsByImpactIdQuery, GetImpactRatingsByImpactIdQueryVariables>;
export const GetImpactRatingsByRatedItemIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingsByRatedItemId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratedItemId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetImpactRatingsByRatedItemIdQuery, GetImpactRatingsByRatedItemIdQueryVariables>;
export const GetImpactRatingsWithAppetitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactRatingsWithAppetites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RatedItemId"},{"kind":"EnumValue","value":"ImpactId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","alias":{"kind":"Name","value":"likelihoodAppetite"},"name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"likelihood"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"impactAppetites"},"name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"impact"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetImpactRatingsWithAppetitesQuery, GetImpactRatingsWithAppetitesQueryVariables>;
export const GetLatestImpactRatingsForRatedImpactsByRatedItemIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestImpactRatingsForRatedImpactsByRatedItemId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ratings"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetLatestImpactRatingsForRatedImpactsByRatedItemIdQuery, GetLatestImpactRatingsForRatedImpactsByRatedItemIdQueryVariables>;
export const InsertChildImpactRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildImpactRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertImpactRatingPairInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildImpactRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Ratings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertChildImpactRatingsMutation, InsertChildImpactRatingsMutationVariables>;
export const DeleteImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_impact_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteImpactMutation, DeleteImpactMutationVariables>;
export const GetImpactAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}}]}}]} as unknown as DocumentNode<GetImpactAuditByIdQuery, GetImpactAuditByIdQueryVariables>;
export const GetImpactByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetImpactByIdQuery, GetImpactByIdQueryVariables>;
export const GetImpactCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetImpactCountQuery, GetImpactCountQueryVariables>;
export const GetImpactListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpactList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}}]}}]}}]} as unknown as DocumentNode<GetImpactListQuery, GetImpactListQueryVariables>;
export const GetImpactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getImpacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RatedItemId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}}]} as unknown as DocumentNode<GetImpactsQuery, GetImpactsQueryVariables>;
export const InsertImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertImpactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertImpactApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertImpactMutation, InsertImpactMutationVariables>;
export const UpdateImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateImpactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImpactApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateImpactMutation, UpdateImpactMutationVariables>;
export const DeleteIndicatorResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIndicatorResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_indicator_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteIndicatorResultsMutation, DeleteIndicatorResultsMutationVariables>;
export const GetIndicatorResultAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorResultAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator_result_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ResultDate"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueNum"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetIndicatorResultAuditByIdQuery, GetIndicatorResultAuditByIdQueryVariables>;
export const GetIndicatorResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ResultDate"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueNum"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetIndicatorResultByIdQuery, GetIndicatorResultByIdQueryVariables>;
export const GetIndicatorResultsByIndicatorIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorResultsByIndicatorId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"indicatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IndicatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indicatorId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ResultDate"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ResultDate"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueNum"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]}}]}}]} as unknown as DocumentNode<GetIndicatorResultsByIndicatorIdQuery, GetIndicatorResultsByIndicatorIdQueryVariables>;
export const InsertIndicatorResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertIndicatorResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IndicatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ResultDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueNum"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueTxt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_indicator_result_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"IndicatorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IndicatorId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ResultDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ResultDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetValueNum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueNum"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetValueTxt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueTxt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertIndicatorResultMutation, InsertIndicatorResultMutationVariables>;
export const UpdateIndicatorResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIndicatorResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ResultDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueNum"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueTxt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_indicator_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ResultDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ResultDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetValueNum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueNum"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetValueTxt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetValueTxt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIndicatorResultMutation, UpdateIndicatorResultMutationVariables>;
export const DeleteIndicatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIndicators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_indicator_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IndicatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteIndicatorsMutation, DeleteIndicatorsMutationVariables>;
export const GetIndicatorAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}}]}}]}}]} as unknown as DocumentNode<GetIndicatorAuditByIdQuery, GetIndicatorAuditByIdQueryVariables>;
export const GetIndicatorByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndicatorParts"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetIndicatorByIdQuery, GetIndicatorByIdQueryVariables>;
export const GetIndicatorTitlesByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorTitlesByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<GetIndicatorTitlesByParentIdQuery, GetIndicatorTitlesByParentIdQueryVariables>;
export const GetIndicatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indicator_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indicator_result_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndicatorParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orderedResults"},"name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ResultDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TargetValueNum"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"ResultDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetIndicatorsQuery, GetIndicatorsQueryVariables>;
export const GetIndicatorsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIndicatorsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndicatorParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orderedResults"},"name":{"kind":"Name","value":"results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ResultDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TargetValueNum"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"ResultDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetIndicatorsByParentIdQuery, GetIndicatorsByParentIdQueryVariables>;
export const InsertIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertChildIndicatorInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertIndicatorMutation, InsertIndicatorMutationVariables>;
export const UpdateIndicatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIndicator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChildIndicatorInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildIndicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;
export const DeleteInternalAuditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteInternalAudits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_internal_audit_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteInternalAuditsMutation, DeleteInternalAuditsMutationVariables>;
export const GetInternalAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditEntityParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditEntityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"businessArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetInternalAuditByIdQuery, GetInternalAuditByIdQueryVariables>;
export const GetInternalAuditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAudits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_entity_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditEntityParts"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditEntityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"businessArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetInternalAuditsQuery, GetInternalAuditsQueryVariables>;
export const GetLinkedRisksByInternalAuditIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkedRisksByInternalAuditId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"linked_risks"},"name":{"kind":"Name","value":"linked_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_risk"},"value":{"kind":"ObjectValue","fields":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","alias":{"kind":"Name","value":"risk"},"name":{"kind":"Name","value":"target_risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactRatings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ImpactId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"impactRatingsForTrend"},"name":{"kind":"Name","value":"impactRatings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"controls_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetLinkedRisksByInternalAuditIdQuery, GetLinkedRisksByInternalAuditIdQueryVariables>;
export const InsertInternalAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInternalAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertInternalAuditInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInternalAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertInternalAuditMutation, InsertInternalAuditMutationVariables>;
export const UpdateInternalAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInternalAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateInternalAuditInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInternalAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateInternalAuditMutation, UpdateInternalAuditMutationVariables>;
export const DeleteInternalAuditReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteInternalAuditReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_internal_audit_report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteInternalAuditReportsMutation, DeleteInternalAuditReportsMutationVariables>;
export const GetInternalAuditReportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportByIdQuery, GetInternalAuditReportByIdQueryVariables>;
export const GetInternalAuditReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assessedItems"},"name":{"kind":"Name","value":"assessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uncontrolledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportsQuery, GetInternalAuditReportsQueryVariables>;
export const GetInternalAuditReportsByOriginatingItemIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportsByOriginatingItemId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginatingItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OriginatingItemId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginatingItemId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assessedItems"},"name":{"kind":"Name","value":"assessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uncontrolledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportsByOriginatingItemIdQuery, GetInternalAuditReportsByOriginatingItemIdQueryVariables>;
export const InsertInternalAuditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInternalAuditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInternalAuditReportApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertInternalAuditReportMutation, InsertInternalAuditReportMutationVariables>;
export const UpdateInternalAuditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInternalAuditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInternalAuditReportApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateInternalAuditReportMutation, UpdateInternalAuditReportMutationVariables>;
export const DeleteInternalAuditResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteInternalAuditResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_impact_internal_audit_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteInternalAuditResultsMutation, DeleteInternalAuditResultsMutationVariables>;
export const GetAllInternalAuditReportResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllInternalAuditReportResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"internalAuditReports"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"documents"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"internalAuditReports"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"obligations"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"internalAuditReports"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risks"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"internalAuditReports"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risks"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetAllInternalAuditReportResultsQuery, GetAllInternalAuditReportResultsQueryVariables>;
export const GetDocumentInternalAuditResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentInternalAuditResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetDocumentInternalAuditResultByIdQuery, GetDocumentInternalAuditResultByIdQueryVariables>;
export const GetInternalAuditReportDocumentAssessmentResultsByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportDocumentAssessmentResultsByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery, GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQueryVariables>;
export const GetInternalAuditReportObligationAssessmentResultsByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportObligationAssessmentResultsByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery, GetInternalAuditReportObligationAssessmentResultsByObligationIdQueryVariables>;
export const GetInternalAuditReportRiskAssessmentResultsByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportRiskAssessmentResultsByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportRiskAssessmentResultsByRiskIdQuery, GetInternalAuditReportRiskAssessmentResultsByRiskIdQueryVariables>;
export const GetInternalAuditReportTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetInternalAuditReportTestResultsByControlIdQuery, GetInternalAuditReportTestResultsByControlIdQueryVariables>;
export const GetInternalAuditResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_result_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ResultType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uncontrolledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_internal_audit_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetInternalAuditResultByIdQuery, GetInternalAuditResultByIdQueryVariables>;
export const GetInternalAuditResultsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditResultsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact_internal_audit_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"consequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifiedIndividual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RatedItemId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactInternalAuditRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_internal_audit_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetInternalAuditResultsByParentIdQuery, GetInternalAuditResultsByParentIdQueryVariables>;
export const GetInternalAuditTestResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditTestResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetInternalAuditTestResultByIdQuery, GetInternalAuditTestResultByIdQueryVariables>;
export const GetLatestInternalAuditReportDocumentAssessmentResultByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestInternalAuditReportDocumentAssessmentResultByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestInternalAuditReportDocumentAssessmentResultByDocumentIdQuery, GetLatestInternalAuditReportDocumentAssessmentResultByDocumentIdQueryVariables>;
export const GetLatestInternalAuditReportObligationAssessmentResultByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestInternalAuditReportObligationAssessmentResultByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQuery, GetLatestInternalAuditReportObligationAssessmentResultByObligationIdQueryVariables>;
export const GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestInternalAuditReportRiskAssessmentResultsByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uncontrolled"},"name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"controlled"},"name":{"kind":"Name","value":"risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdQuery, GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdQueryVariables>;
export const GetLatestInternalAuditReportTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestInternalAuditReportTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"internal_audit_report"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestInternalAuditReportTestResultsByControlIdQuery, GetLatestInternalAuditReportTestResultsByControlIdQueryVariables>;
export const GetObligationInternalAuditResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationInternalAuditResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetObligationInternalAuditResultByIdQuery, GetObligationInternalAuditResultByIdQueryVariables>;
export const GetRiskInternalAuditResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskInternalAuditResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledInternalAuditResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetRiskInternalAuditResultByIdQuery, GetRiskInternalAuditResultByIdQueryVariables>;
export const InsertInternalAuditTestResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInternalAuditTestResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildControlTestInternalAuditResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"DesignEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"OverallEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"PerformanceEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"Submitter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"InternalAuditReportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertInternalAuditTestResultMutation, InsertInternalAuditTestResultMutationVariables>;
export const InsertDocumentInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDocumentInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildDocumentInternalAuditResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"InternalAuditReportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"DocumentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertDocumentInternalAuditResultMutation, InsertDocumentInternalAuditResultMutationVariables>;
export const InsertInternalAuditImpactRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertInternalAuditImpactRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertImpactRatingPairInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildImpactInternalAuditRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"InternalAuditReportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Ratings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertInternalAuditImpactRatingMutation, InsertInternalAuditImpactRatingMutationVariables>;
export const InsertObligationInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertObligationInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildObligationInternalAuditResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"InternalAuditReportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ObligationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertObligationInternalAuditResultMutation, InsertObligationInternalAuditResultMutationVariables>;
export const InsertRiskInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertRiskInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result_control_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildRiskInternalAuditResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"InternalAuditReportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditReportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"RiskIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertRiskInternalAuditResultMutation, InsertRiskInternalAuditResultMutationVariables>;
export const UpdateControlTestInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControlTestInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTestResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateControlTestInternalAuditResultApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateControlTestInternalAuditResultMutation, UpdateControlTestInternalAuditResultMutationVariables>;
export const UpdateDocumentInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocumentInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_document_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentInternalAuditResultMutation, UpdateDocumentInternalAuditResultMutationVariables>;
export const UpdateObligationInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateObligationInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_obligation_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateObligationInternalAuditResultMutation, UpdateObligationInternalAuditResultMutationVariables>;
export const UpdateControlledRiskInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControlledRiskInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_risk_controlled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateControlledRiskInternalAuditResultMutation, UpdateControlledRiskInternalAuditResultMutationVariables>;
export const UpdateUncontrolledRiskInternalAuditResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUncontrolledRiskInternalAuditResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_risk_uncontrolled_internal_audit_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUncontrolledRiskInternalAuditResultMutation, UpdateUncontrolledRiskInternalAuditResultMutationVariables>;
export const DeleteIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIssuesById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteIssuesMutation, DeleteIssuesMutationVariables>;
export const GetIssueAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetIssueAuditByIdQuery, GetIssueAuditByIdQueryVariables>;
export const GetIssueByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetIssueByIdQuery, GetIssueByIdQueryVariables>;
export const GetIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"consequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifiedIndividual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalAuditReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueUpdateSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Count"}},{"kind":"Field","name":{"kind":"Name","value":"LatestTitle"}},{"kind":"Field","name":{"kind":"Name","value":"LatestDescription"}},{"kind":"Field","name":{"kind":"Name","value":"LatestCreatedAtTimestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]} as unknown as DocumentNode<GetIssuesQuery, GetIssuesQueryVariables>;
export const GetIssuesByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssuesByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetIssuesByParentIdQuery, GetIssuesByParentIdQueryVariables>;
export const GetOldestOpenIssueDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOldestOpenIssueDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetOldestOpenIssueDateQuery, GetOldestOpenIssueDateQueryVariables>;
export const GetWidgetIssueCausesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetIssueCauses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"causes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]} as unknown as DocumentNode<GetWidgetIssueCausesQuery, GetWidgetIssueCausesQueryVariables>;
export const GetWidgetIssuesByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetIssuesByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IssueType"}}]}}]}}]} as unknown as DocumentNode<GetWidgetIssuesByTypeQuery, GetWidgetIssuesByTypeQueryVariables>;
export const InsertChildIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<InsertChildIssueMutation, InsertChildIssueMutationVariables>;
export const GetOpenIssueAssessmentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOpenIssueAssessmentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_assessment_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOpenIssueAssessmentCountQuery, GetOpenIssueAssessmentCountQueryVariables>;
export const UpdateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssueApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateIssueMutation, UpdateIssueMutationVariables>;
export const GetIssueAssessmentAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueAssessmentAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_assessment_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetIssueAssessmentAuditByIdQuery, GetIssueAssessmentAuditByIdQueryVariables>;
export const GetIssueAssessmentByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueAssessmentByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentIssueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentIssueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"policyOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifiedIndividual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentIssueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IssueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentIssueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]} as unknown as DocumentNode<GetIssueAssessmentByParentIdQuery, GetIssueAssessmentByParentIdQueryVariables>;
export const InsertIssueAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertIssueAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ActualCloseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetCloseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CertifiedIndividual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreached"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyBreach"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulatoryBreach"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreached"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Reportable"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Severity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment_status_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"SystemResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreachedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssociatedControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreachedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildIssueAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ActualCloseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ActualCloseDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ThirdPartyResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyResponsible"}}},{"kind":"Argument","name":{"kind":"Name","value":"TargetCloseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetCloseDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyOwnerCommentary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwnerCommentary"}}},{"kind":"Argument","name":{"kind":"Name","value":"CertifiedIndividual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CertifiedIndividual"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueCausedBySystemIssue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueCausedByThirdParty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedByThirdParty"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueType"}}},{"kind":"Argument","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"PoliciesBreached"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreached"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwner"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyBreach"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyBreach"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulatoryBreach"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulatoryBreach"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulationsBreached"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreached"}}},{"kind":"Argument","name":{"kind":"Name","value":"Reportable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Reportable"}}},{"kind":"Argument","name":{"kind":"Name","value":"Severity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Severity"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"SystemResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"SystemResponsible"}}},{"kind":"Argument","name":{"kind":"Name","value":"TagTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"DepartmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssociatedControlIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssociatedControlIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulationsBreachedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreachedIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"PoliciesBreachedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreachedIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertIssueAssessmentMutation, InsertIssueAssessmentMutationVariables>;
export const UpdateIssueAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIssueAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ActualCloseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TargetCloseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CertifiedIndividual"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IssueType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreached"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PolicyBreach"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulatoryBreach"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreached"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Reportable"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Severity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment_status_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"SystemResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreachedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreachedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssociatedControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildIssueAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"OriginalTimestamp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}},{"kind":"Argument","name":{"kind":"Name","value":"ActualCloseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ActualCloseDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"ThirdPartyResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyResponsible"}}},{"kind":"Argument","name":{"kind":"Name","value":"TargetCloseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TargetCloseDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyOwnerCommentary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwnerCommentary"}}},{"kind":"Argument","name":{"kind":"Name","value":"CertifiedIndividual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CertifiedIndividual"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueCausedBySystemIssue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueCausedByThirdParty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueCausedByThirdParty"}}},{"kind":"Argument","name":{"kind":"Name","value":"IssueType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IssueType"}}},{"kind":"Argument","name":{"kind":"Name","value":"PoliciesBreached"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreached"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyOwner"}}},{"kind":"Argument","name":{"kind":"Name","value":"PolicyBreach"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PolicyBreach"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulatoryBreach"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulatoryBreach"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulationsBreached"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreached"}}},{"kind":"Argument","name":{"kind":"Name","value":"Reportable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Reportable"}}},{"kind":"Argument","name":{"kind":"Name","value":"Severity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Severity"}}},{"kind":"Argument","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}},{"kind":"Argument","name":{"kind":"Name","value":"SystemResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"SystemResponsible"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssociatedControlIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssociatedControlIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"RegulationsBreachedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RegulationsBreachedIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"PoliciesBreachedIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PoliciesBreachedIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"TagTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"DepartmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DepartmentTypeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateIssueAssessmentMutation, UpdateIssueAssessmentMutationVariables>;
export const GetIssueAssessmentHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueAssessmentHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment_audit_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_assessment_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Action"}}]}}]}}]} as unknown as DocumentNode<GetIssueAssessmentHistoryQuery, GetIssueAssessmentHistoryQueryVariables>;
export const DeleteIssueUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIssueUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relationFile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_issue_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteIssueUpdatesMutation, DeleteIssueUpdatesMutationVariables>;
export const GetIssueUpdateAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueUpdateAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_update_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetIssueUpdateAuditByIdQuery, GetIssueUpdateAuditByIdQueryVariables>;
export const GetIssueUpdateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueUpdateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueUpdateParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetIssueUpdateByIdQuery, GetIssueUpdateByIdQueryVariables>;
export const GetIssueUpdatesByParentIssueIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueUpdatesByParentIssueId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueUpdateParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetIssueUpdatesByParentIssueIdQuery, GetIssueUpdatesByParentIssueIdQueryVariables>;
export const InsertIssueUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertIssueUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_issue_update_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertIssueUpdateMutation, InsertIssueUpdateMutationVariables>;
export const UpdateIssueUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIssueUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_issue_update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentIssueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentIssueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateIssueUpdateMutation, UpdateIssueUpdateMutationVariables>;
export const DeleteLinkedItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteLinkedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<DeleteLinkedItemsMutation, DeleteLinkedItemsMutationVariables>;
export const GetLinkedItemAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkedItemAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risksmart_linked_item_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Source"}},{"kind":"Field","name":{"kind":"Name","value":"Target"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}}]}}]}}]} as unknown as DocumentNode<GetLinkedItemAuditQuery, GetLinkedItemAuditQueryVariables>;
export const GetLinkedItemRisksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkedItemRisks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linked_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"risk","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Source"}},{"kind":"Field","name":{"kind":"Name","value":"Target"}},{"kind":"Field","name":{"kind":"Name","value":"target_risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}}]} as unknown as DocumentNode<GetLinkedItemRisksQuery, GetLinkedItemRisksQueryVariables>;
export const GetLinkedItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLinkedItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IncludeInternalAudit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IncludeCompliance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linked_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Source"}},{"kind":"Field","name":{"kind":"Name","value":"Target"}},{"kind":"Field","name":{"kind":"Name","value":"RelationshipType"}},{"kind":"Field","name":{"kind":"Name","value":"target_node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_control_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_assessment_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentActivityParts"}},{"kind":"Field","name":{"kind":"Name","value":"parentInternalAuditReport"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IncludeInternalAudit"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentComplianceMonitoringAssessment"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IncludeCompliance"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_internal_audit_report"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IncludeInternalAudit"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditReportParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_internal_audit_entity"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IncludeInternalAudit"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalAuditEntityParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_obligation_impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentObligationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_impact_rating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_indicator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndicatorParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptanceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_consequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsequenceParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_cause"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CauseParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_test_result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_action_update"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_issue_update"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueUpdateParts"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"target_third_party"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ThirdPartyParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Owner"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalProvider"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"DocumentType"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocument"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentActivityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityType"}},{"kind":"Field","name":{"kind":"Name","value":"CompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"AssignedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsRCSA"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditReportParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalAuditEntityParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internal_audit_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"businessArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndicatorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"indicator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"UpperToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Unit"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetValueTxt"}},{"kind":"Field","name":{"kind":"Name","value":"LowerToleranceNum"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetiteNum"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptanceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"DateAcceptedTo"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"RequestedByUserGroup"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsequenceParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"consequence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CauseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cause"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Significance"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"CompaniesHouseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"Address"}},{"kind":"Field","name":{"kind":"Name","value":"CityTown"}},{"kind":"Field","name":{"kind":"Name","value":"Postcode"}},{"kind":"Field","name":{"kind":"Name","value":"Country"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyDomain"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]} as unknown as DocumentNode<GetLinkedItemsQuery, GetLinkedItemsQueryVariables>;
export const LinkItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Targets"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Source"}}},{"kind":"Argument","name":{"kind":"Name","value":"Targets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Targets"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Source"}},{"kind":"Field","name":{"kind":"Name","value":"Target"}},{"kind":"Field","name":{"kind":"Name","value":"RelationshipType"}}]}}]}}]}}]} as unknown as DocumentNode<LinkItemsMutation, LinkItemsMutationVariables>;
export const GetModulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getModules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_module"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ModuleSettings"}}]}}]}}]} as unknown as DocumentNode<GetModulesQuery, GetModulesQueryVariables>;
export const UpdateModulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateModules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ModuleSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_module"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModuleSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ModuleSettings"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"organisation_module_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ModuleSettings"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateModulesMutation, UpdateModulesMutationVariables>;
export const GetMyDueItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMyDueItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"control_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentActivityFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"assessment_activity_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"document_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obligationFilterConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsChangeRequestParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"riskFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleState"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"actionFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"closed"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DateDue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"assessmentFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"complete"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TargetCompletionDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"controlFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleState"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"issueFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"closed"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"TargetCloseDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment_activity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"assessmentActivityFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IsRCSA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"complete"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentRisk"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleState"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"RiskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentRisk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attestation_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AttestationStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ExpiresAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"AttestationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"documentFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleState"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"obligationFilterConditions"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleState"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"DueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyItemsContributorGroupParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsChangeRequestParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"change_request"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Approved"}},{"kind":"Field","name":{"kind":"Name","value":"approver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"OwnerApprover"}},{"kind":"Field","name":{"kind":"Name","value":"level"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ApprovalRuleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue_assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentUserOwnerList"},"name":{"kind":"Name","value":"parentOwnerAndContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ContributorType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"owner","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UserId"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsOwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyItemsContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyDueItemsQuery, GetMyDueItemsQueryVariables>;
export const GetMyItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMyItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Purpose"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ancestorContributors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetMyItemsQuery, GetMyItemsQueryVariables>;
export const GetAcceptanceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAcceptanceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"acceptance_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAcceptanceCountQuery, GetAcceptanceCountQueryVariables>;
export const GetAppetiteCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppetiteCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppetiteCountQuery, GetAppetiteCountQueryVariables>;
export const GetAssessmentActivityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentActivityCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_activity_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentAssessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssessmentActivityCountQuery, GetAssessmentActivityCountQueryVariables>;
export const GetAssessmentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssessmentCountQuery, GetAssessmentCountQueryVariables>;
export const GetAssessmentResultCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssessmentResultCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_assessment_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_assessment_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssessmentResultCountQuery, GetAssessmentResultCountQueryVariables>;
export const GetCauseCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCauseCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cause_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetCauseCountQuery, GetCauseCountQueryVariables>;
export const GetComplianceMonitoringAssessmentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compliance_monitoring_assessment_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentCountQuery, GetComplianceMonitoringAssessmentCountQueryVariables>;
export const GetComplianceMonitoringAssessmentResultCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentResultCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_second_line_result_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentResultCountQuery, GetComplianceMonitoringAssessmentResultCountQueryVariables>;
export const GetConsequenceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConsequenceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"consequence_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consequence_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetConsequenceCountQuery, GetConsequenceCountQueryVariables>;
export const GetControlCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"control_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetControlCountQuery, GetControlCountQueryVariables>;
export const GetControlGroupCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlGroupCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_group_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetControlGroupCountQuery, GetControlGroupCountQueryVariables>;
export const GetInternalAuditReportCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internal_audit_report_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetInternalAuditReportCountQuery, GetInternalAuditReportCountQueryVariables>;
export const GetInternalAuditReportResultCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalAuditReportResultCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_internal_audit_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_internal_audit_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_internal_audit_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_internal_audit_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalAuditReport"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetInternalAuditReportResultCountQuery, GetInternalAuditReportResultCountQueryVariables>;
export const GetIssueCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIssueCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"issue_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetIssueCountQuery, GetIssueCountQueryVariables>;
export const GetRiskCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetRiskCountQuery, GetRiskCountQueryVariables>;
export const GetTestResultCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTestResultCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"test_result_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetTestResultCountQuery, GetTestResultCountQueryVariables>;
export const GetObjectTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObjectTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"node"},"name":{"kind":"Name","value":"node_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]} as unknown as DocumentNode<GetObjectTypeByIdQuery, GetObjectTypeByIdQueryVariables>;
export const DisconnectSlackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"disconnectSlack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disconnectSlack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DisconnectSlackMutation, DisconnectSlackMutationVariables>;
export const GetNotificationListDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotificationListDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"indicatorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"riskIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFileIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentDocumentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indicatorIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]} as unknown as DocumentNode<GetNotificationListDetailsQuery, GetNotificationListDetailsQueryVariables>;
export const GetNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"channel_types"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workflows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slackNotificationConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connected"}}]}}]}}]} as unknown as DocumentNode<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>;
export const UpdateNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferenceSet"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preferenceSet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferenceSet"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const DeleteObligationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteObligation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_obligation_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentObligationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteObligationMutation, DeleteObligationMutationVariables>;
export const GetObligationAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}}]}}]} as unknown as DocumentNode<GetObligationAuditByIdQuery, GetObligationAuditByIdQueryVariables>;
export const GetObligationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"CreatedBy"},"name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ModifiedBy"},"name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"Parent"},"name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalProvider"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetObligationByIdQuery, GetObligationByIdQueryVariables>;
export const GetObligationListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetObligationListQuery, GetObligationListQueryVariables>;
export const GetObligationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obligationAssessmentResultsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_assessment_result_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAssessmentResultsHistory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","alias":{"kind":"Name","value":"CreatedBy"},"name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ModifiedBy"},"name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"Parent"},"name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controls_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"BreachedIssues"},"name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assessment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"open"},{"kind":"EnumValue","value":"pending"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RegulatoryBreach"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreachedIssuesParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"obligationAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"obligationAssessmentResultsWhere"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"obligationAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"obligationAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAssessmentResultsHistory"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment_result_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"obligationAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ParentId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"obligationAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimplifiedIssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Adherence"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Interpretation"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalProvider"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreachedIssuesParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_parent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimplifiedIssueParts"}}]}}]}}]} as unknown as DocumentNode<GetObligationsQuery, GetObligationsQueryVariables>;
export const GetObligationsByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationsByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<GetObligationsByTypeQuery, GetObligationsByTypeQueryVariables>;
export const InsertObligationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertObligation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertChildObligationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildObligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertObligationMutation, InsertObligationMutationVariables>;
export const UpdateObligationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateObligation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChildObligationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildObligation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateObligationMutation, UpdateObligationMutationVariables>;
export const GetObligationChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_change"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ObligationId"}},{"kind":"Field","name":{"kind":"Name","value":"ExternalId"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"Regulator"}},{"kind":"Field","name":{"kind":"Name","value":"Reference"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attestations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}}]} as unknown as DocumentNode<GetObligationChangesQuery, GetObligationChangesQueryVariables>;
export const DeleteImpactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteImpacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_obligation_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteImpactsMutation, DeleteImpactsMutationVariables>;
export const GetObligationImpactAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationImpactAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_impact_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactRating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetObligationImpactAuditByIdQuery, GetObligationImpactAuditByIdQueryVariables>;
export const GetObligationImpactByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationImpactById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactRating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetObligationImpactByIdQuery, GetObligationImpactByIdQueryVariables>;
export const GetObligationImpactsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationImpactsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentObligationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactRating"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ParentObligationId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetObligationImpactsByParentIdQuery, GetObligationImpactsByParentIdQueryVariables>;
export const InsertObligationImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertObligationImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactRating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"smallint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_obligation_impact_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ParentObligationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentObligationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertObligationImpactMutation, InsertObligationImpactMutationVariables>;
export const UpdateObligationImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateObligationImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ImpactRating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"smallint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_obligation_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ImpactRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateObligationImpactMutation, UpdateObligationImpactMutationVariables>;
export const GetOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrganisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"ScimEnabled"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const UpdateOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ScimEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_auth_organisation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OrgKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ScimEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ScimEnabled"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const GetQuestionnaireInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestionnaireInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionnaire_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thirdPartyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"UserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionnaireTemplateVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetQuestionnaireInvitesQuery, GetQuestionnaireInvitesQueryVariables>;
export const InsertQuestionnaireInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertQuestionnaireInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaires"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertQuestionnaireInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thirdPartyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"UserEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"Message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"QuestionnaireTemplateVersionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaires"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertQuestionnaireInvitesMutation, InsertQuestionnaireInvitesMutationVariables>;
export const DeleteQuestionnaireTemplateVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteQuestionnaireTemplateVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateVersionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_questionnaire_template_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateVersionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteQuestionnaireTemplateVersionsMutation, DeleteQuestionnaireTemplateVersionsMutationVariables>;
export const GetLatestQuestionnaireTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestQuestionnaireTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template_version_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionnaire_template_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"UISchema"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetLatestQuestionnaireTemplateVersionQuery, GetLatestQuestionnaireTemplateVersionQueryVariables>;
export const GetQuestionnaireTemplateVersionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestionnaireTemplateVersionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"questionnaire_template_version"},"name":{"kind":"Name","value":"questionnaire_template_version_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"UISchema"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetQuestionnaireTemplateVersionByIdQuery, GetQuestionnaireTemplateVersionByIdQueryVariables>;
export const GetQuestionnaireTemplateVersionsByQuestionnaireTemplateIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestionnaireTemplateVersionsByQuestionnaireTemplateId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionnaire_template_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"UISchema"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]}}]} as unknown as DocumentNode<GetQuestionnaireTemplateVersionsByQuestionnaireTemplateIdQuery, GetQuestionnaireTemplateVersionsByQuestionnaireTemplateIdQueryVariables>;
export const InsertQuestionnaireTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertQuestionnaireTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template_version_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_questionnaire_template_version_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertQuestionnaireTemplateVersionMutation, InsertQuestionnaireTemplateVersionMutationVariables>;
export const PublishQuestionnaireTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishQuestionnaireTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishQuestionnaireTemplateVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"QuestionnaireTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireTemplateVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<PublishQuestionnaireTemplateVersionMutation, PublishQuestionnaireTemplateVersionMutationVariables>;
export const UpdateQuestionnaireTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuestionnaireTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template_version_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_questionnaire_template_version_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateQuestionnaireTemplateVersionMutation, UpdateQuestionnaireTemplateVersionMutationVariables>;
export const DeleteQuestionnaireTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteQuestionnaireTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_questionnaire_template_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_questionnaire_template_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteQuestionnaireTemplateMutation, DeleteQuestionnaireTemplateMutationVariables>;
export const GetQuestionnaireTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestionnaireTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"questionnaire_template"},"name":{"kind":"Name","value":"questionnaire_template_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionnaireTemplateParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"draftVersions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"draft"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonDraftVersions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"draft"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publishedVersion"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"published"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionnaireTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetQuestionnaireTemplateByIdQuery, GetQuestionnaireTemplateByIdQueryVariables>;
export const GetQuestionnaireTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestionnaireTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionnaire_template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionnaireTemplateParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"draftVersions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"draft"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nonDraftVersions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"draft"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publishedVersion"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"published"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionnaireTemplateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"questionnaire_template"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetQuestionnaireTemplatesQuery, GetQuestionnaireTemplatesQueryVariables>;
export const InsertQuestionnaireTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertQuestionnaireTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertQuestionnaireTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertQuestionnaireTemplateApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertQuestionnaireTemplateMutation, InsertQuestionnaireTemplateMutationVariables>;
export const UpdateQuestionnaireTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuestionnaireTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQuestionnaireTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuestionnaireTemplateApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateQuestionnaireTemplateMutation, UpdateQuestionnaireTemplateMutationVariables>;
export const GetReportingDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportingData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportingDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportingData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]} as unknown as DocumentNode<GetReportingDataQuery, GetReportingDataQueryVariables>;
export const GetReportingFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportingFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportingFilterOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportingFilterOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetReportingFilterOptionsQuery, GetReportingFilterOptionsQueryVariables>;
export const DeleteRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRiskById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteRiskMutation, DeleteRiskMutationVariables>;
export const GetRiskAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetRiskAuditByIdQuery, GetRiskAuditByIdQueryVariables>;
export const GetRiskByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_eq"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"EntityId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetRiskByIdQuery, GetRiskByIdQueryVariables>;
export const GetRiskListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetRiskListQuery, GetRiskListQueryVariables>;
export const GetRiskListOnlyOptimizedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskListOnlyOptimized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetRiskListOnlyOptimizedQuery, GetRiskListOnlyOptimizedQueryVariables>;
export const GetRiskListOnlyWithEntitiesOptimizedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskListOnlyWithEntitiesOptimized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}}]}}]} as unknown as DocumentNode<GetRiskListOnlyWithEntitiesOptimizedQuery, GetRiskListOnlyWithEntitiesOptimizedQueryVariables>;
export const GetRiskListOptimizedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskListOptimized"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetRiskListOptimizedQuery, GetRiskListOptimizedQueryVariables>;
export const GetRiskListWithEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskListWithEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}}]}}]} as unknown as DocumentNode<GetRiskListWithEntitiesQuery, GetRiskListWithEntitiesQueryVariables>;
export const GetRiskWithOwnContributionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskWithOwnContributions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentUserId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetRiskWithOwnContributionsQuery, GetRiskWithOwnContributionsQueryVariables>;
export const GetRisksByTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRisksByTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRisksByTierQuery, GetRisksByTierQueryVariables>;
export const GetRisksFlatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRisksFlat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"riskAssessmentResultsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LatestDate"}},{"kind":"Field","name":{"kind":"Name","value":"DueDate"}},{"kind":"Field","name":{"kind":"Name","value":"OverdueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AppetiteType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appetite"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appetite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactRatings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ImpactId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ImpactId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"impactRatingsForTrend"},"name":{"kind":"Name","value":"impactRatings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"riskAssessmentResultsWhere"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"riskAssessmentResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"riskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"ControlType"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"controls_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"indicators_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRisk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetRisksFlatQuery, GetRisksFlatQueryVariables>;
export const GetRisksWithAncestorContributorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRisksWithAncestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetRisksWithAncestorContributorsQuery, GetRisksWithAncestorContributorsQueryVariables>;
export const GetRisksWithAncestorContributorsAndEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRisksWithAncestorContributorsAndEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskParts"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseRiskInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Tier"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ParentRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Treatment"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseRiskInstanceWithEntityHierarchyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enterprise_risk_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EntityId"}},{"kind":"Field","name":{"kind":"Name","value":"EnterpriseRiskId"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetRisksWithAncestorContributorsAndEntitiesQuery, GetRisksWithAncestorContributorsAndEntitiesQueryVariables>;
export const InsertRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertChildRiskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertRiskMutation, InsertRiskMutationVariables>;
export const UpdateRiskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRisk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChildRiskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChildRisk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateRiskMutation, UpdateRiskMutationVariables>;
export const GetRiskAssessmentResultConfigAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultConfigAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result_config_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Config"}},{"kind":"Field","name":{"kind":"Name","value":"IsLatest"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultConfigAuditByIdQuery, GetRiskAssessmentResultConfigAuditByIdQueryVariables>;
export const GetRiskAssessmentResultImpactAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskAssessmentResultImpactAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_assessment_result_impact_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"RiskAssessmentResultId"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetRiskAssessmentResultImpactAuditByIdQuery, GetRiskAssessmentResultImpactAuditByIdQueryVariables>;
export const GetRoleAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoleAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role_access"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AccessType"}},{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}}]} as unknown as DocumentNode<GetRoleAccessQuery, GetRoleAccessQueryVariables>;
export const GetAvailableRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available_roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetAvailableRolesQuery, GetAvailableRolesQueryVariables>;
export const GetDefaultRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_role_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Category"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ResourceType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultRolesQuery, GetDefaultRolesQueryVariables>;
export const DeleteScimDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScimDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_scim_domain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedDomains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScimDomainMutation, DeleteScimDomainMutationVariables>;
export const DeleteScimTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScimToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_scim_token"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyId"}}]}}]}}]} as unknown as DocumentNode<DeleteScimTokenMutation, DeleteScimTokenMutationVariables>;
export const GetScimConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getScimConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getScimConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyId"}},{"kind":"Field","name":{"kind":"Name","value":"orgKey"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"expiresOn"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyTokens"}}]}}]}}]} as unknown as DocumentNode<GetScimConfigQuery, GetScimConfigQueryVariables>;
export const InsertScimDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertScimDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_scim_domain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<InsertScimDomainMutation, InsertScimDomainMutationVariables>;
export const InsertScimTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertScimToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireInMonths"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_scim_token"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"expireInMonths"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireInMonths"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyId"}},{"kind":"Field","name":{"kind":"Name","value":"orgKey"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"expiresOn"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<InsertScimTokenMutation, InsertScimTokenMutationVariables>;
export const DeleteSecondLineResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSecondLineResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_impact_second_line_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteSecondLineResultsMutation, DeleteSecondLineResultsMutationVariables>;
export const GetAllComplianceMonitoringAssessmentResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllComplianceMonitoringAssessmentResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"complianceMonitoringAssessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"documents"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"complianceMonitoringAssessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"obligations"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"complianceMonitoringAssessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risks"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}},{"kind":"Field","alias":{"kind":"Name","value":"complianceMonitoringAssessments"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"risks"},"name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetAllComplianceMonitoringAssessmentResultsQuery, GetAllComplianceMonitoringAssessmentResultsQueryVariables>;
export const GetComplianceMonitoringAssessmentTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentTestResultsByControlIdQuery, GetComplianceMonitoringAssessmentTestResultsByControlIdQueryVariables>;
export const GetComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentIdQuery, GetComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentIdQueryVariables>;
export const GetComplianceMonitoringAssessmentObligationAssessmentResultsByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentObligationAssessmentResultsByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentObligationAssessmentResultsByObligationIdQuery, GetComplianceMonitoringAssessmentObligationAssessmentResultsByObligationIdQueryVariables>;
export const GetComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQuery, GetComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQueryVariables>;
export const GetDocumentSecondLineResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentSecondLineResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetDocumentSecondLineResultByIdQuery, GetDocumentSecondLineResultByIdQueryVariables>;
export const GetLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentIdQuery, GetLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentIdQueryVariables>;
export const GetLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationIdQuery, GetLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationIdQueryVariables>;
export const GetLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uncontrolled"},"name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"controlled"},"name":{"kind":"Name","value":"risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQuery, GetLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdQueryVariables>;
export const GetLatestComplianceMonitoringAssessmentTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestComplianceMonitoringAssessmentTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"compliance_monitoring_assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"compliance_monitoring_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestComplianceMonitoringAssessmentTestResultsByControlIdQuery, GetLatestComplianceMonitoringAssessmentTestResultsByControlIdQueryVariables>;
export const GetObligationSecondLineResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObligationSecondLineResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetObligationSecondLineResultByIdQuery, GetObligationSecondLineResultByIdQueryVariables>;
export const GetRiskSecondLineResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRiskSecondLineResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"complianceMonitoringAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}}]} as unknown as DocumentNode<GetRiskSecondLineResultByIdQuery, GetRiskSecondLineResultByIdQueryVariables>;
export const GetSecondLineResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSecondLineResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"second_line_result_parent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ResultType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"obligationAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"controlledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uncontrolledRiskAssessmentResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactRating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_second_line_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}}]} as unknown as DocumentNode<GetSecondLineResultByIdQuery, GetSecondLineResultByIdQueryVariables>;
export const GetSecondLineResultsByParentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSecondLineResultsByParentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObligationSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"obligation"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"risk"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact_second_line_rating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueParts"}},{"kind":"Field","name":{"kind":"Name","value":"consequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CostType"}},{"kind":"Field","name":{"kind":"Name","value":"CostValue"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssueAssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"certifiedIndividual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"open"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImpactParts"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RatedItemId"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ratedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appetites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"EffectiveDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppetiteParts"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ParentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionParts"}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"obligation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"risk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"control"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionUpdateParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updates_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"schedule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Frequency"}},{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteValue"}},{"kind":"Field","name":{"kind":"Name","value":"TimeToCompleteUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObligationSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"obligation_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskControlledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_controlled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RiskUncontrolledSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"risk_uncontrolled_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}},{"kind":"Field","name":{"kind":"Name","value":"Impact"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactSecondLineRatingParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact_second_line_rating"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"RatedItemId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedBy"}},{"kind":"Field","name":{"kind":"Name","value":"Likelihood"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RaisedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"DateIdentified"}},{"kind":"Field","name":{"kind":"Name","value":"DateOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"Details"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactsCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"IsExternalIssue"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssueAssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue_assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"CertifiedIndividual"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedBySystemIssue"}},{"kind":"Field","name":{"kind":"Name","value":"IssueCausedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"IssueType"}},{"kind":"Field","name":{"kind":"Name","value":"ParentIssueId"}},{"kind":"Field","name":{"kind":"Name","value":"PoliciesBreached"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyBreach"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwner"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyOwnerCommentary"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RegulatoryBreach"}},{"kind":"Field","name":{"kind":"Name","value":"RegulationsBreached"}},{"kind":"Field","name":{"kind":"Name","value":"Reportable"}},{"kind":"Field","name":{"kind":"Name","value":"Severity"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"SystemResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCloseDate"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImpactParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"impact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Rationale"}},{"kind":"Field","name":{"kind":"Name","value":"RatingGuidance"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppetiteParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appetite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"LowerAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"UpperAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"LikelihoodAppetite"}},{"kind":"Field","name":{"kind":"Name","value":"Statement"}},{"kind":"Field","name":{"kind":"Name","value":"EffectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"AppetiteType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"ImpactId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DateDue"}},{"kind":"Field","name":{"kind":"Name","value":"DateRaised"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ClosedDate"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionUpdateParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_update"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ParentActionId"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}}]}}]} as unknown as DocumentNode<GetSecondLineResultsByParentIdQuery, GetSecondLineResultsByParentIdQueryVariables>;
export const GetSecondLineTestResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSecondLineTestResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control_test_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ControlTestSecondLineResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"control_test_second_line_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetSecondLineTestResultByIdQuery, GetSecondLineTestResultByIdQueryVariables>;
export const InsertDocumentSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertDocumentSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildDocumentSecondLineResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"DocumentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DocumentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertDocumentSecondLineResultMutation, InsertDocumentSecondLineResultMutationVariables>;
export const InsertObligationSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertObligationSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildObligationSecondLineResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ObligationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObligationIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertObligationSecondLineResultMutation, InsertObligationSecondLineResultMutationVariables>;
export const InsertChildRiskSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertChildRiskSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"risk_assessment_result_control_type_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildRiskSecondLineResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"Argument","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"RiskIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlType"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertChildRiskSecondLineResultMutation, InsertChildRiskSecondLineResultMutationVariables>;
export const InsertSecondLineControlTestResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertSecondLineControlTestResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildControlTestSecondLineResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"DesignEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"OverallEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"PerformanceEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"Submitter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertSecondLineControlTestResultMutation, InsertSecondLineControlTestResultMutationVariables>;
export const InsertSecondLineImpactRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertSecondLineImpactRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertImpactRatingPairInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildImpactSecondLineRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ComplianceMonitoringAssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Ratings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ratings"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"RatedItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RatedItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"Argument","name":{"kind":"Name","value":"CompletedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompletedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertSecondLineImpactRatingMutation, InsertSecondLineImpactRatingMutationVariables>;
export const UpdateControlTestSecondLineResultApiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControlTestSecondLineResultApi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTestResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateControlTestSecondLineResultApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateControlTestSecondLineResultApiMutation, UpdateControlTestSecondLineResultApiMutationVariables>;
export const UpdateDocumentSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocumentSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_document_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentSecondLineResultMutation, UpdateDocumentSecondLineResultMutationVariables>;
export const UpdateObligationSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateObligationSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_obligation_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateObligationSecondLineResultMutation, UpdateObligationSecondLineResultMutationVariables>;
export const UpdateControlledRiskSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateControlledRiskSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_risk_controlled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateControlledRiskSecondLineResultMutation, UpdateControlledRiskSecondLineResultMutationVariables>;
export const UpdateUncontrolledRiskSecondLineResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUncontrolledRiskSecondLineResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_risk_uncontrolled_second_line_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rationale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Likelihood"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Likelihood"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Impact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Impact"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUncontrolledRiskSecondLineResultMutation, UpdateUncontrolledRiskSecondLineResultMutationVariables>;
export const GetDefaultTabsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDefaultTabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentType"}},{"kind":"Field","name":{"kind":"Name","value":"Tabs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation_tab_preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"Preferences"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_tab_preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"Preferences"}}]}}]}}]} as unknown as DocumentNode<GetDefaultTabsQuery, GetDefaultTabsQueryVariables>;
export const GetOrganisationTabPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrganisationTabPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_tab_preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"Preferences"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationTabPreferencesQuery, GetOrganisationTabPreferencesQueryVariables>;
export const GetUserTabPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserTabPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_tab_preference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"Preferences"}}]}}]}}]} as unknown as DocumentNode<GetUserTabPreferencesQuery, GetUserTabPreferencesQueryVariables>;
export const ResetTabPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetTabPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_tab_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_user_tab_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ResetTabPreferencesMutation, ResetTabPreferencesMutationVariables>;
export const UpdateOrganisationTabPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganisationTabPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_tab_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Preferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"organisation_tab_preference_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Preferences"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_user_tab_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationTabPreferencesMutation, UpdateOrganisationTabPreferencesMutationVariables>;
export const UpdateUserTabPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserTabPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"parent_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_tab_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ObjectType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ObjectType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Preferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_tab_preference_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Preferences"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserTabPreferencesMutation, UpdateUserTabPreferencesMutationVariables>;
export const DeleteTagTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTagTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTagTypeApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTagTypesMutation, DeleteTagTypesMutationVariables>;
export const GetTagTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTagTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TagTypeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"tag_type_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTagTypeByIdQuery, GetTagTypeByIdQueryVariables>;
export const GetTagTypesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTagTypesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]}}]} as unknown as DocumentNode<GetTagTypesByNameQuery, GetTagTypesByNameQueryVariables>;
export const GetTagTypeGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTagTypeGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_type_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetTagTypeGroupsQuery, GetTagTypeGroupsQueryVariables>;
export const GetTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tag_type_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const InsertTagTypeGroupByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertTagTypeGroupByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tag_type_group_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"TagTypeGroup_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"Name"}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertTagTypeGroupByNameMutation, InsertTagTypeGroupByNameMutationVariables>;
export const InsertTagTypeWithGroupNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertTagTypeWithGroupName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagGroupName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tag_type_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tag_type_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagGroupName"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"TagTypeGroup_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"Name"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]}}]} as unknown as DocumentNode<InsertTagTypeWithGroupNameMutation, InsertTagTypeWithGroupNameMutationVariables>;
export const InsertTagTypeWithOptionalGroupIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertTagTypeWithOptionalGroupId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tag_type_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TagTypeGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}}]}}]} as unknown as DocumentNode<InsertTagTypeWithOptionalGroupIdMutation, InsertTagTypeWithOptionalGroupIdMutationVariables>;
export const UpdateTagTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTagType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_tag_type"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TagTypeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TagTypeGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TagTypeGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateTagTypeMutation, UpdateTagTypeMutationVariables>;
export const DeleteTaxonomyOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaxonomyOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TaxonomyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_taxonomy_org"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TaxonomyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TaxonomyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"OrgKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_taxonomy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TaxonomyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisations_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTaxonomyOrgMutation, DeleteTaxonomyOrgMutationVariables>;
export const GetTaxonomyByLocaleAndOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxonomyByLocaleAndOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomy_org"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Locale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Locale"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"OrgKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Locale"}},{"kind":"Field","name":{"kind":"Name","value":"OrgName"}},{"kind":"Field","name":{"kind":"Name","value":"TaxonomyId"}},{"kind":"Field","name":{"kind":"Name","value":"taxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Common"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Library"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"Taxonomy"}},{"kind":"Field","name":{"kind":"Name","value":"InternalAuditRating"}},{"kind":"Field","name":{"kind":"Name","value":"organisations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxonomyByLocaleAndOrgQuery, GetTaxonomyByLocaleAndOrgQueryVariables>;
export const InsertTaxonomyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertTaxonomy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_taxonomy_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"StringValue","value":"Description","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"Common"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Library"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Taxonomy"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"InternalAuditRating"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"organisations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Locale"},"value":{"kind":"StringValue","value":"en","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"OrgName"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertTaxonomyMutation, InsertTaxonomyMutationVariables>;
export const UpdateTaxonomyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaxonomy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Common"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Library"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Taxonomy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditRating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_taxonomy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Common"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Common"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Library"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Library"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Rating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Taxonomy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Taxonomy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"InternalAuditRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"InternalAuditRating"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateTaxonomyMutation, UpdateTaxonomyMutationVariables>;
export const GetTaxonomyAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaxonomyAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxonomy_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Locale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Locale"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"OrgKey"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OrgKey"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Common"}},{"kind":"Field","name":{"kind":"Name","value":"Library"}},{"kind":"Field","name":{"kind":"Name","value":"Rating"}},{"kind":"Field","name":{"kind":"Name","value":"Taxonomy"}},{"kind":"Field","name":{"kind":"Name","value":"InternalAuditRating"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"organisations_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaxonomyAuditQuery, GetTaxonomyAuditQueryVariables>;
export const DeleteTestResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTestResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_relation_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTestResultsMutation, DeleteTestResultsMutationVariables>;
export const GetLatestTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLatestTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentParents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetLatestTestResultsByControlIdQuery, GetLatestTestResultsByControlIdQueryVariables>;
export const GetTestResultAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTestResultAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}}]}}]} as unknown as DocumentNode<GetTestResultAuditByIdQuery, GetTestResultAuditByIdQueryVariables>;
export const GetTestResultByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTestResultById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetTestResultByIdQuery, GetTestResultByIdQueryVariables>;
export const GetTestResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTestResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"test_result_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetTestResultsQuery, GetTestResultsQueryVariables>;
export const GetTestResultsByControlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTestResultsByControlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentControlId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"RatingType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"assessment","block":false},{"kind":"StringValue","value":"rating","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentParents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assessment"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssessmentParts"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssessmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"assessment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ActualCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"CompletedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"NextTestDate"}},{"kind":"Field","name":{"kind":"Name","value":"OriginatingItemId"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"TargetCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Outcome"}}]}}]} as unknown as DocumentNode<GetTestResultsByControlIdQuery, GetTestResultsByControlIdQueryVariables>;
export const GetWidgetTestResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetTestResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"test_result_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"controlWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"control_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"control"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"controlWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestResultParts"}},{"kind":"Field","name":{"kind":"Name","value":"submitter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ManualDueDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TestResultParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"test_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"DesignEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"OverallEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"ParentControlId"}},{"kind":"Field","name":{"kind":"Name","value":"PerformanceEffectiveness"}},{"kind":"Field","name":{"kind":"Name","value":"Submitter"}},{"kind":"Field","name":{"kind":"Name","value":"TestDate"}},{"kind":"Field","name":{"kind":"Name","value":"TestType"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetWidgetTestResultsQuery, GetWidgetTestResultsQueryVariables>;
export const InsertControlTestResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertControlTestResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertControlTestResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"Argument","name":{"kind":"Name","value":"DesignEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"DesignEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"OverallEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OverallEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"ControlIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ControlIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"PerformanceEffectiveness"},"value":{"kind":"Variable","name":{"kind":"Name","value":"PerformanceEffectiveness"}}},{"kind":"Argument","name":{"kind":"Name","value":"Submitter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Submitter"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"TestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"Title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Title"}}},{"kind":"Argument","name":{"kind":"Name","value":"AssessmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AssessmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"CustomAttributeData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CustomAttributeData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ids"}}]}}]}}]} as unknown as DocumentNode<InsertControlTestResultMutation, InsertControlTestResultMutationVariables>;
export const UpdateTestResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTestResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTestResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTestResultApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateTestResultMutation, UpdateTestResultMutationVariables>;
export const CreateThirdPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createThirdParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertThirdPartyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertThirdPartyApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<CreateThirdPartyMutation, CreateThirdPartyMutationVariables>;
export const DeleteThirdPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteThirdParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_questionnaire_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_third_party_response"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_third_party_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<DeleteThirdPartyMutation, DeleteThirdPartyMutationVariables>;
export const GetThirdPartiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getThirdParties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"third_party_bool_exp"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ThirdPartyParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"CompaniesHouseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"Address"}},{"kind":"Field","name":{"kind":"Name","value":"CityTown"}},{"kind":"Field","name":{"kind":"Name","value":"Postcode"}},{"kind":"Field","name":{"kind":"Name","value":"Country"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyDomain"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}}]} as unknown as DocumentNode<GetThirdPartiesQuery, GetThirdPartiesQueryVariables>;
export const GetThirdPartyByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getThirdPartyById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"third_party"},"name":{"kind":"Name","value":"third_party_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ThirdPartyParts"}},{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OwnerGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contributorGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContributorGroupParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentParts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationFileParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"SequentialId"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"CompaniesHouseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"Address"}},{"kind":"Field","name":{"kind":"Name","value":"CityTown"}},{"kind":"Field","name":{"kind":"Name","value":"Postcode"}},{"kind":"Field","name":{"kind":"Name","value":"Country"}},{"kind":"Field","name":{"kind":"Name","value":"PrimaryContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactName"}},{"kind":"Field","name":{"kind":"Name","value":"ContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"CompanyDomain"}},{"kind":"Field","name":{"kind":"Name","value":"Type"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Criticality"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CustomAttributeData"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OwnerGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"owner_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContributorGroupParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contributor_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"TagTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"DepartmentTypeId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelationFileParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relation_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"ChangeRequestFileOperation"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileParts"}}]}}]}}]} as unknown as DocumentNode<GetThirdPartyByIdQuery, GetThirdPartyByIdQueryVariables>;
export const GetThirdPartyResponseByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getThirdPartyResponseById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_response_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"invitees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionnaireTemplateVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"UISchema"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetThirdPartyResponseByIdQuery, GetThirdPartyResponseByIdQueryVariables>;
export const GetThirdPartyResponseSubscriptionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getThirdPartyResponseSubscriptionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_response_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"invitees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"ancestorContributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AncestorContributorParts"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionnaireTemplateVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"Schema"}},{"kind":"Field","name":{"kind":"Name","value":"UISchema"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentType"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}},{"kind":"Field","name":{"kind":"Name","value":"FileSize"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"Meta"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AncestorContributorParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ancestor_contributor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContributorType"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"AncestorId"}},{"kind":"Field","name":{"kind":"Name","value":"UserGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}}]} as unknown as DocumentNode<GetThirdPartyResponseSubscriptionByIdSubscription, GetThirdPartyResponseSubscriptionByIdSubscriptionVariables>;
export const GetThirdPartyResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getThirdPartyResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"invitees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"UserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdParty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionnaireTemplateVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetThirdPartyResponsesSubscription, GetThirdPartyResponsesSubscriptionVariables>;
export const GetThirdPartyResponsesByThirdPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"getThirdPartyResponsesByThirdParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_response"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ParentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ThirdPartyResponseParts"}},{"kind":"Field","name":{"kind":"Name","value":"invitees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionnaireTemplateVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Version"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ThirdPartyResponseParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"third_party_response"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ParentId"}},{"kind":"Field","name":{"kind":"Name","value":"QuestionnaireTemplateVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"ResponseData"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}}]}}]} as unknown as DocumentNode<GetThirdPartyResponsesByThirdPartySubscription, GetThirdPartyResponsesByThirdPartySubscriptionVariables>;
export const UpdateThirdPartyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateThirdParty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateThirdPartyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateThirdPartyApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateThirdPartyMutation, UpdateThirdPartyMutationVariables>;
export const UpdateThirdPartyResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateThirdPartyResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"third_party_response_status_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_third_party_response_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<UpdateThirdPartyResponseMutation, UpdateThirdPartyResponseMutationVariables>;
export const UpdateThirdPartyResponseStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateThirdPartyResponseStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"third_party_response_enum_action"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ResponseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RequestType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShareWithRespondents"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateThirdPartyResponseStatusAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Action"}}},{"kind":"Argument","name":{"kind":"Name","value":"ResponseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ResponseIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"Reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"RequestType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RequestType"}}},{"kind":"Argument","name":{"kind":"Name","value":"ShareWithRespondents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShareWithRespondents"}}},{"kind":"Argument","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateThirdPartyResponseStatusMutation, UpdateThirdPartyResponseStatusMutationVariables>;
export const GetThirdPartyContactsByThirdPartyIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getThirdPartyContactsByThirdPartyId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"ThirdPartyId"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"IsRevoked"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}}]}}]}}]}}]} as unknown as DocumentNode<GetThirdPartyContactsByThirdPartyIdQuery, GetThirdPartyContactsByThirdPartyIdQueryVariables>;
export const GetActiveThirdPartyContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveThirdPartyContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_party_contact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"IsRevoked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"Email"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}}]}}]}}]} as unknown as DocumentNode<GetActiveThirdPartyContactsQuery, GetActiveThirdPartyContactsQueryVariables>;
export const InsertThirdPartyContactApiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertThirdPartyContactApi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"JobTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertThirdPartyContactApi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ThirdPartyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ThirdPartyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"Email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Email"}}},{"kind":"Argument","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"Argument","name":{"kind":"Name","value":"JobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"JobTitle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertThirdPartyContactApiMutation, InsertThirdPartyContactApiMutationVariables>;
export const RevokeThirdPartyContactAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeThirdPartyContactAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContactIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeThirdPartyContactAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ContactIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContactIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"IsRevoked"}},{"kind":"Field","name":{"kind":"Name","value":"Message"}}]}}]}}]}}]} as unknown as DocumentNode<RevokeThirdPartyContactAccessMutation, RevokeThirdPartyContactAccessMutationVariables>;
export const DeleteUserGroupUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserGroupUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UserIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UserGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_group_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UserIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UserGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UserGroupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteUserGroupUsersMutation, DeleteUserGroupUsersMutationVariables>;
export const DeleteUserGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"UserGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"UserGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteUserGroupsMutation, DeleteUserGroupsMutationVariables>;
export const GetUserGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerContributor"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"approvers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGroupByIdQuery, GetUserGroupByIdQueryVariables>;
export const GetUserGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerContributor"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const GetUserGroupsWithApproversDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserGroupsWithApprovers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerContributor"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGroupsWithApproversQuery, GetUserGroupsWithApproversQueryVariables>;
export const GetUsersByGroupIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersByGroupId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"GroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"GroupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedAtTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersByGroupIdQuery, GetUsersByGroupIdQueryVariables>;
export const InsertUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerContributor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_group_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"OwnerContributor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerContributor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}}]}}]}}]} as unknown as DocumentNode<InsertUserGroupMutation, InsertUserGroupMutationVariables>;
export const InsertUserGroupUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserGroupUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_group_user_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_group_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_group_user_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertUserGroupUsersMutation, InsertUserGroupUsersMutationVariables>;
export const UpdateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"OwnerContributor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ModifiedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OriginalTimestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"OwnerContributor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"OwnerContributor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const GetUserSearchPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSearchPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_search_preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RecentUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"ShowGroups"}},{"kind":"Field","name":{"kind":"Name","value":"FilterByActivePlatformUsers"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserPlatformRole"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserJobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ShowDirectoryDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserLocation"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ShowArchivedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"ShowInheritedContributors"}}]}}]}}]} as unknown as DocumentNode<GetUserSearchPreferencesQuery, GetUserSearchPreferencesQueryVariables>;
export const GetUserSearchPreferencesAuditByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSearchPreferencesAuditById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_search_preferences_audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"CreatedByUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RecentUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"ShowGroups"}},{"kind":"Field","name":{"kind":"Name","value":"FilterByActivePlatformUsers"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserPlatformRole"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserJobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ShowDirectoryDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserLocation"}},{"kind":"Field","name":{"kind":"Name","value":"ShowUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ShowArchivedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetUserSearchPreferencesAuditByIdQuery, GetUserSearchPreferencesAuditByIdQueryVariables>;
export const UpsertRecentUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertRecentUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RecentUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_search_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RecentUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RecentUserIds"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"recent_users_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RecentUserIds"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertRecentUsersMutation, UpsertRecentUsersMutationVariables>;
export const UpsertUserSearchPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertUserSearchPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowGroups"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"FilterByActivePlatformUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserPlatformRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserJobTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowDirectoryDepartment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserLocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowArchivedUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ShowInheritedContributors"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_search_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ShowGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowGroups"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"FilterByActivePlatformUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"FilterByActivePlatformUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowUserPlatformRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserPlatformRole"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowUserJobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserJobTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowDirectoryDepartment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowDirectoryDepartment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowUserLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserLocation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowUserEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowUserEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowArchivedUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowArchivedUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ShowInheritedContributors"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ShowInheritedContributors"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"recent_users_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ShowGroups"},{"kind":"EnumValue","value":"FilterByActivePlatformUsers"},{"kind":"EnumValue","value":"ShowUserPlatformRole"},{"kind":"EnumValue","value":"ShowUserJobTitle"},{"kind":"EnumValue","value":"ShowDirectoryDepartment"},{"kind":"EnumValue","value":"ShowUserLocation"},{"kind":"EnumValue","value":"ShowUserEmail"},{"kind":"EnumValue","value":"ShowArchivedUsers"},{"kind":"EnumValue","value":"ShowInheritedContributors"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertUserSearchPreferencesMutation, UpsertUserSearchPreferencesMutationVariables>;
export const GetUserTablePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserTablePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_table_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TableId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TableId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Preferences"}}]}}]}}]} as unknown as DocumentNode<GetUserTablePreferencesQuery, GetUserTablePreferencesQueryVariables>;
export const UpsertUserTablePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertUserTablePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_table_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"TableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TableId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Preferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Preferences"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_table_preferences_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"Preferences"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpsertUserTablePreferencesMutation, UpsertUserTablePreferencesMutationVariables>;
export const GetAuthUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"DisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"Department"}},{"kind":"Field","name":{"kind":"Name","value":"OfficeLocation"}},{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"organisationusers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"External_Id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthUserByIdQuery, GetAuthUserByIdQueryVariables>;
export const GetAuthUserByIdWithRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthUserByIdWithRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"DisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"Department"}},{"kind":"Field","name":{"kind":"Name","value":"OfficeLocation"}},{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"organisationusers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"External_Id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthUserByIdWithRolesQuery, GetAuthUserByIdWithRolesQueryVariables>;
export const GetAuthUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"}},{"kind":"Field","name":{"kind":"Name","value":"LastName"}},{"kind":"Field","name":{"kind":"Name","value":"FriendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"Email"}},{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"DisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"JobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"Department"}},{"kind":"Field","name":{"kind":"Name","value":"OfficeLocation"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"ModifiedAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"organisationusers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleKey"}},{"kind":"Field","name":{"kind":"Name","value":"LastSeen"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RoleName"}},{"kind":"Field","name":{"kind":"Name","value":"Id"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsCustomerSupport"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auth_user_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthUsersQuery, GetAuthUsersQueryVariables>;
export const UpdateUserRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;
export const DeleteWizardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteWizard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWizardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"RiskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteWizardMutation, DeleteWizardMutationVariables>;
export const GetWizardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWizardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wizard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"RiskId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"RiskId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RiskId"}},{"kind":"Field","name":{"kind":"Name","value":"CurrentStep"}},{"kind":"Field","name":{"kind":"Name","value":"AssessmentId"}},{"kind":"Field","name":{"kind":"Name","value":"ActivityId"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]} as unknown as DocumentNode<GetWizardByIdQuery, GetWizardByIdQueryVariables>;
export const GetWizardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWizards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wizard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}}]}}]} as unknown as DocumentNode<GetWizardsQuery, GetWizardsQueryVariables>;
export const InsertWizardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertWizard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertWizardInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertChildWizard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RiskId"}}]}}]}}]} as unknown as DocumentNode<InsertWizardMutation, InsertWizardMutationVariables>;
export const UpdateWizardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateWizard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWizardInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWizardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateWizardMutation, UpdateWizardMutationVariables>;
export const namedOperations = {
  Query: {
    getAcceptanceAuditById: 'getAcceptanceAuditById',
    getAcceptanceById: 'getAcceptanceById',
    getAcceptances: 'getAcceptances',
    getAcceptancesByParentRiskId: 'getAcceptancesByParentRiskId',
    getActionAuditById: 'getActionAuditById',
    getActionById: 'getActionById',
    getActions: 'getActions',
    getWidgetActionsByPriority: 'getWidgetActionsByPriority',
    GetOverdueActionCount: 'GetOverdueActionCount',
    getActionUpdateAuditById: 'getActionUpdateAuditById',
    getActionUpdateById: 'getActionUpdateById',
    getActionUpdatesByParentActionId: 'getActionUpdatesByParentActionId',
    getAggregationSettingsForOrg: 'getAggregationSettingsForOrg',
    getActiveAppetitesByParentId: 'getActiveAppetitesByParentId',
    getActiveRiskAppetites: 'getActiveRiskAppetites',
    getAppetiteAuditById: 'getAppetiteAuditById',
    getAppetiteById: 'getAppetiteById',
    getAppetites: 'getAppetites',
    getAppetitesByRiskId: 'getAppetitesByRiskId',
    getAppetitesGroupedByImpact: 'getAppetitesGroupedByImpact',
    getChangeRequestsByApproval: 'getChangeRequestsByApproval',
    getApprovalAuditById: 'getApprovalAuditById',
    getApprovalById: 'getApprovalById',
    getGlobalApprovals: 'getGlobalApprovals',
    getAssessmentActivities: 'getAssessmentActivities',
    getAssessmentActivitiesByParentId: 'getAssessmentActivitiesByParentId',
    getAssessmentActivityAuditById: 'getAssessmentActivityAuditById',
    getAssessmentActivityById: 'getAssessmentActivityById',
    getAssessmentRCSAActivitiesByParentId: 'getAssessmentRCSAActivitiesByParentId',
    getAllAssessmentResults: 'getAllAssessmentResults',
    getAssessmentResultById: 'getAssessmentResultById',
    getAssessmentResultParentAuditById: 'getAssessmentResultParentAuditById',
    getAssessmentResultsByParentId: 'getAssessmentResultsByParentId',
    getDocumentAssessmentResultAuditById: 'getDocumentAssessmentResultAuditById',
    getDocumentAssessmentResultById: 'getDocumentAssessmentResultById',
    getDocumentAssessmentResultsByParentId: 'getDocumentAssessmentResultsByParentId',
    getLatestDocumentAssessmentResultByDocumentId: 'getLatestDocumentAssessmentResultByDocumentId',
    getLatestDocumentAssessmentResults: 'getLatestDocumentAssessmentResults',
    getLatestObligationAssessmentResultByObligationId: 'getLatestObligationAssessmentResultByObligationId',
    getLatestObligationAssessmentResults: 'getLatestObligationAssessmentResults',
    getObligationAssessmentResultAuditById: 'getObligationAssessmentResultAuditById',
    getObligationAssessmentResultById: 'getObligationAssessmentResultById',
    getObligationAssessmentResultsByObligationId: 'getObligationAssessmentResultsByObligationId',
    getRiskAssessmentResultAuditById: 'getRiskAssessmentResultAuditById',
    getRiskAssessmentResultById: 'getRiskAssessmentResultById',
    getRiskAssessmentResultsByControlType: 'getRiskAssessmentResultsByControlType',
    getRiskAssessmentResultsByRiskId: 'getRiskAssessmentResultsByRiskId',
    getRiskAssessmentResultsByRiskIdAndControlType: 'getRiskAssessmentResultsByRiskIdAndControlType',
    getRiskScoresByRiskId: 'getRiskScoresByRiskId',
    getAssessmentAuditById: 'getAssessmentAuditById',
    getAssessmentById: 'getAssessmentById',
    getAssessments: 'getAssessments',
    GetAttestationConfig: 'GetAttestationConfig',
    getGlobalUsersAndGroups: 'getGlobalUsersAndGroups',
    getAttestationCycleRegister: 'getAttestationCycleRegister',
    getAttestationCycles: 'getAttestationCycles',
    getActiveAttestationCycle: 'getActiveAttestationCycle',
    getAttestationStatus: 'getAttestationStatus',
    getPolicyAttestationRecords: 'getPolicyAttestationRecords',
    getPolicyAttestationRecordsForDocument: 'getPolicyAttestationRecordsForDocument',
    getAuditLogs: 'getAuditLogs',
    getBusinessAreas: 'getBusinessAreas',
    getCauseAuditById: 'getCauseAuditById',
    getCauseById: 'getCauseById',
    getCauses: 'getCauses',
    getCausesByParentIssueId: 'getCausesByParentIssueId',
    getApprovalLevels: 'getApprovalLevels',
    getChangeRequestAuditById: 'getChangeRequestAuditById',
    getChangeRequests: 'getChangeRequests',
    getPendingChangeRequests: 'getPendingChangeRequests',
    getMostRecentNonPendingChangeRequest: 'getMostRecentNonPendingChangeRequest',
    getColourPalettes: 'getColourPalettes',
    getCommentAuditById: 'getCommentAuditById',
    getCommentsByConversationId: 'getCommentsByConversationId',
    getConversationAuditById: 'getConversationAuditById',
    getAllComplianceMonitoringAssessments: 'getAllComplianceMonitoringAssessments',
    getComplianceMonitoringAssessmentById: 'getComplianceMonitoringAssessmentById',
    getComplianceMonitoringAssessments: 'getComplianceMonitoringAssessments',
    getConsequenceAuditById: 'getConsequenceAuditById',
    getConsequenceById: 'getConsequenceById',
    getConsequences: 'getConsequences',
    getConsequencesByParentIssueId: 'getConsequencesByParentIssueId',
    getControlAuditById: 'getControlAuditById',
    getControlById: 'getControlById',
    getControls: 'getControls',
    getControlsBasic: 'getControlsBasic',
    getControlsByUser: 'getControlsByUser',
    getControlGroupAuditById: 'getControlGroupAuditById',
    getControlGroupById: 'getControlGroupById',
    getControlGroups: 'getControlGroups',
    getControlGroupsByTitle: 'getControlGroupsByTitle',
    getControlGroupsFlat: 'getControlGroupsFlat',
    getCustomAttributeSchemaAuditById: 'getCustomAttributeSchemaAuditById',
    getCustomDatasourceById: 'getCustomDatasourceById',
    getCustomDatasources: 'getCustomDatasources',
    getCustomRibbonAuditById: 'getCustomRibbonAuditById',
    getRibbonItemsByParentType: 'getRibbonItemsByParentType',
    getCustomRoleById: 'getCustomRoleById',
    getCustomRoles: 'getCustomRoles',
    getDashboardAuditById: 'getDashboardAuditById',
    getDashboardById: 'getDashboardById',
    getDashboards: 'getDashboards',
    getMyItemsDashboard: 'getMyItemsDashboard',
    dataExportOneOffExport: 'dataExportOneOffExport',
    getDataImportById: 'getDataImportById',
    getDataImportErrors: 'getDataImportErrors',
    getDataImports: 'getDataImports',
    getDepartmentAuditById: 'getDepartmentAuditById',
    GetDepartmentTypeById: 'GetDepartmentTypeById',
    getDepartmentTypesByName: 'getDepartmentTypesByName',
    getDepartmentTypeGroups: 'getDepartmentTypeGroups',
    getDepartments: 'getDepartments',
    getDocumentAuditById: 'getDocumentAuditById',
    getDocumentById: 'getDocumentById',
    getDocumentList: 'getDocumentList',
    getDocuments: 'getDocuments',
    getDocumentFileAuditById: 'getDocumentFileAuditById',
    getDocumentFileById: 'getDocumentFileById',
    getDocumentFilesByDocumentId: 'getDocumentFilesByDocumentId',
    getDocumentFile: 'getDocumentFile',
    getLatestPublicDocumentFileByDocumentId: 'getLatestPublicDocumentFileByDocumentId',
    getPublicDocumentFiles: 'getPublicDocumentFiles',
    getEnterpriseRisks: 'getEnterpriseRisks',
    getEnterpriseRiskById: 'getEnterpriseRiskById',
    getEnterpriseRisksByTier: 'getEnterpriseRisksByTier',
    getEnterpriseRisksFlat: 'getEnterpriseRisksFlat',
    getEntities: 'getEntities',
    getEntityById: 'getEntityById',
    getFileAuditById: 'getFileAuditById',
    getFileById: 'getFileById',
    getFormConfiguration: 'getFormConfiguration',
    getFormConfigurationAudit: 'getFormConfigurationAudit',
    getFormConfigurationByParentType: 'getFormConfigurationByParentType',
    getAllFormsCustomisation: 'getAllFormsCustomisation',
    getFormCustomisation: 'getFormCustomisation',
    getFormFieldConfigurationAuditByParentType: 'getFormFieldConfigurationAuditByParentType',
    getFormFieldOptionsByParentType: 'getFormFieldOptionsByParentType',
    getFormFieldOrderingAuditById: 'getFormFieldOrderingAuditById',
    getOwnersAndContributors: 'getOwnersAndContributors',
    getUsers: 'getUsers',
    getImpactRatingAuditById: 'getImpactRatingAuditById',
    getImpactRatingById: 'getImpactRatingById',
    getInternalAuditImpactRatingById: 'getInternalAuditImpactRatingById',
    getSecondLineImpactRatingById: 'getSecondLineImpactRatingById',
    getImpactRatingCount: 'getImpactRatingCount',
    getImpactRatings: 'getImpactRatings',
    getImpactRatingsByImpactId: 'getImpactRatingsByImpactId',
    getImpactRatingsByRatedItemId: 'getImpactRatingsByRatedItemId',
    getImpactRatingsWithAppetites: 'getImpactRatingsWithAppetites',
    getLatestImpactRatingsForRatedImpactsByRatedItemId: 'getLatestImpactRatingsForRatedImpactsByRatedItemId',
    getImpactAuditById: 'getImpactAuditById',
    getImpactById: 'getImpactById',
    getImpactCount: 'getImpactCount',
    getImpactList: 'getImpactList',
    getImpacts: 'getImpacts',
    getIndicatorResultAuditById: 'getIndicatorResultAuditById',
    getIndicatorResultById: 'getIndicatorResultById',
    getIndicatorResultsByIndicatorId: 'getIndicatorResultsByIndicatorId',
    getIndicatorAuditById: 'getIndicatorAuditById',
    getIndicatorById: 'getIndicatorById',
    getIndicatorTitlesByParentId: 'getIndicatorTitlesByParentId',
    getIndicators: 'getIndicators',
    getIndicatorsByParentId: 'getIndicatorsByParentId',
    getInternalAuditById: 'getInternalAuditById',
    getInternalAudits: 'getInternalAudits',
    getLinkedRisksByInternalAuditId: 'getLinkedRisksByInternalAuditId',
    getInternalAuditReportById: 'getInternalAuditReportById',
    getInternalAuditReports: 'getInternalAuditReports',
    getInternalAuditReportsByOriginatingItemId: 'getInternalAuditReportsByOriginatingItemId',
    getAllInternalAuditReportResults: 'getAllInternalAuditReportResults',
    getDocumentInternalAuditResultById: 'getDocumentInternalAuditResultById',
    getInternalAuditReportDocumentAssessmentResultsByDocumentId: 'getInternalAuditReportDocumentAssessmentResultsByDocumentId',
    getInternalAuditReportObligationAssessmentResultsByObligationId: 'getInternalAuditReportObligationAssessmentResultsByObligationId',
    getInternalAuditReportRiskAssessmentResultsByRiskId: 'getInternalAuditReportRiskAssessmentResultsByRiskId',
    getInternalAuditReportTestResultsByControlId: 'getInternalAuditReportTestResultsByControlId',
    getInternalAuditResultById: 'getInternalAuditResultById',
    getInternalAuditResultsByParentId: 'getInternalAuditResultsByParentId',
    getInternalAuditTestResultById: 'getInternalAuditTestResultById',
    getLatestInternalAuditReportDocumentAssessmentResultByDocumentId: 'getLatestInternalAuditReportDocumentAssessmentResultByDocumentId',
    getLatestInternalAuditReportObligationAssessmentResultByObligationId: 'getLatestInternalAuditReportObligationAssessmentResultByObligationId',
    getLatestInternalAuditReportRiskAssessmentResultsByRiskId: 'getLatestInternalAuditReportRiskAssessmentResultsByRiskId',
    getLatestInternalAuditReportTestResultsByControlId: 'getLatestInternalAuditReportTestResultsByControlId',
    getObligationInternalAuditResultById: 'getObligationInternalAuditResultById',
    getRiskInternalAuditResultById: 'getRiskInternalAuditResultById',
    getIssueAuditById: 'getIssueAuditById',
    getIssueById: 'getIssueById',
    getIssues: 'getIssues',
    getIssuesByParentId: 'getIssuesByParentId',
    GetOldestOpenIssueDate: 'GetOldestOpenIssueDate',
    getWidgetIssueCauses: 'getWidgetIssueCauses',
    getWidgetIssuesByType: 'getWidgetIssuesByType',
    GetOpenIssueAssessmentCount: 'GetOpenIssueAssessmentCount',
    getIssueAssessmentAuditById: 'getIssueAssessmentAuditById',
    getIssueAssessmentByParentId: 'getIssueAssessmentByParentId',
    getIssueAssessmentHistory: 'getIssueAssessmentHistory',
    getIssueUpdateAuditById: 'getIssueUpdateAuditById',
    getIssueUpdateById: 'getIssueUpdateById',
    getIssueUpdatesByParentIssueId: 'getIssueUpdatesByParentIssueId',
    getLinkedItemAudit: 'getLinkedItemAudit',
    getLinkedItemRisks: 'getLinkedItemRisks',
    getLinkedItems: 'getLinkedItems',
    getModules: 'getModules',
    getMyDueItems: 'getMyDueItems',
    getMyItems: 'getMyItems',
    getAcceptanceCount: 'getAcceptanceCount',
    getAppetiteCount: 'getAppetiteCount',
    getAssessmentActivityCount: 'getAssessmentActivityCount',
    getAssessmentCount: 'getAssessmentCount',
    getAssessmentResultCount: 'getAssessmentResultCount',
    getCauseCount: 'getCauseCount',
    getComplianceMonitoringAssessmentCount: 'getComplianceMonitoringAssessmentCount',
    getComplianceMonitoringAssessmentResultCount: 'getComplianceMonitoringAssessmentResultCount',
    getConsequenceCount: 'getConsequenceCount',
    getControlCount: 'getControlCount',
    getControlGroupCount: 'getControlGroupCount',
    getInternalAuditReportCount: 'getInternalAuditReportCount',
    getInternalAuditReportResultCount: 'getInternalAuditReportResultCount',
    getIssueCount: 'getIssueCount',
    getRiskCount: 'getRiskCount',
    getTestResultCount: 'getTestResultCount',
    getObjectTypeById: 'getObjectTypeById',
    getNotificationListDetails: 'getNotificationListDetails',
    getNotificationPreferences: 'getNotificationPreferences',
    getObligationAuditById: 'getObligationAuditById',
    getObligationById: 'getObligationById',
    getObligationList: 'getObligationList',
    getObligations: 'getObligations',
    getObligationsByType: 'getObligationsByType',
    getObligationChanges: 'getObligationChanges',
    getObligationImpactAuditById: 'getObligationImpactAuditById',
    getObligationImpactById: 'getObligationImpactById',
    getObligationImpactsByParentId: 'getObligationImpactsByParentId',
    getOrganisation: 'getOrganisation',
    getQuestionnaireInvites: 'getQuestionnaireInvites',
    getLatestQuestionnaireTemplateVersion: 'getLatestQuestionnaireTemplateVersion',
    getQuestionnaireTemplateVersionById: 'getQuestionnaireTemplateVersionById',
    getQuestionnaireTemplateVersionsByQuestionnaireTemplateId: 'getQuestionnaireTemplateVersionsByQuestionnaireTemplateId',
    getQuestionnaireTemplateById: 'getQuestionnaireTemplateById',
    getQuestionnaireTemplates: 'getQuestionnaireTemplates',
    getReportingData: 'getReportingData',
    getReportingFilterOptions: 'getReportingFilterOptions',
    getRiskAuditById: 'getRiskAuditById',
    getRiskById: 'getRiskById',
    getRiskList: 'getRiskList',
    getRiskListOnlyOptimized: 'getRiskListOnlyOptimized',
    getRiskListOnlyWithEntitiesOptimized: 'getRiskListOnlyWithEntitiesOptimized',
    getRiskListOptimized: 'getRiskListOptimized',
    getRiskListWithEntities: 'getRiskListWithEntities',
    getRiskWithOwnContributions: 'getRiskWithOwnContributions',
    getRisksByTier: 'getRisksByTier',
    getRisksFlat: 'getRisksFlat',
    getRisksWithAncestorContributors: 'getRisksWithAncestorContributors',
    getRisksWithAncestorContributorsAndEntities: 'getRisksWithAncestorContributorsAndEntities',
    getRiskAssessmentResultConfigAuditById: 'getRiskAssessmentResultConfigAuditById',
    getRiskAssessmentResultImpactAuditById: 'getRiskAssessmentResultImpactAuditById',
    getRoleAccess: 'getRoleAccess',
    GetAvailableRoles: 'GetAvailableRoles',
    getDefaultRoles: 'getDefaultRoles',
    getScimConfig: 'getScimConfig',
    getAllComplianceMonitoringAssessmentResults: 'getAllComplianceMonitoringAssessmentResults',
    getComplianceMonitoringAssessmentTestResultsByControlId: 'getComplianceMonitoringAssessmentTestResultsByControlId',
    getComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentId: 'getComplianceMonitoringAssessmentDocumentAssessmentResultsByDocumentId',
    getComplianceMonitoringAssessmentObligationAssessmentResultsByObligationId: 'getComplianceMonitoringAssessmentObligationAssessmentResultsByObligationId',
    getComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId: 'getComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId',
    getDocumentSecondLineResultById: 'getDocumentSecondLineResultById',
    getLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentId: 'getLatestComplianceMonitoringAssessmentDocumentAssessmentResultByDocumentId',
    getLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationId: 'getLatestComplianceMonitoringAssessmentObligationAssessmentResultByObligationId',
    getLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId: 'getLatestComplianceMonitoringAssessmentRiskAssessmentResultsByRiskId',
    getLatestComplianceMonitoringAssessmentTestResultsByControlId: 'getLatestComplianceMonitoringAssessmentTestResultsByControlId',
    getObligationSecondLineResultById: 'getObligationSecondLineResultById',
    getRiskSecondLineResultById: 'getRiskSecondLineResultById',
    getSecondLineResultById: 'getSecondLineResultById',
    getSecondLineResultsByParentId: 'getSecondLineResultsByParentId',
    getSecondLineTestResultById: 'getSecondLineTestResultById',
    getDefaultTabs: 'getDefaultTabs',
    getOrganisationTabPreferences: 'getOrganisationTabPreferences',
    getUserTabPreferences: 'getUserTabPreferences',
    GetTagTypeById: 'GetTagTypeById',
    getTagTypesByName: 'getTagTypesByName',
    getTagTypeGroups: 'getTagTypeGroups',
    getTags: 'getTags',
    getTaxonomyByLocaleAndOrg: 'getTaxonomyByLocaleAndOrg',
    getTaxonomyAudit: 'getTaxonomyAudit',
    getLatestTestResultsByControlId: 'getLatestTestResultsByControlId',
    getTestResultAuditById: 'getTestResultAuditById',
    getTestResultById: 'getTestResultById',
    getTestResults: 'getTestResults',
    getTestResultsByControlId: 'getTestResultsByControlId',
    getWidgetTestResults: 'getWidgetTestResults',
    getThirdParties: 'getThirdParties',
    getThirdPartyById: 'getThirdPartyById',
    getThirdPartyResponseById: 'getThirdPartyResponseById',
    getThirdPartyContactsByThirdPartyId: 'getThirdPartyContactsByThirdPartyId',
    getActiveThirdPartyContacts: 'getActiveThirdPartyContacts',
    GetUserGroupById: 'GetUserGroupById',
    getUserGroups: 'getUserGroups',
    getUserGroupsWithApprovers: 'getUserGroupsWithApprovers',
    GetUsersByGroupId: 'GetUsersByGroupId',
    getUserSearchPreferences: 'getUserSearchPreferences',
    getUserSearchPreferencesAuditById: 'getUserSearchPreferencesAuditById',
    getUserTablePreferences: 'getUserTablePreferences',
    GetAuthUserById: 'GetAuthUserById',
    GetAuthUserByIdWithRoles: 'GetAuthUserByIdWithRoles',
    GetAuthUsers: 'GetAuthUsers',
    getWizardById: 'getWizardById',
    getWizards: 'getWizards'
  },
  Mutation: {
    deleteAcceptances: 'deleteAcceptances',
    insertAcceptance: 'insertAcceptance',
    updateAcceptance: 'updateAcceptance',
    deleteActions: 'deleteActions',
    insertChildAction: 'insertChildAction',
    updateAction: 'updateAction',
    deleteActionUpdates: 'deleteActionUpdates',
    insertActionUpdate: 'insertActionUpdate',
    updateActionUpdate: 'updateActionUpdate',
    updateAggregationSettingsForOrg: 'updateAggregationSettingsForOrg',
    deleteAppetites: 'deleteAppetites',
    insertAppetite: 'insertAppetite',
    updateAppetite: 'updateAppetite',
    deleteApproval: 'deleteApproval',
    insertApproval: 'insertApproval',
    updateApproval: 'updateApproval',
    deleteAssessmentActivities: 'deleteAssessmentActivities',
    insertAssessmentActivityWithLinkedItems: 'insertAssessmentActivityWithLinkedItems',
    updateAssessmentActivityWithLinkedItems: 'updateAssessmentActivityWithLinkedItems',
    deleteAssessmentResults: 'deleteAssessmentResults',
    insertDocumentAssessmentResult: 'insertDocumentAssessmentResult',
    insertChildImpactRating: 'insertChildImpactRating',
    insertObligationAssessmentResult: 'insertObligationAssessmentResult',
    insertRiskAssessmentResults: 'insertRiskAssessmentResults',
    updateDocumentAssessmentResult: 'updateDocumentAssessmentResult',
    updateObligationAssessmentResult: 'updateObligationAssessmentResult',
    updateRiskAssessmentResult: 'updateRiskAssessmentResult',
    deleteAssessments: 'deleteAssessments',
    insertAssessment: 'insertAssessment',
    updateAssessment: 'updateAssessment',
    insertAttestationConfig: 'insertAttestationConfig',
    insertAttestationCycle: 'insertAttestationCycle',
    attest: 'attest',
    attestationNotRequired: 'attestationNotRequired',
    deleteCauses: 'deleteCauses',
    insertCause: 'insertCause',
    updateCause: 'updateCause',
    overrideChangeRequestById: 'overrideChangeRequestById',
    updateApproverResponses: 'updateApproverResponses',
    InsertColourPalette: 'InsertColourPalette',
    UpdateColourPalette: 'UpdateColourPalette',
    deleteComment: 'deleteComment',
    deleteConversation: 'deleteConversation',
    deleteConversations: 'deleteConversations',
    insertComment: 'insertComment',
    insertConversation: 'insertConversation',
    resolveConversation: 'resolveConversation',
    updateComment: 'updateComment',
    deleteComplianceMonitoringAssessments: 'deleteComplianceMonitoringAssessments',
    insertComplianceMonitoringAssessment: 'insertComplianceMonitoringAssessment',
    updateComplianceMonitoringAssessment: 'updateComplianceMonitoringAssessment',
    deleteConsequences: 'deleteConsequences',
    insertConsequence: 'insertConsequence',
    updateConsequence: 'updateConsequence',
    addControlParents: 'addControlParents',
    deleteControls: 'deleteControls',
    insertChildControl: 'insertChildControl',
    removeParentControls: 'removeParentControls',
    updateControl: 'updateControl',
    deleteControlGroup: 'deleteControlGroup',
    insertControlGroup: 'insertControlGroup',
    updateControlGroup: 'updateControlGroup',
    deleteCustomDatasource: 'deleteCustomDatasource',
    insertCustomDataSource: 'insertCustomDataSource',
    updateCustomDatasource: 'updateCustomDatasource',
    insertRibbonItemsByParentType: 'insertRibbonItemsByParentType',
    updateRibbonItemsByParentType: 'updateRibbonItemsByParentType',
    customRoleUserUpdate: 'customRoleUserUpdate',
    deleteCustomRole: 'deleteCustomRole',
    insertCustomRole: 'insertCustomRole',
    updateCustomRole: 'updateCustomRole',
    deleteDashboard: 'deleteDashboard',
    insertDashboard: 'insertDashboard',
    updateDashboard: 'updateDashboard',
    dataExportCreateSchedule: 'dataExportCreateSchedule',
    dataExportTestSchedule: 'dataExportTestSchedule',
    dataImportStartImport: 'dataImportStartImport',
    dataImportValidate: 'dataImportValidate',
    deleteDataImportById: 'deleteDataImportById',
    insertDataImport: 'insertDataImport',
    deleteDepartmentTypes: 'deleteDepartmentTypes',
    InsertDepartmentTypeGroupByName: 'InsertDepartmentTypeGroupByName',
    insertDepartmentTypeWithGroupName: 'insertDepartmentTypeWithGroupName',
    insertDepartmentTypeWithOptionalGroupId: 'insertDepartmentTypeWithOptionalGroupId',
    UpdateDepartmentType: 'UpdateDepartmentType',
    deleteDocument: 'deleteDocument',
    insertDocument: 'insertDocument',
    updateDocument: 'updateDocument',
    deleteDocumentFiles: 'deleteDocumentFiles',
    insertDocumentVersion: 'insertDocumentVersion',
    updateDocumentVersion: 'updateDocumentVersion',
    addRiskToEnterpriseRisk: 'addRiskToEnterpriseRisk',
    deleteEnterpriseRisk: 'deleteEnterpriseRisk',
    insertEnterpriseRisk: 'insertEnterpriseRisk',
    updateEnterpriseRisk: 'updateEnterpriseRisk',
    instatiateEnterpriseRisk: 'instatiateEnterpriseRisk',
    insertEntity: 'insertEntity',
    updateEntity: 'updateEntity',
    deleteEntity: 'deleteEntity',
    deleteRelationFileById: 'deleteRelationFileById',
    deleteFormField: 'deleteFormField',
    insertFormField: 'insertFormField',
    updateFormField: 'updateFormField',
    insertFormFieldPositions: 'insertFormFieldPositions',
    updateFormFieldPositions: 'updateFormFieldPositions',
    deleteImpactRating: 'deleteImpactRating',
    deleteImpactRatings: 'deleteImpactRatings',
    insertChildImpactRatings: 'insertChildImpactRatings',
    deleteImpact: 'deleteImpact',
    insertImpact: 'insertImpact',
    updateImpact: 'updateImpact',
    deleteIndicatorResults: 'deleteIndicatorResults',
    insertIndicatorResult: 'insertIndicatorResult',
    updateIndicatorResult: 'updateIndicatorResult',
    deleteIndicators: 'deleteIndicators',
    insertIndicator: 'insertIndicator',
    updateIndicator: 'updateIndicator',
    deleteInternalAudits: 'deleteInternalAudits',
    insertInternalAudit: 'insertInternalAudit',
    updateInternalAudit: 'updateInternalAudit',
    deleteInternalAuditReports: 'deleteInternalAuditReports',
    insertInternalAuditReport: 'insertInternalAuditReport',
    updateInternalAuditReport: 'updateInternalAuditReport',
    deleteInternalAuditResults: 'deleteInternalAuditResults',
    insertInternalAuditTestResult: 'insertInternalAuditTestResult',
    insertDocumentInternalAuditResult: 'insertDocumentInternalAuditResult',
    insertInternalAuditImpactRating: 'insertInternalAuditImpactRating',
    insertObligationInternalAuditResult: 'insertObligationInternalAuditResult',
    insertRiskInternalAuditResult: 'insertRiskInternalAuditResult',
    updateControlTestInternalAuditResult: 'updateControlTestInternalAuditResult',
    updateDocumentInternalAuditResult: 'updateDocumentInternalAuditResult',
    updateObligationInternalAuditResult: 'updateObligationInternalAuditResult',
    updateControlledRiskInternalAuditResult: 'updateControlledRiskInternalAuditResult',
    updateUncontrolledRiskInternalAuditResult: 'updateUncontrolledRiskInternalAuditResult',
    deleteIssues: 'deleteIssues',
    insertChildIssue: 'insertChildIssue',
    updateIssue: 'updateIssue',
    insertIssueAssessment: 'insertIssueAssessment',
    updateIssueAssessment: 'updateIssueAssessment',
    deleteIssueUpdates: 'deleteIssueUpdates',
    insertIssueUpdate: 'insertIssueUpdate',
    updateIssueUpdate: 'updateIssueUpdate',
    deleteLinkedItems: 'deleteLinkedItems',
    linkItems: 'linkItems',
    updateModules: 'updateModules',
    disconnectSlack: 'disconnectSlack',
    updateNotificationPreferences: 'updateNotificationPreferences',
    deleteObligation: 'deleteObligation',
    insertObligation: 'insertObligation',
    updateObligation: 'updateObligation',
    deleteImpacts: 'deleteImpacts',
    insertObligationImpact: 'insertObligationImpact',
    updateObligationImpact: 'updateObligationImpact',
    updateOrganisation: 'updateOrganisation',
    insertQuestionnaireInvites: 'insertQuestionnaireInvites',
    deleteQuestionnaireTemplateVersions: 'deleteQuestionnaireTemplateVersions',
    insertQuestionnaireTemplateVersion: 'insertQuestionnaireTemplateVersion',
    publishQuestionnaireTemplateVersion: 'publishQuestionnaireTemplateVersion',
    updateQuestionnaireTemplateVersion: 'updateQuestionnaireTemplateVersion',
    deleteQuestionnaireTemplate: 'deleteQuestionnaireTemplate',
    insertQuestionnaireTemplate: 'insertQuestionnaireTemplate',
    updateQuestionnaireTemplate: 'updateQuestionnaireTemplate',
    deleteRisk: 'deleteRisk',
    insertRisk: 'insertRisk',
    updateRisk: 'updateRisk',
    deleteScimDomain: 'deleteScimDomain',
    deleteScimToken: 'deleteScimToken',
    insertScimDomain: 'insertScimDomain',
    insertScimToken: 'insertScimToken',
    deleteSecondLineResults: 'deleteSecondLineResults',
    insertDocumentSecondLineResult: 'insertDocumentSecondLineResult',
    insertObligationSecondLineResult: 'insertObligationSecondLineResult',
    insertChildRiskSecondLineResult: 'insertChildRiskSecondLineResult',
    insertSecondLineControlTestResult: 'insertSecondLineControlTestResult',
    insertSecondLineImpactRating: 'insertSecondLineImpactRating',
    updateControlTestSecondLineResultApi: 'updateControlTestSecondLineResultApi',
    updateDocumentSecondLineResult: 'updateDocumentSecondLineResult',
    updateObligationSecondLineResult: 'updateObligationSecondLineResult',
    updateControlledRiskSecondLineResult: 'updateControlledRiskSecondLineResult',
    updateUncontrolledRiskSecondLineResult: 'updateUncontrolledRiskSecondLineResult',
    resetTabPreferences: 'resetTabPreferences',
    updateOrganisationTabPreferences: 'updateOrganisationTabPreferences',
    updateUserTabPreferences: 'updateUserTabPreferences',
    deleteTagTypes: 'deleteTagTypes',
    InsertTagTypeGroupByName: 'InsertTagTypeGroupByName',
    insertTagTypeWithGroupName: 'insertTagTypeWithGroupName',
    insertTagTypeWithOptionalGroupId: 'insertTagTypeWithOptionalGroupId',
    UpdateTagType: 'UpdateTagType',
    deleteTaxonomyOrg: 'deleteTaxonomyOrg',
    InsertTaxonomy: 'InsertTaxonomy',
    updateTaxonomy: 'updateTaxonomy',
    deleteTestResults: 'deleteTestResults',
    insertControlTestResult: 'insertControlTestResult',
    updateTestResult: 'updateTestResult',
    createThirdParty: 'createThirdParty',
    deleteThirdParty: 'deleteThirdParty',
    updateThirdParty: 'updateThirdParty',
    updateThirdPartyResponse: 'updateThirdPartyResponse',
    updateThirdPartyResponseStatus: 'updateThirdPartyResponseStatus',
    insertThirdPartyContactApi: 'insertThirdPartyContactApi',
    RevokeThirdPartyContactAccess: 'RevokeThirdPartyContactAccess',
    DeleteUserGroupUsers: 'DeleteUserGroupUsers',
    deleteUserGroups: 'deleteUserGroups',
    InsertUserGroup: 'InsertUserGroup',
    InsertUserGroupUsers: 'InsertUserGroupUsers',
    UpdateUserGroup: 'UpdateUserGroup',
    upsertRecentUsers: 'upsertRecentUsers',
    upsertUserSearchPreferences: 'upsertUserSearchPreferences',
    upsertUserTablePreferences: 'upsertUserTablePreferences',
    UpdateUserRoles: 'UpdateUserRoles',
    deleteWizard: 'deleteWizard',
    insertWizard: 'insertWizard',
    updateWizard: 'updateWizard'
  },
  Subscription: {
    getRiskScores: 'getRiskScores',
    getLatestRiskScoresByRiskId: 'getLatestRiskScoresByRiskId',
    getChangeRequestById: 'getChangeRequestById',
    getChangeRequestByParentId: 'getChangeRequestByParentId',
    getLivePendingChangeRequests: 'getLivePendingChangeRequests',
    getActiveDataExportSchedule: 'getActiveDataExportSchedule',
    getDataExportScheduleExecutions: 'getDataExportScheduleExecutions',
    getDataImportStatus: 'getDataImportStatus',
    getThirdPartyResponseSubscriptionById: 'getThirdPartyResponseSubscriptionById',
    getThirdPartyResponses: 'getThirdPartyResponses',
    getThirdPartyResponsesByThirdParty: 'getThirdPartyResponsesByThirdParty'
  },
  Fragment: {
    AcceptanceParts: 'AcceptanceParts',
    ActionParts: 'ActionParts',
    ActionUpdateParts: 'ActionUpdateParts',
    AncestorContributorParts: 'AncestorContributorParts',
    AppetiteParts: 'AppetiteParts',
    AssessmentActivityParts: 'AssessmentActivityParts',
    DocumentAssessmentResultParts: 'DocumentAssessmentResultParts',
    ObligationAssessmentResultParts: 'ObligationAssessmentResultParts',
    RiskAssessmentResultParts: 'RiskAssessmentResultParts',
    DocumentInternalAuditResultParts: 'DocumentInternalAuditResultParts',
    ObligationInternalAuditResultParts: 'ObligationInternalAuditResultParts',
    RiskControlledInternalAuditResultParts: 'RiskControlledInternalAuditResultParts',
    RiskUncontrolledInternalAuditResultParts: 'RiskUncontrolledInternalAuditResultParts',
    DocumentSecondLineResultParts: 'DocumentSecondLineResultParts',
    ObligationSecondLineResultParts: 'ObligationSecondLineResultParts',
    RiskControlledSecondLineResultParts: 'RiskControlledSecondLineResultParts',
    RiskUncontrolledSecondLineResultParts: 'RiskUncontrolledSecondLineResultParts',
    AssessmentParts: 'AssessmentParts',
    AttestationConfigParts: 'AttestationConfigParts',
    AttestationGroupParts: 'AttestationGroupParts',
    AttestationCycleParts: 'AttestationCycleParts',
    CauseParts: 'CauseParts',
    ChangeRequestParts: 'ChangeRequestParts',
    ComplianceMonitoringAssessmentParts: 'ComplianceMonitoringAssessmentParts',
    ConsequenceParts: 'ConsequenceParts',
    ControlParts: 'ControlParts',
    ControlGroupParts: 'ControlGroupParts',
    DashboardParts: 'DashboardParts',
    MyItemsAncestorContributorsParts: 'MyItemsAncestorContributorsParts',
    MyItemsChangeRequestParts: 'MyItemsChangeRequestParts',
    MyItemsContributorGroupParts: 'MyItemsContributorGroupParts',
    MyItemsOwnerGroupParts: 'MyItemsOwnerGroupParts',
    DepartmentParts: 'DepartmentParts',
    DocumentParts: 'DocumentParts',
    DocumentRelationFileParts: 'DocumentRelationFileParts',
    PublicDocumentRelationFileParts: 'PublicDocumentRelationFileParts',
    FileParts: 'FileParts',
    FormConfigurationParts: 'FormConfigurationParts',
    ImpactRatingParts: 'ImpactRatingParts',
    ImpactInternalAuditRatingParts: 'ImpactInternalAuditRatingParts',
    ImpactSecondLineRatingParts: 'ImpactSecondLineRatingParts',
    ImpactParts: 'ImpactParts',
    IndicatorParts: 'IndicatorParts',
    InternalAuditEntityParts: 'InternalAuditEntityParts',
    InternalAuditReportParts: 'InternalAuditReportParts',
    IssueParts: 'IssueParts',
    SimplifiedIssueParts: 'SimplifiedIssueParts',
    BreachedIssuesParts: 'BreachedIssuesParts',
    IssueAssessmentParts: 'IssueAssessmentParts',
    IssueUpdateParts: 'IssueUpdateParts',
    ObligationParts: 'ObligationParts',
    QuestionnaireTemplateParts: 'QuestionnaireTemplateParts',
    RelationFileParts: 'RelationFileParts',
    EnterpriseRiskInstanceWithEntityHierarchyParts: 'EnterpriseRiskInstanceWithEntityHierarchyParts',
    RiskParts: 'RiskParts',
    ScheduleParts: 'ScheduleParts',
    TagParts: 'TagParts',
    TestResultParts: 'TestResultParts',
    ControlTestInternalAuditResultParts: 'ControlTestInternalAuditResultParts',
    ControlTestSecondLineResultParts: 'ControlTestSecondLineResultParts',
    ThirdPartyParts: 'ThirdPartyParts',
    ThirdPartyResponseParts: 'ThirdPartyResponseParts',
    ContributorGroupParts: 'ContributorGroupParts',
    OwnerGroupParts: 'OwnerGroupParts',
    ContributorParts: 'ContributorParts',
    OwnerParts: 'OwnerParts'
  }
}